export const CONFIG = {
  APP: {
    ede: {
      meta: {
        label: 'EDE',
        enabled: true,
        modules: {
          application: {
            steps: {
              'get-started': {
                confirm: { coverageState: { options: 'object-list' } },
              },
            },
          },
        },
        description: 'Enhanced Direct Enrollment',
      },
      income: {
        introScreen: {
          label: 'Income & Deductions',
          imagePath:
            'https://zipari-uploads-dev.s3.amazonaws.com/files/53144ac9-a0dc-4166-9acf-4432dec9bcc8',
          description:
            "In this section we're going to ask about the members of your household's yearly income and any deductions that can be applied.",
          whatToExpect: ['Paychecks', 'Bank Statements'],
        },
      },
      notices: {
        text: {
          title: 'Notices',
          noNotices:
            'No notices available are available right now. Please check back later.',
        },
        noticeMapping: {
          EDN: 'Eligibility notice (EDN)',
          ESD_CUSTOM_NOTICE: 'Eligibility support desk (ESD) custom notice',
          CROSS_ISSUER_NOTICE: 'Cross issuer',
          SVI_OBSOLETE_NOTICE: 'SVI OBE Notice',
          DMI_ESCALATION_NOTICE: 'DMI escalation notice',
          DMI_RESOLUTION_NOTICE: 'DMI resolution notice',
          SVI_EXPIRATION_NOTICE: 'SVI expiration notice',
          SVI_RESOLUTION_NOTICE: 'SVI resolution notice',
          IRS_1095_A_VOIDED_FORM: 'Tax Form 1095-A is available notice (void)',
          CLOCK_EXPIRATION_NOTICE: 'Clock expiration notice',
          DATA_SOURCE_DOWN_NOTICE: 'Data Sources Down Notice',
          IRS_1095_A_INITIAL_FORM:
            'Tax Form 1095-A is available notice (initial)',
          IRS_1095_A_CORRECTED_FORM:
            'Tax Form 1095-A is available notice (corrected)',
          SVI_PLAN_SELECTION_NOTICE: 'SVI plan selection clock notice',
          DHS_SAVE_RESOLUTION_NOTICE: 'SAVE Step 2 Notice',
          CONSUMER_CONFIRMATION_NOTICE: 'Consumer confirmation message (CCM)',
          INBOUND_ACCOUNT_TRANSFER_NOTICE: 'Inbound account transfer',
          DMI_INSUFFICIENT_DOCUMENTS_NOTICE:
            'DMI insufficient documents notice',
          SVI_INSUFFICIENT_DOCUMENTS_NOTICE:
            'SVI insufficient documents notice',
          MARKETPLACE_OPEN_ENROLLMENT_NOTICE: 'Open enrollment notice (MOEN)',
          FAILURE_TO_RECONCILE_INITIAL_NOTICE:
            'Combined FTR recheck warning notice',
          PERIODIC_DATA_MATCHING_FINAL_NOTICE:
            'Periodic Data Matching Final Notice',
          PERIODIC_DATA_MATCHING_INITIAL_NOTICE:
            'Periodic Data Matching Initial Notice',
          OUTBOUND_RESPONSE_ACCOUNT_TRANSFER_NOTICE:
            'Outbound account transfer',
        },
      },
      getStarted: {
        confirm: {
          coverageState: {
            options: [
              { label: 'Arizona', value: 'AZ' },
              { label: 'California', value: 'CA' },
              { label: 'Colorado', value: 'CO' },
              { label: 'Florida', value: 'FL' },
              { label: 'Illinois', value: 'IL' },
              { label: 'Kansas', value: 'KS' },
              { label: 'Missouri', value: 'MO' },
              { label: 'North Carolina', value: 'NC' },
              { label: 'Tennessee', value: 'TN' },
              { label: 'Virginia', value: 'VA' },
              { label: 'Utah', value: 'UT' },
            ],
          },
        },
        idProofing: { mockIdProofing: 'true' },
        introScreen: {
          label: 'Get Started',
          imagePath:
            'https://zipari-uploads-dev.s3.amazonaws.com/files/6517693f-e92b-436f-8f3f-b74b36c802df',
          description:
            "To enroll for healthcare coverage, you need to fill out an application to find out whether you are eligible. This will also determine how much financial aid you can receive to help pay for monthly premiums.<br><br>There are five sections in this application. In this section, we're going to ask you some background questions about you and your family.",
        },
      },
      signAndSubmit: {
        introScreen: {
          label: 'Sign & Submit',
          imagePath:
            'https://zipari-uploads-dev.s3.amazonaws.com/files/c5e7338c-8e48-4e0d-a5c8-3f9b70011a4a.png',
          description:
            'B-corp, expose the truth program areas effective altruism NGO technology. Humanitarian milestones then emerging synergy outcomes thought partnership shine living a fully ethical life. Innovation natural resources state of play segmentation shared vocabulary cultivate indicators. Natural resources, academic living a fully ethical life support external partners segmentation technology youth equal opportunity.',
          whatToExpect: ['Material 1', 'Material 2', 'Material 3'],
        },
      },
      additionalInfo: {
        introScreen: {
          label: 'Additional Information',
          imagePath:
            'https://zipari-uploads-dev.s3.amazonaws.com/files/062aec32-12f2-4fcd-9d03-98b0cff4ca08',
          description:
            "In this section, we're going to ask some follow up questions that may include questions about health coverage, employer information, and tax credits.",
          whatToExpect: ['Previous Tax Returns'],
        },
      },
      familyHousehold: {
        introScreen: {
          label: 'Family & Household',
          imagePath:
            'https://zipari-uploads-dev.s3.amazonaws.com/files/247c82f2-56de-4075-b0a6-115d67e4819c',
          description:
            "In this section, we're going to ask some background information about the members of your family.",
          whatToExpect: [
            'Social Security Cards',
            'Citizenship or Immigration Information',
          ],
        },
      },
      eligibilityResults: {
        text: {
          faq: "<p class='t-data t-bold'>What should I do if I think my eligibility results are wrong?</p> <p class='t-data'>If you don't agree with what you qualify for, you may be able to file an appeal.</p> <br /> <p class='t-data'> You can appeal eligibility to buy Marketplace plans and also for enrollment periods. If you're applying for help paying for coverage, you may also have the right to appeal eligibility for tax credits, cost-sharing reductions, Medicaid eligibility, and CHIP eligibility. If you qualify for tax credits or cost-sharing reductions, you can appeal the amount you're eligible for. </p> <br /> <p class='t-data'> Review your eligibility notice to find appeals instructions for each person in your household, including the number of days you have to file an appeal. Here's important information to consider when filing an appeal: </p> <ul> <li class='t-data'> You can have someone file and participate in your appeal. That person can be a friend, relative, lawyer, or other person. Or, you can file and participate in your appeal on your own. </li> <li class='t-data'> If you file an appeal, you may be able to keep your eligibility for coverage while your appeal is pending. </li> <li class='t-data'>The outcome of an appeal could change the eligibility of other members of your household.</li> <li class='t-data'> Depending on your state and your eligibility results, you may be able to file an appeal through the Marketplace of you may have to file an appeal with your state Medicaid or CHIP agency. </li> </ul> <a class='t-data t-link learn-more-eligibility-results' href='https://healthcare.gov/marketplace-appeals/' target='_blank' >Learn more about how to appeal your Marketplace eligibility results.</a > <p class='t-data'> You can also mail an appeal request form or your own letter filing an appeal to Health Insurance Marketplace, 465 Industrial Blvd., London, KY, 40750-0001. </p>",
          title: 'Eligibility Results',
          voteCta: 'Click here to register to vote.',
          badgeDmi: 'Requires Documentation',
          voteTitle: 'Would you like to register to vote? (Optional)',
          sepEligible:
            "You are eligible for Special Enrollment Period. You must pick a plan by ${sepDate}, if you don't then may not be able to enroll until the next yearly Open Enrollment Period.",
          badgeEligible: 'Eligible',
          csrDisclaimer:
            '<br><br>You are eligible for lower copayments, coinsurance, and deductibles (Cost Sharing Reductions) on Silver plans',
          qhpCardHeader: 'Individual & Family Coverage',
          sepIneligible:
            'You are not able to enroll in a 2020 plan due to lack of a qualifying event. You may be able to enroll in coverage for January 1, ${nextYear} by completing a ${nextYear} application.',
          sviCardHeader:
            "You're eligible for a Special Enrollment Period, but we need information.",
          continueButton: 'Continue to Enrollment',
          sepIneligibleOe:
            'Unfortunately you are not able to enroll in a plan at this time due to lack of a qualifying event. You may enroll in a plan between ${oeStartDate} and ${oeEndDate}.',
          documentsNeededBy: 'Documents Needed By:',
          memberQhpEligible: 'You are eligible to buy marketplace plans.',
          resultDescription:
            'Results based on your application (ID: ${ede.id}) submitted on ${submitted_date}. Follow these steps below to complete your enrollment.',
          badgeMayBeEligible: 'May Be Eligible',
          fullMedicaidHeader: 'Full Medicaid Determination',
          medicaidCardHeader: 'Medicaid & CHIP',
          uploadDocumentsCta: 'Upload Your Documents',
          requiredActionHeader:
            'Required Action: View your Eligibility Results',
          fullMedicaidSubmitted:
            'Your request for full medicaid determination has been sent.',
          memberChipDescription: 'You are eligible for CHIP.',
          notEligibleCardHeader: 'Not Eligible For Coverage',
          notEligibleCardStatus: 'Not Eligible',
          fullMedicaidDescription:
            "It looks like these people aren't eligible for Medicaid. They can still continue with a Medicaid application if we send their information to the ${medicaidProgramName}. Do any of these people want us to send their information to the ${medicaidProgramName} so they can check on Medicaid and The Children’s Health Insurance Program (CHIP) eligibility, if applicable?",
          memberDefaultDescription:
            'The following people are not eligible for health plans, premium tax credits, lower copayments, coinsurance, and deductibles (cost-sharing reductions), or state health benefits.',
          memberMedicaidDescription: 'You are eligible for Medicaid.',
          requiredActionDescription:
            "Your eligibility notice explains your options for coverage, costs, deadlines and next steps. If you're eligible for coverage through a Marketplace plan, you can enroll after you view your notice.",
          memberMayBeChipDescription:
            'You may be eligible for CHIP. ${chipProgramName} will contact you if you need to provide more information.',
          viewEligibilityResultsButton: 'View Your Eligibility Results',
          memberMayBeMedicaidDescription:
            'You may be eligible for Medicaid. ${medicaidProgramName} will contact you if you need to provide more information.',
        },
        DMIMap: {
          DMI_SSN: 'Proof of SSN',
          DMI_ESCMEC: 'Proof of Employer Sponsored Coverage',
          DMI_NONESCMEC: 'other',
          DMI_CITIZENSHIP: 'Proof of Citizenship',
          DMI_ANNUAL_INCOME: 'Proof of Income',
          DMI_INCARCERATION: 'Proof of Incarceration Status',
          DMI_TRIBE_MEMBERSHIP:
            'Proof of American Indian or Alaska Native status',
          DMI_QHP_LAWFUL_PRESENCE: 'Proof of Immigration Status',
          DMI_MEDICAID_LAWFUL_PRESENCE: 'Proof of Immigration Status',
        },
        SVIMap: {
          '198_ADOPTION':
            'Proof of adoption, foster care placement, or court order',
          '203_MARRIAGE': 'Proof of Marriage',
          '209_MEC_LOSS': 'Proof of Loss of Coverage',
          '200_MOVED_TO_NEW_SERVICE_AREA':
            'Proof of "permanently moving to a new home and had prior coverage. Need documents to confirm both move and prior coverage"',
          '472_SEP_GRANTED_FOR_MDCAID_DENIAL':
            'Proof of Medicaid or CHIP Denial',
        },
        DMISubtypeMap: {
          NON_ESC_MEC_VA:
            'Proof of Coverage through Veterans Health Care Program',
          NON_ESC_MEC_TRICARE: 'Proof of Coverage through TRICARE',
          NON_ESC_MEC_MEDICARE:
            'Proof of eligibility for or coverage through Medicare',
          NON_ESC_MEC_PEACE_CORPS:
            'Proof of eligibility or coverage through Peace Corps',
          NON_ESC_MEC_MEDICAID_CHIP: 'Proof of Medicaid or CHIP',
        },
        SEP_CONFIRM_LANGUAGE: {
          '198_ADOPTION': 'adoption, foster care placement, or court order',
          '203_MARRIAGE': 'a marriage',
          '209_MEC_LOSS': 'loss of coverage',
          '200_MOVED_TO_NEW_SERVICE_AREA':
            'permanently moving to a new home and had prior coverage. Need documents to confirm both move and prior coverage',
          '472_SEP_GRANTED_FOR_MDCAID_DENIAL': 'Medicaid or CHIP denial',
        },
      },
      dataVerificationIssues: {
        text: {
          header: 'Data & Verification Issues',
          noIssues: 'No Data & Verification Issues',
          dmiHeader: 'Individual Documentation',
          sviHeader: 'Special Enrollment Period Documentation',
          dmiCardHeader:
            'To confirm your eligibility you will need to upload the following documents for the following individual: <br />${name}',
          sviCardHeader:
            'To confirm your eligibility you will need to upload the following documents for the following individuals:',
          dmiDescription:
            'There is a data matching issue that requires you to upload some additional documentation. Depending on what you submit, you may be asked to provide more than one document.',
          sviDescription:
            "Submit documents as soon as possible to confirm ${verificationStatusReason}. You'll pick a plan now, and your coverage will start once your documents are approved. See your eligibility notice for details and deadlines.",
          newMemberStatus: 'Requires Documentation',
          openResolveIssueModal: 'Resolve This Issue',
          documentsNeededByLabel: 'Documents needed by:',
          resolveIssueModalClose: 'Exit',
          resolveIssueModalIntro:
            'There is a data matching issue that requires you to upload some additional documentation. Depending on what you submit, you may be asked to provide more than one document.',
          resolveIssueModalConfirm: 'Mark this issue as resolved',
          resolveIssueModalBackToUpload: 'Go back to uploading your documents',
          resolveIssueModalDefaultHeader:
            'SPECIAL ENROLLMENT PERIOD DOCUMENTATION',
          resolveIssueModalDisplayAcceptedDocs:
            'View the full list of accepted documents',
        },
        dmiSviDocMapping: {
          DMI_SSN: {
            dropdown: [
              'Social Security card',
              'Tax form(s)',
              'Benefit or income statement',
            ],
            paragraphs: [
              'Documents must include your first name, last name, and SSN.',
              '',
              '',
              '·        Social Security card',
              '·        1040 Tax Return (federal or state versions acceptable)',
              '·        W2 and/or 1099s (includes 1099 MISC, 1099G, 1099R, 1099SSA, 1099DIV, 1099S, 1099INT)',
              '·        W4 Withholding Allowance Certificate (federal or state versions acceptable)',
              '·        1095 (includes 1095A, 1095B, 1095C)',
              '·        Pay stub documentation',
              '·        Social Security Administration documentation (includes 4029)',
              '·        Military record',
              '·        U.S. Military ID card',
              '·        Military dependent’s ID card',
              '·        Unemployment Benefits (Unemployment Benefits Letter)',
              '·        Court Order Granting a Name Change, that must have your original first and last name, new first and last name, and SSN',
              '·        Divorce decree',
            ],
          },
          DMI_ESCMEC: {
            dropdown: [
              'Letter from health insurer',
              'Statement of health benefits',
              'Other',
            ],
            paragraphs: [
              'Submit one of the documents below if you need to confirm that your job-based coverage isn’t qualifying health coverage.',
              '',
              '',
              '·        Completed <a class="t-data t-link" target="_blank" href="https://marketplace.cms.gov/applications-and-forms/employer-coverage-tool.pdf">Employer Coverage Tool (PDF)</a> and a cover letter signed by the employer',
              '·        Letter or other documentation from an employer or other documentation with this information:',
              'o   Statement that the employer doesn’t currently offer you (or your family member) coverage',
              'o   Statement that the employer doesn’t provide coverage that isn’t qualifying health coverage',
              'o   Statement showing the cost of your share of the premium for the lowest-cost self-only plan that meets the minimum value standard (factoring in wellness incentives), if offered. Minimum value standard is a standard of minimum coverage that applies to job-based health plans. If your employer’s plan meets this standard and is considered “affordable,” you won’t be eligible for a premium tax credit if you buy a Marketplace insurance plan instead.',
              '·        Health insurance letter that contains confirmation of health coverage and expiration dates for coverage received outside of the Marketplace',
            ],
          },
          '198_ADOPTION': {
            dropdown: [
              'Adoption letter or record',
              'Foster care papers',
              'Court order',
              'Legal guardianship document',
              'Medical support order',
              'DHS immigration document',
              'Other',
              'Letter of explanation ',
            ],
            paragraphs: [
              'Documents must show that you (or your dependent) was adopted, placed in foster care, or became a dependent through a court order. These documents must include the name of the person who became a dependent and the date he or she became a dependent. Documents you can submit:<br><br><br>Adoption letter or record that shows the name of the person who was adopted and the date of adoption. This needs to be signed by a government or court official.<br><br>Foster care papers that show the name of the person who was placed in foster care and the date of the placement. This needs to be signed by a government or court official.<br><br>Child support or other court order that shows the name of the person who became a new dependent and the date of the court order. This needs to be signed by a court official.<br><br>Document for legal guardianship that shows the name of the person who became a new dependent and the date that this person was placed in a home or the date legal guardianship was established. This needs to be a government-issued or legal document.<br><br>Medical support order that shows the name of the person who became a dependent and the effective date of the order.<br><br>You can upload more than one document if you have multiple documents to confirm adoption, foster care placement, or court order. Select the "UPLOAD DOCUMENTS" button on the upload screen in your application to submit each document.<br><br>What if I adopted a child or was adopted from a foreign country?<br><br>You can upload a U.S. Department of Homeland Security (DHS) immigration document that shows the name of the person who was adopted and the date of the adoption.<br><br>What if I don\'t have any of these documents?<br>You can submit a letter explaining the adoption, foster care placement, or court order, and the reason you can’t provide documents. Use <a class=\'t-data t-link\' href="https://www.healthcare.gov/downloads/letter-of-explanation.pdf" target="_blank">this form</a> and fill out the "Adoption, Foster Care Placement, or Court Order" section. When you complete the form, select "Letter of explanation" from the drop-down menu when you\'re on the upload documents screen in the application.',
            ],
          },
          '203_MARRIAGE': {
            dropdown: [
              'Marriage certificate',
              'Marriage license',
              'Official public record',
              'Affidavit',
              'Religious document',
              'Other',
              'Letter of explanation',
            ],
            paragraphs: [
              'Documents must show that you were married. These documents must include the names of the people who were married and the date of the marriage. Documents you can submit:',
              '',
              'Marriage certificate.',
              'Marriage license.',
              'Official public record of marriage.',
              'Marriage affidavit or affidavit of support that’s signed and dated by the person who officiated the marriage or the official witness of the marriage.',
              'Religious document.',
              'You can upload more than one document if you have multiple documents to confirm marriage. Select the green "UPLOAD DOCUMENTS" button on the upload screen in your application to submit each document.',
              "What if I don't have any of these documents?",
              "You can submit a letter explaining the marriage and the reason you can’t provide documents. Use <a class='t-data t-link' href='https://www.healthcare.gov/downloads/letter-of-explanation.pdf' target=\"_blank\">this form</a> and fill out the “Marriage” section. When you complete the form, select “Letter of explanation” from the drop-down menu when you’re on the upload documents screen in the application.",
            ],
          },
          '209_MEC_LOSS': {
            dropdown: [
              'Letter from an insurance company',
              'Letter from an employer',
              'Letter about COBRA coverage',
              'Health care program document',
              'Pay stubs',
              'Letter for loss of student coverage',
              'Document for coverage loss due to divorce/separation',
              'Document for coverage loss due to death',
              'Letter of explanation',
              'Other',
            ],
            paragraphs: [
              'Documents must show that you lost qualifying health coverage in the past 60 days or will lose coverage in the next 60 days. These documents must include your name and the date of coverage loss. Documents you can submit:',
              '',
              'A letter from an insurance company, on official letterhead or stationery, including:',
              'A letter or premium bill from your former insurance company that shows you or your dependent’s cancellation/termination from health coverage.',
              'A decertification letter from your insurance company stating when coverage will no longer be offered.',
              'A letter from an employer, on official letterhead or stationery, that confirms one of these about you or your spouse or dependent family member:',
              'That your employer dropped or will drop your coverage or benefits.',
              'That your employer stopped or will stop contributing to your cost of coverage.',
              'That your employer changed or will change coverage or benefits, and your coverage will no longer be considered qualifying health coverage.',
              'A letter about COBRA coverage, like a letter from an employer or health insurance company that confirms these:',
              'Your employer’s offer of COBRA coverage along with the date this coverage would start.',
              'Your COBRA coverage ended or will end, or your employer stopped or will stop contributing to the cost of coverage and when.',
              'A health care program document, on official letterhead or stationery, including:',
              'A letter from a government health program, like TRICARE, Veterans Affairs (VA), Peace Corps, or Medicare, showing when coverage ended or will end.',
              'A letter from your state Medicaid or CHIP agency showing that your eligibility for Medicaid or CHIP was denied and when it was denied or that your Medicaid or CHIP coverage ended or will end.',
              'A dated copy of your military discharge document (DD214).',
              'A letter if you lost student health coverage, which shows when the coverage ended or will end. This should be on official letterhead or stationery.',
              'You can also submit any of the documents in the list below. However, these documents may include only some of the information we need to confirm, so you’ll most likely need to submit more than one of these documents:',
              '',
              'Pay stubs, if you lost employer-sponsored coverage. You can submit:',
              '2 pay stubs from the past 1-3 months, one that shows a deduction for health coverage and another which shows that the deduction ended in the past 60 days.',
              'If a reduction in work hours caused you to lose coverage, you can submit one previous pay stub that shows that you worked 30 or more hours and a deduction for health coverage, and a pay stub from the past 60 days that shows that you worked less than 30 hours and no deduction for health coverage.',
              'Document showing you lost coverage because of divorce, legal separation, custody agreements, or annulment within 60 days of submitting your application, including:',
              'Divorce or annulment papers that show the date responsibility ends for providing health coverage or proof that you stopped getting health coverage because of your relationship to your former spouse.',
              'Legal separation papers that show the date responsibility ends for providing health coverage.',
              'Other confirmation that you lost or will lose coverage because of divorce, legal separation, or annulment that shows the date that health coverage ends.',
              'Document showing you lost coverage due to death of a family member, including:',
              'A death certificate or public notice of death and proof that you were getting health coverage because of your relationship to the deceased person, like a letter from an insurance company or employer that shows the names of the people on the health plan.',
              'Other confirmation that shows you lost or will lose coverage because of the death of a spouse or other family member.',
              'You can upload more than one document if you have multiple documents to confirm coverage loss. Select the green "UPLOAD DOCUMENTS" button on the upload screen in your application to submit each document.',
              "What if I'm in a plan that ended before the end of the calendar year?",
              'If you’re losing or lost coverage from a non-calendar year plan, you can submit a dated and signed copy of written verification from an insurance agent, or a dated letter from your insurance company stating when the coverage year ends. To submit this, select "Other" from the drop-down menu.',
              "What if I don't have any of these documents?",
              'You can submit a letter explaining the coverage you had, why and when you lost it or will lose it, and the reason you can\'t provide documents. Use <a class=\'t-data t-link\' href="https://www.healthcare.gov/downloads/letter-of-explanation.pdf" target="_blank">this form</a> and fill out the “Loss of Coverage” section. When you complete the form, select “Letter of explanation” from the drop-down menu when you’re on the upload documents screen in the application.',
            ],
          },
          DMI_NONESCMEC: {
            NON_ESC_MEC_VA: {
              dropdown: ['Letter from VA', 'Other'],
              paragraphs: [
                'Submit one of the documents below if you need to confirm that you don’t have coverage through the VA.',
                '',
                '',
                '·        Letter from the VA that shows the expiration date of previous health coverage.·        If you don\'t have this document, you can submit a letter describing that you\'re not enrolled in health coverage through the VA. The Marketplace will take your letter into consideration. <a class="t-data t-link" href="https://www.healthcare.gov/downloads/letter-of-explanation-application-info.pdf" target="_blank">You can use this template</a>. To submit this letter, select "Other" from the drop-down menu when you\'re on the upload screen in the application.',
              ],
            },
            NON_ESC_MEC_TRICARE: {
              dropdown: ['Letter from Tricare', 'Other'],
              paragraphs: [
                'Submit one of the documents below if you need to confirm that you don’t have coverage through TRICARE.',
                '',
                '·        Letter or statement from TRICARE that shows the expiration or un-enrollment date of previous health coverage',
                '',
                '·        Letter or statement from TRICARE that confirms ineligibility for health coverage',
                '',
                '·        Letter, statement, or other document indicating a life change event (like divorce) that would make you or a family member ineligible for TRICARE coverage',
                '',
                '·        Letter or statement from TRICARE or other government agency showing that you or a family member are enrolled in a TRICARE program that’s not considered qualifying health coverage. If you send document(s) verifying enrollment in one of these programs, you may be able to continue your Marketplace coverage with help paying for coverage:',
                '',
                'o   TRICARE Plus',
                '',
                'o   Direct care',
                '',
                'o   Line-of-duty care',
                '',
                'o   Transitional care for service-related conditions',
                '',
                'o   TRICARE coverage limited to space-available care in a facility of the uniformed services for individuals excluded from TRICARE coverage for care from private sector providers.What if I don’t have any of those documents?',
                '',
                'You can submit a letter describing when your enrollment in TRICARE coverage ended or that you were never enrolled in TRICARE. The Marketplace will take your letter into consideration. <a class="t-data t-link" href="https://www.healthcare.gov/downloads/letter-of-explanation-application-info.pdf" target="_blank">You can use this template</a>. To submit this letter, select “Other” from the drop-down menu when you’re on the upload screen in the application.',
              ],
            },
            NON_ESC_MEC_MEDICARE: {
              dropdown: ['Letter from Medicare', 'Other'],
              paragraphs: [
                'Submit this document if you need to confirm that you don’t have coverage through Medicare.',
                '·        Letter or statement from Medicare or the Social Security Administration stating that you or your family members are:',
                '      · Not eligible for or enrolled in premium-free Medicare Part A.',
                '      · Eligible for (but not enrolled in) Part A coverage that requires premium payments. Important: A Social Security document that shows you don\'t pay a premium for "Medical Insurance" refers to Part B. It\'s not acceptable for verifying eligibility for Part A.',
                '      · No longer eligible for Social Security Disability Insurance (SSDI) benefits, and your coverage has ended or will end in the next 90 days.\n',
                'If you don\'t have this document, you can submit a letter describing why you\'re not eligible for premium-free Medicare Part A. The Marketplace will take your letter into consideration. <a href="https://www.healthcare.gov/downloads/letter-of-explanation-application-info.pdf" class="t-data t-link">You can use this template</a>. To submit this letter, select "Other" from the drop-down menu when you\'re on the upload screen in the application.',
              ],
            },
            NON_ESC_MEC_PEACE_CORPS: {
              dropdown: ['Letter from Peace Corps', 'Other'],
              paragraphs: [
                'Submit this document if you need to confirm that you don’t have coverage through the Peace Corps.',
                '',
                '',
                '·        Letter from the Peace Corps with the expiration date for any previous health coverage or a letter showing that you never had this type of coverage',
                '<br><br>If you don\'t have this document, you can submit a letter describing that you\'re no longer eligible for or enrolled in health coverage through the Peace Corps, or that you were never eligible for or enrolled in health coverage through the Peace Corps. The Marketplace will take your letter into consideration. <a href="https://www.healthcare.gov/downloads/letter-of-explanation-application-info.pdf" class="t-data t-link" target="_blank">You can use this template</a>. To submit this letter, select "Other" from the drop-down menu when you\'re on the upload screen in the application.',
              ],
            },
            NON_ESC_MEC_MEDICAID_CHIP: {
              dropdown: ['Letter from Medicaid', 'Letter from CHIP', 'Other'],
              paragraphs: [
                'Submit one of the documents below if you need to confirm that you don’t have coverage through Medicaid or CHIP.',
                '',
                '',
                '',
                'Note: Some Medicaid and CHIP programs are known by names specific to that state. <a href="https://www.healthcare.gov/help/medicaid-and-chip-names/" class="t-data t-link" target="_blank">Find the name of Medicaid & CHIP programs in your state</a>.',
                '',
                '',
                '·        Letter or statement from a Medicaid or CHIP agency that shows that you or your family members aren’t enrolled in or eligible for Medicaid or CHIP',
                '·        Letter or statement from a Medicaid agency showing that you or a family member are enrolled in a Medicaid program that’s not considered qualifying health coverage',
                '·        You can find more detailed information about <a href="https://www.healthcare.gov/medicaid-limited-benefits/" class="t-data t-link" target="_blank">Medicaid programs that don’t provide qualifying coverage</a>. If you send document(s) verifying enrollment in one of these programs, you may be able to continue your financial help for your Marketplace coverage:',
                'o   Medicaid coverage only for pregnancy-related services',
                'o   Medicaid coverage only for family planning services',
                'o   Medicaid coverage only for tuberculosis coverage',
                'o   Medicaid coverage only for emergency treatment',
                'o   Medicaid Demonstration Projects that cover a limited range of benefits',
                'o   Medicaid coverage for “medically needy” individuals whose income is too high for traditional Medicaid and cover a limited range of benefits. These programs are sometimes known as “Share of Cost” or “Spend Down” programs.',
                '·        A letter describing your recent health coverage including:',
                'o   The name of the Medicaid/CHIP program you were enrolled in and when your coverage ended, or',
                'o   That you were never enrolled in Medicaid/CHIP coverage, or',
                'o   The name of the Medicaid/CHIP program with limited benefits that you’re enrolled in that would still allow you to enroll in the Marketplace with help paying for coverage',
              ],
            },
          },
          DMI_CITIZENSHIP: {
            dropdown: [
              'U.S. passport',
              'Certificate of Naturalization',
              'Certificate of Citizenship',
              'State-issued enhanced Drivers License',
              'Document from a federally recognized Indian tribe',
              'Other',
            ],
            paragraphs: [
              '·        U.S. passport',
              '·        Certificate of Naturalization (N-550/N-570)',
              '·        Certificate of Citizenship (N-560/N-561)',
              "·        State-issued enhanced driver's license (available in Michigan, New York, Vermont, and Washington)",
              '·        Document from federally recognized Indian tribe that includes your name and the name of the federally recognized Indian tribe that issued the document, and shows your membership, enrollment, or affiliation with the tribe. Documents you can provide include:',
              'o   A tribal enrollment card',
              'o   A Certificate of Degree of Indian Blood',
              'o   A tribal census document',
              'o   Documents on tribal letterhead signed by a tribal official',
              '',
              'If you don’t have any of the documents above, you can submit 2 documents — one from each list below.',
              '',
              '',
              '',
              'You can submit one of these documents:',
              '',
              '',
              '·        U.S. public birth certificate',
              '·        Consular Report of Birth Abroad (FS-240, CRBA)',
              '·        Certification of Report of Birth (DS-1350)',
              '·        Certification of Birth Abroad (FS-545)',
              '·        U.S. Citizen Identification Card (I-197 or the prior version I-179)',
              '·        Northern Mariana Card (I-873)',
              '·        Final adoption decree showing the person’s name and U.S. place of birth',
              '·        U.S. Civil Service Employment Record showing employment before June 1, 1976',
              '·        Military record showing a U.S. place of birth',
              '·        U.S. medical record from a clinic, hospital, physician, midwife, or institution showing a U.S. place of birth',
              '·        U.S. life, health, or other insurance record showing U.S. place of birth',
              '·        Religious record showing U.S. place of birth recorded in the U.S.',
              '·        School record showing the child’s name and U.S. place of birth',
              '·        Federal or state census record showing U.S. citizenship or U.S. place of birth',
              '·        Documentation of a foreign-born adopted child who received automatic U.S. citizenship (IR3 or IH3)',
              '',
              '',
              '',
              'AND one of these documents (that has a photograph or other information, like your name, age, race, height, weight, eye color, or address):',
              '',
              '',
              "·        Driver's license issued by a state or territory or ID card issued by the federal, state, or local government",
              '·        School identification card',
              '·        U.S. military card or draft record or military dependent’s identification card',
              '·        U.S. Coast Guard Merchant Mariner card',
              '·        Voter Registration Card',
              '·        A clinic, doctor, hospital, or school record, including preschool or day care records (for children under 19 years old)',
              '·        2 documents containing consistent information that proves your identity, like employer IDs, high school and college diplomas, marriage certificates, divorce decrees, property deeds, or titles',
            ],
            otherDropdown: [
              'U.S. public birth certificate',
              'Consular Report of Birth Abroad (FS-240, CRBA),',
              'Certification of Report of Birth (DS-1350)',
              'Certification of Birth Abroad (FS-545)',
              'U.S. Citizen Identification Card (I-197 or the prior version I-179)',
              'Northern Mariana Card (I-873)',
              'Final adoption decree showing the person’s name and U.S. place of birth',
              'U.S. Civil Service Employment Record showing employment before June 1, 1976',
              'Military record showing a U.S. place of birth',
              'U.S. medical record from a clinic, hospital, physician, midwife, or institution showing a U.S. place of birth',
              'U.S. life, health, or other insurance record showing U.S. place of birth',
              'Religious record showing U.S. place of birth recorded in the U.S.',
              'School record showing the child’s name and U.S. place of birth',
              'Federal or state census record showing U.S. citizenship or U.S. place of birth',
              'Documentation of a foreign-born adopted child who received automatic U.S. citizenship (IR3 or IH3)',
            ],
            secondOtherDropdown: [
              "Driver's license issued by a state or territory or ID card issued by the federal, state, or local government",
              'School identification card',
              'U.S. military card or draft record or military dependent’s identification card',
              'U.S. Coast Guard Merchant Mariner card',
              'Voter Registration Card',
              'A clinic, doctor, hospital, or school record, including preschool or day care records (for children under 19 years old)',
            ],
          },
          DMI_ANNUAL_INCOME: {
            dropdown: [
              '1040 tax return',
              'W2 and/or 1099s',
              'Pay stub documentation',
              'Self-employment documentation',
              'Social Security statements',
              'Unemployment benefits letter',
              'Other',
            ],
            paragraphs: [
              'You told us your yearly household income on your application. The documents you submit to the Marketplace to confirm your income must show a yearly income amount that closely matches the yearly income amount you entered on your application. For example, if you have a different job than you had last year, send the Marketplace recent pay stubs from your new job, instead of last year\'s tax return or W2. Read "<a href="https://marketplace.cms.gov/outreach-and-education/household-income-data-matching-issues.pdf" target="_blank" class="t-data t-link">"The Consumer Guide to Annual Income data matching issues</a>" for more information on how to resolve income-related data matching issues.<br><br>You can use <a class="t-data t-link" href="https://marketplace.cms.gov/outreach-and-education/income-worksheet-for-consumers.pdf" target="_blank">this worksheet</a> to find out which documents you may need to submit. If you select "Other" from the drop-down menu, you can include this completed worksheet when you submit documents. We may be able to confirm your income and process your application faster.<br><br>Here are the documents you can submit to confirm your yearly income:',
              '',
              '',
              '·        1040 federal or state tax return. Note: It must contain your first and last name, income amount, and tax year.',
              '·        Wages and tax statement (W-2 and/ or 1099, including 1099 MISC, 1099G, 1099R, 1099SSA, 1099DIV, 1099SS, 1099INT). Note: It must contain your first and last name, income amount, year, and employer name (if applicable).',
              '·        Pay stub. Note: It must contain your first and last name, income amount, pay period or frequency of pay with the date of payment. If a pay stub includes overtime, please indicate average overtime amount per paycheck.',
              '·        Self-employment ledger documentation (can be a Schedule C, the most recent quarterly or year-to-date profit and loss statement, or a self-employment ledger). Note: It must contain your first and last name, company name, and income amount. If you’re submitting a self-employment ledger, include the dates covered by the ledger, and the net income from profit/loss.',
              '·        Social Security Administration Statements (Social Security Benefits Letter). Note: It must contain first and last name, benefit amount, and frequency of pay.',
              '·        Unemployment Benefits Letter. Note: It must contain your first and last name, source/agency, benefits amount, and duration (start and end date, if applicable).',
              '',
              'Documents to confirm self-employment income:',
              '·        1040 SE with Schedule C, F, or SE (for self-employment income)',
              '·        1065 Schedule K1 with Schedule E',
              '·        Tax return',
              '·        Bookkeeping records',
              '·        Receipts for all allowable expenses',
              '·        Signed time sheets and receipt of payroll, if you have employees',
              '·        Most recent quarterly or year-to-date profit and loss statement',
              '',
              'Documents to confirm unearned income:',
              '·        Annuity statement',
              '·        Statement of pension distribution from any government or private source',
              '·        Worker’s compensation letter',
              '·        Prizes, settlements, and awards, including court-ordered awards letter',
              '·        Proof of gifts and contributions',
              '·        Proof of inheritances in cash or property',
              '·        Proof of strike pay and other benefits from unions',
              '·        Sales receipts or other proof of money received from the sale, exchange, or replacement of things you own',
              '·        Interests and dividends income statement',
              '·        Loan statement showing loan proceeds',
              '·        Royalty income statement or 1099-MISC',
              '·        Proof of bonus/incentive payments',
              '·        Proof of severance pay',
              '·        Pay stub indicating sick pay',
              '·        Letter, deposit, or other proof of deferred compensation payments',
              '·        Pay stub indicating substitute/assistant pay',
              '·        Pay stub indicating vacation pay',
              '·        Proof of residuals',
              '·        Letter, deposit, or other proof of travel/business reimbursement pay',
            ],
          },
          DMI_INCARCERATION: {
            dropdown: [
              'Official release papers',
              'Document showing employment/proof of residence',
              'Signed/notarized affidavit',
              'Other',
            ],
            paragraphs: [
              '·        Official release papers from the institution or Department of Corrections',
              '·        Parole papers',
              '·        Unexpired state ID, driver’s license, work ID, or passport',
              '·        Pay stubs',
              '·        Federal, state, or local benefit letter',
              '·        Clinic, doctor, or hospital records for services provided',
              '·        Medical claim explanation of benefits provided',
              '·        School record/schedule showing enrollment (like for college students)',
              '·        Bank or credit card statement showing transaction history (showing only your name, but not a joint account)',
              '·        Military records',
              '·        Cell phone bill (showing only your name)',
              '·        Lease (must be an active lease where you’re currently residing)',
              '·        Signed notarized statement from the individual with alleged false incarceration inconsistency showing that you’re living in the community and includes your name, date of birth, and address',
              '·        Written statement from someone within the community which shows your name, date of birth, address, phone number, your relationship with the person with alleged false incarceration inconsistency (if it’s not you), and that you’re present and participating within the community',
              '·        Rent receipts (showing only your name)',
              '·        What if I don\'t have any of those documents? You can submit a letter providing the reason you can\'t provide the requested documents. The Marketplace will take your letter into consideration. <a class="t-data t-link" href="https://www.healthcare.gov/downloads/letter-of-explanation-application-info.pdf" target="_blank">You can use this template</a>. To submit this letter, select "Other" from the drop-down menu when you\'re on the upload screen in the application. ',
            ],
          },
          DMI_TRIBE_MEMBERSHIP: {
            dropdown: [
              'Tribal Enrollment / Membership Card',
              'Document issued by BIA',
              'Authentic document from a tribe declaring membership',
              'Certificate of Degree of Indian Blood',
              'Certificate of Indian status card',
              'I-872 American Indian Card',
              'U.S. American Indian/Alaska Native tribal enrollment or shareholder documentation',
              'Letter from the Marketplace granting a tribal exemption',
            ],
            paragraphs: [
              '·        Tribal Enrollment/Membership card from a federally recognized tribe',
              '·        Document issued by Bureau of Indian Affairs (BIA) recognizing you as American Indian/Alaska Native',
              '·        Authentic document from a federally recognized tribe declaring your membership',
              '·        Certificate of Degree of Indian Blood',
              '·        Certificate of Indian status card',
              '·        I-872 American Indian Card',
              '·        Document issued by Indian Health Service (IHS) showing that you were/are eligible for IHS services as an American Indian/Alaska Native',
              '·        U.S. American Indian/Alaska Native tribal enrollment or shareholder documentation',
              '·        Letter from the Marketplace granting a tribal exemption based on tribal membership or Alaska Native shareholder status',
            ],
          },
          DMI_QHP_LAWFUL_PRESENCE: {
            dropdown: [
              'Permanent Resident Card, "Green Card" (I-551)',
              'Reentry Permit (I-327)',
              'Refugee Travel Document (I-571)',
              'Employment Authorization Card (I-766)',
              'Machine Readable Immigrant Visa (with temporary I-551 language)',
              'Temporary I-551 Stamp (on Passport or I-94/I-94A)',
              'Foreign passport',
              'Arrival/Departure Record (I-94/I-94A)',
              'Arrival/Departure Record in foreign passport (I-94)',
              'Certificate of Eligibility for Nonimmigrant Student Status (I-20)',
              'Certificate of Eligibility for Exchange Visitor Status (DS-2019)',
              'Notice of Action (I-797)',
              'Document indicating a member of a federally recognized Indian tribe or American Indian born in Canada',
              'Certification from U.S. Department of Health and Human Services (HHS) Office of Refugee Resettlement (ORR)',
              'Document indicating withholding of removal (or withholding of deportation)',
              'Administrative order staying removal issued by the Department of Homeland Security',
              'Office of Refugee Resettlement (ORR) eligibility letter (if under 18)',
              'Resident of American Samoa Card',
            ],
            paragraphs: [
              '·        Permanent Resident Card, "Green Card" (I-551)',
              '·        Reentry Permit (I-327)',
              '·        Refugee Travel Document (I-571)',
              '·        Employment Authorization Card (I-766)',
              '·        Machine Readable Immigrant Visa (with temporary I-551 language)',
              '·        Temporary I-551 Stamp (on Passport or I-94/I-94A)',
              '·        Foreign passport',
              '·        Arrival/Departure Record (I-94/I-94A)',
              '·        Arrival/Departure Record in foreign passport (I-94)',
              '·        Certificate of Eligibility for Nonimmigrant Student Status (I-20)',
              '·        Certificate of Eligibility for Exchange Visitor Status (DS-2019)',
              '·        Notice of Action (I-797)',
              '·        Document indicating a member of a federally recognized Indian tribe or American Indian born in Canada',
              '·        Certification from U.S. Department of Health and Human Services (HHS) Office of Refugee Resettlement (ORR)',
              '·        Document indicating withholding of removal (or withholding of deportation)',
              '·        Administrative order staying removal issued by the Department of Homeland Security',
              '·        Office of Refugee Resettlement (ORR) eligibility letter (if under 18)',
              '·        Resident of American Samoa Card',
            ],
          },
          DMI_MEDICAID_LAWFUL_PRESENCE: 'DMI_QHP_LAWFUL_PRESENCE',
          '200_MOVED_TO_NEW_SERVICE_AREA': {
            dropdown: [
              'Bills/financial statements at new address',
              'U.S. Postal Service change of address letter',
              'Mortgage/rental document at new address',
              'Letter from a government organization',
              'Letter from an insurance company',
              'Document from an employer',
              'Health care program document',
              'Letter of explanation',
              'Arrival/Departure Record (I-94/I-94A)',
              'Passport',
              'Other',
            ],
            paragraphs: [
              'Documents must show that you (or your dependent) moved. These documents must include your name and the date of the move. Documents you can submit:',
              '',
              'Bills or financial statements that show a change of address or newly started services at your new address, including:',
              'Mail from a financial institution or a bank statement.',
              'An internet, cable, phone, or other public utility (like gas or water) bill or service communication. This should show the date that your new utilities or services started.',
              'U.S. Postal Service change of address confirmation letter that includes the mail forwarding date and the address the mail will be forwarded to.',
              'Mortgage or rental document for your new address, including:',
              'A mortgage deed that says the owner uses the property as a primary residence.',
              'A rental or lease agreement that shows a start date at your new address.',
              'A letter from a government organization, on official letterhead or stationery, that shows a change of address to your new address, including:',
              'A Social Security statement.',
              'A notice from SNAP (food stamps) or TANF (cash assistance) agency.',
              'Mail from the Department of Motor Vehicles (DMV).',
              'Mail from the Internal Revenue Service (IRS).',
              'Mail from the Low Income Home Energy Assistance Program (LIHEAP).',
              'A voter registration card.',
              'A letter from an insurance company, like a homeowner’s or renter’s policy statement, that includes your policy start date at your new address. This should be on official letterhead or stationery.',
              "If you're homeless or in transitional housing: You can submit a reference letter from a person in your state who can confirm you live in the area permanently. This could be a friend, family member, or caseworker. This person must also confirm their own residency by including one of the documents listed above.",
              "See what to do if you don't have any of these documents.",
              'What documents can I submit to confirm I had coverage?',
              'If you moved within the U.S., you must also submit a document that includes your name and shows that you had qualifying health coverage for at least 1 day in the past 60 days before your move. Documents you can submit:',
              '',
              'An insurance document, like a letter from an insurance company showing you or your dependent’s health coverage, including COBRA. This should be on official letterhead or stationery.',
              'A document from an employer, like a letter about you or your dependent’s health coverage, including COBRA. This should be on official letterhead or stationery.',
              'A document from a health care program, like a letter from a government health program, like Medicaid, CHIP, TRICARE, Veterans Affairs (VA), or Peace Corps. This should be on official letterhead or stationery.',
              'If you moved from a U.S. territory, you must submit a document that confirms this information. Documents you can submit:',
              '',
              'A license, government issued ID card, voter registration card, or other form of official identification that shows that you previously lived in a U.S. territory.',
              'A document at your previous address dated within 12 months before your move and a document showing your new address (dated within 60 days after your move), or a document confirming your move (listed above).',
              'If you moved from a foreign country, you must submit a document that confirms this information. Documents you can submit:',
              '',
              'An Arrival/Departure Record (I-94/I-94A) (in a foreign passport or separately) that shows your date of entry into the U.S.',
              'A passport with an admission stamp showing your date of entry into the U.S.',
              'You can upload more than one document if you have multiple documents that confirm your move. Select the green "UPLOAD DOCUMENTS" button on the upload screen to submit each document.',
              'What if I’m homeless or in transitional housing?',
              'You can submit a reference letter from a person in your state who can confirm that you live in the area permanently. This could be a friend, family member or caseworker. This person must also confirm their own residency by including one of the documents listed above. To submit this letter, select "Other" from the drop-down menu.',
              'What if I don’t have any of these documents?',
              'You can submit one document showing your new address (dated within 60 days prior to your move) and one document at your previous address dated within 12 months after your move. To submit these documents, select "Other" from the drop-down menu.',
              'Or, you can submit a letter with the date of your move, your old and new addresses, and the reason you can’t submit documents. Use <a class=\'t-data t-link\' href="https://www.healthcare.gov/downloads/letter-of-explanation.pdf" target="_blank">this form</a> and fill out the “Move” section. When you complete the form, select “Letter of explanation” from the drop-down menu when you’re on the upload documents screen in the application.',
            ],
            otherQuestion: {
              options: ['Within the US', 'From a foreign country'],
              'Within the US': {
                label: 'Proof of prior coverage',
                options: [
                  'Letter from an insurance company',
                  'Document from an employer',
                  'Health care program document',
                ],
              },
              'From a foreign country': {
                label: 'Arrival Record',
                options: [
                  'Arrival/Departure Record (I-94/I-94A)\n',
                  'Passport',
                  'Other',
                ],
              },
            },
          },
          '472_SEP_GRANTED_FOR_MDCAID_DENIAL': {
            dropdown: [
              'Denial letter from your state',
              'Letter stating lost coverage',
              'Marketplace letter',
              'Screenshot of results',
              'Other',
              'Letter of explanation',
            ],
            paragraphs: [
              'Documents must show that you were denied coverage through Medicaid or CHIP. These documents must include your name and the date you were denied coverage. Documents you can submit:',
              '',
              'Denial letter from your state Medicaid or CHIP agency that shows your name, that you were denied coverage through Medicaid or CHIP, and the date that you were denied coverage.',
              'Letter stating your Medicaid or CHIP coverage ended that shows you used to have Medicaid or CHIP coverage and the date it ended. This letter can be from your state Medicaid or CHIP agency or from the insurance company that provided your Medicaid or CHIP benefits.',
              'Letter from the Marketplace that says your state Medicaid or CHIP agency sent your application to the Marketplace.',
              'Screenshot of your eligibility results from your state’s online application, if you got your denial online.',
              'You can upload more than one document if you have multiple documents to confirm denial of Medicaid or CHIP coverage. Select the green "UPLOAD DOCUMENTS" button on the upload screen in your application to submit each document.',
              "What if I used to have Medicaid or CHIP coverage, but don't have it anymore?",
              'If you had Medicaid or CHIP coverage and it ended, you can submit a letter explaining that you lost Medicaid or CHIP. See above for more information.',
              "What if I don't have any of these documents?",
              'You can submit a letter stating that you were denied Medicaid or CHIP, and explaining the reason you can’t provide documents. Use <a class="t-data t-link" href="https://www.healthcare.gov/downloads/letter-of-explanation.pdf" target="_blank">this form</a>, and fill out the "Denial of Medicaid or CHIP Coverage" section. When you complete the form, select "Letter of explanation" from the drop-down menu when you\'re on the upload documents screen in the application.',
            ],
          },
        },
        documentTypeConfig: {
          label: 'Document Type',
          placeholder: 'Select a document to upload',
        },
        statusMappingLabel: {
          EXPIRED: 'Expired',
          PENDING: 'Pending',
          COMPLETE: 'Resolved',
          PROCESSING: 'Pending',
        },
        documentTypeConfigOther: {
          label: 'Document Type',
          placeholder: 'Select a document to upload',
        },
        dropdownToRefCodeMapping: {
          Other: 'OTHER',
          Passport: 'PASSPORT',
          'State ID': 'STATE_ID',
          Affidavit: 'AFFIDAVIT',
          'Pay stubs': 'PAY_STUBS',
          'Court order': 'COURT_ORDER',
          'Tax form(s)': 'TAX_FORM_S',
          'U.S. Passport': 'U_S_PASSPORT',
          'Divorce Decree': 'DIVORCE_DECREE',
          'Letter from VA': 'LETTER_FROM_VA',
          'Reentry Permit': 'REENTRY_PERMIT',
          '1040 tax return': 'FORM_1040_TAX_RETURN',
          'Drivers License': 'DRIVER_S_LICENSE',
          'W2 and/or 1099s': 'W2_AND_OR_1099S',
          'Letter from CHIP': 'LETTER_FROM_CHIP',
          'Marriage license': 'MARRIAGE_LICENSE',
          'Foster care papers': 'FOSTER_CARE_PAPERS',
          'Marketplace letter': 'MARKETPLACE_LETTER',
          'Religious document': 'RELIGIOUS_DOCUMENT',
          'Letter from TRICARE': 'LETTER_FROM_TRICARE',
          'Letter from Medicaid': 'LETTER_FROM_MEDICAID',
          'Letter from Medicare': 'LETTER_FROM_MEDICARE',
          'Marriage Certificate': 'MARRIAGE_CERTIFICATE',
          'Social Security Card': 'SOCIAL_SECURITY_CARD',
          'Letter of explanation': 'LETTER_OF_EXPLANATION',
          'Medical support order': 'MEDICAL_SUPPORT_ORDER',
          'Screenshot of results': 'SCREENSHOT_OF_RESULTS',
          'Document issued by BIA': 'DOCUMENT_ISSUED_BY_BIA',
          'Official public record': 'OFFICIAL_PUBLIC_RECORD',
          'Pay stub documentation': 'PAY_STUB_DOCUMENTATION',
          'Property Deed or Title': 'PROPERTY_DEED_OR_TITLE',
          'Letter from Peace Corps': 'LETTER_FROM_PEACE_CORPS',
          'Letter from an employer': 'LETTER_FROM_AN_EMPLOYER',
          'Official release papers': 'OFFICIAL_RELEASE_PAPERS',
          'Refugee Travel Document': 'REFUGEE_TRAVEL_DOCUMENT',
          'Voter registration card': 'VOTER_REGISTRATION_CARD',
          'Arrival/Departure Record': 'ARRIVAL_DEPARTURE_RECORD',
          'DHS immigration document': 'DHS_IMMIGRATION_DOCUMENT',
          'U.S. Public Birth Record': 'US_PUBLIC_BIRTH_REC',
          'Adoption letter or record': 'ADOPTION_LETTER_OR_RECORD',
          'Document from an employer': 'DOCUMENT_FROM_AN_EMPLOYER',
          'Certificate of Citizenship': 'CERTIFICATE_OF_CITIZENSHIP',
          'I-872 American Indian Card': 'FORM_I_872_AMERICAN_INDIAN_CARD',
          'Letter from health insurer': 'LETTER_FROM_HEALTH_INSURER',
          'School identification card': 'SCHOOL_IDENTIFICATION_CARD',
          'Signed/notarized affidavit': 'SIGNED_NOTARIZED_AFFIDAVIT',
          'Social Security statements': 'SOCIAL_SECURITY_STATEMENTS',
          'Benefit or income statement': 'BENEFIT_OR_INCOME_STATEMENT',
          'Immigrant document from DHS': 'IMMIGRANT_DOCUMENT_FROM_DHS',
          'Legal guardianship document': 'LEGAL_GUARDIANSHIP_DOCUMENT',
          'Letter about COBRA coverage': 'LETTER_ABOUT_COBRA_COVERAGE',
          'Employer Identification Card': 'EMPLOYER_IDENTIFICATION_CARD',
          'Health care program document': 'HEALTH_CARE_PROGRAM_DOCUMENT',
          'Letter stating lost coverage': 'LETTER_STATING_LOST_COVERAGE',
          'Other employer documentation': 'OTHER_EMPLOYER_DOCUMENTATION',
          'Statement of health benefits': 'STATEMENT_OF_HEALTH_BENEFITS',
          'Unemployment benefits letter': 'UNEMPLOYMENT_BENEFITS_LETTER',
          'Certificate of Naturalization': 'CERTIFICATE_OF_NATURALIZATION',
          'Denial letter from your state': 'DENIAL_LETTER_FROM_YOUR_STATE',
          'Employment Authorization Card': 'EMPLOYMENT_AUTHORIZATION_CARD',
          'Permanent Resident/Green Card': 'PERMANENT_RESIDENT_GREEN_CARD',
          'Self-employment documentation': 'SELF_EMPLOYMENT_DOCUMENTATION',
          'Consumer Attested Document Type': 'Ref Code',
          'Machine Readable Immigrant Visa': 'MACHINE_READABLE_IMMIGRANT_VISA',
          'Native American Tribal document': 'NATIVE_AMERICAN_TRIBAL_DOCUMENT',
          'Letter from an insurance company':
            'LETTER_FROM_AN_INSURANCE_COMPANY',
          'Certificate of Indian status card':
            'CERTIFICATE_OF_INDIAN_STATUS_CARD',
          'U.S. military card or draft record':
            'U_S_MILITARY_CARD_OR_DRAFT_RECORD',
          'Letter for loss of student coverage':
            'LETTER_FOR_LOSS_OF_STUDENT_COVERAGE',
          'Tribal Enrollment / Membership Card':
            'TRIBAL_ENROLLMENT_MEMBERSHIP_CARD',
          'U.S. passport or U.S. passport card':
            'U_S_PASSPORT_OR_U_S_PASSPORT_CARD',
          'Arrival/Departure Record (I-94/I-94A)':
            'ARRIVAL_DEPARTURE_RECORD_I_94_I_94A',
          'Certificate of Degree of Indian Blood':
            'CERTIFICATE_OF_DEGREE_OF_INDIAN_BLOOD',
          'Employer document with premium amount':
            'EMPLOYER_DOCUMENT_WITH_PREMIUM_AMOUNT',
          'Letter from a government organization':
            'LETTER_FROM_A_GOVERNMENT_ORGANIZATION',
          'State-issued enhanced Drivers License':
            'STATE_ISSUED_ENHANCED_DRIVER_S_LICENSE',
          'U.S. Coast Guard Merchant Mariner card':
            'U_S_COAST_GUARD_MERCHANT_MARINER_CARD',
          'Document for coverage loss due to death':
            'DOCUMENT_FOR_COVERAGE_LOSS_DUE_TO_DEATH',
          'Military dependents identification card':
            'MILITARY_DEPENDENT_S_IDENTIFICATION_CARD',
          'Mortgage/rental document at new address':
            'MORTGAGE_RENTAL_DOCUMENT_AT_NEW_ADDRESS',
          'Bills/financial statements at new address':
            'BILLS_FINANCIAL_STATEMENT_AT_NEW_ADDRESS',
          'Arrival/Departure Record in foreign passport':
            'ARRIVAL_DEPARTURE_RECORD_IN_FOREIGN_PASSPORT',
          'Drivers license issued by state or territory':
            'DRIVER_S_LICENSE_ISSUED_BY_STATE_OR_TERRITORY',
          'Employer letter about the employers coverage':
            'EMPLOYER_LETTER_ABOUT_THE_EMPLOYER_S_COVERAGE',
          'U.S. Postal Service change of address letter':
            'U_S_POSTAL_SERVICE_CHANGE_OF_ADDRESS_LETTER',
          'Document showing employment/proof of residence':
            'DOCUMENT_SHOWING_EMPLOYMENT_PROOF_OF_RESIDENCE',
          'Document from a federally recognized Indian tribe':
            'DOCUMENT_FROM_A_FEDERALLY_RECOGNIZED_INDIAN_TRIBE',
          'Employer Coverage Tool with employer cover letter':
            'EMPLOYER_COVERAGE_TOOL_WITH_EMPLOYER_COVER_LETTER',
          'Temporary I-551 Stamp (on Passport or I-94/I-94A)':
            'TEMPORARY_I_551_STAMP_ON_PASSPORT_OR_I_94_I_94A',
          'Authentic document from a tribe declaring membership':
            'AUTHENTIC_DOCUMENT_FROM_A_TRIBE_DECLARING_MEMBERSHIP',
          'Document for coverage loss due to divorce/separation':
            'DOCUMENT_FOR_COVERAGE_LOSS_DUE_TO_DIVORCE_SEPARATION',
          'Letter from the Marketplace granting a tribal exemption':
            'LETTER_FROM_THE_MARKETPLACE_GRANTING_A_TRIBAL_EXEMPTION',
          'Identification Card Issued by the Federal, State, or Local Government':
            'IDENTIFICATION_CARD_ISSUED_BY_THE_FEDERAL_STATE_OR_LOCAL_GOVERNMENT',
          'Permanent Resident Card or Alien Registation Receipt Card (Form I-551)':
            'PERMANENT_RESIDENT_CARD_OR_ALIEN_REGISTRATION_RECEIPT_CARD_FORM_I_551',
          'Employment Authorization Document that contains a photograph (Form I-766)':
            'EMPLOYMENT_AUTHORIZATION_DOCUMENT_THAT_CONTAINS_A_PHOTOGRAPH_FORM_I_766',
          'High school or college diploma (including high school equivalency diplomas)':
            'HIGH_SCHOOL_OR_COLLEGE_DIPLOMA_INCLUDING_HIGH_SCHOOL_EQUIVALENCY_DIPLOMAS',
          'Employer letter indicating that no plans offered are qualifying health coverage':
            'EMPLOYER_LETTER_INDICATING_THAT_NO_PLANS_OFFERED_ARE_QUALIFYING_HEALTH_COVERAGE',
          'U.S. American Indian/Alaska Native tribal enrollment or shareholder documentation':
            'U_S_AMERICAN_INDIAN_ALASKA_NATIVE_TRIBAL_ENROLLMENT_OR_SHAREHOLDER_DOCUMENTATION',
          'Certificate of Naturalization (Form N-550 or N-570) or Certificate of U.S. Citizenship (Form N-560 or N-561)':
            'CERTIFICATE_OF_NATURALIZATION_FORM_N_550_OR_N_570_OR_US_CITIZENSHIP_FORM_N_560_OR_N_561',
          'Foreign passport, or identification card issued by a foreign embassy or consulate that contains a photograph':
            'FOREIGN_PASSPORT_OR_ID_ISSUED_BY_A_FOREIGN_EMBASSY_OR_CONSULATE_CONTAINS_A_PHOTOGRAPH',
        },
      },
    },
    login: {
      meta: {
        label: 'Log In',
        enabled: true,
        modules: {
          page: 'string',
          layout: 'string',
          layoutOptions: {
            title: 'string',
            header: { icon: 'product-icon', text: 'string' },
            heroImg: 'image',
            sections: 'object-list',
          },
          authCardOptions: {
            form: 'form',
            title: 'string',
            footer: {
              link: { prop: 'string', label: 'string' },
              button: 'button',
            },
            subtitle: 'string',
          },
          routeAfterSuccessConfig: {
            id: 'string',
            route: 'string',
            checkApplication: 'boolean',
          },
        },
        description: '',
      },
      page: 'login',
      layout: 'banner',
      layoutOptions: {
        title:
          "Our not-for-profit status allows us to focus on our mission — caring more for our members than 'the bottom line.",
        header: {
          icon: 'https://zipari-uploads-dev.s3.amazonaws.com/multitenant/files/d40fa16f-4759-4c7f-a2af-61ef3765b7b9.png',
          text: 'Our not-for-profit status allows us to focus on our mission — caring more for our members than the bottom line.',
        },
        heroImg:
          'https://zipari-uploads-dev.s3.amazonaws.com/multitenant/files/f5d8fe90-b44f-4aae-91ca-7bdc66191369.png',
        sections: [
          {
            text: 'We offer access to more than 1 million physicians, provider facilities, hospitals and other care centers in our provider networks <br><br> Search for a doctor, facility or pharmacy by name or provider type. today.',
            type: 'text',
            title: 'Find a Doctor',
          },
          {
            list: [
              { text: 'Expansive provider network' },
              { text: 'Health & Wellness Program' },
              { text: 'Experienced Customer Support Team' },
            ],
            type: 'list',
            title: 'Why Branch Health',
          },
          {
            type: 'links',
            links: [
              { url: 'www.google.com', label: 'Individual & Family Plans >' },
              { url: 'www.google.com', label: 'Employer Plans >' },
              { url: 'www.google.com', label: 'Medicare Supplement Plans >' },
              { url: 'www.google.com', label: 'Dental Plans >' },
            ],
            title: 'Need Health Insurance?',
            description:
              'Check out our complete listing of plans for families and individuals:',
          },
        ],
      },
      authCardOptions: {
        form: {
          controls: [
            {
              link: 'Forgot Username?',
              prop: 'username',
              type: 'text',
              label: 'Username',
              maxLength: 40,
              validators: [
                'required',
                { name: 'minCount', dependency: 6 },
                {
                  name: 'blacklistCharacters',
                  dependency: [
                    '"',
                    '/',
                    '\\',
                    '[',
                    ']',
                    ':',
                    ';',
                    '|',
                    '=',
                    ',',
                    '*',
                    '?',
                    '<',
                    '>',
                  ],
                },
              ],
            },
            {
              link: 'Forgot Password?',
              prop: 'password',
              type: 'password',
              label: 'Password',
              validators: [
                'required',
                { name: 'minCount', dependency: 8 },
                { name: 'not_match', dependency: 'username' },
                { name: 'blacklistCharacters', dependency: [] },
              ],
            },
          ],
        },
        title: 'Welcome Back!',
        footer: {
          link: { prop: 'register', label: 'Not Yet Registered?' },
          button: {
            id: 'loginBtn',
            icon: '',
            level: 'high',
            content: 'Log In',
          },
        },
        subtitle:
          'Please log in with your new account to continue your application.',
      },
      routeAfterSuccessConfig: {
        id: 'id',
        route: 'shopping/workbench/',
        checkApplication: true,
      },
    },
    theme: {
      nav: {
        '--nav-height': '3rem',
        '--stepper-top': '6.25rem',
        '--nav-icon-color': 'var(--white)',
        '--stepper-mobile-top': '3.85rem',
        '--shopping-selection-header-top': '9.65rem',
      },
      table: {
        '--a-p-font-size': '1rem',
        '--table-row-padding': '0',
        '--table-table-top-display': 'flex',
        '--table-table-top-align-items': 'center',
        '--table-table-top-flex-direction': 'row',
        '--table-table-top-justify-content': 'space-between',
      },
      custom: {
        '--pf-link': '#135BEC',
        '--warn--tint': '#fef6ec',
        '--pf-background': 'var(--gray--border)',
        '--compare-plans-top': '2rem',
        '--toolbar-min-height': '2.5rem',
        '--status-border-width': '1px',
        '--status-border-radius': '0.8125rem',
        '--sep__card-margin-bottom': '0rem',
        '--filter-mobile-margin-top': '0rem',
        '--menu__icon-color--mobile': 'var(--white)',
        '--stepper--badge-disabled-bg': 'var(--text--2)',
        '--shopping-stepper-margin-top': '4rem',
        '--enrollment-content-margin-offset': '4rem',
        '--confirmation-margin-offset-mobile': '-2rem',
        '--shopping-stepper-margin-top-mobile': '5rem',
        '--shopping__outlet-margin-top-mobile': '0rem',
        '--broker-portal__outlet-margin-top-mobile': '4rem',
        '--enrollment-content-margin-offset-mobile': '4.8rem',
      },
      dashboard: { '--demographics-splash-height': '9rem' },
      typography: {
        color: {
          '--application-details__aside__section__value-text-color': '#307fe2',
        },
        custom: { '--modal-header-right-display': 'flex' },
        typeface: {
          '--typeface-1-name': "'Lato', 'Helvetica Neue', sans-serif",
        },
      },
      demographics: {
        '--demographics-splash-min-height': '25rem',
        '--demographics-splash-card-bg-color': 'var(--white)',
        '--demographics-coverage-option-avatar-border': '1px solid #C1C8D5',
        '--demographics-coverage-option-avatar-background': '#ffffff',
        '--demographics-coverage-option-avatar-icon-color': '#727377',
        '--demographics-coverage-card-body-banner-bg-color': '#e3eaf6',
        '--demographics-coverage-card-footer-text-decoration': 'underline',
        '--demographics-coverage-option-avatar-background-active': '#E3EAF6',
      },
      'feedback-button': { '--feedback-button-margin-bottom': '3rem' },
      'modal-attribute': { options: { '--modal-attribute-flex': '3' } },
    },
    footer: {
      rows: {
        contact: {
          key: 'contact',
          label: 'Brand Logo & Contact Information',
          columns: {
            '0': {
              '0': {
                type: 'image',
                width: '200px',
                height: '65px',
                source: 'https://d32ul9oyxvd2n5.cloudfront.net/assets/logo.png',
              },
            },
            '1': {
              '0': { type: 'header', label: 'Contact Us' },
              '1': {
                type: 'phone',
                label: 'Member Services',
                phone: '(123) 456-7890',
              },
              '2': {
                type: 'phone',
                label: 'TTY Users',
                phone: '(123) 456-7890',
              },
            },
            '2': {
              '0': { type: 'header', label: 'Hours of Service' },
              '1': { type: 'text', label: 'Mon - Fri 8AM to 5PM EST' },
            },
            '3': {
              '0': { type: 'header', label: 'Address' },
              '1': {
                type: 'address',
                line1: '45 Main Street',
                line2: 'Brooklyn, NY 11201',
              },
            },
          },
          priority: 0,
          marginBottom: '3rem',
        },
        otherLinks: {
          key: 'otherLinks',
          label: 'Other Links',
          columns: {
            '0': {
              '0': {
                type: 'link',
                label: 'Privacy Policy',
                route: 'https://www.google.com',
                target: 'tab',
                isExternalRoute: true,
              },
              '1': {
                type: 'link',
                label: 'Terms Of Use',
                route: 'https://www.google.com',
                target: 'tab',
                isExternalRoute: true,
              },
            },
            '1': {
              '0': {
                type: 'link',
                label: 'Provider 2',
                route: 'https://www.google.com',
                target: 'tab',
                isExternalRoute: true,
              },
              '1': {
                type: 'link',
                label: 'Provider 3',
                route: 'https://www.google.com',
                target: 'tab',
                isExternalRoute: true,
              },
            },
            '2': {
              '0': {
                type: 'link',
                label: 'Resources',
                route: 'https://www.google.com',
                target: 'tab',
                isExternalRoute: true,
              },
              '1': {
                type: 'link',
                label: 'Report Fraud',
                route: 'https://www.google.com',
                target: 'tab',
                isExternalRoute: true,
              },
            },
            '3': {
              '0': {
                type: 'link',
                label: 'Provider 5',
                route: 'https://www.google.com',
                target: 'tab',
                isExternalRoute: true,
              },
              '1': {
                type: 'link',
                label: 'Contact Us',
                route: 'https://www.google.com',
                target: 'tab',
                isExternalRoute: true,
              },
            },
          },
          priority: 1,
          marginBottom: '3rem',
        },
        socialCopyrightAwards: {
          key: 'socialCopyrightAwards',
          label: 'Social Media, Copyright & Awards',
          columns: {
            '0': {
              '0': {
                type: 'image',
                route: 'http://www.google.com',
                width: '32px',
                height: '32px',
                source:
                  'https://zipari-uploads-dev.s3.amazonaws.com/files/80b82888-5af0-4aff-b06b-dbc13b9a2366.png',
                target: 'tab',
                isExternalRoute: true,
              },
              '1': {
                type: 'image',
                route: 'http://www.google.com',
                width: '32px',
                height: '32px',
                source:
                  'https://zipari-uploads-dev.s3.amazonaws.com/files/2991d83e-4368-434f-9c8c-6dd7210c56bc.png',
                target: 'tab',
                isExternalRoute: true,
              },
              '2': {
                type: 'image',
                route: 'http://www.google.com',
                width: '38px',
                height: '32px',
                source:
                  'https://zipari-uploads-dev.s3.amazonaws.com/linkedin.png',
                target: 'tab',
                isExternalRoute: true,
              },
              '3': {
                type: 'image',
                route: 'http://www.google.com',
                width: '32px',
                height: '32px',
                source:
                  'https://zipari-uploads-dev.s3.amazonaws.com/files/045fdc48-53a3-4b8c-979f-edfb1a344f3a.png',
                target: 'tab',
                isExternalRoute: true,
              },
            },
            '1': { '0': { type: 'text', label: '© 2023 Brand Health' } },
            '2': {
              '0': {
                type: 'image',
                width: '142px',
                height: '45px',
                source:
                  'https://zipari-uploads-dev.s3.amazonaws.com/files/e7ca7470-e072-496e-9f0a-b7b3e1e7cf83.png',
              },
            },
          },
          priority: 3,
        },
      },
      text: 'Copyright text',
      layout: 'columns',
      showImg: false,
      contact1: null,
      contact2: null,
      copyright: { text: 'Copyright text', image: null },
      quickLinks1: {
        label: '',
        attributes: [{ label: 'Quicklink', value: '#' }],
      },
      quickLinks2: {
        label: '',
        attributes: [{ label: 'Quicklink', value: '#' }],
      },
      socialMedia: null,
      paginatorText:
        'Showing ${firstShowing} - ${lastShowing} of ${totalCount}',
      usesDesignSystem: true,
      quickLinksHeaderLabel: 'Quick Links',
    },
    global: {
      ede: true,
      meta: {
        label: 'Global',
        enabled: true,
        modules: {
          title: 'string',
          payment: {
            vendor: 'string',
            fiserve_endpoint: 'string',
            ProcessingRegionCode: 'number',
          },
          analytics: {
            cx_capture: {
              base_url: 'https://demo.sandbox.zipari.io/',
              endpoint: 'https://demo.sandbox.zipari.io/',
              source_system_name: 'shp_brandhealth',
            },
          },
        },
        description: '',
      },
      title: 'Brand Health | Shopping',
      timeout: {
        idle: {
          enabled: true,
          timeToIdle: 1620,
          timeoutAfterIdle: 180,
          redirectAfterLogoutUrl: '',
        },
      },
      analytics: {
        posthog: {
          api_host: 'https://posthog.sb1.zipari.cloud',
          initialize: true,
          debug_enabled: false,
          autocapture_on: false,
          customEvent_on: false,
          posthog_api_key: 'phc_CNdt9DfmaeToYeq8ThZBzvUpQ7rIxVIDPvV8wdjDN0s',
        },
        cx_capture: {
          mapping: {},
          base_url: 'https://zipari.sandbox.zipari.io/',
          endpoint: 'https://zipari.sandbox.zipari.io/',
          source_system_name: 'ifp_sp_v3',
        },
        google_analytics: {
          ga: null,
          gtag: null,
          mapping: { workflow_step: 'virtualPageView' },
        },
      },
      plan_card: { badges: { enabled: true } },
      shouldLog: true,
      handleAuth: true,
      tenantName: 'Brand Health',
      featuresFlag: { whoseCovered: { hasParentDependents: true } },
      showDashboard: true,
      authExceptions: ['shopping/individual/quotes/'],
      brokerAssistance: { retrieveDetails: true },
      contactPhoneNumber: '',
      redirectToWorkbench: true,
      preventFamilyHighlightAttributes: false,
      preserveRoutingWhenUnauthenticatedFromRoutes: [
        'shopping/individual/quotes-ua',
      ],
    },
    quotes: {
      table: {
        title: 'Quotes',
        button: { icon: '', level: 'high', content: 'Create Quote' },
        detail: { enabled: true },
        export: { icon: 'download', level: 'medium', content: '' },
        paging: { enabled: true, pageSize: 20 },
        columns: [
          { name: 'Quote ID', prop: 'id', sortable: true },
          {
            name: 'Client Name',
            prop: 'client',
            format: 'FULL_NAME',
            sortable: true,
            sortByProp: 'client__first_name',
          },
          {
            name: 'Products Quoted',
            prop: 'plans',
            format: 'LIST',
            formatOptions: { mapping: 'display_name' },
          },
          {
            name: 'Req. Eff. Date',
            prop: 'coverage_effective_date',
            format: 'DATE',
            sortable: true,
          },
          {
            name: 'Date Created',
            prop: 'created_at',
            format: 'DATE',
            sortable: true,
          },
          {
            name: 'Quote Status',
            prop: 'status',
            format: 'STATUS',
            sortable: true,
          },
          {
            name: 'Action',
            format: 'ACTIONS',
            actions: [
              {
                icon: 'view_detail',
                displayText: 'View Details',
                conditionProp: '',
                conditionValue: [],
              },
              {
                icon: 'delete_active',
                displayText: 'Delete',
                conditionProp: 'status',
                conditionValues: ['expired'],
              },
            ],
            priority: 8,
            sortable: false,
            columnHeaderIcon: 'settings_active',
            columnHeaderIconLabel: 'Edit View',
          },
          {
            name: 'Broker Name',
            prop: 'client.broker',
            format: 'FULL_NAME',
            isHidden: true,
            sortable: true,
          },
        ],
        filters: [
          {
            icon: 'search',
            prop: 'search',
            size: 'small',
            type: 'text',
            label: 'Quote ID or Client Name',
          },
          {
            icon: '',
            prop: 'status',
            size: 'small',
            type: 'dropdown',
            label: 'Status',
            options: [
              { label: 'Select One', value: '' },
              { label: 'Quoted', value: 'quoted' },
              {
                label: 'Application Submitted',
                value: 'application_submitted',
              },
              {
                label: 'Application In Progress',
                value: 'application_in_progress',
              },
              { label: 'Expired', value: 'expired' },
            ],
            autocomplete: 'off',
            usePlaceholder: false,
          },
          {
            icon: '',
            prop: 'coverage_effective_date',
            size: 'small',
            type: 'date',
            label: 'Requested Effective Date',
            placeholder: 'mm/dd/yyyy',
          },
        ],
        sorting: { init: { created_at: 'desc' }, stackedIcons: true },
        endpoint: 'api/shopping/quotes/individuals/',
        formType: 'formGroup',
        messages: { noData: 'No data found.' },
        pagination: 20,
        showSpinner: true,
        exportConfig: { enabled: true, exportWithFormatting: false },
      },
      showFooter: true,
      buttonClick: {
        'Create Quote': { route: 'shopping/individual/create-quote' },
      },
      deleteModal: {
        body: 'Are you sure you want to permanently delete this quote?',
        cancel: 'Cancel',
        header: 'Delete Quote',
        submit: 'Yes, Delete',
      },
      detailPageName: 'quote-details',
      uniqueIdentifier: 'alt_id',
    },
    landing: {
      title: 'Do you want to get a quote or enroll in a plan?',
      splash: {
        card: true,
        list: [
          'Get personalized plan recommendations.',
          "Save money if you're eligible for subsidies",
          'Compare plan benefits side-by-side.',
        ],
        title: 'We make it easy to find the right plan for your needs.',
        alignment: 'right',
        paragraph:
          "Get personalized plan recommendations, save money if you're eligible for subsidies, compare plan benefits side-by-side.",
      },
      getQuote: {
        icon: 'clock',
        text: 'You can select multiple plans to save and compare',
        title: 'Get Quote',
      },
      subtitle:
        'Browse our plans to find the best coverage for you and your family.',
      enrollNow: {
        icon: 'permissions',
        text: 'Create an application and enroll in health coverage',
        title: 'Enroll Now',
      },
    },
    register: {
      meta: {
        label: 'Registration',
        enabled: true,
        modules: {
          page: 'string',
          layout: 'string',
          layoutOptions: {
            title: 'string',
            header: { icon: 'product-icon', text: 'string' },
            heroImg: 'image',
            sections: 'object-list',
          },
          authCardOptions: {
            form: 'form',
            title: 'string',
            footer: {
              link: { prop: 'string', label: 'string' },
              button: 'button',
            },
            subtitle: 'string',
          },
          routeAfterSuccessConfig: {
            id: 'string',
            route: 'string',
            checkApplication: 'boolean',
          },
        },
        description: '',
      },
      page: 'register',
      layout: 'banner',
      layoutOptions: {
        title:
          "Our not-for-profit status allows us to focus on our mission — caring more for our members than 'the bottom line.",
        header: {
          icon: '',
          text: 'Our not-for-profit status allows us to focus on our mission — caring more for our members than the bottom line.',
          iconName: 'cover_who',
        },
        heroImg:
          'https://zipari-uploads-dev.s3.amazonaws.com/multitenant/files/f5d8fe90-b44f-4aae-91ca-7bdc66191369.png',
        sections: [
          {
            text: 'We offer access to more than 1 million physicians, provider facilities, hospitals and other care centers in our provider networks <br><br> Search for a doctor, facility or pharmacy by name or provider type. today.',
            type: 'text',
            title: 'Find a Doctor',
          },
          {
            list: [
              { text: 'Expansive provider network' },
              { text: 'Health & Wellness Program' },
              { text: 'Experienced Customer Support Team' },
            ],
            type: 'list',
            title: 'Why Branch Health',
          },
          {
            type: 'links',
            links: [
              { url: 'www.google.com', label: 'Individual & Family Plans >' },
              { url: 'www.google.com', label: 'Employer Plans >' },
              { url: 'www.google.com', label: 'Medicare Supplement Plans >' },
              { url: 'www.google.com', label: 'Dental Plans >' },
            ],
            title: 'Need Health Insurance?',
            description:
              'Check out our complete listing of plans for families and individuals:',
          },
        ],
      },
      authCardOptions: {
        form: {
          controls: [
            {
              grid: { col: '1 / 3', row: '1' },
              prop: 'first_name',
              type: 'text',
              label: 'Your first name',
              maxLength: 15,
              validators: ['alpha', 'required'],
            },
            {
              grid: { col: '3 / 5', row: '1' },
              prop: 'last_name',
              type: 'text',
              label: 'Your last name',
              maxLength: 15,
              validators: ['alpha', 'required'],
            },
            {
              grid: { col: '5 / 7', row: '1' },
              prop: 'username',
              type: 'text',
              label: 'Create a user name',
              validators: [
                'required',
                { name: 'minCount', dependency: 6 },
                {
                  name: 'blacklistCharacters',
                  dependency: [
                    '"',
                    '/',
                    '\\',
                    '[',
                    ']',
                    ':',
                    ';',
                    '|',
                    '=',
                    ',',
                    '*',
                    '?',
                    '<',
                    '>',
                  ],
                },
              ],
            },
            {
              grid: { col: '1 / 4', row: '2' },
              prop: 'email',
              type: 'text',
              label: 'Enter your email',
              validators: ['email', 'required'],
            },
            {
              grid: { col: '4 / 7', row: '2' },
              prop: 'email_confirm',
              type: 'text',
              label: 'Confirm Email',
              validators: ['required', { name: 'match', dependency: 'email' }],
            },
            {
              grid: { col: '1 / 7', row: '3' },
              prop: 'password',
              type: 'passwords',
              label: 'Confirm Password',
              validators: [
                'required',
                { name: 'match', dependency: 'password' },
              ],
            },
          ],
        },
        title: 'Create an Account to Secure Your Health Plan',
        footer: {
          link: { prop: 'login', label: 'Login with Existing Account' },
          button: { icon: '', level: 'high', content: 'Submit Registration' },
        },
        subtitle:
          'After you create an account, we’ll walk you through the remaining steps to enroll in your selected health plan.',
        successTitle: 'A verification link has been sent to ${email}',
        successSubtitle:
          'Please click the link in that email to complete the registration process.',
      },
      routeAfterSuccessConfig: { disableAfterSuccess: true },
    },
    LANGUAGES: { es: 'Spanish', 'en-us': 'English' },
    errorPage: {
      img: 'https://zipari-uploads-dev.s3.amazonaws.com/multitenant/images/error-2.original.png',
      codes: [],
      header: {
        title: 'We were unable to connect you',
        subtitle:
          'Something went wrong on our end and we were unable to connect. Please try again. If you continue to see this message, please contact Member Services using the number on the back of your ID card.',
      },
      buttons: [
        {
          prop: { route: 'login', action: 'INTERNAL_ROUTE' },
          level: 'medium',
          content: 'Go To Home',
        },
      ],
    },
    individual: {
      quotes: {
        table: {
          title: 'Quotes',
          button: { icon: '', level: 'high', content: 'Create Quote' },
          detail: { enabled: true },
          export: { icon: 'download', level: 'medium', content: '' },
          paging: { enabled: true, pageSize: 20 },
          columns: [
            { name: 'Quote ID', prop: 'id', sortable: true },
            {
              name: 'Client Name',
              prop: 'client',
              format: 'FULL_NAME',
              sortable: true,
              sortByProp: 'client__first_name',
            },
            {
              name: 'Products Quoted',
              prop: 'plans',
              format: 'LIST',
              formatOptions: { mapping: 'display_name' },
            },
            {
              name: 'Req. Eff. Date',
              prop: 'coverage_effective_date',
              format: 'DATE',
              sortable: true,
            },
            {
              name: 'Date Created',
              prop: 'created_at',
              format: 'DATE',
              sortable: true,
            },
            {
              name: 'Quote Status',
              prop: 'status',
              format: 'STATUS',
              sortable: true,
            },
            {
              name: 'Action',
              format: 'ACTIONS',
              actions: [
                {
                  icon: 'view_detail',
                  displayText: 'View Details',
                  conditionProp: '',
                  conditionValue: [],
                },
                {
                  icon: 'delete_active',
                  displayText: 'Delete',
                  conditionProp: 'status',
                  conditionValues: ['expired'],
                },
              ],
              priority: 8,
              sortable: false,
              columnHeaderIcon: 'settings_active',
              columnHeaderIconLabel: 'Edit View',
            },
            {
              name: 'Broker Name',
              prop: 'client.broker',
              format: 'FULL_NAME',
              isHidden: true,
              sortable: true,
            },
          ],
          filters: [
            {
              icon: 'search',
              prop: 'search',
              size: 'small',
              type: 'text',
              label: 'Quote ID or Client Name',
            },
            {
              icon: '',
              prop: 'status',
              size: 'small',
              type: 'dropdown',
              label: 'Status',
              options: [
                { label: 'Select One', value: '' },
                { label: 'Quoted', value: 'quoted' },
                {
                  label: 'Application Submitted',
                  value: 'application_submitted',
                },
                {
                  label: 'Application In Progress',
                  value: 'application_in_progress',
                },
                { label: 'Expired', value: 'expired' },
              ],
              autocomplete: 'off',
              usePlaceholder: false,
            },
            {
              icon: '',
              prop: 'coverage_effective_date',
              size: 'small',
              type: 'date',
              label: 'Requested Effective Date',
              placeholder: 'mm/dd/yyyy',
            },
          ],
          sorting: { init: { created_at: 'desc' }, stackedIcons: true },
          endpoint: 'api/shopping/quotes/individuals/',
          formType: 'formGroup',
          messages: { noData: 'No data found.' },
          pagination: 20,
          showSpinner: true,
          exportConfig: { enabled: true, exportWithFormatting: false },
        },
        showFooter: true,
        buttonClick: {
          'Create Quote': { route: 'shopping/individual/create-quote' },
        },
        deleteModal: {
          body: 'Are you sure you want to permanently delete this quote?',
          cancel: 'Cancel',
          header: 'Delete Quote',
          submit: 'Yes, Delete',
        },
        detailPageName: 'quote-details',
        uniqueIdentifier: 'alt_id',
      },
      upsell: {
        review: {
          label: 'Review',
          button: { content: 'Next' },
          reviewCards: [
            {
              icon: 'coverage',
              label: 'Coverages & Members',
              sections: [
                {
                  prop: null,
                  label: 'Coverage',
                  attributes: [
                    { prop: 'permanent_address.zipcode', label: 'ZIP Code' },
                    {
                      prop: 'demographics.displayCoverageType',
                      label: 'Coverage Type',
                    },
                    {
                      prop: 'coverage_effective_date',
                      label: 'Coverage Start Date',
                      format: 'DATE',
                    },
                  ],
                },
                {
                  prop: 'subscriber.date_of_birth',
                  label: 'Subscriber',
                  attributes: [
                    { prop: 'subscriber', label: 'Name', format: 'FULL_NAME' },
                    {
                      prop: 'subscriber.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    { prop: 'subscriber.gender', label: 'Gender' },
                  ],
                },
                {
                  prop: 'spouse.date_of_birth',
                  label: 'Spouse',
                  attributes: [
                    { prop: 'spouse', label: 'Name', format: 'FULL_NAME' },
                    {
                      prop: 'spouse.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    { prop: 'spouse.gender', label: 'Gender' },
                  ],
                },
                {
                  prop: 'dependents',
                  label: 'Dependent ${displayIndex}',
                  arrayProp: 'dependents',
                  attributes: [
                    {
                      prop: 'dependents.${index}',
                      label: 'Name',
                      format: 'FULL_NAME',
                    },
                    {
                      prop: 'dependents.${index}.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    { prop: 'dependents.${index}.gender', label: 'Gender' },
                  ],
                },
              ],
            },
            {
              icon: 'care',
              type: 'plan',
              label: 'Selected Plan',
              stepIndex: 1,
            },
            { type: 'attestations' },
            { type: 'signature' },
          ],
          planTypeOrder: ['medical', 'bundled', 'dental', 'vision'],
          termsOfService: [
            {
              header: 'Authorization for Release of Information',
              sections: [
                {
                  header: 'Completing Your Application:',
                  paragraphs: [
                    "You must scroll to the bottom of the information and check the box to verify that you've read and agree with the information below for you and on behalf of each applying family member.",
                    'By signing this form, you are authorizing the release of your and/or your dependents? healthcare information by a healthcare provider, insurer, insurance support organization, health plan, or your insurance agent to Blue Shield of California or Blue Shield of California Life & Health Insurance Company (collectively, Blue Shield) for the purpose of processing claims and for administering benefits under the health service agreement/policy.',
                    'Further, by signing below you are authorizing Blue Shield to disclose such healthcare information to a healthcare provider, insurer, self-insurer, insurance support organization, health plan, or your insurance agent for the purpose of investigating or evaluating any claim for benefits. The healthcare information used or disclosed pursuant to this authorization may be subject to re-disclosure and may no longer be protected under the federal health information privacy laws.',
                    'You have the right to refuse to sign this authorization.',
                    'You are entitled to a copy of this authorization after you sign it.',
                  ],
                },
                {
                  header: 'Expiration:',
                  paragraphs: [
                    'This authorization will remain valid: 1) for thirty (30) months from the date of this authorization for the purposes of processing your application, processing a request for reinstatement, or processing a request for a change in benefits; 2) for as long as may be necessary for processing of claims incurred during the term of coverage; and 3) for the term of coverage for all other activities under the health service agreement/policy.',
                  ],
                },
                {
                  header: 'Right to Revoke:',
                  paragraphs: [
                    'I understand that I may revoke this authorization at any time by giving written notice of my revocation to Blue Shield. I understand that revocation of this authorization will not affect any action Blue Shield has taken in reliance on this authorization prior to receiving my written notice of revocation.',
                  ],
                },
              ],
              attestation:
                'I, the enrollee, have read and agree to Authorization for Release of Information',
            },
            {
              header: 'Verification of Accuracy',
              sections: [
                {
                  header: 'Completing Your Application:',
                  paragraphs: [
                    "You must scroll to the bottom of the information and check the box to verify that you've read and agree with the information below for you and on behalf of each applying family member.",
                    'I alone am responsible for the accuracy and completeness of the information provided on this application. I have personally reviewed all information provided on this application, even if I did not fill out the application myself. To the best of my knowledge and belief, all information on this application is accurate, true, and complete. If Blue Shield determines that there is fraud (by act, practice, or omission) or an intentional misrepresentation of material fact in the information on this application, I understand that coverage may be rescinded as allowed by law.',
                    'For applicants with a language preference other than English: If I indicated in Part 1 that I have a language preference other than English and have completed the English version of this application (or version other than in my language preference), I confirm that I understand the questions on this application.',
                    'OR',
                  ],
                },
                {
                  header: 'Broker Attestation:',
                  paragraphs: [
                    'If the application is submitted by the insurance agent, broker, or producer (referred to as your agent) then, by signing this box you are confirming that you [or will you] complete this application on behalf of the client, and will [or will you]  ask each question in this application exactly as set forth and will [or will you] record the answer exactly as given to you. By signing below, you are confirming that you want the service agreement/policy sent directly to the subscriber.',
                  ],
                },
              ],
              attestation:
                'I, the enrollee, insurance agent, broker, or producer, have read and agree to Verification of Accuracy',
            },
            {
              header: 'Verification of Terms',
              sections: [
                {
                  header: 'Completing Your Application:',
                  paragraphs: [
                    "You must scroll to the bottom of the information and check the box to verify that you've read and agree with the information below for you and on behalf of each applying family member.",
                    'You also attest that either You, or an Acceptable Third Party Payor, are making and will make all future premium payments for your Blue Shield coverage in accordance with the Blue Shield Premium Payment Policy.',
                    '1. Application for coverage: It is important to know that Blue Shield of California or Blue Shield of California Life & Health Insurance Company (as applicable) may decline your application for coverage if you are not currently eligible. Your application must be approved by Blue Shield, and an effective date for coverage assigned, before coverage may become effective.',
                    "2. First month's dues/premiums: Blue Shield requires first month's dues/premium at the time of application submission. Find your estimated monthly dues/premiums in the rate book. Failure to submit full payment of dues/premiums will result in a return of your application. Please note that processing any payment does not constitute approval of your application with Blue Shield or Blue Shield Life. If you do not currently qualify for coverage, the dues/premium you submit with your application will not be processed.",
                    '3. Dues/premiums: Dues/premiums are to be paid in full by the due date. Coverage will be terminated for failure to pay dues/premiums in a timely manner as set forth in the health service agreement/policy and as allowed by law. The Subscriber is responsible for payment of dues/premiums to Blue Shield of California. Blue Shield of California does not accept direct or indirect payments of dues/premiums from any person or entity other than the Subscriber, his or her friends, family members or a legal guardian, or an "Acceptable Third Party Payor". Acceptable Third Party Payors are:',
                    ' • Ryan White HIV/AIDS programs under Title XXVI of the Public Health Services Act.',
                    ' • Indian tribes, tribal organizations or urban Indian organizations.',
                    ' • A lawful local, State, or Federal government program, including a grantee directed by a government program to make payments on its behalf.',
                    ' • Bona fide charitable organizations and organizations related to the Subscriber (i.e., church or employer) when the following is also true: payment is guaranteed for the plan year, assistance is provided based on defined financial status criteria and health status is not considered, the organization is unaffiliated with a healthcare provider, and the organization has no financial interest in the payment of a health plan claim. Financially interested institutions/organizations include institutions/organizations that receive the majority of their funding from entities with a pecuniary interest in the payment of health insurance claims, or institutions/organizations that are subject to direct or indirect control of entities with a pecuniary interest in the payment of health insurance claims.',
                    "Upon discovery that dues/premiums were paid directly or indirectly by a person or entity other than those listed above or the Subscriber, Blue Shield of California has the right to reject the payment and inform the Subscriber that the payment was not accepted and that the dues/premiums remain due. Processing any payment does not waive Blue Shield of California's right to reject that payment and future payments under this policy.",
                    '4. Effective date of coverage: If you qualify for coverage, Blue Shield will notify you of your effective date of coverage. If Blue Shield cannot honor your requested effective date, or is unable to issue coverage before your requested date, coverage will begin as soon as possible. If additional dues/premiums are owed, payment must be received before coverage becomes effective. Any charges incurred for services received prior to your effective date or after termination of coverage are not covered.',
                    '5. Acceptance of application: You understand that only Blue Shield can accept your application and issue coverage for an IFP plan requested on this form. Your agent or broker cannot enroll you for coverage or change any terms or conditions of coverage.',
                    '6. Parents/guardians: If you are the parent or legal guardian of an applicant who is a minor, please sign on behalf of the applicant at the bottom of this Part 5. As the parent or legal guardian, you are identified as the person who may make inquiries and act on behalf of the applicant regarding this coverage (as allowed by law). In addition, you are agreeing to assume all responsibility for dues/premiums payments and for following the terms and conditions for coverage. If you are not the parent of the applicant, please attach the court documents that appoint you as the guardian of this minor.',
                    '7. Process to authorize Blue Shield to release personal and health information to a third party: If you would like to authorize your spouse, domestic partner, or a third party to access your personal health information, please complete the form titled Authorization for Blue Shield to Disclose Personal & Health Information to a Third Party. To obtain this form, go to blueshieldca.com and click on the Privacy link at the bottom of the page, or call (800) 431-2809.',
                    '8. Response to requested information: You agree to cooperate with Blue Shield (or Blue Shield Life, as applicable) by providing, or by providing access to, documents and other information requested (such as court orders to provide dependent coverage, etc.) to corroborate information provided in this application for coverage. You acknowledge and agree that failure or refusal to provide these documents or the information requested may be cause to rescind or cancel your coverage.',
                    '9. HIV or genetic testing prohibited: No genetic information, including family medical history, and no information related to HIV testing should be provided. California law prohibits an HIV test from being required or used by a health insurance company or healthcare service plan as a condition of obtaining health coverage.',
                  ],
                },
              ],
              attestation:
                'I, the enrollee, have read and agree to Verification of Terms',
            },
            {
              header:
                'Acknowledgement of Receiving the Summary of Benefits and Coverage',
              sections: [
                {
                  header: 'Completing Your Application:',
                  paragraphs: [
                    "You must scroll to the bottom of the information and check the box to verify that you've read and agree with the information below for you and on behalf of each applying family member.",
                    'Choosing a health coverage option is an important choice. Summary of Benefits and Coverage (SBC) forms are uniform templates and provide you with an easy way to understand your coverage.',
                    'Find definitions for commonly used medical and insurance terms at the Health and Human Services glossary.',
                  ],
                },
              ],
              attestation:
                'I, the enrollee, have received and read Acknowledgement of Receiving the Summary of Benefits and Coverage',
            },
          ],
          signatureConfig: [
            {
              mask: 'alpha',
              prop: 'first',
              type: 'text',
              label: 'First Name',
              errors: {
                equals: 'First name must equals the name you provided',
              },
              maxLength: 15,
              validators: ['required', { name: 'equals' }],
            },
            {
              prop: 'middle',
              type: 'text',
              label: 'Middle',
              errors: {
                equals: 'Middle name must equals the name you provided',
              },
              maxLength: 1,
              validators: [{ name: 'equals' }],
            },
            {
              prop: 'last',
              type: 'text',
              label: 'Last Name',
              errors: { equals: 'Last name must equals the name you provided' },
              maxLength: 15,
              validators: ['required', { name: 'equals' }],
            },
            {
              prop: 'date',
              type: 'text',
              label: "Today's Date",
              default: 'CURRENT_DATE',
              isDisabled: true,
              validators: ['required'],
            },
            {
              prop: 'signature',
              type: 'singleCheckbox',
              boldText: true,
              validators: ['required'],
              checkboxLabel:
                'I verify that this is my electronic signature made with the intent to sign this application and confirm that no other person has made this signature on my behalf.',
              showCheckboxLabelRequired: true,
            },
          ],
          editConfirmation: {
            modalConfig: {
              type: 'popup',
              backdrop: 'true',
              bodyText:
                'You are about to navigate to a previous step in the application',
            },
            footerButtons: {
              okay: { level: 'high', content: 'Okay' },
              cancel: { level: 'medium', content: 'Cancel' },
            },
          },
        },
        billing: {
          text: {
            summary: 'Summary',
            effective: 'Effective',
            purchasing: 'Purchasing',
            credit_card: 'Credit Card',
            payment_method: 'Payment Method',
            initial_payment: 'Initial Payment',
            checking_account: 'Checking Account',
            recurring_payments: 'Recurring Payments',
            accepted_card_types: 'Accepted Card Types',
            edit_payment_method: 'Edit Payment Method',
            total_monthly_premium: 'Total Monthly Premium',
          },
          type: 'billing',
          label: 'Billing Information',
          messages: {
            error:
              'Your payment information is not valid.<br><br>Please verify the payment details and submit again.',
          },
          cardControls: [
            {
              grid: { col: '1 / 3', row: '1' },
              prop: 'first_name',
              type: 'text',
              label: 'First Name',
              validators: ['required'],
            },
            {
              grid: { col: '3 / 5', row: '1' },
              prop: 'last_name',
              type: 'text',
              label: 'Last Name',
              validators: ['required'],
            },
            {
              grid: { col: '1 / 3', row: '2' },
              icon: null,
              prop: 'number',
              type: 'text',
              label: 'Card Number',
              iconRight: 'locked',
              validators: ['required', 'cardNumber'],
            },
            {
              max: '9999-01',
              grid: { col: '3 / 5', row: '2' },
              prop: 'expiration',
              type: 'month',
              label: 'Expiration Date',
              validators: [
                'required',
                'reasonableDate',
                'dateInFutureIncludingCurrentMonth',
              ],
            },
            {
              grid: { col: '1 / 2', row: '3' },
              mask: 'number',
              prop: 'cvv',
              type: 'text',
              label: 'Security Code',
              maxLength: 3,
              validators: ['required'],
            },
            {
              grid: { col: '2 / 3', row: '3' },
              mask: 'number',
              prop: 'zipcode',
              type: 'text',
              label: 'ZIP Code',
              maxLength: 5,
              validators: ['required', 'zipcode'],
            },
          ],
          planTypeOrder: ['medical', 'bundled', 'dental', 'vision'],
          stubBillingCalls: 'true',
          billingHeaderText: {
            title: 'Enter a secured payment and submit application',
            subtitle:
              "Your payment will be processed when your application is received and approved. You will also receive an email confirming that your payment was processed. Please note that this is a one-time payment of your first month's premium. Once you are enrolled, you can login to the Member Portal (blueshieldca.com) to make future premium payments and setup autopayments.",
          },
          defaultPaymentAttestation: {
            header: 'Privacy Policy',
            sections: [
              {
                header: 'INTRODUCTION:',
                paragraphs: [
                  'This Privacy Policy describes the types of "Personal Information" (information that is identifiable to a particular person) that is collected by BillMatrix Corporation as a service provider to your Biller (directly or through its service providers) in connection with the Site and the Service as defined in the "Terms and Conditions for Service" above, and how that  Personal Information is used, shared and protected. Some of this information is required by U.S. federal or other law.',
                ],
              },
              {
                header: 'ELIGIBILITY:',
                paragraphs: [
                  'The eligibility requirements for the Site and the Service are set forth above in the Eligibility section of the main body of the Agreement. We do not knowingly collect any Personal Information from or about individuals under 18 years of age. Please do not submit such information to us, and as a parent or legal guardian, please do not allow your children to submit personal information without your permission. By using the Site and/or the Service, you represent that you agree to the terms of this Privacy Policy.',
                ],
              },
              {
                header: 'COOKIES, BROWSER INFORMATION AND RELATED ISSUES:',
                paragraphs: [
                  'When you visit the Site, we may receive certain standard information that your browser sends to every website you visit, such as the originating IP address, browser type and language, access times and referring website addresses, and other such information. This data may be used, among other uses, to improve the operation of the Site and to improve the security of the Site and Service by assisting in "authenticating" who you are when you access the Site or Service.<br>We may also receive additional information about your visit to the Site, including the pages you view, the links you click and other actions you take in connection with the Site and the Services. This data may be used, among other uses, to improve the operation of the Site and the Service.<br>Like most websites, the Site also uses "cookies," which are small data files placed on your computer or other device by the web server when you visit the Site. Such cookies are "session" cookies that are only used for a specific period during   which you are on the Site (such as when you are going through the authentication process). The Site does not use "persistent" cookies (that stay on your computer after you have logged off the Site). Cookies cannot and will not be used to deliver or run programs on your computer. Most web browsers automatically accept cookies, but you can modify your browser settings to decline cookies if you prefer. However, if you choose to decline cookies, you may not be able to sign in or use other interactive features of the Site that depend on cookies.<br>With respect to personally identifiable information about an individual consumer\'s online activities over time and across different Web sites or online services when a consumer uses this Site, except as required by law: <br><br>(1) parties other than the operator of this Site are not permitted to collect such information, and <br>(2) the operator of this Site does not collect such information (except any such information that is reasonably necessary to process and document user transactions, such as payment history). Therefore, this Site has no need to respond and does not respond to Web browser "do not track" signals or other mechanisms that provide consumers the ability to exercise choice regarding the collection of such information.',
                ],
              },
              {
                header: 'WHAT TYPES OF PERSONAL INFORMATION WE MAY COLLECT:',
                paragraphs: [
                  'In addition to the types of information described in the "Cookies " section of this Policy, we may also collect Personal Information about you. This information may include:<br><br>•    Date of birth, name, postal address, e-mail address, telephone number, and other information that we can use to contact you, verify your identity, and manage risks, such as information maintained about you by identity verification services and consumer reporting agencies, including credit bureaus;<br>•    Bank account information for accounts that you designate for sending payments, fees, debits and credits for the Service, including any required routing information, account numbers, account balances and transaction history;<br>•    Billing account information, including billing account numbers which may be used to verify that only authorized users access the Services;<br>•    Payment and other transaction information, and history for payments through the Service; and<br>•    Any Personal Information that you may enter on the Site.',
                ],
              },
              {
                header: 'HOW WE MAY COLLECT PERSONAL INFORMATION ABOUT YOU:',
                paragraphs: [
                  'We may collect Personal Information about you from the following sources:<br>Your use of the Site and the Service (such as when you send a payment), and your interactions with customer care, including information you enter or speak, and information transmitted by your computer, cell phones and other devices you use to connect to or use the Site or Service; and<br>We also collect Personal Information about you from others, such as Biller, credit bureaus, Affiliates, or other companies (such as identity verification services, consumer reporting agencies, and companies that provide content, such as electronic bills, to the Site, or that use the Service).',
                ],
              },
              {
                table: {
                  data: [
                    {
                      limit: 'No',
                      share: 'Yes',
                      reason:
                        'For our everyday business purposes - such as to enable us and Biller to process your transactions, maintain your accounts, respond to court orders and legal investigations, and report to credit bureaus',
                    },
                    {
                      limit: 'No',
                      share: 'No',
                      reason:
                        'For our marketing purposes - to offer our products and services to you;',
                    },
                    {
                      limit: 'No',
                      share: 'No',
                      reason:
                        'For Joint Marketing with other financial companies',
                    },
                    {
                      limit: 'No',
                      share: 'Yes',
                      reason:
                        "For our Affiliates' everyday business purposes (information about your transactions and experiences)",
                    },
                    {
                      limit: 'We Do Not Share',
                      share: 'No',
                      reason:
                        "For our Affiliates' everyday business purposes (information about your creditworthiness)",
                    },
                    {
                      limit: 'We Do Not Share',
                      share: 'No',
                      reason: 'For our Affiliates to market to you',
                    },
                    {
                      limit: 'We Do Not Share',
                      share: 'No',
                      reason: 'For Non-Affiliates to market to you',
                    },
                  ],
                  config: {
                    paging: { enabled: false },
                    columns: [
                      {
                        name: 'Reasons we can share your Personal Information',
                        prop: 'reason',
                      },
                      { name: 'Do we share?', prop: 'share' },
                      { name: 'Can you limit this sharing?', prop: 'limit' },
                    ],
                  },
                },
                header: 'HOW WE MAY SHARE PERSONAL INFORMATION ABOUT YOU:',
                paragraphs: [
                  'We share Personal Information about you only as permitted by law. For Personal Information that is nonpublic and that we collect in connection with a financial service, U.S. federal law permits us to share such information only for the purposes shown in the following table:',
                ],
              },
              {
                header: 'HOW WE MAY USE PERSONAL INFORMATION ABOUT YOU:',
                paragraphs: [
                  'We use Personal Information about you only as permitted by law, including but not limited to:<br>Other everyday business purposes, such as to maintain your ability to access the Service, to authenticate you when you access the Site or Service to enable Biller to authenticate you when you pay your Billing Statement, to send  you information about the Service, to effect, administer and enforce transactions, to perform (and to enable Biller to perform) Anti-Money Laundering and fraud monitoring and screening, to prevent and investigate actual or potential fraud and unauthorized transactions, to verify your identity, to determine your credit history, to verify the information contained in your account, to perform collections, to report to credit bureaus (including furnishing delinquent account information), to comply with laws, regulations, court orders and lawful instructions from government agencies, to protect the personal safety of subscribers or the public, to prevent and defend claims, to resolve disputes, to troubleshoot problems, to enforce our   Terms and Conditions for Service, to protect our rights and property, and to customize, measure, and improve the Services and the content and layout of the Site including pattern recognition, modeling, enhancement and improvement, system analysis, and Service performance analysis.',
                ],
              },
              {
                header: 'OTHER IMPORTANT INFORMATION:',
                paragraphs: [
                  'Vermont: Under Vermont law, we will not share information we collect about Vermont residents with companies outside of our Affiliates, unless the law allows. We will not share information about your creditworthiness with our Affiliates except  with your consent, but we may share information about our transactions or experiences with you with our Affiliates without your consent.<br>California: Under California law, we will not share information we collect about you with Non-Affiliates, unless the law allows. For example, we may share information with your consent, to service your accounts, or to provide rewards or benefits you are entitled to. We will limit sharing among our Affiliates to the extent required by California law.',
                ],
              },
              {
                header: 'DEFINITIONS:',
                paragraphs: [
                  'Affiliates: Companies related by common ownership or control.<br>Non-Affiliates: Companies not related by common ownership or control. They can be financial or nonfinancial companies. Joint Marketing: A formal agreement between nonaffiliated financial companies that together market financial products or services to you.',
                ],
              },
              {
                header: 'HOW WE PROTECT PERSONAL INFORMATION ABOUT YOU:',
                paragraphs: [
                  'To protect Personal Information about you from unauthorized access and use, we maintain physical, electronic, and procedural safeguards, including but not limited to security measures that comply with applicable federal and state laws. We also require our service providers and business partners to whom we disclose the information to do the same.',
                ],
              },
              {
                header: 'PROTECTION FOR FORMER CUSTOMERS:',
                paragraphs: [
                  'When you are no longer our customer or using the Site or Service, we continue to protect, use and share Personal Information about you as described in this notice and as required by law, including but not limited to for risk management, regulatory compliance, and audit purposes.',
                ],
              },
              {
                header: 'AMENDMENTS:',
                paragraphs: [
                  'We may amend this policy at any time by posting a revised version on the Site. The revised version will be effective immediately at the time it is posted unless a delayed effective date is expressly stated therein. You may (in our discretion) also be provided with an email notification of such amendments. You may (in our discretion) be required to affirmatively acknowledge or accept the revised Privacy Policy in order to continue using the Site or Service. Any use of the Service after a notice of change (whether by Site posting, email, or express acknowledgment or acceptance) will constitute your express agreement to such changes.',
                ],
              },
              {
                header: 'CONTACTING US:',
                paragraphs: [
                  "If you have any questions about this Privacy Policy, you may contact us at the postal address or email address below: <br><br>In writing:<br>BillMatrix Corporation ATTN: Privacy Management<br>2900 Westside Parkway<br>Alpharetta, GA 30004 E-mail: <a class='t-data t-link' href='mailto: privacy@customercenter.net'>privacy@customercenter.net</a>",
                ],
              },
            ],
            attestation: 'I have read and agree to the Privacy Policy',
          },
          defaultTermsAndConditionsAttestation: {
            header: 'Payment Terms and Conditions',
            sections: [
              {
                header: 'INTRODUCTION:',
                paragraphs: [
                  'This document is to provide you information about the online bill payment system offered to you on behalf of your Biller (the "Service") and the associated website (the "Site"). These terms and conditions set forth a legally binding agreement governing your use of the Site and the Service ("Agreement") and outline important conditions that apply to your use of the Site and the Service. By utilizing the Service, permitting any person to do so on your behalf, or utilizing the Service on someone else\'s behalf, you agree to these terms and conditions. If you do not agree to these terms and conditions, you must discontinue your access to the Site and not utilize the Service.',
                ],
              },
              {
                header: 'DEFINITIONS:',
                paragraphs: [
                  'Authorized User is any individual which you allow to use the Service or access to your Funding Account.<br>Auto Pay Payment is a recurring Payment made by you on the Due Date for the amount shown on the Billing Statement.<br>Biller is the entity to which you instruct us to make a Payment on your behalf.<br>Biller Account means the account you have directly with the Biller related to the goods and / or services provided to you by the Biller.<br>Billing Statement is the statement typically sent by Biller to you indicating, among other things, how much you owe for the provision of goods and / or services and the Due Date.<br>Business Day is every Monday through Friday, excluding Federal Reserve holidays.<br>Due Date is the date reflected on your Billing Statement when your payment is due; it is not the late payment date or inclusive of a grace period.<br>Funding Account is the checking account, savings account, or debit card account, held at FDIC or equivalent insured United States depository institutions, or credit card account from which Payments and fees, if any, will be debited and to which credits to you will be credited.<br>Payment is a payment transaction initiated by you through the Service.<br>Payment Date is the calendar day you elect for the Biller to receive the Payment, and is also the day your Funding Account will be debited; provided that if the calendar day you elect falls on a non-Business Day,  or after the daily cutoff  time for the Service, the actual Payment Date and the actual date your Funding Account will be debited will be the immediately following Business Day. This date can be current or in the future.<br>Payment Instruction is the information provided by you (such as, but not limited to, Biller name, Biller Account number, and Payment Date) for a Payment to be made through the Service.<br>Payment Wallet is the Funding Account information you save (if any) for use in making future Payments.<br>Recurring Payment is a Payment made each calendar month on the date designated by you in an amount designated by you. <br>Scheduled Payment is a Payment that has been scheduled for a future date, but which has not yet begun processing.<br>We, us, and our refers to Biller and its third-party service providers.<br>You and "your refer to the individual that is utilizing the Service.',
                ],
              },
              {
                header: 'ELIGIBILITY:',
                paragraphs: [
                  "The Site and the Service are offered only to individuals who can form legally binding contracts under applicable law and, with respect to Payments made using checking, savings, or debit cards, use bank accounts held at FDIC or equivalent insured United States depository institutions. Without limiting the foregoing, the Service is not offered to minors.  Commercial entities, including without limitation commercial payment aggregators, may not use the Site or Service, with the exception that an authorized representative of a commercial entity who holds a Biller Account may use the Site or Service to initiate a Payment to such commercial entity's own Biller Account. By using the Service, you represent that you meet these requirements and that you agree to be bound by this Agreement. You agree to indemnify and hold us harmless for all costs and fees (including without limitation interchange fees and merchant fees) arising out of your violation of this Section.",
                ],
              },
              {
                header: 'PAYMENT AUTHORIZATION, PAYMENT REMITTANCE AND FEES:',
                paragraphs: [
                  "You authorize us to follow the Payment Instructions received from you. When we receive a Payment Instruction from you, you authorize us to debit or charge your Funding Account for the amount of any Payment plus any related fees in effect at the time you initiate the Payment Instruction, and to remit funds on your behalf. You also authorize us to credit your Funding Account, in the event that any Payments are returned to us because the processing of the Payment Instruction could not be completed. In order to process Payments more efficiently and effectively, we may edit or alter payment data or data formats. You certify that any Funding Account you add to your profile or otherwise utilize in connection with the  Service is an account from which you are authorized to make payments, and any Payment you make using the Service will debit/charge a Funding Account that you are legally authorized to use. We will use reasonable efforts to complete your Payments properly. However, we shall incur no liability if the Service is unable to complete any Payments initiated by you because of the existence of any one or more of the following circumstances or other reasons identified in this Agreement <br><br>1.    If your Funding Account does not contain sufficient funds to complete the transaction or the transaction would exceed the credit limit of your overdraft account;<br>2.    If our payment processing center is not working properly and you know or have been advised about the malfunction before you execute the transaction. <br>3.    If you have not provided us with the correct Funding Account information, or other required information. <br>4.    If your debit/credit card is expired;<br>5.    If circumstances beyond our control (such as, but not limited to, fire, flood, or other acts of God, third party systems, or interference from an outside force) prevent the proper execution of the transaction; and/ or<br>6.    If you failed to follow our instructions for the use of the Service.<br><br>Provided none of the foregoing exceptions are applicable, if we cause an incorrect amount of funds to be removed from your Funding Account or cause funds from your Funding Account to be directed in a manner that does not comply with your Payment Instructions, our sole responsibility to you shall be to return the improperly transferred funds to your Funding Account or to direct any previously misdirected Payments to the Biller.You are responsible for ensuring that there are sufficient funds available in your Funding Account to cover any amount you authorize for payment. If you do not have sufficient funds in your Funding Account, your Payment may not be processed. Your Payment may not be processed after a credit or debit card's expiration date, if it is not updated by you prior to such date, unless we are able to obtain updated information from your card issuer. You authorize us to receive such updated credit or debit card information where available.In the event your Payment is not processed for any reason, including the failure to obtain an authorization from your card issuer or financial institution, or you have not provided us with the correct information, your liability shall remain outstanding and unpaid and you will be subject to all applicable penalties, late fees and interest charges assessed thereon, all of which obligations remain your sole responsibility.Any fees associated with your Funding Account, including without limitation any assessed by your financial institution or credit card issuer, will continue to apply. You are also responsible for any and all telephone access fees and/or Internet service fees that may be assessed by your telephone and/or Internet service provider in connection with your utilization of the Service.",
                ],
              },
              {
                header: 'OVERPAYMENT ADJUSTMENT:',
                paragraphs: [
                  'You agree that you shall not intentionally schedule a Payment in excess of the greater of (i) the amount due on the Billing Statement or (ii) the total balance owed on your account. You acknowledge that we may refuse to process any such overpayment or, we may adjust the Payment amount down to the amount due at time of payment processing as to avoid overpayments.',
                ],
              },
              {
                header: 'PAYMENT CANCELLATION REQUESTS:',
                paragraphs: [
                  'You may be permitted to cancel or edit a Payment until such time as the processing of the Payment Instruction has begun. If permitted, there is no charge for canceling or editing a Payment prior to the processing of the Payment Instruction.',
                ],
              },
              {
                header: 'RETURNED PAYMENTS:',
                paragraphs: [
                  'In using the Service, you understand that payments may be returned for various reasons, such as, but not limited to, the Biller Account number is not valid; we are unable to locate your Biller Account; or your Biller Account is paid in full. We will use reasonable efforts to research and correct the returned payment or void the payment and credit your Funding Account. You may receive notification regarding any such returned payments. You may be assessed fees by us or your financial institution as the result of any returns or insufficient funds related to your Funding Account, or charges refused by a card network.',
                ],
              },
              {
                header: 'PAYMENT WALLET:',
                paragraphs: [
                  'The Payment Wallet allows you to save your Funding Account for use in making future Payments. If you elect to use Payment Wallet, the following terms apply:<br><br>1.    Adding Funding Accounts: You authorize the addition of Funding Accounts to your profile when received from you. The first Funding Account that you add to your profile shall be your "Default Funding Account," unless you later designate a different Funding Account as your Default Funding Account. If your identity cannot be verified satisfactorily, the Service may not allow you to add a specific type of Funding Account to your profile.<br>2.    Funding Account Number and Expiration Date Changes: It is your sole responsibility and you agree to ensure that the information maintained in your Payment Wallet is and remains accurate. If your Funding Account number changes or your credit or debit card expiration date changes, you agree to make updates to your Payment Wallet. You also authorize us to acquire such new or additional information regarding your accounts from our financial services partners and authorize the update of your Funding Account information accordingly. All changes made by you or acquired by us will be effective for future Payments paid using the Payment Wallet.',
                ],
              },
              {
                header:
                  'AUTO PAY PAYMENTS, RECURRING PAYMENTS, AND SCHEDULED PAYMENTS:',
                paragraphs: [
                  "You may have the option of enrolling for Auto Pay Payments or Recurring Payments. If you choose to enroll for either Auto Pay Payments or Recurring Payments, or if you initiate a Scheduled Payment, an email confirmation will be sent to you confirming that your enrollment or Payment Instruction has been received and whether it has been accepted. Please note the following:<br><br>1.    Payments must be made by the Due Date or you may be assessed a late fee.<br>2.    We will deduct (i) for Auto Pay Payments, the amount due on the Due Date and (ii) for Recurring Payments and Scheduled Payments, the amount designated by you on the date you selected. <br>3.   While enrolled in either Auto Pay Payments or Recurring Payments, you may receive email confirmations of Payments charged to or debited against your Funding Account. It is your responsibility to update your email address in your profile with your current email address. We will not be responsible for email confirmations that are not received as a result of delivery failures. (e.g., spam blockers or incorrect email address).<br>4.   It is your sole responsibility to ensure that all Funding Account information is accurate, legitimate, and up-to-date in order to ensure proper authorization of your Payment. We will not be responsible for any payment processing errors or fees incurred if you fail to provide accurate Funding Account information. <br>5.   You may terminate your participation in Auto Pay Payments and Recurring Payments online, in writing, or by calling Biller's customer service department. It may take up to thirty (30) days to process termination requests.",
                ],
              },
              {
                header: 'COMMUNICATIONS TO YOU; ADDRESS OR BANKING CHANGES:',
                paragraphs: [
                  "By providing us with a telephone number (including a mobile telephone number) and/or email address, you consent to receiving calls and/or text messages at that number, and/or emails from us for our everyday business purposes (including identity verification). You authorize us to send or provide by electronic communication any notice, communication, amendment or replacement to the Agreement, payment receipt, or disclosure required to be provided orally or in writing to you. You agree to receive any electronic communication provided to you and will not attempt to avoid receiving any such communication. You are deemed to have received any electronic communication provided to you when they are made available to you. By providing us with a telephone number (including a mobile number), you consent to receiving autodialed and prerecorded message calls at that number for Service-related purposes. For example, we may contact you in connection with validating or processing a transaction that you've requested through the Service. You agree that we may provide notices to you by posting them on the Site, sending them to you through an in-product message within the Service, emailing them to an email address that you have provided, sending them via text message to any mobile number that you have provided, or by mailing them to any postal address that you have provided. For example, users of the Service may receive certain notices (such as notice of payments and alerts for validation and receipt of transfers of funds) as text messages on their mobile device. All notices by any of these methods shall be deemed received by you no later than twenty-four (24) hours after they are sent or posted, except for notice by postal mail, which shall be deemed received by you no later than three (3) Business Days after it is mailed. It is your sole responsibility to ensure that your contact information is accurate in the Service. We will not be responsible for communications that are not received by you as a result of delivery failures (e.g., spam blockers, incorrect email address or physical address, or incorrect mobile phone number).<br>Data and messaging charges from your telecommunications provider may apply, and you are responsible for any such charges. In the event your enrolled mobile device is lost or stolen, you agree to update your enrollment information and make the appropriate changes to disable the use of such device.",
                ],
              },
              {
                header: 'SECURITY:',
                paragraphs: [
                  'You agree not to give or make available your access or access credentials to the Service to any unauthorized individuals. You are responsible for all Payments you authorize using the Service or that are made using your access credentials. If you permit Authorized Users or other persons to use the Service, you are responsible for any transactions they authorize.   If you believe that your access or access credentials to the Service has been lost, stolen, or otherwise compromised or that someone has transferred or attempted to transfer money without your permission, you must notify customer care at once.   If you believe there have been any unauthorized transfers related to your Funding Account, you should notify Biller customer care department and /or your financial institution at once. See "Your Liability for Unauthorized Transfers."',
                ],
              },
              {
                header: 'INFORMATION AUTHORIZATION:',
                paragraphs: [
                  'You agree that the information you provide to facilitate a Payment, including your Funding Account information, may go through a verification process. You further agree that we may obtain financial information regarding your Funding Account from your financial institution (for example, to resolve payment posting problems, set transaction limits or for verification purposes).',
                ],
              },
              {
                header: 'ALTERATIONS AND AMENDMENTS:',
                paragraphs: [
                  "This Agreement, applicable fees and service charges may be altered or amended from time to time by posting a revised version on the Site or providing a revised version to you by other means. You may be required to affirmatively accept the revised Agreement in order to continue using the Service. Regardless of whether you are so required, any use of the Service after a notice of change or after the posting of a revised version of this Agreement on the Site will constitute your agreement to such changes and revised versions. The revised version will be effective at the time it is posted or otherwise provided to you unless a delayed effective date is expressly stated in the revision. Further, we may, from time to time, revise or update the Service applications, services, and/or related material, which may render all such prior versions obsolete. Consequently, we reserve the right to terminate this Agreement as to all such prior versions of the applications, services, and/or related material and limit access to only the Service's more recent revisions and updates. You authorize us to send or provide by electronic communication any notice, communication, amendment or replacement to the Agreement, or disclosure required to be provided orally or in writing to you. Your use of the Service may be terminated or suspended at any time for any reason or no reason. Neither termination nor suspension shall affect your liability or obligations under this Agreement.",
                ],
              },
              {
                header: 'PAYMENT DISPUTES:',
                paragraphs: [
                  'If you dispute a Payment made from a Funding Account, you acknowledge that such dispute (including, but not limited to, chargeback or fraud) must be taken up with your issuing debit/credit card provider or financial institution. We are not responsible for any research or resolution of such payment disputes.',
                ],
              },
              {
                header: 'ARBITRATION:',
                paragraphs: [
                  'For any claim (excluding claims for injunctive or other equitable relief) arising out of or relating to this Agreement, the parties must resolve the dispute in a cost-effective manner through binding non-appearance-based arbitration. The party commencing arbitration will initiate such arbitration through the American Arbitration Association ("AAA") or an established alternative dispute resolution (ADR) administrator mutually agreed upon by the parties. The parties agree that the following rules shall apply: (a) the arbitration may be conducted telephonically, online and/or be solely based on written submissions, at the election of the party initiating the arbitration; (b) the arbitration shall not involve any personal appearance by the parties, their representatives or witnesses unless otherwise mutually agreed by the parties; (c) discovery shall not be permitted; (d) the matter shall be submitted for decision within ninety (90) days of initiation of arbitration, unless otherwise agreed by the parties, and the arbitrator must render a decision within thirty (30) days of submission; and (e) any award in such arbitration shall be final and binding upon the parties and may be submitted to any court of competent jurisdiction for confirmation. The parties acknowledge that remedies available under federal, state and local laws remain available through arbitration.',
                ],
              },
              {
                header:
                  'NO CLASS ACTION, OTHER REPRESENTATIVE ACTION, OR PRIVATE ATTORNEY GENERAL ACTION, OR JOINDER OR CONSOLIDATION OF ANY CLAIM WITH A CLAIM OF ANOTHER PERSON SHALL BE ALLOWABLE IN ARBITRATION.',
                paragraphs: [
                  'Notwithstanding this Arbitration section, in the event you are a commercial or corporate entity, including without limitation a commercial payment aggregator, we reserve the right to bring a claim against you outside of arbitration and in any forum.',
                ],
              },
              {
                header: 'GOVERNING LAW:',
                paragraphs: [
                  "This Agreement shall be governed by and construed in accordance with the laws of the State of New York, without regard to its conflicts of law's provisions. To the extent that the terms of this Agreement conflict with applicable state or federal law, such state or federal law shall replace such conflicting terms only to the extent required by law. In the event of such replacement, all other terms of this Agreement shall remain in full force and effect. The United Nations Convention on Contracts for the International Sale of Goods shall not apply to this Agreement. Both parties agree to waive any right to have a jury participate in the resolution of any dispute or claim between the parties or any of their respective affiliates arising under this Agreement, which instead shall be brought under the Arbitration clause set forth above.",
                ],
              },
              {
                header: 'EXCLUSIONS OF WARRANTIES / LIMITATION OF LIABILITY:',
                paragraphs: [
                  "In no event shall we or our services providers be responsible or liable for the timeliness, deletion, mis-delivery, or failure to store any user communications or personalized settings; any viruses which may affect your computer equipment or other property on account of your access to, use of, or downloading from the Site or Service; or any third party's inability or  refusal to authorize a Payment or any other acts or omissions of third parties not controlled by us.",
                ],
              },
              {
                header:
                  'THE SITE AND SERVICE AND RELATED DOCUMENTATION ARE PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESSED OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF TITLE, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, WE DO NOT GUARANTEE CONTINUOUS, UNINTERRUPTED OR SECURE ACCESS TO ANY PART OF OUR SITE OR SERVICE, AND OPERATION OF THE SITE OR SERVICE MAY BE INTERFERED WITH BY NUMEROUS FACTORS OUTSIDE OF OUR CONTROL. SOME STATES DO NOT ALLOW THE DISCLAIMER OF CERTAIN IMPLIED WARRANTIES, SO THE FOREGOING DISCLAIMERS MAY NOT APPLY TO YOU. THIS PARAGRAPH GIVES YOU SPECIFIC LEGAL RIGHTS AND YOU MAY ALSO HAVE OTHER LEGAL RIGHTS THAT VARY FROM STATE TO STATE.',
                paragraphs: [
                  'IN NO EVENT SHALL WE OR OUR SERVICE PROVIDERS (OR EITHER OF OUR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, AFFILIATES OR STOCKHOLDERS) BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF THE SITE OR THE SERVICE OR OTHERWISE RELATING TO THIS AGREEMENT, INCLUDING WITHOUT LIMITATION ANY DIRECT, SPECIAL, INDIRECT, INCIDENTAL, CONSEQUENTIAL, PUNITIVE, EXEMPLARY, OR TORT DAMAGES OR LOST PROFITS (EVEN IF ADVISED OF THE POSSIBILITY THEREOF), REGARDLESS OF WHETHER SUCH CLAIM ARISES IN TORT, CONTRACT, OR OTHERWISE.',
                ],
              },
              {
                header: 'INDEMNIFICATION:',
                paragraphs: [
                  "You agree to indemnify and hold harmless us and our affiliates, suppliers, service providers, licensors and contractors, and the officers, directors, owners, agents, employees and contractors of each of these, from and against any and all loss, damage, liability, claim, demand, fees, costs, and expenses (including attorney's fees) arising out of your breach of this Agreement and/or your access to or use of the Site or the Service.",
                ],
              },
              {
                header: 'INTELLECTUAL PROPERTY:',
                paragraphs: [
                  "All marks and logos related to the Site and the Service are either trademarks or registered trademarks of the Biller or its service providers, or their respective affiliates or licensors. You may not copy, modify, translate, decompile, reverse engineer, reproduce, adapt or disassemble the Site or the Service, both of which are the sole property of the Biller's   service provider or the Biller's service provider's affiliates or their respective licensors. With the exception of your right to use the Site and Service in accordance with the terms hereof, which right may be revoked by us, you are not granted any rights of any kind in the Site, Service, marks, or logos, and we hereby reserve all such rights. The content accessed through the Site is the property of the applicable content owner and may be protected by applicable copyright or other law. Any downloading of material contained on the Site, or on any site linked to the Site, may be a violation of federal trademark or copyright laws.",
                ],
              },
              {
                header: 'ASSIGNMENT:',
                paragraphs: [
                  'You may not assign or transfer any rights or obligations you have under this Agreement to any other party without our prior written consent, which we may withhold in our sole discretion. We reserve the right to assign this Agreement or any right or obligation under this Agreement at any time to any party. We may also assign or delegate certain of our rights and responsibilities under this Agreement to affiliates, independent contractors, or other third parties.',
                ],
              },
              {
                header: 'NO WAIVER:',
                paragraphs: [
                  'We shall not be deemed to have waived any of our rights or remedies hereunder unless such waiver is in writing and signed by one of our authorized representatives. No delay or omission on our part in exercising any rights or remedies   shall operate as a waiver of such rights or remedies or any other rights or remedies. A waiver on any one occasion shall not be construed as a bar or waiver of any rights or remedies on future occasions.',
                ],
              },
              {
                header: 'CAPTIONS:',
                paragraphs: [
                  'The captions of sections hereof are for convenience only and shall not control or affect the meaning or construction of any of the provisions of this Agreement.',
                ],
              },
              {
                header: 'ERROR, QUESTIONS AND COMPLAINTS:',
                paragraphs: [
                  'In case of errors or questions about your transactions or Billing Statements, you should contact Biller customer care as soon as possible.',
                ],
              },
              {
                header: 'ENTIRE AGREEMENT:',
                paragraphs: [
                  'You agree that this Agreement (including without limitation the Privacy Policy set forth below) is the complete and exclusive statement of the agreement between you and us, and it supersedes any proposal or prior agreement, oral or written, and any other communications between you and us relating to the subject matter of this Agreement.',
                ],
              },
            ],
            attestation: 'I have read and agree to the Payment Terms',
          },
        },
        confirmation: {
          text: {
            print: 'Print Your Application',
            reason: 'Reason',
            coverage: 'coverage',
            zip_code: 'ZIP Code',
            submitted: 'Submitted',
            learn_more: 'Learn More About Your New Plan',
            subscriber: 'Subscriber',
            quick_links: 'Quick Links',
            coverage_type: 'Coverage Type',
            selected_plans: 'Selected Plans',
            confirmation_num: 'Confirmation Number',
            enrollment_status: 'Enrollment Status',
            coverage_start_date: 'Coverage Start Date',
            will_receive_updates:
              'You will receive updates to keep you informed. In the meantime, you can always check your status by logging into your account.',
            application_submitted:
              'Your Application Was Successfully Submitted',
          },
          cards: [
            {
              icon: 'id_product',
              label: 'Confirmation Number',
              value: '${confirmation_number}',
            },
            {
              icon: 'clipboard',
              label: 'Enrollment Status',
              value: '${status}',
              format: 'SNAKE_CASE_TO_TITLE',
            },
            { icon: 'wellness_product', label: 'Plans', value: '${plans}' },
          ],
          label: 'Application Complete',
          summary: [
            {
              title: 'Coverage & Members',
              sections: [
                {
                  title: 'Coverage',
                  attributes: [
                    { prop: 'permanent_address.zipcode', label: 'ZIP Code' },
                    {
                      prop: 'demographics.displayCoverageType',
                      label: 'Coverage Type',
                    },
                    {
                      prop: 'coverage_effective_date',
                      label: 'Coverage Start Date',
                      format: 'DATE',
                    },
                  ],
                },
                {
                  title: 'Subscriber',
                  actions: [{ name: 'HIDE' }],
                  attributes: [
                    { prop: 'subscriber', label: 'Name', format: 'FULL_NAME' },
                    {
                      prop: 'subscriber.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    { prop: 'subscriber.gender', label: 'Gender' },
                    {
                      prop: 'subscriber.displaySSN',
                      label: 'Social Security Number',
                    },
                  ],
                  conditions: {
                    all: [{ name: 'subscriber', operation: 'EXISTS' }],
                  },
                },
                {
                  title: 'Spouse',
                  actions: [{ name: 'HIDE' }],
                  attributes: [
                    { prop: 'spouse', label: 'Name', format: 'FULL_NAME' },
                    {
                      prop: 'spouse.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    { prop: 'spouse.gender', label: 'Gender' },
                    {
                      prop: 'spouse.displaySSN',
                      label: 'Social Security Number',
                    },
                  ],
                  conditions: {
                    all: [{ name: 'spouse', operation: 'EXISTS' }],
                  },
                },
                {
                  title: 'Dependent ${ind}',
                  actions: [{ name: 'HIDE' }],
                  attributes: [
                    {
                      prop: 'dependent${i}',
                      label: 'Name',
                      format: 'FULL_NAME',
                    },
                    {
                      prop: 'dependent${i}.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    { prop: 'dependent${i}.gender', label: 'Gender' },
                    {
                      prop: 'dependent${i}.displaySSN',
                      label: 'Social Security Number',
                    },
                  ],
                  conditions: {
                    all: [{ name: 'dependents', operation: 'EXISTS' }],
                  },
                },
              ],
            },
            { type: 'plan', title: 'Selected Plan' },
            {
              type: 'pcp',
              title: 'Primary Care Physician (PCP)',
              actions: [{ name: 'HIDE' }],
              conditions: {
                all: [{ name: 'steps.pcp_selection', operation: 'EXISTS' }],
              },
            },
            {
              title: 'Special Enrollment Period',
              actions: [{ name: 'HIDE' }],
              attributes: [{ prop: 'qleReason', label: 'Reason' }],
              conditions: { all: [{ name: 'qleReason', operation: 'EXISTS' }] },
            },
            {
              title: 'Personal Information',
              sections: [
                {
                  title: 'Address',
                  attributes: [
                    {
                      prop: 'permanent_address.street_name_1',
                      label: 'Address 1',
                    },
                    {
                      prop: 'permanent_address.street_name_2',
                      label: 'Address 2',
                    },
                    { prop: 'permanent_address.city', label: 'City' },
                    { prop: 'permanent_address.state', label: 'State' },
                    { prop: 'permanent_address.zipcode', label: 'ZIP Code' },
                  ],
                },
                {
                  title: 'Contact',
                  attributes: [
                    {
                      prop: 'phoneNumber',
                      label: 'Primary Phone Number',
                      format: 'PHONE',
                    },
                    { prop: 'email', label: 'Email Address', format: 'EMAIL' },
                  ],
                },
              ],
            },
            {
              title: 'Payment Information',
              actions: [{ name: 'HIDE' }],
              sections: [
                {
                  title: 'Payment Method',
                  attributes: [
                    {
                      prop: 'payment.displayPaymentMethod',
                      label: 'Payment Method',
                    },
                    {
                      prop: 'payment.totalMonthlyPremium',
                      label: 'Payment Amount',
                    },
                  ],
                },
                {
                  title: 'Card / Account Information',
                  actions: [{ name: 'HIDE' }],
                  attributes: [
                    {
                      prop: 'payment.cardNumber',
                      label: 'Card/Account Number',
                    },
                    {
                      prop: 'payment.expiration',
                      label: 'Expiration Date',
                      format: 'DATE',
                    },
                    { prop: 'payment.zipcode', label: 'Billing ZIP Code' },
                  ],
                  conditions: {
                    all: [
                      {
                        name: 'displayPaymentMethod',
                        value: 'Credit Card / Debit Card',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                },
                {
                  title: 'Bank Account',
                  actions: [{ name: 'HIDE' }],
                  attributes: [
                    { prop: 'payment.bank', label: 'Bank' },
                    {
                      prop: 'payment.accountNumber',
                      label: 'Account Number',
                      format: 'DATE',
                    },
                    { prop: 'payment.routingNumber', label: 'Routing Number' },
                  ],
                  conditions: {
                    all: [
                      {
                        name: 'displayPaymentMethod',
                        value: 'Credit Card / Debit Card',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                },
              ],
              conditions: { all: [{ name: 'payment', operation: 'EXISTS' }] },
            },
            {
              type: 'signature',
              title: 'Attestation',
              actions: [{ name: 'HIDE' }],
              conditions: {
                all: [{ name: 'signee_info', operation: 'EXISTS' }],
              },
            },
          ],
          download: { printConfig: { hidden: true } },
          learnMore: [
            {
              icon: 'hospital',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/ifp/getting_care&page=contentpages',
              label: 'Getting Care',
              button: 'Get Care',
              description:
                "Learn how to find a doctor, why it's important to have a primary care physician, when you need urgent or emergency care, how to get care outside of a doctor's office and more.",
            },
            {
              icon: 'file',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/ifp/plan_resources&page=contentpages',
              label: 'Plan Resources',
              button: 'Get Information',
              description:
                'Access important plan documents that explain your benefits and learn how to make the most of your individual and family medical, dental, and/or vision plan(s).',
            },
            {
              icon: 'costs_product',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/ifp/billing_resources/billing_costs_financial_help&page=contentpages',
              label: 'Billing Resources',
              button: 'Learn More',
              description:
                'Whether you want to sign-up for automatic payments, learn how to pay your bill online, or want to learn the basics about healthcare costs and claims, you can find it all here.',
            },
          ],
          learn_more: [
            {
              icon: 'hospital',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/ifp/getting_care&page=contentpages',
              label: 'Getting Care',
              button: 'Get Care',
              description:
                "Learn how to find a doctor, why it's important to have a primary care physician, when you need urgent or emergency care, how to get care outside of a doctor's office and more.",
            },
            {
              icon: 'file',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/ifp/plan_resources&page=contentpages',
              label: 'Plan Resources',
              button: 'Get Information',
              description:
                'Access important plan documents that explain your benefits and learn how to make the most of your individual and family medical, dental, and/or vision plan(s).',
            },
            {
              icon: 'costs_product',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/ifp/billing_resources/billing_costs_financial_help&page=contentpages',
              label: 'Billing Resources',
              button: 'Learn More',
              description:
                'Whether you want to sign-up for automatic payments, learn how to pay your bill online, or want to learn the basics about healthcare costs and claims, you can find it all here.',
            },
          ],
          quickLinks: [
            {
              icon: 'heart_product',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/ifp/renewal_center/specialty_offer&page=contentpages',
              label: 'Protect Your Whole Self',
              button: 'Get Total Coverage',
              description:
                'Add a dental plan, vision plan, or life insurance plan for full coverage.',
            },
            {
              icon: 'video_product',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/ifp/getting_help/videos_how&page=contentpages',
              label: 'Helpful Videos',
              button: 'Watch Now',
              description:
                'Find out how to access all the important features of your Blue Shield membership.',
            },
            {
              icon: 'file',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/ifp/ifp_glossary&page=contentpages',
              label: 'Definitions',
              button: 'Read Now',
              description:
                'Get help understanding basic healthcare and billing terms.',
            },
            {
              icon: 'care',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/be_well/pharmacy/tier2_pharmacy_cnt&page=contentpages',
              label: 'Pharmacy',
              button: 'Learn More',
              description:
                'View the drug formulary for your plan, learn about mail service pharmacy.',
            },
            {
              icon: 'calculator',
              link: 'https://www.blueshieldca.com/bsca/documents/find-a-plan/A47476_8-17_Member-flier-TCE.pdf',
              label: 'Treatment Cost Estimator',
              button: 'Estimate Now',
              description:
                'With a PPO plan, you can use this tool to estimate and compare your costs.',
            },
            {
              icon: 'wellness_product',
              link: 'https://www.blueshieldca.com/preventive-care/home.html',
              label: 'Prevention',
              button: 'View Guidelines',
              description:
                "See what's covered during a preventive care visit and guidelines for every age.",
            },
          ],
          quick_links: [
            {
              icon: 'heart_product',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/ifp/renewal_center/specialty_offer&page=contentpages',
              label: 'Protect Your Whole Self',
              button: 'Get Total Coverage',
              description:
                'Add a dental plan, vision plan, or life insurance plan for full coverage.',
            },
            {
              icon: 'video_product',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/ifp/getting_help/videos_how&page=contentpages',
              label: 'Helpful Videos',
              button: 'Watch Now',
              description:
                'Find out how to access all the important features of your Blue Shield membership.',
            },
            {
              icon: 'file',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/ifp/ifp_glossary&page=contentpages',
              label: 'Definitions',
              button: 'Read Now',
              description:
                'Get help understanding basic healthcare and billing terms.',
            },
            {
              icon: 'care',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/be_well/pharmacy/tier2_pharmacy_cnt&page=contentpages',
              label: 'Pharmacy',
              button: 'Learn More',
              description:
                'View the drug formulary for your plan, learn about mail service pharmacy.',
            },
            {
              icon: 'calculator',
              link: 'https://www.blueshieldca.com/bsca/documents/find-a-plan/A47476_8-17_Member-flier-TCE.pdf',
              label: 'Treatment Cost Estimator',
              button: 'Estimate Now',
              description:
                'With a PPO plan, you can use this tool to estimate and compare your costs.',
            },
            {
              icon: 'wellness_product',
              link: 'https://www.blueshieldca.com/preventive-care/home.html',
              label: 'Prevention',
              button: 'View Guidelines',
              description:
                "See what's covered during a preventive care visit and guidelines for every age.",
            },
          ],
          showSummary: true,
          planTypeOrder: ['medical', 'bundled', 'dental', 'vision'],
          attributeColumns: 3,
          defaultNoValueMessage: 'N/A',
        },
        dental_vision: {
          filters: { controls: [] },
          hideCompare: true,
          showSiteFooter: true,
          extraPlanFilters: { market_segment: 'individual' },
        },
      },
      renewals: {
        review: {
          text: {
            signatureVerification:
              'I verify that this is my electronic signature made with the intent to sign this application and confirm that no other person has made this signature on my behalf.',
          },
          label: 'Review',
          button: {
            icon: '',
            level: 'high',
            content: 'Renew My Healthcare Plan',
          },
          anyUpdates: {
            title: 'First, any changes to your information?',
            updates: [
              {
                icon: 'moving',
                link: 'Update Address',
                type: 'address',
                label: 'My address has changed',
                editAccordianSection: 'address',
              },
              {
                icon: 'lost_dep_child',
                link: 'Update Dependents',
                type: 'members',
                label: 'I gained or lost a dependent',
                editAccordianSection: 'members',
              },
              {
                icon: 'payment',
                link: 'Update Income',
                type: 'income',
                label: 'My household income has changed',
                editAccordianSection: 'subsidy',
              },
            ],
            subtitle:
              'Make sure your information is up-to-date before renewing your plan.',
          },
          mergeValues: true,
          reviewCards: [
            {
              icon: 'coverage',
              label: 'Coverages & Members',
              sections: [
                {
                  label: 'Coverage',
                  attributes: [
                    {
                      prop: 'permanent_address.street_name_1',
                      label: 'Address 1',
                    },
                    { prop: 'permanent_address.street_name_2', label: 'Apt' },
                    { prop: 'permanent_address.city', label: 'City' },
                    { prop: 'permanent_address.state', label: 'State' },
                    { prop: 'permanent_address.zipcode', label: 'ZIP Code' },
                  ],
                },
                {
                  prop: 'spouse.date_of_birth',
                  label: 'Spouse',
                  attributes: [
                    { prop: 'spouse', label: 'Name', format: 'FULL_NAME' },
                    {
                      prop: 'spouse.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    { prop: 'spouse.gender', label: 'Sex' },
                  ],
                },
                {
                  prop: 'dependents',
                  label: 'Dependent ${displayIndex}',
                  arrayProp: 'dependents',
                  attributes: [
                    {
                      prop: 'dependents.${index}',
                      label: 'Name',
                      format: 'FULL_NAME',
                    },
                    {
                      prop: 'dependents.${index}.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    { prop: 'dependents.${index}.gender', label: 'Sex' },
                  ],
                },
              ],
              stepIndex: 2,
            },
            {
              icon: 'profile',
              label: 'Personal Information',
              sections: [
                {
                  prop: 'subscriber.date_of_birth',
                  label: 'Subscriber',
                  attributes: [
                    { prop: 'subscriber', label: 'Name', format: 'FULL_NAME' },
                    {
                      prop: 'subscriber.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    { prop: 'subscriber.gender', label: 'Sex' },
                  ],
                },
                {
                  label: 'Address',
                  attributes: [
                    {
                      prop: 'permanent_address.street_name_1',
                      label: 'Address 1',
                    },
                    { prop: 'permanent_address.street_name_2', label: 'Apt' },
                    { prop: 'permanent_address.city', label: 'City' },
                    { prop: 'permanent_address.state', label: 'State' },
                    { prop: 'permanent_address.zipcode', label: 'ZIP Code' },
                  ],
                },
                {
                  label: 'Contact',
                  attributes: [
                    { prop: 'contact.phone', label: 'Phone Number' },
                    {
                      prop: 'contact.email',
                      label: 'Email Address',
                      format: 'VALUE_MAP',
                    },
                    {
                      prop: 'spouse.email_address',
                      label: 'Spouse Email Address',
                      format: 'VALUE_MAP',
                    },
                  ],
                },
              ],
              stepIndex: 3,
            },
          ],
          termsOfService: null,
          signatureConfig: null,
          editConfirmation: {
            modalConfig: {
              type: 'popup',
              backdrop: 'true',
              bodyText:
                'You are about to navigate to a previous step in the application',
            },
            footerButtons: {
              okay: { level: 'high', content: 'Okay' },
              cancel: { level: 'medium', content: 'Cancel' },
            },
          },
          allowEditInformation: true,
        },
        billing: {
          text: {
            summary: 'Summary',
            effective: 'Effective',
            purchasing: 'Purchasing',
            credit_card: 'Credit Card',
            payment_method: 'Payment Method',
            initial_payment: 'Initial Payment',
            checking_account: 'Checking Account',
            recurring_payments: 'Recurring Payments',
            accepted_card_types: 'Accepted Card Types',
            edit_payment_method: 'Edit Payment Method',
            total_monthly_premium: 'Total Monthly Premium',
          },
          type: 'billing',
          label: 'Billing Information',
          defaultPaymentAttestation: {
            header: 'Privacy Policy',
            sections: [
              {
                header: 'INTRODUCTION:',
                paragraphs: [
                  'This Privacy Policy describes the types of "Personal Information" (information that is identifiable to a particular person) that is collected by BillMatrix Corporation as a service provider to your Biller (directly or through its service providers) in connection with the Site and the Service as defined in the “Terms and Conditions for Service” above, and how that  Personal Information is used, shared and protected. Some of this information is required by U.S. federal or other law.',
                ],
              },
              {
                header: 'ELIGIBILITY:',
                paragraphs: [
                  'The eligibility requirements for the Site and the Service are set forth above in the Eligibility section of the main body of the Agreement. We do not knowingly collect any Personal Information from or about individuals under 18 years of age. Please do not submit such information to us, and as a parent or legal guardian, please do not allow your children to submit personal information without your permission. By using the Site and/or the Service, you represent that you agree to the terms of this Privacy Policy.',
                ],
              },
              {
                header: 'COOKIES, BROWSER INFORMATION AND RELATED ISSUES:',
                paragraphs: [
                  'When you visit the Site, we may receive certain standard information that your browser sends to every website you visit, such as the originating IP address, browser type and language, access times and referring website addresses, and other such information. This data may be used, among other uses, to improve the operation of the Site and to improve the security of the Site and Service by assisting in "authenticating" who you are when you access the Site or Service.<br>We may also receive additional information about your visit to the Site, including the pages you view, the links you click and other actions you take in connection with the Site and the Services. This data may be used, among other uses, to improve the operation of the Site and the Service.<br>Like most websites, the Site also uses "cookies," which are small data files placed on your computer or other device by the web server when you visit the Site. Such cookies are "session" cookies that are only used for a specific period during   which you are on the Site (such as when you are going through the authentication process). The Site does not use “persistent” cookies (that stay on your computer after you have logged off the Site). Cookies cannot and will not be used to deliver or run programs on your computer. Most web browsers automatically accept cookies, but you can modify your browser settings to decline cookies if you prefer. However, if you choose to decline cookies, you may not be able to sign in or use other interactive features of the Site that depend on cookies.<br>With respect to personally identifiable information about an individual consumer\'s online activities over time and across different Web sites or online services when a consumer uses this Site, except as required by law: <br><br>(1) parties other than the operator of this Site are not permitted to collect such information, and <br>(2) the operator of this Site does not collect such information (except any such information that is reasonably necessary to process and document user transactions, such as payment history). Therefore, this Site has no need to respond and does not respond to Web browser "do not track" signals or other mechanisms that provide consumers the ability to exercise choice regarding the collection of such information.',
                ],
              },
              {
                header: 'WHAT TYPES OF PERSONAL INFORMATION WE MAY COLLECT:',
                paragraphs: [
                  'In addition to the types of information described in the "Cookies " section of this Policy, we may also collect Personal Information about you. This information may include:<br><br>•    Date of birth, name, postal address, e-mail address, telephone number, and other information that we can use to contact you, verify your identity, and manage risks, such as information maintained about you by identity verification services and consumer reporting agencies, including credit bureaus;<br>•    Bank account information for accounts that you designate for sending payments, fees, debits and credits for the Service, including any required routing information, account numbers, account balances and transaction history;<br>•    Billing account information, including billing account numbers which may be used to verify that only authorized users access the Services;<br>•    Payment and other transaction information, and history for payments through the Service; and<br>•    Any Personal Information that you may enter on the Site.',
                ],
              },
              {
                header: 'HOW WE MAY COLLECT PERSONAL INFORMATION ABOUT YOU:',
                paragraphs: [
                  'We may collect Personal Information about you from the following sources:<br>Your use of the Site and the Service (such as when you send a payment), and your interactions with customer care, including information you enter or speak, and information transmitted by your computer, cell phones and other devices you use to connect to or use the Site or Service; and<br>We also collect Personal Information about you from others, such as Biller, credit bureaus, Affiliates, or other companies (such as identity verification services, consumer reporting agencies, and companies that provide content, such as electronic bills, to the Site, or that use the Service).',
                ],
              },
              {
                table: {
                  data: [
                    {
                      limit: 'No',
                      share: 'Yes',
                      reason:
                        'For our everyday business purposes - such as to enable us and Biller to process your transactions, maintain your accounts, respond to court orders and legal investigations, and report to credit bureaus',
                    },
                    {
                      limit: 'No',
                      share: 'No',
                      reason:
                        'For our marketing purposes - to offer our products and services to you;',
                    },
                    {
                      limit: 'No',
                      share: 'No',
                      reason:
                        'For Joint Marketing with other financial companies',
                    },
                    {
                      limit: 'No',
                      share: 'Yes',
                      reason:
                        "For our Affiliates' everyday business purposes (information about your transactions and experiences)",
                    },
                    {
                      limit: 'We Do Not Share',
                      share: 'No',
                      reason:
                        "For our Affiliates' everyday business purposes (information about your creditworthiness)",
                    },
                    {
                      limit: 'We Do Not Share',
                      share: 'No',
                      reason: 'For our Affiliates to market to you',
                    },
                    {
                      limit: 'We Do Not Share',
                      share: 'No',
                      reason: 'For Non-Affiliates to market to you',
                    },
                  ],
                  config: {
                    paging: { enabled: false },
                    columns: [
                      {
                        name: 'Reasons we can share your Personal Information',
                        prop: 'reason',
                      },
                      { name: 'Do we share?', prop: 'share' },
                      { name: 'Can you limit this sharing?', prop: 'limit' },
                    ],
                  },
                },
                header: 'HOW WE MAY SHARE PERSONAL INFORMATION ABOUT YOU:',
                paragraphs: [
                  'We share Personal Information about you only as permitted by law. For Personal Information that is nonpublic and that we collect in connection with a financial service, U.S. federal law permits us to share such information only for the purposes shown in the following table:',
                ],
              },
              {
                header: 'HOW WE MAY USE PERSONAL INFORMATION ABOUT YOU:',
                paragraphs: [
                  'We use Personal Information about you only as permitted by law, including but not limited to:<br>Other everyday business purposes, such as to maintain your ability to access the Service, to authenticate you when you access the Site or Service to enable Biller to authenticate you when you pay your Billing Statement, to send  you information about the Service, to effect, administer and enforce transactions, to perform (and to enable Biller to perform) Anti-Money Laundering and fraud monitoring and screening, to prevent and investigate actual or potential fraud and unauthorized transactions, to verify your identity, to determine your credit history, to verify the information contained in your account, to perform collections, to report to credit bureaus (including furnishing delinquent account information), to comply with laws, regulations, court orders and lawful instructions from government agencies, to protect the personal safety of subscribers or the public, to prevent and defend claims, to resolve disputes, to troubleshoot problems, to enforce our   Terms and Conditions for Service, to protect our rights and property, and to customize, measure, and improve the Services and the content and layout of the Site including pattern recognition, modeling, enhancement and improvement, system analysis, and Service performance analysis.',
                ],
              },
              {
                header: 'OTHER IMPORTANT INFORMATION:',
                paragraphs: [
                  'Vermont: Under Vermont law, we will not share information we collect about Vermont residents with companies outside of our Affiliates, unless the law allows. We will not share information about your creditworthiness with our Affiliates except  with your consent, but we may share information about our transactions or experiences with you with our Affiliates without your consent.<br>California: Under California law, we will not share information we collect about you with Non-Affiliates, unless the law allows. For example, we may share information with your consent, to service your accounts, or to provide rewards or benefits you are entitled to. We will limit sharing among our Affiliates to the extent required by California law.',
                ],
              },
              {
                header: 'DEFINITIONS:',
                paragraphs: [
                  'Affiliates: Companies related by common ownership or control.<br>Non-Affiliates: Companies not related by common ownership or control. They can be financial or nonfinancial companies. Joint Marketing: A formal agreement between nonaffiliated financial companies that together market financial products or services to you.',
                ],
              },
              {
                header: 'HOW WE PROTECT PERSONAL INFORMATION ABOUT YOU:',
                paragraphs: [
                  'To protect Personal Information about you from unauthorized access and use, we maintain physical, electronic, and procedural safeguards, including but not limited to security measures that comply with applicable federal and state laws. We also require our service providers and business partners to whom we disclose the information to do the same.',
                ],
              },
              {
                header: 'PROTECTION FOR FORMER CUSTOMERS:',
                paragraphs: [
                  'When you are no longer our customer or using the Site or Service, we continue to protect, use and share Personal Information about you as described in this notice and as required by law, including but not limited to for risk management, regulatory compliance, and audit purposes.',
                ],
              },
              {
                header: 'AMENDMENTS:',
                paragraphs: [
                  'We may amend this policy at any time by posting a revised version on the Site. The revised version will be effective immediately at the time it is posted unless a delayed effective date is expressly stated therein. You may (in our discretion) also be provided with an email notification of such amendments. You may (in our discretion) be required to affirmatively acknowledge or accept the revised Privacy Policy in order to continue using the Site or Service. Any use of the Service after a notice of change (whether by Site posting, email, or express acknowledgment or acceptance) will constitute your express agreement to such changes.',
                ],
              },
              {
                header: 'CONTACTING US:',
                paragraphs: [
                  "If you have any questions about this Privacy Policy, you may contact us at the postal address or email address below: <br><br>In writing:<br>BillMatrix Corporation ATTN: Privacy Management<br>2900 Westside Parkway<br>Alpharetta, GA 30004 E-mail: <a class='t-data t-link' href='mailto: privacy@customercenter.net'>privacy@customercenter.net</a>",
                ],
              },
            ],
            attestation: 'I have read and agree to the Privacy Policy',
          },
          getAdditionalPaymentMethods: true,
          defaultTermsAndConditionsAttestation: {
            header: 'Payment Terms and Conditions',
            sections: [
              {
                header: 'INTRODUCTION:',
                paragraphs: [
                  'This document is to provide you information about the online bill payment system offered to you on behalf of your Biller (the “Service”) and the associated website (the “Site”). These terms and conditions set forth a legally binding agreement governing your use of the Site and the Service (“Agreement”) and outline important conditions that apply to your use of the Site and the Service. By utilizing the Service, permitting any person to do so on your behalf, or utilizing the Service on someone else’s behalf, you agree to these terms and conditions. If you do not agree to these terms and conditions, you must discontinue your access to the Site and not utilize the Service.',
                ],
              },
              {
                header: 'DEFINITIONS:',
                paragraphs: [
                  'Authorized User is any individual which you allow to use the Service or access to your Funding Account.<br>Auto Pay Payment is a recurring Payment made by you on the Due Date for the amount shown on the Billing Statement.<br>Biller is the entity to which you instruct us to make a Payment on your behalf.<br>Biller Account means the account you have directly with the Biller related to the goods and / or services provided to you by the Biller.<br>Billing Statement is the statement typically sent by Biller to you indicating, among other things, how much you owe for the provision of goods and / or services and the Due Date.<br>Business Day is every Monday through Friday, excluding Federal Reserve holidays.<br>Due Date is the date reflected on your Billing Statement when your payment is due; it is not the late payment date or inclusive of a grace period.<br>Funding Account is the checking account, savings account, or debit card account, held at FDIC or equivalent insured United States depository institutions, or credit card account from which Payments and fees, if any, will be debited and to which credits to you will be credited.<br>Payment is a payment transaction initiated by you through the Service.<br>Payment Date is the calendar day you elect for the Biller to receive the Payment, and is also the day your Funding Account will be debited; provided that if the calendar day you elect falls on a non-Business Day,  or after the daily cutoff  time for the Service, the actual Payment Date and the actual date your Funding Account will be debited will be the immediately following Business Day. This date can be current or in the future.<br>Payment Instruction is the information provided by you (such as, but not limited to, Biller name, Biller Account number, and Payment Date) for a Payment to be made through the Service.<br>Payment Wallet is the Funding Account information you save (if any) for use in making future Payments.<br>Recurring Payment is a Payment made each calendar month on the date designated by you in an amount designated by you. <br>Scheduled Payment is a Payment that has been scheduled for a future date, but which has not yet begun processing.<br>We, us, and our refers to Biller and its third-party service providers.<br>You and “your refer to the individual that is utilizing the Service.',
                ],
              },
              {
                header: 'ELIGIBILITY:',
                paragraphs: [
                  'The Site and the Service are offered only to individuals who can form legally binding contracts under applicable law and, with respect to Payments made using checking, savings, or debit cards, use bank accounts held at FDIC or equivalent insured United States depository institutions. Without limiting the foregoing, the Service is not offered to minors.  Commercial entities, including without limitation commercial payment aggregators, may not use the Site or Service, with the exception that an authorized representative of a commercial entity who holds a Biller Account may use the Site or Service to initiate a Payment to such commercial entity’s own Biller Account. By using the Service, you represent that you meet these requirements and that you agree to be bound by this Agreement. You agree to indemnify and hold us harmless for all costs and fees (including without limitation interchange fees and merchant fees) arising out of your violation of this Section.',
                ],
              },
              {
                header: 'PAYMENT AUTHORIZATION, PAYMENT REMITTANCE AND FEES:',
                paragraphs: [
                  'You authorize us to follow the Payment Instructions received from you. When we receive a Payment Instruction from you, you authorize us to debit or charge your Funding Account for the amount of any Payment plus any related fees in effect at the time you initiate the Payment Instruction, and to remit funds on your behalf. You also authorize us to credit your Funding Account, in the event that any Payments are returned to us because the processing of the Payment Instruction could not be completed. In order to process Payments more efficiently and effectively, we may edit or alter payment data or data formats. You certify that any Funding Account you add to your profile or otherwise utilize in connection with the  Service is an account from which you are authorized to make payments, and any Payment you make using the Service will debit/charge a Funding Account that you are legally authorized to use. We will use reasonable efforts to complete your Payments properly. However, we shall incur no liability if the Service is unable to complete any Payments initiated by you because of the existence of any one or more of the following circumstances or other reasons identified in this Agreement <br><br>1.    If your Funding Account does not contain sufficient funds to complete the transaction or the transaction would exceed the credit limit of your overdraft account;<br>2.    If our payment processing center is not working properly and you know or have been advised about the malfunction before you execute the transaction. <br>3.    If you have not provided us with the correct Funding Account information, or other required information. <br>4.    If your debit/credit card is expired;<br>5.    If circumstances beyond our control (such as, but not limited to, fire, flood, or other acts of God, third party systems, or interference from an outside force) prevent the proper execution of the transaction; and/ or<br>6.    If you failed to follow our instructions for the use of the Service.<br><br>Provided none of the foregoing exceptions are applicable, if we cause an incorrect amount of funds to be removed from your Funding Account or cause funds from your Funding Account to be directed in a manner that does not comply with your Payment Instructions, our sole responsibility to you shall be to return the improperly transferred funds to your Funding Account or to direct any previously misdirected Payments to the Biller.You are responsible for ensuring that there are sufficient funds available in your Funding Account to cover any amount you authorize for payment. If you do not have sufficient funds in your Funding Account, your Payment may not be processed. Your Payment may not be processed after a credit or debit card’s expiration date, if it is not updated by you prior to such date, unless we are able to obtain updated information from your card issuer. You authorize us to receive such updated credit or debit card information where available.In the event your Payment is not processed for any reason, including the failure to obtain an authorization from your card issuer or financial institution, or you have not provided us with the correct information, your liability shall remain outstanding and unpaid and you will be subject to all applicable penalties, late fees and interest charges assessed thereon, all of which obligations remain your sole responsibility.Any fees associated with your Funding Account, including without limitation any assessed by your financial institution or credit card issuer, will continue to apply. You are also responsible for any and all telephone access fees and/or Internet service fees that may be assessed by your telephone and/or Internet service provider in connection with your utilization of the Service.',
                ],
              },
              {
                header: 'OVERPAYMENT ADJUSTMENT:',
                paragraphs: [
                  'You agree that you shall not intentionally schedule a Payment in excess of the greater of (i) the amount due on the Billing Statement or (ii) the total balance owed on your account. You acknowledge that we may refuse to process any such overpayment or, we may adjust the Payment amount down to the amount due at time of payment processing as to avoid overpayments.',
                ],
              },
              {
                header: 'PAYMENT CANCELLATION REQUESTS:',
                paragraphs: [
                  'You may be permitted to cancel or edit a Payment until such time as the processing of the Payment Instruction has begun. If permitted, there is no charge for canceling or editing a Payment prior to the processing of the Payment Instruction.',
                ],
              },
              {
                header: 'RETURNED PAYMENTS:',
                paragraphs: [
                  'In using the Service, you understand that payments may be returned for various reasons, such as, but not limited to, the Biller Account number is not valid; we are unable to locate your Biller Account; or your Biller Account is paid in full. We will use reasonable efforts to research and correct the returned payment or void the payment and credit your Funding Account. You may receive notification regarding any such returned payments. You may be assessed fees by us or your financial institution as the result of any returns or insufficient funds related to your Funding Account, or charges refused by a card network.',
                ],
              },
              {
                header: 'PAYMENT WALLET:',
                paragraphs: [
                  'The Payment Wallet allows you to save your Funding Account for use in making future Payments. If you elect to use Payment Wallet, the following terms apply:<br><br>1.    Adding Funding Accounts: You authorize the addition of Funding Accounts to your profile when received from you. The first Funding Account that you add to your profile shall be your “Default Funding Account,” unless you later designate a different Funding Account as your Default Funding Account. If your identity cannot be verified satisfactorily, the Service may not allow you to add a specific type of Funding Account to your profile.<br>2.    Funding Account Number and Expiration Date Changes: It is your sole responsibility and you agree to ensure that the information maintained in your Payment Wallet is and remains accurate. If your Funding Account number changes or your credit or debit card expiration date changes, you agree to make updates to your Payment Wallet. You also authorize us to acquire such new or additional information regarding your accounts from our financial services partners and authorize the update of your Funding Account information accordingly. All changes made by you or acquired by us will be effective for future Payments paid using the Payment Wallet.',
                ],
              },
              {
                header:
                  'AUTO PAY PAYMENTS, RECURRING PAYMENTS, AND SCHEDULED PAYMENTS:',
                paragraphs: [
                  'You may have the option of enrolling for Auto Pay Payments or Recurring Payments. If you choose to enroll for either Auto Pay Payments or Recurring Payments, or if you initiate a Scheduled Payment, an email confirmation will be sent to you confirming that your enrollment or Payment Instruction has been received and whether it has been accepted. Please note the following:<br><br>1.    Payments must be made by the Due Date or you may be assessed a late fee.<br>2.    We will deduct (i) for Auto Pay Payments, the amount due on the Due Date and (ii) for Recurring Payments and Scheduled Payments, the amount designated by you on the date you selected. <br>3.   While enrolled in either Auto Pay Payments or Recurring Payments, you may receive email confirmations of Payments charged to or debited against your Funding Account. It is your responsibility to update your email address in your profile with your current email address. We will not be responsible for email confirmations that are not received as a result of delivery failures. (e.g., spam blockers or incorrect email address).<br>4.   It is your sole responsibility to ensure that all Funding Account information is accurate, legitimate, and up-to-date in order to ensure proper authorization of your Payment. We will not be responsible for any payment processing errors or fees incurred if you fail to provide accurate Funding Account information. <br>5.   You may terminate your participation in Auto Pay Payments and Recurring Payments online, in writing, or by calling Biller’s customer service department. It may take up to thirty (30) days to process termination requests.',
                ],
              },
              {
                header: 'COMMUNICATIONS TO YOU; ADDRESS OR BANKING CHANGES:',
                paragraphs: [
                  'By providing us with a telephone number (including a mobile telephone number) and/or email address, you consent to receiving calls and/or text messages at that number, and/or emails from us for our everyday business purposes (including identity verification). You authorize us to send or provide by electronic communication any notice, communication, amendment or replacement to the Agreement, payment receipt, or disclosure required to be provided orally or in writing to you. You agree to receive any electronic communication provided to you and will not attempt to avoid receiving any such communication. You are deemed to have received any electronic communication provided to you when they are made available to you. By providing us with a telephone number (including a mobile number), you consent to receiving autodialed and prerecorded message calls at that number for Service-related purposes. For example, we may contact you in connection with validating or processing a transaction that you’ve requested through the Service. You agree that we may provide notices to you by posting them on the Site, sending them to you through an in-product message within the Service, emailing them to an email address that you have provided, sending them via text message to any mobile number that you have provided, or by mailing them to any postal address that you have provided. For example, users of the Service may receive certain notices (such as notice of payments and alerts for validation and receipt of transfers of funds) as text messages on their mobile device. All notices by any of these methods shall be deemed received by you no later than twenty-four (24) hours after they are sent or posted, except for notice by postal mail, which shall be deemed received by you no later than three (3) Business Days after it is mailed. It is your sole responsibility to ensure that your contact information is accurate in the Service. We will not be responsible for communications that are not received by you as a result of delivery failures (e.g., spam blockers, incorrect email address or physical address, or incorrect mobile phone number).<br>Data and messaging charges from your telecommunications provider may apply, and you are responsible for any such charges. In the event your enrolled mobile device is lost or stolen, you agree to update your enrollment information and make the appropriate changes to disable the use of such device.',
                ],
              },
              {
                header: 'SECURITY:',
                paragraphs: [
                  'You agree not to give or make available your access or access credentials to the Service to any unauthorized individuals. You are responsible for all Payments you authorize using the Service or that are made using your access credentials. If you permit Authorized Users or other persons to use the Service, you are responsible for any transactions they authorize.   If you believe that your access or access credentials to the Service has been lost, stolen, or otherwise compromised or that someone has transferred or attempted to transfer money without your permission, you must notify customer care at once.   If you believe there have been any unauthorized transfers related to your Funding Account, you should notify Biller customer care department and /or your financial institution at once. See "Your Liability for Unauthorized Transfers."',
                ],
              },
              {
                header: 'INFORMATION AUTHORIZATION:',
                paragraphs: [
                  'You agree that the information you provide to facilitate a Payment, including your Funding Account information, may go through a verification process. You further agree that we may obtain financial information regarding your Funding Account from your financial institution (for example, to resolve payment posting problems, set transaction limits or for verification purposes).',
                ],
              },
              {
                header: 'ALTERATIONS AND AMENDMENTS:',
                paragraphs: [
                  "This Agreement, applicable fees and service charges may be altered or amended from time to time by posting a revised version on the Site or providing a revised version to you by other means. You may be required to affirmatively accept the revised Agreement in order to continue using the Service. Regardless of whether you are so required, any use of the Service after a notice of change or after the posting of a revised version of this Agreement on the Site will constitute your agreement to such changes and revised versions. The revised version will be effective at the time it is posted or otherwise provided to you unless a delayed effective date is expressly stated in the revision. Further, we may, from time to time, revise or update the Service applications, services, and/or related material, which may render all such prior versions obsolete. Consequently, we reserve the right to terminate this Agreement as to all such prior versions of the applications, services, and/or related material and limit access to only the Service's more recent revisions and updates. You authorize us to send or provide by electronic communication any notice, communication, amendment or replacement to the Agreement, or disclosure required to be provided orally or in writing to you. Your use of the Service may be terminated or suspended at any time for any reason or no reason. Neither termination nor suspension shall affect your liability or obligations under this Agreement.",
                ],
              },
              {
                header: 'PAYMENT DISPUTES:',
                paragraphs: [
                  'If you dispute a Payment made from a Funding Account, you acknowledge that such dispute (including, but not limited to, chargeback or fraud) must be taken up with your issuing debit/credit card provider or financial institution. We are not responsible for any research or resolution of such payment disputes.',
                ],
              },
              {
                header: 'ARBITRATION:',
                paragraphs: [
                  'For any claim (excluding claims for injunctive or other equitable relief) arising out of or relating to this Agreement, the parties must resolve the dispute in a cost-effective manner through binding non-appearance-based arbitration. The party commencing arbitration will initiate such arbitration through the American Arbitration Association ("AAA") or an established alternative dispute resolution (ADR) administrator mutually agreed upon by the parties. The parties agree that the following rules shall apply: (a) the arbitration may be conducted telephonically, online and/or be solely based on written submissions, at the election of the party initiating the arbitration; (b) the arbitration shall not involve any personal appearance by the parties, their representatives or witnesses unless otherwise mutually agreed by the parties; (c) discovery shall not be permitted; (d) the matter shall be submitted for decision within ninety (90) days of initiation of arbitration, unless otherwise agreed by the parties, and the arbitrator must render a decision within thirty (30) days of submission; and (e) any award in such arbitration shall be final and binding upon the parties and may be submitted to any court of competent jurisdiction for confirmation. The parties acknowledge that remedies available under federal, state and local laws remain available through arbitration.',
                ],
              },
              {
                header:
                  'NO CLASS ACTION, OTHER REPRESENTATIVE ACTION, OR PRIVATE ATTORNEY GENERAL ACTION, OR JOINDER OR CONSOLIDATION OF ANY CLAIM WITH A CLAIM OF ANOTHER PERSON SHALL BE ALLOWABLE IN ARBITRATION.',
                paragraphs: [
                  'Notwithstanding this Arbitration section, in the event you are a commercial or corporate entity, including without limitation a commercial payment aggregator, we reserve the right to bring a claim against you outside of arbitration and in any forum.',
                ],
              },
              {
                header: 'GOVERNING LAW:',
                paragraphs: [
                  'This Agreement shall be governed by and construed in accordance with the laws of the State of New York, without regard to its conflicts of law’s provisions. To the extent that the terms of this Agreement conflict with applicable state or federal law, such state or federal law shall replace such conflicting terms only to the extent required by law. In the event of such replacement, all other terms of this Agreement shall remain in full force and effect. The United Nations Convention on Contracts for the International Sale of Goods shall not apply to this Agreement. Both parties agree to waive any right to have a jury participate in the resolution of any dispute or claim between the parties or any of their respective affiliates arising under this Agreement, which instead shall be brought under the Arbitration clause set forth above.',
                ],
              },
              {
                header: 'EXCLUSIONS OF WARRANTIES / LIMITATION OF LIABILITY:',
                paragraphs: [
                  'In no event shall we or our services providers be responsible or liable for the timeliness, deletion, mis-delivery, or failure to store any user communications or personalized settings; any viruses which may affect your computer equipment or other property on account of your access to, use of, or downloading from the Site or Service; or any third party’s inability or  refusal to authorize a Payment or any other acts or omissions of third parties not controlled by us.',
                ],
              },
              {
                header:
                  'THE SITE AND SERVICE AND RELATED DOCUMENTATION ARE PROVIDED “AS IS” WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESSED OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF TITLE, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, WE DO NOT GUARANTEE CONTINUOUS, UNINTERRUPTED OR SECURE ACCESS TO ANY PART OF OUR SITE OR SERVICE, AND OPERATION OF THE SITE OR SERVICE MAY BE INTERFERED WITH BY NUMEROUS FACTORS OUTSIDE OF OUR CONTROL. SOME STATES DO NOT ALLOW THE DISCLAIMER OF CERTAIN IMPLIED WARRANTIES, SO THE FOREGOING DISCLAIMERS MAY NOT APPLY TO YOU. THIS PARAGRAPH GIVES YOU SPECIFIC LEGAL RIGHTS AND YOU MAY ALSO HAVE OTHER LEGAL RIGHTS THAT VARY FROM STATE TO STATE.',
                paragraphs: [
                  'IN NO EVENT SHALL WE OR OUR SERVICE PROVIDERS (OR EITHER OF OUR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, AFFILIATES OR STOCKHOLDERS) BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF THE SITE OR THE SERVICE OR OTHERWISE RELATING TO THIS AGREEMENT, INCLUDING WITHOUT LIMITATION ANY DIRECT, SPECIAL, INDIRECT, INCIDENTAL, CONSEQUENTIAL, PUNITIVE, EXEMPLARY, OR TORT DAMAGES OR LOST PROFITS (EVEN IF ADVISED OF THE POSSIBILITY THEREOF), REGARDLESS OF WHETHER SUCH CLAIM ARISES IN TORT, CONTRACT, OR OTHERWISE.',
                ],
              },
              {
                header: 'INDEMNIFICATION:',
                paragraphs: [
                  'You agree to indemnify and hold harmless us and our affiliates, suppliers, service providers, licensors and contractors, and the officers, directors, owners, agents, employees and contractors of each of these, from and against any and all loss, damage, liability, claim, demand, fees, costs, and expenses (including attorney’s fees) arising out of your breach of this Agreement and/or your access to or use of the Site or the Service.',
                ],
              },
              {
                header: 'INTELLECTUAL PROPERTY:',
                paragraphs: [
                  'All marks and logos related to the Site and the Service are either trademarks or registered trademarks of the Biller or its service providers, or their respective affiliates or licensors. You may not copy, modify, translate, decompile, reverse engineer, reproduce, adapt or disassemble the Site or the Service, both of which are the sole property of the Biller’s   service provider or the Biller’s service provider’s affiliates or their respective licensors. With the exception of your right to use the Site and Service in accordance with the terms hereof, which right may be revoked by us, you are not granted any rights of any kind in the Site, Service, marks, or logos, and we hereby reserve all such rights. The content accessed through the Site is the property of the applicable content owner and may be protected by applicable copyright or other law. Any downloading of material contained on the Site, or on any site linked to the Site, may be a violation of federal trademark or copyright laws.',
                ],
              },
              {
                header: 'ASSIGNMENT:',
                paragraphs: [
                  'You may not assign or transfer any rights or obligations you have under this Agreement to any other party without our prior written consent, which we may withhold in our sole discretion. We reserve the right to assign this Agreement or any right or obligation under this Agreement at any time to any party. We may also assign or delegate certain of our rights and responsibilities under this Agreement to affiliates, independent contractors, or other third parties.',
                ],
              },
              {
                header: 'NO WAIVER:',
                paragraphs: [
                  'We shall not be deemed to have waived any of our rights or remedies hereunder unless such waiver is in writing and signed by one of our authorized representatives. No delay or omission on our part in exercising any rights or remedies   shall operate as a waiver of such rights or remedies or any other rights or remedies. A waiver on any one occasion shall not be construed as a bar or waiver of any rights or remedies on future occasions.',
                ],
              },
              {
                header: 'CAPTIONS:',
                paragraphs: [
                  'The captions of sections hereof are for convenience only and shall not control or affect the meaning or construction of any of the provisions of this Agreement.',
                ],
              },
              {
                header: 'ERROR, QUESTIONS AND COMPLAINTS:',
                paragraphs: [
                  'In case of errors or questions about your transactions or Billing Statements, you should contact Biller customer care as soon as possible.',
                ],
              },
              {
                header: 'ENTIRE AGREEMENT:',
                paragraphs: [
                  'You agree that this Agreement (including without limitation the Privacy Policy set forth below) is the complete and exclusive statement of the agreement between you and us, and it supersedes any proposal or prior agreement, oral or written, and any other communications between you and us relating to the subject matter of this Agreement.',
                ],
              },
            ],
            attestation: 'I have read and agree to the Payment Terms',
          },
        },
        landing: {
          text: {
            cta: 'Review My Personal Information',
            header: "It's Time to Renew Your Health Plan for 2019!",
            subheader:
              'You may be eligible to keep your current plan, or shop for a new plan that works for you. Get started by reviewing your personal information',
          },
          splash:
            'https://d32ul9oyxvd2n5.cloudfront.net/illustrations/upgrade.svg',
          skipLanding: false,
        },
        workflowNav: { exitEnrollmentRoute: '/shopping/workbench' },
        confirmation: {
          text: {
            print: 'Print Your Application',
            reason: 'Reason',
            coverage: 'coverage',
            zip_code: 'ZIP Code',
            submitted: 'Submitted',
            learn_more: 'Learn More About Your New Plan',
            subscriber: 'Subscriber',
            quick_links: 'Quick Links',
            coverage_type: 'Coverage Type',
            selected_plans: 'Selected Plans',
            confirmation_num: 'Confirmation Number',
            enrollment_status: 'Enrollment Status',
            coverage_start_date: 'Coverage Start Date',
            will_receive_updates:
              'You will receive updates to keep you informed. In the meantime, you can always check your status by logging into your account.',
            application_submitted:
              'Your Application Was Successfully Submitted',
          },
          cards: [
            {
              icon: 'id_product',
              label: 'Confirmation Number',
              value: '${confirmation_number}',
            },
            {
              icon: 'clipboard',
              label: 'Enrollment Status',
              value: '${status}',
              format: 'SNAKE_CASE_TO_TITLE',
            },
            { icon: 'wellness_product', label: 'Plans', value: '${plans}' },
          ],
          label: 'Application Complete',
          summary: [
            {
              title: 'Coverage & Members',
              sections: [
                {
                  title: 'Coverage',
                  attributes: [
                    { prop: 'permanent_address.zipcode', label: 'ZIP Code' },
                    {
                      prop: 'demographics.displayCoverageType',
                      label: 'Coverage Type',
                    },
                    {
                      prop: 'coverage_effective_date',
                      label: 'Coverage Start Date',
                      format: 'DATE',
                    },
                  ],
                },
                {
                  title: 'Subscriber',
                  actions: [{ name: 'HIDE' }],
                  attributes: [
                    { prop: 'subscriber', label: 'Name', format: 'FULL_NAME' },
                    {
                      prop: 'subscriber.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    { prop: 'subscriber.gender', label: 'Gender' },
                    {
                      prop: 'subscriber.displaySSN',
                      label: 'Social Security Number',
                    },
                  ],
                  conditions: {
                    all: [{ name: 'subscriber', operation: 'EXISTS' }],
                  },
                },
                {
                  title: 'Spouse',
                  actions: [{ name: 'HIDE' }],
                  attributes: [
                    { prop: 'spouse', label: 'Name', format: 'FULL_NAME' },
                    {
                      prop: 'spouse.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    { prop: 'spouse.gender', label: 'Gender' },
                    {
                      prop: 'spouse.displaySSN',
                      label: 'Social Security Number',
                    },
                  ],
                  conditions: {
                    all: [{ name: 'spouse', operation: 'EXISTS' }],
                  },
                },
                {
                  title: 'Dependent ${ind}',
                  actions: [{ name: 'HIDE' }],
                  attributes: [
                    {
                      prop: 'dependent${i}',
                      label: 'Name',
                      format: 'FULL_NAME',
                    },
                    {
                      prop: 'dependent${i}.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    { prop: 'dependent${i}.gender', label: 'Gender' },
                    {
                      prop: 'dependent${i}.displaySSN',
                      label: 'Social Security Number',
                    },
                  ],
                  conditions: {
                    all: [{ name: 'dependents', operation: 'EXISTS' }],
                  },
                },
              ],
            },
            { type: 'plan', title: 'Selected Plan' },
            {
              type: 'pcp',
              title: 'Primary Care Physician (PCP)',
              actions: [{ name: 'HIDE' }],
              conditions: {
                all: [{ name: 'steps.pcp_selection', operation: 'EXISTS' }],
              },
            },
            {
              title: 'Special Enrollment Period',
              actions: [{ name: 'HIDE' }],
              attributes: [{ prop: 'qleReason', label: 'Reason' }],
              conditions: { all: [{ name: 'qleReason', operation: 'EXISTS' }] },
            },
            {
              title: 'Personal Information',
              sections: [
                {
                  title: 'Address',
                  attributes: [
                    {
                      prop: 'permanent_address.street_name_1',
                      label: 'Address 1',
                    },
                    {
                      prop: 'permanent_address.street_name_2',
                      label: 'Address 2',
                    },
                    { prop: 'permanent_address.city', label: 'City' },
                    { prop: 'permanent_address.state', label: 'State' },
                    { prop: 'permanent_address.zipcode', label: 'ZIP Code' },
                  ],
                },
                {
                  title: 'Contact',
                  attributes: [
                    {
                      prop: 'phoneNumber',
                      label: 'Primary Phone Number',
                      format: 'PHONE',
                    },
                    { prop: 'email', label: 'Email Address', format: 'EMAIL' },
                  ],
                },
              ],
            },
            {
              type: 'billing',
              title: 'Payment Information',
              actions: [{ name: 'HIDE' }],
              conditions: { all: [{ name: 'payment', operation: 'EXISTS' }] },
            },
            {
              type: 'signature',
              title: 'Attestation',
              actions: [{ name: 'HIDE' }],
              conditions: {
                all: [{ name: 'signee_info', operation: 'EXISTS' }],
              },
            },
          ],
          download: {
            content: 'Print Your Application',
            printConfig: { hidden: true },
          },
          learn_more: [
            {
              icon: 'hospital',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/ifp/getting_care&page=contentpages',
              label: 'Getting Care',
              button: 'Get Care',
              description:
                'Learn how to find a doctor, why it’s important to have a primary care physician, when you need urgent or emergency care, how to get care outside of a doctor’s office and more.',
            },
            {
              icon: 'file',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/ifp/plan_resources&page=contentpages',
              label: 'Plan Resources',
              button: 'Get Information',
              description:
                'Access important plan documents that explain your benefits and learn how to make the most of your individual and family medical, dental, and/or vision plan(s).',
            },
            {
              icon: 'costs_product',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/ifp/billing_resources/billing_costs_financial_help&page=contentpages',
              label: 'Billing Resources',
              button: 'Learn More',
              description:
                'Whether you want to sign-up for automatic payments, learn how to pay your bill online, or want to learn the basics about healthcare costs and claims, you can find it all here.',
            },
          ],
          quick_links: [
            {
              icon: 'heart_product',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/ifp/renewal_center/specialty_offer&page=contentpages',
              label: 'Protect Your Whole Self',
              button: 'Get Total Coverage',
              description:
                'Add a dental plan, vision plan, or life insurance plan for full coverage.',
            },
            {
              icon: 'video_product',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/ifp/getting_help/videos_how&page=contentpages',
              label: 'Helpful Videos',
              button: 'Watch Now',
              description:
                'Find out how to access all the important features of your Blue Shield membership.',
            },
            {
              icon: 'file',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/ifp/ifp_glossary&page=contentpages',
              label: 'Definitions',
              button: 'Read Now',
              description:
                'Get help understanding basic healthcare and billing terms.',
            },
            {
              icon: 'care',
              link: 'https://www.blueshieldca.com/bsca/bsc/public/member/poc?urile=wcm:path:/member_content_en/content%20root/be_well/pharmacy/tier2_pharmacy_cnt&page=contentpages',
              label: 'Pharmacy',
              button: 'Learn More',
              description:
                'View the drug formulary for your plan, learn about mail service pharmacy.',
            },
            {
              icon: 'calculator',
              link: 'https://www.blueshieldca.com/bsca/documents/find-a-plan/A47476_8-17_Member-flier-TCE.pdf',
              label: 'Treatment Cost Estimator',
              button: 'Estimate Now',
              description:
                'With a PPO plan, you can use this tool to estimate and compare your costs.',
            },
            {
              icon: 'wellness_product',
              link: 'https://www.blueshieldca.com/preventive-care/home.html',
              label: 'Prevention',
              button: 'View Guidelines',
              description:
                'See what’s covered during a preventive care visit and guidelines for every age.',
            },
          ],
          attributeColumns: 3,
          defaultNoValueMessage: 'N/A',
        },
        demographics: {
          sep: {
            form: {
              controls: [
                {
                  prop: 'is_sep',
                  type: 'radio',
                  label: 'Special Enrollment',
                  options: [
                    {
                      label: 'See if I qualify for Special Enrollment.',
                      value: true,
                    },
                    {
                      label: "I'll continue with standard Open Enrollment.",
                      value: false,
                    },
                  ],
                  validators: ['required'],
                },
              ],
            },
            title: 'Do you qualify for Special Enrollment?',
            subtitle:
              'Completing an application for Special Enrollment requires a Qualifying Life Event (QLE). You will be asked to provide more details later.',
          },
          label: 'Get Started',
          splash: {
            list: [],
            title:
              'Our individual and family health plans are designed to give you a choice and fit your budget. With all plans, you have 24/7 phone or video access to registered nurses and doctors through NurseHelp 24/7 and Teladoc.',
            alignment: 'center',
            paragraph: '',
          },
          submit: {
            icon: '',
            level: 'high',
            content: 'Start the Enrollment Process',
          },
          members: {
            form: {
              controls: [
                {
                  prop: 'date_of_birth',
                  type: 'date',
                  label: 'Date of Birth',
                  validators: [
                    'required',
                    'reasonableDate',
                    {
                      name: 'minAge',
                      dependency: {
                        age: 18,
                        dateProp: 'parent.value.coverage_effective_date',
                      },
                    },
                    {
                      name: 'maxAge',
                      dependency: {
                        age: 65,
                        dateProp: 'parent.value.coverage_effective_date',
                      },
                    },
                  ],
                  placeholder: 'YYYY-MM-DD',
                },
              ],
            },
            cards: {
              spouse: {
                prop: 'spouse',
                label: 'Your spouse or partner',
                controls: [
                  {
                    prop: 'date_of_birth',
                    type: 'date',
                    label: 'Date of Birth',
                    errors: {
                      maxAge: 'Please enter a valid date of birth',
                      minAge: 'Spouse must be age 18 or older',
                      required: 'Please enter a valid date of birth',
                      dateInPast: 'Please enter a valid date of birth',
                      reasonableDate: 'Please enter a valid date of birth',
                    },
                    validators: [
                      'required',
                      'dateInPast',
                      'reasonableDate',
                      {
                        name: 'minAge',
                        dependency: {
                          age: 18,
                          dateProp: 'parent.value.coverage_effective_date',
                        },
                      },
                      {
                        name: 'maxAge',
                        dependency: {
                          age: 65,
                          dateProp: 'parent.value.coverage_effective_date',
                        },
                      },
                    ],
                    placeholder: 'YYYY-MM-DD',
                  },
                ],
              },
              children: {
                prop: 'children',
                label: 'Your dependent',
                notes: [
                  'For a dependent only application, the dependent must be less than 18 years old.',
                  'If you need to enroll more than one dependent without also including an adult on the policy, you will need to submit separate applications for each dependent.',
                ],
                controls: [
                  {
                    prop: 'date_of_birth',
                    type: 'date',
                    label: 'Date of Birth',
                    errors: {
                      maxAge: 'Child dependent must be under the age 26',
                      required: 'Please enter a valid date of birth',
                      dateInPast: 'Please enter a valid date of birth',
                      reasonableDate:
                        'Child dependent must be under the age 26',
                    },
                    validators: [
                      'required',
                      'dateInPast',
                      'reasonableDate',
                      {
                        name: 'maxAge',
                        dependency: {
                          age: 26,
                          dateProp: 'parent.value.coverage_effective_date',
                        },
                      },
                    ],
                    placeholder: 'YYYY-MM-DD',
                  },
                ],
              },
              child_only: {
                prop: 'children',
                label: 'Your Dependent',
                notes: [
                  'If you need to enroll more than one dependent without also including an adult on the policy, you will need to submit separate applications for each dependent.',
                ],
                controls: [
                  {
                    prop: 'date_of_birth',
                    type: 'date',
                    label: 'Date of Birth',
                    errors: {
                      maxAge: 'Please enter a valid date of birth',
                      required: 'Please enter a valid date of birth',
                      dateInPast: 'Please enter a valid date of birth',
                      reasonableDate: 'Please enter a valid date of birth',
                    },
                    validators: [
                      'required',
                      'dateInPast',
                      'reasonableDate',
                      {
                        name: 'maxAge',
                        dependency: {
                          age: 18,
                          dateProp: 'parent.value.coverage_effective_date',
                        },
                      },
                    ],
                    placeholder: 'YYYY-MM-DD',
                  },
                ],
                childLimit: 1,
              },
              subscriber: {
                prop: 'subscriber',
                label: 'Yourself',
                controls: [
                  {
                    prop: 'date_of_birth',
                    type: 'date',
                    label: 'Date of Birth',
                    errors: {
                      maxAge: 'Please enter a valid date of birth',
                      minAge: 'Please enter a valid date of birth',
                      required: 'Please enter a valid date of birth',
                      dateInPast: 'Please enter a valid date of birth',
                      reasonableDate: 'Please enter a valid date of birth',
                    },
                    validators: [
                      'required',
                      'dateInPast',
                      'reasonableDate',
                      {
                        name: 'maxAge',
                        dependency: {
                          age: 65,
                          dateProp: 'parent.value.coverage_effective_date',
                        },
                      },
                      {
                        name: 'minAge',
                        dependency: {
                          age: 18,
                          dateProp: 'parent.value.coverage_effective_date',
                        },
                      },
                    ],
                    placeholder: 'YYYY-MM-DD',
                  },
                ],
              },
              stepParents: {
                prop: 'stepParents',
                label: 'Your Parent(s)/Step-Parent(s)',
                controls: [
                  {
                    prop: 'date_of_birth',
                    type: 'date',
                    label: 'Date of Birth',
                    errors: {
                      maxAge:
                        'Parent(s)/Step Parent(s) dependent must be under the age 115',
                      minAge:
                        'Parent(s)/Step Parent(s) dependent must be above 26',
                      required: 'Please enter a valid date of birth',
                      dateInPast: 'Please enter a valid date of birth',
                      reasonableDate: 'Please enter a valid date of birth',
                    },
                    validators: [
                      'required',
                      'dateInPast',
                      'reasonableDate',
                      {
                        name: 'maxAge',
                        dependency: {
                          age: 114,
                          dateProp: 'root.value.coverage_effective_date',
                        },
                      },
                      {
                        name: 'minAge',
                        dependency: {
                          age: 27,
                          dateProp: 'root.value.coverage_effective_date',
                        },
                      },
                    ],
                    placeholder: 'YYYY-MM-DD',
                  },
                  {
                    prop: 'tobacco_user',
                    type: 'toggle',
                    label: 'Are you a tobacco user?',
                    options: [
                      { label: 'Yes', value: true },
                      { label: 'No', value: false },
                    ],
                    validators: ['required'],
                    description:
                      'Tobacco user is defined as using tobacco products (for example cigarettes, cigars, smokeless tobacco, e-cigarettes) four or more times a week on average (other than for religious or ceremonial purposes) within the last six months. This only applies to individuals age 21 and over.',
                  },
                ],
              },
            },
            title: 'Who needs insurance?',
            options: {
              family: {
                icon: 'family',
                cards: ['subscriber', 'spouse', 'children'],
                label: 'You and your spouse or partner and dependent',
                value: 'family',
              },
              parent: {
                icon: 'spouse',
                cards: ['subscriber', 'children'],
                label: 'You and your dependent',
                value: 'parent',
              },
              spouse: {
                icon: 'spouse',
                cards: ['subscriber', 'spouse'],
                label: 'You and your spouse or partner',
                value: 'spouse',
              },
              children: {
                icon: 'family',
                cards: ['child_only'],
                label: 'Your dependent',
                value: 'children',
                one_per_policy: true,
              },
              subscriber: {
                icon: 'single',
                cards: ['subscriber'],
                label: 'Yourself',
                value: 'subscriber',
              },
            },
            subtitle: 'You can apply for yourself or a family member.',
          },
          subsidy: null,
          coverage: {
            form: {
              county: {
                prop: 'county',
                type: 'dropdown',
                label: 'County',
                options: [],
                validators: ['required'],
              },
              zipcode: {
                mask: 'number',
                prop: 'zipcode',
                type: 'text',
                label: 'ZIP Code',
                errors: { customErrMessage: 'Please enter a valid CA zipcode' },
                maxLength: 5,
                validators: ['required', 'zipcode'],
                enterAnother: 'Please enter another ZIP Code.',
              },
              coverage_type: {
                prop: 'coverage_type',
                type: 'dropdown',
                label: 'Coverage Type',
                default: 'medical',
                options: [
                  { label: 'Medical', value: 'medical' },
                  { label: 'Dental and/or Vision', value: 'dental/vision' },
                ],
                validators: ['required'],
              },
            },
            text: {
              max_age_spouse_medicare_or_individual_or_dental:
                "<span class='t-bold'>Please Note:</span> Based on the date of birth you entered, your spouse may qualify for Medicare. You can view our Medicare-eligible plans at <a href='https://blueshieldcamedicare.com' class='t-data t-link'>https://blueshieldcamedicare.com</a>. If you would prefer an Individual & Family plan instead, please call us at <a href='tel: (888) 273-0010' class='t-data t-link'>(888) 273-0010</a> to apply. If you are only interested in purchasing a dental or vision plan, select Dental and/or Vision plan",
              max_age_subscriber_medicare_or_individual_or_dental:
                "<span class='t-bold'>Please Note:</span> Based on the date of birth you entered, you may qualify for Medicare. You can view our Medicare-eligible plans at <a href='https://blueshieldcamedicare.com' class='t-data t-link'>https://blueshieldcamedicare.com</a>. If you would prefer an Individual & Family plan instead, please call us at <a href='tel: (888) 273-0010' class='t-data t-link'>(888) 273-0010 </a>to apply. If you are only interested in purchasing a dental or vision plan, select Dental and/or Vision plan",
            },
            title: "Let's find you a plan",
            messages: {
              aep: 'You can still enroll in the Annual Enrollment Period by choosing one of the following dates:',
              sep: "Open Enrollment ended January 15, but you can still qualify for health coverage if you experienced a <span class='t-link'>qualifying event</span>. The next open enrollment period begins October 15th.",
            },
          },
          secondaryQleDateValidators: ['required'],
        },
        doctorSearch: {
          filters: {
            groups: [
              {
                prop: 'specialties',
                controls: [
                  {
                    prop: 'specialties',
                    type: 'dropdown',
                    label: 'Specialties',
                    options: [],
                  },
                ],
              },
              {
                prop: 'sort_by',
                controls: [
                  {
                    prop: 'sort_by',
                    type: 'radio',
                    label: 'Sort By',
                    options: [
                      { label: 'Closest to me', value: 'distance' },
                      { label: 'Name (A - Z)', value: 'last_name' },
                    ],
                  },
                ],
              },
              {
                prop: 'filters',
                controls: [
                  {
                    prop: 'accepting_new_patients',
                    type: 'radio',
                    label: 'Status',
                    options: [
                      { label: 'Accepting New Patients', value: 'true' },
                    ],
                  },
                  {
                    prop: 'gender',
                    type: 'radio',
                    label: 'Gender',
                    options: [
                      { label: 'Female', value: 'female' },
                      { label: 'Male', value: 'male' },
                    ],
                  },
                  {
                    prop: 'language',
                    type: 'dropdown',
                    label: 'Language',
                    options: [
                      { label: 'Arabic', value: 'arabic' },
                      { label: 'Chinese', value: 'chinese' },
                      { label: 'English', value: 'english' },
                      { label: 'Hindi', value: 'hindi' },
                      { label: 'Italian', value: 'italian' },
                      { label: 'Japanese', value: 'japanese' },
                      { label: 'Laotian', value: 'laotian' },
                      { label: 'Portuguese', value: 'portuguese' },
                      { label: 'Russian', value: 'russian' },
                      { label: 'Spanish', value: 'spanish' },
                    ],
                  },
                  {
                    icon: 'search',
                    prop: 'hospital_affiliations',
                    label: 'Hospital Affiliations',
                  },
                  {
                    icon: 'search',
                    prop: 'medical_group_affiliations',
                    label: 'Medical Group Affiliations',
                  },
                ],
              },
            ],
          },
          endpoint: '/api/scapi/providers/search/',
          pageLength: 25,
          buttonConfig: {
            back: { size: 'fullWidth', level: 'medium', content: 'Back' },
            skip: { size: 'fullWidth', level: 'medium', content: 'Skip' },
            continue: {
              size: 'fullWidth',
              level: 'high',
              content: 'Save & Continue',
            },
          },
          incorrect_data: {
            groups: [
              {
                prop: 'correction_type',
                header: 'Correction Types',
                controls: [
                  {
                    prop: 'correction_type',
                    type: 'checkbox',
                    options: [
                      { label: 'Address incorrect', value: 'address' },
                      { label: 'Deceased / Retired', value: 'dead' },
                      {
                        label:
                          'Doctor indicates they no longer accept CareFirst Insurance',
                        value: 'not_accepting_insurance',
                      },
                      {
                        label: 'Doctor no longer accepts new patients',
                        value: 'not_accepting_patients',
                      },
                      {
                        label: 'Doctor left practice location',
                        value: 'doctor_left',
                      },
                      {
                        label: 'Duplicate listing',
                        value: 'duplicate_listing',
                      },
                      { label: 'Gender incorrect', value: 'gender' },
                      { label: 'Phone number incorrect', value: 'phone' },
                      {
                        label: 'Provider / Group name incorrect',
                        value: 'provider_group_name',
                      },
                      { label: 'Specialty incorrect', value: 'specialty' },
                      { label: 'Other (Comments Required)', value: 'other' },
                    ],
                  },
                ],
              },
              {
                prop: 'comments',
                header: 'Comments (optional)',
                controls: [{ prop: 'comments', type: 'textarea' }],
              },
              {
                prop: 'contact_info',
                header: 'Contact Information (optional)',
                controls: [
                  { prop: 'name', label: 'Your Name' },
                  {
                    hint: '(xxx) xxx-xxxx',
                    prop: 'phone',
                    label: 'Contact Number',
                  },
                  { prop: 'email', type: 'email', label: 'Email Address' },
                ],
              },
            ],
          },
          searchBarConfig: {
            header: 'Your Plan Comes with a Primary Care Physician',
            subHeader: 'To use your health plan, you must select a PCP',
            searchConfig: {
              uniqueName: 'Location',
              locationConfig: { within: [5, 10, 25, 50, 100] },
            },
          },
          asideHeaderConfig: {
            header: 'House Hold Member',
            subHeader:
              'Select the person below to assign a Primary Care Physician (PCP)',
            showAsideHeader: true,
          },
          preFilterEndpoint: '/api/scapi/prefilters/',
          providerCardConfig: {
            attributes: [
              { type: 'name', suffix: ', MD' },
              { type: 'specialty' },
              { type: 'phone' },
              { text: 'Get Directions', type: 'address' },
              {
                prop: 'distance',
                type: 'generic',
                prefix: 'Distance from your Address:',
                suffix: 'miles.',
              },
              {
                prop: 'medical_group',
                type: 'generic',
                prefix: 'Medical Group Affiliation:',
              },
            ],
            buttonConfig: {
              add: { size: 'full', level: 'medium', content: 'Add' },
              Selected: {
                icon: 'check',
                size: 'full',
                level: 'high',
                content: 'Add',
                iconFill: 'success',
              },
            },
          },
        },
        personal_info: {
          text: {
            purchasing: 'Purchasing',
            coverage_eff_date: 'Coverage Effective Date',
          },
          forms: {
            spouse: {
              title: "Your Spouse/Partner's ",
              hidden: true,
              controls: [
                {
                  mask: 'alpha',
                  prop: 'first_name',
                  type: 'text',
                  label: 'First Name',
                  maxLength: 15,
                  validators: ['alpha', 'required'],
                },
                {
                  mask: 'alpha',
                  prop: 'middle_initial',
                  type: 'text',
                  label: 'Middle Initial',
                  maxLength: 1,
                  validators: ['alpha'],
                },
                {
                  mask: 'alpha',
                  prop: 'last_name',
                  type: 'text',
                  label: 'Last Name',
                  maxLength: 15,
                  validators: ['alpha', 'required'],
                },
                {
                  prop: 'date_of_birth',
                  type: 'date',
                  label: 'Date of Birth',
                  readonly: true,
                  placeholder: 'YYYY-MM-DD',
                },
                {
                  mask: 'ssn',
                  prop: 'ssn',
                  type: 'text',
                  label: 'SSN',
                  naLabel: 'SSN not available',
                  tooltip:
                    'The Affordable Care Act requires that everyone have health insurance or pay a tax penalty. Your Social Security Number is required on this application and will be used to inform the government that you have applied for coverage and should not be penalized.',
                  inputType: 'password',
                  maxLength: 11,
                  validators: [
                    'ssnDigits',
                    {
                      name: 'requiredIf',
                      prop: 'ssn',
                      message: 'SSN not available',
                      dependency: {
                        requiredIfProp: 'ssn_check',
                        requiredIfPropExpectedValue: false,
                      },
                    },
                  ],
                  inputValidators: ['required', 'social'],
                },
                {
                  prop: 'ssn_check',
                  type: 'singleCheckbox',
                  checkboxLabel: 'SSN not available',
                },
                {
                  prop: 'gender',
                  type: 'toggle',
                  label: 'Gender',
                  options: [
                    { label: 'Male', value: 'male' },
                    { label: 'Female', value: 'female' },
                  ],
                  validators: ['required'],
                },
                {
                  prop: 'different_mailing_address',
                  type: 'radio',
                  label: 'Your spouse lives at a different address?',
                  default: false,
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                },
              ],
              titleSuffix: 'Information',
            },
            questions: {
              title: 'Questions',
              controls: [
                {
                  prop: 'marital_status',
                  type: 'radio',
                  label: 'Married',
                  onlyIf: 'isNotChildOnlyApplication',
                  options: [
                    { label: 'Yes', value: 'married' },
                    { label: 'No', value: 'single' },
                    {
                      label: 'Domestic Partnership',
                      value: 'domestic_partnership',
                    },
                  ],
                  validators: ['required'],
                },
                {
                  prop: 'state_of_residence_cal',
                  type: 'radio',
                  label: 'Do you currently reside in California?',
                  invert: true,
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                  validators: ['required'],
                  conditionalControls: [
                    {
                      prop: 'state_of_residence',
                      type: 'dropdown',
                      label: 'What state do you reside in?',
                      options: [
                        { label: 'Alabama', value: 'AL' },
                        { label: 'Alaska', value: 'AK' },
                        { label: 'American Samoa', value: 'AS' },
                        { label: 'Arizona', value: 'AZ' },
                        { label: 'Arkansas', value: 'AR' },
                        { label: 'Colorado', value: 'CO' },
                        { label: 'Connecticut', value: 'CT' },
                        { label: 'Delaware', value: 'DE' },
                        { label: 'District Of Columbia', value: 'DC' },
                        {
                          label: 'Federated States Of Micronesia',
                          value: 'FM',
                        },
                        { label: 'Florida', value: 'FL' },
                        { label: 'Georgia', value: 'GA' },
                        { label: 'Guam', value: 'GU' },
                        { label: 'Hawaii', value: 'HI' },
                        { label: 'Idaho', value: 'ID' },
                        { label: 'Illinois', value: 'IL' },
                        { label: 'Indiana', value: 'IN' },
                        { label: 'Iowa', value: 'IA' },
                        { label: 'Kansas', value: 'KS' },
                        { label: 'Kentucky', value: 'KY' },
                        { label: 'Louisiana', value: 'LA' },
                        { label: 'Maine', value: 'ME' },
                        { label: 'Marshall Islands', value: 'MH' },
                        { label: 'Maryland', value: 'MD' },
                        { label: 'Massachusetts', value: 'MA' },
                        { label: 'Michigan', value: 'MI' },
                        { label: 'Minnesota', value: 'MN' },
                        { label: 'Mississippi', value: 'MS' },
                        { label: 'Missouri', value: 'MO' },
                        { label: 'Montana', value: 'MT' },
                        { label: 'Nebraska', value: 'NE' },
                        { label: 'Nevada', value: 'NV' },
                        { label: 'New Hampshire', value: 'NH' },
                        { label: 'New Jersey', value: 'NJ' },
                        { label: 'New Mexico', value: 'NM' },
                        { label: 'New York', value: 'NY' },
                        { label: 'North Carolina', value: 'NC' },
                        { label: 'North Dakota', value: 'ND' },
                        { label: 'Northern Mariana Islands', value: 'MP' },
                        { label: 'Ohio', value: 'OH' },
                        { label: 'Oklahoma', value: 'OK' },
                        { label: 'Oregon', value: 'OR' },
                        { label: 'Palau', value: 'PW' },
                        { label: 'Pennsylvania', value: 'PA' },
                        { label: 'Puerto Rico', value: 'PR' },
                        { label: 'Rhode Island', value: 'RI' },
                        { label: 'South Carolina', value: 'SC' },
                        { label: 'South Dakota', value: 'SD' },
                        { label: 'Tennessee', value: 'TN' },
                        { label: 'Texas', value: 'TX' },
                        { label: 'Utah', value: 'UT' },
                        { label: 'Vermont', value: 'VT' },
                        { label: 'Virgin Islands', value: 'VI' },
                        { label: 'Virginia', value: 'VA' },
                        { label: 'Washington', value: 'WA' },
                        { label: 'West Virginia', value: 'WV' },
                        { label: 'Wisconsin', value: 'WI' },
                        { label: 'Wyoming', value: 'WY' },
                        {
                          label: 'Armed Forces Americas(Except Cananda)',
                          value: 'AA',
                        },
                        { label: 'Armed Forces Africa', value: 'AE' },
                        { label: 'Armed Forces Pacific', value: 'AP' },
                      ],
                      validators: ['required'],
                    },
                  ],
                },
                {
                  prop: 'medicare_enrolled',
                  type: 'radio',
                  label:
                    'Are you or anyone applying for coverage currently enrolled with Medicare coverage?',
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                  validators: ['required'],
                  conditionalControls: [
                    {
                      prop: 'medicare_enrolled_applicant_name',
                      type: 'text',
                      label: 'Applicant Name',
                      validators: ['required'],
                    },
                  ],
                },
                {
                  prop: 'medicare_eligible',
                  type: 'radio',
                  label:
                    'Are you or anyone applying for coverage currently eligible for Medicare coverage?',
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                  validators: ['required'],
                  conditionalControls: [
                    {
                      prop: 'medicare_eligible_applicant_name',
                      type: 'text',
                      label: 'Applicant Name',
                      validators: ['required'],
                    },
                  ],
                },
                {
                  prop: 'previous_coverage',
                  type: 'radio',
                  label:
                    'Is this applicant previously insured by Blue Shield of California?',
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                  validators: ['required'],
                  conditionalControls: [
                    {
                      prop: 'previous_plan_name',
                      type: 'text',
                      label: 'Plan Name',
                      validators: ['required'],
                    },
                    {
                      prop: 'previous_subscriber_id',
                      type: 'text',
                      label: 'Subscriber ID',
                      maxLength: 12,
                      validators: ['required'],
                    },
                  ],
                },
                {
                  prop: 'current_coverage',
                  type: 'radio',
                  label:
                    'Is this applicant currently insured by Blue Shield of California?',
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                  validators: ['required'],
                  conditionalControls: [
                    {
                      prop: 'current_plan_name',
                      type: 'text',
                      label: 'Plan Name',
                      validators: ['required'],
                    },
                    {
                      prop: 'current_subscriber_id',
                      type: 'text',
                      label: 'Subscriber ID',
                      maxLength: 12,
                      validators: ['required'],
                    },
                  ],
                },
              ],
            },
            dependents: {
              title: "Your child's / dependent's ",
              hidden: true,
              controls: [
                {
                  mask: 'alpha',
                  prop: 'first_name',
                  type: 'text',
                  label: 'First Name',
                  maxLength: 15,
                  validators: ['alpha', 'required'],
                },
                {
                  mask: 'alpha',
                  prop: 'middle_initial',
                  type: 'text',
                  label: 'Middle Initial',
                  maxLength: 1,
                  validators: ['alpha'],
                },
                {
                  mask: 'alpha',
                  prop: 'last_name',
                  type: 'text',
                  label: 'Last Name',
                  validators: ['alpha', 'required'],
                },
                {
                  mask: 'phone',
                  prop: 'home_phone',
                  type: 'text',
                  label: 'Phone Number',
                  onlyIf: 'isChildOnlyApplication',
                  maxLength: 12,
                  validators: ['required', 'phone'],
                },
                {
                  prop: 'date_of_birth',
                  type: 'date',
                  label: 'Date of Birth',
                  readonly: true,
                  placeholder: 'YYYY-MM-DD',
                },
                {
                  prop: 'email_address',
                  type: 'text',
                  label: 'Email',
                  onlyIf: 'isChildOnlyApplication',
                  maxLength: 40,
                  validators: ['required', 'email'],
                },
                {
                  mask: 'ssn',
                  prop: 'ssn',
                  type: 'text',
                  label: 'SSN',
                  naLabel: 'SSN not available',
                  tooltip:
                    'The Affordable Care Act requires that everyone have health insurance or pay a tax penalty. Your Social Security Number is required on this application and will be used to inform the government that you have applied for coverage and should not be penalized.',
                  inputType: 'password',
                  maxLength: 11,
                  validators: [
                    'ssnDigits',
                    {
                      name: 'requiredIf',
                      prop: 'ssn',
                      message: 'SSN not available',
                      dependency: {
                        requiredIfProp: 'ssn_check',
                        requiredIfPropExpectedValue: false,
                      },
                    },
                  ],
                  inputValidators: ['required', 'social'],
                },
                {
                  prop: 'ssn_check',
                  type: 'singleCheckbox',
                  checkboxLabel: 'SSN not available',
                },
                {
                  prop: 'gender',
                  type: 'toggle',
                  label: 'Gender',
                  options: [
                    { label: 'Male', value: 'male' },
                    { label: 'Female', value: 'female' },
                  ],
                  validators: ['required'],
                },
                {
                  prop: 'relationship_to_subscriber',
                  type: 'dropdownOther',
                  label: 'Relationship to Applicant',
                  onlyIf: 'isNotChildOnlyApplication',
                  default: 'child',
                  options: [
                    { label: 'Child', value: 'child' },
                    { label: 'Adopted Child', value: 'adopted' },
                    { label: 'Step-child', value: 'step_child' },
                    { label: 'Foster Child', value: 'foster_child' },
                    { label: 'Grandchild', value: 'grandchild' },
                    { label: 'Niece/Nephew', value: 'niece_nephew' },
                    { label: 'Brother/Sister', value: 'sibling' },
                    { label: 'Cousin', value: 'cousin' },
                    { label: 'Other Relationship', value: 'other' },
                  ],
                  validators: ['required'],
                },
                {
                  prop: 'legal_guardianship',
                  type: 'singleCheckbox',
                  checkboxLabel: 'Check if legal guardianship',
                },
                {
                  prop: 'different_mailing_address',
                  type: 'radio',
                  label: 'Your dependent lives at a different address?',
                  onlyIf: 'isNotChildOnlyApplication',
                  default: false,
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                },
                {
                  prop: 'language_preference',
                  type: 'dropdownOther',
                  label: 'Language preference',
                  onlyIf: 'isChildOnlyApplication',
                  default: 'english',
                  options: [
                    { label: 'English', value: 'english' },
                    { label: 'Spanish', value: 'spanish' },
                    { label: 'Chinese', value: 'chinese' },
                    { label: 'Vietnamese', value: 'vietnamese' },
                    { label: 'Korean', value: 'korean' },
                    { label: 'Other', value: 'other' },
                  ],
                  validators: ['required'],
                },
              ],
              titleSuffix: 'Information',
            },
            subscriber: {
              title: 'Your Information',
              hidden: true,
              controls: [
                {
                  mask: 'alpha',
                  prop: 'first_name',
                  type: 'text',
                  label: 'First Name',
                  maxLength: 15,
                  validators: ['alpha', 'required'],
                },
                {
                  mask: 'alpha',
                  prop: 'middle_name',
                  type: 'text',
                  label: 'Middle Initial',
                  maxLength: 1,
                  validators: ['alpha'],
                },
                {
                  mask: 'alpha',
                  prop: 'last_name',
                  type: 'text',
                  label: 'Last Name',
                  maxLength: 15,
                  validators: ['alpha', 'required'],
                },
                {
                  mask: 'phone',
                  prop: 'home_phone',
                  type: 'text',
                  label: 'Phone Number',
                  maxLength: 12,
                  validators: ['required', 'phone'],
                },
                {
                  prop: 'date_of_birth',
                  type: 'date',
                  label: 'Date of Birth',
                  readonly: true,
                  placeholder: 'YYYY-MM-DD',
                },
                {
                  prop: 'email_address',
                  type: 'text',
                  label: 'Email',
                  maxLength: 40,
                  validators: ['required', 'email'],
                },
                {
                  mask: 'ssn',
                  prop: 'ssn',
                  type: 'text',
                  label: 'SSN',
                  naLabel: 'SSN not available',
                  tooltip:
                    'The Affordable Care Act requires that everyone have health insurance or pay a tax penalty. Your Social Security Number is required on this application and will be used to inform the government that you have applied for coverage and should not be penalized.',
                  inputType: 'password',
                  maxLength: 11,
                  validators: [
                    'ssnDigits',
                    {
                      name: 'requiredIf',
                      prop: 'ssn',
                      message: 'SSN not available',
                      dependency: {
                        requiredIfProp: 'ssn_check',
                        requiredIfPropExpectedValue: false,
                      },
                    },
                  ],
                  inputValidators: ['required', 'social'],
                },
                {
                  prop: 'ssn_check',
                  type: 'singleCheckbox',
                  checkboxLabel: 'SSN not available',
                },
                {
                  prop: 'gender',
                  type: 'toggle',
                  label: 'Gender',
                  options: [
                    { label: 'Male', value: 'male' },
                    { label: 'Female', value: 'female' },
                  ],
                  validators: ['required'],
                },
                {
                  prop: 'language_preference',
                  type: 'dropdownOther',
                  label: 'Language preference',
                  default: 'english',
                  options: [
                    { label: 'English', value: 'english' },
                    { label: 'Spanish', value: 'spanish' },
                    { label: 'Chinese', value: 'chinese' },
                    { label: 'Vietnamese', value: 'vietnamese' },
                    { label: 'Korean', value: 'korean' },
                    { label: 'Other', value: 'other' },
                  ],
                  validators: ['required'],
                },
              ],
            },
            hmo_questions: {
              title:
                'Please choose a dentist from the Provider Directory at blueshieldca.com, or call (888) 256-3650 for assistance. You can select/change your personal physician selection later',
              hidden: true,
              controls: [
                {
                  prop: 'provider_name',
                  type: 'text',
                  label: 'Dental HMO provider name',
                  maxLength: 50,
                },
                {
                  mask: 'number',
                  prop: 'provider_number',
                  type: 'text',
                  label: 'Dental HMO provider number',
                  maxLength: 20,
                },
              ],
            },
            hsa_questions: {
              title: 'HSA Account',
              hidden: true,
              controls: [
                {
                  prop: 'signedUpHsaAccount',
                  type: 'toggle',
                  label: 'Would you like to sign up for an HSA account?',
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                  maxLength: 50,
                  validators: ['required'],
                },
              ],
            },
            mailing_address: {
              title: 'Mailing Address',
              hidden: true,
              controls: [
                {
                  prop: 'address_1',
                  type: 'text',
                  label: 'Street Address',
                  validators: ['required'],
                },
                {
                  prop: 'address_2',
                  type: 'text',
                  label: 'Apartment, suite, etc.',
                },
                {
                  prop: 'city',
                  type: 'text',
                  label: 'City',
                  validators: ['required'],
                },
                {
                  prop: 'state',
                  type: 'dropdown',
                  label: 'State',
                  options: [
                    { label: 'Alabama', value: 'AL' },
                    { label: 'Alaska', value: 'AK' },
                    { label: 'American Samoa', value: 'AS' },
                    { label: 'Arizona', value: 'AZ' },
                    { label: 'Arkansas', value: 'AR' },
                    { label: 'California', value: 'CA' },
                    { label: 'Colorado', value: 'CO' },
                    { label: 'Connecticut', value: 'CT' },
                    { label: 'Delaware', value: 'DE' },
                    { label: 'District Of Columbia', value: 'DC' },
                    { label: 'Federated States Of Micronesia', value: 'FM' },
                    { label: 'Florida', value: 'FL' },
                    { label: 'Georgia', value: 'GA' },
                    { label: 'Guam', value: 'GU' },
                    { label: 'Hawaii', value: 'HI' },
                    { label: 'Idaho', value: 'ID' },
                    { label: 'Illinois', value: 'IL' },
                    { label: 'Indiana', value: 'IN' },
                    { label: 'Iowa', value: 'IA' },
                    { label: 'Kansas', value: 'KS' },
                    { label: 'Kentucky', value: 'KY' },
                    { label: 'Louisiana', value: 'LA' },
                    { label: 'Maine', value: 'ME' },
                    { label: 'Marshall Islands', value: 'MH' },
                    { label: 'Maryland', value: 'MD' },
                    { label: 'Massachusetts', value: 'MA' },
                    { label: 'Michigan', value: 'MI' },
                    { label: 'Minnesota', value: 'MN' },
                    { label: 'Mississippi', value: 'MS' },
                    { label: 'Missouri', value: 'MO' },
                    { label: 'Montana', value: 'MT' },
                    { label: 'Nebraska', value: 'NE' },
                    { label: 'Nevada', value: 'NV' },
                    { label: 'New Hampshire', value: 'NH' },
                    { label: 'New Jersey', value: 'NJ' },
                    { label: 'New Mexico', value: 'NM' },
                    { label: 'New York', value: 'NY' },
                    { label: 'North Carolina', value: 'NC' },
                    { label: 'North Dakota', value: 'ND' },
                    { label: 'Northern Mariana Islands', value: 'MP' },
                    { label: 'Ohio', value: 'OH' },
                    { label: 'Oklahoma', value: 'OK' },
                    { label: 'Oregon', value: 'OR' },
                    { label: 'Palau', value: 'PW' },
                    { label: 'Pennsylvania', value: 'PA' },
                    { label: 'Puerto Rico', value: 'PR' },
                    { label: 'Rhode Island', value: 'RI' },
                    { label: 'South Carolina', value: 'SC' },
                    { label: 'South Dakota', value: 'SD' },
                    { label: 'Tennessee', value: 'TN' },
                    { label: 'Texas', value: 'TX' },
                    { label: 'Utah', value: 'UT' },
                    { label: 'Vermont', value: 'VT' },
                    { label: 'Virgin Islands', value: 'VI' },
                    { label: 'Virginia', value: 'VA' },
                    { label: 'Washington', value: 'WA' },
                    { label: 'West Virginia', value: 'WV' },
                    { label: 'Wisconsin', value: 'WI' },
                    { label: 'Wyoming', value: 'WY' },
                    {
                      label: 'Armed Forces Americas(Except Cananda)',
                      value: 'AA',
                    },
                    { label: 'Armed Forces Africa', value: 'AE' },
                    { label: 'Armed Forces Pacific', value: 'AP' },
                  ],
                  validators: ['required'],
                },
                {
                  mask: 'number',
                  prop: 'zipcode',
                  type: 'text',
                  label: 'ZIP Code',
                  validators: ['required'],
                },
              ],
            },
            dental_questions: {
              hidden: true,
              controls: [
                {
                  prop: 'current_dental_coverage',
                  type: 'radio',
                  label:
                    'Do you currently have dental coverage through Blue Shield?',
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                  validators: ['required'],
                  conditionalControls: [
                    {
                      prop: 'dental_plan_name',
                      type: 'inputNA',
                      label: 'Plan Name',
                      naLabel: 'I do not know the plan name',
                      inputValidators: ['required'],
                    },
                    {
                      prop: 'dental_subscriber_id',
                      type: 'inputNA',
                      label: 'Subscriber ID',
                      naLabel: 'I do not know the number',
                      maxLength: 12,
                      inputValidators: ['required'],
                    },
                  ],
                },
                {
                  prop: 'current_vision_coverage',
                  type: 'radio',
                  label:
                    'Do you currently have vision coverage through Blue Shield?',
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                  validators: ['required'],
                  conditionalControls: [
                    {
                      prop: 'vision_plan_name',
                      type: 'inputNA',
                      label: 'Plan Name',
                      naLabel: 'I do not know the plan name',
                      inputValidators: ['required'],
                    },
                    {
                      prop: 'vision_subscriber_id',
                      type: 'inputNA',
                      label: 'Subscriber ID',
                      naLabel: 'I do not know the number',
                      inputValidators: ['required'],
                    },
                  ],
                },
                {
                  prop: 'current_medical_coverage',
                  type: 'radio',
                  label:
                    'Do you currently have medical coverage through Blue Shield?',
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                  validators: ['required'],
                  conditionalControls: [
                    {
                      prop: 'medical_plan_name',
                      type: 'inputNA',
                      label: 'Plan Name',
                      naLabel: 'I do not know the plan name',
                      inputValidators: ['required'],
                    },
                    {
                      prop: 'medical_subscriber_id',
                      type: 'inputNA',
                      label: 'Subscriber ID',
                      naLabel: 'I do not know the number',
                      inputValidators: ['required'],
                    },
                  ],
                },
              ],
            },
            permanent_address: {
              title: 'Home Address',
              hidden: true,
              controls: [
                {
                  prop: 'address_1',
                  type: 'text',
                  label: 'Street Address',
                  validators: ['required'],
                },
                {
                  prop: 'address_2',
                  type: 'text',
                  label: 'Apartment, suite, etc.',
                },
                {
                  prop: 'city',
                  type: 'text',
                  label: 'City',
                  validators: ['required'],
                },
                {
                  prop: 'state',
                  type: 'dropdown',
                  label: 'State',
                  options: [{ label: 'California', value: 'CA' }],
                  readonly: true,
                  validators: ['required'],
                },
                {
                  prop: 'zipcode',
                  type: 'text',
                  label: 'ZIP Code',
                  readonly: true,
                  validators: ['required'],
                },
              ],
            },
            different_mailing_address: {
              controls: [
                {
                  prop: 'different_mailing_address',
                  type: 'radio',
                  label: 'Different mailing address?',
                  default: false,
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                },
              ],
            },
          },
          label: 'Personal Information',
          title: 'Your application information',
          validatePrepopulatedAddress: false,
        },
        plan_selection: {
          type: 'plan_selection',
          label: 'Select Plan',
          filters: {
            controls: [
              {
                prop: 'ordering',
                type: 'radio',
                label: 'Sort by',
                options: [
                  { label: 'Lowest Monthly Premium', value: 'price' },
                  { label: 'Lowest Deductible', value: 'deductible' },
                ],
              },
              {
                prop: 'display_name',
                type: 'radio',
                label: 'Sort by plan',
                options: [
                  { label: 'Gold', value: 'gold' },
                  { label: 'Silver', value: 'silver' },
                  { label: 'Bronze', value: 'bronze' },
                  { label: 'Catastrophic', value: 'catastrophic' },
                ],
              },
              {
                prop: 'price',
                type: 'radio',
                label: 'Monthly Premium',
                options: [
                  {
                    label: '$100 - $299',
                    value: { price_low: 100, price_high: 299 },
                  },
                  {
                    label: '$300 - $549',
                    value: { price_low: 300, price_high: 549 },
                  },
                  {
                    label: '$550 - $749',
                    value: { price_low: 550, price_high: 749 },
                  },
                  {
                    label: '$750 - $999',
                    value: { price_low: 750, price_high: 999 },
                  },
                  { label: '$1,000+', value: { price_low: 1000 } },
                ],
              },
              {
                prop: 'deductible',
                type: 'radio',
                label: 'Deductible',
                options: [
                  {
                    label: '$550 - $2,000',
                    value: { deductible_low: 550, deductible_high: 2000 },
                  },
                  {
                    label: '$3,000 - $5,000',
                    value: { deductible_low: 3000, deductible_high: 5000 },
                  },
                  {
                    label: '$6,000 - $8,150',
                    value: { deductible_low: 6000, deductible_high: 8150 },
                  },
                ],
              },
            ],
          },
          planTypes: [
            {
              prop: 'medical',
              label: 'Plans with Subsidies',
              subProp: 'subsidy',
            },
            {
              prop: 'medical',
              label: 'Plans without Subsidies',
              subProp: 'not-subsidy',
            },
          ],
          showCompare: true,
          showFilters: true,
          showNewCard: true,
          subsidyText: {
            subsidyLabel: 'with a ${subsidyAmount} subsidy',
            originalPriceLabel: '(Originally ${originalPrice})',
          },
          compare_plans: {
            text: {
              all: 'All',
              benefits: 'Benefits',
              back_to_plans: 'Back to All Plans',
              monthly_premium: 'Monthy Premium',
            },
            preselectRenewalPlanCompare: false,
            preselectRenewalPlanCompareHeader: 'Current Plan',
          },
          isAccordionOpen: true,
          showPlanDetails: true,
          extraPlanFilters: { market_segment: 'individual' },
          hideFilterFooter: true,
          responsiveFilters: true,
          showEditInfoWidget: true,
          singlePlanSelection: {
            text: {
              headerSubtitle:
                "Here's the Friday plans that are available to you. Questions? We've got you covered! Call us at 844-451-4444 8am - 6pm Mountain Time.",
            },
            plan_details: {
              showLinks: true,
              omnia_note:
                'Note: You are viewing OMNIA Tier 1 benefits. You doctor must be in this network to receive this benefit.',
              find_doctor: {
                link: 'https://providersearch.fridayhealthplans.com/',
                label: 'Find a Doctor',
              },
              summary_benefits: { label: 'View Summary of Plan Benefits' },
              displayAllDocuments: true,
            },
          },
          hideStandaloneDental: true,
          multi_plan_selection: {
            text: {
              no_results: 'NO RESULTS',
              you_selected: "You've Selected:",
            },
          },
          setTabAsPerSubsidyAmount: false,
          footerNextButtonDisplayText: 'Next',
          getPlansCountyCodeParamProp: 'county_location.county_code',
        },
        quoteEditPanel: { openSpecifiedAccordiansOnInit: true },
        year_over_year: {
          text: {
            time_to_renew: "It's time to renew your plan!",
            similar_plan_header:
              "Your current plan has been discontinued, but we've found a similar plan for you to consider",
            edited_members_header:
              "Here's how your plan has changed from last year.",
            change_plan_or_options:
              'Want to change your plan, or see more options?',
            similar_plan_subheader:
              'You current plan is not being continued in 2019, but the suggested plan below is similar to your current plan in terms of premiums, deductible, and coverage.',
            no_matching_plan_header: 'Your current plan has been discontinued.',
            no_matching_plan_subheader:
              "You'll need to shop for a new plan in order to continue coverage into 2019.",
            heres_how_this_years_plan_compares:
              "Here's how this year's renewal plan compares to your current plan.",
          },
          showBackButton: true,
          nextButtonConfig: { content: null },
          selectOrChoosePlanToggleControl: {
            prop: 'chooseDiffPlan',
            type: 'toggle',
            options: [
              { label: 'Select This Plan For Renewal', value: false },
              { label: 'Choose a Different Plan', value: true },
            ],
          },
          comparisonCardsPlanTypeDisplayOrder: ['medical', 'dental', 'vision'],
        },
      },
      enrollment: {
        login: {
          page: 'login',
          layout: 'banner',
          layoutOptions: {
            title:
              "Our not-for-profit status allows us to focus on our mission — caring more for our members than 'the bottom line.",
            header: {
              icon: 'https://zipari-uploads-dev.s3.amazonaws.com/multitenant/files/d40fa16f-4759-4c7f-a2af-61ef3765b7b9.png',
              text: 'Our not-for-profit status allows us to focus on our mission — caring more for our members than the bottom line.',
            },
            heroImg:
              'https://zipari-uploads-dev.s3.amazonaws.com/multitenant/files/f5d8fe90-b44f-4aae-91ca-7bdc66191369.png',
            sections: [
              {
                text: 'We offer access to more than 1 million physicians, provider facilities, hospitals and other care centers in our provider networks <br><br> Search for a doctor, facility or pharmacy by name or provider type. today.',
                type: 'text',
                title: 'Find a Doctor',
              },
              {
                list: [
                  { text: 'Expansive provider network' },
                  { text: 'Health & Wellness Program' },
                  { text: 'Experienced Customer Support Team' },
                ],
                type: 'list',
                title: 'Why Branch Health',
              },
              {
                type: 'links',
                links: [
                  {
                    url: 'www.google.com',
                    label: 'Individual & Family Plans >',
                  },
                  { url: 'www.google.com', label: 'Employer Plans >' },
                  {
                    url: 'www.google.com',
                    label: 'Medicare Supplement Plans >',
                  },
                  { url: 'www.google.com', label: 'Dental Plans >' },
                ],
                title: 'Need Health Insurance?',
                description:
                  'Check out our complete listing of plans for families and individuals:',
              },
            ],
          },
          authCardOptions: {
            form: {
              title: '',
              controls: [
                {
                  prop: 'username',
                  type: 'text',
                  label: 'Username',
                  maxLength: 40,
                  validators: [
                    'required',
                    { name: 'minCount', dependency: 6 },
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                      ],
                    },
                  ],
                },
                {
                  link: 'Forgot Password?',
                  prop: 'password',
                  type: 'password',
                  label: 'Password',
                  validators: [
                    'required',
                    { name: 'minCount', dependency: 8 },
                    { name: 'not_match', dependency: 'username' },
                    { name: 'blacklistCharacters', dependency: [] },
                  ],
                },
              ],
            },
            title: 'Welcome Back!',
            footer: {
              link: { prop: 'register', label: 'Not Yet Registered?' },
              button: { icon: '', level: 'high', content: 'Log In' },
            },
            subtitle:
              'Please log in with your new account to continue your application.',
          },
          routeAfterSuccessConfig: {
            id: 'id',
            route: 'shopping/workbench/',
            checkApplication: true,
          },
        },
        review: {
          label: 'Review',
          title: 'Please Review Your Application',
          button: { level: 'high', content: 'Submit' },
          subtitle: '',
          reviewCards: [
            {
              icon: 'coverage',
              label: 'Coverages & Members',
              sections: [
                {
                  prop: null,
                  label: 'Coverage',
                  attributes: [
                    {
                      prop: 'demographics.displayCoverageType',
                      label: 'Coverage Type',
                      format: 'SNAKE_CASE_TO_TITLE',
                    },
                    {
                      prop: 'coverage_effective_date',
                      label: 'Coverage Start Date',
                      format: 'DATE',
                    },
                    { prop: 'permanent_address.zipcode', label: 'ZIP Code' },
                    { prop: 'county_location.county_name', label: 'County' },
                  ],
                },
                {
                  prop: 'subscriber.date_of_birth',
                  label: 'Subscriber',
                  attributes: [
                    { prop: 'subscriber', label: 'Name', format: 'FULL_NAME' },
                    {
                      prop: 'subscriber.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    {
                      prop: 'subscriber.gender',
                      label: 'Gender',
                      format: 'SNAKE_CASE_TO_TITLE',
                    },
                    {
                      prop: 'subscriber.tobacco_user',
                      label: 'Tobacco User',
                      format: 'YES_NO',
                      noValueMessage: 'HIDE',
                    },
                  ],
                },
                {
                  prop: 'spouse.date_of_birth',
                  label: 'Spouse',
                  attributes: [
                    { prop: 'spouse', label: 'Name', format: 'FULL_NAME' },
                    {
                      prop: 'spouse.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    {
                      prop: 'spouse.gender',
                      label: 'Gender',
                      format: 'SNAKE_CASE_TO_TITLE',
                    },
                    {
                      prop: 'spouse.tobacco_user',
                      label: 'Tobacco User',
                      format: 'YES_NO',
                      noValueMessage: 'HIDE',
                    },
                  ],
                },
                {
                  prop: 'dependents',
                  label: 'Dependent ${displayIndex}',
                  arrayProp: 'dependents',
                  attributes: [
                    {
                      prop: 'dependents.${index}',
                      label: 'Name',
                      format: 'FULL_NAME',
                    },
                    {
                      prop: 'dependents.${index}.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    {
                      prop: 'dependents.${index}.gender',
                      label: 'Gender',
                      format: 'SNAKE_CASE_TO_TITLE',
                    },
                    {
                      prop: 'dependents.${index}.tobacco_user',
                      label: 'Tobacco User',
                      format: 'YES_NO',
                      noValueMessage: 'HIDE',
                    },
                  ],
                },
              ],
              stepIndex: 1,
            },
            {
              icon: 'care',
              type: 'plan',
              label: 'Selected Plan',
              stepIndex: 2,
            },
            {
              type: 'pcp',
              label: 'Primary Care Physician (PCP)',
              stepIndex: 7,
            },
            { type: 'pcc', label: 'Primary Care Clinic (PCC)', stepIndex: 7 },
            {
              prop: 'special_enrollment',
              type: 'specialEnrollment',
              label: 'Special Enrollment',
              sections: [
                {
                  label: '',
                  attributes: [
                    { prop: 'special_enrollment.reason', label: 'Reason' },
                    { prop: 'special_enrollment.qle', label: 'Code' },
                    {
                      prop: 'special_enrollment.date',
                      label: 'Date',
                      format: 'DATE',
                    },
                  ],
                },
              ],
            },
            {
              icon: 'profile',
              label: 'Personal Information',
              sections: [
                {
                  label: 'Address',
                  attributes: [
                    {
                      prop: 'permanent_address.street_name_1',
                      label: 'Address 1',
                    },
                    { prop: 'permanent_address.street_name_2', label: 'Apt' },
                    {
                      prop: 'permanent_address.city',
                      label: 'City',
                      format: 'SNAKE_CASE_TO_TITLE',
                    },
                    { prop: 'permanent_address.state', label: 'State' },
                    { prop: 'permanent_address.zipcode', label: 'ZIP Code' },
                  ],
                },
                {
                  label: 'Billing Address',
                  attributes: [
                    { prop: 'billing_address.address_1', label: 'Address 1' },
                    { prop: 'billing_address.address_2', label: 'Apt' },
                    {
                      prop: 'billing_address.city',
                      label: 'City',
                      format: 'SNAKE_CASE_TO_TITLE',
                    },
                    { prop: 'billing_address.state', label: 'State' },
                    { prop: 'billing_address.zipcode', label: 'ZIP Code' },
                  ],
                },
                {
                  label: 'Mailing Address',
                  attributes: [
                    { prop: 'mailing_address.address_1', label: 'Address 1' },
                    { prop: 'mailing_address.address_2', label: 'Apt' },
                    {
                      prop: 'mailing_address.city',
                      label: 'City',
                      format: 'SNAKE_CASE_TO_TITLE',
                    },
                    { prop: 'mailing_address.state', label: 'State' },
                    { prop: 'mailing_address.zipcode', label: 'ZIP Code' },
                  ],
                },
                {
                  label: 'Contact',
                  attributes: [
                    { prop: 'contact.phone', label: 'Phone Number' },
                    {
                      prop: 'contact.email',
                      label: 'Email Address',
                      format: 'VALUE_MAP',
                    },
                    {
                      prop: 'spouse.email_address',
                      label: 'Spouse Email Address',
                      format: 'VALUE_MAP',
                    },
                  ],
                },
              ],
              stepIndex: 5,
            },
            { type: 'attestations' },
            { type: 'signature' },
          ],
          planTypeOrder: ['medical', 'bundled', 'dental', 'vision'],
          termsOfService: [
            {
              header: 'Authorization for Release of Information',
              sections: [
                {
                  header: 'Completing Your Application:',
                  paragraphs: [
                    "You and each applying family member listed below must scroll to the bottom of the information and check the box by your name to verify that you've read and agree with the information below. By signing this form, you are authorizing the release of your and/or your dependents? healthcare information by a healthcare provider, insurer, insurance support organization, health plan, or your insurance agent to Blue Shield of California or Blue Shield of California Life & Health Insurance Company (collectively, Blue Shield) for the purpose of processing claims and for administering benefits under the health service agreement/policy.",
                    'Further, by signing below you are authorizing Blue Shield to disclose such healthcare information to a healthcare provider, insurer, self-insurer, insurance support organization, health plan, or your insurance agent for the purpose of investigating or evaluating any claim for benefits. The healthcare information used or disclosed pursuant to this authorization may be subject to re-disclosure and may no longer be protected under the federal health information privacy laws.',
                    'You have the right to refuse to sign this authorization.',
                    'You are entitled to a copy of this authorization after you sign it.',
                  ],
                },
                {
                  header: 'Expiration:',
                  paragraphs: [
                    'This authorization will remain valid: 1) for thirty (30) months from the date of this authorization for the purposes of processing your application, processing a request for reinstatement, or processing a request for a change in benefits; 2) for as long as may be necessary for processing of claims incurred during the term of coverage; and 3) for the term of coverage for all other activities under the health service agreement/policy.',
                  ],
                },
                {
                  header: 'Right to Revoke:',
                  paragraphs: [
                    'I understand that I may revoke this authorization at any time by giving written notice of my revocation to Blue Shield. I understand that revocation of this authorization will not affect any action Blue Shield has taken in reliance on this authorization prior to receiving my written notice of revocation.',
                  ],
                },
              ],
              attestation:
                'I have read and agree to Authorization for Release of Information',
            },
            {
              header: 'Verification of Accuracy',
              sections: [
                {
                  header: 'Completing Your Application:',
                  paragraphs: [
                    "You and each applying family member listed below must scroll to the bottom of the information and check the box by your name to verify that you've read and agree with the information below.",
                    'I alone am responsible for the accuracy and completeness of the information provided on this application. I have personally reviewed all information provided on this application, even if I did not fill out the application myself. To the best of my knowledge and belief, all information on this application is accurate, true, and complete. If Blue Shield determines that there is fraud (by act, practice, or omission) or an intentional misrepresentation of material fact in the information on this application, I understand that coverage may be rescinded as allowed by law.',
                    'For applicants with a language preference other than English: If I indicated in Part 1 that I have a language preference other than English and have completed the English version of this application (or version other than in my language preference), I confirm that I understand the questions on this application.',
                  ],
                },
              ],
              attestation: 'I have read and agree to Verification of Accuracy',
            },
            {
              header: 'Verification of Terms',
              sections: [
                {
                  header: 'Completing Your Application:',
                  paragraphs: [
                    "You and each applying family member listed below must scroll to the bottom of the information and check the box by your name to verify that you've read and agree with the information below.",
                    'You also attest that either You, or an Acceptable Third Party Payor, are making and will make all future premium payments for your Blue Shield coverage in accordance with the Blue Shield Premium Payment Policy.',
                    '1. Application for coverage: It is important to know that Blue Shield of California or Blue Shield of California Life & Health Insurance Company (as applicable) may decline your application for coverage if you are not currently eligible. Your application must be approved by Blue Shield, and an effective date for coverage assigned, before coverage may become effective.',
                    "2. First month's dues/premiums: Blue Shield requires first month's dues/premium at the time of application submission. Find your estimated monthly dues/premiums in the rate book. Failure to submit full payment of dues/premiums will result in a return of your application. Please note that processing any payment does not constitute approval of your application with Blue Shield or Blue Shield Life. If you do not currently qualify for coverage, the dues/premium you submit with your application will not be processed.",
                    '3. Dues/premiums: Dues/premiums are to be paid in full by the due date. Coverage will be terminated for failure to pay dues/premiums in a timely manner as set forth in the health service agreement/policy and as allowed by law. The Subscriber is responsible for payment of dues/premiums to Blue Shield of California. Blue Shield of California does not accept direct or indirect payments of dues/premiums from any person or entity other than the Subscriber, his or her friends, family members or a legal guardian, or an "Acceptable Third Party Payor". Acceptable Third Party Payors are:',
                    ' • Ryan White HIV/AIDS programs under Title XXVI of the Public Health Services Act.',
                    ' • Indian tribes, tribal organizations or urban Indian organizations.',
                    ' • A lawful local, State, or Federal government program, including a grantee directed by a government program to make payments on its behalf.',
                    ' • Bona fide charitable organizations and organizations related to the Subscriber (i.e., church or employer) when the following is also true: payment is guaranteed for the plan year, assistance is provided based on defined financial status criteria and health status is not considered, the organization is unaffiliated with a healthcare provider, and the organization has no financial interest in the payment of a health plan claim. Financially interested institutions/organizations include institutions/organizations that receive the majority of their funding from entities with a pecuniary interest in the payment of health insurance claims, or institutions/organizations that are subject to direct or indirect control of entities with a pecuniary interest in the payment of health insurance claims.',
                    "Upon discovery that dues/premiums were paid directly or indirectly by a person or entity other than those listed above or the Subscriber, Blue Shield of California has the right to reject the payment and inform the Subscriber that the payment was not accepted and that the dues/premiums remain due. Processing any payment does not waive Blue Shield of California's right to reject that payment and future payments under this policy.",
                    '4. Effective date of coverage: If you qualify for coverage, Blue Shield will notify you of your effective date of coverage. If Blue Shield cannot honor your requested effective date, or is unable to issue coverage before your requested date, coverage will begin as soon as possible. If additional dues/premiums are owed, payment must be received before coverage becomes effective. Any charges incurred for services received prior to your effective date or after termination of coverage are not covered.',
                    '5. Acceptance of application: You understand that only Blue Shield can accept your application and issue coverage for an IFP plan requested on this form. Your agent or broker cannot enroll you for coverage or change any terms or conditions of coverage.',
                    '6. Parents/guardians: If you are the parent or legal guardian of an applicant who is a minor, please sign on behalf of the applicant at the bottom of this Part 5. As the parent or legal guardian, you are identified as the person who may make inquiries and act on behalf of the applicant regarding this coverage (as allowed by law). In addition, you are agreeing to assume all responsibility for dues/premiums payments and for following the terms and conditions for coverage. If you are not the parent of the applicant, please attach the court documents that appoint you as the guardian of this minor.',
                    '7. Process to authorize Blue Shield to release personal and health information to a third party: If you would like to authorize your spouse, domestic partner, or a third party to access your personal health information, please complete the form titled Authorization for Blue Shield to Disclose Personal & Health Information to a Third Party. To obtain this form, go to blueshieldca.com and click on the Privacy link at the bottom of the page, or call (800) 431-2809.',
                    '8. Response to requested information: You agree to cooperate with Blue Shield (or Blue Shield Life, as applicable) by providing, or by providing access to, documents and other information requested (such as court orders to provide dependent coverage, etc.) to corroborate information provided in this application for coverage. You acknowledge and agree that failure or refusal to provide these documents or the information requested may be cause to rescind or cancel your coverage.',
                    '9. HIV or genetic testing prohibited: No genetic information, including family medical history, and no information related to HIV testing should be provided. California law prohibits an HIV test from being required or used by a health insurance company or healthcare service plan as a condition of obtaining health coverage.',
                  ],
                },
              ],
              attestation: 'I have read and agree to Verification of Terms',
            },
            {
              header:
                'Acknowledgement of Receiving the Summary of Benefits and Coverage',
              sections: [
                {
                  header: 'Completing Your Application:',
                  paragraphs: [
                    "You and each family member listed below must check the box by your name to acknowledge that you've received and read the Summary of Benefits and Coverage forms.",
                    'Choosing a health coverage option is an important choice. Summary of Benefits and Coverage (SBC) forms are uniform templates and provide you with an easy way to understand your coverage.',
                    'Find definitions for commonly used medical and insurance terms at the Health and Human Services glossary.',
                  ],
                },
              ],
              attestation:
                'I have received and read Acknowledgement of Receiving the Summary of Benefits and Coverage',
            },
          ],
          signatureConfig: [
            {
              mask: 'alpha',
              prop: 'first',
              type: 'text',
              label: 'First Name',
              errors: {
                equals: 'First name must equals the name you provided',
              },
              maxLength: 15,
              validators: [
                {
                  name: 'blacklistCharacters',
                  dependency: [
                    '!',
                    '@',
                    '#',
                    '$',
                    '%',
                    '^',
                    '&',
                    '(',
                    ')',
                    '_',
                    '+',
                    '"',
                    '/',
                    '\\',
                    '[',
                    ']',
                    '{',
                    '}',
                    ':',
                    ';',
                    '|',
                    '=',
                    ',',
                    '*',
                    '?',
                    '<',
                    '>',
                    '.',
                    '~',
                    '`',
                    '0',
                    '1',
                    '2',
                    '3',
                    '4',
                    '5',
                    '6',
                    '7',
                    '8',
                    '9',
                  ],
                },
                'required',
                { name: 'equals' },
              ],
            },
            {
              prop: 'middle',
              type: 'text',
              label: 'Middle',
              errors: {
                equals: 'Middle name must equals the name you provided',
              },
              maxLength: 1,
              validators: [{ name: 'equals' }],
            },
            {
              prop: 'last',
              type: 'text',
              label: 'Last Name',
              errors: { equals: 'Last name must equals the name you provided' },
              maxLength: 15,
              validators: ['required', { name: 'equals' }],
            },
            {
              prop: 'date',
              type: 'text',
              label: "Today's Date",
              default: 'CURRENT_DATE',
              isDisabled: true,
              validators: ['required'],
            },
            {
              prop: 'signature',
              type: 'singleCheckbox',
              errors: { required: 'Signature verification is required.' },
              boldText: true,
              validators: ['required', 'requiredTrue'],
              checkboxLabel:
                'I verify that this is my electronic signature made with the intent to sign this application and confirm that no other person has made this signature on my behalf.',
              requiredLabel: '*',
              showCheckboxLabelRequired: true,
            },
          ],
          editConfirmation: {
            modalConfig: {
              type: 'popup',
              backdrop: 'true',
              bodyText:
                'You are about to navigate to a previous step in the application',
            },
            footerButtons: {
              okay: { level: 'high', content: 'Okay' },
              cancel: { level: 'medium', content: 'Cancel' },
            },
          },
          allowEditInformation: false,
          windowShoppingSubmitMessage: {
            icon: 'warning',
            type: 'warning',
            enabled: false,
            message:
              'Your application cannot be submitted until the Open Enrollment Period has begun. Please visit us on or after ${openEnrollmentStartDate} to complete your submission, and make your payment to secure your coverage.',
            preventSubmit: true,
          },
        },
        billing: {
          tabs: ['Credit Card', 'Electronic Fund Transfer'],
          text: {
            submit: 'Submit Payment',
            summary: 'Summary',
            effective: 'Effective',
            purchasing: 'Purchasing',
            credit_card: 'Credit Card',
            payment_method: 'Payment Method',
            initial_payment: 'Initial Payment',
            checking_account: 'Checking Account',
            recurring_payments: 'Recurring Payments',
            accepted_card_types: 'Accepted Card Types',
            edit_payment_method: 'Edit Payment Method',
            total_monthly_premium: 'Total Monthly Premium',
          },
          type: 'billing',
          label: 'Billing Information',
          messages: {
            error: 'Please verify the payment details and submit again.',
            openWindow:
              'A window will open where you can enter your payment details.',
            timeoutErrorTitle: '',
            timeoutErrorMessage:
              "We're sorry, your payment session has expired. Please select 'Make Initial Payment' to continue making your payment.",
          },
          cardTypes: {
            visa: 'https://zipari-uploads-dev.s3.amazonaws.com/files/ee66fd68-7df9-4f85-bb1f-2e6e2d0d5930.png',
            master:
              'https://zipari-uploads-dev.s3.amazonaws.com/files/39677ada-fe70-425c-a564-50ede0265a07.png',
            discover:
              'https://zipari-uploads-dev.s3.amazonaws.com/files/4a38a409-665b-4b03-a4d0-b8db0f38396b.png',
          },
          bankControls: [
            {
              grid: { col: '1 / 3', row: '1' },
              prop: 'name_of_bank',
              type: 'text',
              label: 'Name of Bank/Financial Institution',
              validators: ['required'],
            },
            {
              grid: { col: '3 / 5', row: '1' },
              prop: 'bankType',
              type: 'dropdown',
              label: 'Account Type',
              default: '',
              options: [
                { label: 'Checking', value: 'checking' },
                { label: 'Savings', value: 'saving' },
              ],
              validators: ['required'],
            },
            {
              grid: { col: '1 / 3', row: '2' },
              prop: 'routing_number',
              type: 'number',
              label: 'Routing Number',
              tooltip:
                "This is a 9 digit number that identifies your BANK or credit CARD union. You can usually find this on a BANK statement, the bottom left corner of your personal checks, or via your BANK's website and customer service line.",
              validators: ['required', 'routingNumber'],
            },
            {
              grid: { col: '3 / 5', row: '2' },
              prop: 'account_number',
              type: 'number',
              label: 'Account Number',
              validators: ['required', 'bankAccountNumber'],
            },
            {
              grid: { col: '1 / 3', row: '3' },
              prop: 'first_name',
              type: 'text',
              label: 'First Name on Account',
              validators: ['required'],
            },
            {
              grid: { col: '3 / 5', row: '3' },
              prop: 'last_name',
              type: 'text',
              label: 'Last Name on Account',
              validators: ['required'],
            },
            {
              grid: { col: '1 / 3', row: '4' },
              prop: 'address_line1',
              type: 'text',
              label: "Account Holder's Address Line1",
              validators: ['required'],
            },
            {
              grid: { col: '3 / 5', row: '4' },
              prop: 'address_line2',
              type: 'text',
              label: "Account Holder's Address Line2",
            },
            {
              grid: { col: '1 / 3', row: '5' },
              prop: 'city',
              type: 'text',
              label: "Account Holder's City",
              validators: ['required'],
            },
            {
              grid: { col: '3 / 5', row: '5' },
              prop: 'account_holder_state',
              type: 'dropdown',
              label: "Account Holder's State",
              options: [
                { label: 'Alabama', value: 'AL' },
                { label: 'Alaska', value: 'AK' },
                { label: 'American Samoa', value: 'AS' },
                { label: 'Arizona', value: 'AZ' },
                { label: 'Arkansas', value: 'AR' },
                { label: 'California', value: 'CA' },
                { label: 'Colorado', value: 'CO' },
                { label: 'Connecticut', value: 'CT' },
                { label: 'Delaware', value: 'DE' },
                { label: 'District Of Columbia', value: 'DC' },
                { label: 'Federated States Of Micronesia', value: 'FM' },
                { label: 'Florida', value: 'FL' },
                { label: 'Georgia', value: 'GA' },
                { label: 'Guam', value: 'GU' },
                { label: 'Hawaii', value: 'HI' },
                { label: 'Idaho', value: 'ID' },
                { label: 'Illinois', value: 'IL' },
                { label: 'Indiana', value: 'IN' },
                { label: 'Iowa', value: 'IA' },
                { label: 'Kansas', value: 'KS' },
                { label: 'Kentucky', value: 'KY' },
                { label: 'Louisiana', value: 'LA' },
                { label: 'Maine', value: 'ME' },
                { label: 'Marshall Islands', value: 'MH' },
                { label: 'Maryland', value: 'MD' },
                { label: 'Massachusetts', value: 'MA' },
                { label: 'Michigan', value: 'MI' },
                { label: 'Minnesota', value: 'MN' },
                { label: 'Mississippi', value: 'MS' },
                { label: 'Missouri', value: 'MO' },
                { label: 'Montana', value: 'MT' },
                { label: 'Nebraska', value: 'NE' },
                { label: 'Nevada', value: 'NV' },
                { label: 'New Hampshire', value: 'NH' },
                { label: 'New Jersey', value: 'NJ' },
                { label: 'New Mexico', value: 'NM' },
                { label: 'New York', value: 'NY' },
                { label: 'North Carolina', value: 'NC' },
                { label: 'North Dakota', value: 'ND' },
                { label: 'Northern Mariana Islands', value: 'MP' },
                { label: 'Ohio', value: 'OH' },
                { label: 'Oklahoma', value: 'OK' },
                { label: 'Oregon', value: 'OR' },
                { label: 'Palau', value: 'PW' },
                { label: 'Pennsylvania', value: 'PA' },
                { label: 'Puerto Rico', value: 'PR' },
                { label: 'Rhode Island', value: 'RI' },
                { label: 'South Carolina', value: 'SC' },
                { label: 'South Dakota', value: 'SD' },
                { label: 'Tennessee', value: 'TN' },
                { label: 'Texas', value: 'TX' },
                { label: 'Utah', value: 'UT' },
                { label: 'Vermont', value: 'VT' },
                { label: 'Virgin Islands', value: 'VI' },
                { label: 'Virginia', value: 'VA' },
                { label: 'Washington', value: 'WA' },
                { label: 'West Virginia', value: 'WV' },
                { label: 'Wisconsin', value: 'WI' },
                { label: 'Wyoming', value: 'WY' },
                { label: 'Armed Forces Americas(Except Cananda)', value: 'AA' },
                { label: 'Armed Forces Africa', value: 'AE' },
                { label: 'Armed Forces Pacific', value: 'AP' },
              ],
              validators: ['required'],
            },
            {
              grid: { col: '1 / 3', row: '6' },
              mask: 'number',
              prop: 'account_holder_zipcode',
              type: 'text',
              label: "Account Holder's ZIP Code",
              maxLength: 5,
              validators: ['required', 'zipcode'],
            },
            {
              grid: { col: '1 / 5', row: '7' },
              prop: 'eft_ongoing_payment_option',
              type: 'radio',
              label: 'Please select an ongoing payment option',
              options: [
                {
                  label:
                    'Yes, I agree to recurring automatic EFT drafts for my ongoing monthly payments but would like to use a different bank account than what I provided for my initial payment (No paper or electronic monthly billing statements will be issued.)',
                  value: 'eft_different_bank',
                },
                {
                  label:
                    'Monthly Electronic Bill (eBill): Yes, I agree that I am responsible for initiating my ongoing electronic monthly payments. I am requesting monthly electronic bills (eBIlls) to be sent to my email account as provided in this application.',
                  value: 'credit_card_monthly_payments_eft',
                },
                {
                  label:
                    'Alternate Account: Yes, I agree to recurring automatic EFT drafts for my ongoing monthly payments but would like to use a different bank account than what I provided for my initial payment (No paper or electronic monthly billing statements will be issued.)',
                  value: 'eft_agree',
                },
              ],
              validators: ['required'],
            },
            {
              grid: { col: '1 / 5', row: '8' },
              prop: 'eft_attestation',
              type: 'checkbox',
              label: 'EFT Disclaimer',
              errors: { arrayHasValue: 'Must be selected to proceed' },
              options: [
                {
                  label: 'I have read and agree to the EFT Disclaimer',
                  value: 'Agree',
                },
              ],
              validators: ['required', 'arrayHasValue'],
            },
          ],
          cardControls: [
            {
              grid: { col: '1 / 3', row: '1' },
              prop: 'card__type',
              type: 'radio',
              label: 'Type',
              options: [
                { label: 'Visa', value: 'visa' },
                { label: 'Mastercard', value: 'mastercard' },
              ],
              validators: ['required'],
            },
            {
              grid: { col: '1 / 5', row: '2' },
              icon: null,
              prop: 'number',
              type: 'text',
              label: 'Credit Card Number',
              iconRight: 'locked',
              maxLength: 16,
              validators: ['required', 'cardNumber'],
            },
            {
              grid: { col: '1 / 3', row: '3' },
              mask: 'number',
              prop: 'cvv',
              type: 'text',
              label: 'CVV Security Code',
              maxLength: 3,
              validators: ['required'],
            },
            {
              max: '9999-01',
              grid: { col: '3 / 5', row: '3' },
              prop: 'expiration',
              type: 'month',
              label: 'Card Expiration Date',
              validators: [
                'required',
                'reasonableDate',
                'dateInFutureIncludingCurrentMonth',
              ],
            },
            {
              grid: { col: '1 / 5', row: '4' },
              mask: 'alpha',
              prop: 'first_name',
              type: 'text',
              label:
                "Cardholder's First Name - exactly as it appears on the card",
              maxLength: 15,
              validators: ['required', 'alpha'],
            },
            {
              grid: { col: '1 / 5', row: '5' },
              mask: 'alpha',
              prop: 'last_name',
              type: 'text',
              label:
                "Cardholder's Last Name - exactly as it appears on the card",
              maxLength: 15,
              validators: ['required', 'alpha'],
            },
            {
              grid: { col: '1 / 3', row: '6' },
              prop: 'address_line1',
              type: 'text',
              label: "Account Holder's Address Line1",
              validators: ['required'],
            },
            {
              grid: { col: '3 / 5', row: '6' },
              prop: 'address_line2',
              type: 'text',
              label: "Account Holder's Address Line2",
            },
            {
              grid: { col: '1 / 3', row: '7' },
              prop: 'city',
              type: 'text',
              label: "Account Holder's City",
              validators: ['required'],
            },
            {
              grid: { col: '3 / 5', row: '7' },
              prop: 'state',
              type: 'dropdown',
              label: "Account Holder's State",
              options: [
                { label: 'Alabama', value: 'AL' },
                { label: 'Alaska', value: 'AK' },
                { label: 'American Samoa', value: 'AS' },
                { label: 'Arizona', value: 'AZ' },
                { label: 'Arkansas', value: 'AR' },
                { label: 'California', value: 'CA' },
                { label: 'Colorado', value: 'CO' },
                { label: 'Connecticut', value: 'CT' },
                { label: 'Delaware', value: 'DE' },
                { label: 'District Of Columbia', value: 'DC' },
                { label: 'Federated States Of Micronesia', value: 'FM' },
                { label: 'Florida', value: 'FL' },
                { label: 'Georgia', value: 'GA' },
                { label: 'Guam', value: 'GU' },
                { label: 'Hawaii', value: 'HI' },
                { label: 'Idaho', value: 'ID' },
                { label: 'Illinois', value: 'IL' },
                { label: 'Indiana', value: 'IN' },
                { label: 'Iowa', value: 'IA' },
                { label: 'Kansas', value: 'KS' },
                { label: 'Kentucky', value: 'KY' },
                { label: 'Louisiana', value: 'LA' },
                { label: 'Maine', value: 'ME' },
                { label: 'Marshall Islands', value: 'MH' },
                { label: 'Maryland', value: 'MD' },
                { label: 'Massachusetts', value: 'MA' },
                { label: 'Michigan', value: 'MI' },
                { label: 'Minnesota', value: 'MN' },
                { label: 'Mississippi', value: 'MS' },
                { label: 'Missouri', value: 'MO' },
                { label: 'Montana', value: 'MT' },
                { label: 'Nebraska', value: 'NE' },
                { label: 'Nevada', value: 'NV' },
                { label: 'New Hampshire', value: 'NH' },
                { label: 'New Jersey', value: 'NJ' },
                { label: 'New Mexico', value: 'NM' },
                { label: 'New York', value: 'NY' },
                { label: 'North Carolina', value: 'NC' },
                { label: 'North Dakota', value: 'ND' },
                { label: 'Northern Mariana Islands', value: 'MP' },
                { label: 'Ohio', value: 'OH' },
                { label: 'Oklahoma', value: 'OK' },
                { label: 'Oregon', value: 'OR' },
                { label: 'Palau', value: 'PW' },
                { label: 'Pennsylvania', value: 'PA' },
                { label: 'Puerto Rico', value: 'PR' },
                { label: 'Rhode Island', value: 'RI' },
                { label: 'South Carolina', value: 'SC' },
                { label: 'South Dakota', value: 'SD' },
                { label: 'Tennessee', value: 'TN' },
                { label: 'Texas', value: 'TX' },
                { label: 'Utah', value: 'UT' },
                { label: 'Vermont', value: 'VT' },
                { label: 'Virgin Islands', value: 'VI' },
                { label: 'Virginia', value: 'VA' },
                { label: 'Washington', value: 'WA' },
                { label: 'West Virginia', value: 'WV' },
                { label: 'Wisconsin', value: 'WI' },
                { label: 'Wyoming', value: 'WY' },
                { label: 'Armed Forces Americas(Except Cananda)', value: 'AA' },
                { label: 'Armed Forces Africa', value: 'AE' },
                { label: 'Armed Forces Pacific', value: 'AP' },
              ],
              validators: ['required'],
            },
            {
              grid: { col: '1 / 5', row: '8' },
              mask: 'number',
              prop: 'zipcode',
              type: 'text',
              label: "Account Holder's ZIP Code",
              maxLength: 5,
              validators: ['required', 'zipcode'],
            },
            {
              grid: { col: '1 / 5', row: '9' },
              prop: 'ongoing_payment_option',
              type: 'radio',
              label: 'Please select an ongoing payment option',
              options: [
                {
                  label:
                    'Yes, I agree to recurring automatic EFT drafts for my ongoing monthly payments. (No paper or electronic monthly billing statements will be issued.)',
                  value: 'credit_card_eft',
                },
                {
                  label:
                    'Monthly Electronic Bill (eBill): Yes, I agree that I am responsible for initiating my ongoing electronic monthly payments. I am requesting monthly electronic bills (eBIlls) to be sent to my email account as provided in this application.',
                  value: 'credit_card_monthly_payments_eft',
                },
              ],
              validators: ['required'],
            },
          ],
          planTypeOrder: ['medical', 'bundled', 'dental', 'vision'],
          planTypeMapping: { health: 'medical' },
          stubBillingCalls: true,
          billingHeaderText: {
            title: 'Make a Payment',
            subtitle:
              'You will get a confirmation message after submitting your payment information.',
          },
          billingInfoBanner: {
            icon: 'info_active',
            type: 'info',
            message:
              'Before submitting your payment, please take a moment to carefully review both your application information and payment details. Once payment is successfully submitted, you will not be able to go back and modify your application information and payment details.',
            messageHeading:
              'Important Note: Review Application and Payment Details',
          },
          billingErrorMessage: {
            title: 'We encountered an issue when processing your payment.',
            message: 'Billing address could not be verified',
          },
          applicationErrorMessage: {
            title:
              "Your payment was successfully submitted. However, we've encountered an error while submitting your application.",
            message:
              'Please try again later. If this error persists, please contact our customer services at (888) 273-0010',
          },
          defaultPaymentAttestation: {
            header: 'Privacy Policy',
            sections: [
              {
                header: 'INTRODUCTION:',
                paragraphs: [
                  'This Privacy Policy describes the types of "Personal Information" (information that is identifiable to a particular person) that is collected by BillMatrix Corporation as a service provider to your Biller (directly or through its service providers) in connection with the Site and the Service as defined in the “Terms and Conditions for Service” above, and how that  Personal Information is used, shared and protected. Some of this information is required by U.S. federal or other law.',
                ],
              },
              {
                header: 'ELIGIBILITY:',
                paragraphs: [
                  'The eligibility requirements for the Site and the Service are set forth above in the Eligibility section of the main body of the Agreement. We do not knowingly collect any Personal Information from or about individuals under 18 years of age. Please do not submit such information to us, and as a parent or legal guardian, please do not allow your children to submit personal information without your permission. By using the Site and/or the Service, you represent that you agree to the terms of this Privacy Policy.',
                ],
              },
              {
                header: 'COOKIES, BROWSER INFORMATION AND RELATED ISSUES:',
                paragraphs: [
                  'When you visit the Site, we may receive certain standard information that your browser sends to every website you visit, such as the originating IP address, browser type and language, access times and referring website addresses, and other such information. This data may be used, among other uses, to improve the operation of the Site and to improve the security of the Site and Service by assisting in "authenticating" who you are when you access the Site or Service.<br>We may also receive additional information about your visit to the Site, including the pages you view, the links you click and other actions you take in connection with the Site and the Services. This data may be used, among other uses, to improve the operation of the Site and the Service.<br>Like most websites, the Site also uses "cookies," which are small data files placed on your computer or other device by the web server when you visit the Site. Such cookies are "session" cookies that are only used for a specific period during   which you are on the Site (such as when you are going through the authentication process). The Site does not use “persistent” cookies (that stay on your computer after you have logged off the Site). Cookies cannot and will not be used to deliver or run programs on your computer. Most web browsers automatically accept cookies, but you can modify your browser settings to decline cookies if you prefer. However, if you choose to decline cookies, you may not be able to sign in or use other interactive features of the Site that depend on cookies.<br>With respect to personally identifiable information about an individual consumer\'s online activities over time and across different Web sites or online services when a consumer uses this Site, except as required by law: <br><br>(1) parties other than the operator of this Site are not permitted to collect such information, and <br>(2) the operator of this Site does not collect such information (except any such information that is reasonably necessary to process and document user transactions, such as payment history). Therefore, this Site has no need to respond and does not respond to Web browser "do not track" signals or other mechanisms that provide consumers the ability to exercise choice regarding the collection of such information.',
                ],
              },
              {
                header: 'WHAT TYPES OF PERSONAL INFORMATION WE MAY COLLECT:',
                paragraphs: [
                  'In addition to the types of information described in the "Cookies " section of this Policy, we may also collect Personal Information about you. This information may include:<br><br>•    Date of birth, name, postal address, e-mail address, telephone number, and other information that we can use to contact you, verify your identity, and manage risks, such as information maintained about you by identity verification services and consumer reporting agencies, including credit bureaus;<br>•    Bank account information for accounts that you designate for sending payments, fees, debits and credits for the Service, including any required routing information, account numbers, account balances and transaction history;<br>•    Billing account information, including billing account numbers which may be used to verify that only authorized users access the Services;<br>•    Payment and other transaction information, and history for payments through the Service; and<br>•    Any Personal Information that you may enter on the Site.',
                ],
              },
              {
                header: 'HOW WE MAY COLLECT PERSONAL INFORMATION ABOUT YOU:',
                paragraphs: [
                  'We may collect Personal Information about you from the following sources:<br>Your use of the Site and the Service (such as when you send a payment), and your interactions with customer care, including information you enter or speak, and information transmitted by your computer, cell phones and other devices you use to connect to or use the Site or Service; and<br>We also collect Personal Information about you from others, such as Biller, credit bureaus, Affiliates, or other companies (such as identity verification services, consumer reporting agencies, and companies that provide content, such as electronic bills, to the Site, or that use the Service).',
                ],
              },
              {
                table: {
                  data: [
                    {
                      limit: 'No',
                      share: 'Yes',
                      reason:
                        'For our everyday business purposes - such as to enable us and Biller to process your transactions, maintain your accounts, respond to court orders and legal investigations, and report to credit bureaus',
                    },
                    {
                      limit: 'No',
                      share: 'No',
                      reason:
                        'For our marketing purposes - to offer our products and services to you;',
                    },
                    {
                      limit: 'No',
                      share: 'No',
                      reason:
                        'For Joint Marketing with other financial companies',
                    },
                    {
                      limit: 'No',
                      share: 'Yes',
                      reason:
                        "For our Affiliates' everyday business purposes (information about your transactions and experiences)",
                    },
                    {
                      limit: 'We Do Not Share',
                      share: 'No',
                      reason:
                        "For our Affiliates' everyday business purposes (information about your creditworthiness)",
                    },
                    {
                      limit: 'We Do Not Share',
                      share: 'No',
                      reason: 'For our Affiliates to market to you',
                    },
                    {
                      limit: 'We Do Not Share',
                      share: 'No',
                      reason: 'For Non-Affiliates to market to you',
                    },
                  ],
                  config: {
                    paging: { enabled: false },
                    columns: [
                      {
                        name: 'Reasons we can share your Personal Information',
                        prop: 'reason',
                      },
                      { name: 'Do we share?', prop: 'share' },
                      { name: 'Can you limit this sharing?', prop: 'limit' },
                    ],
                  },
                },
                header: 'HOW WE MAY SHARE PERSONAL INFORMATION ABOUT YOU:',
                paragraphs: [
                  'We share Personal Information about you only as permitted by law. For Personal Information that is nonpublic and that we collect in connection with a financial service, U.S. federal law permits us to share such information only for the purposes shown in the following table:',
                ],
              },
              {
                header: 'HOW WE MAY USE PERSONAL INFORMATION ABOUT YOU:',
                paragraphs: [
                  'We use Personal Information about you only as permitted by law, including but not limited to:<br>Other everyday business purposes, such as to maintain your ability to access the Service, to authenticate you when you access the Site or Service to enable Biller to authenticate you when you pay your Billing Statement, to send  you information about the Service, to effect, administer and enforce transactions, to perform (and to enable Biller to perform) Anti-Money Laundering and fraud monitoring and screening, to prevent and investigate actual or potential fraud and unauthorized transactions, to verify your identity, to determine your credit history, to verify the information contained in your account, to perform collections, to report to credit bureaus (including furnishing delinquent account information), to comply with laws, regulations, court orders and lawful instructions from government agencies, to protect the personal safety of subscribers or the public, to prevent and defend claims, to resolve disputes, to troubleshoot problems, to enforce our   Terms and Conditions for Service, to protect our rights and property, and to customize, measure, and improve the Services and the content and layout of the Site including pattern recognition, modeling, enhancement and improvement, system analysis, and Service performance analysis.',
                ],
              },
              {
                header: 'OTHER IMPORTANT INFORMATION:',
                paragraphs: [
                  'Vermont: Under Vermont law, we will not share information we collect about Vermont residents with companies outside of our Affiliates, unless the law allows. We will not share information about your creditworthiness with our Affiliates except  with your consent, but we may share information about our transactions or experiences with you with our Affiliates without your consent.<br>California: Under California law, we will not share information we collect about you with Non-Affiliates, unless the law allows. For example, we may share information with your consent, to service your accounts, or to provide rewards or benefits you are entitled to. We will limit sharing among our Affiliates to the extent required by California law.',
                ],
              },
              {
                header: 'DEFINITIONS:',
                paragraphs: [
                  'Affiliates: Companies related by common ownership or control.<br>Non-Affiliates: Companies not related by common ownership or control. They can be financial or nonfinancial companies. Joint Marketing: A formal agreement between nonaffiliated financial companies that together market financial products or services to you.',
                ],
              },
              {
                header: 'HOW WE PROTECT PERSONAL INFORMATION ABOUT YOU:',
                paragraphs: [
                  'To protect Personal Information about you from unauthorized access and use, we maintain physical, electronic, and procedural safeguards, including but not limited to security measures that comply with applicable federal and state laws. We also require our service providers and business partners to whom we disclose the information to do the same.',
                ],
              },
              {
                header: 'PROTECTION FOR FORMER CUSTOMERS:',
                paragraphs: [
                  'When you are no longer our customer or using the Site or Service, we continue to protect, use and share Personal Information about you as described in this notice and as required by law, including but not limited to for risk management, regulatory compliance, and audit purposes.',
                ],
              },
              {
                header: 'AMENDMENTS:',
                paragraphs: [
                  'We may amend this policy at any time by posting a revised version on the Site. The revised version will be effective immediately at the time it is posted unless a delayed effective date is expressly stated therein. You may (in our discretion) also be provided with an email notification of such amendments. You may (in our discretion) be required to affirmatively acknowledge or accept the revised Privacy Policy in order to continue using the Site or Service. Any use of the Service after a notice of change (whether by Site posting, email, or express acknowledgment or acceptance) will constitute your express agreement to such changes.',
                ],
              },
              {
                header: 'CONTACTING US:',
                paragraphs: [
                  "If you have any questions about this Privacy Policy, you may contact us at the postal address or email address below: <br><br>In writing:<br>BillMatrix Corporation ATTN: Privacy Management<br>2900 Westside Parkway<br>Alpharetta, GA 30004 E-mail: <a class='t-data t-link' href='mailto: privacy@customercenter.net'>privacy@customercenter.net</a>",
                ],
              },
            ],
            attestation: 'I have read and agree to the Privacy Policy *',
          },
          defaultTermsAndConditionsAttestation: {
            header: 'Payment Terms and Conditions',
            sections: [
              {
                header: 'INTRODUCTION:',
                paragraphs: [
                  'This document is to provide you information about the online bill payment system offered to you on behalf of your Biller (the “Service”) and the associated website (the “Site”). These terms and conditions set forth a legally binding agreement governing your use of the Site and the Service (“Agreement”) and outline important conditions that apply to your use of the Site and the Service. By utilizing the Service, permitting any person to do so on your behalf, or utilizing the Service on someone else’s behalf, you agree to these terms and conditions. If you do not agree to these terms and conditions, you must discontinue your access to the Site and not utilize the Service.',
                ],
              },
              {
                header: 'DEFINITIONS:',
                paragraphs: [
                  'Authorized User is any individual which you allow to use the Service or access to your Funding Account.<br>Auto Pay Payment is a recurring Payment made by you on the Due Date for the amount shown on the Billing Statement.<br>Biller is the entity to which you instruct us to make a Payment on your behalf.<br>Biller Account means the account you have directly with the Biller related to the goods and / or services provided to you by the Biller.<br>Billing Statement is the statement typically sent by Biller to you indicating, among other things, how much you owe for the provision of goods and / or services and the Due Date.<br>Business Day is every Monday through Friday, excluding Federal Reserve holidays.<br>Due Date is the date reflected on your Billing Statement when your payment is due; it is not the late payment date or inclusive of a grace period.<br>Funding Account is the checking account, savings account, or debit card account, held at FDIC or equivalent insured United States depository institutions, or credit card account from which Payments and fees, if any, will be debited and to which credits to you will be credited.<br>Payment is a payment transaction initiated by you through the Service.<br>Payment Date is the calendar day you elect for the Biller to receive the Payment, and is also the day your Funding Account will be debited; provided that if the calendar day you elect falls on a non-Business Day,  or after the daily cutoff  time for the Service, the actual Payment Date and the actual date your Funding Account will be debited will be the immediately following Business Day. This date can be current or in the future.<br>Payment Instruction is the information provided by you (such as, but not limited to, Biller name, Biller Account number, and Payment Date) for a Payment to be made through the Service.<br>Payment Wallet is the Funding Account information you save (if any) for use in making future Payments.<br>Recurring Payment is a Payment made each calendar month on the date designated by you in an amount designated by you. <br>Scheduled Payment is a Payment that has been scheduled for a future date, but which has not yet begun processing.<br>We, us, and our refers to Biller and its third-party service providers.<br>You and “your refer to the individual that is utilizing the Service.',
                ],
              },
              {
                header: 'ELIGIBILITY:',
                paragraphs: [
                  'The Site and the Service are offered only to individuals who can form legally binding contracts under applicable law and, with respect to Payments made using checking, savings, or debit cards, use bank accounts held at FDIC or equivalent insured United States depository institutions. Without limiting the foregoing, the Service is not offered to minors.  Commercial entities, including without limitation commercial payment aggregators, may not use the Site or Service, with the exception that an authorized representative of a commercial entity who holds a Biller Account may use the Site or Service to initiate a Payment to such commercial entity’s own Biller Account. By using the Service, you represent that you meet these requirements and that you agree to be bound by this Agreement. You agree to indemnify and hold us harmless for all costs and fees (including without limitation interchange fees and merchant fees) arising out of your violation of this Section.',
                ],
              },
              {
                header: 'PAYMENT AUTHORIZATION, PAYMENT REMITTANCE AND FEES:',
                paragraphs: [
                  'You authorize us to follow the Payment Instructions received from you. When we receive a Payment Instruction from you, you authorize us to debit or charge your Funding Account for the amount of any Payment plus any related fees in effect at the time you initiate the Payment Instruction, and to remit funds on your behalf. You also authorize us to credit your Funding Account, in the event that any Payments are returned to us because the processing of the Payment Instruction could not be completed. In order to process Payments more efficiently and effectively, we may edit or alter payment data or data formats. You certify that any Funding Account you add to your profile or otherwise utilize in connection with the  Service is an account from which you are authorized to make payments, and any Payment you make using the Service will debit/charge a Funding Account that you are legally authorized to use. We will use reasonable efforts to complete your Payments properly. However, we shall incur no liability if the Service is unable to complete any Payments initiated by you because of the existence of any one or more of the following circumstances or other reasons identified in this Agreement <br><br>1.    If your Funding Account does not contain sufficient funds to complete the transaction or the transaction would exceed the credit limit of your overdraft account;<br>2.    If our payment processing center is not working properly and you know or have been advised about the malfunction before you execute the transaction. <br>3.    If you have not provided us with the correct Funding Account information, or other required information. <br>4.    If your debit/credit card is expired;<br>5.    If circumstances beyond our control (such as, but not limited to, fire, flood, or other acts of God, third party systems, or interference from an outside force) prevent the proper execution of the transaction; and/ or<br>6.    If you failed to follow our instructions for the use of the Service.<br><br>Provided none of the foregoing exceptions are applicable, if we cause an incorrect amount of funds to be removed from your Funding Account or cause funds from your Funding Account to be directed in a manner that does not comply with your Payment Instructions, our sole responsibility to you shall be to return the improperly transferred funds to your Funding Account or to direct any previously misdirected Payments to the Biller.You are responsible for ensuring that there are sufficient funds available in your Funding Account to cover any amount you authorize for payment. If you do not have sufficient funds in your Funding Account, your Payment may not be processed. Your Payment may not be processed after a credit or debit card’s expiration date, if it is not updated by you prior to such date, unless we are able to obtain updated information from your card issuer. You authorize us to receive such updated credit or debit card information where available.In the event your Payment is not processed for any reason, including the failure to obtain an authorization from your card issuer or financial institution, or you have not provided us with the correct information, your liability shall remain outstanding and unpaid and you will be subject to all applicable penalties, late fees and interest charges assessed thereon, all of which obligations remain your sole responsibility.Any fees associated with your Funding Account, including without limitation any assessed by your financial institution or credit card issuer, will continue to apply. You are also responsible for any and all telephone access fees and/or Internet service fees that may be assessed by your telephone and/or Internet service provider in connection with your utilization of the Service.',
                ],
              },
              {
                header: 'OVERPAYMENT ADJUSTMENT:',
                paragraphs: [
                  'You agree that you shall not intentionally schedule a Payment in excess of the greater of (i) the amount due on the Billing Statement or (ii) the total balance owed on your account. You acknowledge that we may refuse to process any such overpayment or, we may adjust the Payment amount down to the amount due at time of payment processing as to avoid overpayments.',
                ],
              },
              {
                header: 'PAYMENT CANCELLATION REQUESTS:',
                paragraphs: [
                  'You may be permitted to cancel or edit a Payment until such time as the processing of the Payment Instruction has begun. If permitted, there is no charge for canceling or editing a Payment prior to the processing of the Payment Instruction.',
                ],
              },
              {
                header: 'RETURNED PAYMENTS:',
                paragraphs: [
                  'In using the Service, you understand that payments may be returned for various reasons, such as, but not limited to, the Biller Account number is not valid; we are unable to locate your Biller Account; or your Biller Account is paid in full. We will use reasonable efforts to research and correct the returned payment or void the payment and credit your Funding Account. You may receive notification regarding any such returned payments. You may be assessed fees by us or your financial institution as the result of any returns or insufficient funds related to your Funding Account, or charges refused by a card network.',
                ],
              },
              {
                header: 'PAYMENT WALLET:',
                paragraphs: [
                  'The Payment Wallet allows you to save your Funding Account for use in making future Payments. If you elect to use Payment Wallet, the following terms apply:<br><br>1.    Adding Funding Accounts: You authorize the addition of Funding Accounts to your profile when received from you. The first Funding Account that you add to your profile shall be your “Default Funding Account,” unless you later designate a different Funding Account as your Default Funding Account. If your identity cannot be verified satisfactorily, the Service may not allow you to add a specific type of Funding Account to your profile.<br>2.    Funding Account Number and Expiration Date Changes: It is your sole responsibility and you agree to ensure that the information maintained in your Payment Wallet is and remains accurate. If your Funding Account number changes or your credit or debit card expiration date changes, you agree to make updates to your Payment Wallet. You also authorize us to acquire such new or additional information regarding your accounts from our financial services partners and authorize the update of your Funding Account information accordingly. All changes made by you or acquired by us will be effective for future Payments paid using the Payment Wallet.',
                ],
              },
              {
                header:
                  'AUTO PAY PAYMENTS, RECURRING PAYMENTS, AND SCHEDULED PAYMENTS:',
                paragraphs: [
                  'You may have the option of enrolling for Auto Pay Payments or Recurring Payments. If you choose to enroll for either Auto Pay Payments or Recurring Payments, or if you initiate a Scheduled Payment, an email confirmation will be sent to you confirming that your enrollment or Payment Instruction has been received and whether it has been accepted. Please note the following:<br><br>1.    Payments must be made by the Due Date or you may be assessed a late fee.<br>2.    We will deduct (i) for Auto Pay Payments, the amount due on the Due Date and (ii) for Recurring Payments and Scheduled Payments, the amount designated by you on the date you selected. <br>3.   While enrolled in either Auto Pay Payments or Recurring Payments, you may receive email confirmations of Payments charged to or debited against your Funding Account. It is your responsibility to update your email address in your profile with your current email address. We will not be responsible for email confirmations that are not received as a result of delivery failures. (e.g., spam blockers or incorrect email address).<br>4.   It is your sole responsibility to ensure that all Funding Account information is accurate, legitimate, and up-to-date in order to ensure proper authorization of your Payment. We will not be responsible for any payment processing errors or fees incurred if you fail to provide accurate Funding Account information. <br>5.   You may terminate your participation in Auto Pay Payments and Recurring Payments online, in writing, or by calling Biller’s customer service department. It may take up to thirty (30) days to process termination requests.',
                ],
              },
              {
                header: 'COMMUNICATIONS TO YOU; ADDRESS OR BANKING CHANGES:',
                paragraphs: [
                  'By providing us with a telephone number (including a mobile telephone number) and/or email address, you consent to receiving calls and/or text messages at that number, and/or emails from us for our everyday business purposes (including identity verification). You authorize us to send or provide by electronic communication any notice, communication, amendment or replacement to the Agreement, payment receipt, or disclosure required to be provided orally or in writing to you. You agree to receive any electronic communication provided to you and will not attempt to avoid receiving any such communication. You are deemed to have received any electronic communication provided to you when they are made available to you. By providing us with a telephone number (including a mobile number), you consent to receiving autodialed and prerecorded message calls at that number for Service-related purposes. For example, we may contact you in connection with validating or processing a transaction that you’ve requested through the Service. You agree that we may provide notices to you by posting them on the Site, sending them to you through an in-product message within the Service, emailing them to an email address that you have provided, sending them via text message to any mobile number that you have provided, or by mailing them to any postal address that you have provided. For example, users of the Service may receive certain notices (such as notice of payments and alerts for validation and receipt of transfers of funds) as text messages on their mobile device. All notices by any of these methods shall be deemed received by you no later than twenty-four (24) hours after they are sent or posted, except for notice by postal mail, which shall be deemed received by you no later than three (3) Business Days after it is mailed. It is your sole responsibility to ensure that your contact information is accurate in the Service. We will not be responsible for communications that are not received by you as a result of delivery failures (e.g., spam blockers, incorrect email address or physical address, or incorrect mobile phone number).<br>Data and messaging charges from your telecommunications provider may apply, and you are responsible for any such charges. In the event your enrolled mobile device is lost or stolen, you agree to update your enrollment information and make the appropriate changes to disable the use of such device.',
                ],
              },
              {
                header: 'SECURITY:',
                paragraphs: [
                  'You agree not to give or make available your access or access credentials to the Service to any unauthorized individuals. You are responsible for all Payments you authorize using the Service or that are made using your access credentials. If you permit Authorized Users or other persons to use the Service, you are responsible for any transactions they authorize.   If you believe that your access or access credentials to the Service has been lost, stolen, or otherwise compromised or that someone has transferred or attempted to transfer money without your permission, you must notify customer care at once.   If you believe there have been any unauthorized transfers related to your Funding Account, you should notify Biller customer care department and /or your financial institution at once. See "Your Liability for Unauthorized Transfers."',
                ],
              },
              {
                header: 'INFORMATION AUTHORIZATION:',
                paragraphs: [
                  'You agree that the information you provide to facilitate a Payment, including your Funding Account information, may go through a verification process. You further agree that we may obtain financial information regarding your Funding Account from your financial institution (for example, to resolve payment posting problems, set transaction limits or for verification purposes).',
                ],
              },
              {
                header: 'ALTERATIONS AND AMENDMENTS:',
                paragraphs: [
                  "This Agreement, applicable fees and service charges may be altered or amended from time to time by posting a revised version on the Site or providing a revised version to you by other means. You may be required to affirmatively accept the revised Agreement in order to continue using the Service. Regardless of whether you are so required, any use of the Service after a notice of change or after the posting of a revised version of this Agreement on the Site will constitute your agreement to such changes and revised versions. The revised version will be effective at the time it is posted or otherwise provided to you unless a delayed effective date is expressly stated in the revision. Further, we may, from time to time, revise or update the Service applications, services, and/or related material, which may render all such prior versions obsolete. Consequently, we reserve the right to terminate this Agreement as to all such prior versions of the applications, services, and/or related material and limit access to only the Service's more recent revisions and updates. You authorize us to send or provide by electronic communication any notice, communication, amendment or replacement to the Agreement, or disclosure required to be provided orally or in writing to you. Your use of the Service may be terminated or suspended at any time for any reason or no reason. Neither termination nor suspension shall affect your liability or obligations under this Agreement.",
                ],
              },
              {
                header: 'PAYMENT DISPUTES:',
                paragraphs: [
                  'If you dispute a Payment made from a Funding Account, you acknowledge that such dispute (including, but not limited to, chargeback or fraud) must be taken up with your issuing debit/credit card provider or financial institution. We are not responsible for any research or resolution of such payment disputes.',
                ],
              },
              {
                header: 'ARBITRATION:',
                paragraphs: [
                  'For any claim (excluding claims for injunctive or other equitable relief) arising out of or relating to this Agreement, the parties must resolve the dispute in a cost-effective manner through binding non-appearance-based arbitration. The party commencing arbitration will initiate such arbitration through the American Arbitration Association ("AAA") or an established alternative dispute resolution (ADR) administrator mutually agreed upon by the parties. The parties agree that the following rules shall apply: (a) the arbitration may be conducted telephonically, online and/or be solely based on written submissions, at the election of the party initiating the arbitration; (b) the arbitration shall not involve any personal appearance by the parties, their representatives or witnesses unless otherwise mutually agreed by the parties; (c) discovery shall not be permitted; (d) the matter shall be submitted for decision within ninety (90) days of initiation of arbitration, unless otherwise agreed by the parties, and the arbitrator must render a decision within thirty (30) days of submission; and (e) any award in such arbitration shall be final and binding upon the parties and may be submitted to any court of competent jurisdiction for confirmation. The parties acknowledge that remedies available under federal, state and local laws remain available through arbitration.',
                ],
              },
              {
                header:
                  'NO CLASS ACTION, OTHER REPRESENTATIVE ACTION, OR PRIVATE ATTORNEY GENERAL ACTION, OR JOINDER OR CONSOLIDATION OF ANY CLAIM WITH A CLAIM OF ANOTHER PERSON SHALL BE ALLOWABLE IN ARBITRATION.',
                paragraphs: [
                  'Notwithstanding this Arbitration section, in the event you are a commercial or corporate entity, including without limitation a commercial payment aggregator, we reserve the right to bring a claim against you outside of arbitration and in any forum.',
                ],
              },
              {
                header: 'GOVERNING LAW:',
                paragraphs: [
                  'This Agreement shall be governed by and construed in accordance with the laws of the State of New York, without regard to its conflicts of law’s provisions. To the extent that the terms of this Agreement conflict with applicable state or federal law, such state or federal law shall replace such conflicting terms only to the extent required by law. In the event of such replacement, all other terms of this Agreement shall remain in full force and effect. The United Nations Convention on Contracts for the International Sale of Goods shall not apply to this Agreement. Both parties agree to waive any right to have a jury participate in the resolution of any dispute or claim between the parties or any of their respective affiliates arising under this Agreement, which instead shall be brought under the Arbitration clause set forth above.',
                ],
              },
              {
                header: 'EXCLUSIONS OF WARRANTIES / LIMITATION OF LIABILITY:',
                paragraphs: [
                  'In no event shall we or our services providers be responsible or liable for the timeliness, deletion, mis-delivery, or failure to store any user communications or personalized settings; any viruses which may affect your computer equipment or other property on account of your access to, use of, or downloading from the Site or Service; or any third party’s inability or  refusal to authorize a Payment or any other acts or omissions of third parties not controlled by us.',
                ],
              },
              {
                header:
                  'THE SITE AND SERVICE AND RELATED DOCUMENTATION ARE PROVIDED “AS IS” WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESSED OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF TITLE, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, WE DO NOT GUARANTEE CONTINUOUS, UNINTERRUPTED OR SECURE ACCESS TO ANY PART OF OUR SITE OR SERVICE, AND OPERATION OF THE SITE OR SERVICE MAY BE INTERFERED WITH BY NUMEROUS FACTORS OUTSIDE OF OUR CONTROL. SOME STATES DO NOT ALLOW THE DISCLAIMER OF CERTAIN IMPLIED WARRANTIES, SO THE FOREGOING DISCLAIMERS MAY NOT APPLY TO YOU. THIS PARAGRAPH GIVES YOU SPECIFIC LEGAL RIGHTS AND YOU MAY ALSO HAVE OTHER LEGAL RIGHTS THAT VARY FROM STATE TO STATE.',
                paragraphs: [
                  'IN NO EVENT SHALL WE OR OUR SERVICE PROVIDERS (OR EITHER OF OUR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, AFFILIATES OR STOCKHOLDERS) BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF THE SITE OR THE SERVICE OR OTHERWISE RELATING TO THIS AGREEMENT, INCLUDING WITHOUT LIMITATION ANY DIRECT, SPECIAL, INDIRECT, INCIDENTAL, CONSEQUENTIAL, PUNITIVE, EXEMPLARY, OR TORT DAMAGES OR LOST PROFITS (EVEN IF ADVISED OF THE POSSIBILITY THEREOF), REGARDLESS OF WHETHER SUCH CLAIM ARISES IN TORT, CONTRACT, OR OTHERWISE.',
                ],
              },
              {
                header: 'INDEMNIFICATION:',
                paragraphs: [
                  'You agree to indemnify and hold harmless us and our affiliates, suppliers, service providers, licensors and contractors, and the officers, directors, owners, agents, employees and contractors of each of these, from and against any and all loss, damage, liability, claim, demand, fees, costs, and expenses (including attorney’s fees) arising out of your breach of this Agreement and/or your access to or use of the Site or the Service.',
                ],
              },
              {
                header: 'INTELLECTUAL PROPERTY:',
                paragraphs: [
                  'All marks and logos related to the Site and the Service are either trademarks or registered trademarks of the Biller or its service providers, or their respective affiliates or licensors. You may not copy, modify, translate, decompile, reverse engineer, reproduce, adapt or disassemble the Site or the Service, both of which are the sole property of the Biller’s   service provider or the Biller’s service provider’s affiliates or their respective licensors. With the exception of your right to use the Site and Service in accordance with the terms hereof, which right may be revoked by us, you are not granted any rights of any kind in the Site, Service, marks, or logos, and we hereby reserve all such rights. The content accessed through the Site is the property of the applicable content owner and may be protected by applicable copyright or other law. Any downloading of material contained on the Site, or on any site linked to the Site, may be a violation of federal trademark or copyright laws.',
                ],
              },
              {
                header: 'ASSIGNMENT:',
                paragraphs: [
                  'You may not assign or transfer any rights or obligations you have under this Agreement to any other party without our prior written consent, which we may withhold in our sole discretion. We reserve the right to assign this Agreement or any right or obligation under this Agreement at any time to any party. We may also assign or delegate certain of our rights and responsibilities under this Agreement to affiliates, independent contractors, or other third parties.',
                ],
              },
              {
                header: 'NO WAIVER:',
                paragraphs: [
                  'We shall not be deemed to have waived any of our rights or remedies hereunder unless such waiver is in writing and signed by one of our authorized representatives. No delay or omission on our part in exercising any rights or remedies   shall operate as a waiver of such rights or remedies or any other rights or remedies. A waiver on any one occasion shall not be construed as a bar or waiver of any rights or remedies on future occasions.',
                ],
              },
              {
                header: 'CAPTIONS:',
                paragraphs: [
                  'The captions of sections hereof are for convenience only and shall not control or affect the meaning or construction of any of the provisions of this Agreement.',
                ],
              },
              {
                header: 'ERROR, QUESTIONS AND COMPLAINTS:',
                paragraphs: [
                  'In case of errors or questions about your transactions or Billing Statements, you should contact Biller customer care as soon as possible.',
                ],
              },
              {
                header: 'ENTIRE AGREEMENT:',
                paragraphs: [
                  'You agree that this Agreement (including without limitation the Privacy Policy set forth below) is the complete and exclusive statement of the agreement between you and us, and it supersedes any proposal or prior agreement, oral or written, and any other communications between you and us relating to the subject matter of this Agreement.',
                ],
              },
            ],
            attestation: 'I have read and agree to the Payment Terms *',
          },
        },
        register: {
          page: 'register',
          layout: 'banner',
          layoutOptions: {
            header: {
              icon: 'https://zipari-uploads-dev.s3.amazonaws.com/multitenant/files/d40fa16f-4759-4c7f-a2af-61ef3765b7b9.png',
              text: 'Our not-for-profit status allows us to focus on our mission — caring more for our members than the bottom line.',
            },
            heroImg:
              'https://zipari-uploads-dev.s3.amazonaws.com/multitenant/files/f5d8fe90-b44f-4aae-91ca-7bdc66191369.png',
            sections: [
              {
                text: 'We offer access to more than 1 million physicians, provider facilities, hospitals and other care centers in our provider networks <br><br> Search for a doctor, facility or pharmacy by name or provider type. today.',
                type: 'text',
                title: 'Find a Doctor',
              },
              {
                list: [
                  { text: 'Expansive provider network' },
                  { text: 'Health & Wellness Program' },
                  { text: 'Experienced Customer Support Team' },
                ],
                type: 'list',
                title: 'Why Branch Health',
              },
              {
                type: 'links',
                links: [
                  {
                    url: 'www.google.com',
                    label: 'Individual & Family Plans >',
                  },
                  { url: 'www.google.com', label: 'Employer Plans >' },
                  {
                    url: 'www.google.com',
                    label: 'Medicare Supplement Plans >',
                  },
                  { url: 'www.google.com', label: 'Dental Plans >' },
                ],
                title: 'Need Health Insurance?',
                description:
                  'Check out our complete listing of plans for families and individuals:',
              },
            ],
          },
          authCardOptions: {
            form: {
              title: '',
              controls: [
                {
                  grid: { col: '1 / 3', row: '1' },
                  prop: 'first_name',
                  type: 'text',
                  label: 'Your first name',
                  maxLength: 15,
                  validators: ['alpha', 'required'],
                },
                {
                  grid: { col: '3 / 5', row: '1' },
                  prop: 'last_name',
                  type: 'text',
                  label: 'Your last name',
                  maxLength: 15,
                  validators: ['alpha', 'required'],
                },
                {
                  grid: { col: '5 / 7', row: '1' },
                  prop: 'username',
                  type: 'text',
                  label: 'Create a user name',
                  validators: ['required'],
                },
                {
                  grid: { col: '1 / 4', row: '2' },
                  prop: 'email',
                  type: 'text',
                  label: 'Enter your email',
                  validators: ['email', 'required'],
                },
                {
                  grid: { col: '4 / 7', row: '2' },
                  prop: 'email_confirm',
                  type: 'text',
                  label: 'Confirm Email',
                  validators: [
                    'required',
                    { name: 'match', dependency: 'email' },
                  ],
                },
                {
                  grid: { col: '1 / 4', row: '3' },
                  prop: 'password',
                  type: 'password',
                  label: 'Create Password',
                  validators: [
                    'required',
                    { name: 'match', dependency: 'password' },
                    { name: 'blacklistCharacters', dependency: [' '] },
                  ],
                },
                {
                  grid: { col: '4 / 7', row: '3' },
                  prop: 'confirm_password',
                  type: 'password',
                  label: 'Confirm Password',
                  validators: [
                    'required',
                    { name: 'match', dependency: 'password' },
                  ],
                },
              ],
            },
            title: 'Create an Account to Secure Your Health Plan',
            footer: {
              link: null,
              button: {
                icon: '',
                level: 'high',
                content: 'Submit Registration',
              },
            },
            subtitle:
              'After you create an account, we’ll walk you through the remaining steps to enroll in your selected health plan.',
            successTitle: 'A verification link has been sent to ${email}',
            successSubtitle:
              'Please click the link in that email to complete the registration process.',
          },
          routeAfterSuccessConfig: { disableAfterSuccess: true },
        },
        showAppId: false,
        autobundle: {
          footer: {
            backButton: { level: 'medium', content: 'Back' },
            nextButton: { level: 'high', content: 'Next' },
          },
          header: {
            title:
              "For complete health coverage, we've automatically added these plans to your enrollment",
          },
          addedPlans: {
            title: 'Added Plans',
            subtitle:
              "These plans have been automatically added for your household to receive complete health coverage. You can remove these plans if you don't want to enroll.",
          },
          planDetail: {
            viewDetailConfig: {
              hideText: 'Hide details',
              viewText: 'View details',
            },
          },
          slideoutModal: {
            footer: {
              okayButton: { level: 'high', content: 'Remove Plan' },
              cancelButton: { level: 'low', content: 'Cancel' },
            },
            headerText: 'Remove Plan',
            waiverTitle: 'Remove ${display_name} Plan',
            attestationList: [
              'Enroll in a dental plan that includes pediatric dental coverage in addition to this health plan. You will need to choose a dental plan on the next page or over the phone at (xxx) xxx-xxxx.',
              'Provide proof of coverage to the insurer if you have existing pediatric dental coverage. Your insurance company will request proof of this coverage after you enroll in this health plan.',
            ],
            firstWaiverText:
              'By law, plans with dependents 18 years old or younger must include pediatric dental coverage.',
            secondWaiverText:
              'To remove this plan, you will be required to either:',
            attestationCheckbox:
              'I understand and wish to continue without this plan',
          },
          yourPlanTitle: 'Your Plan',
          hideBackButton: false,
          removePlanModal: {
            buttons: {
              okayButton: {
                level: 'high',
                action: 'removePlan',
                content: 'Remove Plan',
              },
              cancelButton: { level: 'low', content: 'Cancel' },
            },
            bodyText:
              'Are you sure you want to remove this plan? You will not be enrolled for this coverage.',
            modalConfig: {
              type: 'popup',
              header: { title: 'Remove Plan' },
              backdrop: true,
              clickOutside: false,
            },
          },
          removePlanButton: { action: 'removePlan', content: 'Remove Plan' },
          otherDentalPlansCard: {
            label: 'There are other dental plans available!',
            button: { level: 'medium', content: 'View Dental Plans' },
          },
          otherVisionPlansCard: {
            label: 'There are other vision plans available!',
            button: { level: 'medium', content: 'View Vision Plans' },
          },
          otherDentalAndVisionPlansCard: {
            label: 'There are other dental and vision plans available!',
            button: {
              level: 'medium',
              content: 'View Dental and Vision Plans',
            },
          },
        },
        personalize: {
          header: {
            title: 'What Matters Most to You?',
            subtitle:
              'When you select plan benefits that are important to you, you will see recommended insurance plans personalized to your needs.',
          },
        },
        workflowNav: {
          logoRoute: '/',
          exitEnrollmentIcon: 'exit',
          exitEnrollmentText: 'Exit',
          exitEnrollmentRoute: '/shopping/workbench',
        },
        confirmation: {
          text: {
            print: 'Print Your Application',
            reason: 'Reason',
            coverage: 'coverage',
            zip_code: 'ZIP Code',
            submitted: 'Submitted',
            learn_more: 'Learn More About Your New Plan',
            subscriber: 'Subscriber',
            quick_links: 'Quick Links',
            coverage_type: 'Coverage Type',
            selected_plans: 'Selected Plans',
            confirmation_num: 'Confirmation Number',
            enrollment_status: 'Enrollment Status',
            coverage_start_date: 'Coverage Start Date',
            will_receive_updates:
              'You will receive updates to keep you informed. In the meantime, you can always check your status by logging into your account.',
            application_submitted:
              'Your Application Was Successfully Submitted',
          },
          cards: [
            {
              icon: 'id_product',
              label: 'Confirmation Number',
              value: '${confirmation_number}',
            },
            {
              icon: 'clipboard',
              label: 'Enrollment Status',
              value: '${status}',
              format: 'SNAKE_CASE_TO_TITLE',
            },
            { icon: 'wellness_product', label: 'Plans', value: '${plans}' },
          ],
          label: 'Application Complete',
          summary: [
            {
              title: 'Coverage & Members',
              sections: [
                {
                  title: 'Coverage',
                  attributes: [
                    { prop: 'permanent_address.zipcode', label: 'ZIP Code' },
                    {
                      prop: 'demographics.displayCoverageType',
                      label: 'Coverage Type',
                    },
                    {
                      prop: 'coverage_effective_date',
                      label: 'Coverage Start Date',
                      format: 'DATE',
                    },
                  ],
                },
                {
                  title: 'Subscriber',
                  actions: [{ name: 'HIDE' }],
                  attributes: [
                    { prop: 'subscriber', label: 'Name', format: 'FULL_NAME' },
                    {
                      prop: 'subscriber.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    { prop: 'subscriber.gender', label: 'Gender' },
                    {
                      prop: 'subscriber.displaySSN',
                      label: 'Social Security Number',
                    },
                  ],
                  conditions: {
                    all: [{ name: 'subscriber', operation: 'EXISTS' }],
                  },
                },
                {
                  title: 'Spouse',
                  actions: [{ name: 'HIDE' }],
                  attributes: [
                    { prop: 'spouse', label: 'Name', format: 'FULL_NAME' },
                    {
                      prop: 'spouse.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    { prop: 'spouse.gender', label: 'Gender' },
                    {
                      prop: 'spouse.displaySSN',
                      label: 'Social Security Number',
                    },
                  ],
                  conditions: {
                    all: [{ name: 'spouse', operation: 'EXISTS' }],
                  },
                },
                {
                  title: 'Dependent ${ind}',
                  actions: [{ name: 'HIDE' }],
                  attributes: [
                    {
                      prop: 'dependent${i}',
                      label: 'Name',
                      format: 'FULL_NAME',
                    },
                    {
                      prop: 'dependent${i}.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    { prop: 'dependent${i}.gender', label: 'Gender' },
                    {
                      prop: 'dependent${i}.displaySSN',
                      label: 'Social Security Number',
                    },
                  ],
                  conditions: {
                    all: [{ name: 'dependents', operation: 'EXISTS' }],
                  },
                },
              ],
            },
            { type: 'plan', title: 'Selected Plan' },
            {
              type: 'pcp',
              title: 'Primary Care Physician (PCP)',
              actions: [{ name: 'HIDE' }],
              conditions: {
                all: [{ name: 'steps.pcp_selection', operation: 'EXISTS' }],
              },
            },
            {
              title: 'Special Enrollment Period',
              actions: [{ name: 'HIDE' }],
              attributes: [{ prop: 'qleReason', label: 'Reason' }],
              conditions: { all: [{ name: 'qleReason', operation: 'EXISTS' }] },
            },
            {
              title: 'Personal Information',
              sections: [
                {
                  title: 'Address',
                  attributes: [
                    {
                      prop: 'permanent_address.street_name_1',
                      label: 'Address 1',
                    },
                    {
                      prop: 'permanent_address.street_name_2',
                      label: 'Address 2',
                    },
                    { prop: 'permanent_address.city', label: 'City' },
                    { prop: 'permanent_address.state', label: 'State' },
                    { prop: 'permanent_address.zipcode', label: 'ZIP Code' },
                  ],
                },
                {
                  title: 'Contact',
                  attributes: [
                    {
                      prop: 'phoneNumber',
                      label: 'Primary Phone Number',
                      format: 'PHONE',
                    },
                    { prop: 'email', label: 'Email Address', format: 'EMAIL' },
                    {
                      prop: 'spouse.email_address',
                      label: 'Spouse Email Address',
                      format: 'EMAIL',
                    },
                  ],
                },
              ],
            },
            {
              title: 'Payment Information',
              actions: [{ name: 'HIDE' }],
              sections: [
                {
                  title: 'Payment Method',
                  attributes: [
                    {
                      prop: 'payment.displayPaymentMethod',
                      label: 'Payment Method',
                    },
                    {
                      prop: 'payment.totalMonthlyPremium',
                      label: 'Payment Amount',
                    },
                  ],
                },
                {
                  title: 'Card / Account Information',
                  actions: [{ name: 'HIDE' }],
                  attributes: [
                    {
                      prop: 'payment.cardNumber',
                      label: 'Card/Account Number',
                    },
                    {
                      prop: 'payment.expiration',
                      label: 'Expiration Date',
                      format: 'DATE',
                    },
                    { prop: 'payment.zipcode', label: 'Billing ZIP Code' },
                  ],
                  conditions: {
                    all: [
                      {
                        name: 'displayPaymentMethod',
                        value: 'Credit Card / Debit Card',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                },
                {
                  title: 'Bank Account',
                  actions: [{ name: 'HIDE' }],
                  attributes: [
                    { prop: 'payment.bank', label: 'Bank' },
                    {
                      prop: 'payment.accountNumber',
                      label: 'Account Number',
                      format: 'DATE',
                    },
                    { prop: 'payment.routingNumber', label: 'Routing Number' },
                  ],
                  conditions: {
                    all: [
                      {
                        name: 'displayPaymentMethod',
                        value: 'Credit Card / Debit Card',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                },
              ],
              conditions: { all: [{ name: 'payment', operation: 'EXISTS' }] },
            },
            {
              type: 'signature',
              title: 'Attestation',
              actions: [{ name: 'HIDE' }],
              conditions: {
                all: [{ name: 'signee_info', operation: 'EXISTS' }],
              },
            },
          ],
          download: {
            content: 'Print Your Application',
            printConfig: {
              type: 'pdf',
              endpoint: 'api/documents/external/persist/?download=True',
              fileName: 'enrollment',
              dateFormat: { format: 'DATE' },
              static_values: {
                logo: 'https://d32ul9oyxvd2n5.cloudfront.net/assets/logo.png',
              },
              zip_pdf_main_css: 'democare_application_template',
              zip_pdf_main_html: 'democare_application_template',
            },
          },
          learnMore: [
            {
              icon: 'hospital',
              link: 'https://www.google.com/',
              label: 'Getting Care',
              button: 'Get Care',
              description:
                "Learn how to find a doctor, why it's important to have a primary care physician, when you need urgent or emergency care, how to get care outside of a doctor's office and more.",
            },
            {
              icon: 'file',
              link: 'https://www.google.com/',
              label: 'Plan Resources',
              button: 'Get Information',
              description:
                'Access important plan documents that explain your benefits and learn how to make the most of your individual and family medical, dental, and/or vision plan(s).',
            },
            {
              icon: 'costs_product',
              link: 'https://www.google.com/',
              label: 'Billing Resources',
              button: 'Learn More',
              description:
                'Whether you want to sign-up for automatic payments, learn how to pay your bill online, or want to learn the basics about healthcare costs and claims, you can find it all here.',
            },
          ],
          learn_more: [
            {
              icon: 'hospital',
              link: 'https://www.google.com/',
              label: 'Getting Care',
              button: 'Get Care',
              description:
                "Learn how to find a doctor, why it's important to have a primary care physician, when you need urgent or emergency care, how to get care outside of a doctor's office and more.",
            },
            {
              icon: 'file',
              link: 'https://www.google.com/',
              label: 'Plan Resources',
              button: 'Get Information',
              description:
                'Access important plan documents that explain your benefits and learn how to make the most of your individual and family medical, dental, and/or vision plan(s).',
            },
            {
              icon: 'costs_product',
              link: 'https://www.google.com/',
              label: 'Billing Resources',
              button: 'Learn More',
              description:
                'Whether you want to sign-up for automatic payments, learn how to pay your bill online, or want to learn the basics about healthcare costs and claims, you can find it all here.',
            },
          ],
          quickLinks: [
            {
              icon: 'heart_product',
              link: 'https://www.google.com/',
              label: 'Protect Your Whole Self',
              button: 'Get Total Coverage',
              description:
                'Add a dental plan, vision plan, or life insurance plan for full coverage.',
            },
            {
              icon: 'video_product',
              link: 'https://www.google.com/',
              label: 'Helpful Videos',
              button: 'Watch Now',
              description:
                'Find out how to access all the important features of your membership.',
            },
            {
              icon: 'file',
              link: 'https://www.google.com/',
              label: 'Definitions',
              button: 'Read Now',
              description:
                'Get help understanding basic healthcare and billing terms.',
            },
            {
              icon: 'care',
              link: 'https://www.google.com/',
              label: 'Pharmacy',
              button: 'Learn More',
              description:
                'View the drug formulary for your plan, learn about mail service pharmacy.',
            },
            {
              icon: 'calculator',
              link: 'https://www.google.com/',
              label: 'Treatment Cost Estimator',
              button: 'Estimate Now',
              description:
                'With a PPO plan, you can use this tool to estimate and compare your costs.',
            },
            {
              icon: 'wellness_product',
              link: 'https://www.google.com/',
              label: 'Prevention',
              button: 'View Guidelines',
              description:
                'See what’s covered during a preventive care visit and guidelines for every age.',
            },
          ],
          quick_links: [
            {
              icon: 'heart_product',
              link: 'https://www.google.com/',
              label: 'Protect Your Whole Self',
              button: 'Get Total Coverage',
              description:
                'Add a dental plan, vision plan, or life insurance plan for full coverage.',
            },
            {
              icon: 'video_product',
              link: 'https://www.google.com/',
              label: 'Helpful Videos',
              button: 'Watch Now',
              description:
                'Find out how to access all the important features of your membership.',
            },
            {
              icon: 'file',
              link: 'https://www.google.com/',
              label: 'Definitions',
              button: 'Read Now',
              description:
                'Get help understanding basic healthcare and billing terms.',
            },
            {
              icon: 'care',
              link: 'https://www.google.com/',
              label: 'Pharmacy',
              button: 'Learn More',
              description:
                'View the drug formulary for your plan, learn about mail service pharmacy.',
            },
            {
              icon: 'calculator',
              link: 'https://www.google.com/',
              label: 'Treatment Cost Estimator',
              button: 'Estimate Now',
              description:
                'With a PPO plan, you can use this tool to estimate and compare your costs.',
            },
            {
              icon: 'wellness_product',
              link: 'https://www.google.com/',
              label: 'Prevention',
              button: 'View Guidelines',
              description:
                'See what’s covered during a preventive care visit and guidelines for every age.',
            },
          ],
          showSummary: true,
          summaryTitle: 'Summary',
          planTypeOrder: ['medical', 'bundled', 'dental', 'vision'],
          learnMoreTitle: 'Learn More About Your New Plan',
          attributeColumns: 3,
          defaultNoValueMessage: 'N/A',
        },
        demographics: {
          sep: {
            QLE: null,
            form: {
              controls: [
                {
                  prop: 'is_sep',
                  type: 'radio',
                  label: 'Special Enrollment',
                  options: [
                    {
                      label: 'See if I qualify for Special Enrollment.',
                      value: true,
                    },
                    {
                      label: "I'll continue with standard Open Enrollment.",
                      value: false,
                    },
                  ],
                  validators: ['required'],
                },
              ],
            },
            icon: { iconName: 'wellness_product', showIcon: true },
            title: 'Do You Qualify For Special Enrollment?',
            subTitle: 'Apple Sub Title',
            subtitle:
              'Completing an application for Special Enrollment requires a Qualifying Life Event (QLE). You will be asked to provide more details later.',
            dateLabel: 'When did this happen?',
            headerText:
              'To get coverage during the Special Enrollment period, the Client must have had a Qualifying Life Event (QLE). Please select the QLE that applies to your Client or someone in their household in the past 60 days.',
            helpTextlabel: 'Additional Information',
            subheaderText: { text: 'Apple' },
            secondaryLabel: 'How did this happen?',
            qleHeaderTemplate:
              'To get coverage during this period, a Qualifying Life Event (QLE) must have occured.Please select the QLE that applies to you or someone in your household in the past 60 days.',
            openEnrollmentRange: {
              endDate: '12/31/2024',
              startDate: '07/01/2024',
            },
            windowShoppingRange: { endDate: '10/15', startDate: '09/01' },
            effectiveDateTemplate:
              'Based on the Qualifying Life Event, you are eligible for coverage starting on ${effectiveDate}',
            invalidQLEDateWarning: 'Use a valid date',
            OEPqualifyingLifeEvents: null,
            SEPqualifyingLifeEvents: null,
            secondaryQleDateValidators: ['required'],
            effectiveDateSelectionLabel: 'Select the Coverage Effective Date*',
            coverageEffectiveDateTemplate:
              'Based on the Qualifying Life Event, you are eligible for coverage starting on ${effectiveDate}',
          },
          text: { add_another_child: 'Add Another Dependent' },
          label: 'Get Started',
          splash: {
            card: true,
            title: 'We make it easy to find the right plan for your needs.',
            alignment: 'right',
            paragraph: '',
          },
          submit: {
            icon: '',
            level: 'high',
            content: 'Start the Enrollment Process',
          },
          members: {
            form: {
              controls: [
                {
                  prop: 'date_of_birth',
                  type: 'date',
                  label: 'Date of Birth',
                  validators: [
                    'required',
                    'reasonableDate',
                    {
                      name: 'minAge',
                      dependency: {
                        age: 18,
                        dateProp: 'parent.value.coverage_effective_date',
                      },
                    },
                    {
                      name: 'maxAge',
                      dependency: {
                        age: 65,
                        dateProp: 'parent.value.coverage_effective_date',
                      },
                    },
                  ],
                },
              ],
            },
            icon: { iconName: 'cover_who', showIcon: true },
            cards: {
              spouse: {
                prop: 'spouse',
                label: 'YOUR SPOUSE OR PARTNER',
                controls: [
                  {
                    prop: 'date_of_birth',
                    type: 'date',
                    label: 'Date of Birth',
                    errors: {
                      maxAge: 'Please enter a valid date of birth',
                      minAge: 'Spouse must be age 14 or older',
                      required: 'Please enter a valid date of birth',
                      dateInPast: 'Please enter a valid date of birth',
                      reasonableDate: 'Please enter a valid date of birth',
                    },
                    validators: [
                      'required',
                      'dateInPast',
                      'reasonableDate',
                      {
                        name: 'minAge',
                        dependency: {
                          age: 14,
                          dateProp: 'parent.value.coverage_effective_date',
                        },
                      },
                    ],
                  },
                  {
                    prop: 'gender',
                    type: 'toggle',
                    label: 'Gender',
                    options: [
                      { label: 'Male', value: 'male' },
                      { label: 'Female', value: 'female' },
                    ],
                    validators: ['required'],
                  },
                  {
                    prop: 'tobacco_user',
                    type: 'toggle',
                    label: 'Tobacco User',
                    options: [
                      { label: 'Yes', value: true },
                      { label: 'No', value: false },
                    ],
                    validators: ['required'],
                    description:
                      'Has your spouse or partner smoked or used tobacco products on average for four (4) or more times per week within the past six months (includes chewing tobacco, cigarettes, cigars and pipes, excludes religious or ceremonial use of tobacco)?',
                  },
                  {
                    prop: 'medicare_enrolled',
                    type: 'toggle',
                    label: 'Is your spouse or partner enrolled in Medicare?',
                    errors: {
                      equals:
                        "If you're already covered by Medicare Part A or Part B and have questions, call us at 1-800-670-5935 (TTY 711).",
                    },
                    options: [
                      { label: 'Yes', value: 'true' },
                      { label: 'No', value: 'false' },
                    ],
                    validators: [
                      'required',
                      { name: 'equals', dependency: 'false' },
                    ],
                    conditionalControls: [
                      {
                        prop: 'medicare_enrolled_applicant_name',
                        type: 'text',
                        label: 'Applicant Name',
                        validators: ['required'],
                      },
                    ],
                  },
                ],
                maxAgeAllowed: true,
                maxAllowedText: 'You maybe eligible for Medicare',
              },
              children: {
                prop: 'children',
                label: 'YOUR DEPENDENT',
                notes: [
                  'For a dependent only application, the dependent must be less than 18 years old.',
                  'If you need to enroll more than one dependent without also including an adult on the policy, you will need to submit separate applications for each dependent.',
                ],
                controls: [
                  {
                    prop: 'date_of_birth',
                    type: 'date',
                    label: 'Date of Birth',
                    errors: {
                      maxAge: 'Child dependent must be under the age 26',
                      required: 'Please enter a valid date of birth',
                      reasonableDate:
                        'Child dependent must be under the age 26',
                      dateInFutureWithinDays:
                        'Please enter a valid date of birth',
                    },
                    validators: [
                      'required',
                      { name: 'dateInFutureWithinDays', dependency: 0 },
                      'reasonableDate',
                      {
                        name: 'maxAge',
                        dependency: {
                          age: 26,
                          dateProp:
                            'parent.parent.value.coverage_effective_date',
                        },
                      },
                    ],
                  },
                  {
                    prop: 'gender',
                    type: 'toggle',
                    label: 'Gender',
                    options: [
                      { label: 'Male', value: 'male' },
                      { label: 'Female', value: 'female' },
                    ],
                    validators: ['required'],
                  },
                  {
                    prop: 'tobacco_user',
                    type: 'toggle',
                    label: 'Tobacco User',
                    options: [
                      { label: 'Yes', value: true },
                      { label: 'No', value: false },
                    ],
                    validators: ['required'],
                    description:
                      'Has this dependent smoked or used tobacco products on average for four (4) or more times per week within the past six months (includes chewing tobacco, cigarettes, cigars and pipes, excludes religious or ceremonial use of tobacco)?',
                  },
                  {
                    prop: 'medicare_enrolled',
                    type: 'toggle',
                    label: 'Is this dependent enrolled in Medicare?',
                    errors: {
                      equals:
                        "If you're already covered by Medicare Part A or Part B and have questions, call us at 1-800-670-5935 (TTY 711).",
                    },
                    options: [
                      { label: 'Yes', value: 'true' },
                      { label: 'No', value: 'false' },
                    ],
                    validators: [
                      'required',
                      { name: 'equals', dependency: 'false' },
                    ],
                    conditionalControls: [
                      {
                        prop: 'medicare_enrolled_applicant_name',
                        type: 'text',
                        label: 'Applicant Name',
                        validators: ['required'],
                      },
                    ],
                  },
                ],
              },
              child_only: {
                prop: 'children',
                label: 'Your Dependent',
                notes: [
                  'If you need to enroll more than one dependent without also including an adult on the policy, you will need to submit separate applications for each dependent.',
                ],
                controls: [
                  {
                    prop: 'date_of_birth',
                    type: 'date',
                    label: 'Date of Birth',
                    errors: {
                      maxAge: 'Dependent must be 20 or younger',
                      required: 'Please enter a valid date of birth',
                      dateInPast: 'Please enter a valid date of birth',
                      reasonableDate: 'Please enter a valid date of birth',
                    },
                    validators: [
                      'required',
                      'dateInPast',
                      'reasonableDate',
                      {
                        name: 'maxAge',
                        dependency: {
                          age: 20,
                          dateProp:
                            'parent.parent.value.coverage_effective_date',
                        },
                      },
                    ],
                  },
                  {
                    prop: 'gender',
                    type: 'toggle',
                    label: 'Gender',
                    options: [
                      { label: 'Male', value: 'male' },
                      { label: 'Female', value: 'female' },
                    ],
                    validators: ['required'],
                  },
                  {
                    prop: 'tobacco_user',
                    type: 'toggle',
                    label: 'Tobacco User',
                    options: [
                      { label: 'Yes', value: true },
                      { label: 'No', value: false },
                    ],
                    validators: ['required'],
                    description:
                      'Has this dependent smoked or used tobacco products on average for four (4) or more times per week within the past six months (includes chewing tobacco, cigarettes, cigars and pipes, excludes religious or ceremonial use of tobacco)?',
                  },
                  {
                    prop: 'medicare_enrolled',
                    type: 'toggle',
                    label: 'Is this dependent enrolled in Medicare?',
                    errors: {
                      equals:
                        "If you're already covered by Medicare Part A or Part B and have questions, call us at 1-800-670-5935 (TTY 711).",
                    },
                    options: [
                      { label: 'Yes', value: 'true' },
                      { label: 'No', value: 'false' },
                    ],
                    validators: [
                      'required',
                      { name: 'equals', dependency: 'false' },
                    ],
                    conditionalControls: [
                      {
                        prop: 'medicare_enrolled_applicant_name',
                        type: 'text',
                        label: 'Applicant Name',
                        validators: ['required'],
                      },
                    ],
                  },
                ],
                childLimit: 1,
              },
              subscriber: {
                prop: 'subscriber',
                label: 'YOURSELF',
                controls: [
                  {
                    prop: 'date_of_birth',
                    type: 'date',
                    label: 'Date of Birth',
                    errors: {
                      maxAge: 'Please enter a valid date of birth',
                      minAge: 'Subscriber must be age 18 or older',
                      required: 'Please enter a valid date of birth',
                      dateInPast: 'Please enter a valid date of birth',
                      reasonableDate: 'Please enter a valid date of birth',
                    },
                    validators: [
                      'required',
                      'dateInPast',
                      'reasonableDate',
                      {
                        name: 'minAge',
                        dependency: {
                          age: 18,
                          dateProp: 'parent.value.coverage_effective_date',
                        },
                      },
                    ],
                  },
                  {
                    prop: 'gender',
                    type: 'toggle',
                    label: 'Gender',
                    options: [
                      { label: 'Male', value: 'male' },
                      { label: 'Female', value: 'female' },
                    ],
                    validators: ['required'],
                  },
                  {
                    prop: 'tobacco_user',
                    type: 'toggle',
                    label: 'Tobacco User',
                    options: [
                      { label: 'Yes', value: true },
                      { label: 'No', value: false },
                    ],
                    validators: ['required'],
                    description:
                      'Have you smoked or used tobacco products on average for four (4) or more times per week within the past six months (includes chewing tobacco, cigarettes, cigars and pipes, excludes religious or ceremonial use of tobacco)?',
                  },
                  {
                    prop: 'medicare_enrolled',
                    type: 'toggle',
                    label: 'Are you enrolled in Medicare?',
                    errors: {
                      equals:
                        "If you're already covered by Medicare Part A or Part B and have questions, call us at 1-800-670-5935 (TTY 711).",
                    },
                    options: [
                      { label: 'Yes', value: 'true' },
                      { label: 'No', value: 'false' },
                    ],
                    validators: [
                      'required',
                      { name: 'equals', dependency: 'false' },
                    ],
                    conditionalControls: [
                      {
                        prop: 'medicare_enrolled_applicant_name',
                        type: 'text',
                        label: 'Applicant Name',
                        validators: ['required'],
                      },
                    ],
                  },
                ],
                maxAgeAllowed: true,
                maxAllowedText: 'You maybe eligible for Medicare',
              },
              stepParents: {
                prop: 'stepParents',
                label: 'YOUR PARENT(S)/STEP-PARENT(S)',
                controls: [
                  {
                    prop: 'date_of_birth',
                    type: 'date',
                    label: 'Date of Birth',
                    errors: {
                      maxAge:
                        'Parent(s)/Step Parent(s) dependent must be under the age 115',
                      minAge:
                        'Parent(s)/Step Parent(s) dependent must be above 26',
                      required: 'Please enter a valid date of birth',
                      dateInPast: 'Please enter a valid date of birth',
                      reasonableDate: 'Please enter a valid date of birth',
                    },
                    validators: [
                      'required',
                      'dateInPast',
                      'reasonableDate',
                      {
                        name: 'maxAge',
                        dependency: {
                          age: 114,
                          dateProp: 'root.value.coverage_effective_date',
                        },
                      },
                      {
                        name: 'minAge',
                        dependency: {
                          age: 27,
                          dateProp: 'root.value.coverage_effective_date',
                        },
                      },
                    ],
                    placeholder: 'YYYY-MM-DD',
                  },
                  {
                    prop: 'tobacco_user',
                    type: 'toggle',
                    label: 'Are you a tobacco user?',
                    options: [
                      { label: 'Yes', value: true },
                      { label: 'No', value: false },
                    ],
                    validators: ['required'],
                    description:
                      'Tobacco user is defined as using tobacco products (for example cigarettes, cigars, smokeless tobacco, e-cigarettes) four or more times a week on average (other than for religious or ceremonial purposes) within the last six months. This only applies to individuals age 21 and over.',
                  },
                ],
              },
            },
            title: 'Who Needs Insurance?',
            options: {
              family: {
                icon: 'family',
                cards: ['subscriber', 'spouse', 'children'],
                label: 'You + Spouse/Partner + Children',
                value: 'family',
              },
              parent: {
                icon: 'spouse',
                cards: ['subscriber', 'children'],
                label: 'You + Children',
                value: 'parent',
              },
              spouse: {
                icon: 'spouse',
                cards: ['subscriber', 'spouse'],
                label: 'You + Spouse/Partner',
                value: 'spouse',
              },
              children: {
                icon: 'single',
                cards: ['child_only'],
                label: 'Children',
                value: 'children',
                one_per_policy: false,
              },
              subscriber: {
                icon: 'single',
                cards: ['subscriber'],
                label: 'Yourself',
                value: 'subscriber',
              },
            },
            subtitle: 'You can apply for yourself or a family member',
            addAnotherParent: { text: 'Add Another Parent(s)/Step-Parent(s)' },
            hasParentDependents: false,
            individualsCoveredOptions: {
              family: {
                icon: 'add_family',
                cards: ['subscriber'],
                label: 'Family',
                value: 'family',
              },
              children: {
                icon: 'add_child_only',
                cards: ['child_only'],
                label: 'Child Only',
                value: 'children',
                one_per_policy: true,
              },
              subscriber: {
                icon: 'add_yourself',
                cards: ['subscriber'],
                label: 'Subscriber Only',
                value: 'subscriber',
              },
            },
          },
          subsidy: {
            icon: { iconName: 'calculator', showIcon: true },
            title:
              'Would You Like To Find Out If You Can Get Help Paying For Coverage?',
            button: { content: 'Calculate Subsidy' },
            controls: [
              {
                mask: 'number',
                prop: 'household_size',
                type: 'text',
                label: 'Household Size',
                errors: { max: 'Please provide a household size' },
                maxLength: 2,
                validators: ['required'],
                description: 'Example: 3',
              },
              {
                mask: 'number',
                prop: 'native_indian_alaskan',
                type: 'toggle',
                label: 'Are you an Alaskan or Native American Indian?',
                options: [
                  { label: 'Yes', value: true },
                  { label: 'No', value: false },
                ],
                validators: ['required'],
                description:
                  "You may be eligible for additional savings based on your status. Visit <a target='_blank' class='t-link' href='https://www.healthcare.gov/'>HealthCare.gov</a> or call <a class='t-link' href='tel: 111-111-1111'>111-111-1111</a> for more information.",
              },
              {
                prop: 'native_indian_alaskan_message',
                type: 'description',
                label:
                  "You may be eligible for additional savings based on your status. Visit <a target='_blank' class='t-link' href='https://www.healthcare.gov/'>HealthCare.gov</a> or call <a class='t-link' href='tel:555-555-4444'>(555 )555-4444</a> for more information.",
                conditional: {
                  when: [
                    {
                      prop: 'native_indian_alaskan',
                      value: true,
                      comparator: 'EQUALS',
                    },
                  ],
                  connective: 'AND',
                },
              },
              {
                mask: 'currency',
                prop: 'annual_income',
                type: 'text',
                label: 'Household Income',
                validators: ['required'],
                description: 'Example: 20,000',
              },
            ],
            subtitle:
              'You may qualify for financial help based on your household size and income, or if you belong to a federally recognized American Indian tribe.',
            resultsTitle: 'Eligibility Results',
            stateSubsidy: {
              title: 'Eligibility Results',
              sections: {
                state: {
                  text: '<p>You are also eligible for an additional subsidy amount from the state of New Jersey.</p><p>Your state subsidy may be <strong>${state_subsidy_amount}/month</strong></p>',
                  type: 'text',
                  title: 'State Subsidy',
                  position: 2,
                },
                total: {
                  text: "<p>Your total subsidy may be <strong>${amount}/month</strong></p><p>Please note your subsidy is a preliminary estimate. We will work with your state's exchange or the Marketplace to finalize your exact tax credit amount before you complete your application.</p>",
                  type: 'text',
                  title: 'Total Subsidy',
                  position: 3,
                },
                federal: {
                  text: 'Your federal subsidy may be <strong>${federal_subsidy_amount}/month</strong>',
                  type: 'text',
                  title: 'Federal Subsidy',
                  position: 1,
                },
                __is_array: true,
              },
            },
            eligibilityTypes: {
              subsidy: {
                subsidy_note:
                  'Note: This is an estimate. Your actual savings will be calculated when you submit your application and receive your final eligibility results.',
                subsidy_text:
                  'Based on your household situation, you are eligible for an estimated subsidy amount of ',
              },
              medicaid:
                'Based on your household situation, you may be eligible for Medicaid. Visit <a class="t-link" target="_blank" href="https://www.healthcare.gov/">HealthCare.gov</a> or call <a class="t-data t-link" href="tel: 555-555-4444">(555) 555-4444</a> for more information.',
              ineligible:
                'Based on your household situation, you do not qualify for a subsidy. Visit <a class="t-link" target="_blank" href="https://www.healthcare.gov/">HealthCare.gov</a> or call <a class="t-data t-link" href="tel: 555-555-4444">(555) 555-4444</a> for more information.',
            },
            useAdvancedSubsidy: true,
            isSubsidyOffExchange: false,
          },
          coverage: {
            form: {
              county: {
                prop: 'county',
                type: 'dropdown',
                label: 'County',
                options: [],
                validators: ['required'],
                autocomplete: 'off',
              },
              zipcode: {
                mask: 'number',
                prop: 'zipcode',
                type: 'text',
                label: 'ZIP Code',
                errors: { customErrMessage: 'Please enter a valid CA zipcode' },
                maxLength: 5,
                validators: ['required', 'zipcode'],
                enterAnother: 'Please enter another ZIP Code.',
              },
              coverage_type: {
                prop: 'coverage_type',
                type: 'checkbox',
                label: 'Coverage Type',
                options: [
                  { label: 'Medical', value: 'health' },
                  { label: 'Dental', value: 'dental' },
                  { label: 'Vision', value: 'vision' },
                ],
                validators: ['required'],
              },
            },
            icon: { iconName: 'coverage_gain', showIcon: true },
            text: {
              title: 'What Coverage Do You Need?',
              max_age_spouse_medicare_or_individual_or_dental:
                "<span class='t-bold'>Please Note:</span> Based on the date of birth you entered, your spouse may qualify for Medicare. You can view our Medicare-eligible plans at <a href='https://blueshieldcamedicare.com' class='t-data t-link'>https://blueshieldcamedicare.com</a>. If you would prefer an Individual & Family plan instead, please call us at <a href='tel: (888) 273-0010' class='t-data t-link'>(888) 273-0010</a> to apply. If you are only interested in purchasing a dental or vision plan, select Dental and/or Vision plan",
              max_age_subscriber_medicare_or_individual_or_dental:
                "<span class='t-bold'>Please Note:</span> Based on the date of birth you entered, you may qualify for Medicare. You can view our Medicare-eligible plans at <a href='https://blueshieldcamedicare.com' class='t-data t-link'>https://blueshieldcamedicare.com</a>. If you would prefer an Individual & Family plan instead, please call us at <a href='tel: (888) 273-0010' class='t-data t-link'>(888) 273-0010 </a>to apply. If you are only interested in purchasing a dental or vision plan, select Dental and/or Vision plan",
            },
            title: "Let's find you a plan",
            messages: {
              aep: 'You can still enroll in the Annual Enrollment Period by choosing one of the following dates:',
              sep: "Open Enrollment ended January 15, but you can still qualify for health coverage if you experienced a <span class='t-link'>qualifying event</span>. The next open enrollment period begins October 15th.",
            },
          },
          childLimit: 8,
          leadConfig: {
            form: {
              controls: [
                {
                  mask: 'alpha',
                  prop: 'first_name',
                  type: 'text',
                  label: 'First Name (Optional)',
                  maxLength: 15,
                  validators: [
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  mask: 'alpha',
                  prop: 'last_name',
                  type: 'text',
                  label: 'Last Name (Optional)',
                  maxLength: 20,
                  validators: [
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  prop: 'email_address',
                  type: 'text',
                  label: 'Email (Optional)',
                  maxLength: 40,
                  validators: ['email'],
                },
                {
                  mask: 'phone',
                  prop: 'home_phone',
                  type: 'text',
                  label: 'Phone Number (Optional)',
                  maxLength: 12,
                  validators: ['phone'],
                },
                {
                  prop: 'home_phone_type',
                  type: 'radio',
                  label: 'Phone Type',
                  options: [
                    { label: 'Cell', value: 'Cell' },
                    { label: 'Home', value: 'Home' },
                    { label: 'Work', value: 'Work' },
                  ],
                },
                {
                  prop: 'tell_memore_subsriber',
                  type: 'description',
                  label:
                    'I consent to receive phone calls and emails from Brand Health, regarding my quote or application, at the email address and phone number provided, including my wireless number if provided. I understand calls may be generated using an automated technology and that a licensed insurance agent may contact me.',
                },
              ],
            },
            icon: { iconName: 'email_product', showIcon: true },
            title: 'Tell Us More About You (Optional)',
            subtitle: ' ',
          },
          parentLimit: 8,
          isQLEenabled: true,
          coverageByState: false,
          hasParentDependents: false,
          openEnrollmentRange: {
            endDate: '12/31/2024',
            startDate: '07/01/2024',
          },
          windowShoppingRange: { endDate: '10/15', startDate: '09/01' },
          stateNotLicensedError: {
            enabled: false,
            message:
              'Unfortunately, you cannot shop for plans in this state. Please contact your Broker for further assistance.',
          },
          coverage_effective_date: {
            title: {
              OE: 'You are eligible for coverage starting on ${date}',
              SEP: 'Please select the QLE that applies to you or someone in your household in the past 60 days.',
            },
            subtitle: { OE: '', SEP: '' },
            textTemplates: {
              title: {
                OE: 'You are eligible for coverage starting on ${date}',
                SEP: 'Please select the QLE that applies to you or someone in your household in the past 60 days.',
              },
              subtitle: { OE: '', SEP: ' ' },
            },
          },
          reimbursementArrangement: { showReimbursementForm: false },
        },
        doctorSearch: {
          filters: {
            groups: [
              {
                prop: 'specialties',
                controls: [
                  {
                    prop: 'specialties',
                    type: 'dropdown',
                    label: 'Specialties',
                    options: [],
                  },
                ],
              },
              {
                prop: 'sort_by',
                controls: [
                  {
                    prop: 'sort_by',
                    type: 'radio',
                    label: 'Sort By',
                    options: [
                      { label: 'Closest to me', value: 'distance' },
                      { label: 'Name (A - Z)', value: 'last_name' },
                    ],
                  },
                ],
              },
              {
                prop: 'filters',
                controls: [
                  {
                    prop: 'gender',
                    type: 'radio',
                    label: 'Gender',
                    options: [
                      { label: 'Female', value: 'female' },
                      { label: 'Male', value: 'male' },
                    ],
                  },
                  {
                    prop: 'language',
                    type: 'dropdown',
                    label: 'Language',
                    options: [
                      { label: 'Spanish', value: 'SP01' },
                      { label: 'Chinese', value: 'CH01' },
                      { label: 'Tagalog', value: 'TG01' },
                      { label: 'Vietnamese', value: 'VI01' },
                      { label: 'Afrikaans', value: 'AF01' },
                      { label: 'Amharic', value: 'AH01' },
                      { label: 'Arabic', value: 'AR01' },
                      { label: 'Armenian', value: 'AM01' },
                      { label: 'Assyrian', value: 'AS01' },
                      { label: 'Bengali', value: 'BE01' },
                      { label: 'Bulgarian', value: 'BL01' },
                      { label: 'Burmese', value: 'BU01' },
                      { label: 'Cambodian', value: 'CM01' },
                      { label: 'Cantonese', value: 'CA01' },
                      { label: 'Chinese', value: 'CH01' },
                      { label: 'Czech', value: 'CZ01' },
                      { label: 'Danish', value: 'DA01' },
                      { label: 'Dutch', value: 'DU01' },
                      { label: 'Egyptian', value: 'EG01' },
                      { label: 'English', value: null },
                      { label: 'Farsi', value: 'FA01' },
                      { label: 'Flemish', value: 'FL01' },
                      { label: 'French', value: 'FR01' },
                      { label: 'Fukien', value: 'FU01' },
                      { label: 'German', value: 'GE01' },
                      { label: 'Greek', value: 'GR01' },
                      { label: 'Gujarati', value: 'GU01' },
                      { label: 'Hakka', value: 'HA01' },
                      { label: 'Hebrew', value: 'HE01' },
                      { label: 'Hindi', value: 'HI01' },
                      { label: 'Hmong', value: 'HM01' },
                      { label: 'Hungarian', value: 'HU01' },
                      { label: 'Ibo', value: 'IB01' },
                      { label: 'Ilocano', value: 'IL01' },
                      { label: 'Indonesian', value: 'ID01' },
                      { label: 'Italian', value: 'IT01' },
                      { label: 'Japanese', value: 'JA01' },
                      { label: 'Kannada', value: 'KA01' },
                      { label: 'Konkani', value: 'KN01' },
                      { label: 'Korean', value: 'KO01' },
                      { label: 'Laotian', value: 'LO01' },
                      { label: 'Latin', value: 'LA01' },
                      { label: 'Malay', value: 'MY01' },
                      { label: 'Malayalam', value: 'MA01' },
                      { label: 'Mandarin', value: 'MN01' },
                      { label: 'Nepalese', value: 'NE01' },
                      { label: 'Nigerian', value: 'NI01' },
                      { label: 'Norwegian', value: 'NO01' },
                      { label: 'Pakistani', value: 'PA01' },
                      { label: 'Persian', value: 'PE01' },
                      { label: 'Polish', value: 'PO01' },
                      { label: 'Portuguese', value: 'PR01' },
                      { label: 'Punjabi', value: 'PU01' },
                      { label: 'Romanian', value: 'RO01' },
                      { label: 'Russian', value: 'RU01' },
                      { label: 'Serbian', value: 'SE01' },
                      { label: 'Serbo-Croatian', value: 'SC01' },
                      { label: 'Shanghanese', value: 'SH01' },
                      { label: 'Sign Language', value: 'SN01' },
                      { label: 'Sindhi', value: 'SI01' },
                      { label: 'Sinhala', value: 'SJ01' },
                      { label: 'Slovak', value: 'SL01' },
                      { label: 'Spanish', value: 'SP01' },
                      { label: 'Swahili', value: 'SA01' },
                      { label: 'Swedish', value: 'SW01' },
                      { label: 'Tagalog', value: 'TG01' },
                      { label: 'Taiwanese', value: 'TI01' },
                      { label: 'Tamil', value: 'TA01' },
                      { label: 'Telugu', value: 'TE01' },
                      { label: 'Thai', value: 'TH01' },
                      { label: 'Toisan', value: 'TS01' },
                      { label: 'Tongan', value: 'TO01' },
                      { label: 'Turkish', value: 'TU01' },
                      { label: 'Ukrainian', value: 'UK01' },
                      { label: 'Urdu', value: 'UR01' },
                      { label: 'Vietnamese', value: 'VI01' },
                      { label: 'Yiddish', value: 'YI01' },
                      { label: 'Yugoslavian', value: 'YU01' },
                    ],
                  },
                ],
              },
              {
                prop: 'hospital_affiliations',
                controls: [
                  {
                    prop: 'hospital_affiliations',
                    type: 'typeahead',
                    label: 'Hospital Affiliations',
                    errors: { customErrMessage: 'You must make a selection' },
                    options: [],
                    requireSelect: true,
                  },
                ],
              },
              {
                prop: 'medical_groups',
                controls: [
                  {
                    prop: 'medical_groups',
                    type: 'typeahead',
                    label: 'Medical Group Affiliations',
                    errors: { customErrMessage: 'You must make a selection' },
                    options: [],
                    requireSelect: true,
                  },
                ],
              },
            ],
          },
          endpoint: '/api/scapi/providers/search/',
          pageLength: 25,
          buttonConfig: {
            back: { size: 'fullWidth', level: 'medium', content: 'Back' },
            skip: { size: 'fullWidth', level: 'medium', content: 'Skip' },
            continue: {
              size: 'fullWidth',
              level: 'high',
              content: 'Save & Continue',
            },
          },
          incorrect_data: {
            groups: [
              {
                prop: 'correction_type',
                header: 'Correction Types',
                controls: [
                  {
                    prop: 'correction_type',
                    type: 'checkbox',
                    options: [
                      { label: 'Address incorrect', value: 'address' },
                      { label: 'Deceased / Retired', value: 'dead' },
                      {
                        label:
                          'Doctor indicates they no longer accept CareFirst Insurance',
                        value: 'not_accepting_insurance',
                      },
                      {
                        label: 'Doctor no longer accepts new patients',
                        value: 'not_accepting_patients',
                      },
                      {
                        label: 'Doctor left practice location',
                        value: 'doctor_left',
                      },
                      {
                        label: 'Duplicate listing',
                        value: 'duplicate_listing',
                      },
                      { label: 'Gender incorrect', value: 'gender' },
                      { label: 'Phone number incorrect', value: 'phone' },
                      {
                        label: 'Provider / Group name incorrect',
                        value: 'provider_group_name',
                      },
                      { label: 'Specialty incorrect', value: 'specialty' },
                      { label: 'Other (Comments Required)', value: 'other' },
                    ],
                  },
                ],
              },
              {
                prop: 'comments',
                header: 'Comments (optional)',
                controls: [{ prop: 'comments', type: 'textarea' }],
              },
              {
                prop: 'contact_info',
                header: 'Contact Information (optional)',
                controls: [
                  { prop: 'name', label: 'Your Name' },
                  {
                    hint: '(xxx) xxx-xxxx',
                    prop: 'phone',
                    label: 'Contact Number',
                  },
                  { prop: 'email', type: 'email', label: 'Email Address' },
                ],
              },
            ],
          },
          searchBarConfig: {
            header: 'Choose a PCP for your household',
            subHeader: [],
            searchConfig: {
              uniqueName: 'Location',
              locationConfig: { within: [1, 5, 10, 15, 25] },
              defaultDistance: 5,
            },
            searchBarHeaderText: '',
          },
          asideHeaderConfig: {
            header: 'Household Members',
            subHeader:
              'Select a member below to assign a Primary Care Physician (PCP).',
            showAsideHeader: true,
          },
          preFilterEndpoint: '/api/scapi/prefilters/',
          providerCardConfig: {
            attributes: [
              { type: 'name', suffix: ', MD' },
              { type: 'specialty' },
              { type: 'phone' },
              { text: 'Get Directions', type: 'address' },
              {
                prop: 'distance',
                type: 'generic',
                prefix: 'Distance from your Address:',
                suffix: 'miles.',
              },
              {
                prop: 'medical_group',
                type: 'generic',
                prefix: 'Medical Group Affiliation:',
              },
            ],
            buttonConfig: {
              add: { size: 'full', level: 'medium', content: 'Add' },
              Selected: {
                icon: 'check',
                size: 'full',
                level: 'high',
                content: 'Add',
                iconFill: 'success',
              },
            },
          },
        },
        dental_vision: {
          header: 'Get Optional Dental Coverage',
          filters: { controls: [] },
          subHeader: 'Good health includes your dental plan.',
          showCompare: false,
          showFilters: false,
          maxSelectable: 4,
          useTypeHealth: true,
          multiPlanTypes: [
            {
              prop: 'bundled',
              label: 'Bundled',
              conditional: { health: { prop: 'bundled', label: 'Bundled' } },
            },
            {
              prop: 'dental',
              label: 'Dental',
              conditional: { dental: { prop: 'dental', label: 'Dental' } },
            },
            {
              prop: 'vision',
              label: 'Vision',
              conditional: { vision: { prop: 'vision', label: 'Vision' } },
            },
          ],
          showSiteFooter: true,
          extraPlanFilters: {
            ordering: 'display_name',
            market_segment: 'individual',
          },
          showShoppingCart: true,
          footerNextButtonDisplayText: 'Enroll in Selected Plan',
        },
        personal_info: {
          forms: {
            spouse: {
              title: "Your Spouse/Partner's ",
              hidden: true,
              controls: [
                {
                  mask: 'alpha',
                  prop: 'first_name',
                  type: 'text',
                  label: 'First Name',
                  maxLength: 15,
                  validators: [
                    'required',
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  mask: 'alpha',
                  prop: 'middle_initial',
                  type: 'text',
                  label: 'Middle Initial',
                  maxLength: 1,
                  validators: ['alpha'],
                },
                {
                  mask: 'alpha',
                  prop: 'last_name',
                  type: 'text',
                  label: 'Last Name',
                  maxLength: 20,
                  validators: [
                    'required',
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  prop: 'email_address',
                  type: 'text',
                  label: 'Email Address',
                  maxLength: 40,
                  validators: ['email'],
                },
                {
                  prop: 'suffix',
                  type: 'text',
                  label: 'Suffix',
                  maxLength: 3,
                  validators: [
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '_',
                        '-',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        ' ',
                        "'",
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  mask: 'ssn',
                  prop: 'ssn',
                  type: 'text',
                  label: 'SSN',
                  errors: { customErrMessage: 'SSN must be unique' },
                  naLabel: 'SSN not available',
                  tooltip:
                    'The Affordable Care Act requires that everyone have health insurance or pay a tax penalty. Your Social Security Number is required on this application and will be used to inform the government that you have applied for coverage and should not be penalized.',
                  canToggle: true,
                  inputType: 'password',
                  maxLength: 11,
                  validators: [
                    'ssnDigits',
                    {
                      name: 'requiredIf',
                      prop: 'ssn',
                      message: 'SSN not available',
                      dependency: {
                        requiredIfProp: 'ssn_check',
                        requiredIfPropExpectedValue: false,
                      },
                    },
                  ],
                  inputValidators: ['required', 'social'],
                },
                {
                  prop: 'ssn_check',
                  type: 'singleCheckbox',
                  checkboxLabel: 'SSN not available',
                },
                {
                  prop: 'date_of_birth',
                  type: 'date',
                  label: 'Date of Birth',
                  readonly: true,
                },
                {
                  prop: 'gender',
                  type: 'toggle',
                  label: 'Gender',
                  options: [
                    { label: 'Male', value: 'male' },
                    { label: 'Female', value: 'female' },
                  ],
                  validators: ['required'],
                },
                {
                  prop: 'relationship_to_primary',
                  type: 'dropdownOther',
                  label: 'Relationship With Primary Applicant',
                  default: '',
                  options: [
                    { label: 'Husband', value: 'Husband' },
                    { label: 'Wife', value: 'Wife' },
                    { label: 'Domestic Partner', value: 'Domestic Partner' },
                  ],
                  validators: ['required'],
                },
                {
                  prop: 'language_preference',
                  type: 'dropdownOther',
                  label: 'Spoken Language Preference',
                  default: '',
                  options: [
                    { label: 'English', value: 'EN' },
                    { label: 'Spanish', value: 'ES' },
                    { label: 'Cantonese', value: '12' },
                    { label: 'Mandarin', value: '14' },
                    { label: 'Vietnamese', value: 'VI' },
                    { label: 'Korean', value: 'KO' },
                    { label: 'Tagalog', value: 'TL' },
                    { label: 'Armenian', value: 'HY' },
                    { label: 'Japanese', value: 'JA' },
                    { label: 'Persian', value: 'PS' },
                    { label: 'Punjabi', value: 'PA' },
                    { label: 'Khmer', value: 'LO' },
                    { label: 'Arabic', value: 'AR' },
                    { label: 'White Hmong', value: '03' },
                    { label: 'Blue/Green Hmong', value: '28' },
                    { label: 'Russian', value: 'RU' },
                    { label: 'Declines to State', value: '00' },
                    { label: 'Other', value: '99' },
                  ],
                  otherValue: '99',
                  validators: ['required'],
                },
                {
                  prop: 'written_language_preference',
                  type: 'dropdownOther',
                  label: 'Written Language Preference',
                  default: '',
                  options: [
                    { label: 'English', value: 'EN' },
                    { label: 'Spanish', value: 'ES' },
                    { label: 'Traditional Chinese', value: '20' },
                    { label: 'Vietnamese', value: 'VI' },
                    { label: 'Korean', value: 'KO' },
                    { label: 'Tagalog', value: 'TL' },
                    { label: 'Armenian', value: 'HY' },
                    { label: 'Japanese', value: 'JA' },
                    { label: 'Persian', value: 'PS' },
                    { label: 'Punjabi', value: 'PA' },
                    { label: 'Khmer', value: 'LO' },
                    { label: 'Arabic', value: 'AR' },
                    { label: 'White Hmong', value: '03' },
                    { label: 'Blue/Green Hmong', value: '28' },
                    { label: 'Russian', value: 'RU' },
                    { label: 'Declines to State', value: '00' },
                    { label: 'Other', value: '99' },
                  ],
                  otherValue: '99',
                  validators: ['required'],
                },
                {
                  prop: 'hispanic_latino_spanish_origin',
                  type: 'radio',
                  label: 'Are you Hispanic, Latino/a or Spanish origin?',
                  display: { format: 'SNAKE_CASE_TO_TITLE' },
                  options: [
                    { label: 'Yes', value: 'yes' },
                    { label: 'No', value: 'no' },
                    {
                      label: 'I choose not to answer',
                      value: 'choose_not_to_answer',
                    },
                    { label: 'I do not know', value: 'DC' },
                  ],
                  validators: ['required'],
                },
                {
                  id: 'spouse_ethnicities',
                  prop: 'ethnicities',
                  type: 'checkbox',
                  label: 'Ethnicity (select all that apply)',
                  display: { format: 'SNAKE_CASE_TO_TITLE' },
                  options: [
                    {
                      label: 'Mexican, Mexican-American, Chicano/a',
                      value: '1001',
                    },
                    { label: 'Puerto Rican', value: '1002' },
                    { label: 'Cuban', value: '1000' },
                    {
                      label: 'Another Hispanic, Latino/a, or Spanish Origin',
                      value: '1003',
                    },
                  ],
                  conditions: {
                    all: [
                      {
                        name: 'hispanic_latino_spanish_origin',
                        value: 'yes',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                  validators: [
                    'required',
                    {
                      name: 'arrayHasValue',
                      message: 'At least one selection is required.',
                    },
                  ],
                },
                {
                  prop: 'identify_race',
                  type: 'radio',
                  label: 'Would you like to identify your race?',
                  display: { format: 'SNAKE_CASE_TO_TITLE' },
                  options: [
                    { label: 'Yes', value: 'yes' },
                    { label: 'No', value: 'no' },
                    {
                      label: 'I choose not to answer',
                      value: 'choose_not_to_answer',
                    },
                    { label: 'I do not know', value: 'DC' },
                  ],
                  validators: ['required'],
                },
                {
                  id: 'spouse_races',
                  prop: 'races',
                  type: 'checkbox',
                  label: 'Race (select all that apply) ',
                  display: { format: 'SNAKE_CASE_TO_TITLE' },
                  options: [
                    { label: 'White', value: '1013' },
                    { label: 'Black or African American', value: '1002' },
                    {
                      label: 'American Indian or Alaska Native',
                      value: '1000',
                    },
                    { label: 'Asian Indian', value: '1001' },
                    { label: 'Chinese', value: '1003' },
                    { label: 'Japanese', value: '1006' },
                    { label: 'Korean', value: '1007' },
                    { label: 'Filipino', value: '1004' },
                    { label: 'Other Asian', value: '1021' },
                    { label: 'Native Hawaiian', value: '1008' },
                    { label: 'Vietnamese', value: '1012' },
                    { label: 'Guamanian or Chamorro', value: '1005' },
                    { label: 'Other Pacific Islander', value: '1022' },
                    { label: 'Samoan', value: '1011' },
                    { label: 'Middle Eastern or North African', value: '1023' },
                    { label: 'Another Race Not Listed Above', value: '1024' },
                  ],
                  conditions: {
                    all: [
                      {
                        name: 'identify_race',
                        value: 'yes',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                  validators: [
                    'required',
                    {
                      name: 'arrayHasValue',
                      message: 'At least one selection is required.',
                    },
                  ],
                },
                {
                  grid: { col: '1 / end', row: '17' },
                  prop: 'sex_assigned_at_birth',
                  type: 'dropdown',
                  label:
                    'What was your sex assigned at birth? You can find this on an original birth certificate or similar document.',
                  display: {
                    format: 'SNAKE_CASE_TO_TITLE',
                    conditional: {
                      when: [
                        {
                          prop: 'data.subscriber.sex_assigned_at_birth',
                          comparator: 'EXISTS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  options: [
                    { label: 'Female', value: 'F' },
                    { label: 'Male', value: 'M' },
                    { label: 'Not sure', value: 'NS' },
                    { label: 'I choose not to answer', value: 'DC' },
                    { label: 'A sex that’s not listed', value: 'not_listed' },
                  ],
                  validators: ['required'],
                },
                {
                  grid: { col: '1 / end', row: '18' },
                  mask: 'alpha',
                  prop: 'not_listed_sex_assigned_at_birth',
                  type: 'text',
                  label: 'Please enter your sex assigned at birth.',
                  display: {
                    conditional: {
                      when: [
                        {
                          prop: 'data.workflow.values.subscriber.not_listed_sex_assigned_at_birth',
                          value: true,
                          comparator: 'EQUALS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  maxLength: 46,
                  conditions: {
                    all: [
                      {
                        name: 'sex_assigned_at_birth',
                        value: 'not_listed',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                  validators: [
                    'required',
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '-',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  grid: { col: '1 / end', row: '19' },
                  prop: 'gender_identity',
                  type: 'dropdown',
                  label: 'What’s your gender identity?',
                  display: {
                    format: 'SNAKE_CASE_TO_TITLE',
                    conditional: {
                      when: [
                        {
                          prop: 'data.subscriber.gender_identity',
                          comparator: 'EXISTS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  options: [
                    { label: 'Female', value: 'F' },
                    { label: 'Male', value: 'M' },
                    { label: 'Transgender female', value: 'TF' },
                    { label: 'Transgender male', value: 'TM' },
                    { label: 'Not sure', value: 'NS' },
                    { label: 'I choose not to answer', value: 'DC' },
                    {
                      label: 'A gender that’s not listed',
                      value: 'not_listed',
                    },
                  ],
                  validators: ['required'],
                },
                {
                  grid: { col: '1 / end', row: '20' },
                  mask: 'alpha',
                  prop: 'not_listed_gender_identity',
                  type: 'text',
                  label: 'Please enter your gender identity.',
                  display: {
                    conditional: {
                      when: [
                        {
                          prop: 'data.workflow.values.subscriber.not_listed_gender_identity',
                          value: true,
                          comparator: 'EQUALS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  maxLength: 46,
                  conditions: {
                    all: [
                      {
                        name: 'gender_identity',
                        value: 'not_listed',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                  validators: [
                    'required',
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '-',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  grid: { col: '1 / end', row: '21' },
                  prop: 'sexual_orientation',
                  type: 'dropdown',
                  label: 'What’s your sexual orientation?',
                  display: {
                    format: 'SNAKE_CASE_TO_TITLE',
                    conditional: {
                      when: [
                        {
                          prop: 'data.subscriber.sexual_orientation',
                          comparator: 'EXISTS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  options: [
                    { label: 'Lesbian or gay', value: 'LG' },
                    { label: 'Straight', value: 'ST' },
                    { label: 'Bisexual', value: 'BI' },
                    { label: 'Not sure', value: 'NS' },
                    { label: 'I choose not to answer', value: 'DC' },
                    {
                      label: 'A sexual orientation that’s not listed',
                      value: 'not_listed',
                    },
                  ],
                  validators: ['required'],
                },
                {
                  grid: { col: '1 / end', row: '22' },
                  mask: 'alpha',
                  prop: 'not_listed_sexual_orientation',
                  type: 'text',
                  label: 'Please enter your sexual orientation.',
                  display: {
                    conditional: {
                      when: [
                        {
                          prop: 'data.workflow.values.subscriber.not_listed_sexual_orientation',
                          value: true,
                          comparator: 'EQUALS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  maxLength: 46,
                  conditions: {
                    all: [
                      {
                        name: 'sexual_orientation',
                        value: 'not_listed',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                  validators: [
                    'required',
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '-',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  prop: 'medicare_eligible',
                  type: 'toggle',
                  label: 'Are you eligible for Medicare?',
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                  validators: ['required'],
                  conditionalControls: [
                    {
                      prop: 'medicare_eligible_applicant_name',
                      type: 'text',
                      label: 'Applicant Name',
                      validators: ['required'],
                    },
                  ],
                },
                {
                  prop: 'medicare_enrolled',
                  type: 'radio',
                  label: 'Are you covered under Medicare Part A or Part B?',
                  errors: {
                    equals:
                      "If you're already covered by Medicare Part A or Part B and have questions, call us at 1-800-670-5935 (TTY 711).",
                  },
                  options: [
                    { label: 'Yes', value: 'true' },
                    { label: 'No', value: 'false' },
                  ],
                  validators: [
                    'required',
                    { name: 'equals', dependency: 'false' },
                  ],
                  conditionalControls: [
                    {
                      prop: 'medicare_enrolled_applicant_name',
                      type: 'text',
                      label: 'Applicant Name',
                      validators: ['required'],
                    },
                  ],
                },
              ],
              titleSuffix: 'Information',
            },
            dependents: {
              title: "Dependent's ",
              hidden: true,
              controls: [
                {
                  mask: 'alpha',
                  prop: 'first_name',
                  type: 'text',
                  label: 'First Name',
                  maxLength: 15,
                  validators: [
                    'required',
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  mask: 'alpha',
                  prop: 'middle_initial',
                  type: 'text',
                  label: 'Middle Initial',
                  maxLength: 1,
                  validators: ['alpha'],
                },
                {
                  mask: 'alpha',
                  prop: 'last_name',
                  type: 'text',
                  label: 'Last Name',
                  maxLength: 20,
                  validators: [
                    'required',
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  prop: 'suffix',
                  type: 'text',
                  label: 'Suffix',
                  maxLength: 3,
                  validators: [
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '_',
                        '-',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        ' ',
                        "'",
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  mask: 'ssn',
                  prop: 'ssn',
                  type: 'text',
                  label: 'SSN',
                  errors: { customErrMessage: 'SSN must be unique' },
                  naLabel: 'SSN not available',
                  tooltip:
                    'The Affordable Care Act requires that everyone have health insurance or pay a tax penalty. Your Social Security Number is required on this application and will be used to inform the government that you have applied for coverage and should not be penalized.',
                  canToggle: true,
                  inputType: 'password',
                  maxLength: 11,
                  validators: [
                    'ssnDigits',
                    {
                      name: 'requiredIf',
                      prop: 'ssn',
                      message: 'SSN not available',
                      dependency: {
                        requiredIfProp: 'ssn_check',
                        requiredIfPropExpectedValue: false,
                      },
                    },
                  ],
                  inputValidators: ['required', 'social'],
                },
                {
                  prop: 'ssn_check',
                  type: 'singleCheckbox',
                  checkboxLabel: 'SSN not available',
                },
                {
                  prop: 'relationship_to_subscriber',
                  type: 'dropdownOther',
                  label: 'Relationship to Applicant',
                  onlyIf: 'isNotChildOnlyApplication',
                  options: [
                    { label: 'Child', value: 'child' },
                    { label: 'Adopted Child', value: 'adopted' },
                    { label: 'Step-Child', value: 'step_child' },
                    { label: 'Foster Child', value: 'foster_child' },
                    { label: 'Grand Child', value: 'grand_child' },
                  ],
                  validators: ['required'],
                  placeholder: 'Select one',
                },
                {
                  mask: 'phone',
                  prop: 'home_phone',
                  type: 'text',
                  label: 'Primary Phone Number',
                  onlyIf: 'isChildOnlyApplication',
                  maxLength: 12,
                  validators: ['required', 'phone'],
                },
                {
                  prop: 'home_phone_type',
                  type: 'radio',
                  label: 'Primary Phone Number Type',
                  onlyIf: 'isChildOnlyApplication',
                  options: [
                    { label: 'Cell', value: 'cell' },
                    { label: 'Home', value: 'home' },
                    { label: 'Work', value: 'work' },
                  ],
                  validators: ['required'],
                },
                {
                  mask: 'phone',
                  prop: 'secondary_phone',
                  type: 'text',
                  label: 'Secondary Phone Number',
                  onlyIf: 'isChildOnlyApplication',
                  maxLength: 12,
                  validators: ['phone'],
                },
                {
                  prop: 'secondary_phone_type',
                  type: 'radio',
                  label: 'Secondary Phone Number Type',
                  onlyIf: 'isChildOnlyApplication',
                  options: [
                    { label: 'Cell', value: 'cell' },
                    { label: 'Home', value: 'home' },
                    { label: 'Work', value: 'work' },
                  ],
                },
                {
                  prop: 'date_of_birth',
                  type: 'date',
                  label: 'Date of Birth',
                  readonly: true,
                },
                {
                  prop: 'language_preference',
                  type: 'dropdownOther',
                  label: 'Spoken Language Preference',
                  default: '',
                  options: [
                    { label: 'English', value: 'EN' },
                    { label: 'Spanish', value: 'ES' },
                    { label: 'Cantonese', value: '12' },
                    { label: 'Mandarin', value: '14' },
                    { label: 'Vietnamese', value: 'VI' },
                    { label: 'Korean', value: 'KO' },
                    { label: 'Tagalog', value: 'TL' },
                    { label: 'Armenian', value: 'HY' },
                    { label: 'Japanese', value: 'JA' },
                    { label: 'Persian', value: 'PS' },
                    { label: 'Punjabi', value: 'PA' },
                    { label: 'Khmer', value: 'LO' },
                    { label: 'Arabic', value: 'AR' },
                    { label: 'White Hmong', value: '03' },
                    { label: 'Blue/Green Hmong', value: '28' },
                    { label: 'Russian', value: 'RU' },
                    { label: 'Declines to State', value: 'EN' },
                    { label: 'Other', value: '99' },
                  ],
                  otherValue: '99',
                  validators: ['required'],
                },
                {
                  prop: 'written_language_preference',
                  type: 'dropdownOther',
                  label: 'Written Language Preference',
                  default: '',
                  options: [
                    { label: 'English', value: 'EN' },
                    { label: 'Spanish', value: 'ES' },
                    { label: 'Traditional Chinese', value: '20' },
                    { label: 'Vietnamese', value: 'VI' },
                    { label: 'Korean', value: 'KO' },
                    { label: 'Tagalog', value: 'TL' },
                    { label: 'Armenian', value: 'HY' },
                    { label: 'Japanese', value: 'JA' },
                    { label: 'Persian', value: 'PS' },
                    { label: 'Punjabi', value: 'PA' },
                    { label: 'Khmer', value: 'LO' },
                    { label: 'Arabic', value: 'AR' },
                    { label: 'White Hmong', value: '03' },
                    { label: 'Blue/Green Hmong', value: '28' },
                    { label: 'Russian', value: 'RU' },
                    { label: 'Declines to State', value: '00' },
                    { label: 'Other', value: '99' },
                  ],
                  otherValue: '99',
                  validators: ['required'],
                },
                {
                  prop: 'hispanic_latino_spanish_origin',
                  type: 'radio',
                  label: 'Are you Hispanic, Latino/a or Spanish origin?',
                  display: { format: 'SNAKE_CASE_TO_TITLE' },
                  options: [
                    { label: 'Yes', value: 'yes' },
                    { label: 'No', value: 'no' },
                    {
                      label: 'I choose not to answer',
                      value: 'choose_not_to_answer',
                    },
                    { label: 'I do not know', value: 'DC' },
                  ],
                  validators: ['required'],
                },
                {
                  id: 'dependents_ethnicities',
                  prop: 'ethnicities',
                  type: 'checkbox',
                  label: 'Ethnicity (select all that apply)',
                  display: { format: 'SNAKE_CASE_TO_TITLE' },
                  options: [
                    {
                      label: 'Mexican, Mexican-American, Chicano/a',
                      value: '1001',
                    },
                    { label: 'Puerto Rican', value: '1002' },
                    { label: 'Cuban', value: '1000' },
                    {
                      label: 'Another Hispanic, Latino/a, or Spanish Origin',
                      value: '1003',
                    },
                  ],
                  conditions: {
                    all: [
                      {
                        name: 'hispanic_latino_spanish_origin',
                        value: 'yes',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                  validators: [
                    'required',
                    {
                      name: 'arrayHasValue',
                      message: 'At least one selection is required.',
                    },
                  ],
                },
                {
                  prop: 'identify_race',
                  type: 'radio',
                  label: 'Would you like to identify your race?',
                  display: { format: 'SNAKE_CASE_TO_TITLE' },
                  options: [
                    { label: 'Yes', value: 'yes' },
                    { label: 'No', value: 'no' },
                    {
                      label: 'I choose not to answer',
                      value: 'choose_not_to_answer',
                    },
                    { label: 'I do not know', value: 'DC' },
                  ],
                  validators: ['required'],
                },
                {
                  id: 'dependents_race',
                  prop: 'races',
                  type: 'checkbox',
                  label: 'Race (select all that apply) ',
                  display: { format: 'SNAKE_CASE_TO_TITLE' },
                  options: [
                    { label: 'White', value: '1013' },
                    { label: 'Black or African American', value: '1002' },
                    {
                      label: 'American Indian or Alaska Native',
                      value: '1000',
                    },
                    { label: 'Asian Indian', value: '1001' },
                    { label: 'Chinese', value: '1003' },
                    { label: 'Japanese', value: '1006' },
                    { label: 'Korean', value: '1007' },
                    { label: 'Filipino', value: '1004' },
                    { label: 'Other Asian', value: '1021' },
                    { label: 'Native Hawaiian', value: '1008' },
                    { label: 'Vietnamese', value: '1012' },
                    { label: 'Guamanian or Chamorro', value: '1005' },
                    { label: 'Other Pacific Islander', value: '1022' },
                    { label: 'Samoan', value: '1011' },
                    { label: 'Middle Eastern or North African', value: '1023' },
                    { label: 'Another Race Not Listed Above', value: '1024' },
                  ],
                  conditions: {
                    all: [
                      {
                        name: 'identify_race',
                        value: 'yes',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                  validators: [
                    'required',
                    {
                      name: 'arrayHasValue',
                      message: 'At least one selection is required.',
                    },
                  ],
                },
                {
                  grid: { col: '1 / end', row: '17' },
                  prop: 'sex_assigned_at_birth',
                  type: 'dropdown',
                  label:
                    'What was your sex assigned at birth? You can find this on an original birth certificate or similar document.',
                  display: {
                    format: 'SNAKE_CASE_TO_TITLE',
                    conditional: {
                      when: [
                        {
                          prop: 'data.subscriber.sex_assigned_at_birth',
                          comparator: 'EXISTS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  options: [
                    { label: 'Female', value: 'F' },
                    { label: 'Male', value: 'M' },
                    { label: 'Not sure', value: 'NS' },
                    { label: 'I choose not to answer', value: 'DC' },
                    { label: 'A sex that’s not listed', value: 'not_listed' },
                  ],
                  validators: ['required'],
                },
                {
                  grid: { col: '1 / end', row: '18' },
                  mask: 'alpha',
                  prop: 'not_listed_sex_assigned_at_birth',
                  type: 'text',
                  label: 'Please enter your sex assigned at birth.',
                  display: {
                    conditional: {
                      when: [
                        {
                          prop: 'data.workflow.values.subscriber.not_listed_sex_assigned_at_birth',
                          value: true,
                          comparator: 'EQUALS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  maxLength: 46,
                  conditions: {
                    all: [
                      {
                        name: 'sex_assigned_at_birth',
                        value: 'not_listed',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                  validators: [
                    'required',
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '-',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  grid: { col: '1 / end', row: '19' },
                  prop: 'gender_identity',
                  type: 'dropdown',
                  label: 'What’s your gender identity?',
                  display: {
                    format: 'SNAKE_CASE_TO_TITLE',
                    conditional: {
                      when: [
                        {
                          prop: 'data.subscriber.gender_identity',
                          comparator: 'EXISTS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  options: [
                    { label: 'Female', value: 'F' },
                    { label: 'Male', value: 'M' },
                    { label: 'Transgender female', value: 'TF' },
                    { label: 'Transgender male', value: 'TM' },
                    { label: 'Not sure', value: 'NS' },
                    { label: 'I choose not to answer', value: 'DC' },
                    {
                      label: 'A gender that’s not listed',
                      value: 'not_listed',
                    },
                  ],
                  validators: ['required'],
                },
                {
                  grid: { col: '1 / end', row: '20' },
                  mask: 'alpha',
                  prop: 'not_listed_gender_identity',
                  type: 'text',
                  label: 'Please enter your gender identity.',
                  display: {
                    conditional: {
                      when: [
                        {
                          prop: 'data.workflow.values.subscriber.not_listed_gender_identity',
                          value: true,
                          comparator: 'EQUALS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  maxLength: 46,
                  conditions: {
                    all: [
                      {
                        name: 'gender_identity',
                        value: 'not_listed',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                  validators: [
                    'required',
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '-',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  grid: { col: '1 / end', row: '21' },
                  prop: 'sexual_orientation',
                  type: 'dropdown',
                  label: 'What’s your sexual orientation?',
                  display: {
                    format: 'SNAKE_CASE_TO_TITLE',
                    conditional: {
                      when: [
                        {
                          prop: 'data.subscriber.sexual_orientation',
                          comparator: 'EXISTS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  options: [
                    { label: 'Lesbian or gay', value: 'LG' },
                    { label: 'Straight', value: 'ST' },
                    { label: 'Bisexual', value: 'BI' },
                    { label: 'Not sure', value: 'NS' },
                    { label: 'I choose not to answer', value: 'DC' },
                    {
                      label: 'A sexual orientation that’s not listed',
                      value: 'not_listed',
                    },
                  ],
                  validators: ['required'],
                },
                {
                  grid: { col: '1 / end', row: '22' },
                  mask: 'alpha',
                  prop: 'not_listed_sexual_orientation',
                  type: 'text',
                  label: 'Please enter your sexual orientation.',
                  display: {
                    conditional: {
                      when: [
                        {
                          prop: 'data.workflow.values.subscriber.not_listed_sexual_orientation',
                          value: true,
                          comparator: 'EQUALS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  maxLength: 46,
                  conditions: {
                    all: [
                      {
                        name: 'sexual_orientation',
                        value: 'not_listed',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                  validators: [
                    'required',
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '-',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  prop: 'email_address',
                  type: 'text',
                  label: 'Email Address',
                  onlyIf: 'isChildOnlyApplication',
                  maxLength: 40,
                  validators: ['required', 'email'],
                },
                {
                  prop: 'is_attestation_of_communication_consent_granted',
                  type: 'singleCheckbox',
                  label: 'Attestation of Communication Consent',
                  onlyIf: 'isChildOnlyApplication',
                  checkboxLabel:
                    'I agree that Brand Health and its affiliated entities and agents may communicate with me about my account and various health and wellness programs available to me, and other promotional information that may benefit me and my dependents, including by phone or text to the numbers I have listed on this form, using an auto-dialer or artificial or prerecorded voice; standard data rates apply.',
                  showCheckboxLabelRequired: false,
                },
                {
                  prop: 'contact_attestation',
                  type: 'checkbox',
                  label:
                    'I understand the company may contact me about my quote or application at the email address and phone number above, including my wireless number if provided. I understand calls may be generated using an automated technology.',
                  errors: { arrayHasValue: 'Must be selected to proceed' },
                  onlyIf: 'isChildOnlyApplication',
                  options: [{ label: 'Agree', value: 'agree' }],
                  validators: ['required', 'arrayHasValue'],
                },
                {
                  prop: 'medicare_eligible',
                  type: 'toggle',
                  label: 'Are you eligible for Medicare?',
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                  validators: ['required'],
                  conditionalControls: [
                    {
                      prop: 'medicare_eligible_applicant_name',
                      type: 'text',
                      label: 'Applicant Name',
                      validators: ['required'],
                    },
                  ],
                },
                {
                  prop: 'medicare_enrolled',
                  type: 'radio',
                  label: 'Are you covered under Medicare Part A or Part B?',
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                  validators: ['required'],
                  conditionalControls: [
                    {
                      prop: 'medicare_enrolled_applicant_name',
                      type: 'text',
                      label: 'Applicant Name',
                      validators: ['required'],
                    },
                  ],
                },
                {
                  prop: 'qmcso',
                  type: 'toggle',
                  label:
                    'Is there a Qualified Medical Child Support Order (*QMCSO)?',
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                  tooltip:
                    "A medical child support order which creates or recognizes the existence of a child's right to receive medical benefits which the responsible parent is eligible for under a health plan.",
                  validators: ['required'],
                  conditional: {
                    when: [
                      {
                        prop: 'date_of_birth',
                        value: '<21',
                        comparator: 'COMPAREYEAR',
                      },
                    ],
                  },
                },
                {
                  prop: 'gender',
                  type: 'toggle',
                  label: 'Gender',
                  options: [
                    { label: 'Male', value: 'male' },
                    { label: 'Female', value: 'female' },
                  ],
                  validators: ['required'],
                },
              ],
              titleSuffix: 'Information',
              childOnlyTitle: "Dependent's ",
              stepParentTitle: 'Parent(s)/Step-Parent(s)',
            },
            subscriber: {
              title: 'Subscriber Information',
              hidden: true,
              controls: [
                {
                  prop: 'first_name',
                  type: 'text',
                  label: 'First Name',
                  maxLength: 15,
                  validators: [
                    'required',
                    'alpha',
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  prop: 'middle_initial',
                  type: 'text',
                  label: 'Middle Initial',
                  maxLength: 1,
                  validators: ['alpha'],
                },
                {
                  prop: 'last_name',
                  type: 'text',
                  label: 'Last Name',
                  maxLength: 20,
                  validators: [
                    'required',
                    'alpha',
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  prop: 'suffix',
                  type: 'text',
                  label: 'Suffix',
                  maxLength: 3,
                  validators: [
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '_',
                        '-',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        ' ',
                        "'",
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  mask: 'ssn',
                  prop: 'ssn',
                  type: 'text',
                  label: 'SSN',
                  errors: { customErrMessage: 'SSN must be unique' },
                  naLabel: 'SSN not available',
                  tooltip:
                    'The Affordable Care Act requires that everyone have health insurance or pay a tax penalty. Your Social Security Number is required on this application and will be used to inform the government that you have applied for coverage and should not be penalized.',
                  canToggle: true,
                  inputType: 'password',
                  maxLength: 11,
                  validators: [
                    'ssnDigits',
                    {
                      name: 'requiredIf',
                      prop: 'ssn',
                      message: 'SSN not available',
                      dependency: {
                        requiredIfProp: 'ssn_check',
                        requiredIfPropExpectedValue: false,
                      },
                    },
                  ],
                  inputValidators: ['required', 'social', 'ssnDigits'],
                },
                {
                  prop: 'ssn_check',
                  type: 'singleCheckbox',
                  checkboxLabel: 'SSN not available',
                },
                {
                  prop: 'date_of_birth',
                  type: 'date',
                  label: 'Date of Birth',
                  readonly: true,
                },
                {
                  prop: 'marital_status',
                  type: 'toggle',
                  label: 'Marital Status',
                  onlyIf: 'isNotChildOnlyApplication',
                  options: [
                    { label: 'Married', value: 'married' },
                    { label: 'Single', value: 'single' },
                  ],
                  validators: ['required'],
                },
                {
                  prop: 'gender',
                  type: 'toggle',
                  label: 'Gender',
                  options: [
                    { label: 'Male', value: 'male' },
                    { label: 'Female', value: 'female' },
                  ],
                  validators: ['required'],
                },
                {
                  mask: 'phone',
                  prop: 'home_phone',
                  type: 'text',
                  label: 'Primary Phone Number',
                  maxLength: 12,
                  validators: ['required', 'phone'],
                },
                {
                  prop: 'home_phone_type',
                  type: 'radio',
                  label: 'Primary Phone Number Type',
                  options: [
                    { label: 'Cell', value: 'cell' },
                    { label: 'Home', value: 'home' },
                    { label: 'Work', value: 'work' },
                    { label: 'Other', value: 'other' },
                  ],
                  validators: ['required'],
                },
                {
                  prop: 'is_attestation_of_communication_consent_granted',
                  type: 'singleCheckbox',
                  label:
                    'I agree that Brand Health and its affiliated entities and agents may communicate with me about my account and various health and wellness programs available to me, and other promotional information that may benefit me and my dependents, including by phone or text to the numbers I have listed on this form, using an auto-dialer or artificial or prerecorded voice; standard data rates apply.',
                  validators: ['required'],
                  checkboxLabel: 'Attestation of Communication Consent',
                  isCheckboxTopAligned: true,
                  showCheckboxLabelRequired: true,
                },
                {
                  mask: 'phone',
                  prop: 'secondary_phone_number',
                  type: 'text',
                  label: 'Secondary Phone Number',
                  maxLength: 12,
                  validators: ['phone'],
                },
                {
                  prop: 'secondary_phone_type',
                  type: 'radio',
                  label: 'Secondary Phone Number Type',
                  options: [
                    { label: 'Cell', value: 'cell' },
                    { label: 'Home', value: 'home' },
                    { label: 'Work', value: 'work' },
                  ],
                },
                {
                  prop: 'email_address',
                  type: 'text',
                  label: 'Email Address',
                  maxLength: 40,
                  validators: ['required', 'email'],
                },
                {
                  prop: 'contact_attestation',
                  type: 'checkbox',
                  label:
                    'I understand the company may contact me about my quote or application at the email address and phone number above, including my wireless number if provided. I understand calls may be generated using an automated technology.',
                  errors: { arrayHasValue: 'Must be selected to proceed' },
                  options: [{ label: 'Agree', value: 'agree' }],
                  validators: ['required', 'arrayHasValue'],
                },
                {
                  prop: 'language_preference',
                  type: 'dropdownOther',
                  label: 'Spoken Language Preference',
                  default: '',
                  options: [
                    { label: 'English', value: 'EN' },
                    { label: 'Spanish', value: 'ES' },
                    { label: 'Cantonese', value: '12' },
                    { label: 'Mandarin', value: '14' },
                    { label: 'Vietnamese', value: 'VI' },
                    { label: 'Korean', value: 'KO' },
                    { label: 'Tagalog', value: 'TL' },
                    { label: 'Armenian', value: 'HY' },
                    { label: 'Japanese', value: 'JA' },
                    { label: 'Persian', value: 'PS' },
                    { label: 'Punjabi', value: 'PA' },
                    { label: 'Khmer', value: 'LO' },
                    { label: 'Arabic', value: 'AR' },
                    { label: 'White Hmong', value: '03' },
                    { label: 'Blue/Green Hmong', value: '28' },
                    { label: 'Russian', value: 'RU' },
                    { label: 'Declines to State', value: '00' },
                    { label: 'Other', value: '99' },
                  ],
                  otherValue: '99',
                  validators: ['required'],
                },
                {
                  prop: 'written_language_preference',
                  type: 'dropdownOther',
                  label: 'Written Language Preference',
                  default: '',
                  options: [
                    { label: 'English', value: 'EN' },
                    { label: 'Spanish', value: 'ES' },
                    { label: 'Traditional Chinese', value: '20' },
                    { label: 'Vietnamese', value: 'VI' },
                    { label: 'Korean', value: 'KO' },
                    { label: 'Tagalog', value: 'TL' },
                    { label: 'Armenian', value: 'HY' },
                    { label: 'Japanese', value: 'JA' },
                    { label: 'Persian', value: 'PS' },
                    { label: 'Punjabi', value: 'PA' },
                    { label: 'Khmer', value: 'LO' },
                    { label: 'Arabic', value: 'AR' },
                    { label: 'White Hmong', value: '03' },
                    { label: 'Blue/Green Hmong', value: '28' },
                    { label: 'Russian', value: 'RU' },
                    { label: 'Declines to State', value: '00' },
                    { label: 'Other', value: '99' },
                  ],
                  otherValue: '99',
                  validators: ['required'],
                },
                {
                  prop: 'hispanic_latino_spanish_origin',
                  type: 'radio',
                  label: 'Are you Hispanic, Latino/a or Spanish origin?',
                  display: { format: 'SNAKE_CASE_TO_TITLE' },
                  options: [
                    { label: 'Yes', value: 'yes' },
                    { label: 'No', value: 'no' },
                    {
                      label: 'I choose not to answer',
                      value: 'choose_not_to_answer',
                    },
                    { label: 'I do not know', value: 'DC' },
                  ],
                  validators: ['required'],
                },
                {
                  prop: 'ethnicities',
                  type: 'checkbox',
                  label: 'Ethnicity (select all that apply)',
                  display: { format: 'SNAKE_CASE_TO_TITLE' },
                  options: [
                    {
                      label: 'Mexican, Mexican-American, Chicano/a',
                      value: '1001',
                    },
                    { label: 'Puerto Rican', value: '1002' },
                    { label: 'Cuban', value: '1000' },
                    {
                      label: 'Another Hispanic, Latino/a, or Spanish Origin',
                      value: '1003',
                    },
                  ],
                  conditions: {
                    all: [
                      {
                        name: 'hispanic_latino_spanish_origin',
                        value: 'yes',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                  validators: [
                    'required',
                    {
                      name: 'arrayHasValue',
                      message: 'At least one selection is required.',
                    },
                  ],
                },
                {
                  prop: 'identify_race',
                  type: 'radio',
                  label: 'Would you like to identify your race?',
                  display: { format: 'SNAKE_CASE_TO_TITLE' },
                  options: [
                    { label: 'Yes', value: 'yes' },
                    { label: 'No', value: 'no' },
                    {
                      label: 'I choose not to answer',
                      value: 'choose_not_to_answer',
                    },
                    { label: 'I do not know', value: 'DC' },
                  ],
                  validators: ['required'],
                },
                {
                  prop: 'races',
                  type: 'checkbox',
                  label: 'Race (select all that apply) ',
                  display: { format: 'SNAKE_CASE_TO_TITLE' },
                  options: [
                    { label: 'White', value: '1013' },
                    { label: 'Black or African American', value: '1002' },
                    {
                      label: 'American Indian or Alaska Native',
                      value: '1000',
                    },
                    { label: 'Asian Indian', value: '1001' },
                    { label: 'Chinese', value: '1003' },
                    { label: 'Japanese', value: '1006' },
                    { label: 'Korean', value: '1007' },
                    { label: 'Filipino', value: '1004' },
                    { label: 'Other Asian', value: '1021' },
                    { label: 'Native Hawaiian', value: '1008' },
                    { label: 'Vietnamese', value: '1012' },
                    { label: 'Guamanian or Chamorro', value: '1005' },
                    { label: 'Other Pacific Islander', value: '1022' },
                    { label: 'Samoan', value: '1011' },
                    { label: 'Middle Eastern or North African', value: '1023' },
                    { label: 'Another Race Not Listed Above', value: '1024' },
                  ],
                  conditions: {
                    all: [
                      {
                        name: 'identify_race',
                        value: 'yes',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                  validators: [
                    'required',
                    {
                      name: 'arrayHasValue',
                      message: 'At least one selection is required.',
                    },
                  ],
                },
                {
                  grid: { col: '1 / end', row: '17' },
                  prop: 'sex_assigned_at_birth',
                  type: 'dropdown',
                  label:
                    'What was your sex assigned at birth? You can find this on an original birth certificate or similar document.',
                  display: {
                    format: 'SNAKE_CASE_TO_TITLE',
                    conditional: {
                      when: [
                        {
                          prop: 'data.subscriber.sex_assigned_at_birth',
                          comparator: 'EXISTS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  options: [
                    { label: 'Female', value: 'F' },
                    { label: 'Male', value: 'M' },
                    { label: 'Not sure', value: 'NS' },
                    { label: 'I choose not to answer', value: 'DC' },
                    { label: 'A sex that’s not listed', value: 'not_listed' },
                  ],
                  validators: ['required'],
                },
                {
                  grid: { col: '1 / end', row: '18' },
                  mask: 'alpha',
                  prop: 'not_listed_sex_assigned_at_birth',
                  type: 'text',
                  label: 'Please enter your sex assigned at birth.',
                  display: {
                    conditional: {
                      when: [
                        {
                          prop: 'data.workflow.values.subscriber.not_listed_sex_assigned_at_birth',
                          value: true,
                          comparator: 'EQUALS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  maxLength: 46,
                  conditions: {
                    all: [
                      {
                        name: 'sex_assigned_at_birth',
                        value: 'not_listed',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                  validators: [
                    'required',
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '-',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  grid: { col: '1 / end', row: '19' },
                  prop: 'gender_identity',
                  type: 'dropdown',
                  label: 'What’s your gender identity?',
                  display: {
                    format: 'SNAKE_CASE_TO_TITLE',
                    conditional: {
                      when: [
                        {
                          prop: 'data.subscriber.gender_identity',
                          comparator: 'EXISTS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  options: [
                    { label: 'Female', value: 'F' },
                    { label: 'Male', value: 'M' },
                    { label: 'Transgender female', value: 'TF' },
                    { label: 'Transgender male', value: 'TM' },
                    { label: 'Not sure', value: 'NS' },
                    { label: 'I choose not to answer', value: 'DC' },
                    {
                      label: 'A gender that’s not listed',
                      value: 'not_listed',
                    },
                  ],
                  validators: ['required'],
                },
                {
                  grid: { col: '1 / end', row: '20' },
                  mask: 'alpha',
                  prop: 'not_listed_gender_identity',
                  type: 'text',
                  label: 'Please enter your gender identity.',
                  display: {
                    conditional: {
                      when: [
                        {
                          prop: 'data.workflow.values.subscriber.not_listed_gender_identity',
                          value: true,
                          comparator: 'EQUALS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  maxLength: 46,
                  conditions: {
                    all: [
                      {
                        name: 'gender_identity',
                        value: 'not_listed',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                  validators: [
                    'required',
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '-',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  grid: { col: '1 / end', row: '21' },
                  prop: 'sexual_orientation',
                  type: 'dropdown',
                  label: 'What’s your sexual orientation?',
                  display: {
                    format: 'SNAKE_CASE_TO_TITLE',
                    conditional: {
                      when: [
                        {
                          prop: 'data.subscriber.sexual_orientation',
                          comparator: 'EXISTS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  options: [
                    { label: 'Lesbian or gay', value: 'LG' },
                    { label: 'Straight', value: 'ST' },
                    { label: 'Bisexual', value: 'BI' },
                    { label: 'Not sure', value: 'NS' },
                    { label: 'I choose not to answer', value: 'DC' },
                    {
                      label: 'A sexual orientation that’s not listed',
                      value: 'not_listed',
                    },
                  ],
                  validators: ['required'],
                },
                {
                  grid: { col: '1 / end', row: '22' },
                  mask: 'alpha',
                  prop: 'not_listed_sexual_orientation',
                  type: 'text',
                  label: 'Please enter your sexual orientation.',
                  display: {
                    conditional: {
                      when: [
                        {
                          prop: 'data.workflow.values.subscriber.not_listed_sexual_orientation',
                          value: true,
                          comparator: 'EQUALS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  maxLength: 46,
                  conditions: {
                    all: [
                      {
                        name: 'sexual_orientation',
                        value: 'not_listed',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                  validators: [
                    'required',
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '-',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  prop: 'medicare_eligible',
                  type: 'toggle',
                  label: 'Are you eligible for Medicare?',
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                  validators: ['required'],
                  conditionalControls: [
                    {
                      prop: 'medicare_eligible_applicant_name',
                      type: 'text',
                      label: 'Applicant Name',
                      validators: ['required'],
                    },
                  ],
                },
                {
                  prop: 'medicare_enrolled',
                  type: 'radio',
                  label: 'Are you covered under Medicare Part A or Part B?',
                  errors: {
                    equals:
                      "If you're already covered by Medicare Part A or Part B and have questions, call us at 1-800-670-5935 (TTY 711).",
                  },
                  options: [
                    { label: 'Yes', value: 'true' },
                    { label: 'No', value: 'false' },
                  ],
                  validators: [
                    'required',
                    { name: 'equals', dependency: 'false' },
                  ],
                  conditionalControls: [
                    {
                      prop: 'medicare_enrolled_applicant_name',
                      type: 'text',
                      label: 'Applicant Name',
                      validators: ['required'],
                    },
                  ],
                },
                {
                  prop: 'employer_ichra_qsehra',
                  type: 'radio',
                  label:
                    'Is your employer offering you an individual coverage health reimbursement arrangement (ICHRA) or a qualified small employer health reimbursement arrangement (QSEHRA) that you will use to pay premium for individual health insurance coverage?',
                  options: [
                    {
                      label: 'Yes, my employer is offering an ICHRA',
                      value: 'ichra',
                    },
                    {
                      label: 'Yes, my employer is offering a QSEHRA',
                      value: 'qsehra',
                    },
                    { label: 'No', value: 'no' },
                    { label: 'Unknown', value: 'unknown' },
                  ],
                  validators: ['required'],
                  conditional: {
                    when: [
                      {
                        prop: 'coverage_type',
                        value: 'health',
                        comparator: 'INCLUDES',
                      },
                    ],
                    connective: 'AND',
                  },
                },
                {
                  prop: 'spouse_qsehra',
                  type: 'radio',
                  label:
                    "Does your spouse's employer provide a QSEHRA that will be used to pay all or part of your or your family’s premium?",
                  options: [
                    { label: 'Yes', value: 'yes' },
                    { label: 'No', value: 'no' },
                    { label: 'Unknown', value: 'unknown' },
                  ],
                  validators: ['required'],
                  conditional: {
                    when: [
                      {
                        prop: 'employer_ichra_qsehra',
                        value: 'qsehra',
                        comparator: 'EQUALS',
                      },
                    ],
                    connective: 'AND',
                  },
                },
                {
                  prop: 'claims_qsehra',
                  type: 'radio',
                  label:
                    "Does your employer or your spouse's employer provide a QSEHRA that will be used to reimburse medical and/or pharmacy claims?",
                  options: [
                    {
                      label:
                        "Yes, I will use my employer's QSEHRA to reimburse my medical and/or pharmacy claims",
                      value: 'employer',
                    },
                    {
                      label:
                        'Yes, my spouse will use his/her QSEHRA to reimburse his/her medical and/or pharmacy claims',
                      value: 'spouse',
                    },
                    {
                      label:
                        "Yes, I will use my employer's QSEHRA and my spouse will use his/her QSEHRA to reimburse medical and/or pharmacy claims",
                      value: 'both',
                    },
                    { label: 'No', value: 'no' },
                    { label: 'Unknown', value: 'unknown' },
                  ],
                  validators: ['required'],
                  conditional: {
                    when: [
                      {
                        prop: 'employer_ichra_qsehra',
                        value: 'qsehra',
                        comparator: 'EQUALS',
                      },
                    ],
                    connective: 'AND',
                  },
                },
              ],
              is_attestation_of_communication_consent: true,
            },
            stepParents: {
              title: 'Parent(s)/Step-Parent(s)',
              hidden: true,
              controls: [
                {
                  mask: 'alpha',
                  prop: 'first_name',
                  type: 'text',
                  label: 'First Name',
                  maxLength: 15,
                  validators: ['alpha', 'required'],
                },
                {
                  mask: 'alpha',
                  prop: 'middle_initial',
                  type: 'text',
                  label: 'Middle Initial',
                  maxLength: 1,
                  validators: ['alpha'],
                },
                {
                  mask: 'alpha',
                  prop: 'last_name',
                  type: 'text',
                  label: 'Last Name',
                  validators: ['alpha', 'required'],
                },
                {
                  mask: 'phone',
                  prop: 'home_phone',
                  type: 'text',
                  label: 'Phone Number',
                  onlyIf: 'isChildOnlyApplication',
                  maxLength: 12,
                  validators: ['required', 'phone'],
                },
                {
                  prop: 'date_of_birth',
                  type: 'date',
                  label: 'Date of Birth',
                  readonly: true,
                  placeholder: 'YYYY-MM-DD',
                },
                {
                  prop: 'language_preference',
                  type: 'dropdownOther',
                  label: 'Spoken Language Preference',
                  default: '',
                  options: [
                    { label: 'English', value: 'EN' },
                    { label: 'Spanish', value: 'ES' },
                    { label: 'Cantonese', value: '12' },
                    { label: 'Mandarin', value: '14' },
                    { label: 'Vietnamese', value: 'VI' },
                    { label: 'Korean', value: 'KO' },
                    { label: 'Tagalog', value: 'TL' },
                    { label: 'Armenian', value: 'HY' },
                    { label: 'Japanese', value: 'JA' },
                    { label: 'Persian', value: 'PS' },
                    { label: 'Punjabi', value: 'PA' },
                    { label: 'Khmer', value: 'LO' },
                    { label: 'Arabic', value: 'AR' },
                    { label: 'White Hmong', value: '03' },
                    { label: 'Blue/Green Hmong', value: '28' },
                    { label: 'Russian', value: 'RU' },
                    { label: 'Declines to State', value: 'EN' },
                    { label: 'Other', value: '99' },
                  ],
                  otherValue: '99',
                  validators: ['required'],
                },
                {
                  prop: 'written_language_preference',
                  type: 'dropdownOther',
                  label: 'Written Language Preference',
                  default: '',
                  options: [
                    { label: 'English', value: 'EN' },
                    { label: 'Spanish', value: 'ES' },
                    { label: 'Traditional Chinese', value: '20' },
                    { label: 'Vietnamese', value: 'VI' },
                    { label: 'Korean', value: 'KO' },
                    { label: 'Tagalog', value: 'TL' },
                    { label: 'Armenian', value: 'HY' },
                    { label: 'Japanese', value: 'JA' },
                    { label: 'Persian', value: 'PS' },
                    { label: 'Punjabi', value: 'PA' },
                    { label: 'Khmer', value: 'LO' },
                    { label: 'Arabic', value: 'AR' },
                    { label: 'White Hmong', value: '03' },
                    { label: 'Blue/Green Hmong', value: '28' },
                    { label: 'Russian', value: 'RU' },
                    { label: 'Declines to State', value: '00' },
                    { label: 'Other', value: '99' },
                  ],
                  otherValue: '99',
                  validators: ['required'],
                },
                {
                  grid: { col: '1 / end', row: '17' },
                  prop: 'sex_assigned_at_birth',
                  type: 'dropdown',
                  label:
                    'What was your sex assigned at birth? You can find this on an original birth certificate or similar document.',
                  display: {
                    format: 'SNAKE_CASE_TO_TITLE',
                    conditional: {
                      when: [
                        {
                          prop: 'data.subscriber.sex_assigned_at_birth',
                          comparator: 'EXISTS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  options: [
                    { label: 'Female', value: 'F' },
                    { label: 'Male', value: 'M' },
                    { label: 'Not sure', value: 'NS' },
                    { label: 'I choose not to answer', value: 'DC' },
                    { label: 'A sex that’s not listed', value: 'not_listed' },
                  ],
                  validators: ['required'],
                },
                {
                  grid: { col: '1 / end', row: '18' },
                  mask: 'alpha',
                  prop: 'not_listed_sex_assigned_at_birth',
                  type: 'text',
                  label: 'Please enter your sex assigned at birth.',
                  display: {
                    conditional: {
                      when: [
                        {
                          prop: 'data.workflow.values.subscriber.not_listed_sex_assigned_at_birth',
                          value: true,
                          comparator: 'EQUALS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  maxLength: 46,
                  conditions: {
                    all: [
                      {
                        name: 'sex_assigned_at_birth',
                        value: 'not_listed',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                  validators: [
                    'required',
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '-',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  grid: { col: '1 / end', row: '19' },
                  prop: 'gender_identity',
                  type: 'dropdown',
                  label: 'What’s your gender identity?',
                  display: {
                    format: 'SNAKE_CASE_TO_TITLE',
                    conditional: {
                      when: [
                        {
                          prop: 'data.subscriber.gender_identity',
                          comparator: 'EXISTS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  options: [
                    { label: 'Female', value: 'F' },
                    { label: 'Male', value: 'M' },
                    { label: 'Transgender female', value: 'TF' },
                    { label: 'Transgender male', value: 'TM' },
                    { label: 'Not sure', value: 'NS' },
                    { label: 'I choose not to answer', value: 'DC' },
                    {
                      label: 'A gender that’s not listed',
                      value: 'not_listed',
                    },
                  ],
                  validators: ['required'],
                },
                {
                  grid: { col: '1 / end', row: '20' },
                  mask: 'alpha',
                  prop: 'not_listed_gender_identity',
                  type: 'text',
                  label: 'Please enter your gender identity.',
                  display: {
                    conditional: {
                      when: [
                        {
                          prop: 'data.workflow.values.subscriber.not_listed_gender_identity',
                          value: true,
                          comparator: 'EQUALS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  maxLength: 46,
                  conditions: {
                    all: [
                      {
                        name: 'gender_identity',
                        value: 'not_listed',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                  validators: [
                    'required',
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '-',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  grid: { col: '1 / end', row: '21' },
                  prop: 'sexual_orientation',
                  type: 'dropdown',
                  label: 'What’s your sexual orientation?',
                  display: {
                    format: 'SNAKE_CASE_TO_TITLE',
                    conditional: {
                      when: [
                        {
                          prop: 'data.subscriber.sexual_orientation',
                          comparator: 'EXISTS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  options: [
                    { label: 'Lesbian or gay', value: 'LG' },
                    { label: 'Straight', value: 'ST' },
                    { label: 'Bisexual', value: 'BI' },
                    { label: 'Not sure', value: 'NS' },
                    { label: 'I choose not to answer', value: 'DC' },
                    {
                      label: 'A sexual orientation that’s not listed',
                      value: 'not_listed',
                    },
                  ],
                  validators: ['required'],
                },
                {
                  grid: { col: '1 / end', row: '22' },
                  mask: 'alpha',
                  prop: 'not_listed_sexual_orientation',
                  type: 'text',
                  label: 'Please enter your sexual orientation.',
                  display: {
                    conditional: {
                      when: [
                        {
                          prop: 'data.workflow.values.subscriber.not_listed_sexual_orientation',
                          value: true,
                          comparator: 'EQUALS',
                        },
                      ],
                      connective: 'AND',
                    },
                  },
                  maxLength: 46,
                  conditions: {
                    all: [
                      {
                        name: 'sexual_orientation',
                        value: 'not_listed',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                  validators: [
                    'required',
                    {
                      name: 'blacklistCharacters',
                      dependency: [
                        '!',
                        '@',
                        '#',
                        '$',
                        '%',
                        '^',
                        '&',
                        '(',
                        ')',
                        '-',
                        '_',
                        '+',
                        '"',
                        '/',
                        '\\',
                        '[',
                        ']',
                        '{',
                        '}',
                        ':',
                        ';',
                        '|',
                        '=',
                        ',',
                        '*',
                        '?',
                        '<',
                        '>',
                        '.',
                        '~',
                        '`',
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                      ],
                    },
                  ],
                },
                {
                  prop: 'email_address',
                  type: 'text',
                  label: 'Email',
                  onlyIf: 'isChildOnlyApplication',
                  maxLength: 40,
                  validators: ['required', 'email'],
                },
                {
                  mask: 'ssn',
                  prop: 'ssn',
                  type: 'text',
                  label: 'SSN',
                  naLabel: 'SSN not available',
                  tooltip:
                    'The Affordable Care Act requires that everyone have health insurance or pay a tax penalty. Your Social Security Number is required on this application and will be used to inform the government that you have applied for coverage and should not be penalized.',
                  canToggle: true,
                  inputType: 'password',
                  maxLength: 11,
                  validators: [
                    'ssnDigits',
                    {
                      name: 'requiredIf',
                      prop: 'ssn',
                      message: 'SSN not available',
                      dependency: {
                        requiredIfProp: 'ssn_check',
                        requiredIfPropExpectedValue: false,
                      },
                    },
                  ],
                  inputValidators: ['required', 'social'],
                },
                {
                  prop: 'ssn_check',
                  type: 'singleCheckbox',
                  checkboxLabel: 'SSN not available',
                },
                {
                  prop: 'gender',
                  type: 'toggle',
                  label: 'Gender',
                  options: [
                    { label: 'Male', value: 'male' },
                    { label: 'Female', value: 'female' },
                  ],
                  validators: ['required'],
                },
                {
                  prop: 'relationship_to_subscriber',
                  type: 'dropdownOther',
                  label: 'Relationship to Applicant',
                  onlyIf: 'isNotChildOnlyApplication',
                  options: [
                    { label: 'Parent', value: 'parent' },
                    { label: 'Step-Parent', value: 'step_parent' },
                  ],
                  validators: ['required'],
                  placeholder: 'Select one',
                },
                {
                  prop: 'different_mailing_address',
                  type: 'radio',
                  label: 'Your dependent lives at a different address?',
                  onlyIf: 'isNotChildOnlyApplication',
                  default: false,
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                },
                {
                  prop: 'medicare_eligible',
                  type: 'toggle',
                  label: 'Are you eligible for Medicare?',
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                  validators: ['required'],
                  conditionalControls: [
                    {
                      prop: 'medicare_eligible_applicant_name',
                      type: 'text',
                      label: 'Applicant Name',
                      validators: ['required'],
                    },
                  ],
                },
                {
                  prop: 'medicare_enrolled',
                  type: 'radio',
                  label: 'Are you covered under Medicare Part A or Part B?',
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                  validators: ['required'],
                  conditionalControls: [
                    {
                      prop: 'medicare_enrolled_applicant_name',
                      type: 'text',
                      label: 'Applicant Name',
                      validators: ['required'],
                    },
                  ],
                },
              ],
              titleSuffix: 'Information',
            },
          },
          enableSOGIPlanTypes: ['medical', 'dental', 'vision'],
        },
        facilitySearch: {
          filters: {
            groups: [
              {
                prop: 'specialties',
                controls: [
                  {
                    prop: 'specialties',
                    type: 'dropdown',
                    label: 'Specialties',
                    options: [],
                  },
                ],
              },
              {
                prop: 'language',
                controls: [
                  {
                    prop: 'language',
                    type: 'dropdown',
                    label: 'Language',
                    options: [
                      { label: 'Arabic', value: 'arabic' },
                      { label: 'Chinese', value: 'chinese' },
                      { label: 'English', value: 'english' },
                      { label: 'Hindi', value: 'hindi' },
                      { label: 'Italian', value: 'italian' },
                      { label: 'Japanese', value: 'japanese' },
                      { label: 'Laotian', value: 'laotian' },
                      { label: 'Portuguese', value: 'portuguese' },
                      { label: 'Russian', value: 'russian' },
                      { label: 'Spanish', value: 'spanish' },
                    ],
                  },
                ],
              },
              {
                prop: 'facility_type',
                controls: [
                  {
                    prop: 'facility_type',
                    type: 'dropdown',
                    label: 'Facility Type',
                    options: [],
                  },
                ],
              },
              {
                prop: 'medical_group',
                controls: [
                  {
                    prop: 'medical_group',
                    type: 'dropdown',
                    label: 'Medical Group Affiliation',
                    options: [],
                  },
                ],
              },
              {
                prop: 'wheelchair_access',
                controls: [
                  {
                    prop: 'wheelchair_access',
                    type: 'checkbox',
                    options: [
                      {
                        label:
                          'Accommodations for persons with physical disabilities',
                        value: 'true',
                      },
                    ],
                  },
                ],
              },
              {
                prop: 'accepting_new_patients',
                controls: [
                  {
                    prop: 'accepting_new_patients',
                    type: 'checkbox',
                    options: [
                      { label: 'Accepting New Patients', value: 'true' },
                    ],
                  },
                ],
              },
            ],
          },
          hideMembers: true,
          buttonConfig: {
            back: { size: 'fullWidth', level: 'medium', content: 'Back' },
            skip: { size: 'fullWidth', level: 'medium', content: 'Skip' },
            continue: {
              size: 'fullWidth',
              level: 'high',
              content: 'Save & Continue',
            },
          },
          workflowName: 'facilitySearch',
          incorrect_data: {
            groups: [
              {
                prop: 'correction_type',
                header: 'Correction Types',
                controls: [
                  {
                    prop: 'correction_type',
                    type: 'checkbox',
                    options: [
                      { label: 'Address incorrect', value: 'address' },
                      { label: 'Deceased / Retired', value: 'dead' },
                      {
                        label:
                          'Doctor indicates they no longer accept CareFirst Insurance',
                        value: 'not_accepting_insurance',
                      },
                      {
                        label: 'Doctor no longer accepts new patients',
                        value: 'not_accepting_patients',
                      },
                      {
                        label: 'Doctor left practice location',
                        value: 'doctor_left',
                      },
                      {
                        label: 'Duplicate listing',
                        value: 'duplicate_listing',
                      },
                      { label: 'Gender incorrect', value: 'gender' },
                      { label: 'Phone number incorrect', value: 'phone' },
                      {
                        label: 'Provider / Group name incorrect',
                        value: 'provider_group_name',
                      },
                      { label: 'Specialty incorrect', value: 'specialty' },
                      { label: 'Other (Comments Required)', value: 'other' },
                    ],
                  },
                ],
              },
              {
                prop: 'comments',
                header: 'Comments (optional)',
                controls: [{ prop: 'comments', type: 'textarea' }],
              },
              {
                prop: 'contact_info',
                header: 'Contact Information (optional)',
                controls: [
                  { prop: 'name', label: 'Your Name' },
                  {
                    hint: '(xxx) xxx-xxxx',
                    prop: 'phone',
                    label: 'Contact Number',
                  },
                  { prop: 'email', type: 'email', label: 'Email Address' },
                ],
              },
            ],
          },
          noResultsConfig: {
            img: 'https://d32ul9oyxvd2n5.cloudfront.net/illustrations/empty-4.svg',
            header: 'No Physicians Identified with Current Search Criteria.',
          },
        },
        plan_selection: {
          onExchange: 'true',
          showNewCard: true,
          compare_plans: {
            displayAllDocuments: true,
            showResourcesAsBenefit: true,
          },
          isAccordionOpen: true,
          shoppingHeaderOverrides: {
            dental: {
              title: 'Plans Available In Your ZIP Code',
              subtitle: 'Discover Your Perfect Dental Plan Today!',
            },
            vision: {
              title: 'Plans Available In Your ZIP Code',
              subtitle: 'Discover Your Perfect Vision Plan Today!',
            },
            medical: {
              title: 'Plans Available In Your ZIP Code',
              subtitle: 'Discover Your Perfect Medical Plan Today!',
            },
            subsidy: {
              title: 'Plans Available In Your ZIP Code / Subsidy Tab',
              subtitle:
                "You may be eligible to receive subsidies to help pay for the monthly premiums. Subsidy Estimate: <span class='t-bold'>${subsidy_amount}</span>",
            },
          },
        },
        qle_document_upload: {
          header: {
            title: 'Supporting Documentation for Special Enrollment',
            subtitle:
              'You are enrolling for a Special Enrollment Period based on a Qualifying Life Event. The information you provided is displayed below. <br> Please upload the required documentation so we can verify your qualifying life event. You may also skip this step, and provide this information later.',
          },
          documents: {
            uploadInstructions:
              'Select a document type, and then upload the selected document.',
            isDocumentTypeRequired: true,
          },
          attributes: [
            { prop: 'reason', label: 'Reason' },
            {
              prop: 'updated_coverage_effective_date',
              label: 'Effective Date',
            },
          ],
          fileRestrictions: {
            messages: {
              fileTypes:
                'Your document could not be uploaded. Supported file types include PDF, PNG, JPEG & JPG.',
              fileSizeLimit:
                'Your document could not be uploaded. Please make sure your document size is less than 5 MB',
            },
            fileTypes: 'application/pdf,image/jpg,image/jpeg,image/png',
            filesLimit: 5,
            fileSizeLimit: 5,
          },
        },
        billing_confirmation: {
          cards: {
            selectedPlanCard: {
              key: 'selectedPlan',
              icon: 'wellness_product',
              label: 'Selected Plan',
            },
            applicationStatusCard: {
              key: 'status',
              icon: 'clipboard',
              label: 'Application Status',
            },
          },
          header: 'Your Payment Was Successfully Processed',
          subHeader:
            'Your payment has been processed. Please click “Submit Application” to proceed.',
          iconConfig: { fill: 'primary', size: 'large' },
          infoBanner: {
            icon: 'info_active',
            type: 'info',
            message:
              'Now that your payment has been processed, you will need to click the button below to submit the application.',
            actionIcon: null,
            messageHeading: 'Attention!',
            actionIconAltText: null,
          },
          footerButton: { level: 'high', content: 'Submit Application' },
          planTypeOrder: ['medical', 'bundled', 'dental', 'vision'],
          applicationSubmissionErrorBanner: {
            icon: 'close',
            type: 'error',
            message:
              'If this issue persists, please contact our customer service at xxx-xxx-xxxx',
            messageHeading:
              'We encountered an issue when submitting your application. Please try again!',
          },
        },
        special_enrollment_period: {
          QLE: [
            {
              icon: 'coverage',
              open: false,
              label: 'Lost or losing health coverage',
              value: 'coverage_lost',
              controls: [
                {
                  prop: 'reason',
                  type: 'dropdown',
                  label: 'How did this happen?',
                  options: [
                    { label: 'Change in job status', value: 'QE4' },
                    { label: 'COBRA ended', value: 'QE14a' },
                    { label: 'Child reached age 26', value: 'QE8' },
                    { label: 'Group contributions ended', value: 'QE5' },
                    { label: 'Loss Medicaid/Medi-Cal/AIM', value: 'QE10' },
                    { label: 'Divorce/separation', value: 'QE9' },
                    { label: 'Moved out of service area', value: 'QE11' },
                    { label: 'Medicare', value: 'QE7' },
                    { label: 'Death', value: 'QE6' },
                  ],
                  alignment: 'justified',
                  validators: ['required'],
                },
                {
                  max: '9999-01-01',
                  prop: 'date',
                  type: 'date',
                  label: 'When did this happen?',
                  message: 'Use a valid date',
                  validators: ['required'],
                },
              ],
            },
            {
              icon: 'users',
              open: false,
              label: 'Change in household size',
              value: 'householdSize',
              controls: [
                {
                  prop: 'reason',
                  type: 'dropdown',
                  label: 'How did this happen?',
                  options: [
                    { label: 'Birth/adoption/new foster child', value: 'QE1' },
                    { label: 'Marriage/Domestic Partnership', value: 'QE2' },
                    { label: 'Court order', value: 'QE3' },
                  ],
                  alignment: 'justified',
                  validators: ['required'],
                },
                {
                  max: '9999-01-01',
                  prop: 'date',
                  type: 'date',
                  label: 'When did this happen?',
                  message: 'Use a valid date',
                  validators: ['required'],
                },
              ],
            },
            {
              icon: 'moving',
              open: false,
              label: 'Change in primary place of living',
              value: 'moved',
              controls: [
                {
                  prop: 'reason',
                  type: 'dropdown',
                  label: 'How did this happen?',
                  options: [
                    {
                      label: 'Permanent move and/or new resident of CA',
                      value: 'QE12',
                    },
                  ],
                  alignment: 'justified',
                  validators: ['required'],
                },
                {
                  max: '9999-01-01',
                  prop: 'date',
                  type: 'date',
                  label: 'When did this happen?',
                  message: 'Use a valid date',
                  validators: ['required'],
                },
              ],
            },
            {
              icon: 'check_circle',
              open: false,
              label: 'Change in eligibility',
              value: 'eligibility',
              controls: [
                {
                  prop: 'reason',
                  type: 'dropdown',
                  label: 'How did this happen?',
                  options: [
                    {
                      label: 'Change in eligibility for financial help',
                      value: 'QE14c',
                    },
                    { label: 'End of military service', value: 'QE13' },
                    { label: 'Release from incarceration', value: 'QE14b' },
                  ],
                  alignment: 'justified',
                  validators: ['required'],
                },
                {
                  max: '9999-01-01',
                  prop: 'date',
                  type: 'date',
                  label: 'When did this happen?',
                  message: 'Use a valid date',
                  validators: ['required'],
                },
              ],
            },
            {
              icon: 'other',
              open: false,
              label: 'Other',
              value: 'other',
              controls: [
                {
                  prop: 'reason',
                  type: 'dropdown',
                  label: 'How did this happen?',
                  options: [
                    { label: 'Completion of covered services', value: 'QE14d' },
                    { label: 'Contract violation', value: 'QE14e' },
                    { label: 'Other', value: 'QE15' },
                  ],
                  alignment: 'justified',
                  validators: ['required'],
                },
                {
                  max: '9999-01-01',
                  prop: 'date',
                  type: 'date',
                  label: 'When did this happen?',
                  message: 'Use a valid date',
                  validators: ['required'],
                },
              ],
            },
          ],
          text: {
            uploadInstructions:
              'Select a document type, and then upload the selected document.',
          },
          header: { subtitle: '' },
          showSkipButton: false,
          defaultHeaderTitle:
            'You must submit additional documentation to verify your qualifying life event (QLE).',
          defaultHeaderSubTitle:
            'You may choose to submit these documents later, but adding these documents now will help expedite review of your application.',
          fileUploadRestrictions: {
            messages: {
              fileTypes:
                'Your document could not be uploaded. Supported file types include pdf, jpg, & jpeg',
              fileSizeLimit:
                'Your document could not be uploaded. Please make sure your document size is less than 4 mb',
            },
          },
          acceptedDocumentsMessage:
            'Supported file types include pdf, jpg & jpeg. Please make sure your document size is less than 4MB.',
        },
        addressSelectionModalMessage: {
          errorModalNotVerified: {
            body: 'The address entered could not be verified. Continuing will delay your application for additional eligibility reviews. Please select Go Back to make corrections.',
            header: 'Address not Verified',
            confirm: 'Go Back',
          },
          errorModalNonUSPSValidated: {
            body: 'Selecting to continue with a non-USPS validated address will delay processing of your application for additional eligibility reviews.',
          },
        },
      },
      applications: {
        table: {
          title: 'Applications',
          button: { icon: '', level: 'high', content: 'Create Application' },
          export: { icon: 'download', level: '', content: '' },
          paging: { enabled: true, pageSize: 20 },
          columns: [
            { name: 'Application ID', prop: 'id', sortable: true },
            {
              name: 'First Name',
              prop: 'subscriber.first_name',
              sortable: true,
              sortByProp: 'data__subscriber__first_name',
            },
            {
              name: 'Last Name',
              prop: 'subscriber.last_name',
              sortable: true,
              sortByProp: 'data__subscriber__last_name',
            },
            {
              name: 'Status',
              prop: 'status',
              format: 'STATUS',
              sortable: true,
              statuses: {
                info: [],
                error: [
                  { label: 'Declined', value: 'declined' },
                  { label: 'Denied', value: 'denied' },
                ],
                expired: [{ label: 'Expired', value: 'expired' }],
                pending: [
                  { label: 'In Progress', value: 'in_progress' },
                  { label: 'Pended', value: 'pended' },
                ],
                success: [{ label: 'Submitted', value: 'submitted' }],
              },
            },
            {
              name: 'Req. Eff. Date',
              prop: 'coverage_effective_date',
              format: 'DATE',
              sortable: true,
            },
            {
              name: 'Action',
              format: 'ACTIONS',
              actions: [
                {
                  icon: 'view_detail',
                  displayText: 'View Details',
                  conditionProp: '',
                  conditionValue: [],
                },
                {
                  icon: 'delete_active',
                  displayText: 'Delete',
                  conditionProp: 'status',
                  conditionValues: ['expired'],
                },
              ],
              priority: 8,
              sortable: false,
              columnHeaderIcon: 'settings_active',
              columnHeaderIconLabel: 'Edit View',
            },
            {
              name: 'Broker Name',
              prop: 'broker',
              format: 'FULL_NAME',
              isHidden: true,
              sortable: true,
            },
            {
              name: 'Agency Name',
              prop: 'broker.agency.agency_name',
              isHidden: true,
              sortable: true,
              sortByProp: 'broker__agency_agency_name',
            },
            {
              name: 'Applicant Name',
              prop: 'subscriber',
              format: 'FULL_NAME',
              isHidden: true,
              sortable: true,
              sortByProp: 'subscriber_first_name',
            },
            {
              name: 'Date Submitted',
              prop: 'submitted_date',
              format: 'DATE',
              isHidden: true,
              sortable: true,
            },
            {
              name: 'Product Type',
              prop: 'plans',
              format: 'LIST',
              isHidden: true,
              sortByProp: 'plans__display_name',
              formatOptions: { objectMapping: 'display_name' },
            },
            {
              name: 'Source',
              prop: 'application_type',
              format: 'APP_DISPLAY_NAME',
              isHidden: true,
              sortable: true,
            },
          ],
          filters: [
            {
              icon: 'search',
              prop: 'id',
              size: 'small',
              type: 'text',
              label: 'Application ID',
            },
            {
              icon: '',
              prop: 'coverage_effective_date',
              size: 'small',
              type: 'date',
              label: 'Requested Effective Date',
              placeholder: 'mm/dd/yyyy',
            },
            {
              icon: '',
              prop: 'status_similar_to',
              size: 'small',
              type: 'dropdown',
              label: 'Status',
              options: [
                { label: 'All', value: '' },
                { label: 'Approved', value: 'approved' },
                { label: 'Declined', value: 'declined' },
                { label: 'Expired', value: 'expired' },
                { label: 'In Progress', value: 'in_progress' },
                { label: 'Submitted', value: 'submitted' },
              ],
              placeholder: '',
              autocomplete: 'off',
            },
          ],
          sorting: { init: { created_at: 'desc' }, stackedIcons: true },
          endpoint: 'api/shopping/applications/individuals/',
          messages: { noData: 'No data found.' },
          pagination: 25,
          exportConfig: { enabled: true, exportWithFormatting: false },
        },
        showFooter: true,
        buttonClick: {
          'Create Application': { route: 'shopping/individual/' },
        },
        deleteModal: {
          body: 'Are you sure you want to permanently delete this application?',
          cancel: 'Cancel',
          header: 'Delete Application',
          submit: 'Yes, Delete',
        },
        detailPageName: 'application-details',
        routeAllAppsToDetails: true,
      },
      'create-quote': {
        login: {
          routeAfterSuccessConfig: {
            id: null,
            route: null,
            completeStep: true,
            checkApplication: null,
          },
        },
        steps: [
          {
            review: [
              {
                icon: 'auths',
                type: 'attributes',
                label: 'Get Started',
                attributes: [
                  {
                    label: 'Coverage Type',
                    value: '${demographics.displayCoverageType}',
                  },
                  {
                    label: 'Coverage Start Date',
                    value: '${coverage_effective_date}',
                    format: 'DATE',
                  },
                  { label: 'ZIP Code', value: '${permanent_address.zipcode}' },
                  {
                    label: 'County',
                    value: '${permanent_address.county_name}',
                  },
                ],
              },
              {
                icon: 'auths',
                type: 'attributes',
                label: 'Who Needs Coverage',
                attributes: [
                  {
                    prop: 'demographics.subscriber',
                    title: 'Subscriber',
                    attributes: [
                      {
                        label: 'Date of Birth',
                        value: '${demographics.subscriber.date_of_birth}',
                        format: 'DATE',
                      },
                      {
                        label: 'Gender',
                        value: '${demographics.subscriber.gender}',
                        format: 'SNAKE_CASE_TO_TITLE',
                      },
                      {
                        label: 'Tobacco User',
                        value: '${demographics.subscriber.tobacco_user}',
                        format: 'YES_NO',
                      },
                    ],
                  },
                  {
                    prop: 'demographics.spouse',
                    title: 'Spouse',
                    attributes: [
                      {
                        label: 'Date of Birth',
                        value: '${demographics.spouse.date_of_birth}',
                        format: 'DATE',
                      },
                      {
                        label: 'Gender',
                        value: '${demographics.spouse.gender}',
                        format: 'SNAKE_CASE_TO_TITLE',
                      },
                      {
                        label: 'Tobacco User',
                        value: '${demographics.spouse.tobacco_user}',
                        format: 'YES_NO',
                      },
                    ],
                  },
                  {
                    prop: 'demographics.dependents',
                    title: 'Dependent ${displayIndex}',
                    repeat: 'demographics.dependents',
                    attributes: [
                      {
                        label: 'Date of Birth',
                        value:
                          '${demographics.dependents.${index}.date_of_birth}',
                        format: 'DATE',
                        noValueMessage: 'HIDE',
                      },
                      {
                        label: 'Gender',
                        value: '${demographics.dependents.${index}.gender}',
                        format: 'SNAKE_CASE_TO_TITLE',
                        noValueMessage: 'HIDE',
                      },
                      {
                        label: 'Tobacco User',
                        value:
                          '${demographics.dependents.${index}.tobacco_user}',
                        format: 'YES_NO',
                        noValueMessage: 'HIDE',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            review: [{ type: 'planDisplay', label: 'Product/Plan Selection' }],
          },
        ],
        review: {
          type: 'review',
          label: 'Review',
          printConfig: {
            type: 'pdf',
            endpoint: 'api/documents/external/persist/?download=True',
            fileName: 'quote',
            static_values: {
              logo: 'https://zipari-assets-prod.s3-us-west-1.amazonaws.com/melody/melody.0.0.42/img/brand/Friday_logo_scalable.svg',
            },
            zip_pdf_main_css: 'democare.quote_pdf.template',
            zip_pdf_main_html: 'democare.quote_pdf.template',
          },
          showReviewStepperFooterEffectiveLabel: false,
        },
        confirm: { confirmText: '', showConfirm: false },
        workflowNav: {
          logoRoute: '/',
          exitEnrollmentIcon: 'exit',
          exitEnrollmentText: 'Exit Quote',
          exitEnrollmentRoute: '/shopping/individual/quotes',
        },
        confirmation: {
          text: {
            print: 'Print Your Application',
            reason: 'Reason',
            coverage: 'coverage',
            zip_code: 'ZIP Code',
            submitted: 'Submitted',
            learn_more: 'Learn More About Your New Plan',
            subscriber: 'Subscriber',
            quick_links: 'Quick Links',
            coverage_type: 'Coverage Type',
            selected_plans: 'Selected Plans',
            confirmation_num: 'Confirmation Number',
            enrollment_status: 'Enrollment Status',
            coverage_start_date: 'Coverage Start Date',
            will_receive_updates:
              'You will receive updates to keep you informed. In the meantime, you can always check your status by logging into your account.',
            application_submitted:
              'Your Application Was Successfully Submitted',
          },
          cards: [
            {
              icon: 'id_product',
              label: 'Confirmation Number',
              value: '${confirmation_number}',
            },
            {
              icon: 'clipboard',
              label: 'Enrollment Status',
              value: '${status}',
              format: 'SNAKE_CASE_TO_TITLE',
            },
            { icon: 'wellness_product', label: 'Plans', value: '${plans}' },
          ],
          label: 'Application Complete',
          summary: [
            {
              title: 'Coverage & Members',
              sections: [
                {
                  title: 'Coverage',
                  attributes: [
                    { prop: 'permanent_address.zipcode', label: 'ZIP Code' },
                    {
                      prop: 'demographics.displayCoverageType',
                      label: 'Coverage Type',
                    },
                    {
                      prop: 'coverage_effective_date',
                      label: 'Coverage Start Date',
                      format: 'DATE',
                    },
                  ],
                },
                {
                  title: 'Subscriber',
                  actions: [{ name: 'HIDE' }],
                  attributes: [
                    { prop: 'subscriber', label: 'Name', format: 'FULL_NAME' },
                    {
                      prop: 'subscriber.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    { prop: 'subscriber.gender', label: 'Gender' },
                    {
                      prop: 'subscriber.displaySSN',
                      label: 'Social Security Number',
                    },
                  ],
                  conditions: {
                    all: [{ name: 'subscriber', operation: 'EXISTS' }],
                  },
                },
                {
                  title: 'Spouse',
                  actions: [{ name: 'HIDE' }],
                  attributes: [
                    { prop: 'spouse', label: 'Name', format: 'FULL_NAME' },
                    {
                      prop: 'spouse.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    { prop: 'spouse.gender', label: 'Gender' },
                    {
                      prop: 'spouse.displaySSN',
                      label: 'Social Security Number',
                    },
                  ],
                  conditions: {
                    all: [{ name: 'spouse', operation: 'EXISTS' }],
                  },
                },
                {
                  title: 'Dependent ${ind}',
                  actions: [{ name: 'HIDE' }],
                  attributes: [
                    {
                      prop: 'dependent${i}',
                      label: 'Name',
                      format: 'FULL_NAME',
                    },
                    {
                      prop: 'dependent${i}.date_of_birth',
                      label: 'Date of Birth',
                      format: 'DATE',
                    },
                    { prop: 'dependent${i}.gender', label: 'Gender' },
                    {
                      prop: 'dependent${i}.displaySSN',
                      label: 'Social Security Number',
                    },
                  ],
                  conditions: {
                    all: [{ name: 'dependents', operation: 'EXISTS' }],
                  },
                },
              ],
            },
            { type: 'plan', title: 'Selected Plan' },
            {
              type: 'pcp',
              title: 'Primary Care Physician (PCP)',
              actions: [{ name: 'HIDE' }],
              conditions: {
                all: [{ name: 'steps.pcp_selection', operation: 'EXISTS' }],
              },
            },
            {
              title: 'Special Enrollment Period',
              actions: [{ name: 'HIDE' }],
              attributes: [{ prop: 'qleReason', label: 'Reason' }],
              conditions: { all: [{ name: 'qleReason', operation: 'EXISTS' }] },
            },
            {
              title: 'Personal Information',
              sections: [
                {
                  title: 'Address',
                  attributes: [
                    {
                      prop: 'permanent_address.street_name_1',
                      label: 'Address 1',
                    },
                    {
                      prop: 'permanent_address.street_name_2',
                      label: 'Address 2',
                    },
                    { prop: 'permanent_address.city', label: 'City' },
                    { prop: 'permanent_address.state', label: 'State' },
                    { prop: 'permanent_address.zipcode', label: 'ZIP Code' },
                  ],
                },
                {
                  title: 'Contact',
                  attributes: [
                    {
                      prop: 'phoneNumber',
                      label: 'Primary Phone Number',
                      format: 'PHONE',
                    },
                    { prop: 'email', label: 'Email Address', format: 'EMAIL' },
                  ],
                },
              ],
            },
            {
              title: 'Payment Information',
              actions: [{ name: 'HIDE' }],
              sections: [
                {
                  title: 'Payment Method',
                  attributes: [
                    {
                      prop: 'payment.displayPaymentMethod',
                      label: 'Payment Method',
                    },
                    {
                      prop: 'payment.totalMonthlyPremium',
                      label: 'Payment Amount',
                    },
                  ],
                },
                {
                  title: 'Card / Account Information',
                  actions: [{ name: 'HIDE' }],
                  attributes: [
                    {
                      prop: 'payment.cardNumber',
                      label: 'Card/Account Number',
                    },
                    {
                      prop: 'payment.expiration',
                      label: 'Expiration Date',
                      format: 'DATE',
                    },
                    { prop: 'payment.zipcode', label: 'Billing ZIP Code' },
                  ],
                  conditions: {
                    all: [
                      {
                        name: 'displayPaymentMethod',
                        value: 'Credit Card / Debit Card',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                },
                {
                  title: 'Bank Account',
                  actions: [{ name: 'HIDE' }],
                  attributes: [
                    { prop: 'payment.bank', label: 'Bank' },
                    {
                      prop: 'payment.accountNumber',
                      label: 'Account Number',
                      format: 'DATE',
                    },
                    { prop: 'payment.routingNumber', label: 'Routing Number' },
                  ],
                  conditions: {
                    all: [
                      {
                        name: 'displayPaymentMethod',
                        value: 'Credit Card / Debit Card',
                        operation: 'EQUALS',
                      },
                    ],
                  },
                },
              ],
              conditions: { all: [{ name: 'payment', operation: 'EXISTS' }] },
            },
            {
              type: 'signature',
              title: 'Attestation',
              actions: [{ name: 'HIDE' }],
              conditions: {
                all: [{ name: 'signee_info', operation: 'EXISTS' }],
              },
            },
          ],
          download: {
            content: 'Print Your Application',
            printConfig: { hidden: true },
          },
          learnMore: [
            {
              icon: 'hospital',
              link: 'https://www.google.com/',
              label: 'Getting Care',
              button: 'Get Care',
              description:
                "Learn how to find a doctor, why it's important to have a primary care physician, when you need urgent or emergency care, how to get care outside of a doctor's office and more.",
            },
            {
              icon: 'file',
              link: 'https://www.google.com/',
              label: 'Plan Resources',
              button: 'Get Information',
              description:
                'Access important plan documents that explain your benefits and learn how to make the most of your individual and family medical, dental, and/or vision plan(s).',
            },
            {
              icon: 'costs_product',
              link: 'https://www.google.com/',
              label: 'Billing Resources',
              button: 'Learn More',
              description:
                'Whether you want to sign-up for automatic payments, learn how to pay your bill online, or want to learn the basics about healthcare costs and claims, you can find it all here.',
            },
          ],
          learn_more: [
            {
              icon: 'hospital',
              link: 'https://www.google.com/',
              label: 'Getting Care',
              button: 'Get Care',
              description:
                "Learn how to find a doctor, why it's important to have a primary care physician, when you need urgent or emergency care, how to get care outside of a doctor's office and more.",
            },
            {
              icon: 'file',
              link: 'https://www.google.com/',
              label: 'Plan Resources',
              button: 'Get Information',
              description:
                'Access important plan documents that explain your benefits and learn how to make the most of your individual and family medical, dental, and/or vision plan(s).',
            },
            {
              icon: 'costs_product',
              link: 'https://www.google.com/',
              label: 'Billing Resources',
              button: 'Learn More',
              description:
                'Whether you want to sign-up for automatic payments, learn how to pay your bill online, or want to learn the basics about healthcare costs and claims, you can find it all here.',
            },
          ],
          quickLinks: [
            {
              icon: 'heart_product',
              link: 'https://www.google.com/',
              label: 'Protect Your Whole Self',
              button: 'Get Total Coverage',
              description:
                'Add a dental plan, vision plan, or life insurance plan for full coverage.',
            },
            {
              icon: 'video_product',
              link: 'https://www.google.com/',
              label: 'Helpful Videos',
              button: 'Watch Now',
              description:
                'Find out how to access all the important features of your membership.',
            },
            {
              icon: 'file',
              link: 'https://www.google.com/',
              label: 'Definitions',
              button: 'Read Now',
              description:
                'Get help understanding basic healthcare and billing terms.',
            },
            {
              icon: 'care',
              link: 'https://www.google.com/',
              label: 'Pharmacy',
              button: 'Learn More',
              description:
                'View the drug formulary for your plan, learn about mail service pharmacy.',
            },
            {
              icon: 'calculator',
              link: 'https://www.google.com/',
              label: 'Treatment Cost Estimator',
              button: 'Estimate Now',
              description:
                'With a PPO plan, you can use this tool to estimate and compare your costs.',
            },
            {
              icon: 'wellness_product',
              link: 'https://www.google.com/',
              label: 'Prevention',
              button: 'View Guidelines',
              description:
                'See what’s covered during a preventive care visit and guidelines for every age.',
            },
          ],
          quick_links: [
            {
              icon: 'heart_product',
              link: 'https://www.google.com/',
              label: 'Protect Your Whole Self',
              button: 'Get Total Coverage',
              description:
                'Add a dental plan, vision plan, or life insurance plan for full coverage.',
            },
            {
              icon: 'video_product',
              link: 'https://www.google.com/',
              label: 'Helpful Videos',
              button: 'Watch Now',
              description:
                'Find out how to access all the important features of your membership.',
            },
            {
              icon: 'file',
              link: 'https://www.google.com/',
              label: 'Definitions',
              button: 'Read Now',
              description:
                'Get help understanding basic healthcare and billing terms.',
            },
            {
              icon: 'care',
              link: 'https://www.google.com/',
              label: 'Pharmacy',
              button: 'Learn More',
              description:
                'View the drug formulary for your plan, learn about mail service pharmacy.',
            },
            {
              icon: 'calculator',
              link: 'https://www.google.com/',
              label: 'Treatment Cost Estimator',
              button: 'Estimate Now',
              description:
                'With a PPO plan, you can use this tool to estimate and compare your costs.',
            },
            {
              icon: 'wellness_product',
              link: 'https://www.google.com/',
              label: 'Prevention',
              button: 'View Guidelines',
              description:
                'See what’s covered during a preventive care visit and guidelines for every age.',
            },
          ],
          showSummary: true,
          planTypeOrder: ['medical', 'bundled', 'dental', 'vision'],
          attributeColumns: 3,
          defaultNoValueMessage: 'N/A',
        },
        demographics: {
          members: {
            form: {
              controls: [
                {
                  prop: 'date_of_birth',
                  type: 'date',
                  label: 'Date of Birth',
                  validators: [
                    'required',
                    'reasonableDate',
                    {
                      name: 'minAge',
                      dependency: {
                        age: 18,
                        dateProp: 'parent.value.coverage_effective_date',
                      },
                    },
                    {
                      name: 'maxAge',
                      dependency: {
                        age: 65,
                        dateProp: 'parent.value.coverage_effective_date',
                      },
                    },
                  ],
                },
              ],
            },
            icon: { iconName: 'cover_who', showIcon: true },
            cards: {
              spouse: {
                prop: 'spouse',
                label: 'YOUR SPOUSE OR PARTNER',
                controls: [
                  {
                    prop: 'date_of_birth',
                    type: 'date',
                    label: 'Date of Birth',
                    errors: {
                      maxAge: 'Please enter a valid date of birth',
                      minAge: 'Spouse must be age 14 or older',
                      required: 'Please enter a valid date of birth',
                      dateInPast: 'Please enter a valid date of birth',
                      reasonableDate: 'Please enter a valid date of birth',
                    },
                    validators: [
                      'required',
                      'dateInPast',
                      'reasonableDate',
                      {
                        name: 'minAge',
                        dependency: {
                          age: 14,
                          dateProp: 'parent.value.coverage_effective_date',
                        },
                      },
                    ],
                  },
                  {
                    prop: 'gender',
                    type: 'toggle',
                    label: 'Gender',
                    options: [
                      { label: 'Male', value: 'male' },
                      { label: 'Female', value: 'female' },
                    ],
                    validators: ['required'],
                  },
                  {
                    prop: 'tobacco_user',
                    type: 'toggle',
                    label: 'Tobacco User',
                    options: [
                      { label: 'Yes', value: true },
                      { label: 'No', value: false },
                    ],
                    validators: ['required'],
                    description:
                      'Has your spouse or partner smoked or used tobacco products on average for four (4) or more times per week within the past six months (includes chewing tobacco, cigarettes, cigars and pipes, excludes religious or ceremonial use of tobacco)?',
                  },
                  {
                    prop: 'medicare_enrolled',
                    type: 'toggle',
                    label: 'Is your spouse or partner enrolled in Medicare?',
                    errors: {
                      equals:
                        "If you're already covered by Medicare Part A or Part B and have questions, call us at 1-800-670-5935 (TTY 711).",
                    },
                    options: [
                      { label: 'Yes', value: 'true' },
                      { label: 'No', value: 'false' },
                    ],
                    validators: [
                      'required',
                      { name: 'equals', dependency: 'false' },
                    ],
                    conditionalControls: [
                      {
                        prop: 'medicare_enrolled_applicant_name',
                        type: 'text',
                        label: 'Applicant Name',
                        validators: ['required'],
                      },
                    ],
                  },
                ],
                maxAgeAllowed: true,
                maxAllowedText: 'You maybe eligible for Medicare',
              },
              children: {
                prop: 'children',
                label: 'YOUR DEPENDENT',
                notes: [
                  'For a dependent only application, the dependent must be less than 18 years old.',
                  'If you need to enroll more than one dependent without also including an adult on the policy, you will need to submit separate applications for each dependent.',
                ],
                controls: [
                  {
                    prop: 'date_of_birth',
                    type: 'date',
                    label: 'Date of Birth',
                    errors: {
                      maxAge: 'Child dependent must be under the age 26',
                      required: 'Please enter a valid date of birth',
                      reasonableDate:
                        'Child dependent must be under the age 26',
                      dateInFutureWithinDays:
                        'Please enter a valid date of birth',
                    },
                    validators: [
                      'required',
                      { name: 'dateInFutureWithinDays', dependency: 0 },
                      'reasonableDate',
                      {
                        name: 'maxAge',
                        dependency: {
                          age: 26,
                          dateProp:
                            'parent.parent.value.coverage_effective_date',
                        },
                      },
                    ],
                  },
                  {
                    prop: 'gender',
                    type: 'toggle',
                    label: 'Gender',
                    options: [
                      { label: 'Male', value: 'male' },
                      { label: 'Female', value: 'female' },
                    ],
                    validators: ['required'],
                  },
                  {
                    prop: 'tobacco_user',
                    type: 'toggle',
                    label: 'Tobacco User',
                    options: [
                      { label: 'Yes', value: true },
                      { label: 'No', value: false },
                    ],
                    validators: ['required'],
                    description:
                      'Has this dependent smoked or used tobacco products on average for four (4) or more times per week within the past six months (includes chewing tobacco, cigarettes, cigars and pipes, excludes religious or ceremonial use of tobacco)?',
                  },
                  {
                    prop: 'medicare_enrolled',
                    type: 'toggle',
                    label: 'Is this dependent enrolled in Medicare?',
                    errors: {
                      equals:
                        "If you're already covered by Medicare Part A or Part B and have questions, call us at 1-800-670-5935 (TTY 711).",
                    },
                    options: [
                      { label: 'Yes', value: 'true' },
                      { label: 'No', value: 'false' },
                    ],
                    validators: [
                      'required',
                      { name: 'equals', dependency: 'false' },
                    ],
                    conditionalControls: [
                      {
                        prop: 'medicare_enrolled_applicant_name',
                        type: 'text',
                        label: 'Applicant Name',
                        validators: ['required'],
                      },
                    ],
                  },
                ],
              },
              child_only: {
                prop: 'children',
                label: 'Your Dependent',
                notes: [
                  'If you need to enroll more than one dependent without also including an adult on the policy, you will need to submit separate applications for each dependent.',
                ],
                controls: [
                  {
                    prop: 'date_of_birth',
                    type: 'date',
                    label: 'Date of Birth',
                    errors: {
                      maxAge: 'Dependent must be 20 or younger',
                      required: 'Please enter a valid date of birth',
                      dateInPast: 'Please enter a valid date of birth',
                      reasonableDate: 'Please enter a valid date of birth',
                    },
                    validators: [
                      'required',
                      'dateInPast',
                      'reasonableDate',
                      {
                        name: 'maxAge',
                        dependency: {
                          age: 20,
                          dateProp:
                            'parent.parent.value.coverage_effective_date',
                        },
                      },
                    ],
                  },
                  {
                    prop: 'gender',
                    type: 'toggle',
                    label: 'Gender',
                    options: [
                      { label: 'Male', value: 'male' },
                      { label: 'Female', value: 'female' },
                    ],
                    validators: ['required'],
                  },
                  {
                    prop: 'tobacco_user',
                    type: 'toggle',
                    label: 'Tobacco User',
                    options: [
                      { label: 'Yes', value: true },
                      { label: 'No', value: false },
                    ],
                    validators: ['required'],
                    description:
                      'Has this dependent smoked or used tobacco products on average for four (4) or more times per week within the past six months (includes chewing tobacco, cigarettes, cigars and pipes, excludes religious or ceremonial use of tobacco)?',
                  },
                  {
                    prop: 'medicare_enrolled',
                    type: 'toggle',
                    label: 'Is this dependent enrolled in Medicare?',
                    errors: {
                      equals:
                        "If you're already covered by Medicare Part A or Part B and have questions, call us at 1-800-670-5935 (TTY 711).",
                    },
                    options: [
                      { label: 'Yes', value: 'true' },
                      { label: 'No', value: 'false' },
                    ],
                    validators: [
                      'required',
                      { name: 'equals', dependency: 'false' },
                    ],
                    conditionalControls: [
                      {
                        prop: 'medicare_enrolled_applicant_name',
                        type: 'text',
                        label: 'Applicant Name',
                        validators: ['required'],
                      },
                    ],
                  },
                ],
                childLimit: 1,
              },
              subscriber: {
                prop: 'subscriber',
                label: 'YOURSELF',
                controls: [
                  {
                    prop: 'date_of_birth',
                    type: 'date',
                    label: 'Date of Birth',
                    errors: {
                      maxAge: 'Please enter a valid date of birth',
                      minAge: 'Subscriber must be age 18 or older',
                      required: 'Please enter a valid date of birth',
                      dateInPast: 'Please enter a valid date of birth',
                      reasonableDate: 'Please enter a valid date of birth',
                    },
                    validators: [
                      'required',
                      'dateInPast',
                      'reasonableDate',
                      {
                        name: 'minAge',
                        dependency: {
                          age: 18,
                          dateProp: 'parent.value.coverage_effective_date',
                        },
                      },
                    ],
                  },
                  {
                    prop: 'gender',
                    type: 'toggle',
                    label: 'Gender',
                    options: [
                      { label: 'Male', value: 'male' },
                      { label: 'Female', value: 'female' },
                    ],
                    validators: ['required'],
                  },
                  {
                    prop: 'tobacco_user',
                    type: 'toggle',
                    label: 'Tobacco User',
                    options: [
                      { label: 'Yes', value: true },
                      { label: 'No', value: false },
                    ],
                    validators: ['required'],
                    description:
                      'Have you smoked or used tobacco products on average for four (4) or more times per week within the past six months (includes chewing tobacco, cigarettes, cigars and pipes, excludes religious or ceremonial use of tobacco)?',
                  },
                  {
                    prop: 'medicare_enrolled',
                    type: 'toggle',
                    label: 'Are you enrolled in Medicare?',
                    errors: {
                      equals:
                        "If you're already covered by Medicare Part A or Part B and have questions, call us at 1-800-670-5935 (TTY 711).",
                    },
                    options: [
                      { label: 'Yes', value: 'true' },
                      { label: 'No', value: 'false' },
                    ],
                    validators: [
                      'required',
                      { name: 'equals', dependency: 'false' },
                    ],
                    conditionalControls: [
                      {
                        prop: 'medicare_enrolled_applicant_name',
                        type: 'text',
                        label: 'Applicant Name',
                        validators: ['required'],
                      },
                    ],
                  },
                ],
                maxAgeAllowed: true,
                maxAllowedText: 'You maybe eligible for Medicare',
              },
              stepParents: {
                prop: 'stepParents',
                label: 'YOUR PARENT(S)/STEP-PARENT(S)',
                controls: [
                  {
                    prop: 'date_of_birth',
                    type: 'date',
                    label: 'Date of Birth',
                    errors: {
                      maxAge:
                        'Parent(s)/Step Parent(s) dependent must be under the age 115',
                      minAge:
                        'Parent(s)/Step Parent(s) dependent must be above 26',
                      required: 'Please enter a valid date of birth',
                      dateInPast: 'Please enter a valid date of birth',
                      reasonableDate: 'Please enter a valid date of birth',
                    },
                    validators: [
                      'required',
                      'dateInPast',
                      'reasonableDate',
                      {
                        name: 'maxAge',
                        dependency: {
                          age: 114,
                          dateProp: 'root.value.coverage_effective_date',
                        },
                      },
                      {
                        name: 'minAge',
                        dependency: {
                          age: 27,
                          dateProp: 'root.value.coverage_effective_date',
                        },
                      },
                    ],
                    placeholder: 'YYYY-MM-DD',
                  },
                  {
                    prop: 'tobacco_user',
                    type: 'toggle',
                    label: 'Are you a tobacco user?',
                    options: [
                      { label: 'Yes', value: true },
                      { label: 'No', value: false },
                    ],
                    validators: ['required'],
                    description:
                      'Tobacco user is defined as using tobacco products (for example cigarettes, cigars, smokeless tobacco, e-cigarettes) four or more times a week on average (other than for religious or ceremonial purposes) within the last six months. This only applies to individuals age 21 and over.',
                  },
                ],
              },
            },
            title: 'Who Needs Insurance?',
            options: {
              family: {
                icon: 'family',
                cards: ['subscriber', 'spouse', 'children'],
                label: 'You + Spouse/Partner + Children',
                value: 'family',
              },
              parent: {
                icon: 'spouse',
                cards: ['subscriber', 'children'],
                label: 'You + Children',
                value: 'parent',
              },
              spouse: {
                icon: 'spouse',
                cards: ['subscriber', 'spouse'],
                label: 'You + Spouse/Partner',
                value: 'spouse',
              },
              children: {
                icon: 'single',
                cards: ['child_only'],
                label: 'Children',
                value: 'children',
                one_per_policy: false,
              },
              subscriber: {
                icon: 'single',
                cards: ['subscriber'],
                label: 'Yourself',
                value: 'subscriber',
              },
            },
            subtitle: 'You can apply for yourself or a family member',
            addAnotherParent: { text: 'Add Another Parent(s)/Step-Parent(s)' },
            hasParentDependents: false,
            individualsCoveredOptions: {
              family: {
                icon: 'add_family',
                cards: ['subscriber'],
                label: 'Family',
                value: 'family',
              },
              children: {
                icon: 'add_child_only',
                cards: ['child_only'],
                label: 'Child Only',
                value: 'children',
                one_per_policy: true,
              },
              subscriber: {
                icon: 'add_yourself',
                cards: ['subscriber'],
                label: 'Subscriber Only',
                value: 'subscriber',
              },
            },
          },
          coverage: {
            form: {
              county: {
                prop: 'county',
                type: 'dropdown',
                label: 'County',
                options: [],
                validators: ['required'],
                headingLevel: 3,
              },
              zipcode: {
                mask: 'number',
                prop: 'zipcode',
                type: 'text',
                label: 'ZIP Code',
                errors: { customErrMessage: 'Please enter a valid CA zipcode' },
                maxLength: 5,
                validators: ['required', 'zipcode'],
                enterAnother: 'Please enter another ZIP Code.',
                headingLevel: 3,
              },
              coverage_type: {
                prop: 'coverage_type',
                type: 'checkbox',
                label: 'Coverage Type',
                default: 'health',
                options: [
                  { label: 'Medical', value: 'health' },
                  { label: 'Dental', value: 'dental' },
                  { label: 'Vision', value: 'vision' },
                ],
                validators: ['required'],
                headingLevel: 3,
              },
            },
            text: {
              max_age_spouse_medicare_or_individual_or_dental:
                "<span class='t-bold'>Please Note:</span> Based on the date of birth you entered, your spouse may qualify for Medicare. You can view our Medicare-eligible plans at <a href='https://blueshieldcamedicare.com' class='t-data t-link'>https://blueshieldcamedicare.com</a>. If you would prefer an Individual & Family plan instead, please call us at <a href='tel: (888) 273-0010' class='t-data t-link'>(888) 273-0010</a> to apply. If you are only interested in purchasing a dental or vision plan, select Dental and/or Vision plan",
              max_age_subscriber_medicare_or_individual_or_dental:
                "<span class='t-bold'>Please Note:</span> Based on the date of birth you entered, you may qualify for Medicare. You can view our Medicare-eligible plans at <a href='https://blueshieldcamedicare.com' class='t-data t-link'>https://blueshieldcamedicare.com</a>. If you would prefer an Individual & Family plan instead, please call us at <a href='tel: (888) 273-0010' class='t-data t-link'>(888) 273-0010 </a>to apply. If you are only interested in purchasing a dental or vision plan, select Dental and/or Vision plan",
            },
            title: "Let's find you a plan",
            messages: {
              aep: 'You can still enroll in the Annual Enrollment Period by choosing one of the following dates:',
              sep: "Open Enrollment ended January 15, but you can still qualify for health coverage if you experienced a <span class='t-link'>qualifying event</span>. The next open enrollment period begins October 15th.",
            },
          },
        },
        dental_vision: {
          filters: { controls: [] },
          quoting: true,
          backButton: { level: 'medium', content: 'Back' },
          isSkippable: false,
          showCompare: false,
          showFilters: false,
          maxSelectable: 4,
          multiPlanTypes: [
            {
              prop: 'bundled',
              label: 'Bundled',
              conditional: { health: { prop: 'bundled', label: 'Bundled' } },
            },
            {
              prop: 'dental',
              label: 'Dental',
              conditional: { dental: { prop: 'dental', label: 'Dental' } },
            },
            {
              prop: 'vision',
              label: 'Vision',
              conditional: { vision: { prop: 'vision', label: 'Vision' } },
            },
          ],
          extraPlanFilters: {
            ordering: 'display_name',
            market_segment: 'individual',
          },
          showShoppingCart: true,
          singlePlanSelection: {
            text: {
              subtitle: '_',
              noResults: 'NO RESULTS',
              youSelected: "You've selected",
              sheaderSubtitle: ' ',
            },
            plan_details: {
              omnia_note:
                'Note: You are viewing OMNIA Tier 1 benefits. You doctor must be in this network to receive this benefit.',
              viewDetailConfig: {
                hideText: 'Hide details',
                viewText: 'View details',
              },
              displayAllDocuments: true,
            },
          },
          footerNextButtonDisplayText: {
            dental: 'Review Quote',
            health: 'Review Quote',
            vision: 'Review Quote',
            bundled: 'Review Quote',
            medical: 'Review Quote',
            'dental/vision': 'Review Quote',
            'health/dental': 'Next',
            'medical/dental': 'Next',
          },
        },
        plan_selection: {
          type: 'plan-selection',
          label: 'Plan Selection',
          button: { content: 'Review Quote' },
          review: [{ type: 'planCard', label: 'Product/Plan Selection' }],
          filters: {
            sortHeader: 'Sort',
            filterHeader: 'Filters',
            filterApplyButton: 'Apply',
            filterResetButton: 'Reset',
          },
          noModal: true,
          quoting: true,
          planTypes: [
            {
              prop: 'medical',
              label: 'Plans with Subsidies',
              subProp: 'subsidy',
            },
            {
              prop: 'medical',
              label: 'Plans without Subsidies',
              subProp: 'not-subsidy',
            },
          ],
          canCompare: false,
          showCompare: true,
          showFilters: true,
          showNewCard: true,
          subsidyText: {
            subsidyLabel: 'with a ${subsidyAmount} subsidy',
            originalPriceLabel: '(Originally ${originalPrice})',
          },
          shoppingCart: { totalPremiumLabel: 'Total Premium:' },
          compare_plans: {
            label: {
              linkLabel: 'Click Here',
              backToPlans: 'Back to All Plans',
            },
            showEnroll: false,
            compareTitle: 'Compare',
            enrollButton: 'Enroll',
            compareMessage: 'Select up to ${maxComparable} plans to compare',
            comparePlaceholder: 'add plan to compare',
            displayAllDocuments: true,
            showResourcesAsBenefit: true,
          },
          maxSelectable: 4,
          planTabLabels: [
            {
              prop: 'medical',
              text: 'Plans with Subsidies',
              subProp: 'subsidy',
            },
            {
              prop: 'medical',
              text: 'Plans without Subsidies',
              subProp: 'not-subsidy',
            },
          ],
          singlePlanType: 'medical',
          isAccordionOpen: true,
          showPlanDetails: true,
          extraPlanFilters: { market_segment: 'individual' },
          hideFilterFooter: true,
          showShoppingCart: true,
          responsiveFilters: true,
          deleteConfirmModal: {
            body: 'You are about to delete ${display_name}',
            header: 'Delete Plan?',
            confirm: 'Yes, Delete Plan',
          },
          singlePlanSelection: {
            text: {
              noResults: 'NO RESULTS',
              youSelected: "You've selected ",
              headerSubtitle: null,
            },
            plan_details: {
              showLinks: false,
              omnia_note:
                'Note: You are viewing OMNIA Tier 1 benefits. You doctor must be in this network to receive this benefit.',
              find_doctor: { link: null, label: 'Find a Doctor' },
              summary_benefits: { label: 'View Summary of Plan Benefits' },
              displayAllDocuments: true,
            },
          },
          hideStandaloneDental: true,
          multi_plan_selection: {
            text: {
              no_results: 'NO RESULTS',
              you_selected: "You've Selected:",
              you_selected_multi: "You've selected multiple plans.",
            },
          },
          setTabAsPerSubsidyAmount: true,
          footerNextButtonDisplayText: {
            dental: 'Review Quote',
            health: 'Review Quote',
            vision: 'Review Quote',
            bundled: 'Review Quote',
            medical: 'Review Quote',
            'dental/vision': 'Review Quote',
            'health/dental': 'Next',
            'medical/dental': 'Next',
          },
        },
      },
      'quote-details': {
        aside: {
          header: 'Quote Details',
          attributes: [
            {
              icon: 'person',
              label: 'Subscriber',
              value: '${data.client.first_name} ${data.client.last_name}',
              headingLevel: 2,
            },
            {
              icon: 'email',
              label: 'Email',
              value: '${data.client.email}',
              format: 'EMAIL',
              headingLevel: 2,
            },
            {
              icon: 'phone',
              label: 'Phone',
              value: '${data.client.phone_number}',
              format: 'PHONE',
              headingLevel: 2,
            },
          ],
          extraAttributes: [
            {
              label: 'Broker',
              value: '${data.broker.first_name} ${data.broker.last_name}',
              headingLevel: 2,
              noValueMessage: 'HIDE',
            },
            {
              label: 'Shared',
              value: '${data.is_shared}',
              format: 'YES_NO',
              headingLevel: 2,
              noValueMessage: 'No',
            },
          ],
        },
        badge: [
          { label: 'Quote ID', value: '${data.id}' },
          { type: 'flat', label: 'Client', value: '${data.first_name}' },
          {
            type: 'flat',
            label: 'Requested Effective Date',
            value: '${data.coverage_effective_date}',
            format: 'DATE',
          },
        ],
        enroll: {
          allow: true,
          selected: {
            icon: 'check_circle',
            level: 'high',
            content: 'Selected',
          },
          unselected: {
            icon: '',
            level: 'medium',
            content: 'Select for Enrollment',
          },
        },
        endpoint: 'api/shopping/quotes/individuals/${params.id}/',
        sections: [
          { type: 'planDisplay', label: 'Selected Plans' },
          { type: 'memberDisplay', label: 'Members' },
        ],
        actionMenu: {
          icon: 'chevron_down',
          level: 'high',
          subnav: {
            items: [
              { prop: { action: 'download-quote' }, label: 'Download Quote' },
              {
                prop: { action: 'delete-quote' },
                label: 'Delete Quote',
                conditions: {
                  all: [
                    {
                      name: 'data.status',
                      value: 'expired',
                      operation: 'INCLUDES',
                    },
                  ],
                },
              },
            ],
          },
          content: 'Actions',
        },
        breadcrumb: {
          text: 'All Quotes',
          route: '/shopping/individual/quotes',
        },
        quoteLabel: 'Quote',
        hasPlanYear: false,
        printConfig: {
          type: 'pdf',
          endpoint: 'api/documents/external/persist/?download=True',
          fileName: 'quote',
          static_values: {
            logo: 'https://zipari-assets-prod.s3-us-west-1.amazonaws.com/melody/melody.0.0.42/img/brand/Friday_logo_scalable.svg',
          },
          zip_pdf_main_css: 'democare.quote_pdf.template',
          zip_pdf_main_html: 'democare.quote_pdf.template',
        },
        workflowType: 'individual',
        statusDisplay: {
          in_progress: { label: 'In Progress', statusType: 'pending' },
        },
        shareQuotePdfForm: {
          controls: [
            {
              prop: 'client_email_address',
              type: 'email',
              label: 'Email address',
              validators: ['required', 'email'],
            },
            {
              prop: 'client_email_body',
              type: 'textarea',
              label: 'Message',
              validators: ['required'],
            },
          ],
        },
        shareLiveQuoteForm: {
          controls: [
            {
              prop: 'client_email_address',
              type: 'text',
              label: 'Email address',
              validators: ['required', 'email'],
            },
            {
              prop: 'client_email_body',
              type: 'textarea',
              label: 'Quote ID',
              validators: ['required'],
            },
          ],
        },
        shareQuotePdfModal: {
          type: 'flyout',
          header: { title: 'Share Quote PDF', showClose: true },
          message:
            'Please find a PDF file attached to this email that includes the details of your quote.',
          subject: 'A quote PDF has been shared with you',
          backdrop: true,
          endpoint: 'api/documents/external/persist/?send_email=True',
          template: 'quote_pdf_email',
          bodyMessage: '',
          errorMessage: 'An error occurred. Please try again.',
          footerButtons: [
            { level: 'medium', content: 'Cancel', disabled: false },
            { level: 'high', content: 'Share', disabled: false },
          ],
        },
        shareLiveQuoteModal: {
          type: 'flyout',
          header: { title: 'Share Live Quote', showClose: true },
          subject: 'A quote has been shared with you',
          backdrop: true,
          endpoint: 'api/documents/external/persist/?send_email=True',
          template: 'share_live_quote_email',
          bodyMessage:
            "By clicking 'Share' you are agreeing to share this quote with your client. By sending the email or copying the link above and sending it to your client, they will have the ability to view this quote from within their dashboard. Please note that if your client has not previously created a login, they will be asked to do so prior to being able to view the quote.",
          errorMessage: 'An error occurred. Please try again.',
          footerButtons: [
            { level: 'medium', content: 'Cancel', disabled: false },
            { level: 'high', content: 'Share', disabled: false },
          ],
        },
        memberCardAttributes: [
          { label: 'Member Type', value: '${memberType}' },
          { label: 'Date of Birth', value: '${date_of_birth}', format: 'DATE' },
          {
            label: 'Tobacco Use',
            value: '${tobacco_user}',
            format: 'YES_NO',
            noValueMessage: 'HIDE',
          },
        ],
        deleteConfirmationModal: {
          body: 'Are you sure you want to permanently delete this quote?',
          type: 'popup',
          header: { title: 'Delete Quote', showClose: true },
          backdrop: true,
          question: 'Are you sure you want to permanently delete this quote?',
          errorMessage: 'An error occurred while trying to delete this quote.',
          footerButton: { level: 'medium', content: 'Delete', disabled: false },
        },
      },
      'document-upload': {
        footer: {
          backButton: { level: 'medium', content: 'Back' },
          nextButton: { level: 'high', content: 'Submit' },
          skipButton: { hide: true },
        },
        header: {
          title: 'Supporting Documentation for Special Enrollment',
          subtitle:
            'You are enrolling for a Special Enrollment Period based on a Qualifying Life Event. The information you provided is displayed below. <br> Please upload the required documentation so we can verify your qualifying life event. You may also skip this step, and provide this information later.',
        },
        documents: {
          uploadInstructions:
            'Select a document type, and then upload the selected document.',
          isDocumentTypeRequired: true,
        },
        attributes: [
          { prop: 'reason', label: 'Reason' },
          { prop: 'updated_coverage_effective_date', label: 'Effective Date' },
        ],
        appStatusOnPostSubmissionDocUpload: 'submitted',
      },
      'application-details': {
        meta: { label: 'Application Detail', enabled: true, description: '' },
        aside: {
          label: 'Application Details',
          header: 'Application Details',
          attributes: [
            {
              id: 'subscriber',
              label: 'Subscriber',
              value:
                '${data.subscriber.first_name} ${data.subscriber.last_name}',
              format: '',
              headingLevel: 2,
            },
            {
              label: 'Email',
              value: '${data.workflow.values.contact_info.email_address}',
              format: 'EMAIL',
              headingLevel: 2,
            },
            {
              label: 'Phone',
              value: '${data.workflow.values.contact_info.primary_phone}',
              format: 'PHONE',
              headingLevel: 2,
            },
          ],
          extraAttributes: [
            {
              label: 'Requested Effective Date',
              value: '${data.workflow.values.coverage_effective_date}',
              format: 'DATE',
              headingLevel: 2,
            },
            {
              label: 'Status',
              value: '${data.status}',
              format: 'SNAKE_CASE_TO_TITLE',
              headingLevel: 2,
            },
            {
              label: 'Date Submitted',
              value: '${data.submitted_date}',
              format: 'DATE',
              headingLevel: 2,
            },
          ],
        },
        badge: [
          { label: 'Application #', value: '${data.id}' },
          {
            prop: 'context.data.plan',
            type: 'flat',
            label: 'Plan Name',
            value: '${data.plan.display_name}',
          },
        ],
        endpoint: 'api/shopping/applications/individuals/${params.id}',
        actionMenu: {
          icon: 'chevron_down',
          level: 'high',
          subnav: {
            items: [
              {
                prop: {
                  action: 'document-upload',
                  allowedStatus: ['submitted', 'submitted_pending_review'],
                },
                label: 'Upload Documents',
              },
              {
                prop: {
                  action: 'continue-application',
                  marketSegment: 'individual',
                },
                label: 'Continue Application',
              },
              {
                prop: { action: 'download-application' },
                label: 'Download Application',
              },
              {
                prop: { action: 'delete-application' },
                label: 'Delete',
                conditions: {
                  any: [
                    {
                      name: 'data.status',
                      value: 'expired',
                      operation: 'EQUALS',
                    },
                  ],
                },
              },
            ],
          },
          content: 'Actions',
          hideDownloadAppBtnWhenAppInProgress: true,
        },
        breadcrumb: {
          text: 'All Applications',
          route: '/shopping/individual/applications',
        },
        showHeader: true,
        deleteModal: {
          body: 'Are you sure you want to permanently delete this application?',
          cancel: { level: 'text', content: 'Cancel' },
          header: 'Delete Application',
          submit: { level: 'high', content: 'Yes, Delete' },
          endpoint: 'api/shopping/applications/individuals/${params.id}',
          successRoute: 'shopping/workbench',
        },
        printConfig: {
          type: 'pdf',
          endpoint: 'api/documents/external/persist/?download=True',
          fileName: 'enrollment',
          dateFormat: { format: 'DATE' },
          static_values: {
            logo: 'https://d32ul9oyxvd2n5.cloudfront.net/assets/logo.png',
          },
          zip_pdf_main_css: 'democare_application_template',
          zip_pdf_main_html: 'democare_application_template',
        },
        statusDisplay: {
          in_progress: { label: 'In Progress', statusType: 'pending' },
        },
        daysUploadAllowed: 30,
        memberCardAttributes: [
          {
            label: 'Name',
            value: '${name.first_name} ${name.last_name} ${name.suffix}',
          },
          { label: 'Gender', value: '${gender}' },
          { label: 'Date of Birth', value: '${birth_date}' },
          { label: 'Tobacco Use', value: '${tobacco_use}', format: 'YES_NO' },
        ],
        memberCardAttributesFromEnrollment: [
          { label: 'Member Type', value: '${memberType}' },
          { label: 'Name', value: '${first_name} ${last_name} ${suffix}' },
          {
            label: 'Gender',
            value: '${gender}',
            format: 'SNAKE_CASE_TO_TITLE',
          },
          {
            label: 'Are you Hispanic, Latino/a or Spanish origin?',
            value: '${hispanic_latino_spanish_origin}',
            format: 'VALUE_MAP',
            formatOptions: {
              map: {
                DC: 'I do not know',
                no: 'No',
                yes: 'Yes',
                choose_not_to_answer: 'I choose not to answer',
              },
            },
            noValueMessage: 'HIDE',
          },
          {
            prop: 'ethnicities',
            label: 'Ethnicity (select all that apply)',
            format: 'LIST',
            formatOptions: {
              keysToValues: [
                { key: '1001', value: 'Mexican, Mexican-American, Chicano/a' },
                { key: '1002', value: 'Puerto Rican' },
                { key: '1000', value: 'Cuban' },
                {
                  key: '1003',
                  value: 'Another Hispanic, Latino/a, or Spanish Origin',
                },
              ],
              displayCommaSeparatedList: true,
            },
            noValueMessage: 'HIDE',
          },
          {
            label: 'Would you like to identify your race?',
            value: '${identify_race}',
            format: 'VALUE_MAP',
            formatOptions: {
              map: {
                DC: 'I do not know',
                no: 'No',
                yes: 'Yes',
                choose_not_to_answer: 'I choose not to answer',
              },
            },
            noValueMessage: 'HIDE',
          },
          {
            prop: 'races',
            label: 'Race (select all that apply)',
            format: 'LIST',
            formatOptions: {
              keysToValues: [
                { key: '1013', value: 'White' },
                { key: '1002', value: 'Black or African American' },
                { key: '1000', value: 'American Indian or Alaska Native' },
                { key: '1001', value: 'Asian Indian' },
                { key: '1003', value: 'Chinese' },
                { key: '1006', value: 'Japanese' },
                { key: '1007', value: 'Korean' },
                { key: '1004', value: 'Filipino' },
                { key: '1021', value: 'Other Asian' },
                { key: '1008', value: 'Native Hawaiian' },
                { key: '1012', value: 'Vietnamese' },
                { key: '1005', value: 'Guamanian or Chamorro' },
                { key: '1022', value: 'Other Pacific Islander' },
                { key: '1011', value: 'Samoan' },
                { key: '1023', value: 'Middle Eastern or North African' },
                { key: '1024', value: 'Another Race Not Listed Above' },
              ],
              displayCommaSeparatedList: true,
            },
            noValueMessage: 'HIDE',
          },
          {
            label:
              'What was your sex assigned at birth? You can find this on an original birth certificate or similar document.',
            value: '${sex_assigned_at_birth}',
            format: 'VALUE_MAP',
            formatOptions: {
              map: {
                F: 'Female',
                M: 'Male',
                DC: 'I choose not to answer',
                NS: 'Not sure',
                not_listed: 'HIDE',
              },
            },
            noValueMessage: 'HIDE',
          },
          {
            label:
              'What was your sex assigned at birth? You can find this on an original birth certificate or similar document.',
            value: '${not_listed_sex_assigned_at_birth}',
            noValueMessage: 'HIDE',
          },
          {
            label: 'What’s your gender identity?',
            value: '${gender_identity}',
            format: 'VALUE_MAP',
            formatOptions: {
              map: {
                F: 'Female',
                M: 'Male',
                DC: 'I choose not to answer',
                NS: 'Not sure',
                TF: 'Transgender female',
                TM: 'Transgender male',
                not_listed: 'HIDE',
              },
            },
            noValueMessage: 'HIDE',
          },
          {
            label: 'What’s your gender identity?',
            value: '${not_listed_gender_identity}',
            noValueMessage: 'HIDE',
          },
          {
            label: 'What’s your sexual orientation?',
            value: '${sexual_orientation}',
            format: 'VALUE_MAP',
            formatOptions: {
              map: {
                BI: 'Bisexual',
                DC: 'I choose not to answer',
                LG: 'Lesbian or gay',
                NS: 'Not sure',
                ST: 'Straight',
                not_listed: 'HIDE',
              },
            },
            noValueMessage: 'HIDE',
          },
          {
            label: 'What’s your sexual orientation?',
            value: '${not_listed_sexual_orientation}',
            noValueMessage: 'HIDE',
          },
          { label: 'Date of Birth', value: '${date_of_birth}' },
          {
            label: 'Tobacco Use',
            value: '${tobacco_user}',
            format: 'YES_NO',
            noValueMessage: 'HIDE',
          },
          {
            label: 'Address',
            value:
              '${address.street_name_1}<br>${address.city}, ${address.state} ${address.zipcode}',
          },
          {
            label: 'Mailing Address',
            value:
              '${mailing_address.street_name_1}<br>${mailing_address.city}, ${mailing_address.state} ${mailing_address.zipcode}',
          },
          {
            label:
              'Is your employer offering you an individual coverage health reimbursement arrangement (ICHRA) or a qualified small employer health reimbursement arrangement (QSEHRA) that you will use to pay premium for individual health insurance coverage?',
            value: '${employer_ichra_qsehra}',
            format: 'VALUE_MAP',
            formatOptions: {
              map: {
                no: 'No',
                ichra: 'Yes, my employer is offering an ICHRA',
                qsehra: 'Yes, my employer is offering a QSEHRA',
                unknown: 'Unknown',
              },
            },
            noValueMessage: 'HIDE',
          },
          {
            label:
              "Does your spouse's employer provide a QSEHRA that will be used to pay all or part of your or your family’s premium?",
            value: '${spouse_qsehra}',
            format: 'VALUE_MAP',
            formatOptions: {
              map: { no: 'No', yes: 'Yes', unknown: 'Unknown' },
            },
            noValueMessage: 'HIDE',
          },
          {
            label:
              "Does your employer or your spouse's employer provide a QSEHRA that will be used to reimburse medical and/or pharmacy claims?",
            value: '${claims_qsehra}',
            format: 'VALUE_MAP',
            formatOptions: {
              map: {
                no: 'No',
                both: "Yes, I will use my employer's QSEHRA and my spouse will use his/her QSEHRA to reimburse medical and/or pharmacy claims",
                spouse:
                  'Yes, my spouse will use his/her QSEHRA to reimburse his/her medical and/or pharmacy claims',
                unknown: 'Unknown',
                employer:
                  "Yes, I will use my employer's QSEHRA to reimburse my medical and/or pharmacy claims",
              },
            },
            noValueMessage: 'HIDE',
          },
        ],
      },
      'application-dashboard': { newApplication: true },
      'quote-detail-unauthenticated': {
        aside: {
          header: 'Quote Details',
          attributes: [
            {
              prop: 'data.coverage_effective_date',
              label: 'Requested Effective Date',
              format: 'DATE',
            },
            { prop: 'data.zipcode', label: 'Zip Code' },
            { prop: 'data.county.county_name', label: 'County' },
            {
              prop: 'data.is_shared',
              label: 'Shared',
              format: 'YES_NO',
              noValueMessage: 'No',
            },
          ],
        },
        enroll: {
          allow: true,
          selected: {
            icon: 'check_circle',
            level: 'high',
            content: 'Selected',
          },
          unselected: { icon: '', level: 'medium', content: 'Select Plan' },
        },
        actionMenu: {
          icon: 'chevron_down',
          level: 'high',
          subnav: {
            items: [
              { prop: { action: 'download-quote' }, label: 'Download Quote' },
            ],
          },
          content: 'Actions',
          menuPosition: 'right',
        },
        hasPlanYear: false,
        printConfig: {
          type: 'pdf',
          endpoint: '/api/documents/external/temp/',
          static_values: {
            logo: 'https://zipari-assets-prod.s3-us-west-1.amazonaws.com/melody/melody.0.0.42/img/brand/Friday_logo_scalable.svg',
          },
          zip_pdf_main_css: 'democare.quote_multiplan.template',
          zip_pdf_main_html:
            'democare.quote_multiplan_ifp_unauthorized.template',
        },
        workflowType: 'individual',
        hideSelection: true,
        quoteCriteria: {
          Spouse: {
            title: 'Spouse',
            attributes: [
              {
                prop: 'coverage_effective_date',
                label: 'Requested Effective Date',
                format: 'DATE',
              },
              { prop: 'zipcode', label: 'Zip Code' },
              {
                prop: 'county.county_name',
                label: 'County',
                format: 'SNAKE_CASE_TO_TITLE',
              },
              { prop: 'tobacco_user', label: 'Tobacco Use', format: 'YES_NO' },
            ],
          },
          Dependent: {
            title: 'Dependent ',
            attributes: [
              {
                prop: 'coverage_effective_date',
                label: 'Requested Effective Date',
                format: 'DATE',
              },
              { prop: 'zipcode', label: 'Zip Code' },
              {
                prop: 'county.county_name',
                label: 'County',
                format: 'SNAKE_CASE_TO_TITLE',
              },
              { prop: 'tobacco_user', label: 'Tobacco Use', format: 'YES_NO' },
            ],
          },
          Subscriber: {
            title: 'Application Filer',
            attributes: [
              {
                prop: 'coverage_effective_date',
                label: 'Requested Effective Date',
                format: 'DATE',
              },
              { prop: 'zipcode', label: 'Zip Code' },
              {
                prop: 'county.county_name',
                label: 'County',
                format: 'SNAKE_CASE_TO_TITLE',
              },
              {
                prop: 'tobacco_user',
                label: 'Tobacco Use',
                format: 'YES_NO',
                noValueMessage: 'HIDE',
              },
            ],
          },
          'Parent/StepParent': {
            title: 'Parent(s)/Step-Parent(s) ',
            attributes: [
              {
                prop: 'coverage_effective_date',
                label: 'Requested Effective Date',
                format: 'DATE',
              },
              { prop: 'zipcode', label: 'Zip Code' },
              {
                prop: 'county.county_name',
                label: 'County',
                format: 'SNAKE_CASE_TO_TITLE',
              },
              { prop: 'tobacco_user', label: 'Tobacco Use', format: 'YES_NO' },
            ],
          },
          additionalMemberAttributeContextProps: [
            'coverage_effective_date',
            'county',
            'zipcode',
          ],
        },
        statusDisplay: {
          in_progress: { label: 'In Progress', statusType: 'pending' },
        },
        endpointTemplate: 'api/shopping/unauthorized-quotes/${params.id}',
        primaryPlanTypes: { health: true, medical: true },
        groupMultiPlanCards: true,
        planDisplaySortOrder: ['medical', 'dental', 'vision'],
        hasRedirectToRegisterWithoutCreatingWorkflow: true,
      },
    },
    navigation: {
      menu: {
        main: [],
        footer: [{ icon: 'login', label: 'Log In', route: 'login' }],
        header: [],
        sections: [
          [
            {
              icon: 'chevron_right',
              type: 'languageSelector',
              label: 'Language',
              onClick: 'toggleLang',
            },
          ],
          [
            {
              auth: 'loggedIn',
              label: 'Workbench',
              route: '/shopping/individual/workbench',
            },
            {
              auth: 'loggedIn',
              label: 'Quotes',
              route: '/shopping/individual/quotes',
            },
            {
              auth: 'loggedIn',
              label: 'Applications',
              route: '/shopping/individual/applications',
            },
            {
              auth: 'loggedIn',
              label: 'Resource Center',
              route: '/shopping/individual/resources',
            },
          ],
          [{ label: 'Contact Us', onClick: 'contact' }],
          [
            {
              auth: 'loggedOut',
              label: 'Register',
              route: '/shopping/register',
            },
            {
              auth: 'loggedOut',
              icon: 'open_in_new',
              label: 'Log In',
              route: '/shopping/login',
            },
            {
              auth: 'loggedIn',
              label: 'Log Out',
              route: '',
              onClick: 'logout',
            },
          ],
        ],
      },
      icons: {
        mobile: [
          {
            auth: 'loggedIn',
            icon: 'notifications',
            count: 'notifications',
            label: 'Notifications',
            route: '/shopping/notifications',
          },
        ],
        tablet: [],
        desktop: [],
      },
      links: [
        {
          icon: 'claims',
          label: 'Workbench',
          route: '/shopping/individual/workbench',
        },
        {
          icon: 'claims',
          label: 'Quotes',
          route: '/shopping/individual/quotes',
        },
        {
          icon: 'claims',
          label: 'Applications',
          route: '/shopping/individual/applications',
        },
        {
          icon: 'claims',
          label: 'Resource Center',
          route: '/shopping/individual/resources',
        },
      ],
      navAlt: false,
      buttons: [
        { level: 'text', content: 'Contact Us', onClick: 'contact' },
        {
          level: 'text',
          route: '/shopping/workbench/',
          content: 'Exit to Dashboard',
          blacklist: [
            'upsell',
            'workbench',
            'quotes',
            'applications',
            'resources',
          ],
          queryParams: { stayOnWorkbench: true },
          hideOnLogout: true,
        },
        {
          type: 'auth',
          level: 'text',
          login: 'Log In',
          route: '/shopping/login',
          logout: 'Log Out',
          content: 'Log In',
        },
      ],
      toolbar: {
        icons: [
          {
            auth: 'loggedIn',
            icon: 'notifications',
            count: 'notifications',
            label: 'Notifications',
            route: '/shopping/notifications',
          },
        ],
        label: 'Market Segment',
        routes: [
          {
            icon: 'person',
            prop: 'individual',
            show: true,
            label: 'Individual',
            route: '/broker-portal/individual/dashboard',
          },
        ],
        displayLanguageSelector: false,
      },
      logo_url: '/shopping/individual/workbench',
      imageLink: '',
      showImage: false,
      contact_us: {
        title: 'Need Help Selecting A Plan?',
        sections: [
          { label: 'Monday to Friday', value: '8 a.m. - 5:30 p.m' },
          {
            label: 'Customer Service',
            value: '(888) 273-0010',
            format: 'PHONE',
          },
          { label: 'Pre-admission', value: '(800) 541-6652', format: 'PHONE' },
          { label: 'Tech Support', value: '(800) 393-6130', format: 'PHONE' },
        ],
        subtitle: 'Give us a Call',
        brokerAssistanceConfigs: [
          { label: 'Broker', value: '${first_name} ${last_name}' },
          { label: 'Id', value: '${broker_id}' },
          { label: 'Phone', value: '${phone}', format: 'PHONE' },
          { label: 'Email', value: '${email_address}', format: 'EMAIL' },
        ],
      },
      showHamburger: true,
      openLogoInNewTab: false,
    },
    personalize: {
      meta: {
        label: 'Personalize (Help Me Choose)',
        enabled: true,
        modules: {
          title: 'string',
          header: 'attribute-list',
          subtitle: 'string',
        },
        description: '',
      },
      title: 'What Matters Most to You?',
      header: {
        label: '',
        attributes: [
          { icon: 'patients', label: 'Set Up' },
          { icon: 'coverage', label: 'Special Enrollment', sepCheck: true },
          { icon: 'coverage', label: 'Personalize' },
          { icon: 'claims', label: 'Plans' },
        ],
      },
      subtitle:
        'When you select plan benefits that are important to you, you will see recommended insurance plans personalized to your needs.',
    },
    tokenExpire: {
      maxCharLimit: 300,
      quoteTokenExpired: {
        img: 'https://zipari-uploads-dev.s3.amazonaws.com/multitenant/images/error-2.original.png',
        header: {
          title: 'Quote Token Shared Link Expired',
          subtitle:
            'Your Quote link has expired, please contact your broker or sales representative for a new link.',
        },
      },
      applicationTokenExpired: {
        img: 'https://zipari-uploads-dev.s3.amazonaws.com/multitenant/images/error-2.original.png',
        header: {
          title: 'Application Token Shared Link Expired',
          subtitle:
            "We apologize for the inconvenience caused by the expired application link. It's possible that Your application link has expired. To receive a new link, please contact your broker or sales representative. They will be happy to assist you with the process and provide you with a new link. We value you. We appreciate your patience.",
        },
      },
    },
    applications: {
      table: {
        title: 'Applications',
        button: { icon: '', level: 'high', content: 'Create Application' },
        export: { icon: 'download', level: '', content: '' },
        paging: { enabled: true, pageSize: 20 },
        columns: [
          { name: 'Application ID', prop: 'id', sortable: true },
          {
            name: 'First Name',
            prop: 'subscriber.first_name',
            sortable: true,
            sortByProp: 'data__subscriber__first_name',
          },
          {
            name: 'Last Name',
            prop: 'subscriber.last_name',
            sortable: true,
            sortByProp: 'data__subscriber__last_name',
          },
          {
            name: 'Status',
            prop: 'status',
            format: 'STATUS',
            sortable: true,
            statuses: {
              info: [],
              error: [
                { label: 'Declined', value: 'declined' },
                { label: 'Denied', value: 'denied' },
              ],
              expired: [{ label: 'Expired', value: 'expired' }],
              pending: [
                { label: 'In Progress', value: 'in_progress' },
                { label: 'Pended', value: 'pended' },
              ],
              success: [{ label: 'Submitted', value: 'submitted' }],
            },
          },
          {
            name: 'Req. Eff. Date',
            prop: 'coverage_effective_date',
            format: 'DATE',
            sortable: true,
          },
          {
            name: 'Action',
            format: 'ACTIONS',
            actions: [
              {
                icon: 'view_detail',
                displayText: 'View Details',
                conditionProp: '',
                conditionValue: [],
              },
              {
                icon: 'delete_active',
                displayText: 'Delete',
                conditionProp: 'status',
                conditionValues: ['expired'],
              },
            ],
            priority: 8,
            sortable: false,
            columnHeaderIcon: 'settings_active',
            columnHeaderIconLabel: 'Edit View',
          },
          {
            name: 'Broker Name',
            prop: 'broker',
            format: 'FULL_NAME',
            isHidden: true,
            sortable: true,
          },
          {
            name: 'Agency Name',
            prop: 'broker.agency.agency_name',
            isHidden: true,
            sortable: true,
            sortByProp: 'broker__agency_agency_name',
          },
          {
            name: 'Applicant Name',
            prop: 'subscriber',
            format: 'FULL_NAME',
            isHidden: true,
            sortable: true,
            sortByProp: 'subscriber_first_name',
          },
          {
            name: 'Date Submitted',
            prop: 'submitted_date',
            format: 'DATE',
            isHidden: true,
            sortable: true,
          },
          {
            name: 'Product Type',
            prop: 'plans',
            format: 'LIST',
            isHidden: true,
            sortByProp: 'plans__display_name',
            formatOptions: { objectMapping: 'display_name' },
          },
          {
            name: 'Source',
            prop: 'application_type',
            format: 'APP_DISPLAY_NAME',
            isHidden: true,
            sortable: true,
          },
        ],
        filters: [
          {
            icon: 'search',
            prop: 'id',
            size: 'small',
            type: 'text',
            label: 'Application ID',
          },
          {
            icon: '',
            prop: 'coverage_effective_date',
            size: 'small',
            type: 'date',
            label: 'Requested Effective Date',
            placeholder: 'mm/dd/yyyy',
          },
          {
            icon: '',
            prop: 'status_similar_to',
            size: 'small',
            type: 'dropdown',
            label: 'Status',
            options: [
              { label: 'All', value: '' },
              { label: 'Approved', value: 'approved' },
              { label: 'Denied', value: 'denied' },
              { label: 'Expired', value: 'expired' },
              { label: 'In Progress', value: 'in_progress' },
              { label: 'Submitted', value: 'submitted' },
            ],
            placeholder: '',
            autocomplete: 'off',
          },
        ],
        sorting: { init: { created_at: 'desc' }, stackedIcons: true },
        endpoint: 'api/shopping/applications/individuals/',
        messages: { noData: 'No data found.' },
        pagination: 25,
        exportConfig: { enabled: true, exportWithFormatting: false },
      },
      showFooter: true,
      buttonClick: { 'Create Application': { route: 'shopping/individual/' } },
      deleteModal: {
        body: 'Are you sure you want to permanently delete this application?',
        cancel: 'Cancel',
        header: 'Delete Application',
        submit: 'Yes, Delete',
      },
      detailPageName: 'application-details',
      routeAllAppsToDetails: true,
    },
    confirmation: {
      meta: {
        label: 'Confirmation',
        enabled: true,
        modules: {
          text: {
            print: 'string',
            reason: 'string',
            coverage: 'string',
            zip_code: 'string',
            submitted: 'string',
            learn_more: 'string',
            subscriber: 'string',
            quick_links: 'string',
            coverage_type: 'string',
            selected_plans: 'string',
            confirmation_num: 'string',
            enrollment_status: 'string',
            coverage_start_date: 'string',
            will_receive_updates: 'string',
            application_submitted: 'string',
          },
          learn_more: 'object-list',
          quick_links: 'object-list',
        },
        description: '',
      },
      text: {
        print: 'Print Your Application',
        reason: 'Reason',
        coverage: 'coverage',
        zip_code: 'ZIP Code',
        submitted: 'Submitted',
        learn_more: 'Learn More About Your New Plan',
        subscriber: 'Subscriber',
        quick_links: 'Quick Links',
        coverage_type: 'Coverage Type',
        selected_plans: 'Selected Plans',
        confirmation_num: 'Confirmation Number',
        enrollment_status: 'Enrollment Status',
        coverage_start_date: 'Coverage Start Date',
        will_receive_updates:
          'You will receive updates to keep you informed. In the meantime, you can always check your status by logging into your account.',
        application_submitted: 'Your Application Was Successfully Submitted',
      },
      learn_more: [
        {
          icon: 'hospital',
          link: 'https://www.google.com/',
          label: 'Getting Care',
          button: 'Get Care',
          description:
            'Learn how to find a doctor, why it’s important to have a primary care physician, when you need urgent or emergency care, how to get care outside of a doctor’s office and more.',
        },
        {
          icon: 'file',
          link: 'https://www.google.com/',
          label: 'Plan Resources',
          button: 'Get Information',
          description:
            'Access important plan documents that explain your benefits and learn how to make the most of your individual and family medical, dental, and/or vision plan(s).',
        },
        {
          icon: 'costs_product',
          link: 'https://www.google.com/',
          label: 'Billing Resources',
          button: 'Learn More',
          description:
            'Whether you want to sign-up for automatic payments, learn how to pay your bill online, or want to learn the basics about healthcare costs and claims, you can find it all here.',
        },
      ],
      quick_links: [
        {
          icon: 'heart_product',
          link: 'https://www.google.com/',
          label: 'Protect Your Whole Self',
          button: 'Get Total Coverage',
          description:
            'Add a dental plan, vision plan, or life insurance plan for full coverage.',
        },
        {
          icon: 'video_product',
          link: 'https://www.google.com/',
          label: 'Helpful Videos',
          button: 'Watch Now',
          description:
            'Find out how to access all the important features of your Blue Shield membership.',
        },
        {
          icon: 'file',
          link: 'https://www.google.com/',
          label: 'Definitions',
          button: 'Read Now',
          description:
            'Get help understanding basic healthcare and billing terms.',
        },
        {
          icon: 'care',
          link: 'https://www.google.com/',
          label: 'Pharmacy',
          button: 'Learn More',
          description:
            'View the drug formulary for your plan, learn about mail service pharmacy.',
        },
        {
          icon: 'calculator',
          link: 'https://www.google.com/',
          label: 'Treatment Cost Estimator',
          button: 'Estimate Now',
          description:
            'With a PPO plan, you can use this tool to estimate and compare your costs.',
        },
        {
          icon: 'wellness_product',
          link: 'https://www.google.com/',
          label: 'Prevention',
          button: 'View Guidelines',
          description:
            'See what’s covered during a preventive care visit and guidelines for every age.',
        },
      ],
    },
    notifications: {
      api: {
        edit: 'api/notifications/v2/user/${id}/',
        list: 'api/notifications/v2/user/?webuser_id=${id}&disposition=inbox&is_deleted=false',
      },
      showFooter: true,
      noNotifications: 'You have no notifications.',
    },
    'reset-password': {
      page: 'reset-password',
      layout: 'banner',
      layoutOptions: {
        title:
          "Our not-for-profit status allows us to focus on our mission — caring more for our members than 'the bottom line.",
        header: {
          icon: 'coverage',
          text: 'Our not-for-profit status allows us to focus on our mission — caring more for our members than the bottom line.',
        },
        heroImg:
          'https://zipari-uploads-dev.s3.amazonaws.com/multitenant/files/f5d8fe90-b44f-4aae-91ca-7bdc66191369.png',
        sections: [
          {
            text: 'We offer access to more than 1 million physicians, provider facilities, hospitals and other care centers in our provider networks <br><br> Search for a doctor, facility or pharmacy by name or provider type. today.',
            type: 'text',
            title: 'Find a Doctor',
          },
          {
            list: [
              { text: 'Expansive provider network' },
              { text: 'Health & Wellness Program' },
              { text: 'Experienced Customer Support Team' },
            ],
            type: 'list',
            title: 'Why Branch Health',
          },
          {
            type: 'links',
            links: [
              { url: 'www.google.com', label: 'Individual & Family Plans >' },
              { url: 'www.google.com', label: 'Employer Plans >' },
              { url: 'www.google.com', label: 'Medicare Supplement Plans >' },
              { url: 'www.google.com', label: 'Dental Plans >' },
            ],
            title: 'Need Health Insurance?',
            description:
              'Check out our complete listing of plans for families and individuals:',
          },
        ],
      },
      authCardOptions: {
        form: {
          controls: [
            {
              grid: { col: '1 / 5', row: '1' },
              prop: 'username',
              type: 'text',
              label: 'User Name',
              validators: ['required'],
            },
            {
              grid: { col: '1 / 5', row: '2' },
              prop: 'password',
              type: 'passwords',
              label: 'Confirm Password',
              validators: [
                'required',
                { name: 'match', dependency: 'password' },
              ],
            },
          ],
        },
        title: 'Reset Password',
        footer: { button: { level: 'high', content: 'Submit' } },
        subtitle: '',
      },
      routeAfterSuccessConfig: { route: 'shopping/login' },
    },
    'forgot-password': {
      meta: {
        label: 'Forgot Password',
        enabled: true,
        modules: {
          page: 'string',
          layout: 'string',
          layoutOptions: {
            title: 'string',
            header: { icon: 'product-icon', text: 'string' },
            heroImg: 'image',
            sections: 'object-list',
          },
          authCardOptions: {
            form: 'form',
            title: 'string',
            footer: { button: 'button' },
            subtitle: 'string',
            successTitle: 'string',
            successSubtitle: 'string',
          },
          routeAfterSuccessConfig: { disableAfterSuccess: 'boolean' },
        },
        description: '',
      },
      page: 'forgot-password',
      layout: 'banner',
      layoutOptions: {
        title:
          "Our not-for-profit status allows us to focus on our mission — caring more for our members than 'the bottom line.",
        header: {
          icon: 'https://zipari-uploads-dev.s3.amazonaws.com/multitenant/files/d40fa16f-4759-4c7f-a2af-61ef3765b7b9.png',
          text: 'Our not-for-profit status allows us to focus on our mission — caring more for our members than the bottom line.',
        },
        heroImg:
          'https://zipari-uploads-dev.s3.amazonaws.com/multitenant/files/f5d8fe90-b44f-4aae-91ca-7bdc66191369.png',
        sections: [
          {
            text: 'We offer access to more than 1 million physicians, provider facilities, hospitals and other care centers in our provider networks <br><br> Search for a doctor, facility or pharmacy by name or provider type. today.',
            type: 'text',
            title: 'Find a Doctor',
          },
          {
            list: [
              { text: 'Expansive provider network' },
              { text: 'Health & Wellness Program' },
              { text: 'Experienced Customer Support Team' },
            ],
            type: 'list',
            title: 'Why Branch Health',
          },
          {
            type: 'links',
            links: [
              { url: 'www.google.com', label: 'Individual & Family Plans >' },
              { url: 'www.google.com', label: 'Employer Plans >' },
              { url: 'www.google.com', label: 'Medicare Supplement Plans >' },
              { url: 'www.google.com', label: 'Dental Plans >' },
            ],
            title: 'Need Health Insurance?',
            description:
              'Check out our complete listing of plans for families and individuals:',
          },
        ],
      },
      authCardOptions: {
        form: {
          controls: [
            {
              prop: 'username',
              type: 'text',
              label: 'Username',
              validators: ['required'],
            },
          ],
        },
        title: 'Forgot Password',
        footer: { button: { icon: '', level: 'high', content: 'Submit' } },
        subtitle: '',
        successTitle: 'Email Sent!',
        successSubtitle: 'Check your email to reset your password',
      },
      routeAfterSuccessConfig: { disableAfterSuccess: true },
    },
    'forgot-username': {
      header: { label: 'Forgot Username' },
      controls: [
        {
          key: 'email',
          type: 'email',
          label: 'Enter Email Address',
          validators: ['email', 'required'],
        },
      ],
    },
    'session-expired': {
      body: 'Your session expired after ${timeout} minutes of inactivity.<br />Please login again to continue.',
      image:
        'https://zipari-uploads-dev.s3.amazonaws.com/files/77bacafc-d4c5-4a5d-9cdd-7e7fdbbb0746.svg',
      title: 'You have been logged out',
      loginButton: { content: 'Go To Login' },
      loginButtonUrl: '',
    },
    LANGUAGE_ENABLED: true,
    SESSION_LENGTH_ANONYMOUS: 9999,
    SESSION_LENGTH_AUTHENTICATED: 9999,
    icon_library: {
      name: 'svg',
      type: 'element',
      value: '',
      parent: null,
      children: [
        {
          name: 'defs',
          type: 'element',
          value: '',
          parent: null,
          children: [
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M83.1389 52.9718C82.0453 51.4281 80.6764 50.0994 79.1008 49.0524L66.3629 40.5605C66.8082 40.0854 67.2239 39.5806 67.6099 39.0759C70.5088 35.2724 72.1208 30.6443 72.2122 25.8629V22.8937C72.2134 13.6499 64.7976 6.11516 55.5549 5.96921C53.0808 5.97599 50.6418 6.55525 48.4288 7.66166C45.0033 4.69719 40.6366 3.04519 36.1066 3C25.2129 3.16282 16.5096 12.1185 16.6583 23.0125V25.9817C16.87 31.7512 18.6455 37.3548 21.795 42.1936L7.63192 50.5073C2.86307 53.3868 -0.036449 58.5654 0.000346073 64.136V76.0128C0.0325554 78.3003 1.87072 80.1516 4.15795 80.1994H55.8816C60.6998 85.2865 67.8997 87.3575 74.6845 85.6077C81.4692 83.858 86.7696 78.5634 88.5267 71.7805C90.2838 64.9977 88.2208 57.7956 83.1389 52.9718ZM69.7775 83.1687C66.4273 83.1728 63.1588 82.1351 60.4244 80.1994C59.2522 79.3489 58.1944 78.351 57.2771 77.2302C54.0936 73.4517 52.7956 68.4333 53.748 63.5851C54.7003 58.737 57.8001 54.5824 62.1763 52.2889C63.1811 51.7916 64.2362 51.4034 65.3236 51.1309C66.7729 50.7212 68.2714 50.5114 69.7775 50.5073C78.7898 50.5237 86.0918 57.8256 86.1081 66.838C86.1081 67.1943 86.1081 67.5209 86.1081 67.8475C85.5741 76.4702 78.4166 83.1852 69.7775 83.1687ZM55.5549 8.73057C63.3328 8.84457 69.5499 15.2344 69.4508 23.0125V25.9817C69.3448 30.45 67.7099 34.7468 64.8189 38.1554C64.7369 38.2963 64.6371 38.426 64.522 38.5414C64.1193 38.9987 63.6931 39.4348 63.2452 39.8479C62.5316 40.5181 61.7447 41.1057 60.8995 41.5997C60.2301 42.0098 60.0068 42.877 60.3948 43.5594C60.6418 43.9996 61.1073 44.2721 61.6121 44.272C61.856 44.2764 62.095 44.2036 62.295 44.0641C62.9849 43.6528 63.6403 43.186 64.2547 42.6686L71.945 47.5381C71.2324 47.5381 70.5198 47.5381 69.7775 47.5381C67.1756 47.5396 64.6006 48.0646 62.206 49.0821L50.3291 42.0748C53.5101 37.2453 55.3166 31.641 55.5549 25.8629V22.8937C55.5018 18.023 53.6998 13.3337 50.4776 9.68072C52.0917 9.03528 53.8167 8.71248 55.5549 8.73057ZM19.4494 25.8629V22.8937C19.4482 13.6499 26.864 6.11516 36.1066 5.96921C45.4425 6.1157 52.8961 13.7951 52.7639 23.1312V26.1004C52.7639 36.1957 44.9252 48.993 36.1066 48.993C27.2881 48.993 19.4494 35.9582 19.4494 25.8629ZM4.15795 77.2302C3.39411 77.1983 2.79145 76.5695 2.79211 75.805V63.9282C2.81666 59.4765 5.12674 55.3498 8.90868 53.0015L23.339 44.3908C26.2126 48.6225 30.8827 51.2864 35.9879 51.6059C41.0931 51.2864 45.7631 48.6225 48.6367 44.3908L59.3852 50.6558C53.8557 54.1826 50.4996 60.2795 50.4776 66.838C50.4324 67.5301 50.4324 68.2243 50.4776 68.9164C50.2934 68.8226 50.0904 68.7719 49.8838 68.768C49.5084 68.7679 49.1489 68.919 48.8863 69.1871C48.6237 69.4553 48.4802 69.8179 48.4882 70.1932V73.1624C48.4882 73.9331 49.113 74.5579 49.8838 74.5579C50.6545 74.5579 51.2793 73.9331 51.2793 73.1624V72.8061C51.8549 74.3755 52.6335 75.8629 53.5953 77.2302H4.15795ZM29.1587 68.768C28.7834 68.7679 28.4238 68.919 28.1612 69.1871C27.8987 69.4553 27.7552 69.8179 27.7632 70.1932V73.1624C27.7632 73.9331 28.388 74.5579 29.1587 74.5579C29.9294 74.5579 30.5542 73.9331 30.5542 73.1624V70.1932C30.5622 69.8179 30.4187 69.4553 30.1561 69.1871C29.8935 68.919 29.534 68.7679 29.1587 68.768ZM40.2635 60.187H31.9497C31.1298 60.187 30.4651 60.8516 30.4651 61.6716C30.4651 62.4915 31.1298 63.1562 31.9497 63.1562H40.2635C41.0834 63.1562 41.7481 62.4915 41.7481 61.6716C41.7481 60.8516 41.0834 60.187 40.2635 60.187ZM43.0546 68.768C42.6793 68.7679 42.3197 68.919 42.0571 69.1871C41.7946 69.4553 41.6511 69.8179 41.659 70.1932V73.1624C41.659 73.9331 42.2838 74.5579 43.0546 74.5579C43.8253 74.5579 44.4501 73.9331 44.4501 73.1624V70.1932C44.4581 69.8179 44.3146 69.4553 44.052 69.1871C43.7894 68.919 43.4299 68.7679 43.0546 68.768ZM36.1066 68.768C35.7313 68.7679 35.3718 68.919 35.1092 69.1871C34.8466 69.4553 34.7031 69.8179 34.7111 70.1932V73.1624C34.7111 73.9331 35.3359 74.5579 36.1066 74.5579C36.8774 74.5579 37.5022 73.9331 37.5022 73.1624V70.1932C37.5101 69.8179 37.3666 69.4553 37.1041 69.1871C36.8415 68.919 36.4819 68.7679 36.1066 68.768ZM8.34453 68.768C7.96921 68.7679 7.60968 68.919 7.3471 69.1871C7.08451 69.4553 6.94102 69.8179 6.94901 70.1932V73.1624C6.94102 73.5376 7.08451 73.9003 7.3471 74.1684C7.60968 74.4366 7.96921 74.5877 8.34453 74.5876C8.7173 74.588 9.07402 74.4359 9.33194 74.1668C9.58986 73.8977 9.72658 73.5348 9.71037 73.1624V70.1932C9.72658 69.8208 9.58986 69.4579 9.33194 69.1888C9.07402 68.9196 8.7173 68.7676 8.34453 68.768ZM15.2925 68.768C14.9172 68.7679 14.5576 68.919 14.295 69.1871C14.0325 69.4553 13.889 69.8179 13.897 70.1932V73.1624C13.8173 73.704 14.0617 74.2421 14.5219 74.5386C14.9821 74.8351 15.5732 74.8351 16.0334 74.5386C16.4936 74.2421 16.738 73.704 16.6583 73.1624V70.1932C16.6663 69.823 16.5268 69.4649 16.2707 69.1976C16.0145 68.9303 15.6626 68.7757 15.2925 68.768ZM22.2107 68.768C21.838 68.7676 21.4812 68.9196 21.2233 69.1888C20.9654 69.4579 20.8287 69.8208 20.8449 70.1932V73.1624C20.8287 73.5348 20.9654 73.8977 21.2233 74.1668C21.4812 74.4359 21.838 74.588 22.2107 74.5876C22.6331 74.6355 23.0543 74.4883 23.3549 74.1878C23.6555 73.8872 23.8027 73.466 23.7547 73.0436V70.0744C23.7326 69.6928 23.5548 69.3369 23.263 69.09C22.9711 68.8431 22.5908 68.7266 22.2107 68.768ZM78.6851 65.3534H71.2621V57.9304C71.2531 57.2896 70.8341 56.727 70.2228 56.5348C70.0757 56.5067 69.9246 56.5067 69.7775 56.5348C68.9575 56.5348 68.2928 57.1995 68.2928 58.0194V65.3534H60.8698C60.0499 65.3534 59.3852 66.0181 59.3852 66.838C59.3852 67.6579 60.0499 68.3226 60.8698 68.3226H68.2928V75.7456C68.2983 76.2412 68.5556 76.7 68.9758 76.963C69.2122 77.1263 69.4903 77.219 69.7775 77.2302C70.5974 77.2302 71.2621 76.5655 71.2621 75.7456V68.3226H78.6851C79.505 68.3226 80.1697 67.6579 80.1697 66.838C80.1687 66.4367 80.0085 66.0523 79.7243 65.7691C79.4405 65.5078 79.0707 65.3599 78.6851 65.3534Z',
                  },
                },
              ],
              attributes: {
                id: 'icon-birth_adoption',
                viewBox: '0 0 90 90',
                'data-set': 'product',
                'data-title': 'Add Multiple People',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M24.432 10.0017C18.6867 10.0017 12.9413 12.1884 8.57133 16.5651C4.33011 20.8063 2 26.4309 2 32.4337C2 38.4229 4.33011 44.0587 8.57133 48.2864L35.2933 75.0189C35.3218 75.0542 35.3335 75.0976 35.3674 75.1301L37.2835 77.0488C37.316 77.0813 37.3594 77.0918 37.3947 77.1203L39.8586 79.5868C40.6309 80.3592 41.6487 80.7804 42.7327 80.7804C43.8167 80.7804 44.8451 80.3456 45.6174 79.5868L63.6006 61.5799H83.4231C84.9136 61.5799 86.2701 60.7661 86.9747 59.4653C87.6779 58.1645 87.6236 56.5804 86.8106 55.3473L79.845 44.6289C82.1891 41.038 83.4495 36.8239 83.4495 32.4337C83.4495 29.4255 82.8669 26.526 81.7557 23.843C80.6446 21.1601 79.0056 18.6925 76.8782 16.5651C68.1383 7.81164 53.8968 7.81164 45.1569 16.5651L42.7168 18.9919L40.2926 16.5651C35.9227 12.1884 30.1773 10.0017 24.432 10.0017ZM61.0149 12.7144C66.0658 12.7144 71.1165 14.637 74.9648 18.4785C78.6911 22.2048 80.7368 27.1626 80.7368 32.4337C80.7368 35.8754 79.8569 39.1825 78.2173 42.1094L66.4826 24.0336C65.7387 22.8805 64.4799 22.189 63.0977 22.189C61.7292 22.189 60.469 22.8792 59.7102 24.0309L49.4655 39.8042L47.7188 42.5143L39.3848 55.3473C38.5854 56.5804 38.5161 58.1645 39.2208 59.4653C39.9389 60.7661 41.2954 61.5799 42.7724 61.5799H50.5638L51.6594 62.6782C51.9169 62.9356 52.2708 63.0699 52.6095 63.0699C52.9618 63.0699 53.2992 62.9356 53.5702 62.6782C53.8683 62.3801 54.0055 61.9728 53.9513 61.5799H59.7631L43.6934 77.6628C43.1785 78.1777 42.2975 78.1777 41.7826 77.6628L10.4821 46.3756C6.75581 42.6493 4.71004 37.6911 4.71004 32.4337C4.71004 27.1626 6.75581 22.2022 10.4821 18.4759C14.3304 14.6412 19.3833 12.717 24.424 12.717C29.4783 12.717 34.5335 14.6412 38.3818 18.4759L40.806 20.9107L37.7758 23.941C37.2459 24.4708 37.2459 25.3272 37.7758 25.857C38.04 26.1213 38.3869 26.254 38.7338 26.254C39.0807 26.254 39.4276 26.1213 39.6918 25.857L45.1966 20.3523C45.202 20.3468 45.2031 20.3418 45.2072 20.3364L47.0651 18.4785C50.9133 14.637 55.9641 12.7144 61.0149 12.7144ZM63.0977 24.899C63.5584 24.899 63.965 25.1147 64.2225 25.5077L76.5791 44.5468L78.1247 46.9313L84.5478 56.8241C84.9272 57.4203 84.7092 57.9623 84.6008 58.1791C84.4788 58.3823 84.1412 58.8698 83.4231 58.8698H66.308H62.4731H51.6885H49.7089H42.7724C42.0678 58.8698 41.7272 58.3823 41.6053 58.1791C41.4969 57.9623 41.2679 57.4203 41.6609 56.8241L50.9422 42.5143L52.7048 39.8042L61.9862 25.5077C62.2436 25.1147 62.6506 24.899 63.0977 24.899ZM63.0686 33.0688C62.3567 33.0688 61.6471 33.3329 61.1552 33.8654C60.6633 34.398 60.4127 35.1163 60.475 35.89L61.7242 46.7355C61.8014 47.4184 62.3829 47.9344 63.0713 47.9344C63.7596 47.9344 64.3385 47.4184 64.4157 46.7355L65.6728 35.8397C65.7297 35.1175 65.4766 34.398 64.9847 33.8654C64.4922 33.3329 63.7805 33.0688 63.0686 33.0688ZM63.1242 49.2894C61.6275 49.2894 60.4142 50.5027 60.4142 51.9994C60.4142 53.4962 61.6275 54.7095 63.1242 54.7095C64.6209 54.7095 65.8342 53.4962 65.8342 51.9994C65.8342 50.5027 64.6209 49.2894 63.1242 49.2894ZM45.9059 63.2366C45.5593 63.2366 45.2127 63.3687 44.9478 63.6336C44.418 64.1634 44.418 65.0198 44.9478 65.5497L46.8639 67.4657C47.1282 67.73 47.4751 67.8627 47.822 67.8627C48.1689 67.8627 48.5158 67.73 48.78 67.4657C49.3098 66.9359 49.3098 66.0795 48.78 65.5497L46.8639 63.6336C46.599 63.3687 46.2524 63.2366 45.9059 63.2366ZM41.1157 68.0268C40.7691 68.0268 40.4225 68.1589 40.1576 68.4238C39.6278 68.9536 39.6278 69.8101 40.1576 70.3399L42.0737 72.256C42.3379 72.5202 42.6849 72.6529 43.0318 72.6529C43.3786 72.6529 43.7256 72.5202 43.9898 72.256C44.5196 71.7261 44.5196 70.8697 43.9898 70.3399L42.0737 68.4238C41.8088 68.1589 41.4622 68.0268 41.1157 68.0268Z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-lost_coverage',
                viewBox: '2 2 85 85',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Lost Coverage',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M4.36111 15.5833H12V13.9167H4.36111V15.5833ZM4.36111 10.8333H15.6389V9.16667H4.36111V10.8333ZM4.36111 6.08333H15.6389V4.41667H4.36111V6.08333ZM1.66667 20C1.22222 20 0.833333 19.8333 0.5 19.5C0.166667 19.1667 0 18.7778 0 18.3333V1.66667C0 1.22222 0.166667 0.833333 0.5 0.5C0.833333 0.166667 1.22222 0 1.66667 0H18.3333C18.7778 0 19.1667 0.166667 19.5 0.5C19.8333 0.833333 20 1.22222 20 1.66667V18.3333C20 18.7778 19.8333 19.1667 19.5 19.5C19.1667 19.8333 18.7778 20 18.3333 20H1.66667ZM1.66667 18.3333H18.3333V1.66667H1.66667V18.3333Z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-view_detail',
                viewBox: '-2 -2 25 25',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'View Detail',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M4 15V13H20V15H4ZM4 11V9H20V11H4Z',
                    fill: 'var(--icon-color)',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-drag',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Drag',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'style',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '\n\t.st0{fill:#5D6B87;}\n',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { type: 'text/css', tabindex: '-1' },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20.5,0.5c2.9,0,5.7,1.2,7.8,3.3c2.1,2.1,3.2,4.9,3.2,7.9c0,3.2-1.3,6-3.4,8.1l0,3.7  c0.2,0.1,0.5,0.2,0.8,0.3c1.2,0.6,2.4,1.2,3.5,1.8c1.3,0.7,2.4,1.4,3.2,2.1c0.4,0.3,0.8,0.6,1.1,0.9c0.7,0.7,1.4,1.6,2,2.5  c0.6,1,1,2,1.4,3.1c0.2,0.6,0.4,1.1,0.4,1.4c0.1,0.6-0.1,1.2-0.6,1.5c-11.9,7.2-26.7,7.2-38.7,0c-0.5-0.3-0.8-0.9-0.6-1.5  c0.1-0.3,0.2-0.8,0.4-1.5c0.4-1.1,0.9-2.2,1.5-3.2c0.5-0.9,1.1-1.7,1.8-2.3c0.1-0.1,0.2-0.2,0.4-0.4c1-0.9,2.3-1.7,3.9-2.6  c1.1-0.6,2.3-1.2,3.5-1.8c0.3-0.1,0.5-0.2,0.8-0.3l0-3.7c-2.1-2-3.4-4.9-3.4-8.1C9.5,5.5,14.4,0.5,20.5,0.5z M14.1,26L13.9,26  c-0.2,0.1-0.4,0.2-0.6,0.3C12.2,26.8,11,27.4,10,28c-1.4,0.8-2.6,1.6-3.4,2.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.5,0.5-1,1.1-1.4,1.8  c-0.5,0.8-0.9,1.8-1.3,2.7c0,0.1,0,0.1-0.1,0.2c10.6,5.9,23.4,6,34,0c0-0.1,0-0.1-0.1-0.2c-0.3-0.9-0.7-1.8-1.2-2.6  c-0.4-0.8-0.9-1.4-1.5-2c-0.2-0.2-0.5-0.4-0.8-0.7c-0.8-0.6-1.7-1.2-2.9-1.8c-1.1-0.6-2.2-1.2-3.3-1.7c-0.3-0.1-0.5-0.2-0.7-0.3  c-1.5,2.1-3.9,3.4-6.5,3.4C17.9,29.4,15.5,28.1,14.1,26z M15.7,21.7l0,1.6l0.1,0c0.8,2,2.7,3.3,4.8,3.3c2.1,0,4-1.3,4.8-3.2l0.1,0  l0-1.7c-1.5,0.7-3.1,1.1-4.8,1.1C18.8,22.8,17.1,22.4,15.7,21.7z M20.5,3.3c-4.5,0-8.2,3.7-8.2,8.3S16,20,20.5,20s8.2-3.7,8.2-8.3  c0-2.2-0.9-4.3-2.4-5.9C24.8,4.2,22.7,3.3,20.5,3.3z',
                    id: 'Path',
                    class: 'st0',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-add_yourself',
                viewBox: '-3 -3 50 50',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Add yourself',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'style',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '\n\t.st0{fill:#5D6B87;}\n',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { type: 'text/css', tabindex: '-1' },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M15.9,0.4c2.6,0,5.1,1,6.9,2.9c1.8,1.8,2.9,4.3,2.8,6.9c0,3.2-1.5,6-3.8,7.8l0,2.4  c0.2,0.1,0.4,0.2,0.6,0.3c0.9,0.4,1.8,0.9,2.7,1.3c1,0.5,1.8,1,2.5,1.5c0.3,0.2,0.6,0.5,0.8,0.7c0.6,0.5,1.1,1.2,1.5,1.9  c0.4,0.7,0.8,1.5,1.1,2.3c0.2,0.5,0.3,0.8,0.3,1.1c0.1,0.4-0.1,0.9-0.5,1.1c-9.2,5.3-20.7,5.3-30,0c-0.4-0.2-0.6-0.7-0.5-1.1  c0.1-0.2,0.2-0.6,0.3-1.1c0.3-0.8,0.7-1.6,1.2-2.4c0.4-0.6,0.9-1.2,1.4-1.7c0.1-0.1,0.2-0.2,0.3-0.3c0.7-0.6,1.8-1.3,3-1.9  c0.9-0.5,1.8-0.9,2.7-1.3c0.2-0.1,0.4-0.2,0.6-0.3l0-2.4c-2.3-1.8-3.8-4.6-3.8-7.8C6.2,4.8,10.5,0.4,15.9,0.4z M12.1,19.2l0,1.8  c0,0.4-0.3,0.8-0.7,1c-0.1,0-0.2,0.1-0.3,0.1c-0.3,0.1-0.5,0.2-0.9,0.4c-0.9,0.4-1.8,0.8-2.6,1.2c-1.1,0.6-2,1.2-2.6,1.7  c-0.1,0.1-0.1,0.1-0.2,0.2c-0.4,0.4-0.8,0.8-1.1,1.3c-0.4,0.6-0.7,1.3-1,2c0,0.1,0,0.1-0.1,0.1c8.2,4.4,18.1,4.4,26.3,0  c0,0,0-0.1,0-0.1c-0.2-0.7-0.5-1.3-0.9-1.9c-0.3-0.6-0.7-1.1-1.2-1.4c-0.2-0.2-0.4-0.3-0.6-0.5c-0.6-0.4-1.4-0.9-2.3-1.4  c-0.8-0.4-1.7-0.9-2.6-1.2c-0.3-0.1-0.6-0.3-0.9-0.4c-0.2-0.1-0.3-0.1-0.3-0.1c-0.4-0.2-0.7-0.5-0.7-1l0-1.8  c-1.2,0.5-2.4,0.7-3.7,0.7C14.6,19.9,13.3,19.7,12.1,19.2z M15.9,2.8c-4,0-7.3,3.3-7.3,7.3s3.3,7.3,7.3,7.3s7.3-3.3,7.3-7.3  c0-1.9-0.8-3.8-2.1-5.2S17.8,2.8,15.9,2.8z',
                    id: 'Combined-Shape',
                    class: 'st0',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-add_child_only',
                viewBox: '-4 -2 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Add Child Only',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'style',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '\n\t.st0{fill:#5D6B87;}\n',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { type: 'text/css', tabindex: '-1' },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20.5,0.5c2.9,0,5.7,1.2,7.8,3.3c2.1,2.1,3.2,4.9,3.2,7.9c0,3.2-1.3,6-3.4,8.1l0,3.7  c0.2,0.1,0.5,0.2,0.8,0.3c1.2,0.6,2.4,1.2,3.5,1.8c1.3,0.7,2.4,1.4,3.2,2.1c0.4,0.3,0.8,0.6,1.1,0.9c0.7,0.7,1.4,1.6,2,2.5  c0.6,1,1,2,1.4,3.1c0.2,0.6,0.4,1.1,0.4,1.4c0.1,0.6-0.1,1.2-0.6,1.5c-11.9,7.2-26.7,7.2-38.7,0c-0.5-0.3-0.8-0.9-0.6-1.5  c0.1-0.3,0.2-0.8,0.4-1.5c0.4-1.1,0.9-2.2,1.5-3.2c0.5-0.9,1.1-1.7,1.8-2.3c0.1-0.1,0.2-0.2,0.4-0.4c1-0.9,2.3-1.7,3.9-2.6  c1.1-0.6,2.3-1.2,3.5-1.8c0.3-0.1,0.5-0.2,0.8-0.3l0-3.7c-2.1-2-3.4-4.9-3.4-8.1C9.5,5.5,14.4,0.5,20.5,0.5z M14.1,26L13.9,26  c-0.2,0.1-0.4,0.2-0.6,0.3C12.2,26.8,11,27.4,10,28c-1.4,0.8-2.6,1.6-3.4,2.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.5,0.5-1,1.1-1.4,1.8  c-0.5,0.8-0.9,1.8-1.3,2.7c0,0.1,0,0.1-0.1,0.2c10.6,5.9,23.4,6,34,0c0-0.1,0-0.1-0.1-0.2c-0.3-0.9-0.7-1.8-1.2-2.6  c-0.4-0.8-0.9-1.4-1.5-2c-0.2-0.2-0.5-0.4-0.8-0.7c-0.8-0.6-1.7-1.2-2.9-1.8c-1.1-0.6-2.2-1.2-3.3-1.7c-0.3-0.1-0.5-0.2-0.7-0.3  c-1.5,2.1-3.9,3.4-6.5,3.4C17.9,29.4,15.5,28.1,14.1,26z M15.7,21.7l0,1.6l0.1,0c0.8,2,2.7,3.3,4.8,3.3c2.1,0,4-1.3,4.8-3.2l0.1,0  l0-1.7c-1.5,0.7-3.1,1.1-4.8,1.1C18.8,22.8,17.1,22.4,15.7,21.7z M20.5,3.3c-4.5,0-8.2,3.7-8.2,8.3S16,20,20.5,20s8.2-3.7,8.2-8.3  c0-2.2-0.9-4.3-2.4-5.9C24.8,4.2,22.7,3.3,20.5,3.3z',
                    id: 'Path',
                    class: 'st0',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-add_yourself',
                viewBox: '-3 -3 50 50',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Add yourself',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M10.4651598,20.0411478 L12.7232594,19.3789197 C12.7453617,19.4544967 12.8079234,19.6257562 12.9158999,19.8592458 C13.1014184,20.2604131 13.3421134,20.6626129 13.6399554,21.0337806 C14.4634917,22.0600631 15.548342,22.6553353 17.0059743,22.6553353 C18.4639129,22.6553353 19.5501865,22.0597483 20.375574,21.0329842 C20.6740746,20.661656 20.9154352,20.2593031 21.1015939,19.8579893 C21.2099435,19.6244134 21.2727771,19.4530789 21.2950075,19.377433 L23.5522353,20.0426346 C23.4987304,20.2247026 23.3961687,20.5043673 23.2355386,20.8506477 C22.9733976,21.415761 22.6350248,21.9798351 22.2084335,22.5105055 C20.9621298,24.0608802 19.2281828,25.0115766 17.0059743,25.0115766 C14.7834596,25.0115766 13.0502952,24.0605655 11.8058168,22.5097091 C11.3798536,21.9788782 11.0421939,21.414651 10.7807914,20.8493912 C10.6206153,20.5030246 10.5184252,20.2232848 10.4651598,20.0411478 Z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M24.0059743,10.1436944 C24.0073118,8.28354142 23.2703326,6.50000447 21.9574468,5.18527732 C20.644561,3.87055018 18.863522,3.13253732 17.0059743,3.13387488 C13.1399811,3.13387488 10.0059743,6.27227897 10.0059743,10.1436944 C10.0059743,14.0151098 13.1399811,17.153512 17.0059743,17.153512 C20.8719676,17.153512 24.0059743,14.0151098 24.0059743,10.1436944 Z M17.0059743,19.5097533 C11.8404876,19.5097533 7.65303315,15.3164259 7.65303315,10.1436944 C7.65303315,4.97096287 11.8404876,0.777633342 17.005127,0.777633342 C19.4864533,0.775846211 21.8666644,1.76213926 23.6212275,3.51916317 C25.3756907,5.27608708 26.3605901,7.65946516 26.3589176,10.1441186 C26.3586865,15.3166552 22.1713199,19.5097533 17.0059743,19.5097533 Z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M10.5412684,16.293484 L12.8942096,16.293484 L12.8942096,20.7939048 C12.8942096,21.2759634 12.6009425,21.7093886 12.1538562,21.8880876 C12.0935503,21.9121917 11.9749735,21.9607684 11.8065449,22.0316863 C11.5228212,22.1511499 11.2059175,22.2887495 10.8643014,22.442318 C9.88937609,22.8805813 8.91509144,23.357402 8.0106923,23.8541088 C6.63138609,24.6116404 5.54855962,25.3443295 4.90257054,25.9860081 C4.4574899,26.431713 4.04691384,26.9769741 3.67422859,27.6007193 C3.25710395,28.2988406 2.90987515,29.0552052 2.63219144,29.8122575 C2.61483572,29.8595746 2.59799038,29.9062566 2.58165298,29.9522631 C11.5555744,34.9400651 22.4720819,34.9384738 31.4447638,29.9474892 C31.4300916,29.9050265 31.4149782,29.8619794 31.399421,29.8183809 C31.1344152,29.075712 30.7991834,28.3337404 30.3923631,27.6491882 C30.0106946,27.0069587 29.5854988,26.4502375 29.1201524,26.0023607 C28.9335113,25.8227262 28.7021748,25.6290358 28.4301058,25.4245946 C27.7873356,24.9415968 26.9441068,24.4178796 25.9527264,23.8743293 C25.0534944,23.3813017 24.0853628,22.9002753 23.1166517,22.4521658 C22.7772294,22.2951547 22.4623069,22.1536286 22.1802513,22.0300601 C22.0125341,21.9565833 21.8941905,21.905896 21.8335447,21.8804407 C21.3963578,21.6969373 21.1118567,21.2686072 21.1118567,20.7939048 L21.1118567,16.4937645 L23.4647979,16.4937645 L23.4647979,20.0225451 C23.6663276,20.1126757 23.8798664,20.2097286 24.1033699,20.3131176 C25.1171842,20.7820911 26.1315779,21.2861033 27.0827028,21.8075825 C28.1642696,22.40058 29.0970228,22.9798994 29.8423272,23.5399447 C30.1864548,23.7985331 30.4898066,24.0525194 30.7506197,24.3035414 C31.3795237,24.9088357 31.9310392,25.630951 32.4143334,26.444185 C32.905797,27.2711655 33.3022747,28.1486933 33.6151533,29.0255239 C33.8039416,29.5545959 33.924857,29.9730114 33.9856589,30.2283742 C34.1049269,30.7292892 33.885498,31.2497314 33.4438318,31.5134815 C23.3190181,37.5597232 10.6988129,37.5597232 0.573999179,31.5134815 C0.12762567,31.2469203 -0.0911998385,30.7186409 0.0357028815,30.2139489 C0.100338954,29.9568913 0.227444863,29.5344464 0.423530568,28.9998557 C0.748618385,28.113565 1.15580882,27.2265866 1.65511562,26.390921 C2.12148686,25.6103781 2.64688437,24.9126296 3.24215555,24.3165372 C4.08080394,23.4834672 5.32350008,22.6426031 6.87923309,21.7881758 C7.84417361,21.2582189 8.87275286,20.7548261 9.90069146,20.2927315 C10.1247368,20.1920152 10.3389266,20.0977201 10.5412684,20.0103328 L10.5412684,16.293484 Z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M21.7412191,16.4301247 L23.8472002,15.3792837 C24.3657461,16.421414 25.4276112,17.0808586 26.5883273,17.0828248 C27.62291,17.0828248 28.3856333,16.662758 28.9740785,15.9276955 C29.1898866,15.6581167 29.3652016,15.3647032 29.5003371,15.0722932 C29.5781198,14.9039849 29.6222035,14.7833595 29.6359007,14.7366031 L31.893695,15.399874 C31.7371941,15.9341032 31.3992765,16.6652988 30.8099289,17.4014884 C29.8009477,18.6618677 28.3897739,19.4390644 26.5863389,19.4390644 C24.5326731,19.4355885 22.6571183,18.2708224 21.7412191,16.4301247 Z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M22.5433734,4.2023131 L20.7391635,2.68984423 C23.2110552,-0.26712918 27.5175514,-0.868918474 30.7033738,1.2974466 C33.8891962,3.46381167 34.9189564,7.69426503 33.0859945,11.0857119 C31.2530326,14.4771587 27.1530591,15.9273829 23.5996286,14.4411864 L24.5064377,12.2669597 C26.9450665,13.2868984 29.7587738,12.2916466 31.0166888,9.96418305 C32.2746038,7.63671953 31.5679057,4.73346722 29.3815569,3.24674609 C27.1952082,1.76002497 24.2397697,2.17301762 22.5433734,4.2023131 Z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M32.0955597,15.1502509 C32.8815579,15.515627 33.6681359,15.908465 34.4066453,16.315592 C35.2555236,16.7835635 35.9881524,17.2416458 36.5758709,17.687313 C36.8411752,17.8884933 37.0766697,18.0870215 37.2813152,18.2845824 L37.3276529,18.3319054 C38.5399036,19.6416809 39.4072252,21.2332428 39.8512728,22.9628257 C39.9817863,23.4711811 39.7607251,24.0046834 39.3091498,24.2711683 C36.6466433,25.8423746 33.7261615,26.9265573 30.6842959,27.4730092 L30.2688292,25.1537905 C32.7307374,24.7115243 35.1052392,23.8820479 37.3048253,22.6978478 C36.9273147,21.6875674 36.3578723,20.7569912 35.6252636,19.9589047 C35.49682,19.8370854 35.3393622,19.7052341 35.1554315,19.5657595 C34.6714653,19.1987677 34.0294294,18.7973293 33.2719117,18.3797233 C32.5855563,18.0013479 31.8454936,17.6317409 31.1048511,17.2874486 C30.8452539,17.1667733 30.6044569,17.058039 30.3889281,16.9631712 C30.2611371,16.9069223 30.1713219,16.8682761 30.1259073,16.8491274 C29.6896556,16.6651848 29.4059743,16.2373388 29.4059743,15.7633297 L29.4059743,12.3997954 L31.7589155,12.3997954 L31.7589155,14.9954862 C31.8673764,15.0447819 31.9797473,15.0964148 32.0955597,15.1502509 Z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-add_partner',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Add Partner',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'style',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '\n\t.st0{fill:#5D6B87;}\n',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { type: 'text/css', tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'path',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [],
                      attributes: {
                        d: 'M19.1,23.7l2.6-0.8c0,0.1,0.1,0.3,0.2,0.6c0.2,0.5,0.5,0.9,0.8,1.4c0.9,1.2,2.2,1.9,3.9,1.9   c1.7,0,2.9-0.7,3.9-1.9c0.3-0.4,0.6-0.9,0.8-1.4c0.1-0.3,0.2-0.5,0.2-0.6l2.6,0.8c-0.1,0.2-0.2,0.5-0.4,0.9   c-0.3,0.7-0.7,1.3-1.2,1.9c-1.4,1.8-3.4,2.9-6,2.9c-2.6,0-4.5-1.1-6-2.9c-0.5-0.6-0.9-1.3-1.2-1.9C19.3,24.3,19.2,23.9,19.1,23.7z',
                        id: 'Path',
                        class: 'st0',
                        tabindex: '-1',
                      },
                    },
                    {
                      name: 'path',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [],
                      attributes: {
                        d: 'M34.6,12.2c0-4.5-3.6-8.2-8-8.2s-8,3.7-8,8.2   s3.6,8.2,8,8.2S34.6,16.7,34.6,12.2z M37.3,12.2c0,6-4.8,10.9-10.7,10.9s-10.7-4.9-10.7-10.9S20.7,1.3,26.6,1.3S37.3,6.2,37.3,12.2   z',
                        id: 'Path_00000135660571674646216040000017625172778550429868_',
                        class: 'st0',
                        tabindex: '-1',
                      },
                    },
                    {
                      name: 'path',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [],
                      attributes: {
                        d: 'M19.2,19.4h2.7v5.2c0,0.6-0.3,1.1-0.8,1.3   c-0.1,0-0.2,0.1-0.4,0.2c-0.3,0.1-0.7,0.3-1.1,0.5c-1.1,0.5-2.2,1.1-3.3,1.7c-1.1,0.6-2.1,1.2-2.8,1.8c-0.3,0.2-0.6,0.5-0.8,0.7   c-0.5,0.5-1,1.2-1.5,1.9c-0.5,0.8-0.9,1.7-1.2,2.5c0,0.1,0,0.1-0.1,0.2c10.3,5.8,22.8,5.8,33.1,0c0,0,0-0.1-0.1-0.2   c-0.3-0.9-0.7-1.7-1.2-2.5c-0.4-0.7-0.9-1.4-1.5-1.9c-0.2-0.2-0.5-0.4-0.8-0.7c-0.7-0.6-1.7-1.2-2.8-1.8c-1-0.6-2.1-1.1-3.3-1.7   c-0.4-0.2-0.8-0.3-1.1-0.5c-0.2-0.1-0.3-0.1-0.4-0.2c-0.5-0.2-0.8-0.7-0.8-1.3v-5H34v4.1c0.2,0.1,0.5,0.2,0.7,0.3   c1.2,0.5,2.3,1.1,3.4,1.7c1.2,0.7,2.3,1.4,3.2,2c0.4,0.3,0.7,0.6,1,0.9c0.7,0.7,1.4,1.5,1.9,2.5c0.6,1,1,2,1.4,3   c0.2,0.6,0.4,1.1,0.4,1.4c0.1,0.6-0.1,1.2-0.6,1.5c-11.6,7-26.1,7-37.7,0c-0.5-0.3-0.8-0.9-0.6-1.5c0.1-0.3,0.2-0.8,0.4-1.4   c0.4-1,0.8-2,1.4-3c0.6-0.9,1.2-1.8,1.9-2.5c0.3-0.3,0.6-0.6,1-0.9c0.9-0.7,1.9-1.3,3.2-2c1.1-0.6,2.3-1.2,3.4-1.7   c0.3-0.1,0.5-0.2,0.7-0.3V19.4z',
                        id: 'Path_00000169550811273049217400000014109888628915830947_',
                        class: 'st0',
                        tabindex: '-1',
                      },
                    },
                    {
                      name: 'path',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [],
                      attributes: {
                        d: 'M32,19.5l2.4-1.2c0.6,1.2,1.8,2,3.1,2   c1.2,0,2.1-0.5,2.7-1.3c0.2-0.3,0.4-0.7,0.6-1c0.1-0.2,0.1-0.3,0.2-0.4l2.6,0.8c-0.2,0.6-0.6,1.5-1.2,2.3c-1.2,1.5-2.8,2.4-4.9,2.4   C35.2,23,33.1,21.7,32,19.5z',
                        id: 'Path_00000049902427310539731080000013176836372589123203_',
                        class: 'st0',
                        tabindex: '-1',
                      },
                    },
                    {
                      name: 'path',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [],
                      attributes: {
                        d: 'M33,5.3l-2.1-1.8c2.8-3.4,7.8-4.1,11.4-1.6   s4.8,7.5,2.7,11.4c-2.1,4-6.8,5.6-10.9,3.9l1-2.5c2.8,1.2,6,0,7.5-2.7c1.4-2.7,0.6-6.1-1.9-7.8C38.3,2.4,34.9,2.9,33,5.3z',
                        id: 'Path_00000060716135991135855220000002492902922279920558_',
                        class: 'st0',
                        tabindex: '-1',
                      },
                    },
                    {
                      name: 'path',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [],
                      attributes: {
                        d: 'M43.9,18c0.9,0.4,1.8,0.9,2.7,1.4   c1,0.5,1.8,1.1,2.5,1.6c0.3,0.2,0.6,0.5,0.8,0.7l0.1,0.1c1.4,1.5,2.4,3.4,2.9,5.4c0.2,0.6-0.1,1.2-0.6,1.5   c-3.1,1.8-6.4,3.1-9.9,3.7l-0.5-2.7c2.8-0.5,5.6-1.5,8.1-2.9c-0.4-1.2-1.1-2.3-1.9-3.2c-0.1-0.1-0.3-0.3-0.5-0.5   c-0.6-0.4-1.3-0.9-2.2-1.4c-0.8-0.4-1.6-0.9-2.5-1.3c-0.3-0.1-0.6-0.3-0.8-0.4c-0.1-0.1-0.3-0.1-0.3-0.1c-0.5-0.2-0.8-0.7-0.8-1.3   v-3.9h2.7v3C43.7,17.9,43.8,18,43.9,18z',
                        id: 'Path_00000162309756631124808680000015666581102630056118_',
                        class: 'st0',
                        tabindex: '-1',
                      },
                    },
                    {
                      name: 'path',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [],
                      attributes: {
                        d: 'M16.8,16l2.5,1c-1.2,3.3-4.5,5.4-8,4.9   s-6.2-3.2-6.6-6.7c-0.4-3.5,1.5-6.9,4.8-8.1s6.9-0.1,8.9,2.8l-2.2,1.6c-1.3-1.9-3.6-2.6-5.7-1.8c-2.1,0.8-3.4,3-3.1,5.2   s2,4,4.3,4.3C13.9,19.5,16,18.2,16.8,16z',
                        id: 'Path_00000033351751588442102000000009749932299257136287_',
                        class: 'st0',
                        tabindex: '-1',
                      },
                    },
                    {
                      name: 'path',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [],
                      attributes: {
                        d: 'M14.9,23.8c-0.5-0.2-0.9-0.7-0.9-1.3v-2.6h2.7   v1.7c1.1,0.5,2.2,1.2,3.1,2l0.1,0.1l0.7,0.7l-1.9,1.9l-0.6-0.6C17,24.8,16,24.2,14.9,23.8z',
                        id: 'Path_00000114073822236010335890000003908795504721458574_',
                        class: 'st0',
                        tabindex: '-1',
                      },
                    },
                    {
                      name: 'path',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [],
                      attributes: {
                        d: 'M7.9,19.9h2.7v2.6c0,0.6-0.4,1.1-0.9,1.3   c-1.1,0.4-2.2,1-3.1,1.8C6,26.1,5.5,26.8,5,27.5c1.9,0.9,3.9,1.5,6,1.7l-0.2,2.7c-2.9-0.3-5.7-1.2-8.3-2.6C2,29,1.7,28.2,2,27.6   c0.7-1.5,1.6-2.9,2.8-4l0.1,0c0.9-0.8,2-1.5,3.1-2V19.9z',
                        id: 'Path_00000118361045373789968570000007371373015122663602_',
                        class: 'st0',
                        tabindex: '-1',
                      },
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
              ],
              attributes: {
                id: 'icon-add_family',
                viewBox: '0 -5 54 54',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Add Family',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M15.455565,19.9071657 L17.7811937,19.2197908 C17.8040977,19.2979582 17.8688353,19.4750039 17.9804682,19.7163656 C18.1722681,20.1310565 18.4209427,20.5468212 18.7284888,20.9305271 C19.578888,21.9915166 20.6980789,22.6069565 22.2001975,22.6069565 C23.7020005,22.6069565 24.8197251,21.9918418 25.668217,20.93135 C25.9750845,20.54781 26.2230733,20.1322035 26.4142136,19.717664 C26.5254621,19.4763914 26.5899197,19.2994233 26.6126917,19.2213271 L28.9392185,19.9056294 C28.884339,20.0938376 28.7790523,20.3829021 28.6140224,20.7408142 C28.3446986,21.324916 27.9968067,21.9079508 27.5579356,22.4564761 C26.2757457,24.0590277 24.4900612,25.0417391 22.2001975,25.0417391 C19.9106494,25.0417391 18.1241586,24.0593529 16.8400881,22.457299 C16.4005697,21.9089397 16.0519432,21.326063 15.7818586,20.7421126 C15.6163609,20.3842896 15.5106913,20.0953027 15.455565,19.9071657 Z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M29.4123187,9.67826087 C29.4123187,5.67779829 26.1833421,2.43478261 22.2001975,2.43478261 C18.217053,2.43478261 14.9880763,5.67779829 14.9880763,9.67826087 C14.9880763,13.6787234 18.217053,16.9217391 22.2001975,16.9217391 C26.1833421,16.9217391 29.4123187,13.6787234 29.4123187,9.67826087 Z M31.8365612,9.67826087 C31.8365612,15.0234168 27.5222142,19.3565217 22.2001975,19.3565217 C16.8781808,19.3565217 12.5638339,15.0234168 12.5638339,9.67826087 C12.5638339,4.33310499 16.8781808,6.92006838e-14 22.2001975,6.92006838e-14 C27.5222142,6.92006838e-14 31.8365612,4.33310499 31.8365612,9.67826087 Z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M15.5395915,16.0330435 L17.9638339,16.0330435 L17.9638339,20.6956522 C17.9638339,21.18601 17.6709098,21.6285004 17.2207008,21.8182273 C17.1581574,21.8445843 17.0361224,21.8970601 16.8631785,21.9731239 C16.5723391,22.1010403 16.2476109,22.2475382 15.8976206,22.4100558 C14.8987465,22.8738821 13.9004687,23.3717159 12.9732263,23.881892 C11.9542073,24.4425644 11.0869213,24.9827793 10.4247912,25.4811482 C10.1438565,25.6926008 9.90478567,25.8929766 9.7116506,26.0788915 C9.23108606,26.5414906 8.79252733,27.1164309 8.39932986,27.7796747 C7.98022807,28.4866138 7.63544765,29.2528672 7.36340279,30.0198384 C7.34736533,30.0650526 7.33178971,30.1096921 7.31667302,30.1537227 C16.564859,35.3135982 27.8175717,35.3135629 37.0657302,30.1536167 C37.0505948,30.1094788 37.0349995,30.0647291 37.0189414,30.0194023 C36.7471531,29.2522319 36.4028749,28.4857866 35.9845795,27.7786813 C35.5921672,27.1153299 35.1546392,26.5403171 34.6754113,26.0777233 C34.4831144,25.892101 34.2447677,25.6919543 33.9644542,25.4806984 C33.3022061,24.9816006 32.4334249,24.4404262 31.4120027,23.8787575 C30.4855212,23.3692956 29.4880523,22.8722351 28.4899863,22.4091885 C28.1402785,22.2469438 27.8158129,22.1007001 27.5252102,21.9730127 C27.3524106,21.8970867 27.2304809,21.8447098 27.1679973,21.818406 C26.7175623,21.6287858 26.4244399,21.1861781 26.4244399,20.6956522 L26.4244399,16.2095652 L28.8486824,16.2095652 L28.8486824,19.8985806 C29.0563191,19.9917155 29.2763287,20.0920035 29.5066051,20.1988388 C30.551141,20.6834448 31.5962739,21.2042574 32.5762208,21.7431192 C33.6905624,22.3558833 34.6515807,22.9545133 35.4194702,23.5332268 C35.7740259,23.8004348 36.0865701,24.0628873 36.3552867,24.3222767 C37.0034683,24.9479598 37.5714442,25.6944112 38.0687261,26.5350389 C38.5743988,27.3898508 38.9818293,28.2968882 39.3029119,29.2032004 C39.4966533,29.7500698 39.6205581,30.1825814 39.6827686,30.4465989 C39.804609,30.9636817 39.5784534,31.500394 39.1240507,31.7725481 C28.6924244,38.0203312 15.6897888,38.0203312 5.25816251,31.7725481 C4.80375978,31.500394 4.57760422,30.9636817 4.69944461,30.4465989 C4.76168884,30.1824383 4.8857143,29.7497817 5.07974149,29.2027643 C5.40128132,28.2962528 5.80949471,27.3890235 6.31635993,26.5340455 C6.81478141,25.6933102 7.38422236,24.9467863 8.03419897,24.3211085 C8.30335806,24.0620117 8.61622018,23.7997882 8.97096984,23.532777 C9.73810092,22.9553764 10.6971111,22.3580283 11.8084886,21.7465396 C12.7891204,21.2069882 13.8349934,20.685419 14.8802702,20.2000457 C15.1110548,20.0928811 15.3315342,19.9922906 15.5395915,19.8988843 L15.5395915,16.0330435 Z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M13.4105693,13.0737856 L15.6807348,13.9279536 C14.5861304,16.8624915 11.6406458,18.6696265 8.54133067,18.3081726 C5.44201555,17.9467186 2.98721477,15.5097816 2.59126902,12.40141 C2.19532327,9.29303846 3.96022322,6.31391 6.86911659,5.18045826 C9.77800996,4.04700652 13.0816021,5.05119453 14.8765188,7.6144564 L12.8935732,9.01510881 C11.7396983,7.36729761 9.61596044,6.72174817 7.74595756,7.45039572 C5.87595469,8.17904327 4.74137614,10.0941973 4.9959127,12.0924361 C5.25044925,14.090675 6.82853547,15.6572774 8.82095233,15.8896406 C10.8133692,16.1220039 12.706895,14.9602742 13.4105693,13.0737856 Z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M11.6486433,19.9559733 C11.1560449,19.788851 10.8244399,19.3248134 10.8244399,18.8026087 L10.8244399,16.4895652 L13.2486824,16.4895652 L13.2486824,17.9667299 C14.2540487,18.4016419 15.1900957,18.9867484 16.024479,19.7035919 L16.0936603,19.76787 L16.6997209,20.3765657 L14.9855226,22.098217 L14.4139222,21.5241313 C13.5987462,20.8313715 12.6605807,20.2992901 11.6486433,19.9559733 Z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M5.40625812,16.4895652 L7.83050055,16.4895652 L7.83050055,18.8026087 C7.83050055,19.3248134 7.49889561,19.788851 7.00629715,19.9559733 C5.99017878,20.3007086 5.04844311,20.8357715 4.23092039,21.5327264 C3.69699688,22.0473106 3.23302911,22.6282564 2.84967124,23.2603067 C4.5520772,24.0554065 6.38080449,24.5515957 8.25626723,24.7242102 L8.03503689,27.1488333 C5.43236294,26.9092875 2.90808087,26.1269922 0.623542637,24.8519517 C0.0768086907,24.54681 -0.148970407,23.873959 0.102338447,23.2986957 C0.686520642,21.9614623 1.52956123,20.7542084 2.58244385,19.7471267 L2.63046152,19.7035919 C3.46484481,18.9867484 4.40089175,18.4016419 5.40625812,17.9667299 L5.40625812,16.4895652 Z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-add_child',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Add Child',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'Icon/Product/card-visa',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'g',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [
                                        {
                                          name: 'path',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            d: 'M42,26 C42,28.210938 40.210938,30 38,30 L4,30 C1.789063,30 0,28.210938 0,26 L0,4 C0,1.789063 1.789063,0 4,0 L38,0 C40.210938,0 42,1.789063 42,4 L42,26 Z',
                                            id: 'Path',
                                            fill: 'var(--icon-color)',
                                            tabindex: '-1',
                                          },
                                        },
                                        {
                                          name: 'path',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            d: 'M12.1875,10 L9.558594,17.832031 C9.558594,17.832031 8.894531,14.519531 8.828125,14.101563 C7.332031,10.691406 5.125,10.882813 5.125,10.882813 L7.726563,21 L7.726563,20.996094 L10.886719,20.996094 L15.257813,10 L12.1875,10 Z',
                                            id: 'Path',
                                            fill: 'var(--icon-color)',
                                            tabindex: '-1',
                                          },
                                        },
                                        {
                                          name: 'polygon',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            id: 'Path',
                                            fill: 'var(--icon-color)',
                                            points:
                                              '14.6875 21 17.558594 21 19.296875 10 16.390625 10',
                                            tabindex: '-1',
                                          },
                                        },
                                        {
                                          name: 'path',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            d: 'M35.007813,10 L31.988281,10 L27.277344,21 L30.128906,21 L30.71875,19.429688 L34.3125,19.429688 L34.617188,21 L37.230469,21 L35.007813,10 Z M31.511719,17.328125 L33.074219,13.171875 L33.894531,17.328125 L31.511719,17.328125 Z',
                                            id: 'Shape',
                                            fill: 'var(--icon-color)',
                                            tabindex: '-1',
                                          },
                                        },
                                        {
                                          name: 'path',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            d: 'M23.367188,13.207031 C23.367188,12.601563 23.867188,12.148438 25.296875,12.148438 C26.222656,12.148438 27.285156,12.824219 27.285156,12.824219 L27.753906,10.515625 C27.753906,10.515625 26.394531,10 25.0625,10 C22.042969,10 20.484375,11.441406 20.484375,13.269531 C20.484375,16.578125 24.464844,16.125 24.464844,17.820313 C24.464844,18.113281 24.234375,18.785156 22.574219,18.785156 C20.914063,18.785156 19.816406,18.175781 19.816406,18.175781 L19.320313,20.394531 C19.320313,20.394531 20.386719,21 22.4375,21 C24.496094,21 27.355469,19.460938 27.355469,17.246094 C27.355469,14.585938 23.367188,14.394531 23.367188,13.207031 Z',
                                            id: 'Path',
                                            fill: 'var(--icon-color)',
                                            tabindex: '-1',
                                          },
                                        },
                                        {
                                          name: 'path',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            d: 'M9.210938,15.945313 L8.246094,11.195313 C8.246094,11.195313 7.808594,10.167969 6.671875,10.167969 C5.535156,10.167969 2.234375,10.167969 2.234375,10.167969 C2.234375,10.167969 7.894531,11.839844 9.210938,15.945313 Z',
                                            id: 'Path',
                                            fill: 'var(--icon-color)',
                                            tabindex: '-1',
                                          },
                                        },
                                      ],
                                      attributes: {
                                        id: 'icons8-visa',
                                        tabindex: '-1',
                                        transform:
                                          'translate(318.000000, 37.000000)',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Group',
                                    tabindex: '-1',
                                    transform:
                                      'translate(24.000000, 133.000000)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Payment-Method',
                                tabindex: '-1',
                                transform: 'translate(0.000000, 352.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'Group-2',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 148.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Shopping-Desktop-Payment-1a',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-732.000000, -670.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Payment',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-card_visa',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Card Visa',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'Icon/Product/card-master',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'g',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [
                                        {
                                          name: 'path',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            d: 'M42,26 C42,28.210938 40.210938,30 38,30 L4,30 C1.789063,30 0,28.210938 0,26 L0,4 C0,1.789063 1.789063,0 4,0 L38,0 C40.210938,0 42,1.789063 42,4 L42,26 Z',
                                            id: 'Path',
                                            fill: 'var(--icon-color)',
                                            tabindex: '-1',
                                          },
                                        },
                                        {
                                          name: 'path',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            d: 'M37,15 C37,20.523438 32.523438,25 27,25 C21.476563,25 17,20.523438 17,15 C17,9.476563 21.476563,5 27,5 C32.523438,5 37,9.476563 37,15 Z',
                                            id: 'Path',
                                            fill: 'var(--icon-color)',
                                            tabindex: '-1',
                                          },
                                        },
                                        {
                                          name: 'path',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            d: 'M19.015625,21 C18.550781,20.382813 18.152344,19.714844 17.839844,19 L23.164063,19 C23.441406,18.363281 23.660156,17.695313 23.800781,17 L17.203125,17 C17.070313,16.355469 17,15.6875 17,15 L24,15 C24,14.3125 23.929688,13.644531 23.800781,13 L17.199219,13 C17.34375,12.304688 17.558594,11.636719 17.839844,11 L23.164063,11 C22.851563,10.285156 22.453125,9.617188 21.988281,9 L19.015625,9 C19.449219,8.421875 19.945313,7.878906 20.496094,7.40625 C18.746094,5.910156 16.480469,5 14,5 C8.476563,5 4,9.476563 4,15 C4,20.523438 8.476563,25 14,25 C17.269531,25 20.160156,23.425781 21.984375,21 L19.015625,21 Z',
                                            id: 'Path',
                                            fill: 'var(--icon-color)',
                                            tabindex: '-1',
                                          },
                                        },
                                      ],
                                      attributes: {
                                        id: 'icons8-mastercard',
                                        tabindex: '-1',
                                        transform:
                                          'translate(376.000000, 37.000000)',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Group',
                                    tabindex: '-1',
                                    transform:
                                      'translate(24.000000, 133.000000)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Payment-Method',
                                tabindex: '-1',
                                transform: 'translate(0.000000, 352.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'Group-2',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 148.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Shopping-Desktop-Payment-1a',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-790.000000, -670.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Payment',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-card_master',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Card master',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'Icon/Product/card-discover',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'g',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [
                                        {
                                          name: 'path',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            d: 'M42,26 C42,28.199219 40.199219,30 38,30 L4,30 C1.800781,30 0,28.199219 0,26 L0,4 C0,1.800781 1.800781,0 4,0 L38,0 C40.199219,0 42,1.800781 42,4 L42,26 Z',
                                            id: 'Path',
                                            fill: 'var(--icon-color)',
                                            tabindex: '-1',
                                          },
                                        },
                                        {
                                          name: 'path',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            d: 'M42,26 C42,28.199219 40.199219,30 38,30 L13,30 C13,30 36.601563,26.199219 42,15 L42,26 Z M19,15 C19,16.699219 20.300781,18 22,18 C23.699219,18 25,16.699219 25,15 C25,13.300781 23.699219,12 22,12 C20.300781,12 19,13.300781 19,15 Z',
                                            id: 'Shape',
                                            fill: 'var(--icon-color)',
                                            tabindex: '-1',
                                          },
                                        },
                                        {
                                          name: 'path',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            d: 'M8.199219,12 L9.300781,12 L9.300781,18 L8.199219,18 L8.199219,12 Z M14.199219,15 C14.199219,16.699219 15.5,18 17.199219,18 C17.699219,18 18.101563,17.898438 18.601563,17.699219 L18.601563,16.398438 C18.199219,16.800781 17.800781,17 17.199219,17 C16.101563,17 15.300781,16.199219 15.300781,15 C15.300781,13.898438 16.101563,13 17.199219,13 C17.699219,13 18.101563,13.199219 18.601563,13.601563 L18.601563,12.300781 C18.101563,12.101563 17.699219,11.898438 17.199219,11.898438 C15.5,12 14.199219,13.398438 14.199219,15 Z M27.601563,15.898438 L26,12 L24.800781,12 L27.300781,18 L27.898438,18 L30.398438,12 L29.199219,12 L27.601563,15.898438 Z M30.898438,18 L34.101563,18 L34.101563,17 L32,17 L32,15.398438 L34,15.398438 L34,14.398438 L32,14.398438 L32,13 L34.101563,13 L34.101563,12 L30.898438,12 L30.898438,18 Z M38.5,13.800781 C38.5,12.699219 37.800781,12 36.5,12 L34.800781,12 L34.800781,18 L35.898438,18 L35.898438,15.601563 L36,15.601563 L37.601563,18 L39,18 L37.199219,15.5 C38,15.300781 38.5,14.699219 38.5,13.800781 Z M36.199219,14.800781 L35.898438,14.800781 L35.898438,13 L36.199219,13 C36.898438,13 37.300781,13.300781 37.300781,13.898438 C37.300781,14.398438 37,14.800781 36.199219,14.800781 Z M4.699219,12 L3,12 L3,18 L4.601563,18 C7.101563,18 7.699219,15.898438 7.699219,15 C7.800781,13.199219 6.5,12 4.699219,12 Z M4.398438,17 L4.101563,17 L4.101563,13 L4.5,13 C6,13 6.601563,14 6.601563,15 C6.601563,15.398438 6.5,17 4.398438,17 Z M12.300781,14.300781 C11.601563,14 11.398438,13.898438 11.398438,13.601563 C11.398438,13.199219 11.800781,13 12.199219,13 C12.5,13 12.800781,13.101563 13.101563,13.5 L13.699219,12.699219 C13.199219,12.199219 12.699219,12 12,12 C11,12 10.199219,12.699219 10.199219,13.699219 C10.199219,14.5 10.601563,14.898438 11.601563,15.300781 C12.199219,15.5 12.699219,15.699219 12.699219,16.199219 C12.699219,16.699219 12.300781,17 11.800781,17 C11.300781,17 10.800781,16.699219 10.601563,16.199219 L9.898438,16.898438 C10.398438,17.699219 11,18 11.898438,18 C13.101563,18 13.898438,17.199219 13.898438,16.101563 C13.898438,15.199219 13.5,14.800781 12.300781,14.300781 Z',
                                            id: 'Shape',
                                            fill: 'var(--icon-color)',
                                            tabindex: '-1',
                                          },
                                        },
                                      ],
                                      attributes: {
                                        id: 'icons8-discover',
                                        tabindex: '-1',
                                        transform:
                                          'translate(434.000000, 37.000000)',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Group',
                                    tabindex: '-1',
                                    transform:
                                      'translate(24.000000, 133.000000)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Payment-Method',
                                tabindex: '-1',
                                transform: 'translate(0.000000, 352.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'Group-2',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 148.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Shopping-Desktop-Payment-1a',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-848.000000, -670.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Payment',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-card_discover',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Card Discover',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'path',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [],
                      attributes: {
                        d: 'M0,0h24v24H0V0z',
                        fill: 'none',
                        tabindex: '-1',
                      },
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'path',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [],
                          attributes: {
                            d: 'M3,11h8V3H3V11z M5,5h4v4H5V5z',
                            tabindex: '-1',
                          },
                        },
                        {
                          name: 'path',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [],
                          attributes: {
                            d: 'M13,3v8h8V3H13z M19,9h-4V5h4V9z',
                            tabindex: '-1',
                          },
                        },
                        {
                          name: 'path',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [],
                          attributes: {
                            d: 'M3,21h8v-8H3V21z M5,15h4v4H5V15z',
                            tabindex: '-1',
                          },
                        },
                        {
                          name: 'polygon',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [],
                          attributes: {
                            points:
                              '18,13 16,13 16,16 13,16 13,18 16,18 16,21 18,21 18,18 21,18 21,16 18,16',
                            tabindex: '-1',
                          },
                        },
                      ],
                      attributes: { tabindex: '-1' },
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
              ],
              attributes: {
                id: 'icon-dashboard_custom',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
                'data-title': 'Dashboard - Custom',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'path',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [],
                      attributes: {
                        d: 'M0,0h24v24H0V0z',
                        fill: 'none',
                        tabindex: '-1',
                      },
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'path',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [],
                          attributes: {
                            d: 'M3,11h8V3H3V11z M5,5h4v4H5V5z',
                            tabindex: '-1',
                          },
                        },
                        {
                          name: 'path',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [],
                          attributes: {
                            d: 'M13,3v8h8V3H13z M19,9h-4V5h4V9z',
                            tabindex: '-1',
                          },
                        },
                        {
                          name: 'path',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [],
                          attributes: {
                            d: 'M3,21h8v-8H3V21z M5,15h4v4H5V15z',
                            tabindex: '-1',
                          },
                        },
                        {
                          name: 'polygon',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [],
                          attributes: {
                            points:
                              '18,13 16,13 16,16 13,16 13,18 16,18 16,21 18,21 18,18 21,18 21,16 18,16',
                            tabindex: '-1',
                          },
                        },
                      ],
                      attributes: { tabindex: '-1' },
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
              ],
              attributes: {
                id: 'icon-add_alt',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Add - Alternative',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V5zm6 6c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-mic',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Mic',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-storage',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Storage',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-smartphone',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Smartphone',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-laptop',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Laptop',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-tablet',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Tablet',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-refresh',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
                'data-title': 'Refresh',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-battery',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Battery',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M17 4h3v16h-3V4zM5 14h3v6H5v-6zm6-5h3v11h-3V9z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-cellular_signal',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Cellular Signal',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0zm0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-wifi',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'WiFi',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-rotate_screen',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Rotate Screen',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-align_right',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Align Right',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-desktop',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Desktop',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M8.67 1.778c-.848 0-1.644.334-2.244.941L.93 8.284C.33 8.892 0 9.698 0 10.557v25.292c0 1.062.856 1.929 1.905 1.929h25.397c1.049 0 1.904-.867 1.904-1.929V24.5l7.808-7.923 2.242-2.273A2.565 2.565 0 0 0 40 12.485c0-.685-.263-1.333-.744-1.818l-3.591-3.636c-.96-.972-2.634-.972-3.592 0l-1.765 1.786-.147.15-.332.337v.002l-.623.628V3.706c0-1.062-.855-1.928-1.904-1.928H8.67zm.219 1.285h18.413a.64.64 0 0 1 .635.643v7.516l-2.57 2.607c-.007.007-.02.01-.03.02-.007.01-.01.023-.02.033l-12.53 12.714a.633.633 0 0 0-.18.381l-.47 4.063-.448 3.172c-.027.2.04.404.181.547.12.12.283.189.449.189.03 0 .06-.003.092-.005l3.122-.452 4.053-.437a.639.639 0 0 0 .384-.184l1.617-1.642v1.05a.64.64 0 0 0 .635.643.64.64 0 0 0 .635-.643v-1.286a.633.633 0 0 0-.444-.603l5.524-5.605V35.85a.64.64 0 0 1-.635.643H1.905a.64.64 0 0 1-.635-.643V10.778h5.714c1.05 0 1.905-.867 1.905-1.929V3.063zm-1.27.322v5.464a.64.64 0 0 1-.635.643H1.587c.067-.105.15-.206.24-.299L7.325 3.63c.092-.09.19-.171.295-.244zm26.25 4.191c.33 0 .657.12.898.364l3.591 3.636c.24.244.372.565.372.91 0 .343-.131.665-.372.908l-1.795 1.818-5.387-5.454.032-.032v-.003L32.97 7.94c.24-.243.568-.364.898-.364zm-3.591 3.091l5.387 5.455-.9.914a.627.627 0 0 0-.884.01l-.895.909a.647.647 0 0 0-.01.896l-.9.912-5.387-5.455 3.589-3.64zm-.437 1.645a.625.625 0 0 0-.446.188l-.9.91a.648.648 0 0 0 0 .909.627.627 0 0 0 .897 0l.898-.91a.648.648 0 0 0 0-.909.627.627 0 0 0-.449-.188zM6.984 13.35a.64.64 0 0 0-.635.643.64.64 0 0 0 .635.643h8.889a.64.64 0 0 0 .635-.643.64.64 0 0 0-.635-.643H6.984zm11.429 0a.64.64 0 0 0-.635.643.64.64 0 0 0 .635.643h2.54a.64.64 0 0 0 .634-.643.64.64 0 0 0-.635-.643h-2.54zm13.673 1.236a.631.631 0 0 0-.45.188l-.894.91a.644.644 0 0 0 .448 1.096.621.621 0 0 0 .447-.188l.9-.909a.648.648 0 0 0 0-.909.637.637 0 0 0-.451-.188zm-6.292.633l5.387 5.454-11.21 11.375-.286-2.807a.64.64 0 0 0-.632-.578h-1.161v-.909l3.408-3.448a.651.651 0 0 0 0-.911.632.632 0 0 0-.9 0l-3.376 3.42-2.408-.256 11.178-11.34zm-18.81.703a.64.64 0 0 0-.635.642.64.64 0 0 0 .635.643h11.429a.64.64 0 0 0 .635-.643.64.64 0 0 0-.635-.642H6.984zm17.458 3.648a.637.637 0 0 0-.451.189l-1.796 1.818a.651.651 0 0 0 0 .911.635.635 0 0 0 .898 0l1.798-1.818a.651.651 0 0 0 0-.911.635.635 0 0 0-.449-.189zm-17.458.209a.64.64 0 0 0-.635.643.64.64 0 0 0 .635.642h8.254a.64.64 0 0 0 .635-.642.64.64 0 0 0-.635-.643H6.984zm0 2.571a.64.64 0 0 0-.635.643.64.64 0 0 0 .635.643h5.08a.64.64 0 0 0 .634-.643.64.64 0 0 0-.635-.643H6.984zm6.808 5.414l2.833.302v1.238a.637.637 0 0 0 .632.645h1.225l.295 2.9-3.08.33-2.264-2.29.36-3.125zM3.175 31.35a.64.64 0 0 0-.635.643v1.286a.64.64 0 0 0 .635.643.64.64 0 0 0 .635-.643v-1.286a.64.64 0 0 0-.635-.643zm3.174 0a.64.64 0 0 0-.635.643v1.286a.64.64 0 0 0 .635.643.64.64 0 0 0 .635-.643v-1.286a.64.64 0 0 0-.635-.643zm3.175 0a.64.64 0 0 0-.635.643v1.286a.64.64 0 0 0 .635.643.64.64 0 0 0 .635-.643v-1.286a.64.64 0 0 0-.635-.643zm15.873 0a.64.64 0 0 0-.635.643v1.286a.64.64 0 0 0 .635.643.64.64 0 0 0 .635-.643v-1.286a.64.64 0 0 0-.635-.643z',
                    tabindex: '-1',
                    'fill-rule': 'nonzero',
                  },
                },
              ],
              attributes: {
                id: 'icon-edit_product',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Edit',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M27.208 1.644c1.68 0 3.06 1.274 3.06 2.869v3.863c0 1.403-1.068 2.557-2.468 2.815v1.202a3.06 3.06 0 0 1 2.468 3.002v19.604a3.06 3.06 0 0 1-3.06 3.06H12.703a3.059 3.059 0 0 1-3.059-3.06V15.395a3.059 3.059 0 0 1 2.778-3.047v-1.116c-1.55-.132-2.778-1.351-2.778-2.856V4.513c0-1.595 1.38-2.869 3.06-2.869h14.504zm0 11.847H12.703a1.903 1.903 0 0 0-1.903 1.904v2.01h11.01a2.236 2.236 0 0 1 2.236 2.236v10.97a2.236 2.236 0 0 1-2.236 2.236H10.8v2.152c0 1.052.852 1.904 1.903 1.904h14.505a1.904 1.904 0 0 0 1.904-1.904V15.395a1.904 1.904 0 0 0-1.904-1.904zm-5.398 5.07H10.8v2.86h7.622c.287 0 .526.21.57.485L19 22c0 .319-.259.577-.578.577H10.8v1.51l7.623.001c.287 0 .526.21.57.484l.008.094c0 .32-.259.578-.578.578H10.8v1.51l5.615.001c.287 0 .525.21.57.484l.008.094c0 .319-.259.578-.578.578h-5.615l.001 3.78h11.01a1.08 1.08 0 0 0 1.08-1.08V19.64a1.08 1.08 0 0 0-1.08-1.08zm5.559 2.188c.319 0 .577.26.577.578v1.301a.578.578 0 0 1-1.155 0v-1.3c0-.32.258-.579.578-.579zm-2.02-6.338a2.597 2.597 0 0 1 2.597 2.597v2.19a.578.578 0 0 1-1.155 0v-2.19c0-.796-.645-1.441-1.441-1.441h-3.727a.578.578 0 0 1 0-1.156zm1.295-3.168H13.577v1.092h13.067v-1.092zm.564-8.443H12.703c-1.06 0-1.903.778-1.903 1.713v3.863c0 .935.842 1.713 1.903 1.713h14.505c1.061 0 1.904-.778 1.904-1.713V4.513c0-.935-.842-1.713-1.904-1.713zm-1.652 1.956c.319 0 .577.258.577.577v1.989a.578.578 0 1 1-1.155 0V5.333c0-.319.258-.577.578-.577zm-2.667 0c.319 0 .578.258.578.577v1.989a.578.578 0 0 1-1.156 0V5.333c0-.319.259-.577.578-.577zm-3.111 0c.319 0 .578.258.578.577v1.989a.578.578 0 0 1-1.156 0V5.333c0-.319.259-.577.578-.577zm-2.667 0c.32 0 .578.258.578.577v1.989a.578.578 0 1 1-1.156 0V5.333c0-.319.259-.577.578-.577zm-2.667 0c.32 0 .578.258.578.577v1.989a.578.578 0 1 1-1.155 0V5.333c0-.319.258-.577.577-.577z',
                    tabindex: '-1',
                    'fill-rule': 'nonzero',
                  },
                },
              ],
              attributes: {
                id: 'icon-otc',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Over the Counter',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 .889C9.464.889.889 9.46.889 20 .889 30.539 9.464 39.111 20 39.111c10.536 0 19.111-8.572 19.111-19.111C39.111 9.461 30.536.889 20 .889zm0 1.318c9.81 0 17.793 7.983 17.793 17.793 0 9.81-7.983 17.793-17.793 17.793-9.81 0-17.793-7.983-17.793-17.793C2.207 10.19 10.19 2.207 20 2.207zm0 2.636C11.641 4.843 4.843 11.64 4.843 20S11.64 35.157 20 35.157 35.157 28.36 35.157 20A15.08 15.08 0 0 0 29.36 8.076a.66.66 0 1 0-.816 1.038A13.769 13.769 0 0 1 33.839 20c0 7.63-6.209 13.84-13.839 13.84-7.63 0-13.84-6.21-13.84-13.84S12.37 6.16 20 6.16c.677 0 1.357.05 2.02.148a.656.656 0 0 0 .747-.559.658.658 0 0 0-.556-.746A15.42 15.42 0 0 0 20 4.843zm4.963.885a.656.656 0 0 0-.584.433.658.658 0 0 0 .388.844c.518.19 1.03.415 1.524.667a.657.657 0 0 0 .888-.288.656.656 0 0 0-.288-.886c-.538-.278-1.099-.522-1.668-.73a.646.646 0 0 0-.26-.04zm-6.281 5.705a3.298 3.298 0 0 0-3.295 3.295.659.659 0 1 0 1.318 0 1.98 1.98 0 0 1 1.977-1.977h2.636a1.98 1.98 0 0 1 1.977 1.977v1.871c0 .96-.613 1.813-1.527 2.116a3.546 3.546 0 0 0-2.427 3.368v1.871a.659.659 0 1 0 1.318 0v-1.871c0-.96.613-1.813 1.527-2.116a3.546 3.546 0 0 0 2.427-3.368v-1.871a3.298 3.298 0 0 0-3.295-3.295h-2.636zM8.138 19.341a.659.659 0 0 0-.66.659v1.318a.659.659 0 1 0 1.319 0V20a.659.659 0 0 0-.66-.659zm3.295 0a.659.659 0 0 0-.66.659v1.318a.659.659 0 1 0 1.319 0V20a.659.659 0 0 0-.659-.659zm3.295 0a.659.659 0 0 0-.659.659v1.318a.659.659 0 1 0 1.318 0V20a.659.659 0 0 0-.659-.659zm10.544 0a.659.659 0 0 0-.659.659v1.318a.659.659 0 1 0 1.318 0V20a.659.659 0 0 0-.659-.659zm3.295 0a.659.659 0 0 0-.659.659v1.318a.659.659 0 1 0 1.318 0V20a.659.659 0 0 0-.659-.659zm3.295 0a.659.659 0 0 0-.659.659v1.318a.659.659 0 1 0 1.318 0V20a.659.659 0 0 0-.659-.659zM20 25.931a1.317 1.317 0 1 0-.002 2.635A1.317 1.317 0 0 0 20 25.93z',
                    tabindex: '-1',
                    'fill-rule': 'nonzero',
                  },
                },
              ],
              attributes: {
                id: 'icon-other',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Other',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M3.543 5.778c-.972 0-1.765.798-1.765 1.778v24.296a2.364 2.364 0 0 0 2.354 2.37h28.654c1.064 0 2-.722 2.275-1.768L39.06 16.28a1.781 1.781 0 0 0-.322-1.523 1.759 1.759 0 0 0-1.393-.683h-3.79v-2.963c0-.98-.793-1.778-1.766-1.778H16.905c-.47 0-.908-.183-1.241-.514L13.47 6.634a2.91 2.91 0 0 0-2.069-.856H3.543zm0 1.185h7.859c.469 0 .908.183 1.241.514l2.19 2.183a2.921 2.921 0 0 0 2.072.859h14.883c.324 0 .589.266.589.592v2.963H11.494c-1.085 0-2.023.74-2.285 1.799l-3.894 15.8c-.002.012-.324 1.364-1.183 1.364a1.183 1.183 0 0 1-1.177-1.185V7.556c0-.327.264-.593.588-.593zm7.95 8.296h25.85c.185 0 .353.084.465.23a.576.576 0 0 1 .106.504l-3.99 16.164a1.18 1.18 0 0 1-1.138.88H6.02a3.81 3.81 0 0 0 .441-1.093l.897-3.648h20.899a.589.589 0 0 0 .588-.592.589.589 0 0 0-.588-.593H7.653l2.699-10.951c.13-.53.6-.9 1.142-.9zm19.118 11.852a.589.589 0 0 0-.588.593c0 .328.262.592.588.592h2.354a.589.589 0 0 0 .589-.592.589.589 0 0 0-.589-.593h-2.354zM8.453 29.488a.586.586 0 0 0-.478.443l-.294 1.185a.59.59 0 0 0 .57.736.59.59 0 0 0 .57-.45l.294-1.184a.59.59 0 0 0-.662-.73zm2.942 0a.586.586 0 0 0-.478.443l-.294 1.185a.59.59 0 0 0 .57.736.59.59 0 0 0 .57-.45l.294-1.184a.59.59 0 0 0-.662-.73zm2.942 0a.586.586 0 0 0-.478.443l-.294 1.185a.59.59 0 0 0 .57.736.59.59 0 0 0 .57-.45L15 30.219a.59.59 0 0 0-.662-.73zm2.943 0a.586.586 0 0 0-.479.443l-.294 1.185a.59.59 0 0 0 .57.736.59.59 0 0 0 .57-.45l.294-1.184a.59.59 0 0 0-.661-.73zm2.942 0a.586.586 0 0 0-.478.443l-.295 1.185a.59.59 0 0 0 .57.736.59.59 0 0 0 .57-.45l.295-1.184a.59.59 0 0 0-.662-.73zm2.942 0a.586.586 0 0 0-.478.443l-.294 1.185a.59.59 0 0 0 .57.736.59.59 0 0 0 .57-.45l.294-1.184a.59.59 0 0 0-.662-.73zm2.942 0a.586.586 0 0 0-.478.443l-.294 1.185a.59.59 0 0 0 .57.736.59.59 0 0 0 .57-.45l.294-1.184a.59.59 0 0 0-.662-.73zm2.942 0a.583.583 0 0 0-.478.443l-.294 1.185a.59.59 0 0 0 .57.736.59.59 0 0 0 .57-.45l.294-1.184a.59.59 0 0 0-.662-.73zm2.943 0a.586.586 0 0 0-.479.443l-.294 1.185a.59.59 0 0 0 .57.736.59.59 0 0 0 .57-.45l.295-1.184a.59.59 0 0 0-.662-.73z',
                    tabindex: '-1',
                    'fill-rule': 'nonzero',
                  },
                },
              ],
              attributes: {
                id: 'icon-folder_product',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Folder',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19.999.889c-.431 0-.862.14-1.224.422l-.912.717A19.055 19.055 0 0 1 7.3 6.048l-2.363.155c-1.073.07-1.892.982-1.823 2.03l.449 7.39c.512 6.96 3.755 13.314 9.131 17.892l6.019 5.132c.367.31.826.464 1.285.464.461 0 .92-.155 1.285-.464l6.024-5.132c5.373-4.578 8.616-10.934 9.128-17.902l.45-7.377c.065-1.051-.753-1.963-1.826-2.033l-2.36-.155a19.056 19.056 0 0 1-10.565-4.02l-.912-.717a1.98 1.98 0 0 0-1.224-.422zm0 1.279c.145 0 .288.047.408.142l.912.717a20.379 20.379 0 0 0 11.294 4.298l2.363.154c.357.023.63.328.606.68l-.448 7.37c-.464 6.298-3.281 12.072-7.956 16.37v-.043c0-.352-.291-.64-.653-.64a.647.647 0 0 0-.653.64v1.187l-5.445 4.637a.668.668 0 0 1-.856 0l-5.446-4.637v-1.187c0-.352-.29-.64-.652-.64a.647.647 0 0 0-.653.64v.043C8.147 27.6 5.328 21.829 4.864 15.536l-.449-7.38a.647.647 0 0 1 .61-.677l2.36-.154a20.38 20.38 0 0 0 11.296-4.298l.91-.717a.664.664 0 0 1 .408-.142zm0 1.833c-.26 0-.525.075-.747.23l-1.677 1.148a19.213 19.213 0 0 1-9.593 3.312l-.426.027a.644.644 0 0 0-.61.68.649.649 0 0 0 .653.596c.016 0 .028 0 .044-.002l.423-.025a20.533 20.533 0 0 0 10.258-3.541l1.675-1.15 1.677 1.15a20.3 20.3 0 0 0 5.925 2.787c.346.1.708-.095.808-.432a.638.638 0 0 0-.441-.795 19.104 19.104 0 0 1-5.545-2.607L20.748 4.23a1.316 1.316 0 0 0-.75-.23zm10.53 4.532a.65.65 0 0 0-.741.54.642.642 0 0 0 .55.726c.526.075 1.061.133 1.594.168l.385.025h.046c.339 0 .627-.257.647-.595a.645.645 0 0 0-.604-.684l-.387-.022c-.498-.035-1-.085-1.49-.158zm-2.046 5.422a.647.647 0 0 0-.462.19l-9.327 9.135-4.757-4.662a.665.665 0 0 0-.926 0 .63.63 0 0 0 0 .904l5.221 5.114a.661.661 0 0 0 .925 0l9.79-9.59a.63.63 0 0 0 0-.904.666.666 0 0 0-.464-.187zM16.736 31.217a.647.647 0 0 0-.653.64v1.278c0 .355.293.64.653.64a.644.644 0 0 0 .652-.64v-1.279c0-.352-.29-.64-.652-.64zm3.263 0a.647.647 0 0 0-.653.64v1.278c0 .355.293.64.653.64a.644.644 0 0 0 .652-.64v-1.279c0-.352-.29-.64-.652-.64zm3.263 0a.647.647 0 0 0-.653.64v1.278c0 .355.293.64.653.64a.644.644 0 0 0 .653-.64v-1.279c0-.352-.291-.64-.653-.64z',
                    tabindex: '-1',
                    'fill-rule': 'nonzero',
                  },
                },
              ],
              attributes: {
                id: 'icon-coverage_gain',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Coverage Gain',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm2 16H5V5h11.17L19 7.83V19zm-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zM6 6h9v4H6z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-save',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Save',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'rect',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    fill: 'none',
                    width: '24',
                    height: '24',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M22,2v2H2V2H22z M7,10.5v3h10v-3H7z M2,20v2h20v-2H2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-align_y_between',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Align Y - Space Between',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'rect',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    fill: 'none',
                    width: '24',
                    height: '24',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M22,2v2H2V2H22z M7,22h3V6H7V22z M14,16h3V6h-3V16z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-align_y_top',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Align Y - Top',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'rect',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    fill: 'none',
                    width: '24',
                    height: '24',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M22,22H2v-2h20V22z M10,2H7v16h3V2z M17,8h-3v10h3V8z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-align_y_bottom',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Align Y - Bottom',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'rect',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    fill: 'none',
                    width: '24',
                    height: '24',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'polygon',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    points:
                      '22,11 17,11 17,6 14,6 14,11 10,11 10,3 7,3 7,11 1.84,11 1.84,13 7,13 7,21 10,21 10,13 14,13 14,18 17,18 17,13 22,13',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-align_y_center',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Align Y - Center',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'rect',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    fill: 'none',
                    width: '24',
                    height: '24',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M4,22H2V2h2V22z M22,2h-2v20h2V2z M13.5,7h-3v10h3V7z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-align_x_between',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Align X - Space Between',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'rect',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    fill: 'none',
                    width: '24',
                    height: '24',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20,2h2v20h-2V2z M2,10h16V7H2V10z M8,17h10v-3H8V17z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-align_x_right',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Align X - Right',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'rect',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    fill: 'none',
                    width: '24',
                    height: '24',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M4,22H2V2h2V22z M22,7H6v3h16V7z M16,14H6v3h10V14z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-align_x_left',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Align X - Left',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'rect',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    fill: 'none',
                    width: '24',
                    height: '24',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'polygon',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    points:
                      '11,2 13,2 13,7 21,7 21,10 13,10 13,14 18,14 18,17 13,17 13,22 11,22 11,17 6,17 6,14 11,14 11,10 3,10 3,7 11,7',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-align_x_center',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Align X - Center',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-flex_column',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Direction - Column',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-flex_row',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Direction - Row',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-align_left',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Align Left',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-align_center',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Align Center',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-container',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Container',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'rect',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [],
                      attributes: {
                        fill: 'none',
                        width: '24',
                        height: '24',
                        tabindex: '-1',
                      },
                    },
                    {
                      name: 'path',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [],
                      attributes: {
                        d: 'M14.17,5L19,9.83V19H5V5L14.17,5L14.17,5 M14.17,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V9.83 c0-0.53-0.21-1.04-0.59-1.41l-4.83-4.83C15.21,3.21,14.7,3,14.17,3L14.17,3z M7,15h10v2H7V15z M7,11h10v2H7V11z M7,7h7v2H7V7z',
                        tabindex: '-1',
                      },
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
              ],
              attributes: {
                id: 'icon-description',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Description',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-page_footer',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Page Footer',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm0 14H5V8h14v10z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-page_header',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Page Header',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-dashboard',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Dashboard',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'rect',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    fill: 'none',
                    width: '24',
                    height: '24',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M8.5,8.62v6.76L5.12,12L8.5,8.62 M10,5l-7,7l7,7V5L10,5z M14,5v14l7-7L14,5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-toggle',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Toggle',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-move',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Move',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM4 6h9v7H4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-splash_section',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Splash Section',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 10h9v2H5zm0-3h9v2H5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-content_section',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Content Section',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-image',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Image',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M17.66 5.41l.92.92-2.69 2.69-.92-.92 2.69-2.69M17.67 3c-.26 0-.51.1-.71.29l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42l-2.34-2.34c-.2-.19-.45-.29-.7-.29zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-colorize',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Colorize',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M7 16c.55 0 1 .45 1 1 0 1.1-.9 2-2 2-.17 0-.33-.02-.5-.05.31-.55.5-1.21.5-1.95 0-.55.45-1 1-1M18.67 3c-.26 0-.51.1-.71.29L9 12.25 11.75 15l8.96-8.96a.996.996 0 0 0 0-1.41l-1.34-1.34c-.2-.2-.45-.29-.7-.29zM7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-theme',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Theme',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M7 15c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3m10-8H7c-2.8 0-5 2.2-5 5s2.2 5 5 5h10c2.8 0 5-2.2 5-5s-2.2-5-5-5',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                  },
                },
              ],
              attributes: {
                id: 'icon-ceh_boolean',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
                'data-title': 'CEH Boolean',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 6.36c1.53 2 3.08 4.43 3.71 6.24l2.23 2.23c.03-.27.06-.55.06-.83 0-3.98-6-10.8-6-10.8s-1.18 1.35-2.5 3.19l1.44 1.44c.34-.51.7-1 1.06-1.47zM5.41 5.14L4 6.55l3.32 3.32C6.55 11.33 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.95-1.5l2.63 2.63L20 19.72 5.41 5.14zM12 18c-2.21 0-4-1.79-4-4 0-.69.32-1.62.81-2.64l5.72 5.72c-.7.56-1.57.92-2.53.92z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-monochrome',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Monochrome',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'circle',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: { r: '2', cx: '12', cy: '4', tabindex: '-1' },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-9 7c-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1a5 5 0 1 0 5.9 5.9h-2.07c-.41 1.16-1.52 2-2.83 2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-accessible',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Accessible',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M10 4c4.41 0 8 3.59 8 8s-3.59 8-8 8c-.34 0-.68-.02-1.01-.07C10.9 17.77 12 14.95 12 12s-1.1-5.77-3.01-7.93C9.32 4.02 9.66 4 10 4m0-2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-night',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Night',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6.5c-3.03 0-5.5 2.47-5.5 5.5s2.47 5.5 5.5 5.5 5.5-2.47 5.5-5.5-2.47-5.5-5.5-5.5zm0 9c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-day',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Day',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-eye-hide',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
                'data-title': 'Eye Hide',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-eye',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
                'data-title': 'Eye',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-grid',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
                'data-title': 'Grid',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0 0h24v24H0V0z',
                    fill: 'none',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-code',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Code',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'CF3E7ECB-2DA7-4F05-B021-35AC38D9002D',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'path',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [],
                                  attributes: {
                                    d: 'M18.6547928,0.77286303 C32.7747547,0.77286303 38.3773034,7.04907936 38.3773034,18.998757 C38.3773034,19.3178549 38.1186235,19.5765348 37.7995256,19.5765348 C37.4804278,19.5765348 37.2217479,19.3178549 37.2217479,18.998757 C37.2217479,7.77327103 32.2072936,2.0436086 19.0558163,1.9301379 L18.7169393,1.92865347 L18.6871521,1.93095371 L18.6569617,1.93172891 C10.7369297,1.93172891 5.85442423,7.54874957 5.85442423,15.7090021 C5.85442423,15.7942214 5.83557677,15.8781136 5.79954791,15.9547694 L5.76933079,16.0108122 L1.81204309,22.4708147 C1.4494834,23.0626687 1.60926785,23.8584273 2.15729722,24.2353781 C2.3194253,24.3468946 2.50350725,24.4122333 2.69285043,24.4268255 L2.77427096,24.4299591 L5.27664645,24.4299591 C5.57580069,24.4299591 5.82185323,24.6573145 5.85144123,24.9486624 L5.85442423,25.0077368 L5.85531416,31.5387263 C5.89038692,34.1979776 6.96619736,35.7225263 9.80153229,35.7726059 L9.94722176,35.7738799 L18.6569617,35.7738799 C18.788307,35.7738799 18.9150413,35.8186028 19.0168054,35.8996156 L19.0655123,35.9431071 L21.1830318,38.0606266 L27.1984833,33.0413302 C27.4434925,32.8368944 27.8078395,32.8697856 28.0122753,33.1147947 C28.203082,33.3434699 28.1871505,33.6761017 27.9849768,33.8856501 L27.9388107,33.9285866 L21.5179752,39.2861357 C21.3048188,39.4639935 20.9983624,39.463579 20.78641,39.2933518 L20.7392609,39.2510581 L18.4176383,36.9294355 L9.94722176,36.9294355 C6.26128303,36.9294355 4.74305368,34.8213783 4.69982123,31.5477135 L4.69886868,31.4025339 L4.69886868,25.5855161 L2.77427096,25.5855146 C2.32157116,25.5855146 1.87947616,25.4468022 1.50242867,25.1874578 C0.472823669,24.4792651 0.163176231,23.0599211 0.772216484,21.9606132 L0.826674417,21.8671946 L4.69949549,15.5450781 C4.76529471,6.95372673 10.0071975,0.898247531 18.4016223,0.777997082 L18.5898549,0.776471641 C18.6111719,0.774087421 18.6328393,0.77286303 18.6547928,0.77286303 Z M28.3595312,8.06353132 C31.9738883,12.3709543 31.8464465,18.6414715 28.1857244,22.7876804 L28.7607384,23.472863 L28.8333926,23.4122426 C29.6325337,22.7416836 30.8239609,22.84592 31.4945198,23.645061 L39.1299709,32.7446373 C39.8005299,33.5437783 39.6962935,34.7352056 38.8971525,35.4057645 L36.1527711,37.7085739 C35.3536301,38.3791328 34.1622029,38.2748965 33.4916439,37.4757554 L25.8561928,28.3761792 C25.1856339,27.5770381 25.2898702,26.3856109 26.0890113,25.7150519 L26.1607384,25.653863 L25.5862143,24.9685429 C20.8678311,27.8539631 14.6702053,26.8906342 11.0557666,22.5831138 C7.51493634,18.3633166 7.5490619,12.2268981 11.0573994,8.05881267 C11.1586182,7.93855958 11.2624682,7.82029324 11.3689089,7.70408099 C11.6629799,7.50166224 11.9657332,7.56480478 12.2771688,7.8935086 C12.2771688,7.8935086 14.1378826,9.93774152 14.1378826,9.93774152 C14.3192641,10.2200389 14.3594975,10.566568 14.2585829,10.9773288 C12.0908349,13.5522728 12.1720714,17.2021075 14.3604695,19.8101388 C16.8384697,22.7633045 21.2412995,23.1485022 24.1944652,20.670502 C27.1476308,18.1925018 27.5328285,13.7896719 25.0548283,10.8365063 C23.7049857,9.22782656 21.7672962,8.37048985 19.7988038,8.34284671 C18.5181825,8.32486321 17.2245246,8.65802888 16.0712037,9.36391634 C15.7752571,9.4312297 15.5415066,9.38839633 15.3699522,9.23541625 C15.3699522,9.23541625 13.2964045,6.88954656 13.2964045,6.88954656 C13.0387447,6.62237026 13.0387447,6.33395014 13.2964045,6.0242862 C18.0685345,2.72626188 24.605225,3.58932335 28.3595312,8.06353132 Z M29.5476011,24.2634031 L29.4747384,24.322863 L29.5250255,24.3831403 L29.0107314,24.7277216 L28.9633734,24.7577237 L28.902107,24.8050369 L28.4617384,25.173863 L27.4377384,26.032863 L27.4063609,26.0627696 C27.3927853,26.0759252 27.379754,26.0895003 27.367273,26.1034775 L26.9397339,26.5822691 L26.8747384,26.505863 L26.8032197,26.5662124 C26.4741617,26.8423249 26.4312408,27.3329126 26.7073533,27.6619707 L34.3428044,36.761547 C34.6189169,37.0906051 35.1095046,37.1335259 35.4385627,36.8574134 L38.182944,34.554604 C38.5120021,34.2784915 38.554923,33.7879038 38.2788105,33.4588458 L30.6433594,24.3592695 C30.3672468,24.0302114 29.8766592,23.9872906 29.5476011,24.2634031 Z M36.3429524,33.3326917 C36.5837786,33.1233447 36.9487162,33.1488636 37.1580632,33.3896898 C37.3674102,33.630516 37.3418913,33.9954535 37.1010651,34.2048006 L37.1010651,34.2048006 L36.0945079,35.0797874 C35.8536817,35.2891344 35.4887442,35.2636155 35.2793971,35.0227893 C35.0700501,34.7819631 35.095569,34.4170256 35.3363952,34.2076785 L35.3363952,34.2076785 Z M34.7630708,31.5152457 C35.003897,31.3058987 35.3688345,31.3314176 35.5781815,31.5722438 C35.7875285,31.81307 35.7620096,32.1780076 35.5211834,32.3873546 L35.5211834,32.3873546 L34.5146262,33.2623414 C34.2738,33.4716884 33.9088625,33.4461695 33.6995155,33.2053433 C33.4901684,32.9645171 33.5156874,32.5995796 33.7565136,32.3902326 L33.7565136,32.3902326 Z M33.1831891,29.6977998 C33.4240153,29.4884527 33.7889528,29.5139717 33.9982998,29.7547979 C34.2076469,29.9956241 34.1821279,30.3605616 33.9413017,30.5699086 L33.9413017,30.5699086 L32.9347445,31.4448954 C32.6939183,31.6542425 32.3289808,31.6287236 32.1196338,31.3878973 C31.9102868,31.1470711 31.9358057,30.7821336 32.1766319,30.5727866 L32.1766319,30.5727866 Z M31.6033074,27.8803538 C31.8441336,27.6710068 32.2090711,27.6965257 32.4184182,27.9373519 C32.6277652,28.1781781 32.6022463,28.5431156 32.3614201,28.7524627 L32.3614201,28.7524627 L31.3548629,29.6274495 C31.1140367,29.8367965 30.7490991,29.8112776 30.5397521,29.5704514 C30.3304051,29.3296252 30.355924,28.9646877 30.5967502,28.7553406 L30.5967502,28.7553406 Z M30.0234257,26.0629078 C30.2642519,25.8535608 30.6291895,25.8790797 30.8385365,26.1199059 C31.0478835,26.3607321 31.0223646,26.7256697 30.7815384,26.9350167 L30.7815384,26.9350167 L29.7749812,27.8100035 C29.534155,28.0193505 29.1692175,27.9938316 28.9598704,27.7530054 C28.7505234,27.5121792 28.7760423,27.1472417 29.0168685,26.9378947 L29.0168685,26.9378947 Z M14.4611768,6.59385378 L15.8940814,8.1851985 C19.2291707,6.39799719 23.4242322,7.16465549 25.9059888,10.1222979 C28.7784355,13.5455465 28.3319222,18.6492158 24.9086736,21.5216625 C21.485425,24.3941091 16.3817557,23.9475959 13.509309,20.5243473 C11.0782624,17.6271387 10.9994545,13.4689771 13.2094097,10.49919 L11.7874796,8.9195719 C8.74507635,12.6725827 8.75546051,18.1131337 11.9069271,21.8689054 C15.2697606,25.8765743 21.1134012,26.673523 25.4103236,23.7604801 L25.9317093,23.4070134 L26.2172611,23.9684775 C26.2373022,24.0078832 26.2619971,24.0452558 26.2913694,24.0802604 L27.0126069,24.9401517 L27.0387384,24.917863 L27.8187384,24.262863 L27.9100249,24.1874143 L27.1882257,23.3275615 C27.1591303,23.2928871 27.1274705,23.2629828 27.0939679,23.238129 L26.5846408,22.8602872 L27.0262192,22.4051091 C30.6412965,18.6786943 30.8712218,12.7854296 27.5083707,8.77773977 C24.2613601,4.90810321 18.7053256,4.0344175 14.4611768,6.59385378 Z M20.9147156,10.4070335 C21.5963979,10.4070335 22.1507668,10.9634652 22.1507668,11.6476839 L22.1507668,11.6476839 L22.1507668,12.8883344 L23.3868181,12.8883344 C24.0685003,12.8883344 24.6228693,13.4447661 24.6228693,14.1289848 L24.6228693,14.1289848 L24.6228693,16.6102856 C24.6228693,17.2945043 24.0685003,17.850936 23.3868181,17.850936 L23.3868181,17.850936 L22.1507668,17.850936 L22.1507668,19.0915864 C22.1507668,19.7758051 21.5963979,20.3322369 20.9147156,20.3322369 L20.9147156,20.3322369 L18.4426132,20.3322369 C17.760931,20.3322369 17.206562,19.7758051 17.206562,19.0915864 L17.206562,19.0915864 L17.206562,17.850936 L15.9705108,17.850936 C15.2888286,17.850936 14.7344596,17.2945043 14.7344596,16.6102856 L14.7344596,16.6102856 L14.7344596,14.1289848 C14.7344596,13.4447661 15.2888286,12.8883344 15.9705108,12.8883344 L15.9705108,12.8883344 L17.206562,12.8883344 L17.206562,11.6476839 C17.206562,10.9634652 17.760931,10.4070335 18.4426132,10.4070335 L18.4426132,10.4070335 Z M20.9147156,11.5625891 L18.4426132,11.5625891 C18.4000894,11.5625891 18.3621176,11.6007022 18.3621176,11.6476839 L18.3621176,11.6476839 L18.3621176,14.0438899 L15.9705108,14.0438899 C15.927987,14.0438899 15.8900152,14.082003 15.8900152,14.1289848 L15.8900152,14.1289848 L15.8900152,16.6102856 C15.8900152,16.6572674 15.927987,16.6953805 15.9705108,16.6953805 L15.9705108,16.6953805 L18.3621176,16.6953805 L18.3621176,19.0915864 C18.3621176,19.1385682 18.4000894,19.1766813 18.4426132,19.1766813 L18.4426132,19.1766813 L20.9147156,19.1766813 C20.9572395,19.1766813 20.9952113,19.1385682 20.9952113,19.0915864 L20.9952113,19.0915864 L20.9952113,16.6953805 L23.3868181,16.6953805 C23.4293419,16.6953805 23.4673137,16.6572674 23.4673137,16.6102856 L23.4673137,16.6102856 L23.4673137,14.1289848 C23.4673137,14.082003 23.4293419,14.0438899 23.3868181,14.0438899 L23.3868181,14.0438899 L20.9952113,14.0438899 L20.9952113,11.6476839 C20.9952113,11.6007022 20.9572395,11.5625891 20.9147156,11.5625891 L20.9147156,11.5625891 Z',
                                    id: 'Combined-Shape',
                                    tabindex: '-1',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/edit',
                                tabindex: '-1',
                                transform: 'translate(23.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'video-copy',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 927.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-413.000000, -927.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-provider_search',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Provider Search',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '5B238D94-5D60-461F-AB2C-5EF70636D267',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M19.7247244,0.0683188134 C19.8925742,-0.0227723747 20.0953785,-0.0227729721 20.2632289,0.0683172272 L20.2632289,0.0683172272 L39.4406004,10.4756287 C39.6214923,10.5737964 39.7340619,10.7625598 39.7340619,10.9677224 L39.7340619,10.9677224 L39.7340619,13.4471061 C39.7340619,13.8723884 39.2770704,14.142692 38.9020988,13.9391998 L38.9020988,13.9391998 L38.4155064,13.675 L38.4155434,35.440312 C38.4155434,35.7185084 38.2118933,35.9492986 37.9450696,35.9926746 L37.8539813,36 L2.05858703,36 C1.74844483,36 1.49702489,35.7494192 1.49702489,35.440312 L1.49702489,35.440312 L1.49650638,13.715 L1.01046077,13.9796771 C0.66227309,14.1686261 0.243371241,13.9490541 0.185304587,13.5762214 L0.178506375,13.4875786 L0.178506375,11.0087815 C0.178506375,10.8036201 0.291074708,10.6148576 0.471965016,10.5166894 L0.471965016,10.5166894 Z M19.9939724,3.67800419 L2.61950638,13.105 L2.62014918,34.880624 L37.2924191,34.880624 L37.2915064,13.065 L19.9939724,3.67800419 Z M19.9565769,11.8536585 C25.5390481,11.8536585 30.0649261,16.3745754 30.0649261,21.9515119 C30.0649261,27.5279594 25.5389523,32.0487805 19.9565769,32.0487805 C14.3737119,32.0487805 9.84764218,27.5280551 9.84764218,21.9515119 C9.84764218,16.3744796 14.373616,11.8536585 19.9565769,11.8536585 Z M5.35917999,29.8536585 C5.6534962,29.8536585 5.89208662,30.1484954 5.89208662,30.5121951 C5.89208662,30.8758948 5.6534962,31.1707317 5.35917999,31.1707317 L5.35917999,31.1707317 L4.22746239,31.1707317 C3.93314618,31.1707317 3.69455576,30.8758948 3.69455576,30.5121951 C3.69455576,30.1484954 3.93314618,29.8536585 4.22746239,29.8536585 L4.22746239,29.8536585 Z M35.6851059,29.8536585 C35.9794221,29.8536585 36.2180125,30.1484954 36.2180125,30.5121951 C36.2180125,30.8758948 35.9794221,31.1707317 35.6851059,31.1707317 L35.6851059,31.1707317 L34.5533883,31.1707317 C34.2590721,31.1707317 34.0204817,30.8758948 34.0204817,30.5121951 C34.0204817,30.1484954 34.2590721,29.8536585 34.5533883,29.8536585 L34.5533883,29.8536585 Z M19.9565769,12.9710401 C14.9913955,12.9710401 10.96625,16.991603 10.96625,21.9515119 C10.96625,26.9109211 14.9914807,30.9313989 19.9565769,30.9313989 C24.9211729,30.9313989 28.9463183,26.910836 28.9463183,21.9515119 C28.9463183,16.9916882 24.9212581,12.9710401 19.9565769,12.9710401 Z M21.4530101,15.3658537 C21.7601939,15.3658537 22.0092156,15.6146134 22.0092156,15.921474 L22.0092156,15.921474 L22.0092156,19.9007387 L25.9926712,19.9007387 C26.299855,19.9007387 26.5488767,20.1494984 26.5488767,20.456359 L26.5488767,20.456359 L26.5488767,23.4466615 C26.5488767,23.7535222 26.299855,24.0022819 25.9926712,24.0022819 L25.9926712,24.0022819 L22.0092156,24.0022819 L22.0092156,27.980965 C22.0092156,28.2878257 21.7601939,28.5365854 21.4530101,28.5365854 L21.4530101,28.5365854 L18.4595582,28.5365854 C18.1523744,28.5365854 17.9033527,28.2878257 17.9033527,27.980965 L17.9033527,27.980965 L17.9033527,24.0022819 L13.9198971,24.0022819 C13.6127133,24.0022819 13.3636916,23.7535222 13.3636916,23.4466615 L13.3636916,23.4466615 L13.3636916,20.456359 C13.3636916,20.1494984 13.6127133,19.9007387 13.9198971,19.9007387 L13.9198971,19.9007387 L17.9033527,19.9007387 L17.9033527,15.921474 C17.9033527,15.6146134 18.1523744,15.3658537 18.4595582,15.3658537 L18.4595582,15.3658537 Z M5.35917999,26.3414634 C5.6534962,26.3414634 5.89208662,26.6363003 5.89208662,27 C5.89208662,27.3636997 5.6534962,27.6585366 5.35917999,27.6585366 L5.35917999,27.6585366 L4.22746239,27.6585366 C3.93314618,27.6585366 3.69455576,27.3636997 3.69455576,27 C3.69455576,26.6363003 3.93314618,26.3414634 4.22746239,26.3414634 L4.22746239,26.3414634 Z M35.6851059,26.3414634 C35.9794221,26.3414634 36.2180125,26.6363003 36.2180125,27 C36.2180125,27.3636997 35.9794221,27.6585366 35.6851059,27.6585366 L35.6851059,27.6585366 L34.5533883,27.6585366 C34.2590721,27.6585366 34.0204817,27.3636997 34.0204817,27 C34.0204817,26.6363003 34.2590721,26.3414634 34.5533883,26.3414634 L34.5533883,26.3414634 Z M20.8968046,16.4770944 L19.0157638,16.4770944 L19.0157638,20.456359 C19.0157638,20.7632197 18.7667421,21.0119794 18.4595582,21.0119794 L18.4595582,21.0119794 L14.4761026,21.0119794 L14.4761026,22.8910412 L18.4595582,22.8910412 C18.7667421,22.8910412 19.0157638,23.1398009 19.0157638,23.4466615 L19.0157638,23.4466615 L19.0157638,27.4253447 L20.8968046,27.4253447 L20.8968046,23.4466615 C20.8968046,23.1398009 21.1458263,22.8910412 21.4530101,22.8910412 L21.4530101,22.8910412 L25.4364657,22.8910412 L25.4364657,21.0119794 L21.4530101,21.0119794 C21.1458263,21.0119794 20.8968046,20.7632197 20.8968046,20.456359 L20.8968046,20.456359 L20.8968046,16.4770944 Z M5.35917999,23.2682927 C5.6534962,23.2682927 5.89208662,23.5631296 5.89208662,23.9268293 C5.89208662,24.290529 5.6534962,24.5853659 5.35917999,24.5853659 L5.35917999,24.5853659 L4.22746239,24.5853659 C3.93314618,24.5853659 3.69455576,24.290529 3.69455576,23.9268293 C3.69455576,23.5631296 3.93314618,23.2682927 4.22746239,23.2682927 L4.22746239,23.2682927 Z M35.6851059,23.2682927 C35.9794221,23.2682927 36.2180125,23.5631296 36.2180125,23.9268293 C36.2180125,24.290529 35.9794221,24.5853659 35.6851059,24.5853659 L35.6851059,24.5853659 L34.5533883,24.5853659 C34.2590721,24.5853659 34.0204817,24.290529 34.0204817,23.9268293 C34.0204817,23.5631296 34.2590721,23.2682927 34.5533883,23.2682927 L34.5533883,23.2682927 Z M5.35917999,20.6341463 C5.6534962,20.6341463 5.89208662,20.9289832 5.89208662,21.2926829 C5.89208662,21.6563826 5.6534962,21.9512195 5.35917999,21.9512195 L5.35917999,21.9512195 L4.22746239,21.9512195 C3.93314618,21.9512195 3.69455576,21.6563826 3.69455576,21.2926829 C3.69455576,20.9289832 3.93314618,20.6341463 4.22746239,20.6341463 L4.22746239,20.6341463 Z M35.6851059,20.6341463 C35.9794221,20.6341463 36.2180125,20.9289832 36.2180125,21.2926829 C36.2180125,21.6563826 35.9794221,21.9512195 35.6851059,21.9512195 L35.6851059,21.9512195 L34.5533883,21.9512195 C34.2590721,21.9512195 34.0204817,21.6563826 34.0204817,21.2926829 C34.0204817,20.9289832 34.2590721,20.6341463 34.5533883,20.6341463 L34.5533883,20.6341463 Z M5.35917999,17.1219512 C5.6534962,17.1219512 5.89208662,17.4167881 5.89208662,17.7804878 C5.89208662,18.1441875 5.6534962,18.4390244 5.35917999,18.4390244 L5.35917999,18.4390244 L4.22746239,18.4390244 C3.93314618,18.4390244 3.69455576,18.1441875 3.69455576,17.7804878 C3.69455576,17.4167881 3.93314618,17.1219512 4.22746239,17.1219512 L4.22746239,17.1219512 Z M35.6851059,17.1219512 C35.9794221,17.1219512 36.2180125,17.4167881 36.2180125,17.7804878 C36.2180125,18.1441875 35.9794221,18.4390244 35.6851059,18.4390244 L35.6851059,18.4390244 L34.5533883,18.4390244 C34.2590721,18.4390244 34.0204817,18.1441875 34.0204817,17.7804878 C34.0204817,17.4167881 34.2590721,17.1219512 34.5533883,17.1219512 L34.5533883,17.1219512 Z M5.35917999,14.0487805 C5.6534962,14.0487805 5.89208662,14.3436174 5.89208662,14.7073171 C5.89208662,15.0710168 5.6534962,15.3658537 5.35917999,15.3658537 L5.35917999,15.3658537 L4.22746239,15.3658537 C3.93314618,15.3658537 3.69455576,15.0710168 3.69455576,14.7073171 C3.69455576,14.3436174 3.93314618,14.0487805 4.22746239,14.0487805 L4.22746239,14.0487805 Z M35.6851059,14.0487805 C35.9794221,14.0487805 36.2180125,14.3436174 36.2180125,14.7073171 C36.2180125,15.0710168 35.9794221,15.3658537 35.6851059,15.3658537 L35.6851059,15.3658537 L34.5533883,15.3658537 C34.2590721,15.3658537 34.0204817,15.0710168 34.0204817,14.7073171 C34.0204817,14.3436174 34.2590721,14.0487805 34.5533883,14.0487805 L34.5533883,14.0487805 Z M19.99398,1.19862457 L1.30393106,11.3416151 L1.30393106,12.5440083 L19.724736,2.54769621 C19.8925838,2.45661121 20.0953827,2.456613 20.2632289,2.54770095 L20.2632289,2.54770095 L38.6086372,12.5035168 L38.6086372,11.3005583 L19.99398,1.19862457 Z',
                                        id: 'Combined-Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Group-23',
                                    tabindex: '-1',
                                    transform: 'translate(0.000000, 2.222222)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/edit',
                                tabindex: '-1',
                                transform: 'translate(23.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'video-copy-9',
                            tabindex: '-1',
                            transform: 'translate(1302.000000, 827.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1325.000000, -827.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-nursing_facility',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Nursing Facility',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'BDB84DA7-6B1A-40D1-90B4-B2909DA9FE12',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M37.5412456,0.122746667 C37.8603434,0.122746667 38.1190234,0.381426589 38.1190234,0.700524444 L38.1190234,0.700524444 L38.1190234,5.02132444 C38.1190234,5.3404223 37.8603434,5.59910222 37.5412456,5.59910222 L37.5412456,5.59910222 L26.8217789,5.59910222 L26.8217789,9.77532276 L26.9855853,9.67199414 C28.3079082,8.8589731 29.9117971,8.37470222 31.5562678,8.37470222 C36.1372471,8.37470222 39.71329,11.7462432 39.71329,16.6021244 C39.71329,21.9072096 35.7164196,25.32528 29.6794234,25.32528 C25.5906909,25.32528 22.3888015,24.0294623 20.152446,21.5970398 C19.9583105,21.385884 19.9484788,21.0642736 20.1293535,20.8416536 L20.1293535,20.8416536 L22.8915758,17.4419202 C23.1091804,17.1740932 23.5115057,17.1554918 23.7528951,17.4020972 C25.2696233,18.9515999 27.3154027,19.7785244 29.6442234,19.7785244 C32.0089679,19.7785244 33.4576456,18.5354144 33.4576456,16.8147911 C33.4576456,14.9457337 32.1209422,13.7801689 29.7855122,13.7801689 C27.9605315,13.7801689 26.5168542,14.3419341 25.2251377,15.5690202 C25.0786437,15.7081844 24.8700937,15.7607098 24.675158,15.7075382 L24.675158,15.7075382 L21.1693358,14.7512715 C20.9179768,14.6827095 20.7436011,14.4543997 20.7436011,14.1938578 L20.7436011,14.1938578 L20.7436011,0.700524444 C20.7436011,0.381426589 21.0022811,0.122746667 21.3213789,0.122746667 L21.3213789,0.122746667 Z M19.4375333,0.122746667 C19.7566312,0.122746667 20.0153111,0.381426589 20.0153111,0.700524444 L20.0153111,0.700524444 L20.0153111,5.12741333 C20.0153111,5.44651119 19.7566312,5.70519111 19.4375333,5.70519111 L19.4375333,5.70519111 L13.1444667,5.70519111 L13.1444667,24.3226578 C13.1444667,24.6417556 12.8857867,24.9004356 12.5666889,24.9004356 L12.5666889,24.9004356 L7.50228889,24.9004356 C7.18319103,24.9004356 6.92451111,24.6417556 6.92451111,24.3226578 L6.92451111,24.3226578 L6.92451111,5.70519111 L0.596244444,5.70519111 C0.277146589,5.70519111 0.0184666667,5.44651119 0.0184666667,5.12741333 L0.0184666667,5.12741333 L0.0184666667,0.700524444 C0.0184666667,0.381426589 0.277146589,0.122746667 0.596244444,0.122746667 L0.596244444,0.122746667 Z M36.9634678,1.27830222 L21.8991567,1.27830222 L21.8991567,13.7525697 L24.671981,14.5089 C26.1235083,13.2278876 27.7805076,12.6246133 29.7855122,12.6246133 C32.7266201,12.6246133 34.6132011,14.2696548 34.6132011,16.8147911 C34.6132011,19.2162114 32.6112562,20.93408 29.6442234,20.93408 C27.2395288,20.93408 25.0758192,20.1440985 23.3946345,18.6552732 L23.3946345,18.6552732 L21.3492224,21.172759 L21.4860887,21.3046073 C23.4653002,23.1741298 26.195394,24.1697244 29.6794234,24.1697244 C35.1148382,24.1697244 38.5577345,21.2254053 38.5577345,16.6021244 C38.5577345,12.4001487 35.5137693,9.53025778 31.5562678,9.53025778 C29.6991169,9.53025778 27.8925822,10.2476392 26.6270718,11.3684343 C26.2542329,11.6986379 25.6662234,11.4339416 25.6662234,10.9359022 L25.6662234,10.9359022 L25.6662234,5.02132444 C25.6662234,4.70222659 25.9249033,4.44354667 26.2440011,4.44354667 L26.2440011,4.44354667 L36.9634678,4.44354667 L36.9634678,1.27830222 Z M18.8597556,1.27830222 L1.17402222,1.27830222 L1.17402222,4.54963556 L7.50228889,4.54963556 C7.82138674,4.54963556 8.08006667,4.80831548 8.08006667,5.12741333 L8.08006667,5.12741333 L8.08006667,23.74488 L11.9889111,23.74488 L11.9889111,5.12741333 C11.9889111,4.80831548 12.247591,4.54963556 12.5666889,4.54963556 L12.5666889,4.54963556 L18.8597556,4.54963556 L18.8597556,1.27830222 Z M10.1673733,21.3419911 C10.4864712,21.3419911 10.7451511,21.600671 10.7451511,21.9197689 C10.7451511,22.2388667 10.4864712,22.4975467 10.1673733,22.4975467 L10.1673733,22.4975467 L9.17541778,22.4975467 C8.85631992,22.4975467 8.59764,22.2388667 8.59764,21.9197689 C8.59764,21.600671 8.85631992,21.3419911 9.17541778,21.3419911 L9.17541778,21.3419911 Z M10.1673733,18.7294667 C10.4864712,18.7294667 10.7451511,18.9881466 10.7451511,19.3072444 C10.7451511,19.6263423 10.4864712,19.8850222 10.1673733,19.8850222 L10.1673733,19.8850222 L9.17541778,19.8850222 C8.85631992,19.8850222 8.59764,19.6263423 8.59764,19.3072444 C8.59764,18.9881466 8.85631992,18.7294667 9.17541778,18.7294667 L9.17541778,18.7294667 Z M10.1673733,16.1174311 C10.4864712,16.1174311 10.7451511,16.376111 10.7451511,16.6952089 C10.7451511,17.0143067 10.4864712,17.2729867 10.1673733,17.2729867 L10.1673733,17.2729867 L9.17541778,17.2729867 C8.85631992,17.2729867 8.59764,17.0143067 8.59764,16.6952089 C8.59764,16.376111 8.85631992,16.1174311 9.17541778,16.1174311 L9.17541778,16.1174311 Z M10.1673733,13.5054444 C10.4864712,13.5054444 10.7451511,13.7641244 10.7451511,14.0832222 C10.7451511,14.4023201 10.4864712,14.661 10.1673733,14.661 L10.1673733,14.661 L9.17541778,14.661 C8.85631992,14.661 8.59764,14.4023201 8.59764,14.0832222 C8.59764,13.7641244 8.85631992,13.5054444 9.17541778,13.5054444 L9.17541778,13.5054444 Z M24.6862843,10.1726921 C25.0053822,10.1726921 25.2640621,10.431372 25.2640621,10.7504699 C25.2640621,11.0695677 25.0053822,11.3282476 24.6862843,11.3282476 L24.6862843,11.3282476 L23.6948177,11.3282476 C23.3757198,11.3282476 23.1170399,11.0695677 23.1170399,10.7504699 C23.1170399,10.431372 23.3757198,10.1726921 23.6948177,10.1726921 L23.6948177,10.1726921 Z M24.6862843,7.56065653 C25.0053822,7.56065653 25.2640621,7.81933645 25.2640621,8.13843431 C25.2640621,8.45753216 25.0053822,8.71621208 24.6862843,8.71621208 L24.6862843,8.71621208 L23.6948177,8.71621208 C23.3757198,8.71621208 23.1170399,8.45753216 23.1170399,8.13843431 C23.1170399,7.81933645 23.3757198,7.56065653 23.6948177,7.56065653 L23.6948177,7.56065653 Z M24.6862843,4.94837653 C25.0053822,4.94837653 25.2640621,5.20705645 25.2640621,5.52615431 C25.2640621,5.84525216 25.0053822,6.10393208 24.6862843,6.10393208 L24.6862843,6.10393208 L23.6948177,6.10393208 C23.3757198,6.10393208 23.1170399,5.84525216 23.1170399,5.52615431 C23.1170399,5.20705645 23.3757198,4.94837653 23.6948177,4.94837653 L23.6948177,4.94837653 Z M32.0672687,1.84041208 C32.3863666,1.84041208 32.6450465,2.09909201 32.6450465,2.41818986 L32.6450465,2.41818986 L32.6450465,3.41014542 C32.6450465,3.72924327 32.3863666,3.98792319 32.0672687,3.98792319 C31.7481708,3.98792319 31.4894909,3.72924327 31.4894909,3.41014542 L31.4894909,3.41014542 L31.4894909,2.41818986 C31.4894909,2.09909201 31.7481708,1.84041208 32.0672687,1.84041208 Z M29.4552331,1.84041208 C29.774331,1.84041208 30.0330109,2.09909201 30.0330109,2.41818986 L30.0330109,2.41818986 L30.0330109,3.41014542 C30.0330109,3.72924327 29.774331,3.98792319 29.4552331,3.98792319 C29.1361353,3.98792319 28.8774554,3.72924327 28.8774554,3.41014542 L28.8774554,3.41014542 L28.8774554,2.41818986 C28.8774554,2.09909201 29.1361353,1.84041208 29.4552331,1.84041208 Z M26.8431976,1.84041208 C27.1622954,1.84041208 27.4209754,2.09909201 27.4209754,2.41818986 L27.4209754,2.41818986 L27.4209754,3.41014542 C27.4209754,3.72924327 27.1622954,3.98792319 26.8431976,3.98792319 C26.5240997,3.98792319 26.2654198,3.72924327 26.2654198,3.41014542 L26.2654198,3.41014542 L26.2654198,2.41818986 C26.2654198,2.09909201 26.5240997,1.84041208 26.8431976,1.84041208 Z M24.6862843,2.33638986 C25.0053822,2.33638986 25.2640621,2.59506978 25.2640621,2.91416764 C25.2640621,3.23326549 25.0053822,3.49194542 24.6862843,3.49194542 L24.6862843,3.49194542 L23.6948177,3.49194542 C23.3757198,3.49194542 23.1170399,3.23326549 23.1170399,2.91416764 C23.1170399,2.59506978 23.3757198,2.33638986 23.6948177,2.33638986 L23.6948177,2.33638986 Z',
                                        id: 'Combined-Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Group-15',
                                    tabindex: '-1',
                                    transform: 'translate(0.000000, 7.333333)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/edit',
                                tabindex: '-1',
                                transform: 'translate(23.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'video-copy-7',
                            tabindex: '-1',
                            transform: 'translate(1074.000000, 827.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1097.000000, -827.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-tier_5',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Tier 5',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '7717AFE5-4332-4ED7-8064-9A65B166CC90',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M19.7470048,0.105446399 C20.0661026,0.105446399 20.3247826,0.364126322 20.3247826,0.683224177 L20.3247826,0.683224177 L20.3247826,5.18523504 C20.3247826,5.5043329 20.0661026,5.76301282 19.7470048,5.76301282 L19.7470048,5.76301282 L13.3373435,5.76301282 L13.3373435,24.7062127 C13.3373435,25.0253105 13.0786636,25.2839905 12.7595657,25.2839905 L12.7595657,25.2839905 L7.60922552,25.2839905 C7.29012766,25.2839905 7.03144774,25.0253105 7.03144774,24.7062127 L7.03144774,24.7062127 L7.03144774,5.76301282 L0.585989131,5.76301282 C0.266891276,5.76301282 0.00821135351,5.5043329 0.00821135351,5.18523504 L0.00821135351,5.18523504 L0.00821135351,0.683224177 C0.00821135351,0.364126322 0.266891276,0.105446399 0.585989131,0.105446399 L0.585989131,0.105446399 Z M34.932977,0.105446399 C35.2321312,0.105446399 35.4781837,0.3328018 35.5077717,0.624149756 L35.5107547,0.683224177 L35.5107547,14.6560648 L38.03044,14.6560648 C38.3295942,14.6560648 38.5756468,14.8834202 38.6052348,15.1747682 L38.6082178,15.2338426 L38.6082178,19.7358535 C38.6082178,20.0350077 38.3808624,20.2810603 38.0895144,20.3106483 L38.03044,20.3136313 L35.5107547,20.3136313 L35.5107547,24.7062127 C35.5107547,25.0053669 35.2833993,25.2514195 34.9920514,25.2810075 L34.932977,25.2839905 L29.8189313,25.2839905 C29.519777,25.2839905 29.2737245,25.0566351 29.2441365,24.7652871 L29.2411535,24.7062127 L29.2411535,20.3136313 L18.3294813,20.3136313 C18.0303271,20.3136313 17.7842746,20.0862759 17.7546866,19.7949279 L17.7517036,19.7358535 L17.7517036,15.702191 C17.7517036,15.614381 17.7717135,15.5280244 17.8098596,15.4495631 L17.8418405,15.3922982 L27.3863024,0.373331378 C27.480543,0.225036377 27.6363579,0.128714728 27.8086496,0.109140719 L27.8739433,0.105446399 L34.932977,0.105446399 Z M19.169227,1.26100195 L1.16376691,1.26100195 L1.16376691,4.60745726 L7.60922552,4.60745726 C7.92832337,4.60745726 8.18700329,4.86613719 8.18700329,5.18523504 L8.18700329,5.18523504 L8.18700329,24.1284349 L12.1817879,24.1284349 L12.1817879,5.18523504 C12.1817879,4.86613719 12.4404679,4.60745726 12.7595657,4.60745726 L12.7595657,4.60745726 L19.169227,4.60745726 L19.169227,1.26100195 Z M34.3551992,1.26100195 L28.1913448,1.26100195 L18.9072591,15.8702462 L18.9072591,19.1580757 L29.8189313,19.1580757 C30.1180855,19.1580757 30.364138,19.3854311 30.393726,19.6767791 L30.396709,19.7358535 L30.396709,24.1284349 L34.3551992,24.1284349 L34.3551992,19.7358535 C34.3551992,19.4366992 34.5825546,19.1906467 34.8739025,19.1610587 L34.932977,19.1580757 L37.4526622,19.1580757 L37.4526622,15.8116204 L34.932977,15.8116204 C34.6338227,15.8116204 34.3877702,15.584265 34.3581822,15.292917 L34.3551992,15.2338426 L34.3551992,1.26100195 Z M33.0022052,21.6914977 C33.3213031,21.6914977 33.579983,21.9501776 33.579983,22.2692755 C33.579983,22.5883733 33.3213031,22.8470532 33.0022052,22.8470532 L33.0022052,22.8470532 L31.9939139,22.8470532 C31.674816,22.8470532 31.4161361,22.5883733 31.4161361,22.2692755 C31.4161361,21.9501776 31.674816,21.6914977 31.9939139,21.6914977 L31.9939139,21.6914977 Z M10.7715215,21.6847703 C11.0906193,21.6847703 11.3492993,21.9434502 11.3492993,22.262548 C11.3492993,22.5816459 11.0906193,22.8403258 10.7715215,22.8403258 L10.7715215,22.8403258 L9.76273295,22.8403258 C9.4436351,22.8403258 9.18495518,22.5816459 9.18495518,22.262548 C9.18495518,21.9434502 9.4436351,21.6847703 9.76273295,21.6847703 L9.76273295,21.6847703 Z M33.0022052,19.0346401 C33.3213031,19.0346401 33.579983,19.29332 33.579983,19.6124179 C33.579983,19.9315157 33.3213031,20.1901956 33.0022052,20.1901956 L33.0022052,20.1901956 L31.9939139,20.1901956 C31.674816,20.1901956 31.4161361,19.9315157 31.4161361,19.6124179 C31.4161361,19.29332 31.674816,19.0346401 31.9939139,19.0346401 L31.9939139,19.0346401 Z M10.7715215,19.0279126 C11.0906193,19.0279126 11.3492993,19.2865926 11.3492993,19.6056904 C11.3492993,19.9247883 11.0906193,20.1834682 10.7715215,20.1834682 L10.7715215,20.1834682 L9.76273295,20.1834682 C9.4436351,20.1834682 9.18495518,19.9247883 9.18495518,19.6056904 C9.18495518,19.2865926 9.4436351,19.0279126 9.76273295,19.0279126 L9.76273295,19.0279126 Z M29.7662135,16.3715522 C30.0853114,16.3715522 30.3439913,16.6302321 30.3439913,16.94933 L30.3439913,16.94933 L30.3439913,17.9581185 C30.3439913,18.2772164 30.0853114,18.5358963 29.7662135,18.5358963 C29.4471157,18.5358963 29.1884358,18.2772164 29.1884358,17.9581185 L29.1884358,17.9581185 L29.1884358,16.94933 C29.1884358,16.6302321 29.4471157,16.3715522 29.7662135,16.3715522 Z M27.1098531,16.3715522 C27.428951,16.3715522 27.6876309,16.6302321 27.6876309,16.94933 L27.6876309,16.94933 L27.6876309,17.9581185 C27.6876309,18.2772164 27.428951,18.5358963 27.1098531,18.5358963 C26.7907552,18.5358963 26.5320753,18.2772164 26.5320753,17.9581185 L26.5320753,17.9581185 L26.5320753,16.94933 C26.5320753,16.6302321 26.7907552,16.3715522 27.1098531,16.3715522 Z M24.4529955,16.3715522 C24.7720933,16.3715522 25.0307733,16.6302321 25.0307733,16.94933 L25.0307733,16.94933 L25.0307733,17.9581185 C25.0307733,18.2772164 24.7720933,18.5358963 24.4529955,18.5358963 C24.1338976,18.5358963 23.8752177,18.2772164 23.8752177,17.9581185 L23.8752177,17.9581185 L23.8752177,16.94933 C23.8752177,16.6302321 24.1338976,16.3715522 24.4529955,16.3715522 Z M21.7966848,16.3715522 C22.1157826,16.3715522 22.3744626,16.6302321 22.3744626,16.94933 L22.3744626,16.94933 L22.3744626,17.9581185 C22.3744626,18.2772164 22.1157826,18.5358963 21.7966848,18.5358963 C21.4775869,18.5358963 21.218907,18.2772164 21.218907,17.9581185 L21.218907,17.9581185 L21.218907,16.94933 C21.218907,16.6302321 21.4775869,16.3715522 21.7966848,16.3715522 Z M33.0022052,16.3782797 C33.3213031,16.3782797 33.579983,16.6369596 33.579983,16.9560574 C33.579983,17.2751553 33.3213031,17.5338352 33.0022052,17.5338352 L33.0022052,17.5338352 L31.9939139,17.5338352 C31.674816,17.5338352 31.4161361,17.2751553 31.4161361,16.9560574 C31.4161361,16.6369596 31.674816,16.3782797 31.9939139,16.3782797 L31.9939139,16.3782797 Z M10.7715215,16.3715522 C11.0906193,16.3715522 11.3492993,16.6302321 11.3492993,16.94933 C11.3492993,17.2684279 11.0906193,17.5271078 10.7715215,17.5271078 L10.7715215,17.5271078 L9.76273295,17.5271078 C9.4436351,17.5271078 9.18495518,17.2684279 9.18495518,16.94933 C9.18495518,16.6302321 9.4436351,16.3715522 9.76273295,16.3715522 L9.76273295,16.3715522 Z M30.396709,5.22152955 L30.396709,15.2338426 C30.396709,15.5529405 30.1380291,15.8116204 29.8189313,15.8116204 L23.3356379,15.8116204 C22.8776599,15.8116204 22.6017323,15.304224 22.8506576,14.9198023 L29.333951,4.90748929 C29.6468396,4.42428747 30.396709,4.64587053 30.396709,5.22152955 Z M33.0022052,13.7219689 C33.3213031,13.7219689 33.579983,13.9806489 33.579983,14.2997467 C33.579983,14.6188446 33.3213031,14.8775245 33.0022052,14.8775245 L33.0022052,14.8775245 L31.9939139,14.8775245 C31.674816,14.8775245 31.4161361,14.6188446 31.4161361,14.2997467 C31.4161361,13.9806489 31.674816,13.7219689 31.9939139,13.7219689 L31.9939139,13.7219689 Z M10.7715215,13.7152415 C11.0906193,13.7152415 11.3492993,13.9739214 11.3492993,14.2930193 C11.3492993,14.6121171 11.0906193,14.8707971 10.7715215,14.8707971 L10.7715215,14.8707971 L9.76273295,14.8707971 C9.4436351,14.8707971 9.18495518,14.6121171 9.18495518,14.2930193 C9.18495518,13.9739214 9.4436351,13.7152415 9.76273295,13.7152415 L9.76273295,13.7152415 Z M29.2411535,7.17681382 L24.3980989,14.6560648 L29.2411535,14.6560648 L29.2411535,7.17681382 Z',
                                        id: 'Combined-Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Group-15',
                                    tabindex: '-1',
                                    transform: 'translate(0.590038, 7.333333)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/edit',
                                tabindex: '-1',
                                transform: 'translate(23.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'video-copy-6',
                            tabindex: '-1',
                            transform: 'translate(960.000000, 827.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-983.000000, -827.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-tier_4',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Tier 4',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '1102CEDA-AF11-4844-A178-9B247C7A527C',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M29.5513072,0.250108932 C35.2355396,0.250108932 38.8787582,2.87778162 38.8787582,7.11202614 C38.8787582,9.43177878 37.4258204,11.3352921 35.3207441,12.3311184 L35.3207441,12.3311184 L35.4489468,12.3862237 C37.6175493,13.3438656 39.2262527,15.3617614 39.2262527,17.9452288 C39.2262527,22.3507056 35.2918439,25.3281481 29.5167974,25.3281481 C25.3745504,25.3281481 21.9157032,23.8236272 19.9375594,21.4006937 C19.7656667,21.1901505 19.7637617,20.8882675 19.9329838,20.6755718 L19.9329838,20.6755718 L22.5020469,17.4465086 C22.7199043,17.172683 23.1292342,17.1538303 23.3713392,17.4064712 C24.8148379,18.9127872 27.1736683,19.8674946 29.3428105,19.8674946 C31.7928528,19.8674946 33.1396296,18.9143341 33.1396296,17.4592157 C33.1396296,15.9721329 31.9980683,15.2934641 29.0648148,15.2934641 L29.0648148,15.2934641 L26.9598409,15.3026191 C26.6825952,15.3066014 26.4740009,15.311945 26.3446031,15.3187044 L26.3446031,15.3187044 L26.1824106,15.3289911 C25.8676427,15.3290439 25.6054684,15.073348 25.6054684,14.7511547 L25.6054684,14.7511547 L25.6054684,10.4455773 C25.6054684,10.1076852 25.8941585,9.84189984 26.2308994,9.86976806 C26.4363013,9.88676683 27.0163701,9.89668326 27.8601476,9.90039084 L27.8601476,9.90039084 L29.2172723,9.90132047 C31.5313395,9.87102347 32.7581046,9.1459068 32.7581046,7.91102397 C32.7581046,6.56267833 31.3409923,5.71076253 29.030305,5.71076253 C26.9814318,5.71076253 25.0701397,6.50371599 23.527799,7.98081081 C23.2822584,8.21596429 22.8877535,8.18932046 22.6760617,7.9232867 L22.6760617,7.9232867 L20.2450377,4.86821045 C20.0703838,4.64872222 20.0786051,4.33549823 20.2645326,4.12547429 C22.4422867,1.66548053 25.6197889,0.250108932 29.5513072,0.250108932 Z M19.0655991,0.597028322 C19.384697,0.597028322 19.6433769,0.855708245 19.6433769,1.1748061 L19.6433769,1.1748061 L19.6433769,5.51489325 C19.6433769,5.8339911 19.384697,6.09267102 19.0655991,6.09267102 L19.0655991,6.09267102 L12.9072549,6.09267102 L12.9072549,24.3337603 C12.9072549,24.6528582 12.648575,24.9115381 12.3294771,24.9115381 L12.3294771,24.9115381 L7.36437908,24.9115381 C7.04528123,24.9115381 6.78660131,24.6528582 6.78660131,24.3337603 L6.78660131,24.3337603 L6.78660131,6.09267102 L0.593747277,6.09267102 C0.274649421,6.09267102 0.0159694989,5.8339911 0.0159694989,5.51489325 L0.0159694989,5.51489325 L0.0159694989,1.1748061 C0.0159694989,0.855708245 0.274649421,0.597028322 0.593747277,0.597028322 L0.593747277,0.597028322 Z M29.5513072,1.40566449 C26.1457986,1.40566449 23.4019746,2.54498536 21.4586333,4.53749369 L21.4586333,4.53749369 L23.1982235,6.72364273 C24.8675908,5.31406993 26.8842079,4.55520697 29.030305,4.55520697 C31.8962359,4.55520697 33.9136601,5.76800824 33.9136601,7.91102397 C33.9136601,9.9853712 32.0309788,11.0578649 29.0648148,11.0578649 L29.0648148,11.0578649 L27.3911586,11.0530896 L26.761024,11.0450254 L26.761024,14.1500975 C27.0712055,14.1441469 27.4785851,14.1407937 27.9832266,14.1391513 L27.9832266,14.1391513 L29.237761,14.1387727 C32.6104277,14.1727838 34.2951852,15.211844 34.2951852,17.4592157 C34.2951852,19.6551834 32.3624453,21.0230501 29.3428105,21.0230501 C27.0899167,21.0230501 24.6836762,20.1315449 23.0124294,18.6610343 L23.0124294,18.6610343 L21.1363437,21.0190921 L21.2500551,21.1393999 C23.0557332,23.0092588 25.9948466,24.1725926 29.5167974,24.1725926 C34.712664,24.1725926 38.0706972,21.6313338 38.0706972,17.9452288 C38.0706972,15.2165506 35.8012126,13.235438 33.1726039,12.9643594 C32.505555,12.8955691 32.4714818,11.9365097 33.1319671,11.8205551 C35.7473672,11.3613962 37.7232026,9.48527842 37.7232026,7.11202614 C37.7232026,3.61251572 34.663445,1.40566449 29.5513072,1.40566449 Z M18.4878214,1.75258388 L1.17152505,1.75258388 L1.17152505,4.93711547 L7.36437908,4.93711547 C7.68347694,4.93711547 7.94215686,5.19579539 7.94215686,5.51489325 L7.94215686,5.51489325 L7.94215686,23.7559826 L11.7516993,23.7559826 L11.7516993,5.51489325 C11.7516993,5.19579539 12.0103793,4.93711547 12.3294771,4.93711547 L12.3294771,4.93711547 L18.4878214,4.93711547 L18.4878214,1.75258388 Z M28.6213334,21.6391173 C28.9102993,21.6277567 29.1573443,21.8519097 29.1718381,22.1424635 L29.1718381,22.1424635 L29.2197954,23.1695441 C29.2330545,23.4606988 29.0081583,23.7078801 28.7119168,23.7224985 C28.6515746,23.7243565 28.5925343,23.716354 28.535659,23.6987114 L28.535659,23.6987114 L28.4841979,23.6798607 C28.3005028,23.6015433 28.1735767,23.4241795 28.1634421,23.218097 L28.1634421,23.218097 L28.1154135,22.1904419 C28.1032172,21.8995677 28.3276223,21.6535388 28.6213334,21.6391173 Z M30.0147906,21.5787938 C30.2946652,21.502215 30.586046,21.6636542 30.6646658,21.9446727 L30.6646658,21.9446727 L30.9511376,22.9594342 C31.0294356,23.2405091 30.8662357,23.5320436 30.5843851,23.6112466 C30.4860469,23.6387321 30.3842819,23.636616 30.2883998,23.6080488 L30.2883998,23.6080488 L30.3708882,23.331187 L30.2850109,23.6070165 C30.1163257,23.5544977 29.9824831,23.4201694 29.932977,23.2457478 L29.932977,23.2457478 L29.6466316,22.2308699 C29.5680899,21.9501759 29.7317756,21.6586684 30.0147906,21.5787938 Z M27.1656647,21.453988 L27.2628618,21.4633354 C27.5429593,21.5225632 27.7319999,21.7936502 27.6783418,22.078637 L27.6783418,22.078637 L27.4925465,23.076072 C27.4384854,23.3624425 27.1632141,23.5519235 26.8715926,23.4977642 L26.8715926,23.4977642 L26.8149695,23.4831089 L26.8759695,23.2861089 L26.8138383,23.4826536 L26.7346619,23.4503723 C26.5291424,23.3464702 26.4100329,23.1171086 26.4531655,22.8814969 L26.4531655,22.8814969 L26.6389067,21.8846952 C26.6929609,21.5976019 26.9683039,21.4088668 27.2628618,21.4633354 Z M25.2515705,21.324784 C25.3701222,21.0617471 25.6721995,20.9466055 25.9496905,21.0576143 C26.2153012,21.1762463 26.3344121,21.487149 26.2177488,21.7550393 L26.2177488,21.7550393 L25.8079569,22.6826177 C25.6987844,22.9281286 25.4235013,23.052531 25.1686878,22.9739083 L25.1686878,22.9739083 L25.2519695,22.7011089 L25.1658212,22.9730075 L25.1109343,22.9521643 C24.8441859,22.8345197 24.7236935,22.5236193 24.8406245,22.255114 L24.8406245,22.255114 Z M10.4124575,21.4002092 C10.7315554,21.4002092 10.9902353,21.6588891 10.9902353,21.9779869 C10.9902353,22.2970848 10.7315554,22.5557647 10.4124575,22.5557647 L10.4124575,22.5557647 L9.44043137,22.5557647 C9.12133352,22.5557647 8.86265359,22.2970848 8.86265359,21.9779869 C8.86265359,21.6588891 9.12133352,21.4002092 9.44043137,21.4002092 L9.44043137,21.4002092 Z M23.9818206,20.5360914 C24.1572565,20.3050371 24.4874289,20.2609879 24.7230987,20.4340276 C24.9554995,20.6104858 25.0016259,20.942259 24.8251374,21.1742362 L24.8251374,21.1742362 L24.206213,21.9935475 C24.0711749,22.1733369 23.8387167,22.2460629 23.627709,22.180578 C23.5697379,22.162543 23.5153157,22.1344042 23.4663967,22.0975958 C23.2323591,21.921386 23.1860985,21.5895493 23.36274,21.3573729 L23.36274,21.3573729 Z M10.4124575,18.8389107 C10.7315554,18.8389107 10.9902353,19.0975906 10.9902353,19.4166885 C10.9902353,19.7357863 10.7315554,19.9944662 10.4124575,19.9944662 L10.4124575,19.9944662 L9.44043137,19.9944662 C9.12133352,19.9944662 8.86265359,19.7357863 8.86265359,19.4166885 C8.86265359,19.0975906 9.12133352,18.8389107 9.44043137,18.8389107 L9.44043137,18.8389107 Z M10.4124575,16.2780915 C10.7315554,16.2780915 10.9902353,16.5367714 10.9902353,16.8558693 C10.9902353,17.1749671 10.7315554,17.4336471 10.4124575,17.4336471 L10.4124575,17.4336471 L9.44043137,17.4336471 C9.12133352,17.4336471 8.86265359,17.1749671 8.86265359,16.8558693 C8.86265359,16.5367714 9.12133352,16.2780915 9.44043137,16.2780915 L9.44043137,16.2780915 Z M10.4124575,13.7173203 C10.7315554,13.7173203 10.9902353,13.9760002 10.9902353,14.295098 C10.9902353,14.6141959 10.7315554,14.8728758 10.4124575,14.8728758 L10.4124575,14.8728758 L9.44043137,14.8728758 C9.12133352,14.8728758 8.86265359,14.6141959 8.86265359,14.295098 C8.86265359,13.9760002 9.12133352,13.7173203 9.44043137,13.7173203 L9.44043137,13.7173203 Z',
                                        id: 'Combined-Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Group-21',
                                    tabindex: '-1',
                                    transform: 'translate(0.257310, 7.333333)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/edit',
                                tabindex: '-1',
                                transform: 'translate(23.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'video-copy-5',
                            tabindex: '-1',
                            transform: 'translate(846.000000, 827.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-869.000000, -827.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-tier_3',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Tier 3',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '42B3F209-C07E-4AF4-8B1F-87F93CF4A7E2',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M19.4190667,0.611635556 C19.7381645,0.611635556 19.9968444,0.870315478 19.9968444,1.18941333 L19.9968444,1.18941333 L19.9968444,5.61630222 C19.9968444,5.93540008 19.7381645,6.19408 19.4190667,6.19408 L19.4190667,6.19408 L13.126,6.19408 L13.126,24.8115467 C13.126,25.1306445 12.8673201,25.3893244 12.5482222,25.3893244 L12.5482222,25.3893244 L7.48382222,25.3893244 C7.16472437,25.3893244 6.90604444,25.1306445 6.90604444,24.8115467 L6.90604444,24.8115467 L6.90604444,6.19408 L0.577777778,6.19408 C0.258679922,6.19408 0,5.93540008 0,5.61630222 L0,5.61630222 L0,1.18941333 C0,0.870315478 0.258679922,0.611635556 0.577777778,0.611635556 L0.577777778,0.611635556 Z M30.1238667,0.25768 C35.668322,0.25768 39.7324,3.49348374 39.7324,8.37901333 C39.7324,12.1373058 37.1939642,15.4408727 31.2778786,19.80688 L31.2778786,19.80688 L39.3316,19.80688 C39.6506979,19.80688 39.9093778,20.0655599 39.9093778,20.3846578 L39.9093778,20.3846578 L39.9093778,24.8115467 C39.9093778,25.1306445 39.6506979,25.3893244 39.3316,25.3893244 L39.3316,25.3893244 L21.5531556,25.3893244 C21.2340577,25.3893244 20.9753778,25.1306445 20.9753778,24.8115467 L20.9753778,24.8115467 L20.9753778,20.8451911 C20.9753778,20.6615354 21.0626913,20.4888186 21.2105829,20.3799265 C30.9286034,13.2245819 33.2946282,11.0150511 33.4667779,8.67012398 L33.4667779,8.67012398 L33.4746203,8.52634465 L33.4772444,8.37901333 C33.4772444,6.85181781 32.1135931,5.87532444 30.1947556,5.87532444 C27.845944,5.87532444 25.9068429,6.75453787 24.3078147,8.42419796 C24.0720047,8.67042411 23.6753744,8.65999588 23.4528288,8.40171861 L23.4528288,8.40171861 L20.5845177,5.07287416 C20.3973517,4.855657 20.3978031,4.53403865 20.585578,4.31734767 C22.8682458,1.68316451 26.4170266,0.25768 30.1238667,0.25768 Z M18.8412889,1.76719111 L1.15555556,1.76719111 L1.15555556,5.03852444 L7.48382222,5.03852444 C7.80292008,5.03852444 8.0616,5.29720437 8.0616,5.61630222 L8.0616,5.61630222 L8.0616,24.2337689 L11.9704444,24.2337689 L11.9704444,5.61630222 C11.9704444,5.29720437 12.2291244,5.03852444 12.5482222,5.03852444 L12.5482222,5.03852444 L18.8412889,5.03852444 L18.8412889,1.76719111 Z M30.1238667,1.41323556 C26.9145265,1.41323556 23.8506724,2.57557882 21.794608,4.70699211 L21.794608,4.70699211 L23.9251281,7.17958648 C25.6521978,5.57522118 27.7392795,4.71976889 30.1947556,4.71976889 C32.684718,4.71976889 34.6328,6.11476555 34.6328,8.37901333 C34.6328,11.1545054 32.7927801,13.1801761 24.4140985,19.4436239 L24.4140985,19.4436239 L23.3323679,20.2489875 L22.1309394,21.1371825 L22.1309333,24.2337689 L38.7538222,24.2337689 L38.7538222,20.9624356 L29.4868444,20.9624356 C28.9227365,20.9624356 28.6929772,20.2369425 29.1542451,19.9122122 C35.8267709,15.2147869 38.5768444,11.9325746 38.5768444,8.37901333 C38.5768444,4.19695576 35.0805706,1.41323556 30.1238667,1.41323556 Z M31.4870356,21.6185556 C31.8061334,21.6185556 32.0648133,21.8772355 32.0648133,22.1963333 L32.0648133,22.1963333 L32.0648133,23.1878 C32.0648133,23.5068979 31.8061334,23.7655778 31.4870356,23.7655778 C31.1679377,23.7655778 30.9092578,23.5068979 30.9092578,23.1878 L30.9092578,23.1878 L30.9092578,22.1963333 C30.9092578,21.8772355 31.1679377,21.6185556 31.4870356,21.6185556 Z M28.875,21.6185556 C29.1940979,21.6185556 29.4527778,21.8772355 29.4527778,22.1963333 L29.4527778,22.1963333 L29.4527778,23.1878 C29.4527778,23.5068979 29.1940979,23.7655778 28.875,23.7655778 C28.5559021,23.7655778 28.2972222,23.5068979 28.2972222,23.1878 L28.2972222,23.1878 L28.2972222,22.1963333 C28.2972222,21.8772355 28.5559021,21.6185556 28.875,21.6185556 Z M26.2630133,21.6185556 C26.5821112,21.6185556 26.8407911,21.8772355 26.8407911,22.1963333 L26.8407911,22.1963333 L26.8407911,23.1878 C26.8407911,23.5068979 26.5821112,23.7655778 26.2630133,23.7655778 C25.9439155,23.7655778 25.6852356,23.5068979 25.6852356,23.1878 L25.6852356,23.1878 L25.6852356,22.1963333 C25.6852356,21.8772355 25.9439155,21.6185556 26.2630133,21.6185556 Z M36.8815333,21.6185556 C37.2006312,21.6185556 37.4593111,21.8772355 37.4593111,22.1963333 L37.4593111,22.1963333 L37.4593111,23.1878 C37.4593111,23.5068979 37.2006312,23.7655778 36.8815333,23.7655778 C36.5624355,23.7655778 36.3037556,23.5068979 36.3037556,23.1878 L36.3037556,23.1878 L36.3037556,22.1963333 C36.3037556,21.8772355 36.5624355,21.6185556 36.8815333,21.6185556 Z M34.2690089,21.6185556 C34.5881067,21.6185556 34.8467867,21.8772355 34.8467867,22.1963333 L34.8467867,22.1963333 L34.8467867,23.1878 C34.8467867,23.5068979 34.5881067,23.7655778 34.2690089,23.7655778 C33.949911,23.7655778 33.6912311,23.5068979 33.6912311,23.1878 L33.6912311,23.1878 L33.6912311,22.1963333 C33.6912311,21.8772355 33.949911,21.6185556 34.2690089,21.6185556 Z M10.3891067,21.83088 C10.7082045,21.83088 10.9668844,22.0895599 10.9668844,22.4086578 C10.9668844,22.7277556 10.7082045,22.9864356 10.3891067,22.9864356 L10.3891067,22.9864356 L9.39764,22.9864356 C9.07854214,22.9864356 8.81986222,22.7277556 8.81986222,22.4086578 C8.81986222,22.0895599 9.07854214,21.83088 9.39764,21.83088 L9.39764,21.83088 Z M10.3891067,19.2183556 C10.7082045,19.2183556 10.9668844,19.4770355 10.9668844,19.7961333 C10.9668844,20.1152312 10.7082045,20.3739111 10.3891067,20.3739111 L10.3891067,20.3739111 L9.39764,20.3739111 C9.07854214,20.3739111 8.81986222,20.1152312 8.81986222,19.7961333 C8.81986222,19.4770355 9.07854214,19.2183556 9.39764,19.2183556 L9.39764,19.2183556 Z M10.3891067,16.60632 C10.7082045,16.60632 10.9668844,16.8649999 10.9668844,17.1840978 C10.9668844,17.5031956 10.7082045,17.7618756 10.3891067,17.7618756 L10.3891067,17.7618756 L9.39764,17.7618756 C9.07854214,17.7618756 8.81986222,17.5031956 8.81986222,17.1840978 C8.81986222,16.8649999 9.07854214,16.60632 9.39764,16.60632 L9.39764,16.60632 Z M10.3891067,13.9943333 C10.7082045,13.9943333 10.9668844,14.2530133 10.9668844,14.5721111 C10.9668844,14.891209 10.7082045,15.1498889 10.3891067,15.1498889 L10.3891067,15.1498889 L9.39764,15.1498889 C9.07854214,15.1498889 8.81986222,14.891209 8.81986222,14.5721111 C8.81986222,14.2530133 9.07854214,13.9943333 9.39764,13.9943333 L9.39764,13.9943333 Z',
                                        id: 'Combined-Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Group-14',
                                    tabindex: '-1',
                                    transform: 'translate(0.000000, 7.333333)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/edit',
                                tabindex: '-1',
                                transform: 'translate(23.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'video-copy-4',
                            tabindex: '-1',
                            transform: 'translate(732.000000, 827.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-755.000000, -827.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-tier_2',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Tier 2',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '4978F541-9BBE-4A5E-A722-237CF0638719',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M19.8251474,0.127972789 C20.1442452,0.127972789 20.4029252,0.386652711 20.4029252,0.705750567 L20.4029252,0.705750567 L20.4029252,5.22298413 C20.4029252,5.54208198 20.1442452,5.8007619 19.8251474,5.8007619 L19.8251474,5.8007619 L13.3918594,5.8007619 L13.3918594,24.8099683 C13.3918594,25.1290661 13.1331795,25.387746 12.8140816,25.387746 L12.8140816,25.387746 L7.64632653,25.387746 C7.32722868,25.387746 7.06854875,25.1290661 7.06854875,24.8099683 L7.06854875,24.8099683 L7.06854875,5.8007619 L0.599342404,5.8007619 C0.280244548,5.8007619 0.0215646259,5.54208198 0.0215646259,5.22298413 L0.0215646259,5.22298413 L0.0215646259,0.705750567 C0.0215646259,0.386652711 0.280244548,0.127972789 0.599342404,0.127972789 L0.599342404,0.127972789 Z M33.1956599,0.127972789 C33.5147577,0.127972789 33.7734376,0.386652711 33.7734376,0.705750567 L33.7734376,0.705750567 L33.7734376,24.8099683 C33.7734376,25.1290661 33.5147577,25.387746 33.1956599,25.387746 L33.1956599,25.387746 L28.0638231,25.387746 C27.7447253,25.387746 27.4860454,25.1290661 27.4860454,24.8099683 L27.4860454,24.8099683 L27.4860454,8.73191786 L24.4646247,11.8078225 C24.235757,12.0408173 23.8594109,12.0379458 23.634125,11.8014859 L23.634125,11.8014859 L20.707277,8.72946778 C20.4912874,8.50276522 20.4951903,8.14526867 20.7160779,7.9233357 L20.7160779,7.9233357 L28.3053296,0.298165629 C28.4137613,0.189220724 28.5611346,0.127972789 28.7148435,0.127972789 L28.7148435,0.127972789 Z M19.2473696,1.28352834 L1.17712018,1.28352834 L1.17712018,4.64520635 L7.64632653,4.64520635 C7.96542439,4.64520635 8.22410431,4.90388627 8.22410431,5.22298413 L8.22410431,5.22298413 L8.22410431,24.2321905 L12.2363039,24.2321905 L12.2363039,5.22298413 C12.2363039,4.90388627 12.4949838,4.64520635 12.8140816,4.64520635 L12.8140816,4.64520635 L19.2473696,4.64520635 L19.2473696,1.28352834 Z M32.6178821,1.28352834 L28.9549663,1.28352834 L21.9320083,8.33972466 L24.05878,10.5719831 L27.6516383,6.91433623 C28.0140981,6.5453403 28.6416009,6.80198197 28.6416009,7.31921995 L28.6416009,7.31921995 L28.6416009,24.2321905 L32.6178821,24.2321905 L32.6178821,1.28352834 Z M10.8193152,21.780263 C11.138413,21.780263 11.397093,22.038943 11.397093,22.3580408 C11.397093,22.6771387 11.138413,22.9358186 10.8193152,22.9358186 L10.8193152,22.9358186 L9.80711565,22.9358186 C9.48801779,22.9358186 9.22933787,22.6771387 9.22933787,22.3580408 C9.22933787,22.038943 9.48801779,21.780263 9.80711565,21.780263 L9.80711565,21.780263 Z M10.8193152,19.1144218 C11.138413,19.1144218 11.397093,19.3731017 11.397093,19.6921995 C11.397093,20.0112974 11.138413,20.2699773 10.8193152,20.2699773 L10.8193152,20.2699773 L9.80711565,20.2699773 C9.48801779,20.2699773 9.22933787,20.0112974 9.22933787,19.6921995 C9.22933787,19.3731017 9.48801779,19.1144218 9.80711565,19.1144218 L9.80711565,19.1144218 Z M10.8193152,16.4490794 C11.138413,16.4490794 11.397093,16.7077593 11.397093,17.0268571 C11.397093,17.345955 11.138413,17.6046349 10.8193152,17.6046349 L10.8193152,17.6046349 L9.80711565,17.6046349 C9.48801779,17.6046349 9.22933787,17.345955 9.22933787,17.0268571 C9.22933787,16.7077593 9.48801779,16.4490794 9.80711565,16.4490794 L9.80711565,16.4490794 Z M10.8193152,13.7837868 C11.138413,13.7837868 11.397093,14.0424668 11.397093,14.3615646 C11.397093,14.6806625 11.138413,14.9393424 10.8193152,14.9393424 L10.8193152,14.9393424 L9.80711565,14.9393424 C9.48801779,14.9393424 9.22933787,14.6806625 9.22933787,14.3615646 C9.22933787,14.0424668 9.48801779,13.7837868 9.80711565,13.7837868 L9.80711565,13.7837868 Z M23.288159,7.75959335 C23.5089514,7.52921499 23.8746975,7.52144398 24.1050758,7.74223631 L24.1050758,7.74223631 L24.7239152,8.33532582 C24.9542935,8.55611815 24.9620646,8.92186426 24.7412722,9.15224262 C24.5204799,9.38262098 24.1547338,9.39039199 23.9243554,9.16959965 L23.9243554,9.16959965 L23.3055161,8.57651015 C23.0751377,8.35571781 23.0673667,7.98997171 23.288159,7.75959335 Z M24.8500345,6.12982935 C25.0708268,5.899451 25.4365729,5.89167999 25.6669513,6.11247232 L25.6669513,6.11247232 L26.2857907,6.70556183 C26.516169,6.92635416 26.52394,7.29210027 26.3031477,7.52247862 C26.0823554,7.75285698 25.7166093,7.76062799 25.4862309,7.53983566 L25.4862309,7.53983566 L24.8673915,6.94674615 C24.6370132,6.72595382 24.6292422,6.36020771 24.8500345,6.12982935 Z M26.4119129,4.49989639 C26.6327053,4.26951803 26.9984514,4.26174702 27.2288297,4.48253935 L27.2288297,4.48253935 L27.8476691,5.07562886 C28.0780475,5.29642119 28.0858185,5.6621673 27.8650261,5.89254566 C27.6442338,6.12292402 27.2784877,6.13069502 27.0481093,5.90990269 L27.0481093,5.90990269 L26.42927,5.31681318 C26.1988916,5.09602085 26.1911206,4.73027474 26.4119129,4.49989639 Z M27.9737921,2.86992118 C28.1945844,2.63954282 28.5603305,2.63177181 28.7907089,2.85256414 L28.7907089,2.85256414 L29.4095483,3.44565365 C29.6399266,3.66644598 29.6476976,4.03219209 29.4269053,4.26257045 C29.206113,4.49294881 28.8403669,4.50071981 28.6099885,4.27992748 L28.6099885,4.27992748 L27.9911491,3.68683798 C27.7607708,3.46604564 27.7529998,3.10029953 27.9737921,2.86992118 Z',
                                        id: 'Combined-Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Group-11',
                                    tabindex: '-1',
                                    transform: 'translate(3.137645, 7.333333)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/edit',
                                tabindex: '-1',
                                transform: 'translate(23.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'video-copy-3',
                            tabindex: '-1',
                            transform: 'translate(618.000000, 827.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-641.000000, -827.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-tier_1',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Tier 1',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '264B0055-D77E-44A4-A624-5C8FCF72B5AD',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M21.267652,0 C22.4436239,0 23.3837714,1.00823885 23.3837714,2.23669773 L23.3833463,3.652 L27.8644016,3.65218422 C29.1565128,3.65218422 30.2748977,4.5504039 30.547343,5.84979985 L31.3806799,11.8679279 C31.7691971,11.0214342 32.6220703,10.434812 33.6101942,10.434812 L33.6101942,10.434812 L36.3666256,10.434812 C37.7202199,10.434812 38.820013,11.535623 38.820013,12.8973057 L38.820013,12.8973057 L38.820013,13.5610413 C38.820013,14.9231686 37.7203305,16.0240913 36.3666256,16.0240913 L36.3666256,16.0240913 L35.5409826,16.0240913 L35.5409826,22.8444386 C35.5409826,24.2654727 34.4863908,25.4364982 33.1223707,25.6179927 L33.1220264,28.3960782 C33.1220264,29.1591239 32.5557018,29.7777778 31.8571989,29.7777778 L30.2705228,29.7777778 C29.57202,29.7777778 29.0056953,29.1591239 29.0056953,28.3960782 L29.0053463,25.642 L9.96734633,25.642 L9.967664,28.4483175 C9.967664,29.1826022 9.42283177,29.7777778 8.75065709,29.7777778 L7.06833982,29.7777778 C6.39616514,29.7777778 5.85133291,29.1826022 5.85133291,28.4483175 L5.85053847,25.6178587 C4.48700597,25.4359223 3.43293269,24.2651233 3.43293269,22.8444386 L3.43293269,22.8444386 L3.43293269,16.0240913 L2.60673371,16.0240913 C1.25380598,16.0240913 0.153346329,14.9228357 0.153346329,13.5610413 L0.153346329,13.5610413 L0.153346329,12.8973057 C0.153346329,11.5357895 1.253528,10.434812 2.60673371,10.434812 L2.60673371,10.434812 L5.36316517,10.434812 C6.07616793,10.434812 6.71887884,10.7402362 7.16753152,11.2283161 L7.91830179,5.81066455 C8.18388485,4.55057202 9.30268391,3.65218422 10.5944164,3.65218422 L15.5893463,3.652 L15.5895879,2.23669773 C15.5895879,1.00840861 16.5301152,0 17.7057073,0 L21.267652,0 Z M5.36316517,11.5554201 L2.60673371,11.5554201 C1.86064834,11.5554201 1.25849174,12.1580123 1.25849174,12.8973057 L1.25849174,12.8973057 L1.25849174,13.5610413 C1.25849174,14.3006129 1.86092631,14.9034832 2.60673371,14.9034832 L2.60673371,14.9034832 L4.53807811,14.9034832 L4.53807811,22.8444386 C4.53807811,23.7693417 5.29012994,24.5218083 6.22156174,24.5218083 L6.22156174,24.5218083 L32.7523535,24.5218083 C33.6837853,24.5218083 34.4358372,23.7693417 34.4358372,22.8444386 L34.4358372,22.8444386 L34.4358372,14.9034832 L36.3666256,14.9034832 C37.1131116,14.9034832 37.7148676,14.3010486 37.7148676,13.5610413 L37.7148676,13.5610413 L37.7148676,12.8973057 C37.7148676,12.1577944 37.1130503,11.5554201 36.3666256,11.5554201 L36.3666256,11.5554201 L33.6101942,11.5554201 C32.8637694,11.5554201 32.2619522,12.1577944 32.2619522,12.8973057 L32.2619522,12.8973057 L32.2619522,13.534836 L32.3008326,14.1486069 L31.6973463,14.148 L31.6995066,14.1641231 L6.75931138,14.1641231 L6.76034633,14.148 L6.70918332,14.1486069 L6.70918332,13.5883029 L6.7119631,13.5381368 L6.7119631,12.8973057 C6.7119631,12.157952 6.10974514,11.5554201 5.36316517,11.5554201 L5.36316517,11.5554201 Z M7.90949845,17.2174399 C9.20868357,17.2174399 10.262966,18.2861873 10.262966,19.6035588 C10.262966,20.9213726 9.20879409,21.9902322 7.90949845,21.9902322 C6.60981897,21.9902322 5.55603089,20.9215378 5.55603089,19.6035588 C5.55603089,18.2860222 6.60992948,17.2174399 7.90949845,17.2174399 Z M31.0638609,17.2174399 C32.3634298,17.2174399 33.4173284,18.2860222 33.4173284,19.6035588 C33.4173284,20.9215378 32.3635404,21.9902322 31.0638609,21.9902322 C29.7645652,21.9902322 28.7103933,20.9213726 28.7103933,19.6035588 C28.7103933,18.2861873 29.7646757,17.2174399 31.0638609,17.2174399 Z M12.8345544,18.2609211 C13.1397319,18.2609211 13.3871271,18.5117777 13.3871271,18.8212251 L13.3871271,18.8212251 L13.3871271,20.9081875 C13.3871271,21.2176349 13.1397319,21.4684916 12.8345544,21.4684916 C12.5293769,21.4684916 12.2819817,21.2176349 12.2819817,20.9081875 L12.2819817,20.9081875 L12.2819817,18.8212251 C12.2819817,18.5117777 12.5293769,18.2609211 12.8345544,18.2609211 Z M15.4954045,18.2609211 C15.800582,18.2609211 16.0479772,18.5117777 16.0479772,18.8212251 L16.0479772,18.8212251 L16.0479772,20.9081875 C16.0479772,21.2176349 15.800582,21.4684916 15.4954045,21.4684916 C15.190227,21.4684916 14.9428318,21.2176349 14.9428318,20.9081875 L14.9428318,20.9081875 L14.9428318,18.8212251 C14.9428318,18.5117777 15.190227,18.2609211 15.4954045,18.2609211 Z M18.1562546,18.2609211 C18.4614321,18.2609211 18.7088273,18.5117777 18.7088273,18.8212251 L18.7088273,18.8212251 L18.7088273,20.9081875 C18.7088273,21.2176349 18.4614321,21.4684916 18.1562546,21.4684916 C17.8510771,21.4684916 17.6036819,21.2176349 17.6036819,20.9081875 L17.6036819,20.9081875 L17.6036819,18.8212251 C17.6036819,18.5117777 17.8510771,18.2609211 18.1562546,18.2609211 Z M20.8171047,18.2609211 C21.1222822,18.2609211 21.3696774,18.5117777 21.3696774,18.8212251 L21.3696774,18.8212251 L21.3696774,20.9081875 C21.3696774,21.2176349 21.1222822,21.4684916 20.8171047,21.4684916 C20.5119272,21.4684916 20.264532,21.2176349 20.264532,20.9081875 L20.264532,20.9081875 L20.264532,18.8212251 C20.264532,18.5117777 20.5119272,18.2609211 20.8171047,18.2609211 Z M23.4779548,18.2609211 C23.7831323,18.2609211 24.0305275,18.5117777 24.0305275,18.8212251 L24.0305275,18.8212251 L24.0305275,20.9081875 C24.0305275,21.2176349 23.7831323,21.4684916 23.4779548,21.4684916 C23.1727774,21.4684916 22.9253821,21.2176349 22.9253821,20.9081875 L22.9253821,20.9081875 L22.9253821,18.8212251 C22.9253821,18.5117777 23.1727774,18.2609211 23.4779548,18.2609211 Z M26.1388049,18.2609211 C26.4439824,18.2609211 26.6913776,18.5117777 26.6913776,18.8212251 L26.6913776,18.8212251 L26.6913776,20.9081875 C26.6913776,21.2176349 26.4439824,21.4684916 26.1388049,21.4684916 C25.8336275,21.4684916 25.5862322,21.2176349 25.5862322,20.9081875 L25.5862322,20.9081875 L25.5862322,18.8212251 C25.5862322,18.5117777 25.8336275,18.2609211 26.1388049,18.2609211 Z M7.90949845,18.338048 C7.22027011,18.338048 6.66117631,18.9049315 6.66117631,19.6035588 C6.66117631,20.3026811 7.22021149,20.8696241 7.90949845,20.8696241 C8.59845345,20.8696241 9.1578206,20.3024634 9.1578206,19.6035588 C9.1578206,18.9051492 8.5983948,18.338048 7.90949845,18.338048 Z M31.0638609,18.338048 C30.3749645,18.338048 29.8155387,18.9051492 29.8155387,19.6035588 C29.8155387,20.3024634 30.3749059,20.8696241 31.0638609,20.8696241 C31.7531478,20.8696241 32.312183,20.3026811 32.312183,19.6035588 C32.312183,18.9049315 31.7530892,18.338048 31.0638609,18.338048 Z M27.8644016,4.77279229 L10.5944164,4.77279229 C9.81933317,4.77279229 9.15465906,5.30652094 9.00586905,6.00572983 L8.03234633,13.027 L30.4253463,13.027 L29.4597758,6.04486512 C29.3041146,5.30631104 28.6398236,4.77279229 27.8644016,4.77279229 Z M26.8364359,8.94958161 C27.1400989,8.91879044 27.4108831,9.14344098 27.4412494,9.45135263 C27.4716157,9.75926428 27.250065,10.0338372 26.946402,10.0646283 L26.946402,10.0646283 L16.6555743,11.1081095 C16.3519113,11.1389007 16.0811271,10.9142502 16.0507608,10.6063385 C16.0203945,10.2984269 16.2419453,10.023854 16.5456082,9.99306281 L16.5456082,9.99306281 Z M22.7762156,6.78540851 C23.0798786,6.75461735 23.3506628,6.97926789 23.3810291,7.28717954 C23.4113954,7.59509118 23.1898447,7.86966406 22.8861817,7.90045523 L22.8861817,7.90045523 L12.595354,8.94393643 C12.291691,8.9747276 12.0209068,8.75007706 11.9905405,8.44216541 C11.9601742,8.13425376 12.181725,7.85968088 12.4853879,7.82888972 L12.4853879,7.82888972 Z M21.267652,1.12060808 L17.7057073,1.12060808 C17.1546835,1.12060808 16.6947334,1.61375455 16.6947334,2.23669773 L16.6947334,3.65218422 L22.278626,3.65218422 L22.278626,2.23669773 C22.278626,1.61352959 21.8189939,1.12060808 21.267652,1.12060808 Z',
                                        id: 'Combined-Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Group-31',
                                    tabindex: '-1',
                                    transform: 'translate(0.444444, 4.444444)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/edit',
                                tabindex: '-1',
                                transform: 'translate(23.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'video-copy-2',
                            tabindex: '-1',
                            transform: 'translate(504.000000, 827.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-527.000000, -827.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-taxi_product',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Taxi',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '6D67AD86-C539-4DC7-8AE5-AC43242DEFE0',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M15.5434467,-3.01585917e-13 C15.8393902,-3.01585917e-13 16.082802,0.224802179 16.1120725,0.51287827 L16.1150235,0.57128928 L16.1150235,4.31347534 C19.5453114,4.75217897 22.5536296,6.14869796 25.0195407,8.38529839 C25.2243854,8.57109411 25.2649019,8.87418686 25.1236246,9.10554799 L25.090562,9.15395856 L21.5520757,13.8092109 C21.3465982,14.0795382 20.9519934,14.1121778 20.7048507,13.8792886 C19.5111523,12.754435 18.0167622,11.9102695 16.3441939,11.3732045 L16.1150235,11.3018744 L16.1150235,16.3807882 L16.6486036,16.5261998 L17.1597358,16.6716544 C19.4942303,17.3515455 21.1287975,18.053889 22.5306194,19.0733253 C24.7398305,20.6799129 25.9236111,22.901756 25.9236111,25.9091362 C25.9236111,31.2154171 22.4329993,34.9705073 16.3112895,35.8370561 L16.1150235,35.8637296 L16.1150235,39.4287107 C16.1150235,39.7245054 15.8901081,39.9677948 15.6018871,39.9970505 L15.5434467,40 L11.2883597,40 C10.9924161,40 10.7490043,39.7751978 10.7197339,39.4871217 L10.7167829,39.4287107 L10.7167829,35.9178108 L10.4435028,35.8862751 C6.27100499,35.378291 2.91407317,33.7470786 0.31325189,31.1475656 C0.129910565,30.9643165 0.0944941123,30.6830298 0.220163283,30.4618409 L0.252029359,30.4119361 L3.70086332,25.5774692 C3.907766,25.2874396 4.32687126,25.2553154 4.57560032,25.5104211 C6.17186994,27.1476145 8.19798425,28.3652415 10.4798253,28.9534552 L10.7167829,29.0120511 L10.7167829,23.1330062 C7.91808001,22.4283384 5.98649587,21.6762837 4.40507595,20.5161716 C2.24472496,18.931362 1.08688167,16.7213525 1.08688167,13.7324347 C1.08688167,8.88424093 4.83503106,5.06339863 10.5323253,4.2492951 L10.7167829,4.22407908 L10.7167829,0.57128928 C10.7167829,0.27549457 10.9416982,0.0322052226 11.2299193,0.00294950215 L11.2883597,-3.01585917e-13 L15.5434467,-3.01585917e-13 Z M14.9718699,1.14257856 L11.8599365,1.14257856 L11.8599365,4.73401059 C11.8599365,5.02815188 11.6364814,5.2742177 11.3435681,5.30262869 C5.81174644,5.83918527 2.23003527,9.31024332 2.23003527,13.7324347 C2.23003527,16.3516476 3.21003435,18.2222007 5.08146982,19.595065 C6.59139603,20.7027302 8.52218573,21.4268702 11.4231659,22.1305733 C11.6611642,22.1883056 11.8337688,22.3902163 11.8572124,22.62983 L11.8599365,22.6857463 L11.8599365,29.7140464 C11.8599365,30.0698489 11.5380435,30.3390964 11.1876331,30.2763948 C8.60742842,29.8146993 6.28861819,28.6270779 4.42317663,26.9480925 L4.24407177,26.784084 L1.46812454,30.6753195 C3.99435781,33.0463625 7.2500467,34.4801376 11.3371709,34.830271 C11.6131282,34.8539115 11.8293521,35.0708871 11.8569555,35.3408616 L11.8599365,35.3994733 L11.8599365,38.8574214 L14.9718699,38.8574214 L14.9718699,35.3549787 C14.9718699,35.0619293 15.193718,34.8164044 15.485399,34.7866431 C21.4819753,34.1747912 24.7804575,30.8100925 24.7804575,25.9091362 C24.7804575,23.2753307 23.7776886,21.3932293 21.858058,19.997231 C20.4626923,18.9824899 18.7576206,18.2904952 16.1819628,17.5827337 L15.9214743,17.5118925 L15.3997961,17.3740575 C15.1671891,17.3136897 14.9993869,17.1153378 14.9749475,16.8805123 L14.9718699,16.8211047 L14.9718699,10.5541575 C14.9718699,10.1837191 15.3191655,9.9112387 15.6791872,9.99921199 C17.6106807,10.4711831 19.374723,11.3035918 20.8276665,12.4721926 L21.0154048,12.6265234 L23.8581322,8.88661527 C21.524395,6.90859459 18.7041365,5.7099943 15.4872158,5.39213587 C15.2142436,5.36516395 15.0018959,5.14918444 14.9747961,4.88167902 L14.9718699,4.82361787 L14.9718699,1.14257856 Z M11.8318524,31.4976361 C12.1559378,31.4845363 12.4343398,31.7346799 12.4534298,32.0615865 L12.4534298,32.0615865 L12.520201,33.3852156 C12.5368597,33.7134653 12.2835318,33.9939392 11.9510741,34.0096176 C11.881685,34.0118915 11.8158517,34.0040994 11.7509677,33.9840544 L11.7509677,33.9840544 L11.7928333,33.847 L11.7500396,33.9837659 C11.5436285,33.9192288 11.3883897,33.7487361 11.3434138,33.5381172 L11.3310615,33.4455872 L11.264293,32.1220106 C11.2476244,31.7947571 11.4993501,31.5167896 11.8318524,31.4976361 Z M13.7774902,31.3804217 C14.0991654,31.3265445 14.4067355,31.5395865 14.464038,31.8634088 L14.464038,31.8634088 L14.6995251,33.2022908 C14.7556615,33.525128 14.5397337,33.8337203 14.2119553,33.8908076 C14.0994561,33.9089268 13.9859344,33.8954897 13.882381,33.8521958 L13.882381,33.8521958 L13.9898333,33.593 L13.8800509,33.8512094 C13.7277536,33.7859469 13.6090875,33.6604375 13.5530776,33.5040968 L13.5272227,33.4068279 L13.2924245,32.0694158 C13.2353625,31.7460463 13.4514363,31.4375564 13.7774902,31.3804217 Z M9.95764054,31.2663474 L10.0559371,31.2761932 C10.3713144,31.3416159 10.5849853,31.6451007 10.5281759,31.9668303 L10.5281759,31.9668303 L10.2931598,33.2538223 C10.2338575,33.5762646 9.92475201,33.789561 9.5961871,33.7313234 C9.57409134,33.7269065 9.55393681,33.7215632 9.5322187,33.7147463 L9.5322187,33.7147463 L9.47640311,33.6944911 C9.22301837,33.5879944 9.07126573,33.3176258 9.12191908,33.0402731 L9.12191908,33.0402731 L9.35693522,31.753281 C9.41630731,31.4304593 9.72537114,31.2165715 10.0559371,31.2761932 Z M7.55742425,31.0596967 C7.68944783,30.7616149 8.03138012,30.63003 8.34053689,30.7547128 C8.64103049,30.8858147 8.7784456,31.2361571 8.64759558,31.5381457 L8.64759558,31.5381457 L8.12337139,32.7369993 C8.00097979,33.0134181 7.69214896,33.1540171 7.40509944,33.066385 L7.40509944,33.066385 L7.47883333,32.823 L7.4025232,33.0655852 L7.33913805,33.0424165 C7.038171,32.9104381 6.90147884,32.5604324 7.03316539,32.2592472 L7.03316539,32.2592472 Z M5.90595829,30.0648091 C6.10228193,29.804752 6.4740204,29.7531883 6.73919215,29.9465469 C7.00097531,30.1442654 7.05522934,30.5157919 6.85865533,30.7789487 L6.85865533,30.7789487 L6.06378299,31.8390686 C5.91222559,32.0418203 5.65102243,32.1248731 5.41285422,32.0516272 C5.34630671,32.0310683 5.28455833,31.999302 5.23217107,31.9591581 C4.96772479,31.7627091 4.91377235,31.3885561 5.11133267,31.1268653 L5.11133267,31.1268653 Z M15.2996828,23.0327456 L15.6226016,23.1295093 C18.2043132,23.9256855 19.4290697,24.8761561 19.4290697,26.6253764 C19.4290697,28.5580647 17.8550522,30.0444313 15.2192106,30.4145013 C14.875293,30.4627871 14.5681251,30.1958856 14.5681251,29.8487663 L14.5681251,23.581201 C14.5681251,23.2003678 14.9338871,22.9261527 15.2996828,23.0327456 Z M15.7112787,24.3582637 L15.7112787,29.1607378 L15.8502091,29.1257022 C17.4492992,28.7020789 18.2859161,27.7609363 18.2859161,26.6253764 C18.2859161,25.625405 17.533737,24.9730319 15.7112787,24.3582637 Z M12.2624447,10.1957284 L12.2624447,15.8811554 C12.2624447,16.2552139 11.9087567,16.528352 11.5466232,16.4339535 C8.98260522,15.7655829 7.6259401,14.816327 7.6259401,13.1954091 C7.6259401,11.2130214 9.14049765,9.87217974 11.6349697,9.6271776 C11.9711168,9.5941619 12.2624447,9.85813208 12.2624447,10.1957284 Z M11.1192911,10.8563859 L10.9848048,10.8851366 C9.52666731,11.2165738 8.7690937,12.047079 8.7690937,13.1954091 C8.7690937,13.9971637 9.51024933,14.6129473 11.1192911,15.1230593 L11.1192911,10.8563859 Z M19.3939369,7.98161927 C19.532956,7.77144402 19.788305,7.67415197 20.0291474,7.73283508 L20.0291474,7.73283508 L20.0958033,7.7530001 C20.1392072,7.76910576 20.1803965,7.7903968 20.218483,7.81603769 C20.4924297,7.99818016 20.5669962,8.36787352 20.3841532,8.6396192 L20.3841532,8.6396192 L19.6498552,9.74391116 C19.4686919,10.0149278 19.1011951,10.0872937 18.8242667,9.90877394 C18.5522875,9.72596291 18.4774442,9.35780194 18.6592945,9.08456968 L18.6592945,9.08456968 Z M17.8891382,6.81540226 L17.9865673,6.83103991 L17.9248333,7.08 L17.990791,6.83211648 C18.0030814,6.83537592 18.0131074,6.8381588 18.0227425,6.8411145 L18.0523481,6.85114942 C18.3594529,6.96536346 18.5162476,7.30705544 18.4028936,7.61592858 L18.4028936,7.61592858 L17.9457968,8.84248174 C17.8313676,9.14786591 17.4976937,9.29857459 17.1800262,9.19135702 C16.8731479,9.07603833 16.7170152,8.73425759 16.8310145,8.42566822 L16.8310145,8.42566822 L17.2873935,7.20123488 C17.3934411,6.91740567 17.6944233,6.75894188 17.9865673,6.83103991 Z M11.098475,6.39870275 C11.2094075,6.3694081 11.3246195,6.37258968 11.432343,6.40672569 L11.432343,6.40672569 L11.3918333,6.534 L11.4336473,6.40714243 C11.5918888,6.45812209 11.7220068,6.5727903 11.791858,6.7235497 L11.8262796,6.81811551 L12.1813541,8.12866676 C12.2676722,8.44573838 12.080362,8.77244421 11.76003,8.85954288 C11.4443487,8.94153969 11.1187709,8.75658327 11.0333994,8.44003225 L11.0333994,8.44003225 L10.6769143,7.12796629 C10.5914466,6.81122512 10.7793886,6.48506983 11.098475,6.39870275 Z M15.6559382,6.28454967 L15.7511234,6.28855309 C15.7768367,6.29125839 15.7999821,6.29574094 15.8255706,6.30210825 L15.8255706,6.30210825 L15.8824113,6.31908902 C16.1412294,6.41075383 16.3073412,6.67269765 16.2731177,6.95295805 L16.2731177,6.95295805 L16.1104186,8.25141562 C16.0688386,8.57676366 15.772451,8.8072938 15.4409213,8.76611517 C15.1204846,8.71968117 14.889247,8.42704891 14.9293984,8.10246165 L14.9293984,8.10246165 L15.0920954,6.80463871 C15.1336817,6.47924088 15.4307317,6.24876677 15.7511234,6.28855309 Z M13.3911759,6.14292843 C13.4604876,6.13600074 13.5286358,6.1407103 13.5953992,6.15733247 L13.5953992,6.15733247 L13.6498376,6.1735702 C13.8629635,6.24840739 14.0185509,6.43977176 14.0444585,6.67176884 L14.0444585,6.67176884 L14.185475,7.9891186 C14.2199392,8.31576979 13.9840356,8.60802572 13.653416,8.64392167 C13.3307943,8.67485873 13.0394542,8.44124782 13.0012614,8.11544145 L13.0012614,8.11544145 L12.8608787,6.79761952 C12.8264244,6.47106215 13.0629699,6.17764329 13.3911759,6.14292843 Z',
                                        id: 'Combined-Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Group-27',
                                    tabindex: '-1',
                                    transform: 'translate(7.111111, 0.000000)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/edit-Copy-2',
                                tabindex: '-1',
                                transform: 'translate(23.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'over-the-counter-copy-2',
                            tabindex: '-1',
                            transform: 'translate(1302.000000, 711.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1325.000000, -711.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-money',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Money / Bills',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '725B6690-5467-4424-B64B-5342B7E0BBA7',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M22.7022625,0 C26.700288,0 29.9495511,3.23317433 30.0448106,7.25397662 L30.0468591,7.39621035 L31.7052222,19.733 L34.4,19.7333333 C34.6871881,19.7333333 34.9254376,19.9428641 34.9702156,20.2173926 L34.9777778,20.3111111 L34.9772222,26.133 L39.2,26.1333333 C39.4871881,26.1333333 39.7254376,26.3428641 39.7702156,26.6173926 L39.7777778,26.7111111 C39.7777778,27.030209 39.5190979,27.2888889 39.2,27.2888889 L39.2,27.2888889 L0.8,27.2888889 C0.480902145,27.2888889 0.222222222,27.030209 0.222222222,26.7111111 C0.222222222,26.3920133 0.480902145,26.1333333 0.8,26.1333333 L0.8,26.1333333 L4.48822222,26.133 L4.48888889,20.3111111 C4.48888889,20.023923 4.69841963,19.7856735 4.97294811,19.7408955 L5.06666667,19.7333333 L7.76022222,19.733 L9.41980755,7.39621035 C9.44076592,3.30969652 12.719343,0 16.7644042,0 L22.7022625,0 Z M33.8222222,20.8888889 L5.64444444,20.8888889 L5.64444444,26.1333333 L33.8222222,26.1333333 L33.8222222,20.8888889 Z M8.53333333,21.8666667 C8.85243119,21.8666667 9.11111111,22.1253466 9.11111111,22.4444444 L9.11111111,22.4444444 L9.11111111,24.5777778 C9.11111111,24.8968756 8.85243119,25.1555556 8.53333333,25.1555556 C8.21423548,25.1555556 7.95555556,24.8968756 7.95555556,24.5777778 L7.95555556,24.5777778 L7.95555556,22.4444444 C7.95555556,22.1253466 8.21423548,21.8666667 8.53333333,21.8666667 Z M11.7333333,21.8666667 C12.0524312,21.8666667 12.3111111,22.1253466 12.3111111,22.4444444 L12.3111111,22.4444444 L12.3111111,24.5777778 C12.3111111,24.8968756 12.0524312,25.1555556 11.7333333,25.1555556 C11.4142355,25.1555556 11.1555556,24.8968756 11.1555556,24.5777778 L11.1555556,24.5777778 L11.1555556,22.4444444 C11.1555556,22.1253466 11.4142355,21.8666667 11.7333333,21.8666667 Z M14.9333333,21.8666667 C15.2524312,21.8666667 15.5111111,22.1253466 15.5111111,22.4444444 L15.5111111,22.4444444 L15.5111111,24.5777778 C15.5111111,24.8968756 15.2524312,25.1555556 14.9333333,25.1555556 C14.6142355,25.1555556 14.3555556,24.8968756 14.3555556,24.5777778 L14.3555556,24.5777778 L14.3555556,22.4444444 C14.3555556,22.1253466 14.6142355,21.8666667 14.9333333,21.8666667 Z M18.1333333,21.8666667 C18.4524312,21.8666667 18.7111111,22.1253466 18.7111111,22.4444444 L18.7111111,22.4444444 L18.7111111,24.5777778 C18.7111111,24.8968756 18.4524312,25.1555556 18.1333333,25.1555556 C17.8142355,25.1555556 17.5555556,24.8968756 17.5555556,24.5777778 L17.5555556,24.5777778 L17.5555556,22.4444444 C17.5555556,22.1253466 17.8142355,21.8666667 18.1333333,21.8666667 Z M21.3333333,21.8666667 C21.6524312,21.8666667 21.9111111,22.1253466 21.9111111,22.4444444 L21.9111111,22.4444444 L21.9111111,24.5777778 C21.9111111,24.8968756 21.6524312,25.1555556 21.3333333,25.1555556 C21.0142355,25.1555556 20.7555556,24.8968756 20.7555556,24.5777778 L20.7555556,24.5777778 L20.7555556,22.4444444 C20.7555556,22.1253466 21.0142355,21.8666667 21.3333333,21.8666667 Z M24.5333333,21.8666667 C24.8524312,21.8666667 25.1111111,22.1253466 25.1111111,22.4444444 L25.1111111,22.4444444 L25.1111111,24.5777778 C25.1111111,24.8968756 24.8524312,25.1555556 24.5333333,25.1555556 C24.2142355,25.1555556 23.9555556,24.8968756 23.9555556,24.5777778 L23.9555556,24.5777778 L23.9555556,22.4444444 C23.9555556,22.1253466 24.2142355,21.8666667 24.5333333,21.8666667 Z M27.7333333,21.8666667 C28.0524312,21.8666667 28.3111111,22.1253466 28.3111111,22.4444444 L28.3111111,22.4444444 L28.3111111,24.5777778 C28.3111111,24.8968756 28.0524312,25.1555556 27.7333333,25.1555556 C27.4142355,25.1555556 27.1555556,24.8968756 27.1555556,24.5777778 L27.1555556,24.5777778 L27.1555556,22.4444444 C27.1555556,22.1253466 27.4142355,21.8666667 27.7333333,21.8666667 Z M30.9333333,21.8666667 C31.2524312,21.8666667 31.5111111,22.1253466 31.5111111,22.4444444 L31.5111111,22.4444444 L31.5111111,24.5777778 C31.5111111,24.8968756 31.2524312,25.1555556 30.9333333,25.1555556 C30.6142355,25.1555556 30.3555556,24.8968756 30.3555556,24.5777778 L30.3555556,24.5777778 L30.3555556,22.4444444 C30.3555556,22.1253466 30.6142355,21.8666667 30.9333333,21.8666667 Z M22.7022625,1.15555556 L16.7644042,1.15555556 C13.3480358,1.15555556 10.5752621,3.96575173 10.5752621,7.43562272 L10.5701113,7.51259945 L8.92731063,19.7333333 L19.1552222,19.733 L19.1555556,15.5111111 C19.1555556,15.4937984 19.156317,15.4766634 19.1578083,15.4597381 C17.4774823,15.0794973 16.2222222,13.575222 16.2222222,11.7777778 C16.2222222,11.4586799 16.4809021,11.2 16.8,11.2 C17.1190979,11.2 17.3777778,11.4586799 17.3777778,11.7777778 C17.3777778,13.225989 18.5517079,14.4 20,14.4 C21.4482921,14.4 22.6222222,13.225989 22.6222222,11.7777778 C22.6222222,11.4586799 22.8809021,11.2 23.2,11.2 C23.5190979,11.2 23.7777778,11.4586799 23.7777778,11.7777778 C23.7777778,13.7595758 22.251823,15.3849836 20.3106479,15.5429673 L20.3102222,19.733 L30.539356,19.7333333 L28.8965553,7.51259945 L28.8914046,7.43562272 C28.8914046,3.96575173 26.1186308,1.15555556 22.7022625,1.15555556 Z M32.8711111,11.9644444 C33.0625698,11.7091662 33.4247217,11.6574302 33.68,11.8488889 L33.68,11.8488889 L35.8133333,13.4488889 C36.0686116,13.6403476 36.1203476,14.0024995 35.9288889,14.2577778 C35.7374302,14.5130561 35.3752783,14.564792 35.12,14.3733333 L35.12,14.3733333 L32.9866667,12.7733333 C32.7313884,12.5818746 32.6796524,12.2197227 32.8711111,11.9644444 Z M6.85333333,11.8488889 C7.10861162,11.6574302 7.47076351,11.7091662 7.66222222,11.9644444 C7.85368094,12.2197227 7.80194495,12.5818746 7.54666667,12.7733333 L7.54666667,12.7733333 L5.41333333,14.3733333 C5.15805505,14.564792 4.79590316,14.5130561 4.60444444,14.2577778 C4.41298573,14.0024995 4.46472172,13.6403476 4.72,13.4488889 L4.72,13.4488889 Z M35.9597499,7.08967036 C36.2780725,7.06744083 36.5541446,7.3074717 36.5763741,7.62579432 C36.5986036,7.94411694 36.3585727,8.220189 36.0402501,8.24241853 L36.0402501,8.24241853 L32.8402501,8.4658852 C32.5219275,8.48811473 32.2458554,8.24808385 32.2236259,7.92976123 C32.2013964,7.61143862 32.4414273,7.33536655 32.7597499,7.31313702 L32.7597499,7.31313702 Z M4.04025012,7.08967036 L7.24025012,7.31313702 C7.55857274,7.33536655 7.79860362,7.61143862 7.77637409,7.92976123 C7.75414456,8.24808385 7.47807249,8.48811473 7.15974988,8.4658852 L7.15974988,8.4658852 L3.95974988,8.24241853 C3.64142726,8.220189 3.40139638,7.94411694 3.42362591,7.62579432 C3.44585544,7.3074717 3.72192751,7.06744083 4.04025012,7.08967036 L4.04025012,7.08967036 Z M34.5247827,1.23589386 C34.750419,1.0102576 35.1162477,1.0102576 35.3418839,1.23589386 C35.5675202,1.46153012 35.5675202,1.82735877 35.3418839,2.05299503 L35.3418839,2.05299503 L33.2085506,4.18632836 C32.9829143,4.41196462 32.6170857,4.41196462 32.3914494,4.18632836 C32.1658132,3.96069211 32.1658132,3.59486345 32.3914494,3.36922719 L32.3914494,3.36922719 Z M5.19144942,1.23589386 C5.41708567,1.0102576 5.78291433,1.0102576 6.00855058,1.23589386 L6.00855058,1.23589386 L8.14188392,3.36922719 C8.36752018,3.59486345 8.36752018,3.96069211 8.14188392,4.18632836 C7.91624766,4.41196462 7.55041901,4.41196462 7.32478275,4.18632836 L7.32478275,4.18632836 L5.19144942,2.05299503 C4.96581316,1.82735877 4.96581316,1.46153012 5.19144942,1.23589386 Z',
                                        id: 'Combined-Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Group-22',
                                    tabindex: '-1',
                                    transform: 'translate(0.000000, 6.222222)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/edit',
                                tabindex: '-1',
                                transform: 'translate(23.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'video-copy',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 827.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-413.000000, -827.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-ambulance',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Ambulance',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'D244BE87-35FB-49EB-A160-A291D2925303',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M22.0608246,0.0459816578 C23.8471033,0.0459816578 25.2999851,1.49886349 25.2999851,3.28451429 L25.2999851,13.8891704 L35.9040133,13.8891704 C37.6896641,13.8891704 39.1431738,15.3420522 39.1431738,17.127703 L39.1431738,22.0294526 C39.1431738,23.8157312 37.6896641,25.2679852 35.9040133,25.2679852 L25.2999851,25.2679852 L25.2999851,35.8726413 C25.2999851,37.6576642 23.8471033,39.1111739 22.0608246,39.1111739 L17.1597029,39.1111739 C15.3740521,39.1111739 13.9217982,37.6576642 13.9217982,35.8726413 L13.9217982,25.2679852 L3.31651423,25.2679852 C1.53086343,25.2679852 0.0779815982,23.8157312 0.0779815982,22.0294526 L0.0779815982,17.127703 C0.0779815982,15.3420522 1.53086343,13.8891704 3.31651423,13.8891704 L13.9217982,13.8891704 L13.9217982,3.28451429 C13.9217982,1.49886349 15.3740521,0.0459816578 17.1597029,0.0459816578 L22.0608246,0.0459816578 Z M22.0608246,1.30171358 L17.1597029,1.30171358 C16.0665883,1.30171358 15.1775301,2.19139965 15.1775301,3.28451429 L15.1775301,15.1449023 L3.31651423,15.1449023 C2.22339959,15.1449023 1.33371352,16.0345884 1.33371352,17.127703 L1.33371352,22.0294526 C1.33371352,23.1225672 2.22339959,24.0122533 3.31651423,24.0122533 L15.1775301,24.0122533 L15.1775301,35.8726413 C15.1775301,36.9657559 16.0665883,37.855442 17.1597029,37.855442 L22.0608246,37.855442 C23.1545671,37.855442 24.0442532,36.9657559 24.0442532,35.8726413 L24.0442532,24.0122533 L35.9040133,24.0122533 C36.9977558,24.0122533 37.8874419,23.1225672 37.8874419,22.0294526 L37.8874419,17.127703 C37.8874419,16.0345884 36.9977558,15.1449023 35.9040133,15.1449023 L24.0442532,15.1449023 L24.0442532,3.28451429 C24.0442532,2.19139965 23.1545671,1.30171358 22.0608246,1.30171358 Z M19.5142528,35.1446009 C19.8924055,35.1446009 20.2008607,35.4217994 20.2008607,35.7683881 C20.2008607,36.1149769 19.8924055,36.3921753 19.5142528,36.3921753 L19.5142528,36.3921753 L17.4114123,36.3921753 C17.0336743,36.3921753 16.7248044,36.1147959 16.7248044,35.7683881 C16.7248044,35.4219803 17.0336743,35.1446009 17.4114123,35.1446009 L17.4114123,35.1446009 Z M19.5142528,31.8018779 C19.8924055,31.8018779 20.2008607,32.0790764 20.2008607,32.4256651 C20.2008607,32.7722538 19.8924055,33.0494523 19.5142528,33.0494523 L19.5142528,33.0494523 L17.4114123,33.0494523 C17.0336743,33.0494523 16.7248044,32.7720729 16.7248044,32.4256651 C16.7248044,32.0792573 17.0336743,31.8018779 17.4114123,31.8018779 L17.4114123,31.8018779 Z M19.5142528,28.4591549 C19.8924055,28.4591549 20.2008607,28.7363534 20.2008607,29.0829421 C20.2008607,29.4295308 19.8924055,29.7067293 19.5142528,29.7067293 L19.5142528,29.7067293 L17.4114123,29.7067293 C17.0336743,29.7067293 16.7248044,29.4293499 16.7248044,29.0829421 C16.7248044,28.7365343 17.0336743,28.4591549 17.4114123,28.4591549 L17.4114123,28.4591549 Z M19.5142528,25.1164319 C19.8924055,25.1164319 20.2008607,25.3936303 20.2008607,25.7402191 C20.2008607,26.0868078 19.8924055,26.3640063 19.5142528,26.3640063 L19.5142528,26.3640063 L17.4114123,26.3640063 C17.0336743,26.3640063 16.7248044,26.0866269 16.7248044,25.7402191 C16.7248044,25.3938113 17.0336743,25.1164319 17.4114123,25.1164319 L17.4114123,25.1164319 Z M4.53482003,17.9405321 C4.84290767,17.9405321 5.09194053,18.2183173 5.09194053,18.5605883 L5.09194053,20.6631989 C5.09194053,21.00609 4.84290767,21.2832551 4.53482003,21.2832551 C4.22673239,21.2832551 3.97769953,21.00609 3.97769953,20.6631989 L3.97769953,18.5605883 C3.97769953,18.2183173 4.22673239,17.9405321 4.53482003,17.9405321 Z M7.87754304,17.9405321 C8.18563067,17.9405321 8.43466354,18.2183173 8.43466354,18.5605883 L8.43466354,20.6631989 C8.43466354,21.00609 8.18563067,21.2832551 7.87754304,21.2832551 C7.5694554,21.2832551 7.32042254,21.00609 7.32042254,20.6631989 L7.32042254,18.5605883 C7.32042254,18.2183173 7.5694554,17.9405321 7.87754304,17.9405321 Z M11.220266,17.9405321 C11.5283537,17.9405321 11.7773865,18.2183173 11.7773865,18.5605883 L11.7773865,20.6631989 C11.7773865,21.00609 11.5283537,21.2832551 11.220266,21.2832551 C10.9121784,21.2832551 10.6631455,21.00609 10.6631455,20.6631989 L10.6631455,18.5605883 C10.6631455,18.2183173 10.9121784,17.9405321 11.220266,17.9405321 Z M14.562989,17.9405321 C14.8710767,17.9405321 15.1201095,18.2183173 15.1201095,18.5605883 L15.1201095,20.6631989 C15.1201095,21.00609 14.8710767,21.2832551 14.562989,21.2832551 C14.2549014,21.2832551 14.0058685,21.00609 14.0058685,20.6631989 L14.0058685,18.5605883 C14.0058685,18.2183173 14.2549014,17.9405321 14.562989,17.9405321 Z M19.5142528,13.4169014 C19.8922004,13.4169014 20.2008607,13.6944758 20.2008607,14.0406886 C20.2008607,14.3869013 19.8922004,14.6644757 19.5142528,14.6644757 L19.5142528,14.6644757 L17.4114123,14.6644757 C17.0338795,14.6644757 16.7248044,14.3867202 16.7248044,14.0406886 C16.7248044,13.6946569 17.0338795,13.4169014 17.4114123,13.4169014 L17.4114123,13.4169014 Z M19.5142528,10.0741784 C19.8922004,10.0741784 20.2008607,10.3517528 20.2008607,10.6979656 C20.2008607,11.0441783 19.8922004,11.3217527 19.5142528,11.3217527 L19.5142528,11.3217527 L17.4114123,11.3217527 C17.0338795,11.3217527 16.7248044,11.0439972 16.7248044,10.6979656 C16.7248044,10.3519339 17.0338795,10.0741784 17.4114123,10.0741784 L17.4114123,10.0741784 Z M19.5142528,6.7314554 C19.8922004,6.7314554 20.2008607,7.00902983 20.2008607,7.35524257 C20.2008607,7.7014553 19.8922004,7.97902973 19.5142528,7.97902973 L19.5142528,7.97902973 L17.4114123,7.97902973 C17.0338795,7.97902973 16.7248044,7.70127419 16.7248044,7.35524257 C16.7248044,7.00921094 17.0338795,6.7314554 17.4114123,6.7314554 L17.4114123,6.7314554 Z M19.5142528,3.38873239 C19.8922004,3.38873239 20.2008607,3.66630682 20.2008607,4.01251956 C20.2008607,4.3587323 19.8922004,4.63630673 19.5142528,4.63630673 L19.5142528,4.63630673 L17.4114123,4.63630673 C17.0338795,4.63630673 16.7248044,4.35855119 16.7248044,4.01251956 C16.7248044,3.66648794 17.0338795,3.38873239 17.4114123,3.38873239 L17.4114123,3.38873239 Z',
                                        id: 'Combined-Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Group-28',
                                    tabindex: '-1',
                                    transform: 'translate(0.415884, 0.444444)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/edit-Copy-2',
                                tabindex: '-1',
                                transform: 'translate(23.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'over-the-counter-copy',
                            tabindex: '-1',
                            transform: 'translate(1188.000000, 709.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1211.000000, -709.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-emergency',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Emergency',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'A9276469-6364-42E6-BBFB-8D65DCD0A6DB',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'path',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [],
                                  attributes: {
                                    d: 'M19.5552971,0.888888889 C29.8648513,0.888888889 38.2222222,9.24604964 38.2222222,19.5555556 C38.2222222,20.6123126 38.129339,21.66944 37.9481801,22.7263974 L37.9868889,22.4758889 L39.5555556,23.2128182 L35.9245189,25.7777778 L35.5555556,21.3333333 L36.9542948,21.990407 C37.0684725,21.1777609 37.1266617,20.3661234 37.1266617,19.5555556 C37.1266617,9.8511172 29.2597961,1.98444946 19.5552971,1.98444946 C9.85123751,1.98444946 1.98444946,9.85119471 1.98444946,19.5555556 C1.98444946,29.2595805 9.85141843,37.1266617 19.5552971,37.1266617 C23.7156188,37.1266617 27.6502828,35.6762465 30.78358,33.0695124 C31.0161491,32.8760274 31.3615341,32.9077114 31.5550191,33.1402805 C31.7485041,33.3728496 31.7168201,33.7182347 31.484251,33.9117197 C28.155986,36.6806564 23.9740501,38.2222222 19.5552971,38.2222222 C9.24635353,38.2222222 0.888888889,29.8646384 0.888888889,19.5555556 C0.888888889,9.24613197 9.24617745,0.888888889 19.5552971,0.888888889 Z M19.7777778,33.6031746 C20.0706534,33.6031746 20.3095238,33.842045 20.3095238,34.1349206 C20.3095238,34.4277962 20.0706534,34.6666667 19.7777778,34.6666667 C19.4849022,34.6666667 19.2460317,34.4277962 19.2460317,34.1349206 C19.2460317,33.842045 19.4849022,33.6031746 19.7777778,33.6031746 Z M22.57983,33.3289931 C22.8332405,33.3289931 23.0513393,33.5076268 23.1011905,33.7548052 C23.1281931,33.8939732 23.0991135,34.0372953 23.0222597,34.1556922 C22.9433284,34.2720117 22.8207774,34.3530195 22.6836869,34.3820996 C22.5445188,34.4091022 22.4011968,34.3800226 22.2828004,34.3010913 C22.1664809,34.2221605 22.0854726,34.1016865 22.0563925,33.9625185 C22.0003103,33.6737974 22.187252,33.3954613 22.4759736,33.3373016 C22.5092077,33.3310701 22.5445188,33.3269161 22.57983,33.3289931 Z M16.9923426,33.3269161 C17.0214222,33.3269161 17.0525794,33.3310701 17.0816595,33.3373016 C17.3703806,33.3954613 17.5573228,33.6737974 17.4991631,33.9625185 C17.4410034,34.2512401 17.1626673,34.4381823 16.8739462,34.3800226 C16.5852246,34.3218629 16.3982824,34.0435268 16.4564421,33.7548052 C16.5062933,33.5013952 16.7327012,33.3206845 16.9923426,33.3269161 Z M25.2759488,32.5085254 C25.4898936,32.5106029 25.6830668,32.6393849 25.7640752,32.8387897 C25.8180804,32.9675722 25.8180804,33.1150482 25.7640752,33.2459077 C25.7100694,33.3746902 25.6062131,33.4785466 25.4753536,33.5325523 C25.203249,33.6447173 24.8937563,33.5159353 24.7795139,33.2459077 C24.7275857,33.1150482 24.7275857,32.9675722 24.7815909,32.8367127 C24.8355966,32.7079302 24.939453,32.6040738 25.0703125,32.5500681 C25.1347038,32.5230655 25.205326,32.5085254 25.2759488,32.5085254 Z M14.2962238,32.5085254 C14.3626921,32.5106029 14.4270833,32.5251425 14.4873201,32.5500681 C14.7594246,32.6622335 14.8882071,32.9738032 14.7760417,33.2459077 C14.6638768,33.5159353 14.3523065,33.6447173 14.080202,33.5325523 C13.810175,33.4203869 13.6813925,33.1088172 13.7935579,32.8387897 C13.8766432,32.6352309 14.076048,32.5043714 14.2962238,32.5085254 Z M27.7601998,31.1833149 C27.936756,31.1833149 28.1008496,31.2726317 28.1963974,31.4180308 C28.3604911,31.6631327 28.2940228,31.9933964 28.0509984,32.1574901 C27.8058964,32.3195067 27.4756327,32.2530385 27.3136161,32.0100135 C27.2346853,31.8936941 27.2056052,31.748295 27.2326078,31.611204 C27.2596109,31.4720365 27.3406187,31.3494855 27.4590156,31.2705542 C27.548332,31.2123945 27.6521889,31.1812379 27.7601998,31.1833149 Z M11.8119728,31.1833149 C11.9137527,31.1833149 12.0134551,31.216549 12.0986174,31.2726317 C12.3416419,31.4367248 12.4081101,31.7649121 12.2440165,32.0100135 C12.0820004,32.2530385 11.7517361,32.3195067 11.5087117,32.1574901 C11.2636097,31.9933964 11.1971415,31.6631327 11.3612351,31.4180308 C11.4609375,31.2684772 11.6312627,31.1791603 11.8119728,31.1833149 Z M29.9370351,29.3990575 C30.0762031,29.3990575 30.2070621,29.4551403 30.3046875,29.5548426 C30.5124008,29.7604789 30.5124008,30.0990512 30.3046875,30.3046875 C30.0990512,30.5124008 29.7604789,30.5124008 29.5548426,30.3046875 C29.3471293,30.0990512 29.3471293,29.7604789 29.5548426,29.5548426 C29.654545,29.4530633 29.7937131,29.3969805 29.9370351,29.3990575 Z M9.63306052,29.3990575 C9.77222856,29.3990575 9.90308806,29.4551403 10.0007129,29.5548426 C10.2084262,29.7604789 10.2084262,30.0990512 10.0007129,30.3046875 C9.79507715,30.5124008 9.45650435,30.5124008 9.25086806,30.3046875 C9.04315476,30.0990512 9.04315476,29.7604789 9.25086806,29.5548426 C9.35057044,29.4530633 9.48973848,29.3969805 9.63306052,29.3990575 Z M20.8437096,10.9777778 C21.7901912,10.9777778 22.5572469,11.7447841 22.5572469,12.6912421 L22.5572469,12.6912421 L22.5572469,16.9984503 L26.8647694,16.9984503 L27.0126129,17.0047374 C27.8896882,17.0796693 28.5777778,17.8151087 28.5777778,18.7113856 L28.5777778,18.7113856 L28.5777778,20.843112 C28.5777778,21.7895877 27.8112334,22.5565763 26.8647694,22.5565763 L26.8647694,22.5565763 L22.5572469,22.5565763 L22.5572469,26.8637845 C22.5572469,27.8102602 21.7901736,28.5777778 20.8437096,28.5777778 L20.8437096,28.5777778 L18.711846,28.5777778 C17.765382,28.5777778 16.9983086,27.8102602 16.9983086,26.8637845 L16.9983086,26.8637845 L16.9983086,22.5565763 L12.6907861,22.5565763 C11.7447101,22.5565763 10.9777778,21.7894465 10.9777778,20.843112 L10.9777778,20.843112 L10.9777778,18.7113856 C10.9777778,17.7654566 11.7448335,16.9984503 12.6907861,16.9984503 L12.6907861,16.9984503 L16.9983086,16.9984503 L16.9983086,12.6912421 C16.9983086,11.7447841 17.7653643,10.9777778 18.711846,10.9777778 L18.711846,10.9777778 Z M7.84672619,27.2222222 C8.02120536,27.2242992 8.18529899,27.3115391 8.28292437,27.4569381 C8.44701748,27.7020401 8.38054922,28.0323043 8.1375248,28.1943204 C7.89242338,28.3584141 7.56215911,28.2919458 7.39806548,28.0489214 C7.23604937,27.8038194 7.30251763,27.4756327 7.54554205,27.3115391 C7.6348589,27.2513023 7.73871528,27.2201452 7.84672619,27.2222222 Z M31.7254464,27.2222222 C31.8272258,27.2222222 31.9269282,27.2533793 32.0100135,27.3115391 C32.2551155,27.4735552 32.3215837,27.8038194 32.1574901,28.0468439 C32.0806363,28.1652408 31.9580853,28.2462486 31.8189173,28.2732518 C31.6818268,28.3023313 31.5364272,28.2732518 31.4201078,28.1943204 C31.1770833,28.0302268 31.1106151,27.7020401 31.2747087,27.4569381 C31.3744111,27.3073845 31.5447357,27.2180682 31.7254464,27.2222222 Z M20.8437096,12.1333333 L18.711846,12.1333333 C18.4035434,12.1333333 18.1538642,12.3829965 18.1538642,12.6912421 L18.1538642,12.6912421 L18.1538642,18.1540058 L12.6907861,18.1540058 C12.3830126,18.1540058 12.1333333,18.403669 12.1333333,18.7113856 L12.1333333,18.7113856 L12.1333333,20.843112 C12.1333333,21.1513174 12.3829724,21.4010208 12.6907861,21.4010208 L12.6907861,21.4010208 L18.1538642,21.4010208 L18.1538642,26.8637845 C18.1538642,27.1722142 18.4037275,27.4222222 18.711846,27.4222222 L18.711846,27.4222222 L20.8437096,27.4222222 C21.151828,27.4222222 21.4016914,27.1722142 21.4016914,26.8637845 L21.4016914,26.8637845 L21.4016914,21.4010208 L26.8647694,21.4010208 C27.1728878,21.4010208 27.4222222,21.1515418 27.4222222,20.843112 L27.4222222,20.843112 L27.4222222,18.7113856 C27.4222222,18.4034446 27.1728477,18.1540058 26.8647694,18.1540058 L26.8647694,18.1540058 L21.4016914,18.1540058 L21.4016914,12.6912421 C21.4016914,12.3829965 21.1520121,12.1333333 20.8437096,12.1333333 L20.8437096,12.1333333 Z M6.51736111,24.7400482 C6.73130594,24.7421258 6.92447917,24.8709077 7.00548748,25.0682355 C7.05949267,25.199095 7.05949267,25.344494 7.00548748,25.4753536 C6.95148176,25.6062131 6.84762538,25.7100694 6.71676587,25.7619976 C6.44466133,25.8762401 6.13516865,25.7474581 6.02092621,25.4753536 C5.96899802,25.344494 5.96899802,25.199095 6.02300374,25.0682355 C6.07700893,24.937376 6.18086584,24.8335196 6.30964782,24.7795139 C6.37611607,24.7525113 6.44673886,24.7400482 6.51736111,24.7400482 Z M33.0548115,24.7379712 C33.1192028,24.7400482 33.185671,24.7545883 33.2459077,24.7795139 C33.5180123,24.8916793 33.6467943,25.203249 33.5346293,25.4753536 C33.4203869,25.7453806 33.1108942,25.8741631 32.8387897,25.7619976 C32.5666851,25.6498327 32.4379032,25.3382625 32.5500681,25.0682355 C32.6352309,24.8646762 32.8346357,24.7338172 33.0548115,24.7379712 Z M33.8732022,22.0460069 C33.9043587,22.0480839 33.9334389,22.0522385 33.9625185,22.0563925 C34.2512401,22.1145522 34.4381823,22.3949653 34.3820996,22.6836869 C34.3239399,22.970331 34.0435268,23.1572732 33.7548052,23.1011905 C33.4681611,23.0430308 33.2812189,22.7626177 33.3373016,22.4759736 C33.3892298,22.2204861 33.6135601,22.0397754 33.8732022,22.0460069 Z M5.698971,22.0460069 C5.95238095,22.0480839 6.16840278,22.2267176 6.21825397,22.4759736 C6.27641369,22.7626177 6.08947199,23.0430308 5.80075038,23.1011905 C5.51202877,23.1572732 5.23369322,22.970331 5.1755335,22.6836869 C5.11737378,22.3949653 5.30431548,22.1145522 5.59303709,22.0563925 C5.62834821,22.0501615 5.66365934,22.0460069 5.698971,22.0460069 Z M34.1349206,19.2460317 C34.4277962,19.2460317 34.6666667,19.4849022 34.6666667,19.7777778 C34.6666667,20.0706534 34.4277962,20.3095238 34.1349206,20.3095238 C33.842045,20.3095238 33.6031746,20.0706534 33.6031746,19.7777778 C33.6031746,19.4849022 33.842045,19.2460317 34.1349206,19.2460317 Z M5.42063492,19.2460317 C5.71351053,19.2460317 5.95238095,19.4849022 5.95238095,19.7777778 C5.95238095,20.0706534 5.71351053,20.3095238 5.42063492,20.3095238 C5.12775931,20.3095238 4.88888889,20.0706534 4.88888889,19.7777778 C4.88888889,19.4849022 5.12775931,19.2460317 5.42063492,19.2460317 Z M33.8607391,16.4460565 C34.1141496,16.4460565 34.3322484,16.6246902 34.3820996,16.8718687 C34.4381823,17.1605903 34.2512401,17.4410034 33.9625185,17.4991631 C33.6758744,17.5552458 33.3954613,17.3683036 33.3373016,17.079582 C33.2812189,16.7929379 33.4681611,16.5125248 33.7548052,16.4543651 C33.7901168,16.4481335 33.825428,16.4439795 33.8607391,16.4460565 Z M5.71143353,16.4460565 C5.74259066,16.4460565 5.77167025,16.4502111 5.80282738,16.4543651 C6.08947199,16.5125248 6.27641369,16.7929379 6.21825397,17.079582 C6.19125137,17.21875 6.11024306,17.341301 5.99392361,17.4202318 C5.87552717,17.4970861 5.73220513,17.5261657 5.59511409,17.4991631 C5.45594605,17.4721605 5.3333956,17.3911522 5.25446429,17.2727557 C5.1755335,17.1564363 5.14853037,17.0110367 5.1755335,16.8718687 C5.22746169,16.6184587 5.45179205,16.439825 5.71143353,16.4460565 Z M6.52566964,13.7520153 C6.5921379,13.7540923 6.65652915,13.7665553 6.71676587,13.7935579 C6.98887042,13.9057228 7.1176524,14.215216 7.00548748,14.4873201 C6.89332204,14.7594246 6.58175237,14.8882071 6.30964782,14.7760417 C6.0396208,14.6617992 5.91083829,14.3523065 6.02300374,14.080202 C6.10608906,13.8766432 6.30549382,13.7478607 6.52566964,13.7520153 Z M33.046503,13.7520153 C33.2604478,13.7520153 33.451544,13.8828748 33.5346293,14.078125 C33.6467943,14.3502295 33.5180123,14.6617992 33.2459077,14.7739647 C32.9738032,14.8861296 32.6643105,14.7573476 32.5500681,14.4852431 C32.4379032,14.215216 32.5666851,13.9036458 32.8387897,13.7914809 C32.9052579,13.7644778 32.9758807,13.7499383 33.046503,13.7520153 Z M7.84880319,11.2698413 C7.9526601,11.2719183 8.05028548,11.3030754 8.1354478,11.3591581 C8.38054922,11.5211742 8.44494048,11.8514385 8.28292437,12.0965404 C8.11883074,12.3395649 7.79064347,12.4060331 7.54554205,12.2419395 C7.3004401,12.0799234 7.23604937,11.7496591 7.39806548,11.5045572 C7.49776786,11.3550036 7.66809302,11.2656873 7.84880319,11.2698413 Z M31.7212924,11.2698413 C31.8957716,11.2698413 32.0598647,11.3591581 32.1574901,11.5045572 C32.3215837,11.7496591 32.2551155,12.0778458 32.0100135,12.2419395 C31.7669891,12.4060331 31.4367248,12.3395649 31.2747087,12.0944629 C31.1106151,11.8514385 31.1770833,11.5211742 31.4201078,11.3591581 C31.5094246,11.2989214 31.6132815,11.2677643 31.7212924,11.2698413 Z M29.9370351,9.09300595 C30.0762031,9.09508295 30.2070621,9.15116567 30.3046875,9.25086806 C30.5124008,9.45650435 30.5124008,9.79507715 30.3046875,10.0007129 C30.0990512,10.2084262 29.7604789,10.2084262 29.5548426,10.0007129 C29.3471293,9.79507715 29.3471293,9.45650435 29.5548426,9.25086806 C29.654545,9.14908867 29.7937131,9.09300595 29.9370351,9.09300595 Z M9.63306052,9.09300595 C9.77222856,9.09508295 9.90308806,9.15116567 10.0007129,9.25086806 C10.2084262,9.45650435 10.2084262,9.79507715 10.0007129,10.0007129 C9.79507715,10.2084262 9.45650435,10.2084262 9.25086806,10.0007129 C9.04315476,9.79507715 9.04315476,9.45650435 9.25086806,9.25086806 C9.35057044,9.14908867 9.48973848,9.09300595 9.63306052,9.09300595 Z M27.7622768,7.30667163 C27.8661337,7.30874863 27.9637585,7.33990575 28.0489214,7.39806548 C28.1673178,7.47491926 28.2483262,7.59747024 28.2753288,7.73663828 C28.3023313,7.87372879 28.2732518,8.01912836 28.1943204,8.1354478 C28.0323043,8.37847222 27.7020401,8.44494048 27.4569381,8.28084684 C27.2139137,8.11883074 27.1474454,7.78856647 27.3115391,7.54554205 C27.4112415,7.39391148 27.5815661,7.30459463 27.7622768,7.30667163 Z M11.8078188,7.30667163 C11.982298,7.30874863 12.1463916,7.39806548 12.2440165,7.54554205 C12.4060331,7.78856647 12.3416419,8.11883074 12.0965404,8.28084684 C11.8514385,8.44494048 11.5211742,8.37847222 11.3591581,8.1354478 C11.1950645,7.89034585 11.2615327,7.56008211 11.5045572,7.39806548 C11.593874,7.33782875 11.6998079,7.30667163 11.8078188,7.30667163 Z M25.2842573,5.98146108 C25.3486486,5.98353808 25.4151168,5.99600061 25.4753536,6.02092621 C25.7474581,6.13516865 25.8762401,6.44466133 25.7619976,6.71676587 C25.6498327,6.98887042 25.34034,7.1176524 25.0682355,7.00548748 C24.796131,6.89124504 24.667349,6.58175237 24.7795139,6.30964782 C24.8646762,6.10608906 25.064081,5.97730655 25.2842573,5.98146108 Z M14.2879153,5.98146108 C14.5018601,5.98353808 14.6929563,6.11232006 14.7760417,6.30964782 C14.8882071,6.58175237 14.7594246,6.89124504 14.4873201,7.00548748 C14.215216,7.1176524 13.9057228,6.98887042 13.7935579,6.71676587 C13.6793155,6.44466133 13.808098,6.13516865 14.080202,6.02092621 C14.1466703,5.99392361 14.217293,5.98146108 14.2879153,5.98146108 Z M22.592293,5.16307044 C22.6234502,5.16514744 22.6525298,5.16930197 22.6836869,5.17345597 C22.970331,5.23161569 23.1572732,5.51202877 23.1011905,5.80075038 C23.0430308,6.08739446 22.7626177,6.27433669 22.4759736,6.21825397 C22.187252,6.16009425 22.0003103,5.87968117 22.0563925,5.59303709 C22.1083212,5.3375496 22.3326516,5.1568389 22.592293,5.16307044 Z M16.9798796,5.16514744 C17.2332901,5.16722497 17.4493119,5.34585813 17.4991631,5.59303709 C17.5573228,5.8817587 17.3703806,6.16009425 17.0816595,6.21825397 C16.9424915,6.24525656 16.7991694,6.21617697 16.68285,6.13932318 C16.564453,6.06039187 16.4834452,5.93784089 16.4564421,5.80075038 C16.3982824,5.51202877 16.5852246,5.23161569 16.8739462,5.17345597 C16.9092573,5.16722497 16.9445685,5.16514744 16.9798796,5.16514744 Z M19.7777778,4.88888889 C20.0706534,4.88888889 20.3095238,5.12775931 20.3095238,5.42063492 C20.3095238,5.71351053 20.0706534,5.95238095 19.7777778,5.95238095 C19.4849022,5.95238095 19.2460317,5.71351053 19.2460317,5.42063492 C19.2460317,5.12775931 19.4849022,4.88888889 19.7777778,4.88888889 Z',
                                    id: 'Combined-Shape',
                                    tabindex: '-1',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/edit-Copy',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'access-24/7-doctor',
                            tabindex: '-1',
                            transform: 'translate(960.000000, 711.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-985.000000, -711.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-access_doctor',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Access 24/7 Doctor',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '3D6B08E0-F8B4-4E77-B9C1-B695A02187A4',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'path',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [],
                                  attributes: {
                                    d: 'M12.3949333,8.29457778 C13.2411408,8.29457778 13.9264889,8.98036719 13.9264889,9.82657778 L13.9260889,18.6884 L26.0730889,18.6884 L26.0734222,9.8264 C26.0734222,8.98018941 26.7587703,8.2944 27.6049778,8.2944 L29.9849778,8.2944 C30.8308526,8.2944 31.5165333,8.98030138 31.5165333,9.8264 L31.5160628,12.3783523 C31.6365633,12.3479068 31.7627613,12.3317333 31.8927556,12.3317333 L34.2727556,12.3317333 C35.118632,12.3317333 35.8043111,13.0171918 35.8043111,13.8632889 L35.8040889,18.6884 L36.7538667,18.6892 C37.2809778,18.6892 37.7080889,19.1163111 37.7080889,19.6434222 C37.7080889,20.1700889 37.2809778,20.5972 36.7538667,20.5972 L35.8040889,20.5964 L35.8043111,24.5966222 C35.8043111,25.4427208 35.1186304,26.1286222 34.2727556,26.1286222 L31.8927556,26.1286222 C31.7627616,26.1286222 31.6365637,26.1124383 31.5160633,26.0819751 L31.5165333,28.6335111 C31.5165333,29.4796097 30.8308526,30.1655111 29.9849778,30.1655111 L27.6049778,30.1655111 C26.7587703,30.1655111 26.0734222,29.4797217 26.0734222,28.6335111 L26.0730889,20.5964 L13.9260889,20.5964 L13.9264889,28.6336889 C13.9264889,29.4798979 13.2411423,30.1652444 12.3949333,30.1652444 L10.0149333,30.1652444 C9.1690569,30.1652444 8.48337778,29.479786 8.48337778,28.6336889 L8.48389272,26.0817365 C8.36339226,26.1121821 8.23719422,26.1283556 8.1072,26.1283556 L5.7272,26.1283556 C4.88132357,26.1283556 4.19564444,25.4428971 4.19564444,24.5968 L4.19508889,20.5964 L3.24586667,20.5972 C2.7192,20.5972 2.29208889,20.1700889 2.29208889,19.6434222 C2.29208889,19.1163111 2.7192,18.6892 3.24586667,18.6892 L4.19508889,18.6884 L4.19564444,13.8634667 C4.19564444,13.017368 4.88132514,12.3314667 5.7272,12.3314667 L8.1072,12.3314667 C8.23719399,12.3314667 8.36339187,12.3476506 8.48389222,12.3781138 L8.48337778,9.82657778 C8.48337778,8.98047916 9.16905847,8.29457778 10.0149333,8.29457778 L12.3949333,8.29457778 Z M29.9849778,9.44995556 L27.6049778,9.44995556 C27.3971326,9.44995556 27.2289778,9.61821866 27.2289778,9.8264 L27.2289778,28.6335111 C27.2289778,28.8416924 27.3971326,29.0099556 27.6049778,29.0099556 L29.9849778,29.0099556 C30.1925737,29.0099556 30.3609778,28.8414972 30.3609778,28.6335111 L30.3609778,9.8264 C30.3609778,9.61841386 30.1925737,9.44995556 29.9849778,9.44995556 Z M12.3949333,9.45013333 L10.0149333,9.45013333 C9.80733744,9.45013333 9.63893333,9.61859164 9.63893333,9.82657778 L9.63893333,28.6336889 C9.63893333,28.841507 9.80716936,29.0096889 10.0149333,29.0096889 L12.3949333,29.0096889 C12.6029466,29.0096889 12.7709333,28.8417021 12.7709333,28.6336889 L12.7709333,9.82657778 C12.7709333,9.61839644 12.6027785,9.45013333 12.3949333,9.45013333 Z M29.1717333,25.7764 C29.4908312,25.7764 29.7495111,26.0350799 29.7495111,26.3541778 C29.7495111,26.6732756 29.4908312,26.9319556 29.1717333,26.9319556 L29.1717333,26.9319556 L28.4179556,26.9319556 C28.0988577,26.9319556 27.8401778,26.6732756 27.8401778,26.3541778 C27.8401778,26.0350799 28.0988577,25.7764 28.4179556,25.7764 L28.4179556,25.7764 Z M11.5818667,25.7764 C11.9009645,25.7764 12.1596444,26.0350799 12.1596444,26.3541778 C12.1596444,26.6732756 11.9009645,26.9319556 11.5818667,26.9319556 L11.5818667,26.9319556 L10.8280889,26.9319556 C10.508991,26.9319556 10.2503111,26.6732756 10.2503111,26.3541778 C10.2503111,26.0350799 10.508991,25.7764 10.8280889,25.7764 L10.8280889,25.7764 Z M34.2727556,13.4872889 L31.8927556,13.4872889 C31.6847423,13.4872889 31.5167556,13.6552756 31.5167556,13.8632889 L31.5167556,24.5966222 C31.5167556,24.8048036 31.6849104,24.9730667 31.8927556,24.9730667 L34.2727556,24.9730667 C34.4803514,24.9730667 34.6487556,24.8046084 34.6487556,24.5966222 L34.6487556,13.8632889 C34.6487556,13.6554708 34.4805195,13.4872889 34.2727556,13.4872889 Z M8.1072,13.4870222 L5.7272,13.4870222 C5.51960411,13.4870222 5.3512,13.6554805 5.3512,13.8634667 L5.3512,24.5968 C5.3512,24.8046181 5.51943602,24.9728 5.7272,24.9728 L8.1072,24.9728 C8.31521326,24.9728 8.4832,24.8048133 8.4832,24.5968 L8.4832,13.8634667 C8.4832,13.6552853 8.31504517,13.4870222 8.1072,13.4870222 Z M29.1717333,23.4018222 C29.4908312,23.4018222 29.7495111,23.6605021 29.7495111,23.9796 C29.7495111,24.2986979 29.4908312,24.5573778 29.1717333,24.5573778 L29.1717333,24.5573778 L28.4179556,24.5573778 C28.0988577,24.5573778 27.8401778,24.2986979 27.8401778,23.9796 C27.8401778,23.6605021 28.0988577,23.4018222 28.4179556,23.4018222 L28.4179556,23.4018222 Z M11.5818667,23.4018222 C11.9009645,23.4018222 12.1596444,23.6605021 12.1596444,23.9796 C12.1596444,24.2986979 11.9009645,24.5573778 11.5818667,24.5573778 L11.5818667,24.5573778 L10.8280889,24.5573778 C10.508991,24.5573778 10.2503111,24.2986979 10.2503111,23.9796 C10.2503111,23.6605021 10.508991,23.4018222 10.8280889,23.4018222 L10.8280889,23.4018222 Z M29.1717333,21.0268444 C29.4908312,21.0268444 29.7495111,21.2855244 29.7495111,21.6046222 C29.7495111,21.9237201 29.4908312,22.1824 29.1717333,22.1824 L29.1717333,22.1824 L28.4179556,22.1824 C28.0988577,22.1824 27.8401778,21.9237201 27.8401778,21.6046222 C27.8401778,21.2855244 28.0988577,21.0268444 28.4179556,21.0268444 L28.4179556,21.0268444 Z M11.5818667,21.0268444 C11.9009645,21.0268444 12.1596444,21.2855244 12.1596444,21.6046222 C12.1596444,21.9237201 11.9009645,22.1824 11.5818667,22.1824 L11.5818667,22.1824 L10.8280889,22.1824 C10.508991,22.1824 10.2503111,21.9237201 10.2503111,21.6046222 C10.2503111,21.2855244 10.508991,21.0268444 10.8280889,21.0268444 L10.8280889,21.0268444 Z M29.1717333,18.6522667 C29.4908312,18.6522667 29.7495111,18.9109466 29.7495111,19.2300444 C29.7495111,19.5491423 29.4908312,19.8078222 29.1717333,19.8078222 L29.1717333,19.8078222 L28.4179556,19.8078222 C28.0988577,19.8078222 27.8401778,19.5491423 27.8401778,19.2300444 C27.8401778,18.9109466 28.0988577,18.6522667 28.4179556,18.6522667 L28.4179556,18.6522667 Z M11.5818667,18.6522667 C11.9009645,18.6522667 12.1596444,18.9109466 12.1596444,19.2300444 C12.1596444,19.5491423 11.9009645,19.8078222 11.5818667,19.8078222 L11.5818667,19.8078222 L10.8280889,19.8078222 C10.508991,19.8078222 10.2503111,19.5491423 10.2503111,19.2300444 C10.2503111,18.9109466 10.508991,18.6522667 10.8280889,18.6522667 L10.8280889,18.6522667 Z M29.1717333,16.2774667 C29.4908312,16.2774667 29.7495111,16.5361466 29.7495111,16.8552444 C29.7495111,17.1743423 29.4908312,17.4330222 29.1717333,17.4330222 L29.1717333,17.4330222 L28.4179556,17.4330222 C28.0988577,17.4330222 27.8401778,17.1743423 27.8401778,16.8552444 C27.8401778,16.5361466 28.0988577,16.2774667 28.4179556,16.2774667 L28.4179556,16.2774667 Z M11.5818667,16.2774667 C11.9009645,16.2774667 12.1596444,16.5361466 12.1596444,16.8552444 C12.1596444,17.1743423 11.9009645,17.4330222 11.5818667,17.4330222 L11.5818667,17.4330222 L10.8280889,17.4330222 C10.508991,17.4330222 10.2503111,17.1743423 10.2503111,16.8552444 C10.2503111,16.5361466 10.508991,16.2774667 10.8280889,16.2774667 L10.8280889,16.2774667 Z M29.1717333,13.9028889 C29.4908312,13.9028889 29.7495111,14.1615688 29.7495111,14.4806667 C29.7495111,14.7997645 29.4908312,15.0584444 29.1717333,15.0584444 L29.1717333,15.0584444 L28.4179556,15.0584444 C28.0988577,15.0584444 27.8401778,14.7997645 27.8401778,14.4806667 C27.8401778,14.1615688 28.0988577,13.9028889 28.4179556,13.9028889 L28.4179556,13.9028889 Z M11.5818667,13.9028889 C11.9009645,13.9028889 12.1596444,14.1615688 12.1596444,14.4806667 C12.1596444,14.7997645 11.9009645,15.0584444 11.5818667,15.0584444 L11.5818667,15.0584444 L10.8280889,15.0584444 C10.508991,15.0584444 10.2503111,14.7997645 10.2503111,14.4806667 C10.2503111,14.1615688 10.508991,13.9028889 10.8280889,13.9028889 L10.8280889,13.9028889 Z M29.1717333,11.5281333 C29.4908312,11.5281333 29.7495111,11.7868133 29.7495111,12.1059111 C29.7495111,12.425009 29.4908312,12.6836889 29.1717333,12.6836889 L29.1717333,12.6836889 L28.4179556,12.6836889 C28.0988577,12.6836889 27.8401778,12.425009 27.8401778,12.1059111 C27.8401778,11.7868133 28.0988577,11.5281333 28.4179556,11.5281333 L28.4179556,11.5281333 Z M11.5818667,11.5281333 C11.9009645,11.5281333 12.1596444,11.7868133 12.1596444,12.1059111 C12.1596444,12.425009 11.9009645,12.6836889 11.5818667,12.6836889 L11.5818667,12.6836889 L10.8280889,12.6836889 C10.508991,12.6836889 10.2503111,12.425009 10.2503111,12.1059111 C10.2503111,11.7868133 10.508991,11.5281333 10.8280889,11.5281333 L10.8280889,11.5281333 Z',
                                    id: 'Combined-Shape',
                                    tabindex: '-1',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/edit-Copy',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'fitness',
                            tabindex: '-1',
                            transform: 'translate(846.000000, 711.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-871.000000, -711.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-fitness',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Fitness',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '63DD93FD-C944-4907-96AC-A3138129CD31',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'path',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [],
                                  attributes: {
                                    d: 'M19.5552889,10.4814667 C25.3766411,10.4814667 30.3532862,12.4050223 34.4810995,15.6071703 C35.9247844,16.7271078 37.1601044,17.927089 38.1888892,19.1284285 C38.5501772,19.5503143 38.8602797,19.9429516 39.1193869,20.2965691 C39.2771333,20.5118542 39.3841498,20.6684759 39.4405993,20.756677 L39.6425573,21.072232 L39.4368573,21.3853605 C39.379314,21.4729562 39.270309,21.6287044 39.1098915,21.8428863 C38.8462995,22.1948219 38.5314548,22.5856277 38.1653799,23.0055715 C37.1228468,24.2015164 35.8761585,25.3961574 34.4251727,26.5111571 C30.2755169,29.6999306 25.3133937,31.6156889 19.5552889,31.6156889 C13.7910089,31.6156889 9.01087447,29.6949012 5.17371033,26.4968604 C3.83109983,25.377877 2.701566,24.1789132 1.77692976,22.9784826 C1.45211351,22.5567823 1.17569246,22.1642293 0.946684492,21.8105558 C0.807046387,21.5949027 0.712979105,21.4377089 0.663532333,21.3486888 L0.510014218,21.0723069 L0.660017309,20.7940016 C0.708334226,20.7043578 0.800381761,20.54627 0.937322441,20.3294905 C1.16182217,19.9741037 1.43348253,19.5796854 1.75349856,19.1560075 C2.66436906,17.9500814 3.7825414,16.7456752 5.11788186,15.6216614 C8.93327017,12.4100839 13.7279221,10.4814667 19.5552889,10.4814667 Z M19.5552889,11.6370222 C14.0146556,11.6370222 9.47830761,13.4617384 5.86202925,16.5057164 C4.59628638,17.571147 3.53658372,18.7125742 2.67557922,19.8524814 C2.37543899,20.2498452 2.12198999,20.6178227 1.91427617,20.9466372 C1.88777399,20.9885906 1.86332097,21.0277962 1.84090708,21.0641545 C1.86403633,21.1007385 1.88928247,21.1402173 1.9166537,21.1824886 C2.12894347,21.510343 2.38727504,21.8772066 2.69239802,22.2733397 C3.56758817,23.4095757 4.63940851,24.5472786 5.91353412,25.609184 C9.55275886,28.6422544 14.0767911,30.4601333 19.5552889,30.4601333 C25.0403508,30.4601333 29.7619775,28.637225 33.7210717,25.5948873 C35.1081484,24.5289981 36.2999289,23.3869725 37.2943228,22.2462507 C37.6411724,21.8483612 37.9381363,21.4797503 38.1849935,21.1501581 C38.2074918,21.1201195 38.2287901,21.0914704 38.2488875,21.0642467 C38.2294915,21.0373866 38.2089537,21.0091458 38.1872742,20.9795586 C37.9450446,20.6489748 37.6530117,20.2792163 37.3111886,19.8800603 C36.3310845,18.7355665 35.1514878,17.5897145 33.7728116,16.5202075 C29.836736,13.4667999 25.1027144,11.6370222 19.5552889,11.6370222 Z M20.0616,13.6988444 C24.1206248,13.6988444 27.4109333,16.9894513 27.4109333,21.0486222 C27.4109333,25.1077931 24.1206248,28.3984 20.0616,28.3984 C16.0024291,28.3984 12.7113778,25.107647 12.7113778,21.0486222 C12.7113778,20.5374716 12.7636555,20.0326995 12.8665087,19.5399767 L13.0972747,18.434483 L13.8587652,19.2684503 C14.4615698,19.9286285 15.3103494,20.3111111 16.2222222,20.3111111 C17.9891896,20.3111111 19.4222222,18.8781906 19.4222222,17.1111111 C19.4222222,16.2279616 19.0633188,15.4033136 18.4387376,14.8032743 L17.6241095,14.0206558 L18.7354696,13.8181971 C19.1701497,13.7390106 19.6135227,13.6988444 20.0616,13.6988444 Z M20.0616,14.8544 C20.0239818,14.8544 19.9864076,14.8547347 19.9488807,14.8554031 C20.3548542,15.5248613 20.5777778,16.3005652 20.5777778,17.1111111 C20.5777778,19.5164066 18.627365,21.4666667 16.2222222,21.4666667 C15.3729312,21.4666667 14.5624234,21.2220124 13.8726677,20.7794532 C13.8688493,20.8688866 13.8669333,20.958623 13.8669333,21.0486222 C13.8669333,24.4694279 16.6406014,27.2428444 20.0616,27.2428444 C23.4824056,27.2428444 26.2553778,24.4696209 26.2553778,21.0486222 C26.2553778,17.6276236 23.4824056,14.8544 20.0616,14.8544 Z M36.6681685,13.9807252 C36.8859082,13.7474595 37.2515203,13.7348733 37.4847859,13.952613 C37.7180516,14.1703527 37.7306379,14.5359647 37.5128982,14.7692304 L37.5128982,14.7692304 L36.4844537,15.8710082 C36.266714,16.1042738 35.9011019,16.1168601 35.6678363,15.8991204 C35.4345706,15.6813807 35.4219844,15.3157686 35.6397241,15.082503 L35.6397241,15.082503 Z M3.27039202,12.2444532 C3.52407,12.0508791 3.88663943,12.0996029 4.08021351,12.3532809 C4.20730531,12.5198342 4.30892729,12.6530822 4.53744782,12.9527758 C4.76592729,13.2524155 4.86745346,13.3855379 4.99443573,13.5519476 C5.1880098,13.8056256 5.13928596,14.168195 4.88560798,14.3617691 C4.63193,14.5553431 4.26936057,14.5066193 4.07578649,14.2529413 C3.94869469,14.0863881 3.84707271,13.9531401 3.61855218,13.6534465 L3.52796072,13.5346419 C3.36054572,13.3150924 3.27040622,13.1969115 3.16156427,13.0542746 C2.9679902,12.8005967 3.01671404,12.4380272 3.27039202,12.2444532 Z M34.4095598,12.1758972 C34.6000689,11.9199095 34.9620261,11.8668285 35.2180139,12.0573376 C35.4740016,12.2478467 35.5270826,12.6098039 35.3365735,12.8657916 C35.1864808,13.0674385 35.1864808,13.0674385 35.0363932,13.2690124 C34.7363539,13.6719772 34.603093,13.8510403 34.4368183,14.0747958 C34.246491,14.3309188 33.8845715,14.3842567 33.6284486,14.1939294 C33.3723257,14.0036021 33.3189878,13.6416827 33.5093151,13.3855597 C33.6758798,13.161414 33.8092856,12.9821561 34.1095426,12.5788988 C34.2596031,12.3773615 34.2596031,12.3773615 34.4095598,12.1758972 Z M5.71506716,10.584201 C5.98881574,10.4202341 6.34365428,10.5092297 6.50762121,10.7829783 C6.61513375,10.9624743 6.70122332,11.1060556 6.89499656,11.4291221 C7.08888999,11.7523889 7.17505968,11.8961039 7.28273232,12.0758672 C7.44669925,12.3496157 7.35770365,12.7044543 7.08395506,12.8684212 C6.81020648,13.0323881 6.45536795,12.9433925 6.29140101,12.669644 C6.18388847,12.490148 6.0977989,12.3465666 5.90402567,12.0235002 C5.76553036,11.7925953 5.68199614,11.6532985 5.60632874,11.5270383 L5.5162899,11.3767551 C5.35232297,11.1030065 5.44131858,10.7481679 5.71506716,10.584201 Z M32.0075189,10.6577249 C32.1689871,10.382495 32.5230008,10.290273 32.7982307,10.4517412 C33.0734605,10.6132093 33.1656826,10.967223 33.0042144,11.2424529 C32.8770554,11.4591838 32.8770554,11.4591838 32.7498772,11.675929 L32.7498772,11.675929 L32.6227241,11.8926586 C32.475683,12.1433158 32.3563512,12.3468672 32.2417708,12.5425168 C32.0805127,12.8178699 31.7265695,12.9103621 31.4512165,12.7491041 C31.1758635,12.5878461 31.0833712,12.2339029 31.2446292,11.9585498 C31.3593721,11.7626229 31.4788376,11.5588434 31.6260093,11.3079636 L31.6260093,11.3079636 L31.7532141,11.0911459 C31.8804063,10.8743767 31.8804063,10.8743767 32.0075189,10.6577249 Z M8.28198772,9.22782921 C8.5718229,9.09434134 8.91499404,9.22108588 9.0484819,9.51092106 C9.13830145,9.70594152 9.22152619,9.88700708 9.36363165,10.1964327 C9.55765503,10.6189063 9.59362816,10.6972083 9.678349,10.8813373 C9.81172971,11.1712218 9.68485832,11.5143461 9.39497381,11.6477268 C9.1050893,11.7811075 8.76196505,11.6542361 8.62858434,11.3643516 C8.5436991,11.1798653 8.50768672,11.1014778 8.3135239,10.6787006 C8.17158164,10.3696304 8.08849464,10.1888645 7.99889587,9.99432339 C7.86540801,9.70448821 7.99215255,9.36131708 8.28198772,9.22782921 Z M29.4868105,9.42630138 C29.6177687,9.13531447 29.9598228,9.00558558 30.2508097,9.1365438 C30.5417966,9.26750203 30.6715255,9.60955615 30.5405673,9.90054306 C30.454703,10.0913321 30.3860486,10.2440599 30.2315947,10.5877905 C30.0770486,10.9317266 30.0083326,11.0845913 29.9223451,11.2756542 C29.7913869,11.5666411 29.4493327,11.69637 29.1583458,11.5654118 C28.8673589,11.4344535 28.73763,11.0923994 28.8685882,10.8014125 C28.9544526,10.6106235 29.023107,10.4578956 29.1775608,10.114165 L29.2388406,9.97779367 C29.3143419,9.80978041 29.3666265,9.69346299 29.4149319,9.58606229 Z M10.9487173,8.17268531 C11.2513835,8.07160832 11.5786821,8.23502874 11.6797591,8.53769503 C11.8275173,8.98014416 11.9824981,9.4434665 12.1578276,9.96701308 C12.2591585,10.2695945 12.0960127,10.5970301 11.7934314,10.6983609 C11.49085,10.7996918 11.1634144,10.6365461 11.0620835,10.3339647 C10.8866582,9.81013201 10.7315778,9.34651184 10.5837075,8.90372719 C10.4826305,8.6010609 10.646051,8.2737623 10.9487173,8.17268531 Z M26.8721536,8.48251577 C26.9714518,8.17926125 27.2977853,8.01392201 27.6010398,8.11322023 C27.9042943,8.21251845 28.0696336,8.53885193 27.9703353,8.84210645 C27.8835113,9.1072651 27.8142226,9.31947395 27.6584377,9.79704657 C27.5805034,10.0359611 27.5805034,10.0359611 27.5024862,10.2749783 C27.4034429,10.5783161 27.0772485,10.7439296 26.7739106,10.6448862 C26.4705728,10.5458429 26.3049593,10.2196485 26.4040027,9.91631062 C26.4819361,9.67754999 26.4819361,9.67754999 26.5598537,9.43868676 C26.7157724,8.96070383 26.7851504,8.74822132 26.8721536,8.48251577 Z M13.6881969,7.41836001 C13.9999531,7.35030454 14.3078512,7.54786298 14.3759067,7.85961913 C14.4895391,8.38015951 14.595767,8.86498905 14.6983595,9.33108802 C14.7669537,9.64272607 14.5699278,9.95096524 14.2582898,10.0195595 C13.9466517,10.0881537 13.6384125,9.8911278 13.5698183,9.57948975 C13.4670741,9.11270147 13.3607054,8.62722943 13.2469378,8.10606976 C13.1788823,7.79431361 13.3764408,7.48641547 13.6881969,7.41836001 Z M24.7787407,7.37064582 L24.8719949,7.38264637 C25.184182,7.44869681 25.3837152,7.75531891 25.3176647,8.067506 C25.2743084,8.27242952 25.2395747,8.43633571 25.1613907,8.8050839 L25.1304059,8.95122726 C25.0731485,9.2213032 25.0423434,9.36671028 25.0052203,9.54217267 C24.9391699,9.85435976 24.6325478,10.0538929 24.3203607,9.98784251 C24.0081736,9.92179208 23.8086404,9.61516998 23.8746908,9.30298289 C23.9180472,9.09805937 23.9527809,8.93415318 24.0309648,8.56540499 L24.0619496,8.41926163 C24.1192071,8.14918569 24.1500121,8.0037786 24.1871353,7.82831622 C24.2531857,7.51612913 24.5598078,7.31659594 24.8719949,7.38264637 Z M16.4747042,6.9634287 C16.7919084,6.92871685 17.0771928,7.15772217 17.1119046,7.47492641 C17.1346701,7.68296235 17.1529418,7.84942478 17.1940992,8.22400729 C17.2352751,8.59875811 17.253559,8.76533272 17.2763491,8.97359308 C17.3110609,9.29079732 17.0820556,9.57608167 16.7648514,9.61079352 C16.4476471,9.64550538 16.1623628,9.41650005 16.1276509,9.09929581 C16.1048854,8.89125987 16.0866138,8.72479745 16.0454564,8.35021493 C16.0042805,7.97546411 15.9859965,7.8088895 15.9632065,7.60062915 C15.9284946,7.28342491 16.1575,6.99814055 16.4747042,6.9634287 Z M21.9982478,6.94485686 L22.092247,6.94697747 C22.4096514,6.97980916 22.6403431,7.26373157 22.6075114,7.58113592 L22.6075114,7.58113592 L22.4524003,9.08069148 C22.4195686,9.39809583 22.1356462,9.62878755 21.8182419,9.59595586 C21.5008375,9.56312417 21.2701458,9.27920176 21.3029775,8.96179741 L21.3029775,8.96179741 L21.4580886,7.46224186 C21.4909203,7.14483751 21.7748427,6.91414578 22.092247,6.94697747 Z M19.2842214,6.80675548 C19.6033173,6.80562963 19.8629113,7.06339226 19.8640408,7.38248812 C19.8661063,7.96598113 19.8672441,8.3003432 19.8681724,8.61750557 L19.8689334,8.89055633 C19.8697777,9.20965306 19.6117849,9.46901822 19.2926881,9.46986671 C18.9735914,9.47071104 18.7142262,9.21271818 18.7133798,8.89362145 C18.7122683,8.47458988 18.7111469,8.13644331 18.7084888,7.38657855 C18.707363,7.0674827 18.9651256,6.80788872 19.2842214,6.80675548 Z',
                                    id: 'Combined-Shape',
                                    tabindex: '-1',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/edit',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'vision',
                            tabindex: '-1',
                            transform: 'translate(732.000000, 711.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-757.000000, -711.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-vision',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Vision',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '45CCF36A-7C9E-421A-8E7F-1EC01B2F25C2',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'path',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [],
                                  attributes: {
                                    d: 'M30.1673546,1.35447976 L30.4582707,1.35682165 C33.1086439,1.41822292 35.6219538,4.58326284 37.5436469,9.41104414 C39.210096,13.5975874 40.0489494,18.2063087 39.4601877,20.2760398 C39.3387082,20.7032199 39.0989101,21.1034665 38.7427433,21.5064546 C38.2075852,22.111964 38.0788805,22.2125474 35.8733938,23.8429541 C34.2543665,25.0398206 33.1620189,25.9467517 32.0291356,27.1158126 C29.3886048,29.8406663 27.4274751,33.2337027 26.1991974,37.788827 C25.7086822,39.6084584 22.9072684,39.4637018 22.6656188,37.5868895 C22.2496562,34.356047 21.7973706,31.6489971 21.3140926,29.6657336 C20.8125431,27.6074881 20.2529956,26.4255556 20.0448889,26.4255556 C19.8366064,26.4255556 19.2768145,27.6081863 18.7750786,29.6674929 C18.2916343,31.6517236 17.839215,34.3600717 17.4232469,37.5919585 C17.1810721,39.4683099 14.3827716,39.6158163 13.8890847,37.7974249 C12.6658465,33.2931763 10.7115683,29.951199 8.06725383,27.2546921 C6.97807791,26.1440184 5.92467347,25.2703052 4.36507727,24.1114543 C2.16138479,22.4740105 2.07703554,22.4082728 1.524177,21.8150248 C1.04507806,21.3009249 0.743252825,20.7948887 0.620827621,20.2431481 C0.151691444,18.1286809 1.01924261,13.498559 2.62960681,9.38908493 C4.5254393,4.55112688 6.98305853,1.41817301 9.63155718,1.3568205 C11.9964131,1.30223901 13.6036508,2.12713555 15.8483126,4.0561509 C15.9856151,4.17414578 16.4438955,4.57196219 16.4683412,4.59309557 C16.7077699,4.80008188 16.8892213,4.95401349 17.0647784,5.09788781 C18.2368043,6.05839838 19.0834001,6.47844444 20.0448889,6.47844444 C21.257543,6.47844444 22.186531,5.97734114 23.6230157,4.72431465 C23.765921,4.5996603 24.2479929,4.17135414 24.3545202,4.0765241 L24.371086,4.06170011 C26.5849264,2.10221279 28.0964081,1.30230925 30.4582707,1.35682165 Z M30.4315321,2.51206781 C28.4320428,2.46592498 27.1523474,3.14316599 25.1369659,4.92699578 C25.2043933,4.86731527 24.5563945,5.44354342 24.3826152,5.59512874 C22.7537742,7.01594511 21.6079714,7.634 20.0448889,7.634 C18.756319,7.634 17.6919334,7.10589562 16.3323153,5.99164756 C16.1475188,5.84020123 15.9590536,5.68031952 15.7126144,5.46727266 C15.6862453,5.44447658 15.2298568,5.04830242 15.0951579,4.93254499 C13.0473106,3.17266795 11.6697336,2.46564215 9.65826953,2.51206726 C7.6568848,2.55842938 5.4399623,5.38454492 3.7055043,9.81069285 C2.17173775,13.724698 1.34142537,18.1560765 1.74894785,19.9928415 C1.82133951,20.3190931 2.0199305,20.6520481 2.36954857,21.0272078 C2.84914728,21.541844 2.94743347,21.6184434 5.05427536,23.1839228 C6.65804249,24.3755948 7.75271621,25.2835375 8.89230061,26.4456145 C11.6726805,29.2808725 13.7282582,32.7960802 15.0042596,37.4946155 C15.1704657,38.1068004 16.1986526,38.0526017 16.2771714,37.4442441 C17.302029,29.4815567 18.328146,25.27 20.0448889,25.27 C21.7612223,25.27 22.7868189,29.4788164 23.811714,37.4393282 C23.8899118,38.0466647 24.9185593,38.0998176 25.0834804,37.4880208 C26.3636181,32.7405712 28.4243441,29.175219 31.1992953,26.3116523 C32.3849493,25.0881355 33.5208159,24.1450724 35.1864699,22.9137372 C37.2801821,21.3659597 37.4241894,21.2534173 37.8768922,20.7412027 C38.1267634,20.4584837 38.2793665,20.2037741 38.3487139,19.9599153 C38.8493179,18.2000936 38.0497078,13.8069779 36.4700197,9.8384003 C34.7107497,5.41866706 32.4396315,2.55861285 30.4315321,2.51206781 Z M22.6354222,17.5142222 C22.9545201,17.5142222 23.2132,17.7729021 23.2132,18.092 L23.2132,18.092 L23.2132,19.5995556 C23.2132,19.9186534 22.9545201,20.1773333 22.6354222,20.1773333 C22.3163244,20.1773333 22.0576444,19.9186534 22.0576444,19.5995556 L22.0576444,19.5995556 L22.0576444,18.092 C22.0576444,17.7729021 22.3163244,17.5142222 22.6354222,17.5142222 Z M25.01,17.5142222 C25.3290979,17.5142222 25.5877778,17.7729021 25.5877778,18.092 L25.5877778,18.092 L25.5877778,19.5995556 C25.5877778,19.9186534 25.3290979,20.1773333 25.01,20.1773333 C24.6909021,20.1773333 24.4322222,19.9186534 24.4322222,19.5995556 L24.4322222,19.5995556 L24.4322222,18.092 C24.4322222,17.7729021 24.6909021,17.5142222 25.01,17.5142222 Z M27.3845333,17.5142222 C27.7036312,17.5142222 27.9623111,17.7729021 27.9623111,18.092 L27.9623111,18.092 L27.9623111,19.5995556 C27.9623111,19.9186534 27.7036312,20.1773333 27.3845333,20.1773333 C27.0654355,20.1773333 26.8067556,19.9186534 26.8067556,19.5995556 L26.8067556,19.5995556 L26.8067556,18.092 C26.8067556,17.7729021 27.0654355,17.5142222 27.3845333,17.5142222 Z M29.7595556,17.5142222 C30.0786534,17.5142222 30.3373333,17.7729021 30.3373333,18.092 L30.3373333,18.092 L30.3373333,19.5995556 C30.3373333,19.9186534 30.0786534,20.1773333 29.7595556,20.1773333 C29.4404577,20.1773333 29.1817778,19.9186534 29.1817778,19.5995556 L29.1817778,19.5995556 L29.1817778,18.092 C29.1817778,17.7729021 29.4404577,17.5142222 29.7595556,17.5142222 Z M32.1341333,17.5142222 C32.4532312,17.5142222 32.7119111,17.7729021 32.7119111,18.092 L32.7119111,18.092 L32.7119111,19.5995556 C32.7119111,19.9186534 32.4532312,20.1773333 32.1341333,20.1773333 C31.8150355,20.1773333 31.5563556,19.9186534 31.5563556,19.5995556 L31.5563556,19.5995556 L31.5563556,18.092 C31.5563556,17.7729021 31.8150355,17.5142222 32.1341333,17.5142222 Z M34.5086667,17.5142222 C34.8277645,17.5142222 35.0864444,17.7729021 35.0864444,18.092 L35.0864444,18.092 L35.0864444,19.5995556 C35.0864444,19.9186534 34.8277645,20.1773333 34.5086667,20.1773333 C34.1895688,20.1773333 33.9308889,19.9186534 33.9308889,19.5995556 L33.9308889,19.5995556 L33.9308889,18.092 C33.9308889,17.7729021 34.1895688,17.5142222 34.5086667,17.5142222 Z M36.8836889,17.5142222 C37.2027867,17.5142222 37.4614667,17.7729021 37.4614667,18.092 L37.4614667,18.092 L37.4614667,19.5995556 C37.4614667,19.9186534 37.2027867,20.1773333 36.8836889,20.1773333 C36.564591,20.1773333 36.3059111,19.9186534 36.3059111,19.5995556 L36.3059111,19.5995556 L36.3059111,18.092 C36.3059111,17.7729021 36.564591,17.5142222 36.8836889,17.5142222 Z M14.1834011,6.89683896 C14.3867186,6.65090106 14.750912,6.61635035 14.9968499,6.8196678 L14.9968499,6.8196678 L16.1586277,7.78011225 C16.4045656,7.9834297 16.4391163,8.34762313 16.2357989,8.59356104 C16.0324814,8.83949894 15.668288,8.87404965 15.4223501,8.6707322 L15.4223501,8.6707322 L14.2605723,7.71028775 C14.0146344,7.5069703 13.9800837,7.14277687 14.1834011,6.89683896 Z M7.31673845,6.0577079 C8.76308266,4.12915928 10.9140443,3.78346944 13.5325352,5.98863948 C13.776611,6.19418864 13.807843,6.55868166 13.6022939,6.80275744 C13.3967447,7.04683322 13.0322517,7.07806523 12.7881759,6.87251607 C10.696749,5.11121465 9.30300811,5.33520845 8.24119837,6.7510206 C8.04613861,7.01111237 7.88125913,7.29278279 7.74732043,7.5743864 C7.66801112,7.74113273 7.61800204,7.86702199 7.59652501,7.93047712 C7.49422383,8.23273183 7.16626648,8.39482619 6.86401177,8.29252501 C6.56175706,8.19022383 6.3996627,7.86226648 6.50196388,7.56001177 C6.63336415,7.17178214 6.89713979,6.6171988 7.31673845,6.0577079 Z',
                                    id: 'Combined-Shape',
                                    tabindex: '-1',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/edit',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'dental',
                            tabindex: '-1',
                            transform: 'translate(618.000000, 711.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-643.000000, -711.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-dental',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Dental',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'FF0B4C63-AD1A-4734-85D9-3849A181C880',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M9.11111111,0 C8.10746513,0 7.28888889,0.820794601 7.28888889,1.82716049 L7.28888889,2.43621399 L5.46666667,2.43621399 C4.46302068,2.43621399 3.64444444,3.25700859 3.64444444,4.26337449 L3.64444444,4.87242798 L1.82222222,4.87242798 C0.818576237,4.87242798 0,5.69322258 0,6.69958848 L0,31.0617284 C0,32.0680943 0.818576237,32.8888889 1.82222222,32.8888889 L34.6222222,32.8888889 C35.6258682,32.8888889 36.4444444,32.0680943 36.4444444,31.0617284 L36.4444444,6.69958848 C36.4444444,5.69322258 35.6258682,4.87242798 34.6222222,4.87242798 L32.7833911,4.87242798 C32.7881367,4.84625756 32.8,4.82246672 32.8,4.7962963 L32.8,4.26337449 C32.8,3.25700859 31.9814238,2.43621399 30.9777778,2.43621399 L29.1389466,2.43621399 C29.1436923,2.41004357 29.1555556,2.38625272 29.1555556,2.3600823 L29.1555556,1.82716049 C29.1555556,0.820794601 28.3369793,0 27.3333333,0 L9.11111111,0 Z M9.11111111,1.218107 L27.3333333,1.218107 C27.6678818,1.218107 27.9407407,1.4917054 27.9407407,1.82716049 L27.9407407,2.3600823 C27.9407407,2.38625272 27.952604,2.41004357 27.9573497,2.43621399 L8.5037037,2.43621399 L8.5037037,1.82716049 C8.5037037,1.4917054 8.77656265,1.218107 9.11111111,1.218107 Z M5.46666667,3.65432099 L30.9777778,3.65432099 C31.3123262,3.65432099 31.5851852,3.92791939 31.5851852,4.26337449 L31.5851852,4.7962963 C31.5851852,4.82246672 31.5970485,4.84625756 31.6017941,4.87242798 L4.85925926,4.87242798 L4.85925926,4.26337449 C4.85925926,3.92791939 5.13211821,3.65432099 5.46666667,3.65432099 Z M1.82222222,6.09053498 L34.6222222,6.09053498 C34.9567707,6.09053498 35.2296296,6.36413338 35.2296296,6.69958848 L35.2296296,31.0617284 C35.2296296,31.3971835 34.9567707,31.6707819 34.6222222,31.6707819 L1.82222222,31.6707819 C1.48767376,31.6707819 1.21481481,31.3971835 1.21481481,31.0617284 L1.21481481,6.69958848 C1.21481481,6.36413338 1.48767376,6.09053498 1.82222222,6.09053498 Z M3.03703704,7.30864198 C2.70248858,7.30864198 2.42962963,7.58224038 2.42962963,7.91769547 L2.42962963,9.13580247 C2.42962963,9.47125756 2.70248858,9.74485597 3.03703704,9.74485597 C3.3715855,9.74485597 3.64444444,9.47125756 3.64444444,9.13580247 L3.64444444,7.91769547 C3.64444444,7.58224038 3.3715855,7.30864198 3.03703704,7.30864198 Z M6.07407407,7.30864198 C5.73952561,7.30864198 5.46666667,7.58224038 5.46666667,7.91769547 L5.46666667,9.13580247 C5.46666667,9.47125756 5.73952561,9.74485597 6.07407407,9.74485597 C6.40862253,9.74485597 6.68148148,9.47125756 6.68148148,9.13580247 L6.68148148,7.91769547 C6.68148148,7.58224038 6.40862253,7.30864198 6.07407407,7.30864198 Z M9.11111111,7.30864198 C8.77656265,7.30864198 8.5037037,7.58224038 8.5037037,7.91769547 L8.5037037,9.13580247 C8.5037037,9.47125756 8.77656265,9.74485597 9.11111111,9.74485597 C9.44565957,9.74485597 9.71851852,9.47125756 9.71851852,9.13580247 L9.71851852,7.91769547 C9.71851852,7.58224038 9.44565957,7.30864198 9.11111111,7.30864198 Z M12.1481481,7.30864198 C11.8135997,7.30864198 11.5407407,7.58224038 11.5407407,7.91769547 L11.5407407,9.13580247 C11.5407407,9.47125756 11.8135997,9.74485597 12.1481481,9.74485597 C12.4826966,9.74485597 12.7555556,9.47125756 12.7555556,9.13580247 L12.7555556,7.91769547 C12.7555556,7.58224038 12.4826966,7.30864198 12.1481481,7.30864198 Z M15.1851852,7.30864198 C14.8506367,7.30864198 14.5777778,7.58224038 14.5777778,7.91769547 L14.5777778,9.13580247 C14.5777778,9.47125756 14.8506367,9.74485597 15.1851852,9.74485597 C15.5197336,9.74485597 15.7925926,9.47125756 15.7925926,9.13580247 L15.7925926,7.91769547 C15.7925926,7.58224038 15.5197336,7.30864198 15.1851852,7.30864198 Z M18.2222222,7.30864198 C17.8876738,7.30864198 17.6148148,7.58224038 17.6148148,7.91769547 L17.6148148,9.13580247 C17.6148148,9.47125756 17.8876738,9.74485597 18.2222222,9.74485597 C18.5567707,9.74485597 18.8296296,9.47125756 18.8296296,9.13580247 L18.8296296,7.91769547 C18.8296296,7.58224038 18.5567707,7.30864198 18.2222222,7.30864198 Z M21.2592593,7.30864198 C20.9247108,7.30864198 20.6518519,7.58224038 20.6518519,7.91769547 L20.6518519,9.13580247 C20.6518519,9.47125756 20.9247108,9.74485597 21.2592593,9.74485597 C21.5938077,9.74485597 21.8666667,9.47125756 21.8666667,9.13580247 L21.8666667,7.91769547 C21.8666667,7.58224038 21.5938077,7.30864198 21.2592593,7.30864198 Z M24.2962963,7.30864198 C23.9617478,7.30864198 23.6888889,7.58224038 23.6888889,7.91769547 L23.6888889,9.13580247 C23.6888889,9.47125756 23.9617478,9.74485597 24.2962963,9.74485597 C24.6308448,9.74485597 24.9037037,9.47125756 24.9037037,9.13580247 L24.9037037,7.91769547 C24.9037037,7.58224038 24.6308448,7.30864198 24.2962963,7.30864198 Z M27.3333333,7.30864198 C26.9987849,7.30864198 26.7259259,7.58224038 26.7259259,7.91769547 L26.7259259,9.13580247 C26.7259259,9.47125756 26.9987849,9.74485597 27.3333333,9.74485597 C27.6678818,9.74485597 27.9407407,9.47125756 27.9407407,9.13580247 L27.9407407,7.91769547 C27.9407407,7.58224038 27.6678818,7.30864198 27.3333333,7.30864198 Z M30.3703704,7.30864198 C30.0358219,7.30864198 29.762963,7.58224038 29.762963,7.91769547 L29.762963,9.13580247 C29.762963,9.47125756 30.0358219,9.74485597 30.3703704,9.74485597 C30.7049188,9.74485597 30.9777778,9.47125756 30.9777778,9.13580247 L30.9777778,7.91769547 C30.9777778,7.58224038 30.7049188,7.30864198 30.3703704,7.30864198 Z M33.4074074,7.30864198 C33.0728589,7.30864198 32.8,7.58224038 32.8,7.91769547 L32.8,9.13580247 C32.8,9.47125756 33.0728589,9.74485597 33.4074074,9.74485597 C33.7419559,9.74485597 34.0148148,9.47125756 34.0148148,9.13580247 L34.0148148,7.91769547 C34.0148148,7.58224038 33.7419559,7.30864198 33.4074074,7.30864198 Z M14.5706596,12.0359441 C14.3594907,12.0311855 14.1483219,12.0859053 13.9561346,12.195345 C13.5693867,12.4142236 13.362963,12.8115353 13.362963,13.25643 L13.362963,24.5048868 C13.362963,24.9497815 13.5693867,25.3470939 13.9561346,25.5659725 C14.1435762,25.6730326 14.35,25.7253728 14.5564238,25.7253728 C14.7723383,25.7253728 14.9858796,25.668274 15.178067,25.5516975 L24.5478012,19.9274691 C24.9179401,19.7038326 25.1409722,19.3136577 25.1409722,18.8806584 C25.1409722,18.4476598 24.9179401,18.0574849 24.5478012,17.8338477 L15.178067,12.2096193 C14.9882522,12.0954218 14.781829,12.038323 14.5706596,12.0359441 Z M14.5564238,13.25643 L23.9237849,18.8806584 L14.5564238,24.5072658 L14.5564238,13.25643 Z M3.03703704,28.0164609 C2.70248858,28.0164609 2.42962963,28.2900593 2.42962963,28.6255144 L2.42962963,29.8436214 C2.42962963,30.1790765 2.70248858,30.4526749 3.03703704,30.4526749 C3.3715855,30.4526749 3.64444444,30.1790765 3.64444444,29.8436214 L3.64444444,28.6255144 C3.64444444,28.2900593 3.3715855,28.0164609 3.03703704,28.0164609 Z M6.07407407,28.0164609 C5.73952561,28.0164609 5.46666667,28.2900593 5.46666667,28.6255144 L5.46666667,29.8436214 C5.46666667,30.1790765 5.73952561,30.4526749 6.07407407,30.4526749 C6.40862253,30.4526749 6.68148148,30.1790765 6.68148148,29.8436214 L6.68148148,28.6255144 C6.68148148,28.2900593 6.40862253,28.0164609 6.07407407,28.0164609 Z M9.11111111,28.0164609 C8.77656265,28.0164609 8.5037037,28.2900593 8.5037037,28.6255144 L8.5037037,29.8436214 C8.5037037,30.1790765 8.77656265,30.4526749 9.11111111,30.4526749 C9.44565957,30.4526749 9.71851852,30.1790765 9.71851852,29.8436214 L9.71851852,28.6255144 C9.71851852,28.2900593 9.44565957,28.0164609 9.11111111,28.0164609 Z M12.1481481,28.0164609 C11.8135997,28.0164609 11.5407407,28.2900593 11.5407407,28.6255144 L11.5407407,29.8436214 C11.5407407,30.1790765 11.8135997,30.4526749 12.1481481,30.4526749 C12.4826966,30.4526749 12.7555556,30.1790765 12.7555556,29.8436214 L12.7555556,28.6255144 C12.7555556,28.2900593 12.4826966,28.0164609 12.1481481,28.0164609 Z M15.1851852,28.0164609 C14.8506367,28.0164609 14.5777778,28.2900593 14.5777778,28.6255144 L14.5777778,29.8436214 C14.5777778,30.1790765 14.8506367,30.4526749 15.1851852,30.4526749 C15.5197336,30.4526749 15.7925926,30.1790765 15.7925926,29.8436214 L15.7925926,28.6255144 C15.7925926,28.2900593 15.5197336,28.0164609 15.1851852,28.0164609 Z M18.2222222,28.0164609 C17.8876738,28.0164609 17.6148148,28.2900593 17.6148148,28.6255144 L17.6148148,29.8436214 C17.6148148,30.1790765 17.8876738,30.4526749 18.2222222,30.4526749 C18.5567707,30.4526749 18.8296296,30.1790765 18.8296296,29.8436214 L18.8296296,28.6255144 C18.8296296,28.2900593 18.5567707,28.0164609 18.2222222,28.0164609 Z M21.2592593,28.0164609 C20.9247108,28.0164609 20.6518519,28.2900593 20.6518519,28.6255144 L20.6518519,29.8436214 C20.6518519,30.1790765 20.9247108,30.4526749 21.2592593,30.4526749 C21.5938077,30.4526749 21.8666667,30.1790765 21.8666667,29.8436214 L21.8666667,28.6255144 C21.8666667,28.2900593 21.5938077,28.0164609 21.2592593,28.0164609 Z M24.2962963,28.0164609 C23.9617478,28.0164609 23.6888889,28.2900593 23.6888889,28.6255144 L23.6888889,29.8436214 C23.6888889,30.1790765 23.9617478,30.4526749 24.2962963,30.4526749 C24.6308448,30.4526749 24.9037037,30.1790765 24.9037037,29.8436214 L24.9037037,28.6255144 C24.9037037,28.2900593 24.6308448,28.0164609 24.2962963,28.0164609 Z M27.3333333,28.0164609 C26.9987849,28.0164609 26.7259259,28.2900593 26.7259259,28.6255144 L26.7259259,29.8436214 C26.7259259,30.1790765 26.9987849,30.4526749 27.3333333,30.4526749 C27.6678818,30.4526749 27.9407407,30.1790765 27.9407407,29.8436214 L27.9407407,28.6255144 C27.9407407,28.2900593 27.6678818,28.0164609 27.3333333,28.0164609 Z M30.3703704,28.0164609 C30.0358219,28.0164609 29.762963,28.2900593 29.762963,28.6255144 L29.762963,29.8436214 C29.762963,30.1790765 30.0358219,30.4526749 30.3703704,30.4526749 C30.7049188,30.4526749 30.9777778,30.1790765 30.9777778,29.8436214 L30.9777778,28.6255144 C30.9777778,28.2900593 30.7049188,28.0164609 30.3703704,28.0164609 Z M33.4074074,28.0164609 C33.0728589,28.0164609 32.8,28.2900593 32.8,28.6255144 L32.8,29.8436214 C32.8,30.1790765 33.0728589,30.4526749 33.4074074,30.4526749 C33.7419559,30.4526749 34.0148148,30.1790765 34.0148148,29.8436214 L34.0148148,28.6255144 C34.0148148,28.2900593 33.7419559,28.0164609 33.4074074,28.0164609 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'icons8-video-playlist',
                                    tabindex: '-1',
                                    transform: 'translate(1.777778, 3.555556)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/edit',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'video',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 711.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-415.000000, -711.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-video_product',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Video',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'A0EE95DB-9E0A-4C7A-BF08-B1893D43F6A9',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M3.86206897,0 C2.76781609,0 1.93103448,0.841325536 1.93103448,1.94152047 L1.93103448,7.11890838 L1.28735632,7.11890838 C0.579310345,7.11890838 0,7.70136452 0,8.41325536 L0,13.5906433 C0,14.3025341 0.579310345,14.8849903 1.28735632,14.8849903 L1.93103448,14.8849903 L1.93103448,30.417154 C1.93103448,31.5173489 2.76781609,32.3586745 3.86206897,32.3586745 L21.5493896,32.3586745 C22.9474586,35.0470331 25.7445517,36.8888889 28.9655172,36.8888889 C33.5794023,36.8888889 37.3333333,33.1145731 37.3333333,28.4756335 C37.3333333,24.7401481 34.8976552,21.5694634 31.5402299,20.4744458 L31.5402299,14.8849903 L32.183908,14.8849903 C32.891954,14.8849903 33.4712644,14.3025341 33.4712644,13.5906433 L33.4712644,8.41325536 C33.4712644,7.63664717 32.891954,7.11890838 32.183908,7.11890838 L31.5402299,7.11890838 L31.5402299,1.94152047 C31.5402299,0.841325536 30.7034483,0 29.6091954,0 L3.86206897,0 Z M3.86206897,1.29434698 L29.6091954,1.29434698 C29.9954023,1.29434698 30.2528736,1.55321637 30.2528736,1.94152047 L30.2528736,10.3547758 L3.2183908,10.3547758 L3.2183908,1.94152047 C3.2183908,1.55321637 3.47586207,1.29434698 3.86206897,1.29434698 Z M18.0229885,3.26873156 C17.9103448,3.26873156 17.7977011,3.30007935 17.7011494,3.3647967 L16.4137931,4.01197019 C16.091954,4.14140489 15.9632184,4.53021442 16.091954,4.85380117 C16.2206897,5.17738791 16.6073993,5.30682261 16.9292383,5.17738791 L17.2510774,4.98273042 L17.2510774,7.76608187 C17.2510774,8.15438596 17.5085487,8.41325536 17.8947556,8.41325536 C18.2809625,8.41325536 18.5384337,8.15438596 18.5384337,7.76608187 L18.5384337,3.88304094 C18.6671694,3.68888889 18.537931,3.42951405 18.3448276,3.3647967 C18.2482759,3.30007935 18.1356322,3.26873156 18.0229885,3.26873156 Z M26.3908046,3.26873156 C26.2781609,3.26873156 26.1655172,3.30007935 26.0689655,3.3647967 L24.7816092,4.01197019 C24.4597701,4.14140489 24.3310345,4.53021442 24.4597701,4.85380117 C24.5885057,5.17738791 24.9752154,5.30682261 25.2970544,5.17738791 L25.6188935,4.98273042 L25.6188935,7.76608187 C25.6188935,8.15438596 25.8763648,8.41325536 26.2625717,8.41325536 C26.6487786,8.41325536 26.9062498,8.15438596 26.9062498,7.76608187 L26.9062498,3.88304094 C27.0349855,3.68888889 26.9057471,3.42951405 26.7126437,3.3647967 C26.616092,3.30007935 26.5034483,3.26873156 26.3908046,3.26873156 Z M21.8850575,3.88304094 C21.4988506,3.88304094 21.2413793,4.14191033 21.2413793,4.53021442 L21.2413793,5.17738791 L20.5977011,5.17738791 C20.2114943,5.17738791 19.954023,5.43625731 19.954023,5.8245614 C19.954023,6.2128655 20.2114943,6.47173489 20.5977011,6.47173489 L21.2413793,6.47173489 L21.2413793,7.11890838 C21.2413793,7.50721248 21.4988506,7.76608187 21.8850575,7.76608187 C22.2712644,7.76608187 22.5287356,7.50721248 22.5287356,7.11890838 L22.5287356,6.47173489 L23.1724138,6.47173489 C23.5586207,6.47173489 23.816092,6.2128655 23.816092,5.8245614 C23.816092,5.43625731 23.5586207,5.17738791 23.1724138,5.17738791 L22.5287356,5.17738791 L22.5287356,4.53021442 C22.5287356,4.14191033 22.2712644,3.88304094 21.8850575,3.88304094 Z M1.28735632,8.41325536 L1.93103448,8.41325536 L1.93103448,13.5906433 L1.28735632,13.5906433 L1.28735632,8.41325536 Z M31.5402299,8.41325536 L32.183908,8.41325536 L32.183908,13.5906433 L31.5402299,13.5906433 L31.5402299,8.41325536 Z M3.2183908,11.6491228 L30.2528736,11.6491228 L30.2528736,20.1609712 C30.2754023,20.1661486 30.2969758,20.1766347 30.3195046,20.1824593 C29.8772977,20.1099758 29.4276782,20.0623782 28.9655172,20.0623782 C28.5265287,20.0623782 28.0991264,20.1069827 27.6781609,20.1723472 L27.6781609,18.1208577 C27.6781609,17.4089669 27.0988506,16.8265107 26.3908046,16.8265107 L22.5287356,16.8265107 C21.8206897,16.8265107 21.2413793,17.4089669 21.2413793,18.1208577 L21.2413793,25.2448218 C20.8281379,26.2401746 20.5977011,27.3314308 20.5977011,28.4756335 C20.5977011,29.3790877 20.7442789,30.2482417 21.0075433,31.0643275 L3.86206897,31.0643275 C3.47586207,31.0643275 3.2183908,30.8054581 3.2183908,30.417154 L3.2183908,11.6491228 Z M7.08045977,12.9434698 C6.69425287,12.9434698 6.43678161,13.2023392 6.43678161,13.5906433 L6.43678161,14.8849903 C6.43678161,15.2732943 6.69425287,15.5321637 7.08045977,15.5321637 C7.46666667,15.5321637 7.72413793,15.2732943 7.72413793,14.8849903 L7.72413793,13.5906433 C7.72413793,13.2023392 7.46666667,12.9434698 7.08045977,12.9434698 Z M10.2988506,12.9434698 C9.91264368,12.9434698 9.65517241,13.2023392 9.65517241,13.5906433 L9.65517241,14.8849903 C9.65517241,15.2732943 9.91264368,15.5321637 10.2988506,15.5321637 C10.6850575,15.5321637 10.9425287,15.2732943 10.9425287,14.8849903 L10.9425287,13.5906433 C10.9425287,13.2023392 10.6850575,12.9434698 10.2988506,12.9434698 Z M13.5172414,12.9434698 C13.1310345,12.9434698 12.8735632,13.2023392 12.8735632,13.5906433 L12.8735632,14.8849903 C12.8735632,15.2732943 13.1310345,15.5321637 13.5172414,15.5321637 C13.9034483,15.5321637 14.1609195,15.2732943 14.1609195,14.8849903 L14.1609195,13.5906433 C14.1609195,13.2023392 13.9034483,12.9434698 13.5172414,12.9434698 Z M16.7356322,12.9434698 C16.3494253,12.9434698 16.091954,13.2023392 16.091954,13.5906433 L16.091954,14.8849903 C16.091954,15.2732943 16.3494253,15.5321637 16.7356322,15.5321637 C17.1218391,15.5321637 17.3793103,15.2732943 17.3793103,14.8849903 L17.3793103,13.5906433 C17.3793103,13.2023392 17.1218391,12.9434698 16.7356322,12.9434698 Z M19.954023,12.9434698 C19.5678161,12.9434698 19.3103448,13.2023392 19.3103448,13.5906433 L19.3103448,14.8849903 C19.3103448,15.2732943 19.5678161,15.5321637 19.954023,15.5321637 C20.3402299,15.5321637 20.5977011,15.2732943 20.5977011,14.8849903 L20.5977011,13.5906433 C20.5977011,13.2023392 20.3402299,12.9434698 19.954023,12.9434698 Z M23.1724138,12.9434698 C22.7862069,12.9434698 22.5287356,13.2023392 22.5287356,13.5906433 L22.5287356,14.8849903 C22.5287356,15.2732943 22.7862069,15.5321637 23.1724138,15.5321637 C23.5586207,15.5321637 23.816092,15.2732943 23.816092,14.8849903 L23.816092,13.5906433 C23.816092,13.2023392 23.5586207,12.9434698 23.1724138,12.9434698 Z M26.3908046,12.9434698 C26.0045977,12.9434698 25.7471264,13.2023392 25.7471264,13.5906433 L25.7471264,14.8849903 C25.7471264,15.2732943 26.0045977,15.5321637 26.3908046,15.5321637 C26.7770115,15.5321637 27.0344828,15.2732943 27.0344828,14.8849903 L27.0344828,13.5906433 C27.0344828,13.2023392 26.7770115,12.9434698 26.3908046,12.9434698 Z M7.08045977,16.8265107 C6.37241379,16.8265107 5.79310345,17.4089669 5.79310345,18.1208577 L5.79310345,20.7095517 C5.79310345,21.4214425 6.37241379,22.0038986 7.08045977,22.0038986 L10.9425287,22.0038986 C11.6505747,22.0038986 12.2298851,21.4214425 12.2298851,20.7095517 L12.2298851,18.1208577 C12.2298851,17.4089669 11.6505747,16.8265107 10.9425287,16.8265107 L7.08045977,16.8265107 Z M14.8045977,16.8265107 C14.0965517,16.8265107 13.5172414,17.4089669 13.5172414,18.1208577 L13.5172414,20.7095517 C13.5172414,21.4214425 14.0965517,22.0038986 14.8045977,22.0038986 L18.6666667,22.0038986 C19.3747126,22.0038986 19.954023,21.4214425 19.954023,20.7095517 L19.954023,18.1208577 C19.954023,17.4089669 19.3747126,16.8265107 18.6666667,16.8265107 L14.8045977,16.8265107 Z M7.08045977,18.1208577 L10.9425287,18.1208577 L10.9425287,20.7095517 L7.08045977,20.7095517 L7.08045977,18.1208577 Z M14.8045977,18.1208577 L18.6666667,18.1208577 L18.6666667,20.7095517 L14.8045977,20.7095517 L14.8045977,18.1208577 Z M22.5287356,18.1208577 L26.3908046,18.1208577 L26.3908046,20.4744458 C24.865931,20.9714751 23.5309425,21.8945768 22.5287356,23.1073799 L22.5287356,18.1208577 Z M28.9655172,21.3567251 C32.8694253,21.3567251 36.045977,24.5505263 36.045977,28.4756335 C36.045977,32.4007407 32.8694253,35.5945419 28.9655172,35.5945419 C25.0616092,35.5945419 21.8850575,32.4007407 21.8850575,28.4756335 C21.8850575,24.5505263 25.0616092,21.3567251 28.9655172,21.3567251 Z M28.9655172,22.6510721 C28.6095632,22.6510721 28.3218391,22.9410058 28.3218391,23.2982456 L28.3218391,23.9454191 C26.9018851,23.9454191 25.7471264,25.1064483 25.7471264,26.5341131 C25.7471264,27.9617778 26.9018851,29.122807 28.3218391,29.122807 L29.6091954,29.122807 C30.3191724,29.122807 30.8965517,29.7033216 30.8965517,30.417154 C30.8965517,31.1309864 30.3191724,31.711501 29.6091954,31.711501 L29.6091954,30.417154 C29.6091954,30.0599142 29.3214713,29.7699805 28.9655172,29.7699805 C28.6095632,29.7699805 28.3218391,30.0599142 28.3218391,30.417154 L28.3218391,31.711501 C27.6118621,31.711501 27.0344828,31.1309864 27.0344828,30.417154 C27.0344828,30.0599142 26.7467586,29.7699805 26.3908046,29.7699805 C26.0348506,29.7699805 25.7471264,30.0599142 25.7471264,30.417154 C25.7471264,31.8448187 26.9018851,33.005848 28.3218391,33.005848 L28.3218391,33.6530214 C28.3218391,34.0102612 28.6095632,34.3001949 28.9655172,34.3001949 C29.3214713,34.3001949 29.6091954,34.0102612 29.6091954,33.6530214 L29.6091954,33.005848 C31.0291494,33.005848 32.183908,31.8448187 32.183908,30.417154 C32.183908,28.9894893 31.0291494,27.82846 29.6091954,27.82846 L29.6091954,26.5341131 C29.6091954,26.1768733 29.3214713,25.8869396 28.9655172,25.8869396 C28.6095632,25.8869396 28.3218391,26.1768733 28.3218391,26.5341131 L28.3218391,27.82846 C27.6118621,27.82846 27.0344828,27.2479454 27.0344828,26.5341131 C27.0344828,25.8202807 27.6118621,25.2397661 28.3218391,25.2397661 L29.6091954,25.2397661 C30.3191724,25.2397661 30.8965517,25.8202807 30.8965517,26.5341131 C30.8965517,26.8913528 31.1842759,27.1812865 31.5402299,27.1812865 C31.8961839,27.1812865 32.183908,26.8913528 32.183908,26.5341131 C32.183908,25.1064483 31.0291494,23.9454191 29.6091954,23.9454191 L29.6091954,23.2982456 C29.6091954,22.9410058 29.3214713,22.6510721 28.9655172,22.6510721 Z M7.08045977,23.2982456 C6.37241379,23.2982456 5.79310345,23.8807018 5.79310345,24.5925926 L5.79310345,27.1812865 C5.79310345,27.8931774 6.37241379,28.4756335 7.08045977,28.4756335 L10.9425287,28.4756335 C11.6505747,28.4756335 12.2298851,27.8931774 12.2298851,27.1812865 L12.2298851,24.5925926 C12.2298851,23.8807018 11.6505747,23.2982456 10.9425287,23.2982456 L7.08045977,23.2982456 Z M14.8045977,23.2982456 C14.0965517,23.2982456 13.5172414,23.8807018 13.5172414,24.5925926 L13.5172414,27.1812865 C13.5172414,27.8931774 14.0965517,28.4756335 14.8045977,28.4756335 L18.6666667,28.4756335 C19.3747126,28.4756335 19.954023,27.8931774 19.954023,27.1812865 L19.954023,24.5925926 C19.954023,23.8807018 19.3747126,23.2982456 18.6666667,23.2982456 L14.8045977,23.2982456 Z M7.08045977,24.5925926 L10.9425287,24.5925926 L10.9425287,27.1812865 L7.08045977,27.1812865 L7.08045977,24.5925926 Z M14.8045977,24.5925926 L18.6666667,24.5925926 L18.6666667,27.1812865 L14.8045977,27.1812865 L14.8045977,24.5925926 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'icons8-estimate',
                                    tabindex: '-1',
                                    transform: 'translate(1.333333, 1.777778)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/delete-terminate',
                                tabindex: '-1',
                                transform: 'translate(26.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'delete-terminate',
                            tabindex: '-1',
                            transform: 'translate(1302.000000, 595.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1328.000000, -595.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-calculator',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Calculator',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '53122B1D-7AC6-4EA9-8018-D9FB63814403',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M3.01075269,0 C1.35062366,0 0,1.33673737 0,2.97979798 L0,23.2424242 C0,24.8854848 1.35062366,26.2222222 3.01075269,26.2222222 L34.3225806,26.2222222 C35.9827097,26.2222222 37.3333333,24.8854848 37.3333333,23.2424242 L37.3333333,2.97979798 C37.3333333,1.33673737 35.9827097,0 34.3225806,0 L3.01075269,0 Z M3.01075269,1.19191919 L34.3225806,1.19191919 C35.3185376,1.19191919 36.1290323,1.99408081 36.1290323,2.97979798 L36.1290323,23.2424242 C36.1290323,24.2281414 35.3185376,25.030303 34.3225806,25.030303 L3.01075269,25.030303 C2.0147957,25.030303 1.20430108,24.2281414 1.20430108,23.2424242 L1.20430108,2.97979798 C1.20430108,1.99408081 2.0147957,1.19191919 3.01075269,1.19191919 Z M3.61290323,2.38383838 C3.27991398,2.38383838 3.01075269,2.65082828 3.01075269,2.97979798 L3.01075269,4.17171717 C3.01075269,4.50068687 3.27991398,4.76767677 3.61290323,4.76767677 C3.94589247,4.76767677 4.21505376,4.50068687 4.21505376,4.17171717 L4.21505376,2.97979798 C4.21505376,2.65082828 3.94589247,2.38383838 3.61290323,2.38383838 Z M6.62365591,2.38383838 C6.29066667,2.38383838 6.02150538,2.65082828 6.02150538,2.97979798 L6.02150538,4.17171717 C6.02150538,4.50068687 6.29066667,4.76767677 6.62365591,4.76767677 C6.95664516,4.76767677 7.22580645,4.50068687 7.22580645,4.17171717 L7.22580645,2.97979798 C7.22580645,2.65082828 6.95664516,2.38383838 6.62365591,2.38383838 Z M9.6344086,2.38383838 C9.30141935,2.38383838 9.03225806,2.65082828 9.03225806,2.97979798 L9.03225806,4.17171717 C9.03225806,4.50068687 9.30141935,4.76767677 9.6344086,4.76767677 C9.96739785,4.76767677 10.2365591,4.50068687 10.2365591,4.17171717 L10.2365591,2.97979798 C10.2365591,2.65082828 9.96739785,2.38383838 9.6344086,2.38383838 Z M12.6451613,2.38383838 C12.312172,2.38383838 12.0430108,2.65082828 12.0430108,2.97979798 L12.0430108,4.17171717 C12.0430108,4.50068687 12.312172,4.76767677 12.6451613,4.76767677 C12.9781505,4.76767677 13.2473118,4.50068687 13.2473118,4.17171717 L13.2473118,2.97979798 C13.2473118,2.65082828 12.9781505,2.38383838 12.6451613,2.38383838 Z M15.655914,2.38383838 C15.3229247,2.38383838 15.0537634,2.65082828 15.0537634,2.97979798 L15.0537634,4.17171717 C15.0537634,4.50068687 15.3229247,4.76767677 15.655914,4.76767677 C15.9889032,4.76767677 16.2580645,4.50068687 16.2580645,4.17171717 L16.2580645,2.97979798 C16.2580645,2.65082828 15.9889032,2.38383838 15.655914,2.38383838 Z M18.6666667,2.38383838 C18.3336774,2.38383838 18.0645161,2.65082828 18.0645161,2.97979798 L18.0645161,4.17171717 C18.0645161,4.50068687 18.3336774,4.76767677 18.6666667,4.76767677 C18.9996559,4.76767677 19.2688172,4.50068687 19.2688172,4.17171717 L19.2688172,2.97979798 C19.2688172,2.65082828 18.9996559,2.38383838 18.6666667,2.38383838 Z M21.6774194,2.38383838 C21.3444301,2.38383838 21.0752688,2.65082828 21.0752688,2.97979798 L21.0752688,4.17171717 C21.0752688,4.50068687 21.3444301,4.76767677 21.6774194,4.76767677 C22.0104086,4.76767677 22.2795699,4.50068687 22.2795699,4.17171717 L22.2795699,2.97979798 C22.2795699,2.65082828 22.0104086,2.38383838 21.6774194,2.38383838 Z M24.688172,2.38383838 C24.3551828,2.38383838 24.0860215,2.65082828 24.0860215,2.97979798 L24.0860215,4.17171717 C24.0860215,4.50068687 24.3551828,4.76767677 24.688172,4.76767677 C25.0211613,4.76767677 25.2903226,4.50068687 25.2903226,4.17171717 L25.2903226,2.97979798 C25.2903226,2.65082828 25.0211613,2.38383838 24.688172,2.38383838 Z M27.6989247,2.38383838 C27.3659355,2.38383838 27.0967742,2.65082828 27.0967742,2.97979798 L27.0967742,4.17171717 C27.0967742,4.50068687 27.3659355,4.76767677 27.6989247,4.76767677 C28.031914,4.76767677 28.3010753,4.50068687 28.3010753,4.17171717 L28.3010753,2.97979798 C28.3010753,2.65082828 28.031914,2.38383838 27.6989247,2.38383838 Z M30.7096774,2.38383838 C30.3766882,2.38383838 30.1075269,2.65082828 30.1075269,2.97979798 L30.1075269,4.17171717 C30.1075269,4.50068687 30.3766882,4.76767677 30.7096774,4.76767677 C31.0426667,4.76767677 31.311828,4.50068687 31.311828,4.17171717 L31.311828,2.97979798 C31.311828,2.65082828 31.0426667,2.38383838 30.7096774,2.38383838 Z M33.7204301,2.38383838 C33.3874409,2.38383838 33.1182796,2.65082828 33.1182796,2.97979798 L33.1182796,4.17171717 C33.1182796,4.50068687 33.3874409,4.76767677 33.7204301,4.76767677 C34.0534194,4.76767677 34.3225806,4.50068687 34.3225806,4.17171717 L34.3225806,2.97979798 C34.3225806,2.65082828 34.0534194,2.38383838 33.7204301,2.38383838 Z M11.4408602,6.55555556 C9.11294624,6.55555556 7.22580645,8.42329293 7.22580645,10.7272727 L7.22580645,11.9191919 C7.24387097,12.9227879 7.55592585,13.9005806 8.12315166,14.7325402 C6.15351725,15.458419 4.55322717,16.926035 3.67288308,18.8146304 C3.50849598,19.100691 3.60965727,19.4643944 3.89868953,19.6270914 C4.18772179,19.7897883 4.55637906,19.6896671 4.72076616,19.4036065 C4.73521771,19.3791722 4.74638574,19.353006 4.75722445,19.3267838 C5.56470856,17.5722781 7.10320318,16.2520417 8.97227845,15.7091225 C9.64548275,16.3253447 10.5255631,16.6737576 11.4420362,16.6868687 C12.3567029,16.6719697 13.2333401,16.3235568 13.904738,15.7091225 C15.7744154,16.2514457 17.31291,17.5716822 18.1197917,19.3267838 C18.2197487,19.535965 18.4330323,19.6684545 18.6666667,19.6666667 C18.9990538,19.6654747 19.2676695,19.3973489 19.2664692,19.0683793 C19.2664692,18.9801772 19.2467731,18.8938936 19.2088376,18.8146304 C18.3266871,16.9278229 16.7269989,15.4630472 14.7585688,14.7383603 C15.3269989,13.9046128 15.6390538,12.9251717 15.655914,11.9191919 L15.655914,10.7272727 C15.655914,8.42329293 13.7687742,6.55555556 11.4408602,6.55555556 Z M11.4408602,7.74747475 C13.1033978,7.74747475 14.4516129,9.08182828 14.4516129,10.7272727 L14.4516129,11.9191919 C14.4516129,13.540202 13.1088172,15.4949495 11.4408602,15.4949495 C9.77290323,15.4949495 8.43010753,13.540202 8.43010753,11.9191919 L8.43010753,10.7272727 C8.43010753,9.08182828 9.77832258,7.74747475 11.4408602,7.74747475 Z M22.2795699,8.93939394 C21.9471828,8.93939394 21.6774194,9.20638384 21.6774194,9.53535354 C21.6774194,9.86432323 21.9471828,10.1313131 22.2795699,10.1313131 L28.3010753,10.1313131 C28.6334624,10.1313131 28.9032258,9.86432323 28.9032258,9.53535354 C28.9032258,9.20638384 28.6334624,8.93939394 28.3010753,8.93939394 L22.2795699,8.93939394 Z M30.7096774,8.93939394 C30.3772903,8.93939394 30.1075269,9.20638384 30.1075269,9.53535354 C30.1075269,9.86432323 30.3772903,10.1313131 30.7096774,10.1313131 L33.1182796,10.1313131 C33.4506667,10.1313131 33.7204301,9.86432323 33.7204301,9.53535354 C33.7204301,9.20638384 33.4506667,8.93939394 33.1182796,8.93939394 L30.7096774,8.93939394 Z M22.2795699,12.5151515 C21.9471828,12.5151515 21.6774194,12.7821414 21.6774194,13.1111111 C21.6774194,13.4400808 21.9471828,13.7070707 22.2795699,13.7070707 L33.1182796,13.7070707 C33.4506667,13.7070707 33.7204301,13.4400808 33.7204301,13.1111111 C33.7204301,12.7821414 33.4506667,12.5151515 33.1182796,12.5151515 L22.2795699,12.5151515 Z M22.2795699,16.0909091 C21.9471828,16.0909091 21.6774194,16.357899 21.6774194,16.6868687 C21.6774194,17.0158384 21.9471828,17.2828283 22.2795699,17.2828283 L29.5053763,17.2828283 C29.8377634,17.2828283 30.1075269,17.0158384 30.1075269,16.6868687 C30.1075269,16.357899 29.8377634,16.0909091 29.5053763,16.0909091 L22.2795699,16.0909091 Z M3.61290323,21.4545455 C3.27991398,21.4545455 3.01075269,21.7215354 3.01075269,22.0505051 L3.01075269,23.2424242 C3.01075269,23.5713939 3.27991398,23.8383838 3.61290323,23.8383838 C3.94589247,23.8383838 4.21505376,23.5713939 4.21505376,23.2424242 L4.21505376,22.0505051 C4.21505376,21.7215354 3.94589247,21.4545455 3.61290323,21.4545455 Z M6.62365591,21.4545455 C6.29066667,21.4545455 6.02150538,21.7215354 6.02150538,22.0505051 L6.02150538,23.2424242 C6.02150538,23.5713939 6.29066667,23.8383838 6.62365591,23.8383838 C6.95664516,23.8383838 7.22580645,23.5713939 7.22580645,23.2424242 L7.22580645,22.0505051 C7.22580645,21.7215354 6.95664516,21.4545455 6.62365591,21.4545455 Z M9.6344086,21.4545455 C9.30141935,21.4545455 9.03225806,21.7215354 9.03225806,22.0505051 L9.03225806,23.2424242 C9.03225806,23.5713939 9.30141935,23.8383838 9.6344086,23.8383838 C9.96739785,23.8383838 10.2365591,23.5713939 10.2365591,23.2424242 L10.2365591,22.0505051 C10.2365591,21.7215354 9.96739785,21.4545455 9.6344086,21.4545455 Z M12.6451613,21.4545455 C12.312172,21.4545455 12.0430108,21.7215354 12.0430108,22.0505051 L12.0430108,23.2424242 C12.0430108,23.5713939 12.312172,23.8383838 12.6451613,23.8383838 C12.9781505,23.8383838 13.2473118,23.5713939 13.2473118,23.2424242 L13.2473118,22.0505051 C13.2473118,21.7215354 12.9781505,21.4545455 12.6451613,21.4545455 Z M15.655914,21.4545455 C15.3229247,21.4545455 15.0537634,21.7215354 15.0537634,22.0505051 L15.0537634,23.2424242 C15.0537634,23.5713939 15.3229247,23.8383838 15.655914,23.8383838 C15.9889032,23.8383838 16.2580645,23.5713939 16.2580645,23.2424242 L16.2580645,22.0505051 C16.2580645,21.7215354 15.9889032,21.4545455 15.655914,21.4545455 Z M18.6666667,21.4545455 C18.3336774,21.4545455 18.0645161,21.7215354 18.0645161,22.0505051 L18.0645161,23.2424242 C18.0645161,23.5713939 18.3336774,23.8383838 18.6666667,23.8383838 C18.9996559,23.8383838 19.2688172,23.5713939 19.2688172,23.2424242 L19.2688172,22.0505051 C19.2688172,21.7215354 18.9996559,21.4545455 18.6666667,21.4545455 Z M21.6774194,21.4545455 C21.3444301,21.4545455 21.0752688,21.7215354 21.0752688,22.0505051 L21.0752688,23.2424242 C21.0752688,23.5713939 21.3444301,23.8383838 21.6774194,23.8383838 C22.0104086,23.8383838 22.2795699,23.5713939 22.2795699,23.2424242 L22.2795699,22.0505051 C22.2795699,21.7215354 22.0104086,21.4545455 21.6774194,21.4545455 Z M24.688172,21.4545455 C24.3551828,21.4545455 24.0860215,21.7215354 24.0860215,22.0505051 L24.0860215,23.2424242 C24.0860215,23.5713939 24.3551828,23.8383838 24.688172,23.8383838 C25.0211613,23.8383838 25.2903226,23.5713939 25.2903226,23.2424242 L25.2903226,22.0505051 C25.2903226,21.7215354 25.0211613,21.4545455 24.688172,21.4545455 Z M27.6989247,21.4545455 C27.3659355,21.4545455 27.0967742,21.7215354 27.0967742,22.0505051 L27.0967742,23.2424242 C27.0967742,23.5713939 27.3659355,23.8383838 27.6989247,23.8383838 C28.031914,23.8383838 28.3010753,23.5713939 28.3010753,23.2424242 L28.3010753,22.0505051 C28.3010753,21.7215354 28.031914,21.4545455 27.6989247,21.4545455 Z M30.7096774,21.4545455 C30.3766882,21.4545455 30.1075269,21.7215354 30.1075269,22.0505051 L30.1075269,23.2424242 C30.1075269,23.5713939 30.3766882,23.8383838 30.7096774,23.8383838 C31.0426667,23.8383838 31.311828,23.5713939 31.311828,23.2424242 L31.311828,22.0505051 C31.311828,21.7215354 31.0426667,21.4545455 30.7096774,21.4545455 Z M33.7204301,21.4545455 C33.3874409,21.4545455 33.1182796,21.7215354 33.1182796,22.0505051 L33.1182796,23.2424242 C33.1182796,23.5713939 33.3874409,23.8383838 33.7204301,23.8383838 C34.0534194,23.8383838 34.3225806,23.5713939 34.3225806,23.2424242 L34.3225806,22.0505051 C34.3225806,21.7215354 34.0534194,21.4545455 33.7204301,21.4545455 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'icons8-name-tag',
                                    tabindex: '-1',
                                    transform: 'translate(1.333333, 6.666667)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/delete-terminate',
                                tabindex: '-1',
                                transform: 'translate(26.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'delete-terminate',
                            tabindex: '-1',
                            transform: 'translate(1188.000000, 595.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1214.000000, -595.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-id_product',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'ID',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'D61BEA41-6FF7-46CB-AA04-3C069E031AF6',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M10.5260753,0 C7.83122131,0 5.13636727,1.01593981 3.08231695,3.04781848 C1.09532768,5.0182004 0,7.63553605 0,10.4226048 C0,13.2072137 1.09532768,15.8245494 3.08231695,17.7949307 L15.6202193,30.2125156 C15.635122,30.2297351 15.6425727,30.2494143 15.659959,30.2666338 L16.559072,31.1571179 C16.5764577,31.1743374 16.5988118,31.1817173 16.6161975,31.1964764 L17.7686512,32.3378709 C18.1287935,32.6945565 18.6081545,32.8888889 19.1173204,32.8888889 C19.6264862,32.8888889 20.1058479,32.6945565 20.4659895,32.3378709 L35.1399053,17.7949307 C37.1268945,15.8245494 38.2222222,13.2072137 38.2222222,10.4226048 C38.2222222,7.63553605 37.1268945,5.0182004 35.1399053,3.04781848 C31.0342888,-1.01593949 24.3555207,-1.01593949 20.2499043,3.04781848 L19.109869,4.17691363 L17.972318,3.04781848 C15.9182676,1.01593981 13.2234136,0 10.5260753,0 Z M10.5260753,1.25947026 C12.898044,1.25947026 15.267529,2.15241418 17.0707214,3.94076304 L18.2132403,5.06985818 L16.7900593,6.47692208 C16.5416857,6.72291227 16.5416857,7.12141607 16.7900593,7.36740626 C16.9142459,7.49040168 17.0756892,7.55189907 17.2396155,7.55189907 C17.4035424,7.55189907 17.5649852,7.49040168 17.6891717,7.36740626 L20.2722577,4.80910826 L21.1515008,3.94076304 C24.7603699,0.366525702 30.6294396,0.366525702 34.2383087,3.94076304 C35.9868593,5.67007425 36.9505491,7.97254245 36.9505491,10.4226048 C36.9505491,12.8702073 35.9868593,15.1726755 34.2383087,16.9019861 L19.5668765,31.4449263 C19.3259542,31.6835373 18.9086865,31.685997 18.6677642,31.4449263 L3.98142991,16.9019861 C2.23536293,15.1726755 1.27167313,12.8702073 1.27167313,10.4226048 C1.27167313,7.97254245 2.23536293,5.672534 3.98142991,3.94076304 C5.78710594,2.15241418 8.15659096,1.25947026 10.5260753,1.25947026 Z M15.3321058,8.18163396 C15.1706631,8.18163396 15.0067362,8.24313135 14.8825496,8.36612676 L13.6108765,9.62559655 C13.3625029,9.87158674 13.3625029,10.2700905 13.6108765,10.5160807 C13.735063,10.6390761 13.8965064,10.7005735 14.0604327,10.7005735 C14.2243596,10.7005735 14.3858023,10.6390761 14.5099888,10.5160807 L15.781662,9.25661094 C16.0300356,9.01062075 16.0300356,8.61211695 15.781662,8.36612676 C15.6574755,8.24313135 15.4935485,8.18163396 15.3321058,8.18163396 Z M31.8439867,13.6057175 C31.6825439,13.6057175 31.5211012,13.6672156 31.3969141,13.7902103 C31.1460568,14.0386603 31.1460568,14.434705 31.3969141,14.6831549 L32.2935428,15.5711793 C32.41773,15.6941748 32.5816563,15.7581319 32.7455832,15.7581319 C32.9070259,15.7581319 33.0709529,15.6941748 33.1951394,15.5711793 C33.443513,15.3251891 33.443513,14.9291451 33.1951394,14.6831549 L32.2935428,13.7902103 C32.1693563,13.6672156 32.0079136,13.6057175 31.8439867,13.6057175 Z M29.5986888,15.834389 C29.4347625,15.834389 29.2733191,15.8958864 29.1491326,16.0164214 C28.8982754,16.2624116 28.8982754,16.660916 29.1491326,16.909366 L30.0457614,17.7973904 C30.1699485,17.9203858 30.3338748,17.9818832 30.4953175,17.9818832 C30.6592445,17.9818832 30.8231708,17.9203858 30.9473579,17.7973904 C31.1957316,17.5514002 31.1957316,17.1528964 30.9473579,16.9069062 L30.0457614,16.0164214 C29.9215749,15.8958864 29.7601315,15.834389 29.5986888,15.834389 Z M27.3484237,18.0606001 C27.1869804,18.0606001 27.0230541,18.1196377 26.898867,18.2450929 C26.6504933,18.4910831 26.6504933,18.8871271 26.898867,19.1331173 L27.7979799,20.0260619 C27.9221664,20.1465969 28.0836098,20.2080943 28.2475361,20.2080943 C28.411463,20.2080943 28.5729057,20.1465969 28.6970922,20.0260619 C28.9454659,19.7776119 28.9454659,19.3815673 28.6970922,19.1331173 L27.7979799,18.2450929 C27.6737928,18.1196377 27.5098665,18.0606001 27.3484237,18.0606001 Z M25.1006417,20.2868112 C24.9391989,20.2868112 24.7752726,20.3483092 24.6510855,20.471304 C24.4027118,20.7172942 24.4027118,21.1157986 24.6510855,21.3617888 L25.5501985,22.252273 C25.674385,22.3752684 25.8358277,22.4367658 25.9997546,22.4367658 C26.1636809,22.4367658 26.3251243,22.3752684 26.4493108,22.252273 C26.6976844,22.0062828 26.6976844,21.607779 26.4493108,21.3617888 L25.5501985,20.471304 C25.4260113,20.3483092 25.262085,20.2868112 25.1006417,20.2868112 Z M22.8528602,22.5105625 C22.6914175,22.5105625 22.5274906,22.5745203 22.403304,22.6975151 C22.1549304,22.9435053 22.1549304,23.3420097 22.403304,23.5879999 L23.3024164,24.4784841 C23.4266035,24.6014795 23.5880462,24.6629769 23.7519732,24.6629769 C23.9158995,24.6629769 24.0773422,24.6014795 24.2015293,24.4784841 C24.449903,24.2324939 24.449903,23.8339901 24.2015293,23.5879999 L23.3024164,22.6975151 C23.1782299,22.5745203 23.0143029,22.5105625 22.8528602,22.5105625 Z M20.6050787,24.739234 C20.443636,24.739234 20.2797091,24.8007314 20.1555226,24.9237268 C19.9071489,25.169717 19.9071489,25.5682208 20.1555226,25.814211 L21.0546349,26.7046958 C21.1788221,26.8276905 21.3402648,26.8891879 21.5041911,26.8891879 C21.668118,26.8891879 21.8295607,26.8276905 21.9537479,26.7046958 C22.2021215,26.4587056 22.2021215,26.0602011 21.9537479,25.814211 L21.0546349,24.9237268 C20.9304484,24.8007314 20.7665215,24.739234 20.6050787,24.739234 Z M18.3572973,26.9654451 C18.1958539,26.9654451 18.0319276,27.0269424 17.9077405,27.1499379 C17.6593668,27.395928 17.6593668,27.7944318 17.9077405,28.040422 L18.8068535,28.9309068 C18.93104,29.0539016 19.0924833,29.1153997 19.2564096,29.1153997 C19.4203366,29.1153997 19.5817793,29.0539016 19.7059658,28.9309068 C19.9543394,28.6849167 19.9543394,28.2864122 19.7059658,28.040422 L18.8068535,27.1499379 C18.6826663,27.0269424 18.51874,26.9654451 18.3572973,26.9654451 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'icons8-heart-outline',
                                    tabindex: '-1',
                                    transform: 'translate(0.888889, 3.555556)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/delete-terminate',
                                tabindex: '-1',
                                transform: 'translate(26.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'delete-terminate',
                            tabindex: '-1',
                            transform: 'translate(1074.000000, 595.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1100.000000, -595.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-heart_product',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Heart',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '73CD95B7-25D1-44DC-B60C-9388E92151D4',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M1.86666667,0 C0.838541511,0 0,0.841393693 0,1.87301587 L0,24.3492063 C0,25.3808285 0.838541511,26.2222222 1.86666667,26.2222222 L35.4666667,26.2222222 C36.4947918,26.2222222 37.3333333,25.3808285 37.3333333,24.3492063 L37.3333333,1.87301587 C37.3333333,0.841393693 36.4947918,0 35.4666667,0 L1.86666667,0 Z M1.86666667,1.24867725 L35.4666667,1.24867725 C35.8093748,1.24867725 36.0888889,1.52914202 36.0888889,1.87301587 L36.0888889,2.17786856 L19.3958333,14.3085732 C18.9607637,14.6256199 18.3725696,14.6256199 17.9375,14.3085732 L1.24444444,2.17786856 L1.24444444,1.87301587 C1.24444444,1.52914202 1.52395849,1.24867725 1.86666667,1.24867725 Z M1.24444444,3.71920454 L17.2083333,15.3182455 C17.6434029,15.6352928 18.1562503,15.7938161 18.6666667,15.7938161 C19.1770836,15.7938161 19.6899304,15.6352928 20.125,15.3182455 L36.0888889,3.71920454 L36.0888889,19.4910714 L25.8027778,13.2013474 C25.5086807,13.0208748 25.1246526,13.1159891 24.9472222,13.4110865 C24.7697918,13.7061839 24.8621526,14.0890789 25.1538193,14.2695521 L36.0888889,20.9543651 L36.0888889,24.3492063 C36.0888889,24.6930802 35.8093748,24.973545 35.4666667,24.973545 L1.86666667,24.973545 C1.52395849,24.973545 1.24444444,24.6930802 1.24444444,24.3492063 L1.24444444,20.9543651 L12.179514,14.2695521 C12.4711807,14.0890789 12.5659725,13.7037452 12.3861111,13.4110865 C12.2062503,13.1159891 11.8246526,13.0208748 11.5305556,13.2013474 L1.24444444,19.4910714 L1.24444444,3.71920454 Z M3.11111111,21.2275132 C2.76840293,21.2275132 2.48888889,21.5055393 2.48888889,21.8518519 L2.48888889,23.1005291 C2.48888889,23.4468422 2.76840293,23.7248677 3.11111111,23.7248677 C3.45381929,23.7248677 3.73333333,23.4468422 3.73333333,23.1005291 L3.73333333,21.8518519 C3.73333333,21.5055393 3.45381929,21.2275132 3.11111111,21.2275132 Z M6.22222222,21.2275132 C5.87951404,21.2275132 5.6,21.5055393 5.6,21.8518519 L5.6,23.1005291 C5.6,23.4468422 5.87951404,23.7248677 6.22222222,23.7248677 C6.5649304,23.7248677 6.84444444,23.4468422 6.84444444,23.1005291 L6.84444444,21.8518519 C6.84444444,21.5055393 6.5649304,21.2275132 6.22222222,21.2275132 Z M9.33333333,21.2275132 C8.99062516,21.2275132 8.71111111,21.5055393 8.71111111,21.8518519 L8.71111111,23.1005291 C8.71111111,23.4468422 8.99062516,23.7248677 9.33333333,23.7248677 C9.67604151,23.7248677 9.95555556,23.4468422 9.95555556,23.1005291 L9.95555556,21.8518519 C9.95555556,21.5055393 9.67604151,21.2275132 9.33333333,21.2275132 Z M12.4444444,21.2275132 C12.1017363,21.2275132 11.8222222,21.5055393 11.8222222,21.8518519 L11.8222222,23.1005291 C11.8222222,23.4468422 12.1017363,23.7248677 12.4444444,23.7248677 C12.7871526,23.7248677 13.0666667,23.4468422 13.0666667,23.1005291 L13.0666667,21.8518519 C13.0666667,21.5055393 12.7871526,21.2275132 12.4444444,21.2275132 Z M15.5555556,21.2275132 C15.2128474,21.2275132 14.9333333,21.5055393 14.9333333,21.8518519 L14.9333333,23.1005291 C14.9333333,23.4468422 15.2128474,23.7248677 15.5555556,23.7248677 C15.8982637,23.7248677 16.1777778,23.4468422 16.1777778,23.1005291 L16.1777778,21.8518519 C16.1777778,21.5055393 15.8982637,21.2275132 15.5555556,21.2275132 Z M18.6666667,21.2275132 C18.3239585,21.2275132 18.0444444,21.5055393 18.0444444,21.8518519 L18.0444444,23.1005291 C18.0444444,23.4468422 18.3239585,23.7248677 18.6666667,23.7248677 C19.0093748,23.7248677 19.2888889,23.4468422 19.2888889,23.1005291 L19.2888889,21.8518519 C19.2888889,21.5055393 19.0093748,21.2275132 18.6666667,21.2275132 Z M21.7777778,21.2275132 C21.4350696,21.2275132 21.1555556,21.5055393 21.1555556,21.8518519 L21.1555556,23.1005291 C21.1555556,23.4468422 21.4350696,23.7248677 21.7777778,23.7248677 C22.120486,23.7248677 22.4,23.4468422 22.4,23.1005291 L22.4,21.8518519 C22.4,21.5055393 22.120486,21.2275132 21.7777778,21.2275132 Z M24.8888889,21.2275132 C24.5461807,21.2275132 24.2666667,21.5055393 24.2666667,21.8518519 L24.2666667,23.1005291 C24.2666667,23.4468422 24.5461807,23.7248677 24.8888889,23.7248677 C25.2315971,23.7248677 25.5111111,23.4468422 25.5111111,23.1005291 L25.5111111,21.8518519 C25.5111111,21.5055393 25.2315971,21.2275132 24.8888889,21.2275132 Z M28,21.2275132 C27.6572918,21.2275132 27.3777778,21.5055393 27.3777778,21.8518519 L27.3777778,23.1005291 C27.3777778,23.4468422 27.6572918,23.7248677 28,23.7248677 C28.3427082,23.7248677 28.6222222,23.4468422 28.6222222,23.1005291 L28.6222222,21.8518519 C28.6222222,21.5055393 28.3427082,21.2275132 28,21.2275132 Z M31.1111111,21.2275132 C30.7684029,21.2275132 30.4888889,21.5055393 30.4888889,21.8518519 L30.4888889,23.1005291 C30.4888889,23.4468422 30.7684029,23.7248677 31.1111111,23.7248677 C31.4538193,23.7248677 31.7333333,23.4468422 31.7333333,23.1005291 L31.7333333,21.8518519 C31.7333333,21.5055393 31.4538193,21.2275132 31.1111111,21.2275132 Z M34.2222222,21.2275132 C33.879514,21.2275132 33.6,21.5055393 33.6,21.8518519 L33.6,23.1005291 C33.6,23.4468422 33.879514,23.7248677 34.2222222,23.7248677 C34.5649304,23.7248677 34.8444444,23.4468422 34.8444444,23.1005291 L34.8444444,21.8518519 C34.8444444,21.5055393 34.5649304,21.2275132 34.2222222,21.2275132 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'icons8-secured-letter',
                                    tabindex: '-1',
                                    transform: 'translate(1.333333, 7.111111)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/delete-terminate',
                                tabindex: '-1',
                                transform: 'translate(26.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'delete-terminate',
                            tabindex: '-1',
                            transform: 'translate(960.000000, 595.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-986.000000, -595.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-email_product',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Email',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '789CEB8E-4A88-461C-B04E-E0765754C312',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M17.4,0 C9.9914064,0 3.9304686,5.88978495 3.6140628,13.2473118 L3,13.2473118 C1.3453128,13.2473118 0,14.5974465 0,16.2580645 L0,24.688172 C0,26.3487906 1.3453128,27.6989247 3,27.6989247 L4.9101564,27.6989247 C5.1585936,28.3975133 5.8195314,28.9032258 6.6,28.9032258 C7.5914064,28.9032258 8.4,28.091734 8.4,27.0967742 L8.4,13.8494624 C8.4,12.8545025 7.5914064,12.0430108 6.6,12.0430108 C5.8195314,12.0430108 5.1585936,12.5487233 4.9101564,13.2473118 L4.8304686,13.2473118 C4.959375,10.547043 5.925,8.07022865 7.4859378,6.07090039 L10.2023436,8.747648 C10.6710936,9.20866951 11.2804686,9.44388456 11.8875,9.44388456 C12.421875,9.44388456 12.95625,9.26276912 13.396875,8.89583363 C14.6835936,7.81854839 16.3195314,7.22580645 18,7.22580645 C19.6734378,7.22580645 21.3046878,7.81619639 22.5914064,8.88642503 C23.5335936,9.66969101 24.9070314,9.6014788 25.7882814,8.7288308 L28.4929686,6.04502718 C30.065625,8.04905944 31.040625,10.5352824 31.1695314,13.2473118 L31.0875,13.2473118 C30.8414064,12.5463713 30.1804686,12.0430108 29.4,12.0430108 C28.40625,12.0430108 27.6,12.8521505 27.6,13.8494624 L27.6,27.0967742 C27.6,28.091734 28.40625,28.9032258 29.4,28.9032258 C30.1804686,28.9032258 30.8414064,28.3975133 31.0875,27.6989247 L31.8,27.6989247 L31.8,28.9032258 C31.8,31.8904573 29.3789064,34.3225806 26.4,34.3225806 L22.715625,34.3225806 C22.4460936,33.2852824 21.515625,32.516129 20.4,32.516129 L19.2,32.516129 C17.8757814,32.516129 16.8,33.5957663 16.8,34.9247312 C16.8,36.2513441 17.8757814,37.3333333 19.2,37.3333333 L20.4,37.3333333 C21.515625,37.3333333 22.4460936,36.561828 22.715625,35.5268817 L26.4,35.5268817 C30.0398436,35.5268817 33,32.5537634 33,28.9032258 L33,27.6989247 C34.6546878,27.6989247 36,26.346438 36,24.688172 L36,16.2580645 C36,14.5974465 34.6546878,13.2473118 33,13.2473118 L32.3835936,13.2473118 C32.0695314,5.88978495 26.0085936,0 18.6,0 L17.4,0 Z M17.4,1.20430108 L18.6,1.20430108 C22.18125,1.20430108 25.4109378,2.71908602 27.7054686,5.13239277 L24.9445314,7.872648 C24.5039064,8.3101477 23.821875,8.34307811 23.3554686,7.95967742 C21.8554686,6.71068533 19.9546878,6.02150538 18,6.02150538 C16.040625,6.02150538 14.1328128,6.71303794 12.628125,7.96908602 C12.1664064,8.35483871 11.484375,8.3219089 11.04375,7.8867606 L8.2710936,5.15826598 C10.5679686,2.72849462 13.8070314,1.20430108 17.4,1.20430108 Z M18,2.40860215 C17.6671878,2.40860215 17.4,2.67674761 17.4,3.01075269 L17.4,4.21505376 C17.4,4.54905944 17.6671878,4.8172043 18,4.8172043 C18.3328128,4.8172043 18.6,4.54905944 18.6,4.21505376 L18.6,3.01075269 C18.6,2.67674761 18.3328128,2.40860215 18,2.40860215 Z M21.2554686,2.85551105 C21.0257814,2.88608886 20.8242186,3.0530917 20.7585936,3.29536275 L20.446875,4.45967742 C20.3625,4.77956989 20.5523436,5.11122297 20.8710936,5.19825299 C20.925,5.21001359 20.9765628,5.21707019 21.028125,5.21707019 C21.2929686,5.21707019 21.5367186,5.04065875 21.609375,4.77016129 L21.91875,3.60819923 C22.0054686,3.28595415 21.8132814,2.95665308 21.4945314,2.86962366 C21.4148436,2.84845445 21.3328128,2.84374985 21.2554686,2.85551105 Z M14.7445314,2.85551105 C14.6671878,2.84374985 14.5851564,2.84845445 14.5054686,2.86962366 C14.1867186,2.95665308 13.9945314,3.28595415 14.08125,3.60819923 L14.390625,4.77016129 C14.4632814,5.04065875 14.7046878,5.21707019 14.971875,5.21707019 C15.0234378,5.21707019 15.075,5.21001359 15.1289064,5.19825299 C15.4476564,5.11122297 15.6375,4.78192189 15.553125,4.45967742 L15.2414064,3.29771535 C15.1757814,3.0554437 14.9742186,2.88844086 14.7445314,2.85551105 Z M11.475,4.14684155 C11.3976564,4.15625015 11.3203128,4.18212396 11.25,4.22446237 C10.9617186,4.3914652 10.865625,4.75840069 11.0320314,5.04771535 L11.6320314,6.08736559 C11.7421878,6.28259424 11.94375,6.38844086 12.15,6.38844086 C12.253125,6.38844086 12.35625,6.36491966 12.45,6.31082004 C12.7382814,6.1438172 12.834375,5.77452972 12.6679686,5.48521505 L12.0679686,4.44556482 C11.9460936,4.22916697 11.7070314,4.11861574 11.475,4.14684155 Z M24.525,4.14919355 C24.290625,4.11861574 24.0539064,4.22916697 23.9320314,4.44556482 L23.3320314,5.48756705 C23.165625,5.77452972 23.2617186,6.1438172 23.55,6.31082004 C23.64375,6.36491966 23.746875,6.39079286 23.85,6.39079286 C24.05625,6.39079286 24.2578128,6.28259424 24.3679686,6.08971759 L24.9679686,5.04771535 C25.134375,4.75840069 25.0359378,4.3914652 24.75,4.22446237 C24.6773436,4.18212396 24.6023436,4.15860215 24.525,4.14919355 Z M6.6,13.2473118 C6.9304686,13.2473118 7.2,13.5178093 7.2,13.8494624 L7.2,27.0967742 C7.2,27.4284273 6.9304686,27.6989247 6.6,27.6989247 C6.2695314,27.6989247 6,27.4284273 6,27.0967742 L6,13.8494624 C6,13.5178093 6.2695314,13.2473118 6.6,13.2473118 Z M29.4,13.2473118 C29.7304686,13.2473118 30,13.5178093 30,13.8494624 L30,27.0967742 C30,27.4284273 29.7304686,27.6989247 29.4,27.6989247 C29.0695314,27.6989247 28.8,27.4284273 28.8,27.0967742 L28.8,13.8494624 C28.8,13.5178093 29.0695314,13.2473118 29.4,13.2473118 Z M3,14.4516129 L4.8,14.4516129 L4.8,26.4946237 L3,26.4946237 C2.0085936,26.4946237 1.2,25.6831319 1.2,24.688172 L1.2,16.2580645 C1.2,15.2631047 2.0085936,14.4516129 3,14.4516129 Z M31.2,14.4516129 L33,14.4516129 C33.9914064,14.4516129 34.8,15.2631047 34.8,16.2580645 L34.8,24.688172 C34.8,25.6831319 33.9914064,26.4946237 33,26.4946237 L31.2,26.4946237 L31.2,14.4516129 Z M19.2,33.7204301 L20.4,33.7204301 C21.0609378,33.7204301 21.6,34.261425 21.6,34.9247312 C21.6,35.5880379 21.0609378,36.1290323 20.4,36.1290323 L19.2,36.1290323 C18.5390628,36.1290323 18,35.5880379 18,34.9247312 C18,34.261425 18.5390628,33.7204301 19.2,33.7204301 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'icons8-support',
                                    tabindex: '-1',
                                    transform: 'translate(2.222222, 1.333333)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/delete-terminate',
                                tabindex: '-1',
                                transform: 'translate(26.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'delete-terminate',
                            tabindex: '-1',
                            transform: 'translate(846.000000, 595.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-872.000000, -595.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-csr_product',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'CSR',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '4C10AD64-CFC6-4802-BAFC-495338076EDD',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M18.6666667,0 C8.3736092,0 0,8.37425287 0,18.6666667 C0,28.9590805 8.3736092,37.3333333 18.6666667,37.3333333 C28.9597241,37.3333333 37.3333333,28.9590805 37.3333333,18.6666667 C37.3333333,8.37425287 28.9597241,0 18.6666667,0 Z M18.6666667,1.28735632 C28.2497471,1.28735632 36.045977,9.08358621 36.045977,18.6666667 C36.045977,28.2497471 28.2497471,36.045977 18.6666667,36.045977 C9.08358621,36.045977 1.28735632,28.2497471 1.28735632,18.6666667 C1.28735632,9.08358621 9.08358621,1.28735632 18.6666667,1.28735632 Z M19.6975571,3.25233479 C19.3403158,3.24396697 19.0362081,3.49734483 19.012392,3.85201149 L18.9281609,5.13685361 C18.9049885,5.49152028 19.1731712,5.79820267 19.5278379,5.82201876 C19.5426425,5.82266244 19.5564211,5.82327586 19.570582,5.82327586 C19.906582,5.82327586 20.1904743,5.56159044 20.213003,5.22108469 L20.2972341,3.9375 C20.3204065,3.58283333 20.0522245,3.27615088 19.6975571,3.25233479 Z M15.9951506,3.46354168 C15.6456334,3.52469111 15.4110127,3.85763364 15.4721621,4.20779456 L15.6946836,5.47629278 C15.7493969,5.78912037 16.0200127,6.0093394 16.3270472,6.0093394 C16.3637368,6.0093394 16.4009601,6.00571807 16.4389365,5.99928129 C16.7884543,5.93813186 17.0230744,5.60518998 16.961925,5.25502841 L16.7406606,3.98653019 C16.6801555,3.63701295 16.3498173,3.40496697 15.9951506,3.46354168 Z M12.6925287,4.47934628 C12.6088905,4.48051295 12.5237743,4.49784192 12.4423491,4.53340533 C12.1166479,4.67630189 11.9694265,5.05694676 12.1129667,5.38200423 L12.633441,6.55998547 C12.7402916,6.8007211 12.9758881,6.94342648 13.2230605,6.94342648 C13.3093134,6.94342648 13.396461,6.92670115 13.4807828,6.88936782 C13.806484,6.74647126 13.9537054,6.36582639 13.8101651,6.04076892 L13.2909486,4.86278768 C13.1837762,4.61899393 12.9434422,4.47584628 12.6925287,4.47934628 Z M9.73186087,6.30352028 C9.56852754,6.28235936 9.39696671,6.32390685 9.25664487,6.4330103 C8.97471384,6.64992984 8.92155053,7.05373683 9.13847007,7.33566786 L9.92420993,8.35524441 C10.0510145,8.52002602 10.242167,8.6066812 10.4346268,8.6066812 C10.5723739,8.6066812 10.7103617,8.56292074 10.8268675,8.47216211 C11.1087985,8.25524257 11.1619625,7.85269269 10.9450429,7.57076166 L10.1593031,6.549928 C10.0505215,6.4083188 9.89519421,6.3246812 9.73186087,6.30352028 Z M21.2866376,7.10183182 C18.1649594,7.05436055 14.7041942,7.87100726 12.1355965,10.62949 C9.64069995,13.3097659 8.47030189,16.1534452 8.65696855,19.0815372 C8.94916625,23.6720728 12.4369364,26.7959363 12.8635057,27.1614586 C12.8570419,28.7200615 12.9739493,30.2126765 13.2155172,31.4761137 C13.274092,31.7844356 13.544095,31.9991023 13.8466237,31.9991023 C13.8865318,31.9991023 13.9273448,31.9955118 13.9698276,31.987787 C14.3187011,31.9202008 14.5471869,31.583608 14.4802444,31.2347344 C13.7915088,27.6359298 14.0562311,22.1523249 15.8945759,18.63398 C18.1236334,14.3689686 21.3399728,12.7324767 21.3708693,12.7176721 C21.6901337,12.5606153 21.8208506,12.1757659 21.6637931,11.8565015 C21.5073793,11.5378808 21.1225299,11.4065505 20.8026219,11.5623206 C20.6558633,11.6350563 17.1893448,13.3803896 14.7543103,18.0393321 C13.6757194,20.1029978 13.1128248,22.7790511 12.9301367,25.4076866 C11.8665403,24.2497952 10.1280628,21.9461837 9.94055292,19.0010774 C9.77770234,16.439882 10.8327211,13.918836 13.0772269,11.5082613 C17.3267901,6.9407211 24.3503249,8.33001995 27.1426007,9.56716938 C26.1288076,11.2761349 25.7796425,13.3614816 25.4114586,15.5551367 C25.0072287,17.9631367 24.5893805,20.4531555 23.216415,22.3829026 C20.7678633,25.8246491 16.1282414,26.0808633 16.0818966,26.0827943 C15.7265862,26.0995299 15.4522989,26.399464 15.4683908,26.7541307 C15.4844828,27.109441 15.7812287,27.3766177 16.1384701,27.3688935 C16.3534586,27.3592383 21.4455965,27.0915088 24.2649069,23.1296697 C25.8090908,20.9572559 26.2519111,18.319141 26.6799571,15.7676007 C27.0687387,13.4516467 27.4359667,11.2645686 28.5971621,9.70043071 C28.7065874,9.55302906 28.7476425,9.36582878 28.7103091,9.18624257 C28.6736195,9.00665637 28.5612874,8.85084634 28.4022989,8.75880037 C27.1912184,8.06008772 24.4083164,7.14930308 21.2866376,7.10183182 Z M7.03771568,8.78771568 C6.87398005,8.80581913 6.71660074,8.88628855 6.60524441,9.02532303 C6.38317545,9.30274832 6.42839384,9.70716938 6.70581913,9.92923834 L7.71156625,10.733836 C7.83064671,10.8297441 7.97289959,10.8758977 8.1138651,10.8758977 C8.3024628,10.8758977 8.48993407,10.7941506 8.61673867,10.6345184 C8.83880763,10.3570931 8.79358924,9.95141499 8.51616395,9.72934602 L7.51041683,8.92474832 C7.37170418,8.81307016 7.20145131,8.76961223 7.03771568,8.78771568 Z M5.26382878,11.8087284 C5.01288506,11.7998578 4.7698663,11.9402498 4.6578663,12.1821119 C4.50853297,12.5052383 4.64967936,12.8876636 4.97216211,13.036997 L6.13882878,13.5788433 C6.22636901,13.6200387 6.31836478,13.637931 6.4091234,13.637931 C6.65179007,13.637931 6.88493223,13.5001034 6.99371384,13.2658046 C7.14304717,12.9426782 7.00315789,12.5602529 6.68067513,12.4109195 L5.51275136,11.8690732 C5.43180883,11.8312571 5.34747733,11.8116854 5.26382878,11.8087284 Z M32.6767241,13.1124283 C32.5932371,13.1073793 32.5067731,13.1198905 32.4227731,13.150144 L31.2083333,13.5763291 C30.872977,13.6934785 30.6957846,14.0619135 30.8135777,14.3972704 C30.9062674,14.6618222 31.1549583,14.8272269 31.4207973,14.8272269 C31.4916019,14.8272269 31.5637138,14.816516 31.6345184,14.7907689 L32.8489583,14.3633261 C33.1843146,14.2461766 33.3615069,13.8777417 33.2437138,13.5423847 C33.155369,13.2913509 32.9271851,13.1275747 32.6767241,13.1124283 Z M4.26185348,15.2006104 C3.9116925,15.1330242 3.57512934,15.3615402 3.50754314,15.7097701 C3.44060061,16.0586437 3.66908621,16.3971379 4.01795977,16.4640805 L5.28142952,16.7104888 C5.32262492,16.7188566 5.36408166,16.7218034 5.40463338,16.7218034 C5.70651844,16.7218034 5.97587779,16.5083636 6.03573986,16.2013291 C6.10268239,15.8524555 5.8754537,15.5127042 5.52658078,15.4457617 L4.26185348,15.2006104 Z M33.2852015,16.2390448 L32.007902,16.3936782 C31.655167,16.4361609 31.4034586,16.7556364 31.4459413,17.1090157 C31.4852057,17.4353606 31.7621379,17.6760061 32.0833333,17.6760061 C32.1090805,17.6760061 32.1355318,17.6741954 32.1612789,17.670977 L33.4385777,17.5176007 C33.7913134,17.475118 34.0430218,17.1543847 34.000539,16.8010054 C33.9580563,16.4482698 33.6379371,16.1984931 33.2852015,16.2390448 Z M32.1788796,19.3191452 C31.8235693,19.2721567 31.5108421,19.5434265 31.4773709,19.8974495 C31.4438996,20.2514725 31.7029092,20.5667441 32.0569322,20.6002154 L33.3392601,20.720905 C33.3605015,20.7234797 33.3802644,20.724677 33.4008621,20.724677 C33.7291379,20.724677 34.0092287,20.476026 34.0407689,20.1426007 C34.0742402,19.7885777 33.8139728,19.4733061 33.4599498,19.4398349 L32.1788796,19.3191452 Z M31.4685705,22.1830103 C31.2185318,22.2057 30.9944816,22.3725735 30.9128954,22.625539 C30.8041137,22.9647574 30.9898349,23.326997 31.3277659,23.4364223 L32.5535203,23.8311785 C32.6191754,23.8517762 32.6852426,23.862608 32.7508977,23.862608 C33.0225299,23.862608 33.2756062,23.6892269 33.3631464,23.4163073 C33.471928,23.0770889 33.2862069,22.7148494 32.9482759,22.6054241 L31.7225215,22.2106679 C31.6378778,22.1839552 31.5519165,22.1754471 31.4685705,22.1830103 Z M30.4062498,24.8494973 C30.1573878,24.8164586 29.901516,24.9322601 29.7663436,25.162536 C29.5867574,25.4689268 29.6893739,25.8629782 29.9964077,26.0425644 L31.1065015,26.6937858 C31.2088463,26.7542916 31.3213993,26.783046 31.4321119,26.783046 C31.6528935,26.783046 31.8674199,26.6696679 31.987787,26.4649782 C32.1673732,26.1585874 32.0660145,25.7632789 31.75898,25.5836927 L30.6476291,24.9324713 C30.5707096,24.887092 30.4892039,24.86051 30.4062498,24.8494973 Z M28.5531609,27.191631 C28.3887011,27.1979069 28.2266153,27.2671422 28.1056031,27.3978088 C27.8642238,27.6591422 27.8801149,28.0659873 28.1408046,28.3080103 L29.0862069,29.1830103 C29.2097931,29.297585 29.3660357,29.3539873 29.5224495,29.3539873 C29.6949552,29.3539873 29.8677023,29.2836552 29.9951506,29.1465517 C30.2365299,28.8852184 30.2206394,28.4783732 29.9599498,28.2363509 L29.0145475,27.362608 C28.8838808,27.2422402 28.7176207,27.1853551 28.5531609,27.191631 Z M26.4901222,29.1276939 C26.3279958,29.0988088 26.1547356,29.1309831 26.0086207,29.2320399 C25.7163908,29.4354422 25.645556,29.8368264 25.8489583,30.1284126 L26.5844108,31.1844471 C26.7092843,31.364677 26.909026,31.4610272 27.1124283,31.4610272 C27.2392329,31.4610272 27.3681391,31.4232517 27.4807828,31.3453666 C27.7730127,31.1419643 27.8438475,30.7405808 27.6404452,30.4489946 L26.9049927,29.3929594 C26.8036134,29.2471663 26.6522486,29.1565789 26.4901222,29.1276939 Z M23.816092,30.520654 C23.7325046,30.5198288 23.6479812,30.5347943 23.5659123,30.5684265 C23.2369927,30.7042426 23.0799855,31.0805632 23.2151579,31.4094828 L23.7054598,32.6000357 C23.8078046,32.8484954 24.0483993,32.9985632 24.3013648,32.9985632 C24.3831119,32.9985632 24.4660563,32.982974 24.546516,32.9507901 C24.8754356,32.814974 25.0324429,32.438654 24.8972704,32.1097344 L24.4069686,30.9191809 C24.3051065,30.6724912 24.0668548,30.5231276 23.816092,30.520654 Z M20.8893678,31.334052 C20.5392069,31.3952015 20.3052299,31.7294011 20.3663793,32.079562 L20.5863866,33.3480605 C20.6410992,33.6602444 20.9129728,33.8811065 21.2200073,33.8811065 C21.2560532,33.8811065 21.2945632,33.8774858 21.3318966,33.871049 C21.6820575,33.8098996 21.9160345,33.4769571 21.8548851,33.1267961 L21.6348778,31.8570406 C21.5737284,31.5081663 21.2388851,31.2754767 20.8893678,31.334052 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'icons8-organic-food',
                                    tabindex: '-1',
                                    transform: 'translate(1.333333, 1.333333)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/delete-terminate',
                                tabindex: '-1',
                                transform: 'translate(26.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'delete-terminate',
                            tabindex: '-1',
                            transform: 'translate(732.000000, 595.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-758.000000, -595.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-wellness_product',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Wellness',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '3706DB96-6644-4206-BA02-58153CE37DC5',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M18.6666667,0 C8.37284515,0 0,8.37284515 0,18.6666667 C0,28.9604888 8.37284515,37.3333333 18.6666667,37.3333333 C28.9604888,37.3333333 37.3333333,28.9604888 37.3333333,18.6666667 C37.3333333,8.37284515 28.9604888,0 18.6666667,0 Z M18.6666667,1.28735632 C28.2489226,1.28735632 36.045977,9.08441076 36.045977,18.6666667 C36.045977,28.2489226 28.2489226,36.045977 18.6666667,36.045977 C9.08441076,36.045977 1.28735632,28.2489226 1.28735632,18.6666667 C1.28735632,9.08441076 9.08441076,1.28735632 18.6666667,1.28735632 Z M18.6666667,3.86206897 C10.5025142,3.86206897 3.86206897,10.5025142 3.86206897,18.6666667 C3.86206897,26.8308191 10.5025142,33.4712644 18.6666667,33.4712644 C26.8308191,33.4712644 33.4712644,26.8308191 33.4712644,18.6666667 C33.4712644,14.0930314 31.4069686,9.84877857 27.8063938,7.02011494 C27.5272989,6.80136478 27.125,6.84913793 26.9037356,7.12823292 C26.6849855,7.40732791 26.7327586,7.81214097 27.0118536,8.03340533 C30.2981325,10.6156612 32.183908,14.4928161 32.183908,18.6666667 C32.183908,26.1192529 26.1192529,32.183908 18.6666667,32.183908 C11.2140805,32.183908 5.14942529,26.1192529 5.14942529,18.6666667 C5.14942529,11.2140805 11.2140805,5.14942529 18.6666667,5.14942529 C19.3279456,5.14942529 19.9917387,5.19719844 20.637931,5.29274409 C20.9924567,5.3455463 21.3193249,5.10165214 21.3696122,4.74964064 C21.4198996,4.39762915 21.1785203,4.07076166 20.8265088,4.01796009 C20.1174567,3.91487053 19.3908046,3.86206897 18.6666667,3.86206897 Z M23.5143678,4.72701149 C23.2654452,4.73958317 23.0341234,4.89798851 22.941092,5.14942529 C22.8204023,5.48132184 22.9913793,5.85093407 23.3257901,5.97413793 C23.8286636,6.15768662 24.329023,6.37895099 24.8117816,6.62535936 C24.9073279,6.67313251 25.0079026,6.69576166 25.1059625,6.69576166 C25.3397992,6.69576166 25.566092,6.56752874 25.6792383,6.34375016 C25.8401579,6.02693949 25.7144398,5.63972717 25.3976291,5.47880763 C24.8696122,5.20725591 24.3214797,4.9683908 23.7683188,4.76472717 C23.6853448,4.73455476 23.5998566,4.72198308 23.5143678,4.72701149 Z M18.6666667,7.72413793 C18.312141,7.72413793 18.0229885,8.01329039 18.0229885,8.36781609 L18.0229885,9.65517241 C18.0229885,10.0096981 18.312141,10.2988506 18.6666667,10.2988506 C19.0211924,10.2988506 19.3103448,10.0096981 19.3103448,9.65517241 L19.3103448,8.36781609 C19.3103448,8.01329039 19.0211924,7.72413793 18.6666667,7.72413793 Z M22.516164,8.47593407 C22.2647272,8.47844828 22.0283763,8.62931034 21.9278016,8.87823292 L21.4450429,10.0700429 C21.3117816,10.3994253 21.4701869,10.7765808 21.8020835,10.9098421 C21.8800291,10.9400145 21.963003,10.9551004 22.0434628,10.9551004 C22.2974138,10.9551004 22.5387931,10.8042383 22.6393678,10.5528016 L23.1221264,9.35847733 C23.2553878,9.02909499 23.0944682,8.65445434 22.7650865,8.52119237 C22.6821119,8.48850575 22.5991379,8.47341986 22.516164,8.47593407 Z M25.8099855,10.6131464 C25.6440375,10.6181754 25.483118,10.6835487 25.3573993,10.8117816 L24.4622843,11.737069 C24.2158766,11.9935348 24.2234199,12.4008621 24.4798851,12.6472704 C24.6030889,12.7679601 24.7640085,12.8283049 24.924928,12.8283049 C25.095905,12.8283049 25.2618536,12.7604168 25.3875717,12.6321839 L26.2826866,11.7068966 C26.5316092,11.4504314 26.5240659,11.0431034 26.2701149,10.7941809 C26.141882,10.670977 25.9759341,10.6106322 25.8099855,10.6131464 Z M18.6666667,11.5862069 C18.312141,11.5862069 18.0229885,11.8753594 18.0229885,12.2298851 L18.0229885,17.5578306 C17.6408046,17.7816092 17.3793103,18.1914513 17.3793103,18.6666667 C17.3793103,19.3757187 17.9576153,19.954023 18.6666667,19.954023 C18.7823279,19.954023 18.8904452,19.933908 18.996049,19.9062498 L23.0391525,23.9493533 C23.1648705,24.075072 23.3283049,24.137931 23.4942529,24.137931 C23.6602015,24.137931 23.8236352,24.075072 23.9493533,23.9493533 C24.2007901,23.6979165 24.2007901,23.2905892 23.9493533,23.0391525 L19.9062498,18.996049 C19.933908,18.8904452 19.954023,18.7823279 19.954023,18.6666667 C19.954023,18.1914513 19.6925287,17.7816092 19.3103448,17.5578306 L19.3103448,12.2298851 C19.3103448,11.8753594 19.0211924,11.5862069 18.6666667,11.5862069 Z M28.062859,13.834052 C27.9798851,13.8365663 27.8943969,13.854167 27.8139371,13.8893678 L26.637213,14.4123563 C26.312859,14.55819 26.167026,14.937859 26.3103448,15.2647272 C26.4184628,15.5035923 26.6522989,15.6469111 26.8987072,15.6469111 C26.9867096,15.6469111 27.0747126,15.6267961 27.1602015,15.5890805 L28.3369256,15.066092 C28.6612789,14.9202589 28.8071119,14.5405892 28.6637931,14.216236 C28.5531609,13.9723418 28.3142958,13.829023 28.062859,13.834052 Z M8.36781609,18.0229885 C8.01329039,18.0229885 7.72413793,18.312141 7.72413793,18.6666667 C7.72413793,19.0211924 8.01329039,19.3103448 8.36781609,19.3103448 L9.65517241,19.3103448 C10.0096981,19.3103448 10.2988506,19.0211924 10.2988506,18.6666667 C10.2988506,18.312141 10.0096981,18.0229885 9.65517241,18.0229885 L8.36781609,18.0229885 Z M27.6781609,18.0229885 C27.3236352,18.0229885 27.0344828,18.312141 27.0344828,18.6666667 C27.0344828,19.0211924 27.3236352,19.3103448 27.6781609,19.3103448 L28.9655172,19.3103448 C29.3200429,19.3103448 29.6091954,19.0211924 29.6091954,18.6666667 C29.6091954,18.312141 29.3200429,18.0229885 28.9655172,18.0229885 L27.6781609,18.0229885 Z M27.0118536,21.3997846 C26.7604168,21.4022989 26.5240659,21.5531609 26.4234912,21.8020835 C26.2927441,22.1314658 26.4511494,22.5061065 26.7805318,22.6393678 L27.9748566,23.1221264 C28.0528016,23.1548131 28.1357762,23.1698996 28.2137211,23.1698996 C28.4701869,23.1698996 28.7115663,23.0165233 28.812141,22.7650865 C28.9454023,22.4357042 28.786997,22.0610635 28.4551004,21.9278016 L27.2632904,21.4450429 C27.1803164,21.4123563 27.0948276,21.3972704 27.0118536,21.3997846 Z M25.1386497,24.2812498 C24.9752154,24.2862789 24.8092674,24.3516521 24.6860635,24.4798851 C24.588003,24.5804598 24.5427441,24.7086927 24.5226291,24.8369256 C24.4145118,25.0732759 24.4522269,25.3624283 24.6483479,25.5585487 L25.4931754,26.4033763 C25.6188935,26.529095 25.7823279,26.591954 25.9482759,26.591954 C26.1142245,26.591954 26.2776582,26.529095 26.4033763,26.4033763 C26.4260061,26.3807471 26.4385777,26.3480605 26.4586927,26.3229165 C26.483836,26.3028016 26.5140085,26.2927441 26.5391525,26.2676007 C26.7855602,26.0111349 26.7780176,25.6038076 26.5215517,25.3573993 L25.5962644,24.4622843 C25.4680314,24.3390805 25.3020835,24.2787356 25.1386497,24.2812498 Z M18.6666667,27.0344828 C18.312141,27.0344828 18.0229885,27.3236352 18.0229885,27.6781609 L18.0229885,28.9655172 C18.0229885,29.3200429 18.312141,29.6091954 18.6666667,29.6091954 C19.0211924,29.6091954 19.3103448,29.3200429 19.3103448,28.9655172 L19.3103448,27.6781609 C19.3103448,27.3236352 19.0211924,27.0344828 18.6666667,27.0344828 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'icons8-clock',
                                    tabindex: '-1',
                                    transform: 'translate(1.333333, 1.333333)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/delete-terminate',
                                tabindex: '-1',
                                transform: 'translate(26.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'delete-terminate',
                            tabindex: '-1',
                            transform: 'translate(618.000000, 595.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-644.000000, -595.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-clock',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Clock / Hours',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'E7F4A856-CB84-47E8-AFA3-44F8CF460B8A',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M13.3333333,0 C12.6666667,0 12.0677087,0.333333333 11.6666667,0.867187333 L9.66666667,4 L2,4 C0.867187333,4 0,4.86718733 0,6 L0,10 C0,11.1328127 0.867187333,12 2,12 L2.065104,12 L4.39843733,34.3333333 C4.59895867,36.0677087 6,37.3333333 7.73177067,37.3333333 L24.2682293,37.3333333 C26,37.3333333 27.401042,36.0677087 27.6015627,34.3333333 L29.934896,12 L30,12 C31.1328127,12 32,11.1328127 32,10 L32,6 C32,4.86718733 31.1328127,4 30,4 L22.3333333,4 L20.2682293,0.867187333 C19.934896,0.333333333 19.2682293,0 18.6015627,0 L13.3333333,0 Z M13.3984373,1.33333333 L18.6666667,1.33333333 C18.8671873,1.33333333 19.0677087,1.466146 19.2005207,1.59895867 L20.7317707,4 L11.2682293,4 L12.7994793,1.59895867 C12.932292,1.466146 13.1328127,1.33333333 13.3984373,1.33333333 Z M2,5.33333333 L30,5.33333333 C30.401042,5.33333333 30.6666667,5.59895867 30.6666667,6 L30.6666667,10 C30.6666667,10.401042 30.401042,10.6666667 30,10.6666667 L2,10.6666667 C1.59895867,10.6666667 1.33333333,10.401042 1.33333333,10 L1.33333333,6 C1.33333333,5.59895867 1.59895867,5.33333333 2,5.33333333 Z M4,6.66666667 C3.59895867,6.66666667 3.33333333,6.932292 3.33333333,7.33333333 L3.33333333,8.66666667 C3.33333333,9.06770867 3.59895867,9.33333333 4,9.33333333 C4.401042,9.33333333 4.66666667,9.06770867 4.66666667,8.66666667 L4.66666667,7.33333333 C4.66666667,6.932292 4.401042,6.66666667 4,6.66666667 Z M7.33333333,6.66666667 C6.932292,6.66666667 6.66666667,6.932292 6.66666667,7.33333333 L6.66666667,8.66666667 C6.66666667,9.06770867 6.932292,9.33333333 7.33333333,9.33333333 C7.73437533,9.33333333 8,9.06770867 8,8.66666667 L8,7.33333333 C8,6.932292 7.73437533,6.66666667 7.33333333,6.66666667 Z M10.6666667,6.66666667 C10.2656253,6.66666667 10,6.932292 10,7.33333333 L10,8.66666667 C10,9.06770867 10.2656253,9.33333333 10.6666667,9.33333333 C11.0677087,9.33333333 11.3333333,9.06770867 11.3333333,8.66666667 L11.3333333,7.33333333 C11.3333333,6.932292 11.0677087,6.66666667 10.6666667,6.66666667 Z M14,6.66666667 C13.5989587,6.66666667 13.3333333,6.932292 13.3333333,7.33333333 L13.3333333,8.66666667 C13.3333333,9.06770867 13.5989587,9.33333333 14,9.33333333 C14.401042,9.33333333 14.6666667,9.06770867 14.6666667,8.66666667 L14.6666667,7.33333333 C14.6666667,6.932292 14.401042,6.66666667 14,6.66666667 Z M18,6.66666667 C17.5989587,6.66666667 17.3333333,6.932292 17.3333333,7.33333333 L17.3333333,8.66666667 C17.3333333,9.06770867 17.5989587,9.33333333 18,9.33333333 C18.401042,9.33333333 18.6666667,9.06770867 18.6666667,8.66666667 L18.6666667,7.33333333 C18.6666667,6.932292 18.401042,6.66666667 18,6.66666667 Z M21.3333333,6.66666667 C20.932292,6.66666667 20.6666667,6.932292 20.6666667,7.33333333 L20.6666667,8.66666667 C20.6666667,9.06770867 20.932292,9.33333333 21.3333333,9.33333333 C21.7343753,9.33333333 22,9.06770867 22,8.66666667 L22,7.33333333 C22,6.932292 21.7343753,6.66666667 21.3333333,6.66666667 Z M24.6666667,6.66666667 C24.2656253,6.66666667 24,6.932292 24,7.33333333 L24,8.66666667 C24,9.06770867 24.2656253,9.33333333 24.6666667,9.33333333 C25.0677087,9.33333333 25.3333333,9.06770867 25.3333333,8.66666667 L25.3333333,7.33333333 C25.3333333,6.932292 25.0677087,6.66666667 24.6666667,6.66666667 Z M28,6.66666667 C27.5989587,6.66666667 27.3333333,6.932292 27.3333333,7.33333333 L27.3333333,8.66666667 C27.3333333,9.06770867 27.5989587,9.33333333 28,9.33333333 C28.401042,9.33333333 28.6666667,9.06770867 28.6666667,8.66666667 L28.6666667,7.33333333 C28.6666667,6.932292 28.401042,6.66666667 28,6.66666667 Z M3.39843733,12 L28.6015627,12 L26.2682293,34.2005207 C26.1328127,35.2005207 25.3333333,36 24.2682293,36 L7.73177067,36 C6.73177067,36 5.86718733,35.2005207 5.73177067,34.2005207 L3.39843733,12 Z M16,15.3333333 C15.5989587,15.3333333 15.3333333,15.5989587 15.3333333,16 L15.3333333,29.3333333 C15.3333333,29.7343753 15.5989587,30 16,30 C16.401042,30 16.6666667,29.7343753 16.6666667,29.3333333 L16.6666667,16 C16.6666667,15.5989587 16.401042,15.3333333 16,15.3333333 Z M10,15.3984373 C9.59895867,15.3984373 9.33333333,15.7317707 9.39843733,16.065104 L10.065104,29.3984373 C10,29.7317707 10.3333333,30 10.6666667,30 C11.0677087,30 11.3333333,29.6666667 11.3333333,29.3333333 L10.6666667,16 C10.6666667,15.5989587 10.3333333,15.3333333 10,15.3984373 Z M22.065104,15.3984373 C21.6666667,15.3984373 21.3984373,15.6666667 21.3984373,16 L20.7317707,29.3333333 C20.6666667,29.6666667 20.932292,30 21.3333333,30 C21.7343753,30 22,29.7317707 22,29.3984373 L22.6666667,16.065104 C22.6666667,15.6666667 22.3984373,15.3984373 22.065104,15.3984373 Z M8.66666667,33.3333333 C8.26562533,33.3333333 8,33.5989587 8,34 C8,34.401042 8.26562533,34.6666667 8.66666667,34.6666667 L18,34.6666667 C18.401042,34.6666667 18.6666667,34.401042 18.6666667,34 C18.6666667,33.5989587 18.401042,33.3333333 18,33.3333333 L8.66666667,33.3333333 Z M20.6666667,33.3333333 C20.2656253,33.3333333 20,33.5989587 20,34 C20,34.401042 20.2656253,34.6666667 20.6666667,34.6666667 L23.3333333,34.6666667 C23.7343753,34.6666667 24,34.401042 24,34 C24,33.5989587 23.7343753,33.3333333 23.3333333,33.3333333 L20.6666667,33.3333333 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(4.000000, 1.333333)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/delete-terminate',
                                tabindex: '-1',
                                transform: 'translate(26.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'delete-terminate',
                            tabindex: '-1',
                            transform: 'translate(504.000000, 595.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-530.000000, -595.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-delete',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Delete / Terminate',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '7F3C6F76-7F32-47C4-BD0F-0841B285675F',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M16,-1.89478063e-14 C14.7307692,-1.89478063e-14 13.4615385,0.394937276 12.379808,1.18240383 L10.7211538,2.39129689 L1.84615385,2.39129689 C0.829326769,2.39129689 0,3.22210991 0,4.24075925 L0,36.2981069 C0,37.3167563 0.829326769,38.1475693 1.84615385,38.1475693 L30.1538462,38.1475693 C31.1706732,38.1475693 32,37.3167563 32,36.2981069 L32,4.24075925 C32,3.22210991 31.1706732,2.39129689 30.1538462,2.39129689 L21.2764425,2.39129689 L19.6177883,1.18240383 C18.5360578,0.394937276 17.2668271,-1.89478063e-14 16,-1.89478063e-14 Z M16,1.23538291 C17.0144234,1.23538291 18.0288462,1.54844325 18.8942308,2.17937933 L21.3942308,3.99994384 C21.8701926,4.34671804 22.1538462,4.90781779 22.1538462,5.49781601 L22.1538462,6.70670908 C22.1538462,7.04625865 21.8774037,7.32319653 21.5384615,7.32319653 L10.4615385,7.32319653 C10.1225963,7.32319653 9.84615385,7.04625865 9.84615385,6.70670908 L9.84615385,5.49781601 C9.84615385,4.90781779 10.129808,4.34671804 10.6057692,3.99994384 L13.1057692,2.17937933 C13.9711538,1.54844325 14.9855772,1.23538291 16,1.23538291 Z M16,2.39555556 C16.6780726,2.39555556 17.2311111,2.94859406 17.2311111,3.62666667 C17.2311111,4.30473928 16.6780726,4.85777778 16,4.85777778 C15.3219274,4.85777778 14.7688889,4.30473928 14.7688889,3.62666667 C14.7688889,2.94859406 15.3219274,2.39555556 16,2.39555556 Z M1.84615385,3.6242718 L9.254808,3.6242718 C8.84855754,4.15647371 8.61538462,4.81390024 8.61538462,5.49781601 L8.61538462,6.09022162 L4.92307692,6.09022162 C4.24519262,6.09022162 3.69230769,6.64409738 3.69230769,7.32319653 L3.69230769,33.2156696 C3.69230769,33.8947694 4.24519262,34.4486446 4.92307692,34.4486446 L22.2596154,34.4486446 C22.7524037,34.4486446 23.2163465,34.2559922 23.564904,33.90681 L27.7668271,29.6973566 C28.1153846,29.3481744 28.3076923,28.8834002 28.3076923,28.3897288 L28.3076923,7.32319653 C28.3076923,6.64409738 27.754808,6.09022162 27.0769231,6.09022162 L23.3846154,6.09022162 L23.3846154,5.49781601 C23.3846154,4.81390024 23.1514425,4.15647371 22.7451926,3.6242718 L30.1538462,3.6242718 C30.4927883,3.6242718 30.7692308,3.90120968 30.7692308,4.24075925 L30.7692308,36.2981069 C30.7692308,36.6376565 30.4927883,36.9145944 30.1538462,36.9145944 L1.84615385,36.9145944 C1.50721169,36.9145944 1.23076923,36.6376565 1.23076923,36.2981069 L1.23076923,4.24075925 C1.23076923,3.90120968 1.50721169,3.6242718 1.84615385,3.6242718 Z M4.92307692,7.32319653 L8.72836554,7.32319653 C8.98317292,8.03841815 9.66105785,8.55617144 10.4615385,8.55617144 L21.5384615,8.55617144 C22.3389422,8.55617144 23.0168271,8.03841815 23.2716345,7.32319653 L27.0769231,7.32319653 L27.0769231,28.28377 L23.3846154,28.28377 C22.7067311,28.28377 22.1538462,28.8376458 22.1538462,29.5167449 L22.1538462,33.2156696 L4.92307692,33.2156696 L4.92307692,7.32319653 Z M6.76923077,9.78914635 C6.43028862,9.78914635 6.15384615,10.0636762 6.15384615,10.4056338 L6.15384615,11.6386087 C6.15384615,11.9805669 6.43028862,12.2550962 6.76923077,12.2550962 C7.10817292,12.2550962 7.38461538,11.9805669 7.38461538,11.6386087 L7.38461538,10.4056338 C7.38461538,10.0636762 7.10817292,9.78914635 6.76923077,9.78914635 Z M9.84615385,9.78914635 C9.50721169,9.78914635 9.23076923,10.0636762 9.23076923,10.4056338 L9.23076923,11.6386087 C9.23076923,11.9805669 9.50721169,12.2550962 9.84615385,12.2550962 C10.185096,12.2550962 10.4615385,11.9805669 10.4615385,11.6386087 L10.4615385,10.4056338 C10.4615385,10.0636762 10.185096,9.78914635 9.84615385,9.78914635 Z M12.9230769,9.78914635 C12.5841348,9.78914635 12.3076923,10.0636762 12.3076923,10.4056338 L12.3076923,11.6386087 C12.3076923,11.9805669 12.5841348,12.2550962 12.9230769,12.2550962 C13.2620191,12.2550962 13.5384615,11.9805669 13.5384615,11.6386087 L13.5384615,10.4056338 C13.5384615,10.0636762 13.2620191,9.78914635 12.9230769,9.78914635 Z M16,9.78914635 C15.6610578,9.78914635 15.3846154,10.0636762 15.3846154,10.4056338 L15.3846154,11.6386087 C15.3846154,11.9805669 15.6610578,12.2550962 16,12.2550962 C16.3389422,12.2550962 16.6153846,11.9805669 16.6153846,11.6386087 L16.6153846,10.4056338 C16.6153846,10.0636762 16.3389422,9.78914635 16,9.78914635 Z M19.0769231,9.78914635 C18.7379809,9.78914635 18.4615385,10.0636762 18.4615385,10.4056338 L18.4615385,11.6386087 C18.4615385,11.9805669 18.7379809,12.2550962 19.0769231,12.2550962 C19.4158652,12.2550962 19.6923077,11.9805669 19.6923077,11.6386087 L19.6923077,10.4056338 C19.6923077,10.0636762 19.4158652,9.78914635 19.0769231,9.78914635 Z M22.1538462,9.78914635 C21.814904,9.78914635 21.5384615,10.0636762 21.5384615,10.4056338 L21.5384615,11.6386087 C21.5384615,11.9805669 21.814904,12.2550962 22.1538462,12.2550962 C22.4927883,12.2550962 22.7692308,11.9805669 22.7692308,11.6386087 L22.7692308,10.4056338 C22.7692308,10.0636762 22.4927883,9.78914635 22.1538462,9.78914635 Z M25.2307692,9.78914635 C24.8918271,9.78914635 24.6153846,10.0636762 24.6153846,10.4056338 L24.6153846,11.6386087 C24.6153846,11.9805669 24.8918271,12.2550962 25.2307692,12.2550962 C25.5697114,12.2550962 25.8461538,11.9805669 25.8461538,11.6386087 L25.8461538,10.4056338 C25.8461538,10.0636762 25.5697114,9.78914635 25.2307692,9.78914635 Z M20.9230769,15.9540209 C20.7668271,15.9540209 20.6081729,16.0142246 20.4879809,16.1346326 C20.2475963,16.375448 20.2475963,16.7655687 20.4879809,17.0063841 L21.2836542,17.8034833 L20.4879809,18.6005824 C20.2475963,18.8413978 20.2475963,19.2315185 20.4879809,19.4723339 C20.6081729,19.5927419 20.7644234,19.6529456 20.9230769,19.6529456 C21.0817311,19.6529456 21.2379809,19.5927419 21.3581729,19.4723339 L22.1538462,18.6752354 L22.9495194,19.4723339 C23.0697114,19.5927419 23.2259618,19.6529456 23.3846154,19.6529456 C23.5432695,19.6529456 23.6995194,19.5927419 23.8197114,19.4723339 C24.060096,19.2315185 24.060096,18.8413978 23.8197114,18.6005824 L23.0240388,17.8034833 L23.8197114,17.0063841 C24.060096,16.7655687 24.060096,16.375448 23.8197114,16.1346326 C23.5793268,15.8938172 23.189904,15.8938172 22.9495194,16.1346326 L22.1538462,16.9317318 L21.3581729,16.1346326 C21.2379809,16.0142246 21.0793268,15.9540209 20.9230769,15.9540209 Z M8.61538462,17.1869958 C8.27644246,17.1869958 8,17.4615257 8,17.8034833 C8,18.1454415 8.27644246,18.4199707 8.61538462,18.4199707 L12.3076923,18.4199707 C12.6466345,18.4199707 12.9230769,18.1454415 12.9230769,17.8034833 C12.9230769,17.4615257 12.6466345,17.1869958 12.3076923,17.1869958 L8.61538462,17.1869958 Z M14.7692308,17.1869958 C14.4302886,17.1869958 14.1538462,17.4615257 14.1538462,17.8034833 C14.1538462,18.1454415 14.4302886,18.4199707 14.7692308,18.4199707 L17.2307692,18.4199707 C17.5697114,18.4199707 17.8461538,18.1454415 17.8461538,17.8034833 C17.8461538,17.4615257 17.5697114,17.1869958 17.2307692,17.1869958 L14.7692308,17.1869958 Z M20.9230769,22.1188955 C20.7668271,22.1188955 20.6081729,22.1790992 20.4879809,22.2995072 C20.2475963,22.5403226 20.2475963,22.9304432 20.4879809,23.1712587 L21.2836542,23.9683578 L20.4879809,24.765457 C20.2475963,25.0062724 20.2475963,25.3963931 20.4879809,25.6372085 C20.6081729,25.7576165 20.7644234,25.8178202 20.9230769,25.8178202 C21.0817311,25.8178202 21.2379809,25.7576165 21.3581729,25.6372085 L22.1538462,24.8401099 L22.9495194,25.6372085 C23.0697114,25.7576165 23.2259618,25.8178202 23.3846154,25.8178202 C23.5432695,25.8178202 23.6995194,25.7576165 23.8197114,25.6372085 C24.060096,25.3963931 24.060096,25.0062724 23.8197114,24.765457 L23.0240388,23.9683578 L23.8197114,23.1712587 C24.060096,22.9304432 24.060096,22.5403226 23.8197114,22.2995072 C23.5793268,22.0586918 23.189904,22.0586918 22.9495194,22.2995072 L22.1538462,23.0966063 L21.3581729,22.2995072 C21.2379809,22.1790992 21.0793268,22.1188955 20.9230769,22.1188955 Z M8.61538462,23.3518704 C8.27644246,23.3518704 8,23.6264002 8,23.9683578 C8,24.310316 8.27644246,24.5848453 8.61538462,24.5848453 L17.2307692,24.5848453 C17.5697114,24.5848453 17.8461538,24.310316 17.8461538,23.9683578 C17.8461538,23.6264002 17.5697114,23.3518704 17.2307692,23.3518704 L8.61538462,23.3518704 Z M23.3846154,29.5167449 L26.2067311,29.5167449 L23.3846154,32.3439182 L23.3846154,29.5167449 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(4.000000, 0.444444)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/checklist/fail',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'checklist---fail',
                            tabindex: '-1',
                            transform: 'translate(1302.000000, 479.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1327.000000, -479.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-checklist_fail',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Checklist - Fail',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '9B402CD1-7AE4-4F16-AD09-1DA298ECCC38',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M16,1.26318709e-14 C14.7331729,1.26318709e-14 13.4639422,0.394937276 12.3822117,1.18481183 L10.7211538,2.39370489 L1.84615385,2.39370489 C0.831731077,2.39370489 0,3.22692652 0,4.24316725 L0,36.3005149 C0,37.3167563 0.831731077,38.1499773 1.84615385,38.1499773 L30.1538462,38.1499773 C31.1682695,38.1499773 32,37.3167563 32,36.3005149 L32,4.24316725 C32,3.22692652 31.1682695,2.39370489 30.1538462,2.39370489 L21.2788462,2.39370489 L19.6177883,1.18481183 C18.5360578,0.394937276 17.2668271,0.002408 16,1.26318709e-14 Z M16,1.23779091 C17.0144234,1.23779091 18.0312498,1.55325925 18.8990388,2.18419533 L19.1875003,2.39370489 L20.875,3.6266798 L21.3918271,4.00235184 C21.8701926,4.34671804 22.1538462,4.90781779 22.1538462,5.50022401 L22.1538462,6.70911708 C22.1538462,7.04866665 21.8774037,7.32560453 21.5384615,7.32560453 L10.4615385,7.32560453 C10.1225963,7.32560453 9.84615385,7.04866665 9.84615385,6.70911708 L9.84615385,5.50022401 C9.84615385,4.90781779 10.129808,4.34671804 10.6081729,4.00235184 L11.125,3.6266798 L12.8125003,2.39370489 L13.1009618,2.18419533 C13.9687502,1.55325925 14.9855772,1.23779091 16,1.23779091 Z M16,2.39555556 C15.3203241,2.39555556 14.7688889,2.94699074 14.7688889,3.62666667 C14.7688889,4.30634259 15.3203241,4.85777778 16,4.85777778 C16.6796759,4.85777778 17.2311111,4.30634259 17.2311111,3.62666667 C17.2311111,2.94699074 16.6796759,2.39555556 16,2.39555556 Z M1.84615385,3.6266798 L9.25,3.6266798 C8.84375015,4.15647371 8.61538462,4.81630824 8.61538462,5.50022401 L8.61538462,6.09262962 L4.92307692,6.09262962 C4.24519262,6.09262962 3.69230769,6.64650538 3.69230769,7.32560453 L3.69230769,33.2180776 C3.69230769,33.8971774 4.24519262,34.4510526 4.92307692,34.4510526 L22.2596154,34.4510526 C22.75,34.4510526 23.2187502,34.2584002 23.5625003,33.909218 L27.7668271,29.6973566 C28.1153846,29.3529904 28.3076923,28.8834002 28.3076923,28.3921368 L28.3076923,7.32560453 C28.3076923,6.64650538 27.754808,6.09262962 27.0769231,6.09262962 L23.3846154,6.09262962 L23.3846154,5.50022401 C23.3846154,4.81630824 23.1562498,4.15647371 22.75,3.6266798 L30.1538462,3.6266798 C30.4927883,3.6266798 30.7692308,3.90361768 30.7692308,4.24316725 L30.7692308,36.3005149 C30.7692308,36.6400645 30.4927883,36.9170024 30.1538462,36.9170024 L1.84615385,36.9170024 C1.50721169,36.9170024 1.23076923,36.6400645 1.23076923,36.3005149 L1.23076923,4.24316725 C1.23076923,3.90361768 1.50721169,3.6266798 1.84615385,3.6266798 Z M4.92307692,7.32560453 L8.72596185,7.32560453 C8.97836554,8.04082615 9.66105785,8.55857944 10.4615385,8.55857944 L21.5384615,8.55857944 C22.3389422,8.55857944 23.0216345,8.04082615 23.2740388,7.32560453 L27.0769231,7.32560453 L27.0769231,28.286178 L23.3846154,28.286178 C22.7067311,28.286178 22.1538462,28.8400538 22.1538462,29.5191529 L22.1538462,33.2180776 L4.92307692,33.2180776 L4.92307692,7.32560453 Z M6.76923077,9.79155435 C6.42788492,9.79155435 6.15384615,10.0684922 6.15384615,10.4080418 L6.15384615,11.6410167 C6.15384615,11.9805663 6.42788492,12.2575042 6.76923077,12.2575042 C7.11057723,12.2575042 7.38461538,11.9805663 7.38461538,11.6410167 L7.38461538,10.4080418 C7.38461538,10.0684922 7.11057723,9.79155435 6.76923077,9.79155435 Z M9.84615385,9.79155435 C9.504808,9.79155435 9.23076923,10.0684922 9.23076923,10.4080418 L9.23076923,11.6410167 C9.23076923,11.9805663 9.504808,12.2575042 9.84615385,12.2575042 C10.1875003,12.2575042 10.4615385,11.9805663 10.4615385,11.6410167 L10.4615385,10.4080418 C10.4615385,10.0684922 10.1875003,9.79155435 9.84615385,9.79155435 Z M12.9230769,9.79155435 C12.5817311,9.79155435 12.3076923,10.0684922 12.3076923,10.4080418 L12.3076923,11.6410167 C12.3076923,11.9805663 12.5817311,12.2575042 12.9230769,12.2575042 C13.2644234,12.2575042 13.5384615,11.9805663 13.5384615,11.6410167 L13.5384615,10.4080418 C13.5384615,10.0684922 13.2644234,9.79155435 12.9230769,9.79155435 Z M16,9.79155435 C15.6586542,9.79155435 15.3846154,10.0684922 15.3846154,10.4080418 L15.3846154,11.6410167 C15.3846154,11.9805663 15.6586542,12.2575042 16,12.2575042 C16.3413465,12.2575042 16.6153846,11.9805663 16.6153846,11.6410167 L16.6153846,10.4080418 C16.6153846,10.0684922 16.3413465,9.79155435 16,9.79155435 Z M19.0769231,9.79155435 C18.7355772,9.79155435 18.4615385,10.0684922 18.4615385,10.4080418 L18.4615385,11.6410167 C18.4615385,11.9805663 18.7355772,12.2575042 19.0769231,12.2575042 C19.4182695,12.2575042 19.6923077,11.9805663 19.6923077,11.6410167 L19.6923077,10.4080418 C19.6923077,10.0684922 19.4182695,9.79155435 19.0769231,9.79155435 Z M22.1538462,9.79155435 C21.8125003,9.79155435 21.5384615,10.0684922 21.5384615,10.4080418 L21.5384615,11.6410167 C21.5384615,11.9805663 21.8125003,12.2575042 22.1538462,12.2575042 C22.4951926,12.2575042 22.7692308,11.9805663 22.7692308,11.6410167 L22.7692308,10.4080418 C22.7692308,10.0684922 22.4951926,9.79155435 22.1538462,9.79155435 Z M25.2307692,9.79155435 C24.8894234,9.79155435 24.6153846,10.0684922 24.6153846,10.4080418 L24.6153846,11.6410167 C24.6153846,11.9805663 24.8894234,12.2575042 25.2307692,12.2575042 C25.5721157,12.2575042 25.8461538,11.9805663 25.8461538,11.6410167 L25.8461538,10.4080418 C25.8461538,10.0684922 25.5721157,9.79155435 25.2307692,9.79155435 Z M24,15.9564289 C23.8437502,15.9564289 23.685096,16.0166326 23.564904,16.1370406 L21.5384615,18.1671147 L20.7427883,17.3700155 C20.5024037,17.1292001 20.1129809,17.1292001 19.8725963,17.3700155 C19.6322117,17.6108309 19.6322117,18.0009516 19.8725963,18.241767 L21.1033655,19.4747419 C21.2235575,19.5951499 21.379808,19.6553536 21.5384615,19.6553536 C21.6971157,19.6553536 21.8533655,19.5951499 21.9735575,19.4747419 L24.435096,17.0087921 C24.6754806,16.7679767 24.6754806,16.377856 24.435096,16.1370406 C24.314904,16.0166326 24.1562498,15.9564289 24,15.9564289 Z M8.61538462,17.1894038 C8.27403877,17.1894038 8,17.4663417 8,17.8058913 C8,18.1454408 8.27403877,18.4223787 8.61538462,18.4223787 L12.3076923,18.4223787 C12.6490388,18.4223787 12.9230769,18.1454408 12.9230769,17.8058913 C12.9230769,17.4663417 12.6490388,17.1894038 12.3076923,17.1894038 L8.61538462,17.1894038 Z M14.7692308,17.1894038 C14.4278849,17.1894038 14.1538462,17.4663417 14.1538462,17.8058913 C14.1538462,18.1454408 14.4278849,18.4223787 14.7692308,18.4223787 L17.2307692,18.4223787 C17.5721157,18.4223787 17.8461538,18.1454408 17.8461538,17.8058913 C17.8461538,17.4663417 17.5721157,17.1894038 17.2307692,17.1894038 L14.7692308,17.1894038 Z M20.9230769,22.1213035 C20.7668271,22.1213035 20.6081729,22.1815072 20.4879809,22.3019152 C20.2475963,22.5427306 20.2475963,22.9328512 20.4879809,23.1736667 L21.2836542,23.9707658 L20.4879809,24.767865 C20.2475963,25.0086804 20.2475963,25.3988011 20.4879809,25.6396165 C20.6081729,25.7600245 20.7644234,25.8202282 20.9230769,25.8202282 C21.0817311,25.8202282 21.2379809,25.7600245 21.3581729,25.6396165 L22.1538462,24.8425179 L22.9495194,25.6396165 C23.0697114,25.7600245 23.2259618,25.8202282 23.3846154,25.8202282 C23.5432695,25.8202282 23.6995194,25.7600245 23.8197114,25.6396165 C24.060096,25.3988011 24.060096,25.0086804 23.8197114,24.767865 L23.0240388,23.9707658 L23.8197114,23.1736667 C24.060096,22.9328512 24.060096,22.5427306 23.8197114,22.3019152 C23.5793268,22.0610998 23.189904,22.0610998 22.9495194,22.3019152 L22.1538462,23.0990143 L21.3581729,22.3019152 C21.2379809,22.1815072 21.0793268,22.1213035 20.9230769,22.1213035 Z M8.61538462,23.3542784 C8.27403877,23.3542784 8,23.6312162 8,23.9707658 C8,24.3103154 8.27403877,24.5872533 8.61538462,24.5872533 L17.2307692,24.5872533 C17.5721157,24.5872533 17.8461538,24.3103154 17.8461538,23.9707658 C17.8461538,23.6312162 17.5721157,23.3542784 17.2307692,23.3542784 L8.61538462,23.3542784 Z M23.3846154,29.5191529 L26.2091348,29.5191529 L23.3846154,32.3487342 L23.3846154,29.5191529 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(4.000000, 0.444444)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/checklist/mixed',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'checklist---mixed',
                            tabindex: '-1',
                            transform: 'translate(1188.000000, 479.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1213.000000, -479.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-checklist_mixed',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Checklist - Mixed',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'F590C942-B0E6-409A-B434-F868FA5138C6',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M16,1.26318709e-14 C14.7331729,1.26318709e-14 13.4639422,0.394937276 12.3822117,1.18481183 L10.7211538,2.39370489 L1.84615385,2.39370489 C0.831731077,2.39370489 0,3.22692652 0,4.24316725 L0,36.3005149 C0,37.3167563 0.831731077,38.1499773 1.84615385,38.1499773 L30.1538462,38.1499773 C31.1682695,38.1499773 32,37.3167563 32,36.3005149 L32,4.24316725 C32,3.22692652 31.1682695,2.39370489 30.1538462,2.39370489 L21.2788462,2.39370489 L19.6177883,1.18481183 C18.5360578,0.394937276 17.2668271,0.002408 16,1.26318709e-14 Z M16,1.23779091 C17.0144234,1.23779091 18.0312498,1.55325925 18.8990388,2.18419533 L19.1875003,2.39370489 L20.875,3.6266798 L21.3918271,4.00235184 C21.8701926,4.34671804 22.1538462,4.90781779 22.1538462,5.50022401 L22.1538462,6.70911708 C22.1538462,7.04866665 21.8774037,7.32560453 21.5384615,7.32560453 L10.4615385,7.32560453 C10.1225963,7.32560453 9.84615385,7.04866665 9.84615385,6.70911708 L9.84615385,5.50022401 C9.84615385,4.90781779 10.129808,4.34671804 10.6081729,4.00235184 L11.125,3.6266798 L12.8125003,2.39370489 L13.1009618,2.18419533 C13.9687502,1.55325925 14.9855772,1.23779091 16,1.23779091 Z M16,2.39555556 C15.3203241,2.39555556 14.7688889,2.94699074 14.7688889,3.62666667 C14.7688889,4.30634259 15.3203241,4.85777778 16,4.85777778 C16.6796759,4.85777778 17.2311111,4.30634259 17.2311111,3.62666667 C17.2311111,2.94699074 16.6796759,2.39555556 16,2.39555556 Z M1.84615385,3.6266798 L9.25,3.6266798 C8.84375015,4.15647371 8.61538462,4.81630824 8.61538462,5.50022401 L8.61538462,6.09262962 L4.92307692,6.09262962 C4.24519262,6.09262962 3.69230769,6.64650538 3.69230769,7.32560453 L3.69230769,33.2180776 C3.69230769,33.8971774 4.24519262,34.4510526 4.92307692,34.4510526 L22.2596154,34.4510526 C22.75,34.4510526 23.2187502,34.2584002 23.5625003,33.909218 L27.7668271,29.6973566 C28.1153846,29.3529904 28.3076923,28.8834002 28.3076923,28.3921368 L28.3076923,7.32560453 C28.3076923,6.64650538 27.754808,6.09262962 27.0769231,6.09262962 L23.3846154,6.09262962 L23.3846154,5.50022401 C23.3846154,4.81630824 23.1562498,4.15647371 22.75,3.6266798 L30.1538462,3.6266798 C30.4927883,3.6266798 30.7692308,3.90361768 30.7692308,4.24316725 L30.7692308,36.3005149 C30.7692308,36.6400645 30.4927883,36.9170024 30.1538462,36.9170024 L1.84615385,36.9170024 C1.50721169,36.9170024 1.23076923,36.6400645 1.23076923,36.3005149 L1.23076923,4.24316725 C1.23076923,3.90361768 1.50721169,3.6266798 1.84615385,3.6266798 Z M4.92307692,7.32560453 L8.72596185,7.32560453 C8.97836554,8.04082615 9.66105785,8.55857944 10.4615385,8.55857944 L21.5384615,8.55857944 C22.3389422,8.55857944 23.0216345,8.04082615 23.2740388,7.32560453 L27.0769231,7.32560453 L27.0769231,28.286178 L23.3846154,28.286178 C22.7067311,28.286178 22.1538462,28.8400538 22.1538462,29.5191529 L22.1538462,33.2180776 L4.92307692,33.2180776 L4.92307692,7.32560453 Z M6.76923077,9.79155435 C6.43028862,9.79155435 6.15384615,10.0684922 6.15384615,10.4080418 L6.15384615,11.6410167 C6.15384615,11.9805663 6.43028862,12.2575042 6.76923077,12.2575042 C7.10817292,12.2575042 7.38461538,11.9805663 7.38461538,11.6410167 L7.38461538,10.4080418 C7.38461538,10.0684922 7.10817292,9.79155435 6.76923077,9.79155435 Z M9.84615385,9.79155435 C9.50721169,9.79155435 9.23076923,10.0684922 9.23076923,10.4080418 L9.23076923,11.6410167 C9.23076923,11.9805663 9.50721169,12.2575042 9.84615385,12.2575042 C10.185096,12.2575042 10.4615385,11.9805663 10.4615385,11.6410167 L10.4615385,10.4080418 C10.4615385,10.0684922 10.185096,9.79155435 9.84615385,9.79155435 Z M12.9230769,9.79155435 C12.5841348,9.79155435 12.3076923,10.0684922 12.3076923,10.4080418 L12.3076923,11.6410167 C12.3076923,11.9805663 12.5841348,12.2575042 12.9230769,12.2575042 C13.2620191,12.2575042 13.5384615,11.9805663 13.5384615,11.6410167 L13.5384615,10.4080418 C13.5384615,10.0684922 13.2620191,9.79155435 12.9230769,9.79155435 Z M16,9.79155435 C15.6610578,9.79155435 15.3846154,10.0684922 15.3846154,10.4080418 L15.3846154,11.6410167 C15.3846154,11.9805663 15.6610578,12.2575042 16,12.2575042 C16.3389422,12.2575042 16.6153846,11.9805663 16.6153846,11.6410167 L16.6153846,10.4080418 C16.6153846,10.0684922 16.3389422,9.79155435 16,9.79155435 Z M19.0769231,9.79155435 C18.7379809,9.79155435 18.4615385,10.0684922 18.4615385,10.4080418 L18.4615385,11.6410167 C18.4615385,11.9805663 18.7379809,12.2575042 19.0769231,12.2575042 C19.4158652,12.2575042 19.6923077,11.9805663 19.6923077,11.6410167 L19.6923077,10.4080418 C19.6923077,10.0684922 19.4158652,9.79155435 19.0769231,9.79155435 Z M22.1538462,9.79155435 C21.814904,9.79155435 21.5384615,10.0684922 21.5384615,10.4080418 L21.5384615,11.6410167 C21.5384615,11.9805663 21.814904,12.2575042 22.1538462,12.2575042 C22.4927883,12.2575042 22.7692308,11.9805663 22.7692308,11.6410167 L22.7692308,10.4080418 C22.7692308,10.0684922 22.4927883,9.79155435 22.1538462,9.79155435 Z M25.2307692,9.79155435 C24.8918271,9.79155435 24.6153846,10.0684922 24.6153846,10.4080418 L24.6153846,11.6410167 C24.6153846,11.9805663 24.8918271,12.2575042 25.2307692,12.2575042 C25.5697114,12.2575042 25.8461538,11.9805663 25.8461538,11.6410167 L25.8461538,10.4080418 C25.8461538,10.0684922 25.5697114,9.79155435 25.2307692,9.79155435 Z M24,15.9564289 C23.8437502,15.9564289 23.685096,16.0166326 23.564904,16.1370406 L21.5384615,18.1671147 L20.7427883,17.3700155 C20.5024037,17.1292001 20.1129809,17.1292001 19.8725963,17.3700155 C19.6322117,17.6108309 19.6322117,18.0009516 19.8725963,18.241767 L21.1033655,19.4747419 C21.2235575,19.5951499 21.379808,19.6553536 21.5384615,19.6553536 C21.6971157,19.6553536 21.8533655,19.5951499 21.9735575,19.4747419 L24.435096,17.0087921 C24.6754806,16.7679767 24.6754806,16.377856 24.435096,16.1370406 C24.314904,16.0166326 24.1562498,15.9564289 24,15.9564289 Z M8.61538462,17.1894038 C8.27644246,17.1894038 8,17.4663417 8,17.8058913 C8,18.1454408 8.27644246,18.4223787 8.61538462,18.4223787 L12.3076923,18.4223787 C12.6466345,18.4223787 12.9230769,18.1454408 12.9230769,17.8058913 C12.9230769,17.4663417 12.6466345,17.1894038 12.3076923,17.1894038 L8.61538462,17.1894038 Z M14.7692308,17.1894038 C14.4302886,17.1894038 14.1538462,17.4663417 14.1538462,17.8058913 C14.1538462,18.1454408 14.4302886,18.4223787 14.7692308,18.4223787 L17.2307692,18.4223787 C17.5697114,18.4223787 17.8461538,18.1454408 17.8461538,17.8058913 C17.8461538,17.4663417 17.5697114,17.1894038 17.2307692,17.1894038 L14.7692308,17.1894038 Z M24,22.1213035 C23.8437502,22.1213035 23.685096,22.1815072 23.564904,22.3019152 L21.5384615,24.3319892 L20.7427883,23.5348901 C20.5024037,23.2940747 20.1129809,23.2940747 19.8725963,23.5348901 C19.6322117,23.7757055 19.6322117,24.1658262 19.8725963,24.4066416 L21.1033655,25.6396165 C21.2235575,25.7600245 21.379808,25.8202282 21.5384615,25.8202282 C21.6971157,25.8202282 21.8533655,25.7600245 21.9735575,25.6396165 L24.435096,23.1736667 C24.6754806,22.9328512 24.6754806,22.5427306 24.435096,22.3019152 C24.314904,22.1815072 24.1562498,22.1213035 24,22.1213035 Z M8.61538462,23.3542784 C8.27644246,23.3542784 8,23.6312162 8,23.9707658 C8,24.3103154 8.27644246,24.5872533 8.61538462,24.5872533 L17.2307692,24.5872533 C17.5697114,24.5872533 17.8461538,24.3103154 17.8461538,23.9707658 C17.8461538,23.6312162 17.5697114,23.3542784 17.2307692,23.3542784 L8.61538462,23.3542784 Z M23.3846154,29.5191529 L26.2091348,29.5191529 L23.3846154,32.3487342 L23.3846154,29.5191529 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(4.000000, 0.444444)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/checklist/pass',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'checklist---pass',
                            tabindex: '-1',
                            transform: 'translate(1074.000000, 479.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1099.000000, -479.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-checklist_pass',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Checklist - Pass',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '96FEFA4F-91C0-49CF-90E6-F8B67D72EE32',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M16,0 C14.7307692,0 13.4615385,0.395710149 12.379808,1.18471773 L10.7235575,2.39597654 L1.84615385,2.39597654 C0.829326769,2.39597654 0,3.22841542 0,4.24905821 L0,36.3691405 C0,37.3897833 0.829326769,38.2222222 1.84615385,38.2222222 L30.1538462,38.2222222 C31.1706732,38.2222222 32,37.3897833 32,36.3691405 L32,4.24905821 C32,3.22841542 31.1706732,2.39597654 30.1538462,2.39597654 L21.2764425,2.39597654 L19.6177883,1.18471773 C18.5360578,0.395710149 17.2668271,0 16,0 Z M16,1.23780049 C17.0144234,1.23780049 18.0288462,1.55388619 18.8942308,2.18364427 L21.3942308,4.00777154 C21.8701926,4.35522435 22.1538462,4.91742215 22.1538462,5.50857497 L22.1538462,6.71983378 C22.1538462,7.06004784 21.8774037,7.33752767 21.5384615,7.33752767 L10.4615385,7.33752767 C10.1225963,7.33752767 9.84615385,7.06004784 9.84615385,6.71983378 L9.84615385,5.50857497 C9.84615385,4.91742215 10.129808,4.35522435 10.6057692,4.00777154 L13.1057692,2.18364427 C13.9711538,1.55388619 14.9855772,1.23780049 16,1.23780049 Z M16,2.39597654 C15.4062498,2.39597654 14.9086542,2.81917098 14.7956732,3.37942257 C14.7788462,3.45877199 14.7692308,3.54292951 14.7692308,3.62708765 C14.7692308,3.71124579 14.7788462,3.79540393 14.7956732,3.87475274 C14.9086542,4.43500432 15.4062498,4.85819876 16,4.85819876 C16.5937502,4.85819876 17.0913465,4.43500432 17.2043268,3.87475274 C17.2211538,3.79540393 17.2307692,3.71124579 17.2307692,3.62708765 C17.2307692,3.54292951 17.2211538,3.45877199 17.2043268,3.37942257 C17.0913465,2.81917098 16.5937502,2.39597654 16,2.39597654 Z M1.84615385,3.63136432 L9.254808,3.63136432 C8.84855754,4.16460772 8.61538462,4.82332081 8.61538462,5.50857497 L8.61538462,6.10213989 L4.92307692,6.10213989 C4.24519262,6.10213989 3.69230769,6.65709955 3.69230769,7.33752767 L3.69230769,33.2806711 C3.69230769,33.9610998 4.24519262,34.5160589 4.92307692,34.5160589 L22.2596154,34.5160589 C22.7524037,34.5160589 23.2163465,34.3230295 23.564904,33.973164 L27.7668271,29.7554729 C28.1153846,29.4056074 28.3076923,28.9399236 28.3076923,28.4452861 L28.3076923,7.33752767 C28.3076923,6.65709955 27.754808,6.10213989 27.0769231,6.10213989 L23.3846154,6.10213989 L23.3846154,5.50857497 C23.3846154,4.82332081 23.1514425,4.16460772 22.7451926,3.63136432 L30.1538462,3.63136432 C30.4927883,3.63136432 30.7692308,3.90884415 30.7692308,4.24905821 L30.7692308,36.3691405 C30.7692308,36.7093546 30.4927883,36.9868344 30.1538462,36.9868344 L1.84615385,36.9868344 C1.50721169,36.9868344 1.23076923,36.7093546 1.23076923,36.3691405 L1.23076923,4.24905821 C1.23076923,3.90884415 1.50721169,3.63136432 1.84615385,3.63136432 Z M4.92307692,7.33752767 L8.72836554,7.33752767 C8.98317292,8.05414894 9.66105785,8.57291545 10.4615385,8.57291545 L21.5384615,8.57291545 C22.3389422,8.57291545 23.0168271,8.05414894 23.2716345,7.33752767 L27.0769231,7.33752767 L27.0769231,28.33912 L23.3846154,28.33912 C22.7067311,28.33912 22.1538462,28.8940796 22.1538462,29.5745077 L22.1538462,33.2806711 L4.92307692,33.2806711 L4.92307692,7.33752767 Z M6.76923077,9.80830323 C6.43028862,9.80830323 6.15384615,10.0857831 6.15384615,10.4259971 L6.15384615,11.6613849 C6.15384615,12.001599 6.43028862,12.2790788 6.76923077,12.2790788 C7.10817292,12.2790788 7.38461538,12.001599 7.38461538,11.6613849 L7.38461538,10.4259971 C7.38461538,10.0857831 7.10817292,9.80830323 6.76923077,9.80830323 Z M9.84615385,9.80830323 C9.50721169,9.80830323 9.23076923,10.0857831 9.23076923,10.4259971 L9.23076923,11.6613849 C9.23076923,12.001599 9.50721169,12.2790788 9.84615385,12.2790788 C10.185096,12.2790788 10.4615385,12.001599 10.4615385,11.6613849 L10.4615385,10.4259971 C10.4615385,10.0857831 10.185096,9.80830323 9.84615385,9.80830323 Z M12.9230769,9.80830323 C12.5841348,9.80830323 12.3076923,10.0857831 12.3076923,10.4259971 L12.3076923,11.6613849 C12.3076923,12.001599 12.5841348,12.2790788 12.9230769,12.2790788 C13.2620191,12.2790788 13.5384615,12.001599 13.5384615,11.6613849 L13.5384615,10.4259971 C13.5384615,10.0857831 13.2620191,9.80830323 12.9230769,9.80830323 Z M16,9.80830323 C15.6610578,9.80830323 15.3846154,10.0857831 15.3846154,10.4259971 L15.3846154,11.6613849 C15.3846154,12.001599 15.6610578,12.2790788 16,12.2790788 C16.3389422,12.2790788 16.6153846,12.001599 16.6153846,11.6613849 L16.6153846,10.4259971 C16.6153846,10.0857831 16.3389422,9.80830323 16,9.80830323 Z M19.0769231,9.80830323 C18.7379809,9.80830323 18.4615385,10.0857831 18.4615385,10.4259971 L18.4615385,11.6613849 C18.4615385,12.001599 18.7379809,12.2790788 19.0769231,12.2790788 C19.4158652,12.2790788 19.6923077,12.001599 19.6923077,11.6613849 L19.6923077,10.4259971 C19.6923077,10.0857831 19.4158652,9.80830323 19.0769231,9.80830323 Z M22.1538462,9.80830323 C21.814904,9.80830323 21.5384615,10.0857831 21.5384615,10.4259971 L21.5384615,11.6613849 C21.5384615,12.001599 21.814904,12.2790788 22.1538462,12.2790788 C22.4927883,12.2790788 22.7692308,12.001599 22.7692308,11.6613849 L22.7692308,10.4259971 C22.7692308,10.0857831 22.4927883,9.80830323 22.1538462,9.80830323 Z M25.2307692,9.80830323 C24.8918271,9.80830323 24.6153846,10.0857831 24.6153846,10.4259971 L24.6153846,11.6613849 C24.6153846,12.001599 24.8918271,12.2790788 25.2307692,12.2790788 C25.5697114,12.2790788 25.8461538,12.001599 25.8461538,11.6613849 L25.8461538,10.4259971 C25.8461538,10.0857831 25.5697114,9.80830323 25.2307692,9.80830323 Z M8.61538462,15.9852421 C7.93750031,15.9852421 7.38461538,16.5402018 7.38461538,17.2206299 L7.38461538,18.4560177 C7.38461538,19.1364464 7.93750031,19.6914055 8.61538462,19.6914055 L9.84615385,19.6914055 C10.5240388,19.6914055 11.0769231,19.1364464 11.0769231,18.4560177 L11.0769231,17.2206299 C11.0769231,16.5402018 10.5240388,15.9852421 9.84615385,15.9852421 L8.61538462,15.9852421 Z M12.9230769,15.9852421 C12.5841348,15.9852421 12.3076923,16.262722 12.3076923,16.602936 C12.3076923,16.9431501 12.5841348,17.2206299 12.9230769,17.2206299 L19.0769231,17.2206299 C19.4158652,17.2206299 19.6923077,16.9431501 19.6923077,16.602936 C19.6923077,16.262722 19.4158652,15.9852421 19.0769231,15.9852421 L12.9230769,15.9852421 Z M21.5384615,15.9852421 C21.1995194,15.9852421 20.9230769,16.262722 20.9230769,16.602936 C20.9230769,16.9431501 21.1995194,17.2206299 21.5384615,17.2206299 L24,17.2206299 C24.3389422,17.2206299 24.6153846,16.9431501 24.6153846,16.602936 C24.6153846,16.262722 24.3389422,15.9852421 24,15.9852421 L21.5384615,15.9852421 Z M8.38461538,16.9889947 L10.0769231,16.9889947 L10.0769231,18.6876529 L8.38461538,18.6876529 L8.38461538,16.9889947 Z M12.9230769,18.4560177 C12.5841348,18.4560177 12.3076923,18.7334975 12.3076923,19.0737116 C12.3076923,19.4139257 12.5841348,19.6914055 12.9230769,19.6914055 L20.3076923,19.6914055 C20.6466345,19.6914055 20.9230769,19.4139257 20.9230769,19.0737116 C20.9230769,18.7334975 20.6466345,18.4560177 20.3076923,18.4560177 L12.9230769,18.4560177 Z M10.4615385,22.1621811 C10.3052886,22.1621811 10.1466345,22.2225026 10.0264425,22.3431462 L8.61538462,23.7594992 L8.435096,23.578534 C8.19471138,23.3372473 7.80528862,23.3372473 7.564904,23.578534 C7.32451938,23.8198207 7.32451938,24.2107048 7.564904,24.4519915 L8.18028862,25.0696853 C8.30048062,25.190329 8.45673108,25.2506505 8.61538462,25.2506505 C8.77403877,25.2506505 8.93028862,25.190329 9.05048062,25.0696853 L10.8966345,23.2166037 C11.1370191,22.975317 11.1370191,22.5844329 10.8966345,22.3431462 C10.7764425,22.2225026 10.6177883,22.1621811 10.4615385,22.1621811 Z M12.9230769,22.1621811 C12.5841348,22.1621811 12.3076923,22.4396609 12.3076923,22.7798749 C12.3076923,23.120089 12.5841348,23.3975688 12.9230769,23.3975688 L22.7692308,23.3975688 C23.1081729,23.3975688 23.3846154,23.120089 23.3846154,22.7798749 C23.3846154,22.4396609 23.1081729,22.1621811 22.7692308,22.1621811 L12.9230769,22.1621811 Z M12.9230769,24.6329566 C12.5841348,24.6329566 12.3076923,24.9104365 12.3076923,25.2506505 C12.3076923,25.5908646 12.5841348,25.8683444 12.9230769,25.8683444 L20.3076923,25.8683444 C20.6466345,25.8683444 20.9230769,25.5908646 20.9230769,25.2506505 C20.9230769,24.9104365 20.6466345,24.6329566 20.3076923,24.6329566 L12.9230769,24.6329566 Z M23.3846154,29.5745077 L26.2067311,29.5745077 L23.3846154,32.4072136 L23.3846154,29.5745077 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(4.000000, 0.444444)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/checklist/empty',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'checklist---empty',
                            tabindex: '-1',
                            transform: 'translate(960.000000, 479.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-985.000000, -479.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-checklist_empty',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Checklist - Empty',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '0EEDC0F4-1164-464D-A3CD-0C2922C8E93D',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M13.9487179,0.392360889 C12.7522702,0.392360889 11.5535522,0.766744325 10.5319179,1.5155112 L8.96314103,2.66148947 L1.74358974,2.66148947 C0.785523795,2.66148947 0,3.4513475 0,4.41469971 L0,33.6348703 C0,34.5982231 0.785523795,35.3880806 1.74358974,35.3880806 L8.13675214,35.3880806 L8.13675214,36.5568874 C8.13675214,37.2006446 8.65892123,37.7256942 9.2991453,37.7256942 L24.5101496,37.7256942 C24.9732906,37.7256942 25.4159991,37.5430682 25.740652,37.2120586 L29.7114051,33.2193963 C30.0405983,32.8929521 30.2222222,32.4478009 30.2222222,31.9821044 L30.2222222,13.1807509 C30.2222222,12.5369943 29.7000537,12.0119441 29.0598291,12.0119441 L27.8974359,12.0119441 L27.8974359,4.41469971 C27.8974359,3.4513475 27.1119127,2.66148947 26.1538462,2.66148947 L18.9342949,2.66148947 L17.365518,1.5155112 C16.3438837,0.766744325 15.1451657,0.394643569 13.9487179,0.392360889 Z M13.9487179,1.56573307 C14.9067845,1.56573307 15.8671206,1.8647834 16.686699,2.46288348 L16.9591349,2.66148947 L18.5528846,3.8302963 L19.0409991,4.18641713 C19.4927888,4.51286137 19.7606838,5.04475964 19.7606838,5.60633508 L19.7606838,6.75231336 C19.7606838,7.07419166 19.4995992,7.33671677 19.1794872,7.33671677 L8.71794872,7.33671677 C8.39783668,7.33671677 8.13675214,7.07419166 8.13675214,6.75231336 L8.13675214,5.60633508 C8.13675214,5.04475964 8.40464773,4.51286137 8.85643682,4.18641713 L9.34455128,3.8302963 L10.9383016,2.66148947 L11.2107375,2.46288348 C12.0303153,1.8647834 12.990652,1.56573307 13.9487179,1.56573307 Z M14.0174359,2.66148947 C13.3369583,2.66148947 12.7863248,3.212123 12.7863248,3.89260058 C12.7863248,4.57307817 13.3369583,5.12371169 14.0174359,5.12371169 C14.6979135,5.12371169 15.248547,4.57307817 15.248547,3.89260058 C15.248547,3.212123 14.6979135,2.66148947 14.0174359,2.66148947 Z M1.74358974,3.8302963 L7.57371795,3.8302963 C7.19003754,4.33251798 6.97435897,4.95801255 6.97435897,5.60633508 L6.97435897,6.16790995 L4.64957265,6.16790995 C4.00934858,6.16790995 3.48717949,6.69296018 3.48717949,7.33671677 L3.48717949,30.7128533 C3.48717949,31.3566104 4.00934858,31.8816601 4.64957265,31.8816601 L6.39316239,31.8816601 C6.71327443,31.8816601 6.97435897,31.619135 6.97435897,31.2972567 C6.97435897,30.9753784 6.71327443,30.7128533 6.39316239,30.7128533 L4.64957265,30.7128533 L4.64957265,7.33671677 L7.07879303,7.33671677 C7.31717429,8.0147159 7.96193925,8.5055236 8.71794872,8.5055236 L19.1794872,8.5055236 C19.9354966,8.5055236 20.5802616,8.0147159 20.8186435,7.33671677 L23.2478632,7.33671677 L23.2478632,10.2587338 C23.2478632,10.5806121 23.5089478,10.8431372 23.8290598,10.8431372 C24.1491719,10.8431372 24.4102564,10.5806121 24.4102564,10.2587338 L24.4102564,7.33671677 C24.4102564,6.69296018 23.8880879,6.16790995 23.2478632,6.16790995 L20.9230769,6.16790995 L20.9230769,5.60633508 C20.9230769,4.95801255 20.7073984,4.33251798 20.3237179,3.8302963 L26.1538462,3.8302963 C26.4739582,3.8302963 26.7350427,4.09282141 26.7350427,4.41469971 L26.7350427,12.0119441 L9.2991453,12.0119441 C8.65892123,12.0119441 8.13675214,12.5369943 8.13675214,13.1807509 L8.13675214,34.2192737 L1.74358974,34.2192737 C1.42347771,34.2192737 1.16239316,33.9567486 1.16239316,33.6348703 L1.16239316,4.41469971 C1.16239316,4.09282141 1.42347771,3.8302963 1.74358974,3.8302963 Z M9.2991453,13.1807509 L29.0598291,13.1807509 L29.0598291,31.8816601 L25.5726496,31.8816601 C24.9324255,31.8816601 24.4102564,32.4067103 24.4102564,33.0504669 L24.4102564,36.5568874 L9.2991453,36.5568874 L9.2991453,13.1807509 Z M12.2051282,15.5183645 C11.882746,15.5183645 11.6239316,15.7808897 11.6239316,16.102768 L11.6239316,17.2715748 C11.6239316,17.5934531 11.882746,17.8559782 12.2051282,17.8559782 C12.527511,17.8559782 12.7863248,17.5934531 12.7863248,17.2715748 L12.7863248,16.102768 C12.7863248,15.7808897 12.527511,15.5183645 12.2051282,15.5183645 Z M15.1111111,15.5183645 C14.7887289,15.5183645 14.5299145,15.7808897 14.5299145,16.102768 L14.5299145,17.2715748 C14.5299145,17.5934531 14.7887289,17.8559782 15.1111111,17.8559782 C15.4334939,17.8559782 15.6923077,17.5934531 15.6923077,17.2715748 L15.6923077,16.102768 C15.6923077,15.7808897 15.4334939,15.5183645 15.1111111,15.5183645 Z M18.017094,15.5183645 C17.6947118,15.5183645 17.4358974,15.7808897 17.4358974,16.102768 L17.4358974,17.2715748 C17.4358974,17.5934531 17.6947118,17.8559782 18.017094,17.8559782 C18.3394768,17.8559782 18.5982906,17.5934531 18.5982906,17.2715748 L18.5982906,16.102768 C18.5982906,15.7808897 18.3394768,15.5183645 18.017094,15.5183645 Z M20.9230769,15.5183645 C20.6006947,15.5183645 20.3418803,15.7808897 20.3418803,16.102768 L20.3418803,17.2715748 C20.3418803,17.5934531 20.6006947,17.8559782 20.9230769,17.8559782 C21.2454597,17.8559782 21.5042735,17.5934531 21.5042735,17.2715748 L21.5042735,16.102768 C21.5042735,15.7808897 21.2454597,15.5183645 20.9230769,15.5183645 Z M23.8290598,15.5183645 C23.5066776,15.5183645 23.2478632,15.7808897 23.2478632,16.102768 L23.2478632,17.2715748 C23.2478632,17.5934531 23.5066776,17.8559782 23.8290598,17.8559782 C24.1514426,17.8559782 24.4102564,17.5934531 24.4102564,17.2715748 L24.4102564,16.102768 C24.4102564,15.7808897 24.1514426,15.5183645 23.8290598,15.5183645 Z M26.7350427,15.5183645 C26.4126605,15.5183645 26.1538462,15.7808897 26.1538462,16.102768 L26.1538462,17.2715748 C26.1538462,17.5934531 26.4126605,17.8559782 26.7350427,17.8559782 C27.0574255,17.8559782 27.3162393,17.5934531 27.3162393,17.2715748 L27.3162393,16.102768 C27.3162393,15.7808897 27.0574255,15.5183645 26.7350427,15.5183645 Z M13.3675214,21.3623987 C13.0451392,21.3623987 12.7863248,21.6249238 12.7863248,21.9468021 C12.7863248,22.2686804 13.0451392,22.5312055 13.3675214,22.5312055 L20.3418803,22.5312055 C20.6642631,22.5312055 20.9230769,22.2686804 20.9230769,21.9468021 C20.9230769,21.6249238 20.6642631,21.3623987 20.3418803,21.3623987 L13.3675214,21.3623987 Z M22.6666667,21.3623987 C22.3442845,21.3623987 22.0854701,21.6249238 22.0854701,21.9468021 C22.0854701,22.2686804 22.3442845,22.5312055 22.6666667,22.5312055 L24.991453,22.5312055 C25.3138358,22.5312055 25.5726496,22.2686804 25.5726496,21.9468021 C25.5726496,21.6249238 25.3138358,21.3623987 24.991453,21.3623987 L22.6666667,21.3623987 Z M13.3675214,23.7000123 C13.0451392,23.7000123 12.7863248,23.9625374 12.7863248,24.2844157 C12.7863248,24.606294 13.0451392,24.8688191 13.3675214,24.8688191 L22.6666667,24.8688191 C22.9890494,24.8688191 23.2478632,24.606294 23.2478632,24.2844157 C23.2478632,23.9625374 22.9890494,23.7000123 22.6666667,23.7000123 L13.3675214,23.7000123 Z M13.3675214,27.2064328 C13.0451392,27.2064328 12.7863248,27.4689579 12.7863248,27.7908362 C12.7863248,28.1127145 13.0451392,28.3752396 13.3675214,28.3752396 L23.8290598,28.3752396 C24.1514426,28.3752396 24.4102564,28.1127145 24.4102564,27.7908362 C24.4102564,27.4689579 24.1514426,27.2064328 23.8290598,27.2064328 L13.3675214,27.2064328 Z M13.3675214,29.5440464 C13.0451392,29.5440464 12.7863248,29.8065716 12.7863248,30.1284499 C12.7863248,30.4503282 13.0451392,30.7128533 13.3675214,30.7128533 L18.017094,30.7128533 C18.3394768,30.7128533 18.5982906,30.4503282 18.5982906,30.1284499 C18.5982906,29.8065716 18.3394768,29.5440464 18.017094,29.5440464 L13.3675214,29.5440464 Z M25.5726496,33.0504669 L28.2402512,33.0504669 L25.5726496,35.7327874 L25.5726496,33.0504669 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(4.888889, 0.444444)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/clipboard',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'edit',
                            tabindex: '-1',
                            transform: 'translate(846.000000, 479.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-871.000000, -479.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-clipboard',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Clipboard',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '69D29E8C-4C98-463B-A070-C0D726C750B8',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M2.05797076,0 C0.92128491,0 0,0.916650701 0,2.04761884 L0,36.1745995 C0,37.3055676 0.92128491,38.2222222 2.05797076,38.2222222 L22.1848178,38.2222222 C23.0951268,38.2235834 23.9690887,37.8646099 24.6139196,37.2250703 L30.5533624,31.3155038 C31.1961353,30.6739165 31.5569236,29.8043508 31.5555556,28.8986207 L31.5555556,2.04761884 C31.5555556,0.916650701 30.6342667,0 29.4975809,0 L2.05797076,0 Z M2.05797076,1.36507923 L29.4975809,1.36507923 C29.8762475,1.36507923 30.1835712,1.67085697 30.1835712,2.04761884 L30.1835712,28.6666638 L24.0096589,28.6666638 C22.872973,28.6666638 21.9516881,29.5833145 21.9516881,30.7142826 L21.9516881,36.8571391 L2.05797076,36.8571391 C1.67930414,36.8571391 1.37198051,36.5513614 1.37198051,36.1745995 L1.37198051,2.04761884 C1.37198051,1.67085697 1.67930414,1.36507923 2.05797076,1.36507923 Z M6.85990253,8.19047536 C6.48123591,8.19047536 6.17391228,8.49625311 6.17391228,8.87301497 C6.17391228,9.24977684 6.48123591,9.55555459 6.85990253,9.55555459 L9.60386355,9.55555459 C9.98253017,9.55555459 10.2898538,9.24977684 10.2898538,8.87301497 C10.2898538,8.49625311 9.98253017,8.19047536 9.60386355,8.19047536 L6.85990253,8.19047536 Z M12.3478246,8.19047536 C11.9691579,8.19047536 11.6618343,8.49625311 11.6618343,8.87301497 C11.6618343,9.24977684 11.9691579,9.55555459 12.3478246,9.55555459 L24.6956491,9.55555459 C25.0743157,9.55555459 25.3816394,9.24977684 25.3816394,8.87301497 C25.3816394,8.49625311 25.0743157,8.19047536 24.6956491,8.19047536 L12.3478246,8.19047536 Z M6.85990253,12.285713 C6.48123591,12.285713 6.17391228,12.5914908 6.17391228,12.9682527 C6.17391228,13.3450145 6.48123591,13.6507923 6.85990253,13.6507923 L9.60386355,13.6507923 C9.98253017,13.6507923 10.2898538,13.3450145 10.2898538,12.9682527 C10.2898538,12.5914908 9.98253017,12.285713 9.60386355,12.285713 L6.85990253,12.285713 Z M12.3478246,12.285713 C11.9691579,12.285713 11.6618343,12.5914908 11.6618343,12.9682527 C11.6618343,13.3450145 11.9691579,13.6507923 12.3478246,13.6507923 L24.6956491,13.6507923 C25.0743157,13.6507923 25.3816394,13.3450145 25.3816394,12.9682527 C25.3816394,12.5914908 25.0743157,12.285713 24.6956491,12.285713 L12.3478246,12.285713 Z M6.85990253,16.3809507 C6.48123591,16.3809507 6.17391228,16.6867285 6.17391228,17.0634903 C6.17391228,17.4402522 6.48123591,17.7460299 6.85990253,17.7460299 L9.60386355,17.7460299 C9.98253017,17.7460299 10.2898538,17.4402522 10.2898538,17.0634903 C10.2898538,16.6867285 9.98253017,16.3809507 9.60386355,16.3809507 L6.85990253,16.3809507 Z M12.3478246,16.3809507 C11.9691579,16.3809507 11.6618343,16.6867285 11.6618343,17.0634903 C11.6618343,17.4402522 11.9691579,17.7460299 12.3478246,17.7460299 L24.6956491,17.7460299 C25.0743157,17.7460299 25.3816394,17.4402522 25.3816394,17.0634903 C25.3816394,16.6867285 25.0743157,16.3809507 24.6956491,16.3809507 L12.3478246,16.3809507 Z M6.85990253,20.4761884 C6.48123591,20.4761884 6.17391228,20.7819661 6.17391228,21.158728 C6.17391228,21.5354899 6.48123591,21.8412676 6.85990253,21.8412676 L9.60386355,21.8412676 C9.98253017,21.8412676 10.2898538,21.5354899 10.2898538,21.158728 C10.2898538,20.7819661 9.98253017,20.4761884 9.60386355,20.4761884 L6.85990253,20.4761884 Z M12.3478246,20.4761884 C11.9691579,20.4761884 11.6618343,20.7819661 11.6618343,21.158728 C11.6618343,21.5354899 11.9691579,21.8412676 12.3478246,21.8412676 L24.6956491,21.8412676 C25.0743157,21.8412676 25.3816394,21.5354899 25.3816394,21.158728 C25.3816394,20.7819661 25.0743157,20.4761884 24.6956491,20.4761884 L12.3478246,20.4761884 Z M6.85990253,24.5714261 C6.48123591,24.5714261 6.17391228,24.8772038 6.17391228,25.2539657 C6.17391228,25.6307276 6.48123591,25.9365053 6.85990253,25.9365053 L9.60386355,25.9365053 C9.98253017,25.9365053 10.2898538,25.6307276 10.2898538,25.2539657 C10.2898538,24.8772038 9.98253017,24.5714261 9.60386355,24.5714261 L6.85990253,24.5714261 Z M12.3478246,24.5714261 C11.9691579,24.5714261 11.6618343,24.8772038 11.6618343,25.2539657 C11.6618343,25.6307276 11.9691579,25.9365053 12.3478246,25.9365053 L24.6956491,25.9365053 C25.0743157,25.9365053 25.3816394,25.6307276 25.3816394,25.2539657 C25.3816394,24.8772038 25.0743157,24.5714261 24.6956491,24.5714261 L12.3478246,24.5714261 Z M24.0096589,30.031743 L29.840576,30.031743 C29.7644311,30.1450446 29.6767211,30.2507959 29.5793105,30.3463514 L23.6398676,36.255918 C23.5438283,36.3528386 23.437543,36.4401074 23.3236686,36.5158693 L23.3236686,30.7142826 C23.3236686,30.3375207 23.6309922,30.031743 24.0096589,30.031743 Z M4.80193177,32.7619014 C4.42326515,32.7619014 4.11594152,33.0676792 4.11594152,33.4444411 L4.11594152,34.8095203 C4.11594152,35.1862821 4.42326515,35.4920599 4.80193177,35.4920599 C5.18059839,35.4920599 5.48792203,35.1862821 5.48792203,34.8095203 L5.48792203,33.4444411 C5.48792203,33.0676792 5.18059839,32.7619014 4.80193177,32.7619014 Z M8.23188304,32.7619014 C7.85321642,32.7619014 7.54589279,33.0676792 7.54589279,33.4444411 L7.54589279,34.8095203 C7.54589279,35.1862821 7.85321642,35.4920599 8.23188304,35.4920599 C8.61054966,35.4920599 8.91787329,35.1862821 8.91787329,34.8095203 L8.91787329,33.4444411 C8.91787329,33.0676792 8.61054966,32.7619014 8.23188304,32.7619014 Z M11.6618343,32.7619014 C11.2831677,32.7619014 10.9758441,33.0676792 10.9758441,33.4444411 L10.9758441,34.8095203 C10.9758441,35.1862821 11.2831677,35.4920599 11.6618343,35.4920599 C12.0405009,35.4920599 12.3478246,35.1862821 12.3478246,34.8095203 L12.3478246,33.4444411 C12.3478246,33.0676792 12.0405009,32.7619014 11.6618343,32.7619014 Z M15.0917856,32.7619014 C14.713119,32.7619014 14.4057953,33.0676792 14.4057953,33.4444411 L14.4057953,34.8095203 C14.4057953,35.1862821 14.713119,35.4920599 15.0917856,35.4920599 C15.4704522,35.4920599 15.7777758,35.1862821 15.7777758,34.8095203 L15.7777758,33.4444411 C15.7777758,33.0676792 15.4704522,32.7619014 15.0917856,32.7619014 Z M18.5217368,32.7619014 C18.1430702,32.7619014 17.8357466,33.0676792 17.8357466,33.4444411 L17.8357466,34.8095203 C17.8357466,35.1862821 18.1430702,35.4920599 18.5217368,35.4920599 C18.9004035,35.4920599 19.2077271,35.1862821 19.2077271,34.8095203 L19.2077271,33.4444411 C19.2077271,33.0676792 18.9004035,32.7619014 18.5217368,32.7619014 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(4.444444, 0.888889)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/file-doc',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'file-doc',
                            tabindex: '-1',
                            transform: 'translate(732.000000, 479.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-757.000000, -479.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-file',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'File / Document',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '45FF5659-916A-4A3D-A460-5E9109F2F552',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M6.14285714,0 C5.01506679,0 4.0952381,0.919828698 4.0952381,2.04761905 L4.0952381,32.7619048 L1.36507937,32.7619048 C0.613219587,32.7619048 0,33.3751243 0,34.1269841 L0,35.4920635 C0,36.9984497 1.22377249,38.2222222 2.73015873,38.2222222 L35.4920635,38.2222222 C36.9984497,38.2222222 38.2222222,36.9984497 38.2222222,35.4920635 L38.2222222,2.04761905 C38.2222222,0.919828698 37.3023935,0 36.1746032,0 L6.14285714,0 Z M6.14285714,1.36507937 L36.1746032,1.36507937 C36.5505331,1.36507937 36.8571429,1.67168916 36.8571429,2.04761905 L36.8571429,35.4920635 C36.8571429,36.243924 36.243924,36.8571429 35.4920635,36.8571429 C34.7402037,36.8571429 34.1269841,36.243924 34.1269841,35.4920635 L34.1269841,34.1269841 C34.1269841,33.3751243 33.5137652,32.7619048 32.7619048,32.7619048 L5.46031746,32.7619048 L5.46031746,2.04761905 C5.46031746,1.67168916 5.76692725,1.36507937 6.14285714,1.36507937 Z M13.6507937,4.78844246 C13.4375,4.78844246 13.2268723,4.87642592 13.0962302,5.05505952 L12.09375,6.43080357 L10.4860489,5.91356681 C10.278088,5.84691203 10.0514636,5.88423876 9.87549603,6.01221495 C9.69686243,6.14019114 9.59288229,6.34548611 9.5902156,6.56411244 L9.57955092,8.27845965 L7.97451654,8.81969246 C7.76655489,8.88901324 7.60658465,9.04898348 7.53993056,9.25694444 C7.47061046,9.4649061 7.50527051,9.68886443 7.6332467,9.86483135 L8.62239617,11.2619048 L7.6332467,12.6589782 C7.50527051,12.8376118 7.47061046,13.0615701 7.53993056,13.2668651 C7.60658465,13.4748267 7.76655489,13.637463 7.97451654,13.7067831 L9.55555556,14.2373512 L9.55555556,22.5238095 C9.55555556,22.7504339 9.66753506,22.9610615 9.85416667,23.0890377 C10.043465,23.2170139 10.280754,23.2410093 10.4913816,23.1583585 L13.6507937,21.8945933 L16.8102057,23.1583585 C16.8928571,23.1903525 16.9781746,23.2063492 17.0634921,23.2063492 C17.1968009,23.2063492 17.3301091,23.1663565 17.4474206,23.0890377 C17.6340529,22.9610615 17.7460317,22.7504339 17.7460317,22.5238095 L17.7460317,14.2373512 L19.3270708,13.7041171 C19.5350324,13.634797 19.6950027,13.4748267 19.7616567,13.2668651 C19.8309775,13.0615701 19.7963168,12.8349458 19.6683406,12.6589782 L18.6818578,11.2619048 L19.6710073,9.86483135 C19.7963168,9.68886443 19.8309775,9.46223941 19.7616567,9.25694444 C19.6950027,9.04898348 19.5350324,8.88901324 19.3297374,8.81969246 L17.7247024,8.27845965 L17.7113717,6.56411244 C17.7087057,6.34548611 17.6047249,6.14019114 17.4260913,6.01221495 C17.2501243,5.88423876 17.0234993,5.84691203 16.8155384,5.91356681 L15.2078373,6.43080357 L14.2053571,5.05505952 C14.074715,4.87642592 13.8640873,4.78844246 13.6507937,4.78844246 Z M13.6507937,6.62543386 L14.3893227,7.6385787 C14.5626243,7.8785344 14.8745661,7.97984854 15.1545139,7.88919908 L16.3462923,7.50793651 L16.3516243,8.77703373 C16.354291,9.07031284 16.5435886,9.33159722 16.8208704,9.42491337 L18.0153148,9.82483862 L17.2767857,10.8646455 C17.1114835,11.1019345 17.1114835,11.421875 17.2794517,11.659164 L18.0153148,12.6989709 L16.8208704,13.0988962 C16.5435886,13.1922123 16.354291,13.4534974 16.3516243,13.7467758 L16.3462923,15.015873 L15.1545139,14.6319444 C14.8719001,14.543961 14.5652903,14.6426091 14.3893227,14.8825648 L13.6507937,15.8983757 L12.9122646,14.8852308 C12.7816224,14.7039312 12.5736607,14.5999504 12.3577011,14.5999504 C12.2883803,14.5999504 12.2163942,14.6132811 12.1470734,14.6346104 L10.955295,15.015873 L10.949963,13.7467758 C10.947297,13.4534974 10.7579987,13.1922123 10.4807169,13.0988962 L9.28627249,12.6989709 L10.0248016,11.659164 C10.1927705,11.421875 10.1927705,11.1046005 10.0248016,10.8673115 L9.28627249,9.8275053 L10.4807169,9.42757937 C10.7579987,9.33159722 10.947297,9.07297884 10.949963,8.77969973 L10.955295,7.50793651 L12.1470734,7.89186508 C12.4296878,7.98251522 12.7389636,7.8812004 12.9122646,7.64391138 L13.6507937,6.62543386 Z M23.2063492,6.82539683 C22.8304193,6.82539683 22.5238095,7.12934062 22.5238095,7.50793651 C22.5238095,7.88653308 22.8304193,8.19047619 23.2063492,8.19047619 L25.9365079,8.19047619 C26.3124378,8.19047619 26.6190476,7.88653308 26.6190476,7.50793651 C26.6190476,7.12934062 26.3124378,6.82539683 25.9365079,6.82539683 L23.2063492,6.82539683 Z M28.6666667,6.82539683 C28.2907368,6.82539683 27.984127,7.12934062 27.984127,7.50793651 C27.984127,7.88653308 28.2907368,8.19047619 28.6666667,8.19047619 L32.7619048,8.19047619 C33.1378347,8.19047619 33.4444444,7.88653308 33.4444444,7.50793651 C33.4444444,7.12934062 33.1378347,6.82539683 32.7619048,6.82539683 L28.6666667,6.82539683 Z M23.2063492,9.55555556 C22.8304193,9.55555556 22.5238095,9.85949935 22.5238095,10.2380952 C22.5238095,10.6166918 22.8304193,10.9206349 23.2063492,10.9206349 L30.031746,10.9206349 C30.4076759,10.9206349 30.7142857,10.6166918 30.7142857,10.2380952 C30.7142857,9.85949935 30.4076759,9.55555556 30.031746,9.55555556 L23.2063492,9.55555556 Z M23.2063492,15.015873 C22.8304193,15.015873 22.5238095,15.3198168 22.5238095,15.6984127 C22.5238095,16.0770093 22.8304193,16.3809524 23.2063492,16.3809524 L32.7619048,16.3809524 C33.1378347,16.3809524 33.4444444,16.0770093 33.4444444,15.6984127 C33.4444444,15.3198168 33.1378347,15.015873 32.7619048,15.015873 L23.2063492,15.015873 Z M12.09375,16.093006 L13.0962302,17.46875 C13.2242063,17.6447176 13.432168,17.7486977 13.6507937,17.7486977 C13.86942,17.7486977 14.077381,17.6447176 14.2053571,17.46875 L15.2078373,16.093006 L16.3809524,16.4689358 L16.3809524,21.5159974 L13.90408,20.5241819 C13.8214286,20.4921878 13.7361111,20.4761905 13.6507937,20.4761905 C13.5654762,20.4761905 13.4801587,20.4921878 13.3975073,20.5241819 L10.9206349,21.5159974 L10.9206349,16.4689358 L12.09375,16.093006 Z M23.2063492,17.7460317 C22.8304193,17.7460317 22.5238095,18.0499755 22.5238095,18.4285714 C22.5238095,18.807168 22.8304193,19.1111111 23.2063492,19.1111111 L27.3015873,19.1111111 C27.6775172,19.1111111 27.984127,18.807168 27.984127,18.4285714 C27.984127,18.0499755 27.6775172,17.7460317 27.3015873,17.7460317 L23.2063492,17.7460317 Z M30.031746,17.7460317 C29.6558161,17.7460317 29.3492063,18.0499755 29.3492063,18.4285714 C29.3492063,18.807168 29.6558161,19.1111111 30.031746,19.1111111 L31.3968254,19.1111111 C31.7727553,19.1111111 32.0793651,18.807168 32.0793651,18.4285714 C32.0793651,18.0499755 31.7727553,17.7460317 31.3968254,17.7460317 L30.031746,17.7460317 Z M24.9660218,21.1587302 C24.7473962,21.1667288 24.5687626,21.2307169 24.4407864,21.300037 C23.2543406,21.9239213 23.2543406,24.1795013 23.6515999,26.0831475 C23.8302335,26.9416541 24.3234749,28.0401164 24.9740205,28.9386164 C24.6434153,29.6371528 24.219494,30.2743677 23.6995906,30.7569444 C23.4249755,31.0155628 23.4116442,31.4474828 23.6675966,31.7220986 C23.8035714,31.8660714 23.984871,31.9407242 24.1661706,31.9407242 C24.3341396,31.9407242 24.5021085,31.8794021 24.6354167,31.7567586 C25.1553201,31.2661832 25.5952381,30.666295 25.9578373,30.0077507 C26.0538194,30.0850694 26.1524676,30.1570562 26.2511164,30.2210443 C26.5310642,30.4023439 26.7950152,30.5009921 27.0642983,30.5249874 C27.3789061,30.5516495 27.7095112,30.4743307 28.0454491,30.2876984 C28.5653525,29.999752 29.1679067,29.3705357 29.6691468,28.6320066 C30.1383929,28.7839782 30.5969742,28.7786462 30.9889015,28.6080113 C31.9647196,28.18409 33.1405013,26.6883684 33.3697917,26.2484497 C33.5430926,25.9178446 33.4124504,25.5045886 33.0791792,25.331287 C32.7432414,25.1579861 32.3326515,25.2859623 32.1566839,25.6192335 C31.9967136,25.9258433 31.0048981,27.112289 30.4423367,27.3575767 C30.4210073,27.3682414 30.3943452,27.3735741 30.3623512,27.3762401 C30.5809775,26.8670013 30.7142857,26.3684279 30.7142857,25.9365079 C30.7142857,25.0246779 30.3516865,24.3074775 29.7437996,24.0168651 C29.2852183,23.7955727 28.7493181,23.8595608 28.3413942,24.184834 C28.0507811,24.416791 27.4162328,25.1259921 27.778832,26.7016991 C27.8774802,27.1309524 28.1414312,27.5628724 28.5066964,27.9174729 C28.1494299,28.4427083 27.7335073,28.9012897 27.3842388,29.09592 C27.2455979,29.1705727 27.1842758,29.1652407 27.1842758,29.1679067 C27.1682791,29.1652407 27.1176217,29.1545761 26.9923115,29.0745906 C26.845672,28.9812751 26.6963664,28.855965 26.5523935,28.7066594 C26.9949775,27.517547 27.2216025,26.2591144 27.2535966,25.1926462 C27.2962553,23.6942586 26.9736481,22.5051462 26.3444319,21.8439358 C25.8111977,21.2867063 25.3339537,21.1427335 24.9660218,21.1587302 Z M25.0486733,22.5371402 C25.1046627,22.5664683 25.2113095,22.638455 25.3552831,22.7877606 C25.7152156,23.1636905 25.9205113,24.0701885 25.8885172,25.1553201 C25.8698538,25.8005331 25.760541,26.5497275 25.563244,27.3042533 C25.2886283,26.7843505 25.0806673,26.2457837 24.9873512,25.8031997 C24.5740946,23.8302335 24.8673737,22.7690972 25.0486733,22.5371402 Z M29.1545761,25.2459696 C29.1919021,25.2646329 29.3492063,25.4459325 29.3492063,25.9365079 C29.3492063,26.1204735 29.2932169,26.3550966 29.1999008,26.6110489 C29.1545761,26.5337302 29.125248,26.4617434 29.1092513,26.3950893 C28.922619,25.5819074 29.1492434,25.2726316 29.1545761,25.2459696 Z M8.19047619,27.3015873 C7.8145463,27.3015873 7.50793651,27.6055311 7.50793651,27.984127 L7.50793651,29.3492063 C7.50793651,29.7278029 7.8145463,30.031746 8.19047619,30.031746 C8.56640608,30.031746 8.87301587,29.7278029 8.87301587,29.3492063 L8.87301587,27.984127 C8.87301587,27.6055311 8.56640608,27.3015873 8.19047619,27.3015873 Z M11.6031746,27.3015873 C11.2272447,27.3015873 10.9206349,27.6055311 10.9206349,27.984127 L10.9206349,29.3492063 C10.9206349,29.7278029 11.2272447,30.031746 11.6031746,30.031746 C11.9791045,30.031746 12.2857143,29.7278029 12.2857143,29.3492063 L12.2857143,27.984127 C12.2857143,27.6055311 11.9791045,27.3015873 11.6031746,27.3015873 Z M15.015873,27.3015873 C14.6399431,27.3015873 14.3333333,27.6055311 14.3333333,27.984127 L14.3333333,29.3492063 C14.3333333,29.7278029 14.6399431,30.031746 15.015873,30.031746 C15.3918029,30.031746 15.6984127,29.7278029 15.6984127,29.3492063 L15.6984127,27.984127 C15.6984127,27.6055311 15.3918029,27.3015873 15.015873,27.3015873 Z M18.4285714,27.3015873 C18.0526415,27.3015873 17.7460317,27.6055311 17.7460317,27.984127 L17.7460317,29.3492063 C17.7460317,29.7278029 18.0526415,30.031746 18.4285714,30.031746 C18.8045013,30.031746 19.1111111,29.7278029 19.1111111,29.3492063 L19.1111111,27.984127 C19.1111111,27.6055311 18.8045013,27.3015873 18.4285714,27.3015873 Z M21.8412698,27.3015873 C21.46534,27.3015873 21.1587302,27.6055311 21.1587302,27.984127 L21.1587302,29.3492063 C21.1587302,29.7278029 21.46534,30.031746 21.8412698,30.031746 C22.2171997,30.031746 22.5238095,29.7278029 22.5238095,29.3492063 L22.5238095,27.984127 C22.5238095,27.6055311 22.2171997,27.3015873 21.8412698,27.3015873 Z M34.1269841,27.3015873 C33.7510542,27.3015873 33.4444444,27.6055311 33.4444444,27.984127 L33.4444444,29.3492063 C33.4444444,29.7278029 33.7510542,30.031746 34.1269841,30.031746 C34.502914,30.031746 34.8095238,29.7278029 34.8095238,29.3492063 L34.8095238,27.984127 C34.8095238,27.6055311 34.502914,27.3015873 34.1269841,27.3015873 Z M1.36507937,34.1269841 L32.7619048,34.1269841 L32.7619048,35.4920635 C32.7619048,35.9906376 32.9058783,36.4545509 33.1431673,36.8571429 L2.73015873,36.8571429 C1.97829895,36.8571429 1.36507937,36.243924 1.36507937,35.4920635 L1.36507937,34.1269841 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(0.888889, 0.888889)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/credentials-attestations',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'credentials-attestations',
                            tabindex: '-1',
                            transform: 'translate(618.000000, 479.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-643.000000, -479.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-credentials',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Credentials',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'D104812F-EC52-4B0E-A365-C07C61CE8CED',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M0.625,0 C0.280761875,0 0,0.272135722 0,0.611111111 C0,0.950087111 0.280761875,1.22222222 0.625,1.22222222 L24.375,1.22222222 C24.7192381,1.22222222 25,1.49674494 25,1.83333333 L25,18.3333333 L2.5,18.3333333 L2.5,12.8333333 C2.5,12.4943579 2.21923812,12.2222222 1.875,12.2222222 C1.53076187,12.2222222 1.25,12.4943579 1.25,12.8333333 L1.25,18.3333333 C1.25,18.3715278 1.26464875,18.4049482 1.2719725,18.4383681 C0.534668125,18.6866319 0,19.3621963 0,20.1666667 L0,23.8333333 C0,24.8430991 0.842285,25.6666667 1.875,25.6666667 L5.04882812,25.6666667 C5.35400375,27.7363283 7.17529312,29.3333333 9.375,29.3333333 C11.5747069,29.3333333 13.3959962,27.7363283 13.7011719,25.6666667 L27.5488281,25.6666667 C27.8540038,27.7363283 29.6752931,29.3333333 31.875,29.3333333 C34.0747069,29.3333333 35.8959962,27.7363283 36.2011719,25.6666667 L38.125,25.6666667 C39.157715,25.6666667 40,24.8430991 40,23.8333333 L40,20.1666667 C40,19.3621963 39.4653319,18.6866319 38.7280275,18.4383681 C38.7353519,18.4049482 38.75,18.3715278 38.75,18.3333333 L38.75,15.9963106 C38.75,15.4090713 38.5791019,14.8385417 38.2519531,14.3420139 L33.7622069,7.51475694 C33.186035,6.63628472 32.20459,6.11111111 31.1352538,6.11111111 L30,6.11111111 L30,4.88888889 C30,4.5499135 29.7192381,4.27777778 29.375,4.27777778 C29.0307619,4.27777778 28.75,4.5499135 28.75,4.88888889 L28.75,6.11111111 L26.25,6.11111111 L26.25,1.83333333 C26.25,0.823567556 25.407715,0 24.375,0 L0.625,0 Z M0.625,2.44444444 C0.280761875,2.44444444 0,2.71658017 0,3.05555556 C0,3.39453156 0.280761875,3.66666667 0.625,3.66666667 L3.125,3.66666667 C3.46923812,3.66666667 3.75,3.39453156 3.75,3.05555556 C3.75,2.71658017 3.46923812,2.44444444 3.125,2.44444444 L0.625,2.44444444 Z M5.625,2.44444444 C5.28076187,2.44444444 5,2.71658017 5,3.05555556 C5,3.39453156 5.28076187,3.66666667 5.625,3.66666667 L19.375,3.66666667 C19.7192381,3.66666667 20,3.39453156 20,3.05555556 C20,2.71658017 19.7192381,2.44444444 19.375,2.44444444 L5.625,2.44444444 Z M0.625,4.88888889 C0.280761875,4.88888889 0,5.16102461 0,5.5 C0,5.838976 0.280761875,6.11111111 0.625,6.11111111 L14.375,6.11111111 C14.7192381,6.11111111 15,5.838976 15,5.5 C15,5.16102461 14.7192381,4.88888889 14.375,4.88888889 L0.625,4.88888889 Z M0.625,7.33333333 C0.280761875,7.33333333 0,7.60546906 0,7.94444444 C0,8.28342044 0.280761875,8.55555556 0.625,8.55555556 L9.375,8.55555556 C9.71923813,8.55555556 10,8.28342044 10,7.94444444 C10,7.60546906 9.71923813,7.33333333 9.375,7.33333333 L0.625,7.33333333 Z M26.25,7.33333333 L31.1352537,7.33333333 C31.7749025,7.33333333 32.3657225,7.6484375 32.7124025,8.17599811 L37.2021487,15.0032551 C37.3974612,15.3016496 37.5,15.6453996 37.5,15.9963106 L37.5,18.3333333 L26.25,18.3333333 L26.25,7.33333333 Z M28.75,8.55555556 C28.0615237,8.55555556 27.5,9.104601 27.5,9.77777778 L27.5,13.4444444 C27.5,14.1176218 28.0615237,14.6666667 28.75,14.6666667 L33.2470706,14.6666667 C33.7011719,14.6666667 34.1210937,14.4255644 34.3408206,14.0364583 C34.5605469,13.6497399 34.54834,13.1723093 34.3066406,12.7951389 L31.9628906,9.12847222 C31.7333987,8.77039961 31.3354494,8.55555556 30.9033206,8.55555556 L28.75,8.55555556 Z M0.625,9.77777778 C0.280761875,9.77777778 0,10.0499135 0,10.3888889 C0,10.7278649 0.280761875,11 0.625,11 L4.375,11 C4.71923812,11 5,10.7278649 5,10.3888889 C5,10.0499135 4.71923812,9.77777778 4.375,9.77777778 L0.625,9.77777778 Z M28.75,9.77777778 L30.9033206,9.77777778 L33.2519531,13.4444444 L28.75,13.4444444 L28.75,9.77777778 Z M28.125,15.8888889 C27.7807619,15.8888889 27.5,16.1610246 27.5,16.5 C27.5,16.838976 27.7807619,17.1111111 28.125,17.1111111 L29.375,17.1111111 C29.7192381,17.1111111 30,16.838976 30,16.5 C30,16.1610246 29.7192381,15.8888889 29.375,15.8888889 L28.125,15.8888889 Z M1.875,19.5555556 L38.125,19.5555556 C38.4692381,19.5555556 38.75,19.8300783 38.75,20.1666667 L38.75,23.8333333 C38.75,24.1699217 38.4692381,24.4444444 38.125,24.4444444 L36.2011719,24.4444444 C35.8959963,22.3747828 34.0747069,20.7777778 31.875,20.7777778 C29.6752931,20.7777778 27.8540038,22.3747828 27.5488281,24.4444444 L13.7011719,24.4444444 C13.3959963,22.3747828 11.5747069,20.7777778 9.375,20.7777778 C7.17529313,20.7777778 5.35400375,22.3747828 5.04882813,24.4444444 L1.875,24.4444444 C1.53076188,24.4444444 1.25,24.1699217 1.25,23.8333333 L1.25,23.2222222 C1.59423813,23.2222222 1.875,22.9500871 1.875,22.6111111 L1.875,21.3888889 C1.875,21.0499135 1.59423813,20.7777778 1.25,20.7777778 L1.25,20.1666667 C1.25,19.8300783 1.53076188,19.5555556 1.875,19.5555556 Z M4.375,20.7777778 C4.03076187,20.7777778 3.75,21.0499135 3.75,21.3888889 L3.75,22.6111111 C3.75,22.9500871 4.03076187,23.2222222 4.375,23.2222222 C4.71923812,23.2222222 5,22.9500871 5,22.6111111 L5,21.3888889 C5,21.0499135 4.71923812,20.7777778 4.375,20.7777778 Z M14.375,20.7777778 C14.0307619,20.7777778 13.75,21.0499135 13.75,21.3888889 L13.75,22.6111111 C13.75,22.9500871 14.0307619,23.2222222 14.375,23.2222222 C14.7192381,23.2222222 15,22.9500871 15,22.6111111 L15,21.3888889 C15,21.0499135 14.7192381,20.7777778 14.375,20.7777778 Z M17.5,20.7777778 C17.1557619,20.7777778 16.875,21.0499135 16.875,21.3888889 L16.875,22.6111111 C16.875,22.9500871 17.1557619,23.2222222 17.5,23.2222222 C17.8442381,23.2222222 18.125,22.9500871 18.125,22.6111111 L18.125,21.3888889 C18.125,21.0499135 17.8442381,20.7777778 17.5,20.7777778 Z M20.625,20.7777778 C20.2807619,20.7777778 20,21.0499135 20,21.3888889 L20,22.6111111 C20,22.9500871 20.2807619,23.2222222 20.625,23.2222222 C20.9692381,23.2222222 21.25,22.9500871 21.25,22.6111111 L21.25,21.3888889 C21.25,21.0499135 20.9692381,20.7777778 20.625,20.7777778 Z M23.75,20.7777778 C23.4057619,20.7777778 23.125,21.0499135 23.125,21.3888889 L23.125,22.6111111 C23.125,22.9500871 23.4057619,23.2222222 23.75,23.2222222 C24.0942381,23.2222222 24.375,22.9500871 24.375,22.6111111 L24.375,21.3888889 C24.375,21.0499135 24.0942381,20.7777778 23.75,20.7777778 Z M26.875,20.7777778 C26.5307619,20.7777778 26.25,21.0499135 26.25,21.3888889 L26.25,22.6111111 C26.25,22.9500871 26.5307619,23.2222222 26.875,23.2222222 C27.2192381,23.2222222 27.5,22.9500871 27.5,22.6111111 L27.5,21.3888889 C27.5,21.0499135 27.2192381,20.7777778 26.875,20.7777778 Z M36.875,20.7777778 C36.5307619,20.7777778 36.25,21.0499135 36.25,21.3888889 L36.25,22.6111111 C36.25,22.9500871 36.5307619,23.2222222 36.875,23.2222222 C37.2192381,23.2222222 37.5,22.9500871 37.5,22.6111111 L37.5,21.3888889 C37.5,21.0499135 37.2192381,20.7777778 36.875,20.7777778 Z M9.375,22 C11.0986331,22 12.5,23.370226 12.5,25.0555556 C12.5,26.7408857 11.0986331,28.1111111 9.375,28.1111111 C7.6513675,28.1111111 6.25,26.7408857 6.25,25.0555556 C6.25,23.370226 7.6513675,22 9.375,22 Z M31.875,22 C33.5986331,22 35,23.370226 35,25.0555556 C35,26.7408857 33.5986331,28.1111111 31.875,28.1111111 C30.1513675,28.1111111 28.75,26.7408857 28.75,25.0555556 C28.75,23.370226 30.1513675,22 31.875,22 Z M9.375,23.8333333 C8.68408187,23.8333333 8.125,24.3799912 8.125,25.0555556 C8.125,25.7311199 8.68408187,26.2777778 9.375,26.2777778 C10.0659181,26.2777778 10.625,25.7311199 10.625,25.0555556 C10.625,24.3799912 10.0659181,23.8333333 9.375,23.8333333 Z M31.875,23.8333333 C31.1840819,23.8333333 30.625,24.3799912 30.625,25.0555556 C30.625,25.7311199 31.1840819,26.2777778 31.875,26.2777778 C32.5659181,26.2777778 33.125,25.7311199 33.125,25.0555556 C33.125,24.3799912 32.5659181,23.8333333 31.875,23.8333333 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(0.000000, 5.333333)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/moving',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'moving',
                            tabindex: '-1',
                            transform: 'translate(504.000000, 479.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-529.000000, -479.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-moving',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Moving',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'C5F061E5-7116-4877-9710-837714C72815',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M33.903646,0.00257205183 C33.5494793,0.0207153357 33.1979167,0.132166083 32.8906253,0.336924295 L24.2942707,6.04163879 C23.5104167,6.56001358 22.6015627,6.89177346 21.6666667,7.00063183 L4.119792,9.05598841 C1.77083333,9.33072672 0,11.3161025 0,13.6695241 L0,19.8589192 C0,22.2149325 1.77083333,24.1977159 4.119792,24.4698625 L4.78906267,24.5502108 L8.403646,35.9414972 C8.66666667,36.7734886 9.434896,37.3333333 10.3125,37.3333333 L12.5,37.3333333 C13.0703127,37.3333333 13.6171873,37.0896975 13.994792,36.6672219 C14.375,36.2421545 14.5546873,35.674534 14.4869793,35.1120975 L13.809896,29.3710964 L15.0416667,29.3710964 C15.6406253,29.3710964 16.2057293,29.1041332 16.5859373,28.64278 C16.96875,28.1788344 17.119792,27.5775196 17,26.9891641 L16.7916667,25.9550068 L21.6666667,26.5278108 C22.6015627,26.6366692 23.5104167,26.9684291 24.2942707,27.4868039 L32.8906253,33.1941107 C33.2265627,33.4144199 33.6119793,33.5284623 34,33.5284623 C34.3229167,33.5284623 34.6484373,33.4481141 34.9453127,33.2900099 C35.596354,32.9426991 36,32.2714036 36,31.5379031 L36,20.5587249 L38.6328127,19.6878552 C39.4505207,19.4157086 40,18.6562897 40,17.7983792 L40,15.7300634 C40,14.8721536 39.4505207,14.1127341 38.6328127,13.8405875 L36,12.9697178 L36,1.99053957 C36,1.25703906 35.596354,0.583151826 34.9453127,0.238432751 C34.6171873,0.0621853195 34.2578127,-0.0155705685 33.903646,0.00257205183 Z M34.0442707,1.32701983 C34.1640627,1.33738732 34.2604167,1.37885731 34.3125,1.40736809 C34.4192707,1.46438898 34.6666667,1.63286129 34.6666667,1.99053957 L34.6666667,31.5379031 C34.6666667,31.895582 34.4218753,32.0640537 34.315104,32.1210746 C34.2109373,32.1780961 33.9296873,32.2869545 33.6302087,32.0873804 L25.033854,26.3852576 C24.0755207,25.7476569 22.963542,25.3407322 21.8229167,25.2085471 L14.6354167,24.3661876 L14.6380207,9.16225507 L21.8229167,8.31989619 C22.966146,8.18771045 24.0755207,7.7807864 25.033854,7.14318507 L30.6380207,3.42643809 L30.6380207,22.2097484 C30.6380207,22.5752032 30.934896,22.8732682 31.3046873,22.8732682 C31.6744793,22.8732682 31.971354,22.5752032 31.971354,22.2097484 L31.971354,2.80179596 C31.971354,2.718856 31.9895833,2.52964936 31.9895833,2.52964936 L33.6302087,1.44106228 C33.78125,1.33997903 33.9244793,1.31665233 34.0442707,1.32701983 Z M13.3046873,9.31776751 L13.3046873,24.2003076 C13.3046873,24.2054917 13.307292,24.2080834 13.307292,24.2106751 L4.276042,23.1531906 C2.59895867,22.9588005 1.33333333,21.5410453 1.33333333,19.8589192 L1.33333333,13.6695241 C1.33333333,11.9873974 2.59895867,10.5696428 4.276042,10.3752521 L13.3046873,9.31776751 Z M16.6380207,9.49401494 C16.2682293,9.49401494 15.971354,9.79208062 15.971354,10.1575347 C15.971354,10.5229888 16.2682293,10.8210544 16.6380207,10.8210544 L17.971354,10.8210544 C18.341146,10.8210544 18.6380207,10.5229888 18.6380207,10.1575347 C18.6380207,9.79208062 18.341146,9.49401494 17.971354,9.49401494 L16.6380207,9.49401494 Z M16.6380207,12.8116137 C16.2682293,12.8116137 15.971354,13.1096793 15.971354,13.4751334 C15.971354,13.8405875 16.2682293,14.1386531 16.6380207,14.1386531 L17.971354,14.1386531 C18.341146,14.1386531 18.6380207,13.8405875 18.6380207,13.4751334 C18.6380207,13.1096793 18.341146,12.8116137 17.971354,12.8116137 L16.6380207,12.8116137 Z M36,14.3693298 L38.2109373,15.1002386 C38.4843753,15.1909536 38.6666667,15.4449576 38.6666667,15.7300634 L38.6666667,17.7983792 C38.6666667,18.083485 38.4843753,18.337489 38.2109373,18.4282048 L36,19.1617046 L36,14.3693298 Z M16.6380207,16.1292124 C16.2682293,16.1292124 15.971354,16.427278 15.971354,16.7927321 C15.971354,17.1581862 16.2682293,17.4562518 16.6380207,17.4562518 L17.971354,17.4562518 C18.341146,17.4562518 18.6380207,17.1581862 18.6380207,16.7927321 C18.6380207,16.427278 18.341146,16.1292124 17.971354,16.1292124 L16.6380207,16.1292124 Z M16.6380207,19.4468111 C16.2682293,19.4468111 15.971354,19.7448768 15.971354,20.1103308 C15.971354,20.4757849 16.2682293,20.7738506 16.6380207,20.7738506 L17.971354,20.7738506 C18.341146,20.7738506 18.6380207,20.4757849 18.6380207,20.1103308 C18.6380207,19.7448768 18.341146,19.4468111 17.971354,19.4468111 L16.6380207,19.4468111 Z M16.6380207,22.7644098 C16.2682293,22.7644098 15.971354,23.0624755 15.971354,23.4279295 C15.971354,23.7933836 16.2682293,24.0914493 16.6380207,24.0914493 L17.971354,24.0914493 C18.341146,24.0914493 18.6380207,23.7933836 18.6380207,23.4279295 C18.6380207,23.0624755 18.341146,22.7644098 17.971354,22.7644098 L16.6380207,22.7644098 Z M31.3046873,24.0344277 C30.934896,24.0344277 30.6380207,24.3324934 30.6380207,24.6979475 L30.6380207,27.5179064 C30.6380207,27.8833611 30.934896,28.1814261 31.3046873,28.1814261 C31.6744793,28.1814261 31.971354,27.8833611 31.971354,27.5179064 L31.971354,24.6979475 C31.971354,24.3324934 31.6744793,24.0344277 31.3046873,24.0344277 Z M6.23958333,24.7186824 L12.0104167,25.3977538 C12.0104167,25.4210805 12.002604,25.4418155 12.0052087,25.4677345 L13.1640627,35.2650182 C13.184896,35.4542249 13.127604,35.6382481 13,35.783393 C12.869792,35.9259456 12.6927087,36.0062938 12.5,36.0062938 L10.3125,36.0062938 C10.0182293,36.0062938 9.76302067,35.8196789 9.67447933,35.5423482 L6.23958333,24.7186824 Z M13.3567707,25.5532662 L15.401042,25.7943103 L15.6953127,27.2509438 C15.7343753,27.4453339 15.682292,27.6475004 15.5546873,27.8030128 C15.4296873,27.9559336 15.2395833,28.0440569 15.0416667,28.0440569 L13.653646,28.0440569 L13.3567707,25.5532662 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(0.000000, 1.333333)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/announcemnet',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'announcement',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 479.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-415.000000, -479.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-announcement',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Announcement',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '9A6BB0FD-AD5B-4CBA-B832-D34C8F4C56D7',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M6.45152048,0 C6.04244593,0 5.63337058,0.155429933 5.32422199,0.466289799 L3.06337917,2.71691523 C2.43883695,3.33552656 2.43883695,4.34582093 3.06337917,4.96754066 L14.3675933,16.2206678 L3.06337917,27.473795 C2.43883695,28.0955147 2.43883695,29.1058091 3.06337917,29.7244204 L5.32422199,31.9750458 C5.94564169,32.5967656 6.96052259,32.5967656 7.58506481,31.9750458 L18.8892789,20.7219187 L30.193493,31.9750458 C30.5057641,32.2859057 30.9148395,32.4444444 31.3270373,32.4444444 C31.7361127,32.4444444 32.1451872,32.2859057 32.4543358,31.9750458 L34.7151786,29.7244204 C35.3397209,29.1058091 35.3397209,28.0955147 34.7151786,27.473795 L23.4109645,16.2206678 L34.7151786,4.96754066 C35.3397209,4.34582093 35.3397209,3.33552656 34.7151786,2.71691523 L32.4543358,0.466289799 C31.8329161,-0.155429933 30.8180352,-0.155429933 30.193493,0.466289799 L18.8892789,11.719417 L7.58506481,0.466289799 C7.2727937,0.155429933 6.86371835,0 6.45152048,0 Z M6.45152048,1.58849372 L18.8892789,13.9700424 L31.3270373,1.58849372 L33.5878801,3.83911915 L21.1501217,16.2206678 L33.5878801,28.6022165 L31.3270373,30.8528419 L18.8892789,18.4712933 L6.45152048,30.8528419 L4.19067767,28.6022165 L16.6284361,16.2206678 L4.19067767,3.83911915 L6.45152048,1.58849372 Z M35.848723,6.42236484 C35.6426236,6.42236484 35.4396476,6.50007961 35.2803891,6.65550994 C34.968118,6.9663698 34.968118,7.46996239 35.2803891,7.78082225 L36.4139335,8.90613537 C36.5669461,9.0615649 36.7730454,9.13928047 36.9760215,9.13928047 C37.1821208,9.13928047 37.3882193,9.0615649 37.541232,8.90613537 C37.8566264,8.5952755 37.8566264,8.09168212 37.541232,7.78082225 L36.4139335,6.65550994 C36.254675,6.50007961 36.051699,6.42236484 35.848723,6.42236484 Z M33.0195463,9.23564643 C32.8165703,9.23564643 32.6135943,9.31336199 32.4543358,9.46879153 C32.1420647,9.77965139 32.1420647,10.2832448 32.4543358,10.5941046 L33.5878801,11.719417 C33.7408928,11.8748473 33.9469921,11.9525621 34.1530906,11.9525621 C34.3560667,11.9525621 34.562166,11.8748473 34.7151786,11.719417 C35.0305723,11.4085571 35.0305723,10.9049645 34.7151786,10.5941046 L33.5878801,9.46879153 C33.4286217,9.31336199 33.2256457,9.23564643 33.0195463,9.23564643 Z M30.193493,12.0489288 C29.990517,12.0489288 29.7844176,12.1266436 29.631405,12.2820731 C29.3160114,12.592933 29.3160114,13.0965264 29.631405,13.4073862 L30.7587035,14.5326986 C30.9148395,14.6881289 31.120938,14.7658436 31.3270373,14.7658436 C31.5300133,14.7658436 31.7361127,14.6881289 31.8922478,14.5326986 C32.2045189,14.2218387 32.2045189,13.7182461 31.8922478,13.4073862 L30.7587035,12.2820731 C30.6025684,12.1266436 30.3995923,12.0489288 30.193493,12.0489288 Z M9.28069712,14.8622104 C9.0777211,14.8622104 8.87162177,14.9399252 8.71548661,15.0953555 C8.40321551,15.4062154 8.40321551,15.909808 8.71548661,16.2206678 L9.84590763,17.3459809 C10.0020436,17.5014105 10.2050196,17.5791252 10.4111181,17.5791252 C10.6172175,17.5791252 10.8201935,17.5014105 10.9763294,17.3459809 C11.2886005,17.0351211 11.2886005,16.5315277 10.9763294,16.2206678 L9.84590763,15.0953555 C9.68977247,14.9399252 9.48367314,14.8622104 9.28069712,14.8622104 Z M27.3674397,14.8622104 C27.1613403,14.8622104 26.9583643,14.9399252 26.8022292,15.0953555 C26.4899581,15.4062154 26.4899581,15.909808 26.8022292,16.2206678 L27.9326502,17.3459809 C28.0887861,17.5014105 28.2917622,17.5791252 28.4978607,17.5791252 C28.70396,17.5791252 28.906936,17.5014105 29.063072,17.3459809 C29.3753431,17.0351211 29.3753431,16.5315277 29.063072,16.2206678 L27.9326502,15.0953555 C27.776515,14.9399252 27.5735382,14.8622104 27.3674397,14.8622104 Z M6.45152048,17.675492 C6.24854446,17.675492 6.04556844,17.7532068 5.88630998,17.9086371 C5.57403887,18.219497 5.57403887,18.7230895 5.88630998,19.0339494 L7.0198543,20.1592625 C7.17598945,20.3146921 7.37896627,20.3924076 7.58506481,20.3924076 C7.78804083,20.3924076 7.99414016,20.3146921 8.1471528,20.1592625 C8.46254642,19.8484027 8.46254642,19.3448093 8.1471528,19.0339494 L7.0198543,17.9086371 C6.86059584,17.7532068 6.65761982,17.675492 6.45152048,17.675492 Z M3.62546716,20.4887736 C3.42249114,20.4887736 3.21951512,20.5664892 3.06337917,20.7219187 C2.74798555,21.0327786 2.74798555,21.5363719 3.06337917,21.8472318 L4.19067767,22.9725441 C4.34681362,23.1279745 4.55291215,23.2056892 4.75901148,23.2056892 C4.9619875,23.2056892 5.16808683,23.1279745 5.32422199,22.9725441 C5.63649309,22.6616843 5.63649309,22.1580917 5.32422199,21.8472318 L4.19067767,20.7219187 C4.03454251,20.5664892 3.83156649,20.4887736 3.62546716,20.4887736 Z M0.802536347,23.302056 C0.596437816,23.302056 0.393460996,23.3797707 0.234203331,23.5352003 C-0.0780677769,23.8460601 -0.0780677769,24.3496535 0.234203331,24.6605134 L1.36462434,25.7858257 C1.52076029,25.941256 1.72685883,26.0189708 1.92983485,26.0189708 C2.13593418,26.0189708 2.34203271,25.941256 2.49816866,25.7858257 C2.81043977,25.4749658 2.81043977,24.9713733 2.49816866,24.6605134 L1.36462434,23.5352003 C1.20848919,23.3797707 1.00551237,23.302056 0.802536347,23.302056 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(1.333333, 4.000000)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/none',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'none',
                            tabindex: '-1',
                            transform: 'translate(1302.000000, 363.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1327.000000, -363.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-none',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'None',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '040A101A-0454-4959-B770-23CDFC4EA0C0',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M25.1423526,0 C22.4760752,0 19.8074039,1.01477891 17.7777778,3.04672994 L3.04623416,17.7777778 C-1.01541139,21.8392866 -1.01541139,28.4473168 3.04623416,32.5088256 C5.07586029,34.5383834 7.7445316,35.5555556 10.4132029,35.5555556 C13.0794803,35.5555556 15.7481516,34.5383834 17.7777778,32.5088256 L32.5093214,17.7777778 C36.5709669,13.7162689 36.5709669,7.1082394 32.5093214,3.04672994 C30.477302,1.01477891 27.8086307,0 25.1423526,0 Z M25.1423526,1.22539341 C27.4950916,1.22539341 29.8502238,2.1205053 31.6405072,3.91312168 C35.2258612,7.49835442 35.2258612,13.3285465 31.6429005,16.9113867 L26.8751938,21.6765391 L13.8788853,8.6806679 L18.6441987,3.91312168 C20.4368754,2.1205053 22.7896143,1.22539341 25.1423526,1.22539341 Z M25.1303857,2.4603602 C24.2735391,2.4603602 23.4286589,2.5943876 22.6220741,2.86244241 C22.3013552,2.97014285 22.1266346,3.31717855 22.2343392,3.63788668 C22.33965,3.95859541 22.6866968,4.13091636 23.0074157,4.02560911 C24.6780281,3.47274592 26.5449012,3.60198632 28.1269563,4.38461078 C28.2131197,4.43008452 28.3064635,4.44923129 28.3974134,4.44923129 C28.6223959,4.44923129 28.8401979,4.32477727 28.947902,4.10937578 C29.098688,3.80781443 28.9742298,3.43923876 28.6702644,3.28845839 C27.5645008,2.73798839 26.3725745,2.4603602 25.1303857,2.4603602 Z M30.3743845,4.65266559 C30.216418,4.6502724 30.0584521,4.70771271 29.9363872,4.82737973 C29.6970445,5.06432119 29.6946512,5.45443682 29.9316006,5.69616466 C30.180517,5.94746589 30.410286,6.2203077 30.6137272,6.50750928 C30.7333982,6.67504323 30.9224791,6.76359751 31.1139533,6.76359751 C31.2360182,6.76359751 31.3604764,6.72769716 31.4681805,6.65111007 C31.745818,6.45485535 31.8080474,6.07191991 31.6117861,5.79429172 C31.3700501,5.45683001 31.099593,5.13372808 30.8052013,4.83455992 C30.6855297,4.7148929 30.5299571,4.65266559 30.3743845,4.65266559 Z M13.0100711,9.54466583 L26.0111668,22.545324 L25.1423526,23.4093219 C24.9030099,23.1699873 24.5152751,23.1699873 24.2783256,23.4093219 L23.4095115,24.2757137 C23.1701688,24.5150483 23.1701688,24.9027701 23.4095115,25.1421048 L16.9113575,31.6424339 C13.3283967,35.225274 7.49800846,35.225274 3.91265505,31.6424339 C0.32969492,28.0572011 0.32969492,22.2270091 3.91265505,18.6441695 L8.68036173,13.8790165 L16.9113575,22.1121284 C17.0310285,22.2294023 17.1866011,22.2892358 17.3445676,22.2892358 C17.5025335,22.2892358 17.6581067,22.2294023 17.7777778,22.1121284 C18.0171205,21.8704006 18.0171205,21.4850713 17.7777778,21.2433435 L9.54438874,13.0126247 L10.4132029,12.1462336 C10.5304807,12.2659006 10.6884472,12.3257348 10.8464131,12.3257348 C11.0019857,12.3257348 11.1599521,12.2659006 11.2772299,12.1462336 L12.1460441,11.2798419 C12.3853868,11.0405072 12.3853868,10.6527854 12.1460441,10.4134508 L13.0100711,9.54466583 Z M13.8788853,12.399928 C13.7233127,12.399928 13.5653462,12.4597622 13.4456751,12.5794292 L12.5792542,13.4458209 C12.3399115,13.6851556 12.3399115,14.0728774 12.5792542,14.3122121 C12.6989259,14.4318797 12.8544985,14.4917132 13.0124644,14.4917132 C13.1704309,14.4917132 13.3260035,14.4318797 13.4456751,14.3122121 L14.3120954,13.4458209 C14.5514381,13.2064863 14.5514381,12.8187638 14.3120954,12.5794292 C14.1924244,12.4597622 14.0344579,12.399928 13.8788853,12.399928 Z M16.0449366,14.5659071 C15.889364,14.5659071 15.7313975,14.6257406 15.6117265,14.7454076 L14.7453056,15.6117994 C14.5059629,15.851134 14.5059629,16.2388558 14.7453056,16.4781905 C14.8649772,16.5978581 15.0205498,16.6576916 15.1785163,16.6576916 C15.3364822,16.6576916 15.4920548,16.5978581 15.6117265,16.4781905 L16.4781467,15.6117994 C16.7174894,15.3724647 16.7174894,14.9847423 16.4781467,14.7454076 C16.3584757,14.6257406 16.2005092,14.5659071 16.0449366,14.5659071 Z M18.2109879,16.7318855 C18.0554153,16.7318855 17.8974494,16.791719 17.7777778,16.9113867 L16.9113575,17.7777778 C16.6720148,18.0171124 16.6720148,18.4048349 16.9113575,18.6441695 C17.0310285,18.7638365 17.1866011,18.82367 17.3445676,18.82367 C17.5025335,18.82367 17.6581067,18.7638365 17.7777778,18.6441695 L18.6441987,17.7777778 C18.8835414,17.5384431 18.8835414,17.1507213 18.6441987,16.9113867 C18.524527,16.791719 18.3665611,16.7318855 18.2109879,16.7318855 Z M20.3770399,18.8978639 C20.2214666,18.8978639 20.0635008,18.9576974 19.9438291,19.0773651 L19.0774088,19.9437562 C18.8380661,20.1830909 18.8380661,20.5708133 19.0774088,20.8101479 C19.1970799,20.929815 19.3526531,20.9896491 19.510619,20.9896491 C19.6685855,20.9896491 19.8241581,20.929815 19.9438291,20.8101479 L20.81025,19.9437562 C21.0495927,19.7044216 21.0495927,19.3166997 20.81025,19.0773651 C20.6905783,18.9576974 20.5326125,18.8978639 20.3770399,18.8978639 Z M22.5430912,21.0638424 C22.3875186,21.0638424 22.2295521,21.1236765 22.109881,21.2433435 L21.2434601,22.1097352 C21.0041174,22.3490699 21.0041174,22.7367917 21.2434601,22.9761264 C21.3631318,23.095794 21.5187044,23.1556275 21.6766703,23.1556275 C21.8346368,23.1556275 21.9902094,23.095794 22.109881,22.9761264 L22.9763013,22.1097352 C23.215644,21.8704006 23.215644,21.4826782 22.9763013,21.2433435 C22.8566303,21.1236765 22.6986638,21.0638424 22.5430912,21.0638424 Z M19.0774088,22.7966252 C18.9218362,22.7966252 18.7638697,22.8564594 18.6441987,22.9761264 C18.404856,23.215461 18.404856,23.6031835 18.6441987,23.8425181 L20.3770399,25.575301 C20.4967109,25.694968 20.6522835,25.7548015 20.81025,25.7548015 C20.9682159,25.7548015 21.1237891,25.694968 21.2434601,25.575301 C21.4828028,25.3359663 21.4828028,24.9482439 21.2434601,24.7089092 L19.510619,22.9761264 C19.3909479,22.8564594 19.2329814,22.7966252 19.0774088,22.7966252 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(2.222222, 2.222222)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/prescriptions',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'prescriptions',
                            tabindex: '-1',
                            transform: 'translate(1188.000000, 363.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1213.000000, -363.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-prescriptions',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Prescriptions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'E729AC15-5A9E-476B-A0D9-230FCC83B0F1',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M16,0 C14.7323077,0 13.4640868,0.395263358 12.3810098,1.18588658 L10.719952,2.39710746 L1.84615385,2.39710746 C0.830769231,2.39710746 0,3.23096789 0,4.25013064 L0,36.369199 C0,37.3883618 0.830769231,38.2222222 1.84615385,38.2222222 L30.1538462,38.2222222 C31.1692308,38.2222222 32,37.3883618 32,36.369199 L32,4.25013064 C32,3.23096789 31.1692308,2.39710746 30.1538462,2.39710746 L21.280048,2.39710746 L19.6189902,1.18588658 C18.5359132,0.395263358 17.2676923,0 16,0 Z M16,1.23776159 C17.0153846,1.23776159 18.0313465,1.55407846 18.8990388,2.18719465 L19.1875003,2.39710746 L20.8737982,3.63245624 L21.3906252,4.00885158 C21.8706252,4.35474924 22.1538462,4.91663991 22.1538462,5.50960733 L22.1538462,6.10315381 L22.1538462,6.72082821 C22.1538462,7.06054912 21.8769231,7.3385026 21.5384615,7.3385026 L10.4615385,7.3385026 C10.1230769,7.3385026 9.84615385,7.06054912 9.84615385,6.72082821 L9.84615385,6.10315381 L9.84615385,5.50960733 C9.84615385,4.91663991 10.1293748,4.35474924 10.6093748,4.00885158 L11.1262018,3.63245624 L12.8124997,2.39710746 L13.1009612,2.18719465 C13.9686542,1.55407846 14.9846154,1.23776159 16,1.23776159 Z M16,2.39710746 C15.3202649,2.39710746 14.7692308,2.95019195 14.7692308,3.63245624 C14.7692308,4.31472054 15.3202649,4.86780503 16,4.86780503 C16.6797351,4.86780503 17.2307692,4.31472054 17.2307692,3.63245624 C17.2307692,2.95019195 16.6797351,2.39710746 16,2.39710746 Z M1.84615385,3.63245624 L9.24879815,3.63245624 C8.84264431,4.16365622 8.61538462,4.82398875 8.61538462,5.50960733 L8.61538462,6.10315381 L4.92307692,6.10315381 C4.24615385,6.10315381 3.69230769,6.65906077 3.69230769,7.3385026 L3.69230769,33.2808271 C3.69230769,33.9602689 4.24615385,34.5161759 4.92307692,34.5161759 L27.0769231,34.5161759 C27.7538462,34.5161759 28.3076923,33.9602689 28.3076923,33.2808271 L28.3076923,7.3385026 C28.3076923,6.64670728 27.7661538,6.10315381 27.0769231,6.10315381 L23.3846154,6.10315381 L23.3846154,5.50960733 C23.3846154,4.82398875 23.1573557,4.16365622 22.7512018,3.63245624 L30.1538462,3.63245624 C30.4923077,3.63245624 30.7692308,3.91040972 30.7692308,4.25013064 L30.7692308,36.369199 C30.7692308,36.70892 30.4923077,36.9868734 30.1538462,36.9868734 L1.84615385,36.9868734 C1.50769231,36.9868734 1.23076923,36.70892 1.23076923,36.369199 L1.23076923,4.25013064 C1.23076923,3.91040972 1.50769231,3.63245624 1.84615385,3.63245624 Z M4.92307692,7.3385026 L8.72596185,7.3385026 C8.97826954,8.05500489 9.66153846,8.57385138 10.4615385,8.57385138 L21.5384615,8.57385138 C22.3384615,8.57385138 23.0217311,8.05500489 23.2740382,7.3385026 L27.0769231,7.3385026 L27.0769231,33.2808271 L4.92307692,33.2808271 L4.92307692,7.3385026 Z M6.76923077,9.80920017 C6.42892308,9.80920017 6.15384615,10.0853006 6.15384615,10.4268746 L6.15384615,11.6622233 C6.15384615,12.0037973 6.42892308,12.2798977 6.76923077,12.2798977 C7.10953846,12.2798977 7.38461538,12.0037973 7.38461538,11.6622233 L7.38461538,10.4268746 C7.38461538,10.0853006 7.10953846,9.80920017 6.76923077,9.80920017 Z M9.84615385,9.80920017 C9.50584615,9.80920017 9.23076923,10.0853006 9.23076923,10.4268746 L9.23076923,11.6622233 C9.23076923,12.0037973 9.50584615,12.2798977 9.84615385,12.2798977 C10.1864615,12.2798977 10.4615385,12.0037973 10.4615385,11.6622233 L10.4615385,10.4268746 C10.4615385,10.0853006 10.1864615,9.80920017 9.84615385,9.80920017 Z M12.9230769,9.80920017 C12.5827692,9.80920017 12.3076923,10.0853006 12.3076923,10.4268746 L12.3076923,11.6622233 C12.3076923,12.0037973 12.5827692,12.2798977 12.9230769,12.2798977 C13.2633846,12.2798977 13.5384615,12.0037973 13.5384615,11.6622233 L13.5384615,10.4268746 C13.5384615,10.0853006 13.2633846,9.80920017 12.9230769,9.80920017 Z M16,9.80920017 C15.6596923,9.80920017 15.3846154,10.0853006 15.3846154,10.4268746 L15.3846154,11.6622233 C15.3846154,12.0037973 15.6596923,12.2798977 16,12.2798977 C16.3403077,12.2798977 16.6153846,12.0037973 16.6153846,11.6622233 L16.6153846,10.4268746 C16.6153846,10.0853006 16.3403077,9.80920017 16,9.80920017 Z M19.0769231,9.80920017 C18.7366154,9.80920017 18.4615385,10.0853006 18.4615385,10.4268746 L18.4615385,11.6622233 C18.4615385,12.0037973 18.7366154,12.2798977 19.0769231,12.2798977 C19.4172308,12.2798977 19.6923077,12.0037973 19.6923077,11.6622233 L19.6923077,10.4268746 C19.6923077,10.0853006 19.4172308,9.80920017 19.0769231,9.80920017 Z M22.1538462,9.80920017 C21.8135385,9.80920017 21.5384615,10.0853006 21.5384615,10.4268746 L21.5384615,11.6622233 C21.5384615,12.0037973 21.8135385,12.2798977 22.1538462,12.2798977 C22.4941538,12.2798977 22.7692308,12.0037973 22.7692308,11.6622233 L22.7692308,10.4268746 C22.7692308,10.0853006 22.4941538,9.80920017 22.1538462,9.80920017 Z M25.2307692,9.80920017 C24.8904615,9.80920017 24.6153846,10.0853006 24.6153846,10.4268746 L24.6153846,11.6622233 C24.6153846,12.0037973 24.8904615,12.2798977 25.2307692,12.2798977 C25.5710769,12.2798977 25.8461538,12.0037973 25.8461538,11.6622233 L25.8461538,10.4268746 C25.8461538,10.0853006 25.5710769,9.80920017 25.2307692,9.80920017 Z M11.0769231,14.7505953 C10.3981538,14.7505953 9.84615385,15.3046492 9.84615385,15.9859441 L9.84615385,17.2212929 L8.61538462,17.2212929 C7.93661538,17.2212929 7.38461538,17.7753468 7.38461538,18.4566417 L7.38461538,20.9273392 C7.38461538,21.6086341 7.93661538,22.162688 8.61538462,22.162688 L9.84615385,22.162688 L9.84615385,23.3980368 C9.84615385,24.0793317 10.3981538,24.6333856 11.0769231,24.6333856 L13.5384615,24.6333856 C14.2172308,24.6333856 14.7692308,24.0793317 14.7692308,23.3980368 L14.7692308,22.162688 L16,22.162688 C16.6787692,22.162688 17.2307692,21.6086341 17.2307692,20.9273392 L17.2307692,18.4566417 C17.2307692,17.7753468 16.6787692,17.2212929 16,17.2212929 L14.7692308,17.2212929 L14.7692308,15.9859441 C14.7692308,15.3046492 14.2172308,14.7505953 13.5384615,14.7505953 L11.0769231,14.7505953 Z M11.0769231,15.9859441 L13.5384615,15.9859441 L13.5384615,17.8389673 C13.5384615,18.1805412 13.8135385,18.4566417 14.1538462,18.4566417 L16,18.4566417 L16,20.9273392 L14.1538462,20.9273392 C13.8135385,20.9273392 13.5384615,21.2034397 13.5384615,21.5450136 L13.5384615,23.3980368 L11.0769231,23.3980368 L11.0769231,21.5450136 C11.0769231,21.2034397 10.8018462,20.9273392 10.4615385,20.9273392 L8.61538462,20.9273392 L8.61538462,18.4566417 L10.4615385,18.4566417 C10.8018462,18.4566417 11.0769231,18.1805412 11.0769231,17.8389673 L11.0769231,15.9859441 Z M19.0769231,15.9859441 C18.7366154,15.9859441 18.4615385,16.2620445 18.4615385,16.6036185 C18.4615385,16.9451924 18.7366154,17.2212929 19.0769231,17.2212929 L24,17.2212929 C24.3403077,17.2212929 24.6153846,16.9451924 24.6153846,16.6036185 C24.6153846,16.2620445 24.3403077,15.9859441 24,15.9859441 L19.0769231,15.9859441 Z M19.6923077,19.6919904 C19.352,19.6919904 19.0769231,19.9680909 19.0769231,20.3096648 C19.0769231,20.6512388 19.352,20.9273392 19.6923077,20.9273392 L24,20.9273392 C24.3403077,20.9273392 24.6153846,20.6512388 24.6153846,20.3096648 C24.6153846,19.9680909 24.3403077,19.6919904 24,19.6919904 L19.6923077,19.6919904 Z M17.2307692,23.3980368 C16.8904615,23.3980368 16.6153846,23.6741373 16.6153846,24.0157112 C16.6153846,24.3572851 16.8904615,24.6333856 17.2307692,24.6333856 L24,24.6333856 C24.3403077,24.6333856 24.6153846,24.3572851 24.6153846,24.0157112 C24.6153846,23.6741373 24.3403077,23.3980368 24,23.3980368 L17.2307692,23.3980368 Z M9.23076923,27.1040832 C8.89046154,27.1040832 8.61538462,27.3801836 8.61538462,27.7217576 C8.61538462,28.0633315 8.89046154,28.3394319 9.23076923,28.3394319 L24,28.3394319 C24.3403077,28.3394319 24.6153846,28.0633315 24.6153846,27.7217576 C24.6153846,27.3801836 24.3403077,27.1040832 24,27.1040832 L9.23076923,27.1040832 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(4.000000, 0.444444)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/care-treatment',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'care-treatment',
                            tabindex: '-1',
                            transform: 'translate(1074.000000, 363.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1099.000000, -363.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-care',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Care / Treatment',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '94868ACF-9AC5-415D-8DCC-D425338EE3C3',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M14.8387097,0 C13.7726813,0 12.9032258,0.887345514 12.9032258,1.97530864 L12.9032258,5.26748971 L10.3225806,5.26748971 L10.3225806,3.9891977 C10.3225806,3.62397103 10.0352826,3.33076148 9.67741935,3.33076148 C9.31955677,3.33076148 9.03225806,3.62397103 9.03225806,3.9891977 L9.03225806,5.26748971 L7.74193548,5.26748971 L7.74193548,0.694444774 C7.74193548,0.331789959 7.45463742,0.0360085597 7.09677419,0.0360085597 C6.73891161,0.0360085597 6.4516129,0.331789959 6.4516129,0.694444774 L6.4516129,5.26748971 L6.15171355,5.26748971 C5.71824581,5.26748971 5.31754065,5.48611095 5.07812516,5.85390947 L2.85534258,9.25668741 C1.96572581,9.43415638 1.29032258,10.2340537 1.29032258,11.1934156 C1.29032258,12.049897 1.83215742,12.7752059 2.58064516,13.0478393 L2.58064516,34.2386831 L0.64516129,34.2386831 C0.28729871,34.2386831 0,34.5344652 0,34.8971193 C0,35.2597735 0.28729871,35.5555556 0.64516129,35.5555556 L39.3548387,35.5555556 C39.7127019,35.5555556 40,35.2597735 40,34.8971193 C40,34.5344652 39.7127019,34.2386831 39.3548387,34.2386831 L37.4193548,34.2386831 L37.4193548,13.0478393 C38.1678426,12.7752059 38.7096774,12.049897 38.7096774,11.1934156 C38.7096774,10.2340537 38.0342742,9.43415638 37.1446574,9.25668741 L34.9218748,5.85390947 C34.68246,5.48611095 34.2817542,5.26748971 33.8482865,5.26748971 L27.0967742,5.26748971 L27.0967742,1.97530864 C27.0967742,0.887345514 26.2273187,0 25.1612903,0 L14.8387097,0 Z M14.8387097,1.31687243 L25.1612903,1.31687243 C25.5166329,1.31687243 25.8064516,1.61265449 25.8064516,1.97530864 L25.8064516,12.5102881 C25.8064516,12.8729422 25.5166329,13.1687243 25.1612903,13.1687243 L14.8387097,13.1687243 C14.4833671,13.1687243 14.1935484,12.8729422 14.1935484,12.5102881 L14.1935484,1.97530864 C14.1935484,1.61265449 14.4833671,1.31687243 14.8387097,1.31687243 Z M19.3548387,2.63374486 C18.6441535,2.63374486 18.0645161,3.22530897 18.0645161,3.95061728 L18.0645161,5.26748971 L16.7741935,5.26748971 C16.0635084,5.26748971 15.483871,5.85905383 15.483871,6.58436214 L15.483871,7.90123457 C15.483871,8.62654354 16.0635084,9.218107 16.7741935,9.218107 L18.0645161,9.218107 L18.0645161,10.5349794 C18.0645161,11.2602884 18.6441535,11.8518519 19.3548387,11.8518519 L20.6451613,11.8518519 C21.3558471,11.8518519 21.9354839,11.2602884 21.9354839,10.5349794 L21.9354839,9.218107 L23.2258065,9.218107 C23.9364923,9.218107 24.516129,8.62654354 24.516129,7.90123457 L24.516129,6.58436214 C24.516129,5.85905383 23.9364923,5.26748971 23.2258065,5.26748971 L21.9354839,5.26748971 L21.9354839,3.95061728 C21.9354839,3.22530897 21.3558471,2.63374486 20.6451613,2.63374486 L19.3548387,2.63374486 Z M19.3548387,3.95061728 L20.6451613,3.95061728 L20.6451613,5.26748971 C20.6451613,5.99279868 21.2247987,6.58436214 21.9354839,6.58436214 L23.2258065,6.58436214 L23.2258065,7.90123457 L21.9354839,7.90123457 C21.2247987,7.90123457 20.6451613,8.49279868 20.6451613,9.218107 L20.6451613,10.5349794 L19.3548387,10.5349794 L19.3548387,9.218107 C19.3548387,8.49279868 18.7752019,7.90123457 18.0645161,7.90123457 L16.7741935,7.90123457 L16.7741935,6.58436214 L18.0645161,6.58436214 C18.7752019,6.58436214 19.3548387,5.99279868 19.3548387,5.26748971 L19.3548387,3.95061728 Z M6.15171355,6.58436214 L6.4516129,6.58436214 L6.4516129,7.28137877 C6.4516129,7.64403292 6.73891161,7.93981498 7.09677419,7.93981498 C7.45463742,7.93981498 7.74193548,7.64403292 7.74193548,7.28137877 L7.74193548,6.58436214 L9.03225806,6.58436214 L9.03225806,7.28137877 C9.03225806,7.64403292 9.31955677,7.93981498 9.67741935,7.93981498 C10.0352826,7.93981498 10.3225806,7.64403292 10.3225806,7.28137877 L10.3225806,6.58436214 L12.9032258,6.58436214 L12.9032258,9.218107 L4.43044387,9.218107 L6.15171355,6.58436214 Z M27.0967742,6.58436214 L33.8482865,6.58436214 L35.5695568,9.218107 L27.0967742,9.218107 L27.0967742,6.58436214 Z M3.22580645,10.5349794 L12.9032258,10.5349794 L12.9032258,11.8518519 L3.22580645,11.8518519 C2.87046387,11.8518519 2.58064516,11.5560698 2.58064516,11.1934156 C2.58064516,10.8307615 2.87046387,10.5349794 3.22580645,10.5349794 Z M27.0967742,10.5349794 L36.7741935,10.5349794 C37.1295361,10.5349794 37.4193548,10.8307615 37.4193548,11.1934156 C37.4193548,11.5560698 37.1295361,11.8518519 36.7741935,11.8518519 L27.0967742,11.8518519 L27.0967742,10.5349794 Z M3.87096774,13.1687243 L13.0216735,13.1687243 C13.2888103,13.932613 13.9994961,14.4855967 14.8387097,14.4855967 L25.1612903,14.4855967 C26.0005039,14.4855967 26.7111897,13.932613 26.9783265,13.1687243 L36.1290323,13.1687243 L36.1290323,34.2386831 L24.516129,34.2386831 L24.516129,27.6208849 C24.516129,26.895576 23.9364923,26.3040125 23.2258065,26.3040125 L16.7741935,26.3040125 C16.0635084,26.3040125 15.483871,26.895576 15.483871,27.6208849 L15.483871,34.2386831 L3.87096774,34.2386831 L3.87096774,25.0205761 L29.6774194,25.0205761 C30.0352826,25.0205761 30.3225806,24.7247941 30.3225806,24.3621399 C30.3225806,23.9994858 30.0352826,23.7037037 29.6774194,23.7037037 L3.87096774,23.7037037 L3.87096774,13.1687243 Z M7.09677419,17.1193416 C6.73891161,17.1193416 6.4516129,17.4151236 6.4516129,17.7777778 C6.4516129,18.1404319 6.73891161,18.436214 7.09677419,18.436214 L8.38709677,18.436214 C8.74496,18.436214 9.03225806,18.1404319 9.03225806,17.7777778 C9.03225806,17.4151236 8.74496,17.1193416 8.38709677,17.1193416 L7.09677419,17.1193416 Z M10.9677419,17.1193416 C10.6098794,17.1193416 10.3225806,17.4151236 10.3225806,17.7777778 C10.3225806,18.1404319 10.6098794,18.436214 10.9677419,18.436214 L12.2580645,18.436214 C12.6159277,18.436214 12.9032258,18.1404319 12.9032258,17.7777778 C12.9032258,17.4151236 12.6159277,17.1193416 12.2580645,17.1193416 L10.9677419,17.1193416 Z M17.4193548,17.1193416 C17.0614923,17.1193416 16.7741935,17.4151236 16.7741935,17.7777778 C16.7741935,18.1404319 17.0614923,18.436214 17.4193548,18.436214 L18.7096774,18.436214 C19.0675406,18.436214 19.3548387,18.1404319 19.3548387,17.7777778 C19.3548387,17.4151236 19.0675406,17.1193416 18.7096774,17.1193416 L17.4193548,17.1193416 Z M21.2903226,17.1193416 C20.93246,17.1193416 20.6451613,17.4151236 20.6451613,17.7777778 C20.6451613,18.1404319 20.93246,18.436214 21.2903226,18.436214 L22.5806452,18.436214 C22.9385084,18.436214 23.2258065,18.1404319 23.2258065,17.7777778 C23.2258065,17.4151236 22.9385084,17.1193416 22.5806452,17.1193416 L21.2903226,17.1193416 Z M27.7419355,17.1193416 C27.3840729,17.1193416 27.0967742,17.4151236 27.0967742,17.7777778 C27.0967742,18.1404319 27.3840729,18.436214 27.7419355,18.436214 L29.0322581,18.436214 C29.3901213,18.436214 29.6774194,18.1404319 29.6774194,17.7777778 C29.6774194,17.4151236 29.3901213,17.1193416 29.0322581,17.1193416 L27.7419355,17.1193416 Z M31.6129032,17.1193416 C31.2550406,17.1193416 30.9677419,17.4151236 30.9677419,17.7777778 C30.9677419,18.1404319 31.2550406,18.436214 31.6129032,18.436214 L32.9032258,18.436214 C33.261089,18.436214 33.5483871,18.1404319 33.5483871,17.7777778 C33.5483871,17.4151236 33.261089,17.1193416 32.9032258,17.1193416 L31.6129032,17.1193416 Z M7.09677419,19.7530864 C6.73891161,19.7530864 6.4516129,20.0488685 6.4516129,20.4115226 C6.4516129,20.7741768 6.73891161,21.0699588 7.09677419,21.0699588 L8.38709677,21.0699588 C8.74496,21.0699588 9.03225806,20.7741768 9.03225806,20.4115226 C9.03225806,20.0488685 8.74496,19.7530864 8.38709677,19.7530864 L7.09677419,19.7530864 Z M10.9677419,19.7530864 C10.6098794,19.7530864 10.3225806,20.0488685 10.3225806,20.4115226 C10.3225806,20.7741768 10.6098794,21.0699588 10.9677419,21.0699588 L12.2580645,21.0699588 C12.6159277,21.0699588 12.9032258,20.7741768 12.9032258,20.4115226 C12.9032258,20.0488685 12.6159277,19.7530864 12.2580645,19.7530864 L10.9677419,19.7530864 Z M17.4193548,19.7530864 C17.0614923,19.7530864 16.7741935,20.0488685 16.7741935,20.4115226 C16.7741935,20.7741768 17.0614923,21.0699588 17.4193548,21.0699588 L18.7096774,21.0699588 C19.0675406,21.0699588 19.3548387,20.7741768 19.3548387,20.4115226 C19.3548387,20.0488685 19.0675406,19.7530864 18.7096774,19.7530864 L17.4193548,19.7530864 Z M21.2903226,19.7530864 C20.93246,19.7530864 20.6451613,20.0488685 20.6451613,20.4115226 C20.6451613,20.7741768 20.93246,21.0699588 21.2903226,21.0699588 L22.5806452,21.0699588 C22.9385084,21.0699588 23.2258065,20.7741768 23.2258065,20.4115226 C23.2258065,20.0488685 22.9385084,19.7530864 22.5806452,19.7530864 L21.2903226,19.7530864 Z M27.7419355,19.7530864 C27.3840729,19.7530864 27.0967742,20.0488685 27.0967742,20.4115226 C27.0967742,20.7741768 27.3840729,21.0699588 27.7419355,21.0699588 L29.0322581,21.0699588 C29.3901213,21.0699588 29.6774194,20.7741768 29.6774194,20.4115226 C29.6774194,20.0488685 29.3901213,19.7530864 29.0322581,19.7530864 L27.7419355,19.7530864 Z M31.6129032,19.7530864 C31.2550406,19.7530864 30.9677419,20.0488685 30.9677419,20.4115226 C30.9677419,20.7741768 31.2550406,21.0699588 31.6129032,21.0699588 L32.9032258,21.0699588 C33.261089,21.0699588 33.5483871,20.7741768 33.5483871,20.4115226 C33.5483871,20.0488685 33.261089,19.7530864 32.9032258,19.7530864 L31.6129032,19.7530864 Z M31.6129032,23.7037037 C31.2550406,23.7037037 30.9677419,23.9994858 30.9677419,24.3621399 C30.9677419,24.7247941 31.2550406,25.0205761 31.6129032,25.0205761 L34.1935484,25.0205761 C34.5514116,25.0205761 34.8387097,24.7247941 34.8387097,24.3621399 C34.8387097,23.9994858 34.5514116,23.7037037 34.1935484,23.7037037 L31.6129032,23.7037037 Z M16.7741935,27.6208849 L19.3548387,27.6208849 L19.3548387,34.2052471 L16.7741935,34.2052471 L16.7741935,27.6208849 Z M20.6451613,27.6208849 L23.2258065,27.6208849 L23.2258065,34.2052471 L20.6451613,34.2052471 L20.6451613,27.6208849 Z M7.09677419,27.654321 C6.73891161,27.654321 6.4516129,27.950103 6.4516129,28.3127572 C6.4516129,28.6754114 6.73891161,28.9711934 7.09677419,28.9711934 L8.38709677,28.9711934 C8.74496,28.9711934 9.03225806,28.6754114 9.03225806,28.3127572 C9.03225806,27.950103 8.74496,27.654321 8.38709677,27.654321 L7.09677419,27.654321 Z M10.9677419,27.654321 C10.6098794,27.654321 10.3225806,27.950103 10.3225806,28.3127572 C10.3225806,28.6754114 10.6098794,28.9711934 10.9677419,28.9711934 L12.2580645,28.9711934 C12.6159277,28.9711934 12.9032258,28.6754114 12.9032258,28.3127572 C12.9032258,27.950103 12.6159277,27.654321 12.2580645,27.654321 L10.9677419,27.654321 Z M27.7419355,27.654321 C27.3840729,27.654321 27.0967742,27.950103 27.0967742,28.3127572 C27.0967742,28.6754114 27.3840729,28.9711934 27.7419355,28.9711934 L29.0322581,28.9711934 C29.3901213,28.9711934 29.6774194,28.6754114 29.6774194,28.3127572 C29.6774194,27.950103 29.3901213,27.654321 29.0322581,27.654321 L27.7419355,27.654321 Z M31.6129032,27.654321 C31.2550406,27.654321 30.9677419,27.950103 30.9677419,28.3127572 C30.9677419,28.6754114 31.2550406,28.9711934 31.6129032,28.9711934 L32.9032258,28.9711934 C33.261089,28.9711934 33.5483871,28.6754114 33.5483871,28.3127572 C33.5483871,27.950103 33.261089,27.654321 32.9032258,27.654321 L31.6129032,27.654321 Z M7.09677419,30.2880658 C6.73891161,30.2880658 6.4516129,30.5838479 6.4516129,30.9465021 C6.4516129,31.3091562 6.73891161,31.6049383 7.09677419,31.6049383 L8.38709677,31.6049383 C8.74496,31.6049383 9.03225806,31.3091562 9.03225806,30.9465021 C9.03225806,30.5838479 8.74496,30.2880658 8.38709677,30.2880658 L7.09677419,30.2880658 Z M10.9677419,30.2880658 C10.6098794,30.2880658 10.3225806,30.5838479 10.3225806,30.9465021 C10.3225806,31.3091562 10.6098794,31.6049383 10.9677419,31.6049383 L12.2580645,31.6049383 C12.6159277,31.6049383 12.9032258,31.3091562 12.9032258,30.9465021 C12.9032258,30.5838479 12.6159277,30.2880658 12.2580645,30.2880658 L10.9677419,30.2880658 Z M27.7419355,30.2880658 C27.3840729,30.2880658 27.0967742,30.5838479 27.0967742,30.9465021 C27.0967742,31.3091562 27.3840729,31.6049383 27.7419355,31.6049383 L29.0322581,31.6049383 C29.3901213,31.6049383 29.6774194,31.3091562 29.6774194,30.9465021 C29.6774194,30.5838479 29.3901213,30.2880658 29.0322581,30.2880658 L27.7419355,30.2880658 Z M31.6129032,30.2880658 C31.2550406,30.2880658 30.9677419,30.5838479 30.9677419,30.9465021 C30.9677419,31.3091562 31.2550406,31.6049383 31.6129032,31.6049383 L32.9032258,31.6049383 C33.261089,31.6049383 33.5483871,31.3091562 33.5483871,30.9465021 C33.5483871,30.5838479 33.261089,30.2880658 32.9032258,30.2880658 L31.6129032,30.2880658 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(0.000000, 2.222222)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/site-hospital',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'site-hospital',
                            tabindex: '-1',
                            transform: 'translate(960.000000, 363.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-985.000000, -363.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-hospital',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Hospital',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '1027488B-6CEE-4894-9B8D-0603D4BC1DFD',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M19.3548387,0 C19.1145161,0 18.8744458,0.0450491777 18.6454135,0.136473976 L0.986643161,7.17699976 C0.322127032,7.44474381 0,8.20200824 0.264616903,8.87463354 C0.45816529,9.37093959 0.935181484,9.69730392 1.46421368,9.69730392 L2.58064516,9.69730392 L2.58064516,11.0033725 C2.58064516,11.7217102 3.16129032,12.309441 3.87096774,12.309441 L5.16129032,12.309441 L5.16129032,25.3701265 L3.87096774,25.3701265 C3.16129032,25.3701265 2.58064516,25.9578574 2.58064516,26.6761951 L2.58064516,27.9822636 L1.29032258,27.9822636 C0.580645161,27.9822636 0,28.5699945 0,29.2883322 L0,32.5535036 C0,32.9126724 0.290322581,33.2065378 0.64516129,33.2065378 L18.7096774,33.2065378 L18.7096774,35.818675 C18.7096774,36.8987936 19.5780645,37.7777778 20.6451613,37.7777778 L38.0645161,37.7777778 C39.1316129,37.7777778 40,36.8987936 40,35.818675 L40,24.064058 C40,22.9839393 39.1316129,22.1049552 38.0645161,22.1049552 L33.5483871,22.1049552 L33.5483871,12.309441 L34.8387097,12.309441 C35.5483871,12.309441 36.1290323,11.7217102 36.1290323,11.0033725 L36.1290323,9.69730392 L37.2454639,9.69730392 C37.9551413,9.69730392 38.5359374,9.10972588 38.5294858,8.38485784 C38.5294858,7.85590007 38.2070561,7.37291004 37.7167342,7.17699976 L20.0642639,0.136473976 C19.8352316,0.0450491777 19.5951613,0 19.3548387,0 Z M19.3510587,1.30606855 C19.4308974,1.30606855 19.5108871,1.32194545 19.5866935,1.35198502 L37.2454639,8.39123537 L35.483871,8.39123537 C35.1277419,8.39123537 34.8387097,8.68379472 34.8387097,9.04426964 L34.8387097,11.0033725 L3.87096774,11.0033725 L3.87096774,9.69730392 L27.7419355,9.69730392 C28.0980645,9.69730392 28.3870968,9.40474456 28.3870968,9.04426964 C28.3870968,8.68379472 28.0980645,8.39123537 27.7419355,8.39123537 L1.46421368,8.39123537 L19.1166832,1.35198502 C19.1924897,1.32194545 19.27122,1.30606855 19.3510587,1.30606855 Z M19.3548387,3.16696116 C18.2858065,3.16696116 17.4193548,4.04398619 17.4193548,5.12606399 C17.4193548,6.20814178 18.2858065,7.08516682 19.3548387,7.08516682 C20.423871,7.08516682 21.2903226,6.20814178 21.2903226,5.12606399 C21.2903226,4.04398619 20.423871,3.16696116 19.3548387,3.16696116 Z M19.3548387,4.30977114 C19.8,4.30977114 20.1612903,4.67547034 20.1612903,5.12606399 C20.1612903,5.57665764 19.8,5.94235683 19.3548387,5.94235683 C18.9096774,5.94235683 18.5483871,5.57665764 18.5483871,5.12606399 C18.5483871,4.67547034 18.9096774,4.30977114 19.3548387,4.30977114 Z M30.3225806,8.39123537 C29.9664516,8.39123537 29.6774194,8.68379472 29.6774194,9.04426964 C29.6774194,9.40474456 29.9664516,9.69730392 30.3225806,9.69730392 L32.9032258,9.69730392 C33.2593548,9.69730392 33.5483871,9.40474456 33.5483871,9.04426964 C33.5483871,8.68379472 33.2593548,8.39123537 32.9032258,8.39123537 L30.3225806,8.39123537 Z M6.4516129,12.309441 L9.03225806,12.309441 L9.03225806,25.3701265 L6.4516129,25.3701265 L6.4516129,12.309441 Z M10.3225806,12.309441 L12.9032258,12.309441 L12.9032258,25.3701265 L10.3225806,25.3701265 L10.3225806,12.309441 Z M14.1935484,12.309441 L16.7741935,12.309441 L16.7741935,25.3701265 L14.1935484,25.3701265 L14.1935484,12.309441 Z M18.0645161,12.309441 L20.6451613,12.309441 L20.6451613,22.1049552 C19.5780645,22.1049552 18.7096774,22.9839393 18.7096774,24.064058 L18.7096774,25.3701265 L18.0645161,25.3701265 L18.0645161,12.309441 Z M21.9354839,12.309441 L24.516129,12.309441 L24.516129,22.1049552 L21.9354839,22.1049552 L21.9354839,12.309441 Z M25.8064516,12.309441 L28.3870968,12.309441 L28.3870968,22.1049552 L25.8064516,22.1049552 L25.8064516,12.309441 Z M29.6774194,12.309441 L32.2580645,12.309441 L32.2580645,22.1049552 L29.6774194,22.1049552 L29.6774194,12.309441 Z M20.6451613,23.4110237 L38.0645161,23.4110237 C38.4206452,23.4110237 38.7096774,23.7042361 38.7096774,24.064058 L38.7096774,25.3701265 L20,25.3701265 L20,24.064058 C20,23.7042361 20.2890323,23.4110237 20.6451613,23.4110237 Z M3.87096774,26.6761951 L18.7096774,26.6761951 L18.7096774,31.9004693 L1.29032258,31.9004693 L1.29032258,29.2883322 L3.22580645,29.2883322 C3.58064516,29.2883322 3.87096774,28.9944668 3.87096774,28.6352979 L3.87096774,26.6761951 Z M20,26.6761951 L38.7096774,26.6761951 L38.7096774,27.9822636 L20,27.9822636 L20,26.6761951 Z M6.4516129,27.9822636 C6.09548387,27.9822636 5.80645161,28.274823 5.80645161,28.6352979 L5.80645161,29.9413665 C5.80645161,30.3018414 6.09548387,30.5944007 6.4516129,30.5944007 C6.80774194,30.5944007 7.09677419,30.3018414 7.09677419,29.9413665 L7.09677419,28.6352979 C7.09677419,28.274823 6.80774194,27.9822636 6.4516129,27.9822636 Z M9.67741935,27.9822636 C9.32129032,27.9822636 9.03225806,28.274823 9.03225806,28.6352979 L9.03225806,29.9413665 C9.03225806,30.3018414 9.32129032,30.5944007 9.67741935,30.5944007 C10.0335484,30.5944007 10.3225806,30.3018414 10.3225806,29.9413665 L10.3225806,28.6352979 C10.3225806,28.274823 10.0335484,27.9822636 9.67741935,27.9822636 Z M12.9032258,27.9822636 C12.5470968,27.9822636 12.2580645,28.274823 12.2580645,28.6352979 L12.2580645,29.9413665 C12.2580645,30.3018414 12.5470968,30.5944007 12.9032258,30.5944007 C13.2593548,30.5944007 13.5483871,30.3018414 13.5483871,29.9413665 L13.5483871,28.6352979 C13.5483871,28.274823 13.2593548,27.9822636 12.9032258,27.9822636 Z M16.1290323,27.9822636 C15.7729032,27.9822636 15.483871,28.274823 15.483871,28.6352979 L15.483871,29.9413665 C15.483871,30.3018414 15.7729032,30.5944007 16.1290323,30.5944007 C16.4851613,30.5944007 16.7741935,30.3018414 16.7741935,29.9413665 L16.7741935,28.6352979 C16.7741935,28.274823 16.4851613,27.9822636 16.1290323,27.9822636 Z M20,29.2883322 L38.7096774,29.2883322 L38.7096774,35.818675 C38.7096774,36.1784968 38.4206452,36.4717092 38.0645161,36.4717092 L20.6451613,36.4717092 C20.2890323,36.4717092 20,36.1784968 20,35.818675 L20,33.2065378 L23.8709677,33.2065378 C24.2277419,33.2065378 24.516129,32.9139785 24.516129,32.5535036 C24.516129,32.1930287 24.2277419,31.9004693 23.8709677,31.9004693 L20,31.9004693 L20,29.2883322 Z M33.5005039,30.5956761 C33.3800606,30.599482 33.2593445,30.6149818 33.1388606,30.6415929 C32.4007961,30.8048515 31.8084374,31.4173872 31.6645665,32.1657645 C31.5523084,32.7502301 31.70002,33.3451444 32.0690523,33.7983502 C32.6522781,34.5153818 33.7040019,34.7161284 34.5375503,34.249862 C34.8285181,34.42161 35.1609574,34.5126064 35.4977316,34.5126064 C36.0777316,34.5126064 36.6231555,34.2528313 36.9921877,33.7996255 C37.36122,33.3457667 37.5089316,32.7508832 37.3966735,32.1657645 C37.2528026,31.4167342 36.6597987,30.8041985 35.9223794,30.6415929 C35.4404439,30.5351483 34.9480542,30.6128183 34.5299897,30.8609713 C34.2169252,30.6748565 33.8618348,30.5842585 33.5005039,30.5956761 Z M33.5660284,31.8991939 C33.7090123,31.9001735 33.8208768,31.9506818 33.894909,31.9986798 C34.2807155,32.2455267 34.7792942,32.2455267 35.1638103,31.9986798 C35.2631652,31.9346824 35.4277116,31.8674199 35.6464213,31.9170505 C35.8799697,31.9686402 36.0832258,32.17808 36.1290323,32.4144785 C36.1825806,32.6894059 36.0696271,32.8792149 35.9967239,32.9680275 C35.8025303,33.205732 35.4497477,33.2758516 35.1852316,33.1210824 C34.9807155,33.0002711 34.755151,32.9399673 34.5299897,32.9399673 C34.3048284,32.9399673 34.079909,33.0009241 33.8747477,33.1210824 C33.6102316,33.2758516 33.2580948,33.206385 33.0632561,32.9680275 C32.9909981,32.8792149 32.8774297,32.6880998 32.9296877,32.4144785 C32.9754942,32.177427 33.1781045,31.9686402 33.4122981,31.9170505 C33.4666529,31.9046428 33.5183671,31.8988674 33.5660284,31.8991939 Z M26.4516129,31.9004693 C26.0948387,31.9004693 25.8064516,32.1930287 25.8064516,32.5535036 C25.8064516,32.9139785 26.0948387,33.2065378 26.4516129,33.2065378 L29.6774194,33.2065378 C30.0341935,33.2065378 30.3225806,32.9139785 30.3225806,32.5535036 C30.3225806,32.1930287 30.0341935,31.9004693 29.6774194,31.9004693 L26.4516129,31.9004693 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(0.000000, 0.888889)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/billing-payment',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'add-new',
                            tabindex: '-1',
                            transform: 'translate(846.000000, 363.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-871.000000, -363.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-payment',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Payment / Billing',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '3258E686-BEF3-4D82-82B3-9AAE9168111A',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M29.2756567,0 C24.0087911,0 19.7234179,4.27078136 19.7234179,9.51971326 C19.7234179,14.7686452 24.0087911,19.0394265 29.2756567,19.0394265 C34.5425224,19.0394265 38.8278956,14.7686452 38.8278956,9.51971326 C38.8278956,4.27078136 34.5425224,0 29.2756567,0 Z M29.2756567,1.18996416 C33.884612,1.18996416 37.6338657,4.92645161 37.6338657,9.51971326 C37.6338657,14.1129749 33.884612,17.8494624 29.2756567,17.8494624 C24.6667015,17.8494624 20.9174478,14.1129749 20.9174478,9.51971326 C20.9174478,4.92645161 24.6667015,1.18996416 29.2756567,1.18996416 Z M28.9118508,4.65294549 L28.9118508,5.43037347 C27.319015,5.5654344 26.3582126,6.43754783 26.3582126,7.76614281 C26.3582126,8.8918489 27.0651624,9.65803708 28.36964,9.97873242 L28.9118508,10.1077227 L28.9118508,12.5062443 C28.1267761,12.4217568 27.612317,11.9713649 27.5615708,11.3406839 L26.1833057,11.3406839 C26.1886794,12.6686839 27.2276997,13.5578751 28.9106848,13.659022 L28.9106848,14.386481 L29.6907684,14.386481 L29.6907684,13.654374 C31.3910669,13.5139583 32.3680082,12.6412219 32.3680082,11.2453939 C32.3686042,10.0572147 31.6850967,9.33110394 30.2504699,8.99910394 L29.6907684,8.88057221 L29.6907684,6.60174444 C30.3683803,6.69158673 30.8424293,7.15293048 30.8591457,7.73244303 L32.2094251,7.73244303 C32.181366,6.46572618 31.1988287,5.56483942 29.6907684,5.43037347 L29.6907684,4.65294549 L28.9118508,4.65294549 Z M28.9118508,6.59477184 L28.9118508,8.71672009 C28.1548358,8.55904984 27.7539684,8.1878554 27.7539684,7.64761167 C27.7539684,7.07285898 28.240209,6.63463564 28.9118508,6.59477184 Z M29.6907684,10.2541443 C30.5833057,10.428474 30.9897427,10.787936 30.9897427,11.3906529 C30.9897427,12.0552478 30.515843,12.4661294 29.6907684,12.5167028 L29.6907684,10.2541443 Z M9.57416421,18.4444444 C8.98782928,18.4444444 8.42883286,18.5565034 7.91371645,18.7477461 C7.89590749,18.7503414 7.9187654,18.7390962 7.85074988,18.7616907 L7.86590869,18.7558807 C6.57604122,19.1473128 0.459192208,20.8464519 0.459192208,20.8464519 C0.246379547,20.8967961 0.0782221421,21.0590778 0.0208912,21.269438 C-0.0364397421,21.4797981 0.0262333726,21.704562 0.184248201,21.8552833 C0.342263029,22.0060047 0.570324401,22.0585559 0.778688447,21.9922577 C0.778688447,21.9922577 6.75639824,20.3343521 8.17257854,19.9063339 C8.21482845,19.8999275 8.2562661,19.8890191 8.29617913,19.8737961 C8.69661675,19.7207423 9.12431107,19.6344086 9.57416421,19.6344086 C10.2298233,19.6344086 10.8392167,19.8116871 11.3687069,20.1189935 C11.3894368,20.1307187 11.4108527,20.1411963 11.4328394,20.1503699 C11.4374364,20.1525113 11.4422054,20.1551881 11.4468323,20.1573419 C15.2091206,21.9274993 22.8499111,25.7400927 22.8705726,25.7504061 L22.8729051,25.7527301 C22.837735,25.7340179 22.8411791,25.7362616 22.9137164,25.7829439 C22.9269894,25.7916158 22.940604,25.7997569 22.9545278,25.8073477 C23.5190526,26.1106701 23.9025224,26.6872595 23.9025224,27.3691756 C23.9025224,27.7259441 23.796889,28.0525173 23.6156753,28.3325355 C23.0903869,29.1472558 22.0750102,29.3193853 21.1250036,28.8636034 C21.1138915,28.8582202 21.1026145,28.8531821 21.0911887,28.8484962 L20.6842388,28.6834815 C20.4851779,28.5951628 20.2536479,28.6219266 20.0801575,28.7533107 C19.9066671,28.8846947 19.8187693,29.0998331 19.8508248,29.3146248 C19.8828802,29.5294166 20.0297981,29.7097494 20.2341457,29.7851283 L20.641095,29.950143 L20.60728,29.9350358 C21.808517,30.5113504 23.2744203,30.381987 24.2138561,29.4713681 L24.8633433,29.9141187 C25.0299104,30.027427 25.2426157,30.0492806 25.4288753,29.9722222 L35.2248173,25.936338 L34.9764496,25.4424565 C35.1176145,25.7233468 35.4535638,25.8464819 35.7437069,25.7236783 C35.9573111,25.6337158 36.1910394,25.5842294 36.4398358,25.5842294 C37.4359457,25.5842294 38.2308806,26.3764575 38.2308806,27.3691756 C38.2308806,28.046762 37.851895,28.6216409 37.2922144,28.9275176 C37.0198167,29.0761858 36.9072654,29.4081429 37.0333529,29.6910004 L36.8094723,29.1889842 L25.0394161,35.4153789 C25.0592669,35.4056866 25.0418663,35.4140687 25.014929,35.4223509 C24.9869559,35.4311834 24.9596742,35.442059 24.9333057,35.4548893 C24.6114114,35.6094192 24.2675409,35.6989247 23.9025224,35.6989247 C23.5508914,35.6989247 23.2202227,35.6182398 22.9113845,35.4769685 C22.8976191,35.4706289 22.8836163,35.4648143 22.8694066,35.4595373 C22.824572,35.4429896 22.8169899,35.4397006 22.8484179,35.4537273 L8.01516242,29.2006048 C7.88149192,29.1443937 7.73185758,29.1386104 7.59422033,29.1843356 L0.430041104,31.564264 C0.11706249,31.6682349 -0.0520837435,32.0053754 0.0522424171,32.3172883 C0.156568578,32.6292012 0.494860938,32.7977715 0.807839551,32.6938006 L7.75863227,30.3847584 L22.3680078,36.5425909 C22.4580753,36.5833888 22.47716,36.5842991 22.4554609,36.5762907 C22.8932651,36.7702858 23.3821493,36.8888889 23.9025224,36.8888889 C24.4652651,36.8888889 24.9896442,36.74898 25.4510299,36.5274837 C25.4870299,36.514763 25.5188848,36.5065784 25.5641361,36.4844867 C25.5700176,36.4814847 25.5758487,36.4783856 25.5816269,36.4751907 L37.8612442,29.9803568 C37.9597214,29.9275368 38.041334,29.8482154 38.0967857,29.7514279 C38.8676126,29.2160286 39.4249105,28.3777535 39.4249105,27.3691756 C39.4249105,25.7332629 38.0813379,24.3942652 36.4398358,24.3942652 C36.1131576,24.3942652 35.8107684,24.4827486 35.5151624,24.5801971 C35.5151624,24.5801971 35.5139964,24.5801971 35.5139964,24.5801971 C35.4343906,24.5797367 35.3554961,24.5951459 35.2819535,24.6255181 L25.2702932,28.7497197 L24.7805541,28.4162049 C24.9162245,28.0770401 25.0965523,27.7554606 25.0965523,27.3691756 C25.0965523,26.2387763 24.4516281,25.2590634 23.5212257,24.7591564 L23.5620376,24.7835602 C23.5819176,24.7963583 23.5423003,24.7592017 23.4361045,24.7022149 C23.4310911,24.6994309 23.4260376,24.6967191 23.4209457,24.6940803 C23.4209457,24.6940803 15.7405845,20.8602401 11.9435672,19.0742889 C11.9393149,19.0723018 11.9350391,19.0703648 11.9307409,19.0684783 C11.865375,19.0395265 11.8588382,19.0393456 11.891095,19.0522091 C11.2053839,18.6705626 10.4158544,18.4444444 9.57416421,18.4444444 Z M13.1562538,26.1792115 C12.8265315,26.1792115 12.5592388,26.445594 12.5592388,26.7741935 C12.5592388,27.1027931 12.8265315,27.3691756 13.1562538,27.3691756 C13.485976,27.3691756 13.7532687,27.1027931 13.7532687,26.7741935 C13.7532687,26.445594 13.485976,26.1792115 13.1562538,26.1792115 Z M14.9472985,26.7741935 C14.6175763,26.7741935 14.3502836,27.0405761 14.3502836,27.3691756 C14.3502836,27.6977752 14.6175763,27.9641577 14.9472985,27.9641577 C15.2770208,27.9641577 15.5443135,27.6977752 15.5443135,27.3691756 C15.5443135,27.0405761 15.2770208,26.7741935 14.9472985,26.7741935 Z M16.7383433,27.3691756 C16.4086211,27.3691756 16.1413284,27.6355582 16.1413284,27.9641577 C16.1413284,28.2927572 16.4086211,28.5591398 16.7383433,28.5591398 C17.0680656,28.5591398 17.3353582,28.2927572 17.3353582,27.9641577 C17.3353582,27.6355582 17.0680656,27.3691756 16.7383433,27.3691756 Z M18.5293881,27.9641577 C18.1996659,27.9641577 17.9323732,28.2305403 17.9323732,28.5591398 C17.9323732,28.8877393 18.1996659,29.1541219 18.5293881,29.1541219 C18.8591103,29.1541219 19.126403,28.8877393 19.126403,28.5591398 C19.126403,28.2305403 18.8591103,27.9641577 18.5293881,27.9641577 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(0.000000, 1.333333)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/costs-expenses',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'costs-expenses',
                            tabindex: '-1',
                            transform: 'translate(732.000000, 363.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-757.000000, -363.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-costs_product',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Costs',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'E8778BF4-6652-46CA-A992-4387A005A9E4',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'defs',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'polygon',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [],
                      attributes: {
                        id: 'path-1',
                        points:
                          '0 0.9908 16.0999 0.9908 16.0999 9.5908 0 9.5908',
                        tabindex: '-1',
                      },
                    },
                    {
                      name: 'polygon',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [],
                      attributes: {
                        id: 'path-3',
                        points:
                          '0.655755556 0.539 12.0196243 0.539 12.0196243 14.9349444 0.655755556 14.9349444',
                        tabindex: '-1',
                      },
                    },
                    {
                      name: 'polygon',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [],
                      attributes: {
                        id: 'path-5',
                        points:
                          '0.9004 0.0905185031 11.46 0.0905185031 11.46 15 0.9004 15',
                        tabindex: '-1',
                      },
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'g',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [
                                        {
                                          name: 'g',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [
                                            {
                                              name: 'g',
                                              type: 'element',
                                              value: '',
                                              parent: null,
                                              children: [
                                                {
                                                  name: 'mask',
                                                  type: 'element',
                                                  value: '',
                                                  parent: null,
                                                  children: [
                                                    {
                                                      name: 'use',
                                                      type: 'element',
                                                      value: '',
                                                      parent: null,
                                                      children: [],
                                                      attributes: {
                                                        tabindex: '-1',
                                                        'xlink:href': '#path-1',
                                                      },
                                                    },
                                                  ],
                                                  attributes: {
                                                    id: 'mask-2',
                                                    fill: 'var(--icon-color)',
                                                    tabindex: '-1',
                                                  },
                                                },
                                                {
                                                  name: 'g',
                                                  type: 'element',
                                                  value: '',
                                                  parent: null,
                                                  children: [],
                                                  attributes: {
                                                    id: 'Clip-2',
                                                    tabindex: '-1',
                                                  },
                                                },
                                                {
                                                  name: 'path',
                                                  type: 'element',
                                                  value: '',
                                                  parent: null,
                                                  children: [],
                                                  attributes: {
                                                    d: 'M7.5999,5.2908 C7.5999,7.0908 6.0999,8.5908 4.2999,8.5908 C2.4999,8.5908 0.9999,7.0908 0.9999,5.2908 C0.9999,3.4908 2.4999,1.9908 4.2999,1.9908 L4.2999,0.9908 C1.8999,0.9908 -0.0001,2.8908 -0.0001,5.2908 C-0.0001,7.6898 1.8999,9.5908 4.2999,9.5908 C6.2999,9.5908 7.8999,8.2908 8.3999,6.4908 L12.7999,6.4908 C12.9999,7.1898 13.5999,7.6898 14.3999,7.6898 C15.2999,7.6898 16.0999,6.8908 16.0999,5.9908 C16.0999,5.0908 15.2999,4.2908 14.3999,4.2908 C13.5999,4.2908 12.9999,4.7908 12.7999,5.4908 L8.5999,5.4908',
                                                    id: 'Fill-1',
                                                    fill: 'var(--icon-color)',
                                                    mask: 'url(#mask-2)',
                                                    tabindex: '-1',
                                                  },
                                                },
                                              ],
                                              attributes: {
                                                id: 'Group-3',
                                                tabindex: '-1',
                                                transform:
                                                  'translate(0.000000, 8.461300)',
                                              },
                                            },
                                            {
                                              name: 'g',
                                              type: 'element',
                                              value: '',
                                              parent: null,
                                              children: [
                                                {
                                                  name: 'mask',
                                                  type: 'element',
                                                  value: '',
                                                  parent: null,
                                                  children: [
                                                    {
                                                      name: 'use',
                                                      type: 'element',
                                                      value: '',
                                                      parent: null,
                                                      children: [],
                                                      attributes: {
                                                        tabindex: '-1',
                                                        'xlink:href': '#path-3',
                                                      },
                                                    },
                                                  ],
                                                  attributes: {
                                                    id: 'mask-4',
                                                    fill: 'var(--icon-color)',
                                                    tabindex: '-1',
                                                  },
                                                },
                                                {
                                                  name: 'g',
                                                  type: 'element',
                                                  value: '',
                                                  parent: null,
                                                  children: [],
                                                  attributes: {
                                                    id: 'Clip-5',
                                                    tabindex: '-1',
                                                  },
                                                },
                                                {
                                                  name: 'path',
                                                  type: 'element',
                                                  value: '',
                                                  parent: null,
                                                  children: [],
                                                  attributes: {
                                                    d: 'M5.9002,7.4905 C5.2002,7.0905 4.9002,6.5905 4.6002,5.6905 C4.4002,4.8905 4.5002,3.9905 4.9002,3.1905 C5.8002,1.5905 7.8002,1.0905 9.2992,1.8905 C10.9002,2.7905 11.4002,4.7905 10.6002,6.2905 L11.5002,6.7905 C12.6002,4.6905 11.9002,2.0905 9.9002,0.9905 C7.8002,-0.0095 5.2002,0.6905 4.0002,2.6905 C3.4002,3.6905 3.3002,4.7905 3.6002,5.8905 C3.9002,6.6905 4.2002,7.2905 4.8002,7.7905 L2.7002,11.5905 C2.0002,11.4905 1.3002,11.7905 0.9002,12.3905 C0.4002,13.1905 0.7002,14.1905 1.5002,14.6905 C2.3002,15.1905 3.3002,14.8905 3.8002,14.0905 C4.2002,13.3905 4.0002,12.5905 3.5002,12.0905 L5.6002,8.3905',
                                                    id: 'Fill-4',
                                                    fill: 'var(--icon-color)',
                                                    mask: 'url(#mask-4)',
                                                    tabindex: '-1',
                                                  },
                                                },
                                              ],
                                              attributes: {
                                                id: 'Group-6',
                                                tabindex: '-1',
                                                transform:
                                                  'translate(2.000000, 0.461300)',
                                              },
                                            },
                                            {
                                              name: 'g',
                                              type: 'element',
                                              value: '',
                                              parent: null,
                                              children: [
                                                {
                                                  name: 'mask',
                                                  type: 'element',
                                                  value: '',
                                                  parent: null,
                                                  children: [
                                                    {
                                                      name: 'use',
                                                      type: 'element',
                                                      value: '',
                                                      parent: null,
                                                      children: [],
                                                      attributes: {
                                                        tabindex: '-1',
                                                        'xlink:href': '#path-5',
                                                      },
                                                    },
                                                  ],
                                                  attributes: {
                                                    id: 'mask-6',
                                                    fill: 'var(--icon-color)',
                                                    tabindex: '-1',
                                                  },
                                                },
                                                {
                                                  name: 'g',
                                                  type: 'element',
                                                  value: '',
                                                  parent: null,
                                                  children: [],
                                                  attributes: {
                                                    id: 'Clip-8',
                                                    tabindex: '-1',
                                                  },
                                                },
                                                {
                                                  name: 'path',
                                                  type: 'element',
                                                  value: '',
                                                  parent: null,
                                                  children: [],
                                                  attributes: {
                                                    d: 'M5.6004,7.991 C6.2994,7.491 7.2004,7.39 8.1004,7.591 C8.9004,7.791 9.7004,8.291 10.1004,9.091 C10.6004,9.791 10.7004,10.69 10.4994,11.591 C10.2994,12.39 9.7994,13.19 8.9994,13.591 C7.4994,14.491 5.4004,13.991 4.4994,12.491 L3.6004,12.991 C4.4004,14.39 5.9004,15.091 7.4004,14.991 C8.1004,14.991 8.7994,14.791 9.4004,14.39 C11.4004,13.19 12.1004,10.491 10.7994,8.491 C10.2004,7.491 9.2994,6.791 8.2004,6.591 C7.4994,6.39 6.7004,6.491 6.1004,6.691 L3.7994,2.89 C4.2994,2.39 4.4004,1.591 3.9994,0.89 C3.4994,0.091 2.4994,-0.11 1.7004,0.291 C0.9004,0.791 0.7004,1.791 1.1004,2.591 C1.4994,3.191 2.2004,3.491 2.9004,3.39 L5.1004,6.991',
                                                    id: 'Fill-7',
                                                    fill: 'var(--icon-color)',
                                                    mask: 'url(#mask-6)',
                                                    tabindex: '-1',
                                                  },
                                                },
                                              ],
                                              attributes: {
                                                id: 'Group-9',
                                                tabindex: '-1',
                                                transform:
                                                  'translate(7.000000, 3.461300)',
                                              },
                                            },
                                          ],
                                          attributes: {
                                            id: 'Group-10',
                                            tabindex: '-1',
                                            transform:
                                              'translate(3.000000, 3.000000)',
                                          },
                                        },
                                      ],
                                      attributes: {
                                        id: 'icon',
                                        tabindex: '-1',
                                        transform:
                                          'translate(33.000000, 0.000000)',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Portal/Styleguide/syetem-icon-Copy-102',
                                    tabindex: '-1',
                                    transform:
                                      'translate(570.000000, 0.000000)',
                                  },
                                },
                              ],
                              attributes: {
                                id: '9',
                                tabindex: '-1',
                                transform: 'translate(0.000000, 801.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'Features',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 1597.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        tabindex: '-1',
                        transform: 'translate(-993.000000, -2398.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-ceh_webhook',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
                'data-title': 'CEH Webhook',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '3EABFEC4-5B2E-4A46-82A2-0A9DE9CBF682',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'g',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [
                                        {
                                          name: 'g',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [
                                            {
                                              name: 'polygon',
                                              type: 'element',
                                              value: '',
                                              parent: null,
                                              children: [],
                                              attributes: {
                                                id: 'Fill-1',
                                                points:
                                                  '0 3 16 3 16 0.999 0 0.999',
                                                tabindex: '-1',
                                              },
                                            },
                                            {
                                              name: 'polygon',
                                              type: 'element',
                                              value: '',
                                              parent: null,
                                              children: [],
                                              attributes: {
                                                id: 'Fill-2',
                                                points: '0 7 10 7 10 5 0 5',
                                                tabindex: '-1',
                                              },
                                            },
                                          ],
                                          attributes: {
                                            id: 'Group-3',
                                            tabindex: '-1',
                                            transform:
                                              'translate(4.000000, 9.000000)',
                                          },
                                        },
                                      ],
                                      attributes: {
                                        id: 'icon',
                                        tabindex: '-1',
                                        transform:
                                          'translate(33.000000, 0.000000)',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Portal/Styleguide/syetem-icon-Copy-101',
                                    tabindex: '-1',
                                    transform:
                                      'translate(456.000000, 0.000000)',
                                  },
                                },
                              ],
                              attributes: {
                                id: '9',
                                tabindex: '-1',
                                transform: 'translate(0.000000, 801.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'Features',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 1597.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        transform: 'translate(-879.000000, -2398.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-ceh_string',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
                'data-title': 'CEH String',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '694D5920-9944-4122-B35C-1BD321CE5E80',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'g',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [
                                        {
                                          name: 'g',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [
                                            {
                                              name: 'polygon',
                                              type: 'element',
                                              value: '',
                                              parent: null,
                                              children: [],
                                              attributes: {
                                                id: 'Fill-1',
                                                points:
                                                  '5.6997 0.0005 3.6997 19.4005 5.6997 19.4005 7.7007 0.0005',
                                                tabindex: '-1',
                                              },
                                            },
                                            {
                                              name: 'polygon',
                                              type: 'element',
                                              value: '',
                                              parent: null,
                                              children: [],
                                              attributes: {
                                                id: 'Fill-2',
                                                points:
                                                  '13.6998 0.0005 11.6998 19.4005 13.6998 19.4005 15.6998 0.0005',
                                                tabindex: '-1',
                                              },
                                            },
                                            {
                                              name: 'polygon',
                                              type: 'element',
                                              value: '',
                                              parent: null,
                                              children: [],
                                              attributes: {
                                                id: 'Fill-3',
                                                points:
                                                  '0 6.7 19.4 6.7 19.4 4.699 0 4.699',
                                                tabindex: '-1',
                                              },
                                            },
                                            {
                                              name: 'polygon',
                                              type: 'element',
                                              value: '',
                                              parent: null,
                                              children: [],
                                              attributes: {
                                                id: 'Fill-4',
                                                points:
                                                  '0 14.7 19.4 14.7 19.4 12.699 0 12.699',
                                                tabindex: '-1',
                                              },
                                            },
                                          ],
                                          attributes: {
                                            id: 'Group-5',
                                            tabindex: '-1',
                                            transform:
                                              'translate(2.000000, 2.000000)',
                                          },
                                        },
                                      ],
                                      attributes: {
                                        id: 'icon',
                                        tabindex: '-1',
                                        transform:
                                          'translate(33.000000, 0.000000)',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Portal/Styleguide/syetem-icon-Copy-100',
                                    tabindex: '-1',
                                    transform:
                                      'translate(342.000000, 0.000000)',
                                  },
                                },
                              ],
                              attributes: {
                                id: '9',
                                tabindex: '-1',
                                transform: 'translate(0.000000, 801.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'Features',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 1597.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        transform: 'translate(-765.000000, -2398.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-ceh_number',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
                'data-title': 'CEH Number',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '692C4FFA-FD96-45E8-8D80-F17D3FC066F7',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'g',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [
                                        {
                                          name: 'g',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [
                                            {
                                              name: 'polygon',
                                              type: 'element',
                                              value: '',
                                              parent: null,
                                              children: [],
                                              attributes: {
                                                id: 'Fill-1',
                                                points:
                                                  '0 6 2 6 2 3.999 0 3.999',
                                                tabindex: '-1',
                                              },
                                            },
                                            {
                                              name: 'polygon',
                                              type: 'element',
                                              value: '',
                                              parent: null,
                                              children: [],
                                              attributes: {
                                                id: 'Fill-2',
                                                points: '0 10 2 10 2 8 0 8',
                                                tabindex: '-1',
                                              },
                                            },
                                            {
                                              name: 'polygon',
                                              type: 'element',
                                              value: '',
                                              parent: null,
                                              children: [],
                                              attributes: {
                                                id: 'Fill-3',
                                                points: '0 2 2 2 2 0 0 0',
                                                tabindex: '-1',
                                              },
                                            },
                                            {
                                              name: 'polygon',
                                              type: 'element',
                                              value: '',
                                              parent: null,
                                              children: [],
                                              attributes: {
                                                id: 'Fill-4',
                                                points:
                                                  '4 6 18 6 18 3.999 4 3.999',
                                                tabindex: '-1',
                                              },
                                            },
                                            {
                                              name: 'polygon',
                                              type: 'element',
                                              value: '',
                                              parent: null,
                                              children: [],
                                              attributes: {
                                                id: 'Fill-5',
                                                points: '4 10 18 10 18 8 4 8',
                                                tabindex: '-1',
                                              },
                                            },
                                            {
                                              name: 'polygon',
                                              type: 'element',
                                              value: '',
                                              parent: null,
                                              children: [],
                                              attributes: {
                                                id: 'Fill-6',
                                                points: '4 2 18 2 18 0 4 0',
                                                tabindex: '-1',
                                              },
                                            },
                                          ],
                                          attributes: {
                                            id: 'Group-7',
                                            tabindex: '-1',
                                            transform:
                                              'translate(3.000000, 7.000000)',
                                          },
                                        },
                                      ],
                                      attributes: {
                                        id: 'icon',
                                        tabindex: '-1',
                                        transform:
                                          'translate(33.000000, 0.000000)',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Portal/Styleguide/syetem-icon-Copy-99',
                                    tabindex: '-1',
                                    transform:
                                      'translate(228.000000, 0.000000)',
                                  },
                                },
                              ],
                              attributes: {
                                id: '9',
                                tabindex: '-1',
                                transform: 'translate(0.000000, 801.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'Features',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 1597.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        transform: 'translate(-651.000000, -2398.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-ceh_list',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
                'data-title': 'CEH List',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '244326A1-736A-4D5F-BB22-C679EE8F7EF3',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'defs',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'polygon',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [],
                      attributes: {
                        id: 'path-1',
                        points: '0 0.2 19.7999 0.2 19.7999 20 0 20',
                        tabindex: '-1',
                      },
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'g',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [
                                        {
                                          name: 'g',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [
                                            {
                                              name: 'g',
                                              type: 'element',
                                              value: '',
                                              parent: null,
                                              children: [
                                                {
                                                  name: 'mask',
                                                  type: 'element',
                                                  value: '',
                                                  parent: null,
                                                  children: [
                                                    {
                                                      name: 'use',
                                                      type: 'element',
                                                      value: '',
                                                      parent: null,
                                                      children: [],
                                                      attributes: {
                                                        tabindex: '-1',
                                                        'xlink:href': '#path-1',
                                                      },
                                                    },
                                                  ],
                                                  attributes: {
                                                    id: 'mask-2',
                                                    fill: 'var(--icon-color)',
                                                    tabindex: '-1',
                                                  },
                                                },
                                                {
                                                  name: 'g',
                                                  type: 'element',
                                                  value: '',
                                                  parent: null,
                                                  children: [],
                                                  attributes: {
                                                    id: 'Clip-2',
                                                    tabindex: '-1',
                                                  },
                                                },
                                                {
                                                  name: 'path',
                                                  type: 'element',
                                                  value: '',
                                                  parent: null,
                                                  children: [],
                                                  attributes: {
                                                    d: 'M9.8999,20 C4.4409,20 -0.0001,15.559 -0.0001,10.1 C-0.0001,9.547 0.4479,9.1 0.9999,9.1 C1.5519,9.1 1.9999,9.547 1.9999,10.1 C1.9999,14.456 5.5439,18 9.8999,18 C14.2559,18 17.7999,14.456 17.7999,10.1 C17.7999,5.744 14.2559,2.2 9.8999,2.2 C9.3479,2.2 8.8999,1.752 8.8999,1.2 C8.8999,0.647 9.3479,0.2 9.8999,0.2 C15.3589,0.2 19.7999,4.641 19.7999,10.1 C19.7999,15.559 15.3589,20 9.8999,20',
                                                    id: 'Fill-1',
                                                    fill: 'var(--icon-color)',
                                                    mask: 'url(#mask-2)',
                                                    tabindex: '-1',
                                                  },
                                                },
                                              ],
                                              attributes: {
                                                id: 'Group-3',
                                                tabindex: '-1',
                                                transform:
                                                  'translate(0.000000, 0.800300)',
                                              },
                                            },
                                            {
                                              name: 'path',
                                              type: 'element',
                                              value: '',
                                              parent: null,
                                              children: [],
                                              attributes: {
                                                d: 'M9.8999,17.4995 C6.2609,17.4995 3.2999,14.5385 3.2999,10.8995 C3.2999,10.3475 3.7479,9.8995 4.2999,9.8995 C4.8519,9.8995 5.2999,10.3475 5.2999,10.8995 C5.2999,13.4365 7.3629,15.4995 9.8999,15.4995 C12.4359,15.4995 14.4999,13.4365 14.4999,10.8995 C14.4999,8.3635 12.4359,6.2995 9.8999,6.2995 C9.3479,6.2995 8.8999,5.8525 8.8999,5.2995 C8.8999,4.7475 9.3479,4.2995 9.8999,4.2995 C13.5389,4.2995 16.4999,7.2605 16.4999,10.8995 C16.4999,14.5385 13.5389,17.4995 9.8999,17.4995',
                                                id: 'Fill-4',
                                                fill: 'var(--icon-color)',
                                                tabindex: '-1',
                                              },
                                            },
                                            {
                                              name: 'path',
                                              type: 'element',
                                              value: '',
                                              parent: null,
                                              children: [],
                                              attributes: {
                                                d: 'M9.8999,7.6001 C11.7219,7.6001 13.1999,9.0771 13.1999,10.9001 C13.1999,12.7221 11.7219,14.2001 9.8999,14.2001 C8.0769,14.2001 6.5999,12.7221 6.5999,10.9001 C6.5999,9.0771 8.0769,7.6001 9.8999,7.6001',
                                                id: 'Fill-6',
                                                fill: 'var(--icon-color)',
                                                tabindex: '-1',
                                              },
                                            },
                                          ],
                                          attributes: {
                                            id: 'Group-8',
                                            tabindex: '-1',
                                            transform:
                                              'translate(2.000000, 2.000000)',
                                          },
                                        },
                                      ],
                                      attributes: {
                                        id: 'icon',
                                        tabindex: '-1',
                                        transform:
                                          'translate(33.000000, 0.000000)',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Portal/Styleguide/syetem-icon-Copy-98',
                                    tabindex: '-1',
                                    transform:
                                      'translate(114.000000, 0.000000)',
                                  },
                                },
                              ],
                              attributes: {
                                id: '9',
                                tabindex: '-1',
                                transform: 'translate(0.000000, 801.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'Features',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 1597.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        tabindex: '-1',
                        transform: 'translate(-537.000000, -2398.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-ceh_event',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
                'data-title': 'CEH Event',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'D06929D8-9078-4A7C-816B-37FCD877CB88',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M5,20 L19,20 L19,9 L5,9 L5,20 Z M19,4 L18,4 L18,2 L16,2 L16,4 L8,4 L8,2 L6,2 L6,4 L5,4 C3.9,4 3,4.9 3,6 L3,20 C3,21.1 3.9,22 5,22 L19,22 C20.1,22 21,21.1 21,20 L21,6 C21,4.9 20.1,4 19,4 L19,4 Z M15,13 L17,13 L17,11 L15,11 L15,13 Z M11,13 L13,13 L13,11 L11,11 L11,13 Z M7,13 L9,13 L9,11 L7,11 L7,13 Z',
                                        id: 'Fill-1',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'icon',
                                    tabindex: '-1',
                                    transform: 'translate(33.000000, 0.000000)',
                                  },
                                },
                              ],
                              attributes: {
                                id: '9',
                                tabindex: '-1',
                                transform: 'translate(0.000000, 801.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'Features',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 1597.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        transform: 'translate(-423.000000, -2398.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-ceh_date',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
                'data-title': 'CEH Date',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'CA4260BA-3409-4483-B892-7682FA031E86',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'g',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [
                                        {
                                          name: 'path',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            d: 'M12,8 C9.79,8 8,9.79 8,12 C8,14.21 9.79,16 12,16 C14.21,16 16,14.21 16,12 C16,9.79 14.21,8 12,8 Z M20.94,11 C20.48,6.83 17.17,3.52 13,3.06 L13,1 L11,1 L11,3.06 C6.83,3.52 3.52,6.83 3.06,11 L1,11 L1,13 L3.06,13 C3.52,17.17 6.83,20.48 11,20.94 L11,23 L13,23 L13,20.94 C17.17,20.48 20.48,17.17 20.94,13 L23,13 L23,11 L20.94,11 Z M12,19 C8.13,19 5,15.87 5,12 C5,8.13 8.13,5 12,5 C15.87,5 19,8.13 19,12 C19,15.87 15.87,19 12,19 Z',
                                            id: 'Shape',
                                            tabindex: '-1',
                                          },
                                        },
                                      ],
                                      attributes: {
                                        id: 'icon',
                                        tabindex: '-1',
                                        transform:
                                          'translate(33.000000, 0.000000)',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Portal/Styleguide/syetem-icon-Copy-26',
                                    tabindex: '-1',
                                    transform:
                                      'translate(684.000000, 0.000000)',
                                  },
                                },
                              ],
                              attributes: {
                                id: '4',
                                tabindex: '-1',
                                transform: 'translate(0.000000, 330.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'Features',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 1597.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1107.000000, -1927.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-current_location',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
                'data-title': 'Location - Current',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'D0041F73-6BB2-4564-B201-FAD327983D59',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'g',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [
                                        {
                                          name: 'path',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            d: 'M20.5,3 L20.34,3.03 L15,5.1 L9,3 L3.36,4.9 C3.15,4.97 3,5.15 3,5.38 L3,20.5 C3,20.78 3.22,21 3.5,21 L3.66,20.97 L9,18.9 L15,21 L20.64,19.1 C20.85,19.03 21,18.85 21,18.62 L21,3.5 C21,3.22 20.78,3 20.5,3 Z M15,19 L9,16.89 L9,5 L15,7.11 L15,19 Z',
                                            id: 'Shape',
                                            tabindex: '-1',
                                          },
                                        },
                                      ],
                                      attributes: {
                                        id: 'icon',
                                        tabindex: '-1',
                                        transform:
                                          'translate(33.000000, 0.000000)',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Portal/Styleguide/syetem-icon-Copy-26',
                                    tabindex: '-1',
                                    transform:
                                      'translate(912.000000, 0.000000)',
                                  },
                                },
                              ],
                              attributes: {
                                id: '4',
                                tabindex: '-1',
                                transform: 'translate(0.000000, 330.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'Features',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 1597.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1335.000000, -1927.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-map_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
                'data-title': 'Map - Active',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'D75F12C5-2ED1-4C17-A551-A18B0091DD50',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'g',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [
                                        {
                                          name: 'path',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            d: 'M20.5,3 L20.34,3.03 L15,5.1 L9,3 L3.36,4.9 C3.15,4.97 3,5.15 3,5.38 L3,20.5 C3,20.78 3.22,21 3.5,21 L3.66,20.97 L9,18.9 L15,21 L20.64,19.1 C20.85,19.03 21,18.85 21,18.62 L21,3.5 C21,3.22 20.78,3 20.5,3 Z M10,5.47 L14,6.87 L14,18.53 L10,17.13 L10,5.47 Z M5,6.46 L8,5.45 L8,17.15 L5,18.31 L5,6.46 Z M19,17.54 L16,18.55 L16,6.86 L19,5.7 L19,17.54 Z',
                                            id: 'Shape',
                                            tabindex: '-1',
                                          },
                                        },
                                      ],
                                      attributes: {
                                        id: 'icon',
                                        tabindex: '-1',
                                        transform:
                                          'translate(33.000000, 0.000000)',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Portal/Styleguide/syetem-icon-Copy-25',
                                    tabindex: '-1',
                                    transform:
                                      'translate(798.000000, 0.000000)',
                                  },
                                },
                              ],
                              attributes: {
                                id: '4',
                                tabindex: '-1',
                                transform: 'translate(0.000000, 330.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'Features',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 1597.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1221.000000, -1927.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-Map',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
                'data-title': 'map',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '06B1C787-1A99-40EA-998D-141B06107A08',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'g',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [
                                        {
                                          name: 'path',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            d: 'M9.63157895,10.02 L14.3684211,10.02 L14.3684211,21 L9.63157895,21 L9.63157895,10.02 Z M16.2631579,21 L19.1052632,21 C20.1473684,21 21,20.1 21,19 L21,10 L16.2631579,10 L16.2631579,21 Z M19.1052632,3 L4.89473684,3 C3.85263158,3 3,3.9 3,5 L3,8 L21,8 L21,5 C21,3.9 20.1473684,3 19.1052632,3 Z M3,19 C3,20.1 3.85263158,21 4.89473684,21 L7.73684211,21 L7.73684211,10 L3,10 L3,19 Z',
                                            id: 'Shape',
                                            tabindex: '-1',
                                          },
                                        },
                                      ],
                                      attributes: {
                                        id: 'icon',
                                        tabindex: '-1',
                                        transform:
                                          'translate(33.000000, 0.000000)',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Portal/Styleguide/syetem-icon-Copy-16',
                                    tabindex: '-1',
                                    transform:
                                      'translate(342.000000, 0.000000)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Group-21',
                                tabindex: '-1',
                                transform: 'translate(0.000000, 782.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'Actions',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 2747.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-765.000000, -3529.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-table_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
                'data-title': 'Table - Active',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '1FBAE70E-C4A0-4807-9BCE-A6B97C9B658C',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'g',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [
                                        {
                                          name: 'path',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            d: 'M19.1052632,3 L4.89473684,3 C3.85263158,3 3,3.9 3,5 L3,19 C3,20.1 3.85263158,21 4.89473684,21 L19.1052632,21 C20.1473684,21 21,20.1 21,19 L21,5 C21,3.9 20.1473684,3 19.1052632,3 Z M19.1052632,5 L19.1052632,8 L4.89473684,8 L4.89473684,5 L19.1052632,5 Z M14.3684211,19 L9.63157895,19 L9.63157895,10 L14.3684211,10 L14.3684211,19 Z M4.89473684,10 L7.73684211,10 L7.73684211,19 L4.89473684,19 L4.89473684,10 Z M16.2631579,19 L16.2631579,10 L19.1052632,10 L19.1052632,19 L16.2631579,19 Z',
                                            id: 'Shape',
                                            tabindex: '-1',
                                          },
                                        },
                                      ],
                                      attributes: {
                                        id: 'icon',
                                        tabindex: '-1',
                                        transform:
                                          'translate(33.000000, 0.000000)',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Portal/Styleguide/syetem-icon-Copy-74',
                                    tabindex: '-1',
                                    transform:
                                      'translate(228.000000, 0.000000)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Group-21',
                                tabindex: '-1',
                                transform: 'translate(0.000000, 782.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'Actions',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 2747.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-651.000000, -3529.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-table',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
                'data-title': 'Table',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'A3BA7EAB-3D5F-494C-84AA-7FEB92A3553E',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M22.7994427,0 C19.1679968,0 16.2104275,2.93772401 16.2104275,6.54480287 C16.2104275,8.04155466 16.9615189,9.52668586 18.0121116,10.9397683 C19.0627037,12.3505267 20.438535,13.698533 21.8073466,14.8815246 C24.5449705,17.2451837 27.2732343,18.9487846 27.2732343,18.9487846 L27.5914538,19.1486617 L27.9096732,18.9487846 C27.9096732,18.9487846 30.6379377,17.2451837 33.3755609,14.8815246 C34.7443725,13.698533 36.1202038,12.3505267 37.1707965,10.9397683 C38.2213886,9.52668586 38.9724801,8.04155466 38.9724801,6.54480287 C38.9724801,2.93772401 36.0149107,0 32.3834648,0 C30.4788279,0 28.7941365,0.836693548 27.5914538,2.12194766 C26.3887716,0.836693548 24.7040802,0 22.7994427,0 Z M22.7994427,1.18996416 C24.5683686,1.18996416 26.1267085,2.0359543 27.1117848,3.34212619 L27.5914538,3.97894265 L28.0711227,3.34212619 C29.0561996,2.0359543 30.6145389,1.18996416 32.3834648,1.18996416 C35.3691124,1.18996416 37.7744773,3.57918907 37.7744773,6.54480287 C37.7744773,7.63250448 37.1778156,8.92705518 36.2067787,10.2309031 C35.2357411,11.5347504 33.9160662,12.8385977 32.5893716,13.9844029 C30.1886866,16.0575435 28.0290057,17.4473848 27.5914538,17.7262826 C27.1539018,17.4473848 24.9942215,16.0575435 22.593536,13.9844029 C21.2668413,12.8385977 19.9471664,11.5347504 18.9761295,10.2309031 C18.0050919,8.92705518 17.4084302,7.63250448 17.4084302,6.54480287 C17.4084302,3.57918907 19.8137952,1.18996416 22.7994427,1.18996416 Z M22.7994427,2.97491039 C22.4695241,2.97491039 22.2004413,3.24218765 22.2004413,3.56989247 C22.2004413,3.8975973 22.4695241,4.16487455 22.7994427,4.16487455 C23.1293613,4.16487455 23.3984441,3.8975973 23.3984441,3.56989247 C23.3984441,3.24218765 23.1293613,2.97491039 22.7994427,2.97491039 Z M20.6912387,3.84646632 C20.527449,3.84414232 20.3730193,3.90689389 20.2583668,4.02077763 C20.0243819,4.2531925 20.0243819,4.6297043 20.2583668,4.86211918 C20.4923517,5.09453405 20.871407,5.09453405 21.1053919,4.86211918 C21.3393768,4.6297043 21.3393768,4.2531925 21.1053919,4.02077763 C20.9954188,3.91154249 20.8456685,3.84879032 20.6912387,3.84646632 Z M19.8044358,5.94982079 C19.4745172,5.94982079 19.2054344,6.21709804 19.2054344,6.54480287 C19.2054344,6.87250769 19.4745172,7.13978495 19.8044358,7.13978495 C20.1343543,7.13978495 20.4034371,6.87250769 20.4034371,6.54480287 C20.4034371,6.21709804 20.1343543,5.94982079 19.8044358,5.94982079 Z M20.6912387,8.05317525 C20.527449,8.05085125 20.3730193,8.11360342 20.2583668,8.22748656 C20.0243819,8.45990143 20.0243819,8.83641383 20.2583668,9.0688287 C20.4923517,9.30124358 20.871407,9.30124358 21.1053919,9.0688287 C21.3393768,8.83641383 21.3393768,8.45990143 21.1053919,8.22748656 C20.9954188,8.11825142 20.8456685,8.05549985 20.6912387,8.05317525 Z M9.62141222,18.4444444 C9.03410993,18.4444444 8.47254614,18.5560036 7.95543962,18.7489081 C7.93672083,18.7512321 7.96011962,18.7396115 7.89226354,18.7605287 L7.90864264,18.7558807 C6.6123665,19.1463377 0.477281711,20.8452899 0.477281711,20.8452899 C0.262015588,20.8964215 0.0935464488,21.0591116 0.037390069,21.2682853 C-0.0211060102,21.479783 0.0420700668,21.7052253 0.20117981,21.8562948 C0.357949254,22.0050403 0.587254771,22.0584959 0.795501196,21.9934197 C0.795501196,21.9934197 6.79487444,20.3339772 8.21516303,19.9063339 C8.25728001,19.8993619 8.2993976,19.8900653 8.33917488,19.8737961 C8.74162894,19.720402 9.16982148,19.6344086 9.62141222,19.6344086 C10.2789097,19.6344086 10.8896108,19.8110439 11.4207561,20.1178315 C11.4418152,20.1317767 11.4652134,20.1410733 11.4862719,20.1503699 C11.4909518,20.1526939 11.4956312,20.1550179 11.5003112,20.1573419 C15.2744878,21.9283436 22.9421733,25.7399475 22.9608921,25.7515681 L22.9655721,25.7515681 C22.9281345,25.7329749 22.9328139,25.7352989 23.0053494,25.7817819 C23.0193888,25.7910785 23.0334276,25.8003751 23.0451267,25.8073477 C23.6137102,26.1118113 23.9974455,26.6882002 23.9974455,27.3691756 C23.9974455,27.7270948 23.8921524,28.0524757 23.7096439,28.3336975 C23.1831779,29.1471493 22.1630037,29.3191366 21.210685,28.8636034 C21.1989859,28.8589548 21.1872868,28.8543068 21.1779274,28.8473342 L20.7684536,28.6823195 C20.5695666,28.5940022 20.3355817,28.6218919 20.1624325,28.7543683 C19.989284,28.8845206 19.9003694,29.1006663 19.9331276,29.314488 C19.9635455,29.5283097 20.1109561,29.7095936 20.3168629,29.7862903 L20.7239963,29.951305 L20.6912387,29.9350358 C21.8962612,30.5114247 23.3680262,30.3812724 24.3086452,29.4702061 L24.9614633,29.9141187 C25.1275927,30.0280018 25.3428589,30.048919 25.5300468,29.9722222 L35.3574133,25.9375 L35.1070493,25.4424565 C35.2497799,25.7236783 35.5867182,25.8468581 35.8768595,25.7236783 C36.0921256,25.6330364 36.3261105,25.5842294 36.5764745,25.5842294 C37.5755903,25.5842294 38.3734787,26.376764 38.3734787,27.3691756 C38.3734787,28.0478271 37.9920831,28.6218919 37.4305193,28.9286796 C37.1590968,29.0751011 37.0444444,29.4074539 37.1731362,29.6910004 L36.9485107,29.1889842 L25.1392918,35.4153789 C25.1580106,35.4060823 25.1416315,35.4130543 25.1135534,35.4223509 C25.0854752,35.4316475 25.057397,35.4409441 25.0316591,35.4548893 C24.7087596,35.6082828 24.3648016,35.6989247 23.9974455,35.6989247 C23.6441281,35.6989247 23.3118698,35.6175794 23.0030097,35.4758065 C22.9889703,35.4711585 22.9749315,35.4641859 22.9608921,35.4595373 C22.9164354,35.4432687 22.9094157,35.4386201 22.9398336,35.4548893 L8.05839298,29.2006048 C7.92268203,29.1448253 7.77293169,29.1378527 7.63488044,29.1843356 L0.446863821,31.564264 C0.133323735,31.6688511 -0.0374851041,32.0058525 0.0678079583,32.3172882 C0.17310162,32.6287244 0.512379598,32.7983871 0.825919086,32.6938006 L7.79866958,30.3835964 L22.457825,36.5425909 C22.5490787,36.5844253 22.5677975,36.5844253 22.546739,36.5751287 C22.9842909,36.7703572 23.4756589,36.8888889 23.9974455,36.8888889 C24.5613489,36.8888889 25.0878155,36.74944 25.5511053,36.5263217 C25.5862032,36.5147011 25.6189608,36.5077285 25.6634181,36.4844873 C25.6704377,36.4821627 25.6774574,36.4775147 25.6821368,36.4751907 L38.0014425,29.9815188 C38.1020562,29.9280632 38.183951,29.8490425 38.2401074,29.7514279 C39.0122574,29.216874 39.5714815,28.3778565 39.5714815,27.3691756 C39.5714815,25.7329749 38.2237283,24.3942652 36.5764745,24.3942652 C36.2488956,24.3942652 35.9447156,24.4825832 35.6498943,24.5801971 L35.6475546,24.5801971 C35.5679994,24.5801971 35.4884448,24.5941423 35.4159093,24.6266801 L25.3709371,28.7497203 L24.8772287,28.4173669 C25.01528,28.0780408 25.1954482,27.7549846 25.1954482,27.3691756 C25.1954482,26.2396396 24.5473102,25.2588486 23.6137102,24.7591564 L23.6558278,24.7847222 C23.6768863,24.7963428 23.637109,24.7591564 23.5294756,24.7010529 C23.5247962,24.6987289 23.5201162,24.6964049 23.5130965,24.6940803 C23.5130965,24.6940803 15.8079734,20.8592351 11.998699,19.0742889 C11.9940196,19.0719649 11.9893396,19.0696403 11.9869999,19.0673163 C11.9191444,19.0394265 11.9144644,19.0394265 11.9448823,19.0510471 C11.2569669,18.6698867 10.4660976,18.4444444 9.62141222,18.4444444 Z M13.2154205,26.1792115 C12.8855019,26.1792115 12.6164191,26.4464887 12.6164191,26.7741935 C12.6164191,27.1018984 12.8855019,27.3691756 13.2154205,27.3691756 C13.5453391,27.3691756 13.8144219,27.1018984 13.8144219,26.7741935 C13.8144219,26.4464887 13.5453391,26.1792115 13.2154205,26.1792115 Z M15.0124247,26.7741935 C14.6825061,26.7741935 14.4134233,27.0414708 14.4134233,27.3691756 C14.4134233,27.6968805 14.6825061,27.9641577 15.0124247,27.9641577 C15.3423433,27.9641577 15.6114261,27.6968805 15.6114261,27.3691756 C15.6114261,27.0414708 15.3423433,26.7741935 15.0124247,26.7741935 Z M16.8094288,27.3691756 C16.4795103,27.3691756 16.2104275,27.6364529 16.2104275,27.9641577 C16.2104275,28.2918625 16.4795103,28.5591398 16.8094288,28.5591398 C17.1393474,28.5591398 17.4084302,28.2918625 17.4084302,27.9641577 C17.4084302,27.6364529 17.1393474,27.3691756 16.8094288,27.3691756 Z M18.606433,27.9641577 C18.2765144,27.9641577 18.0074316,28.231435 18.0074316,28.5591398 C18.0074316,28.8868446 18.2765144,29.1541219 18.606433,29.1541219 C18.9363516,29.1541219 19.2054344,28.8868446 19.2054344,28.5591398 C19.2054344,28.231435 18.9363516,27.9641577 18.606433,27.9641577 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(0.000000, 1.333333)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/cover-who',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'cover-who',
                            tabindex: '-1',
                            transform: 'translate(618.000000, 363.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-643.000000, -363.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-cover_who',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Cover Who',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'E84BE849-CE0F-46B4-BD43-4333B6D95070',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M7.60493827,0 C6.46257699,0 5.5308642,0.932252288 5.5308642,2.07527504 L5.5308642,4.15055009 L2.07407407,4.15055009 C0.899305383,4.15055009 0,5.11252654 0,6.23393185 L0,35.2499516 C0,36.3713569 0.899305383,37.3333333 2.07407407,37.3333333 L35.2592593,37.3333333 C36.434028,37.3333333 37.3333333,36.3713569 37.3333333,35.2499516 L37.3333333,6.23393185 C37.3333333,5.11252654 36.434028,4.15055009 35.2592593,4.15055009 L31.8024691,4.15055009 L31.8024691,2.07527504 C31.8024691,0.932252288 30.8707563,0 29.7283951,0 C28.5860338,0 27.654321,0.932252288 27.654321,2.07527504 L27.654321,4.15055009 L20.7407407,4.15055009 L20.7407407,2.07527504 C20.7407407,0.932252288 19.809028,0 18.6666667,0 C17.5243054,0 16.5925926,0.932252288 16.5925926,2.07527504 L16.5925926,4.15055009 L9.67901235,4.15055009 L9.67901235,2.07527504 C9.67901235,0.932252288 8.74729956,0 7.60493827,0 Z M7.60493827,1.3835167 C7.98572514,1.3835167 8.2962963,1.69426769 8.2962963,2.07527504 L8.2962963,7.60934183 C8.2962963,7.99034918 7.98572514,8.30110017 7.60493827,8.30110017 C7.22415141,8.30110017 6.91358025,7.99034918 6.91358025,7.60934183 L6.91358025,2.07527504 C6.91358025,1.69426769 7.22415141,1.3835167 7.60493827,1.3835167 Z M18.6666667,1.3835167 C19.0474535,1.3835167 19.3580247,1.69426769 19.3580247,2.07527504 L19.3580247,7.60934183 C19.3580247,7.99034918 19.0474535,8.30110017 18.6666667,8.30110017 C18.2858798,8.30110017 17.9753086,7.99034918 17.9753086,7.60934183 L17.9753086,2.07527504 C17.9753086,1.69426769 18.2858798,1.3835167 18.6666667,1.3835167 Z M29.7283951,1.3835167 C30.1091819,1.3835167 30.4197531,1.69426769 30.4197531,2.07527504 L30.4197531,7.60934183 C30.4197531,7.99034918 30.1091819,8.30110017 29.7283951,8.30110017 C29.3476082,8.30110017 29.037037,7.99034918 29.037037,7.60934183 L29.037037,2.07527504 C29.037037,1.69426769 29.3476082,1.3835167 29.7283951,1.3835167 Z M2.07407407,5.51244933 L5.5308642,5.51244933 L5.5308642,7.60934183 C5.5308642,8.75236458 6.46257699,9.68461687 7.60493827,9.68461687 C8.74729956,9.68461687 9.67901235,8.75236458 9.67901235,7.60934183 L9.67901235,5.51244933 L16.5925926,5.51244933 L16.5925926,7.60934183 C16.5925926,8.75236458 17.5243054,9.68461687 18.6666667,9.68461687 C19.809028,9.68461687 20.7407407,8.75236458 20.7407407,7.60934183 L20.7407407,5.51244933 L27.654321,5.51244933 L27.654321,7.60934183 C27.654321,8.75236458 28.5860338,9.68461687 29.7283951,9.68461687 C30.8707563,9.68461687 31.8024691,8.75236458 31.8024691,7.60934183 L31.8024691,5.51244933 L35.2592593,5.51244933 C35.6751547,5.51244933 35.9506173,5.83130704 35.9506173,6.23393185 L35.9506173,11.0681336 C35.5347226,11.0681336 35.2592593,11.3761826 35.2592593,11.7598919 L35.2592593,13.1434086 C35.2592593,13.5271187 35.5347226,13.835167 35.9506173,13.835167 L35.9506173,35.2499516 C35.9506173,35.6498744 35.6751547,35.9714341 35.2592593,35.9714341 L2.07407407,35.9714341 C1.65817936,35.9714341 1.38271605,35.6498744 1.38271605,35.2499516 L1.38271605,13.835167 C1.79861146,13.835167 2.07407407,13.5271187 2.07407407,13.1434086 L2.07407407,11.7598919 C2.07407407,11.3761826 1.79861146,11.0681336 1.38271605,11.0681336 L1.38271605,6.23393185 C1.38271605,5.83130704 1.65817936,5.51244933 2.07407407,5.51244933 Z M4.83950617,11.0681336 C4.42361146,11.0681336 4.14814815,11.3761826 4.14814815,11.7598919 L4.14814815,13.1434086 C4.14814815,13.524416 4.42361146,13.835167 4.83950617,13.835167 C5.25540158,13.835167 5.5308642,13.5271187 5.5308642,13.1434086 L5.5308642,11.7598919 C5.5308642,11.3761826 5.25540158,11.0681336 4.83950617,11.0681336 Z M8.2962963,11.0681336 C7.88040158,11.0681336 7.60493827,11.3761826 7.60493827,11.7598919 L7.60493827,13.1434086 C7.60493827,13.524416 7.88040158,13.835167 8.2962963,13.835167 C8.7121917,13.835167 8.98765432,13.5271187 8.98765432,13.1434086 L8.98765432,11.7598919 C8.98765432,11.3761826 8.7121917,11.0681336 8.2962963,11.0681336 Z M11.7530864,11.0681336 C11.3371917,11.0681336 11.0617284,11.3761826 11.0617284,11.7598919 L11.0617284,13.1434086 C11.0617284,13.524416 11.3371917,13.835167 11.7530864,13.835167 C12.1689818,13.835167 12.4444444,13.5271187 12.4444444,13.1434086 L12.4444444,11.7598919 C12.4444444,11.3761826 12.1689818,11.0681336 11.7530864,11.0681336 Z M15.2098765,11.0681336 C14.7939818,11.0681336 14.5185185,11.3761826 14.5185185,11.7598919 L14.5185185,13.1434086 C14.5185185,13.524416 14.7939818,13.835167 15.2098765,13.835167 C15.625772,13.835167 15.9012346,13.5271187 15.9012346,13.1434086 L15.9012346,11.7598919 C15.9012346,11.3761826 15.625772,11.0681336 15.2098765,11.0681336 Z M18.6666667,11.0681336 C18.250772,11.0681336 17.9753086,11.3761826 17.9753086,11.7598919 L17.9753086,13.1434086 C17.9753086,13.524416 18.250772,13.835167 18.6666667,13.835167 C19.0825621,13.835167 19.3580247,13.5271187 19.3580247,13.1434086 L19.3580247,11.7598919 C19.3580247,11.3761826 19.0825621,11.0681336 18.6666667,11.0681336 Z M22.1234568,11.0681336 C21.7075621,11.0681336 21.4320988,11.3761826 21.4320988,11.7598919 L21.4320988,13.1434086 C21.4320988,13.524416 21.7075621,13.835167 22.1234568,13.835167 C22.5393522,13.835167 22.8148148,13.5271187 22.8148148,13.1434086 L22.8148148,11.7598919 C22.8148148,11.3761826 22.5393522,11.0681336 22.1234568,11.0681336 Z M25.5802469,11.0681336 C25.1643522,11.0681336 24.8888889,11.3761826 24.8888889,11.7598919 L24.8888889,13.1434086 C24.8888889,13.524416 25.1643522,13.835167 25.5802469,13.835167 C25.9961423,13.835167 26.2716049,13.5271187 26.2716049,13.1434086 L26.2716049,11.7598919 C26.2716049,11.3761826 25.9961423,11.0681336 25.5802469,11.0681336 Z M29.037037,11.0681336 C28.6211423,11.0681336 28.345679,11.3761826 28.345679,11.7598919 L28.345679,13.1434086 C28.345679,13.524416 28.6211423,13.835167 29.037037,13.835167 C29.4529324,13.835167 29.7283951,13.5271187 29.7283951,13.1434086 L29.7283951,11.7598919 C29.7283951,11.3761826 29.4529324,11.0681336 29.037037,11.0681336 Z M32.4938272,11.0681336 C32.0779324,11.0681336 31.8024691,11.3761826 31.8024691,11.7598919 L31.8024691,13.1434086 C31.8024691,13.524416 32.0779324,13.835167 32.4938272,13.835167 C32.9097226,13.835167 33.1851852,13.5271187 33.1851852,13.1434086 L33.1851852,11.7598919 C33.1851852,11.3761826 32.9097226,11.0681336 32.4938272,11.0681336 Z M23.5553062,17.9365553 C23.2859712,17.6672203 22.8468352,17.6671424 22.5775782,17.9365553 L18.6666667,21.8497314 L14.7557551,17.9365553 C14.4864981,17.6671424 14.0473621,17.6672203 13.7780272,17.9365553 C13.5086922,18.2058902 13.5087702,18.6454364 13.7780272,18.9148493 L17.6889388,22.8280255 L13.7780272,26.7412016 C13.5087702,27.0106145 13.5086922,27.4501608 13.7780272,27.7194957 C14.0473621,27.9888306 14.4864981,27.9889085 14.7557551,27.7194957 L18.6666667,23.8063195 L22.5775782,27.7194957 C22.8468352,27.9889085 23.2859712,27.9888306 23.5553062,27.7194957 C23.8246411,27.4501608 23.8245631,27.0106145 23.5553061,26.7412016 L19.6443946,22.8280255 L23.5553061,18.9148493 C23.8245631,18.6454364 23.8246411,18.2058902 23.5553062,17.9365553 Z M3.45679012,31.820884 C3.07600326,31.820884 2.7654321,32.131635 2.7654321,32.5126423 C2.7654321,32.8936497 3.07600326,33.2044007 3.45679012,33.2044007 L33.8765432,33.2044007 C34.2573301,33.2044007 34.5679012,32.8936497 34.5679012,32.5126423 C34.5679012,32.131635 34.2573301,31.820884 33.8765432,31.820884 L3.45679012,31.820884 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(1.333333, 1.333333)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/coverage-lost',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'coverage-lost-terminated',
                            tabindex: '-1',
                            transform: 'translate(504.000000, 363.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-529.000000, -363.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-coverage_lost',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Coverage Lost',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'F3070FB5-FD35-438F-8C45-55781A8B8D18',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M28.1114369,0 C27.8361545,0 27.5981991,0.186011905 27.5305446,0.451079167 L26.9659832,2.70647321 C26.80268,2.76692738 26.6393773,2.83435655 26.4760741,2.91108631 L24.4744468,1.71363452 C24.2388241,1.5741256 23.9378796,1.60900298 23.7442494,1.80199048 L22.477485,3.06454643 C20.394206,2.63439345 18.047309,2.38095238 15.5277778,2.38095238 C6.82139757,2.38095238 0,5.25716131 0,8.92857143 L0,26.7857143 C0,30.4571244 6.82139757,33.3333333 15.5277778,33.3333333 C24.234158,33.3333333 31.0555556,30.4571244 31.0555556,26.7857143 L31.0555556,17.1688988 L31.5617946,15.1506696 C31.7250978,15.0902161 31.8907338,15.0227863 32.0517037,14.9460565 L34.053331,16.1435083 C34.2889543,16.2830173 34.5898982,16.2481399 34.7835289,16.0551524 L36.4142251,14.4298738 C36.6078559,14.2368863 36.6451823,13.9369423 36.5028756,13.7021018 L35.3014323,11.7071244 C35.3784178,11.5466893 35.4460723,11.3816036 35.5067274,11.2188429 L37.7696401,10.6561571 C38.0355903,10.588728 38.2222222,10.3515625 38.2222222,10.0795202 L38.2222222,7.77994821 C38.2222222,7.50558036 38.0355903,7.26841548 37.7696401,7.20098571 L35.5067274,6.6383 C35.4460723,6.47553929 35.3784178,6.31277917 35.3014323,6.15001845 L36.5028756,4.15504107 C36.6428495,3.92020119 36.6078559,3.62258214 36.4142251,3.42726964 L34.7835289,1.80431548 C34.5898982,1.60900298 34.2889543,1.5718006 34.053331,1.71363452 L32.0517037,2.91108631 C31.8907338,2.83435655 31.7250978,2.76692738 31.5617946,2.70647321 L30.9972332,0.451079167 C30.9295793,0.186011905 30.6916233,0 30.4186742,0 L28.1114369,0 Z M28.5780168,1.19047619 L29.9520943,1.19047619 L30.4839954,3.3086869 C30.5329861,3.510975 30.6869578,3.67141012 30.8852541,3.73418929 C31.190864,3.82719524 31.4964734,3.95507798 31.8020833,4.11551369 C31.9863825,4.21316964 32.2080081,4.20619405 32.3876412,4.0992375 L34.2679577,2.97154048 L35.2384439,3.94112738 L34.1093206,5.81752262 C34.0020075,5.99655893 33.9973414,6.21744821 34.0953235,6.40113452 C34.2539607,6.70340417 34.3822703,7.01032381 34.477919,7.31259286 C34.5385741,7.51255595 34.6995446,7.66369048 34.9025064,7.71484405 L37.0277778,8.24497798 L37.0277778,9.61216548 L34.9025064,10.1422994 C34.6995446,10.1934524 34.5385741,10.3445869 34.477919,10.54455 C34.3822703,10.846819 34.2539607,11.1537387 34.0929907,11.4560083 C33.9950087,11.6396952 34.0020075,11.8605839 34.1093206,12.0396208 L35.2384439,13.9160155 L34.2679577,14.8832774 L32.3853085,13.7579054 C32.2056748,13.6509488 31.9840498,13.6462982 31.7997506,13.7416298 C31.4964734,13.9020649 31.1885307,14.0299482 30.8852541,14.1252792 C30.6846244,14.1857327 30.5329861,14.3461685 30.4816626,14.548456 L29.9497616,16.6666667 L28.5756834,16.6666667 L28.0437824,14.548456 C27.9947917,14.3461685 27.8408206,14.1857327 27.6425237,14.1252792 C27.3369144,14.0299482 27.0313044,13.9020649 26.7256944,13.7416298 C26.5413952,13.6439732 26.3197703,13.6509488 26.1401366,13.7579054 L24.25982,14.8832774 L23.2893339,13.9160155 L24.4184572,12.0396208 C24.5257702,11.8605839 24.5304363,11.6396952 24.4324543,11.4560083 C24.2738171,11.1537387 24.1455081,10.846819 24.0498588,10.54455 C23.9892037,10.3445869 23.8282338,10.1934524 23.6252714,10.1422994 L21.5,9.61216548 L21.5,8.24265238 L23.6252714,7.71251845 C23.8282338,7.66369048 23.9892037,7.51023095 24.0498588,7.31259286 C24.1455081,7.00799881 24.2738171,6.70340417 24.4347876,6.39880952 C24.5327691,6.21512262 24.5257702,5.99423393 24.4184572,5.81752262 L23.2893339,3.94112738 L24.25982,2.97154048 L26.1424699,4.0992375 C26.322103,4.20619405 26.5437286,4.21084464 26.7280272,4.11551369 C27.0313044,3.95507798 27.3392471,3.82719524 27.6425237,3.73418929 C27.8431534,3.67141012 27.9947917,3.510975 28.0461157,3.3086869 L28.5780168,1.19047619 Z M15.5277778,3.57142857 C17.9423287,3.57142857 20.130588,3.79464286 22.031901,4.16666667 L23.2263455,6.15001845 C23.14936,6.31045417 23.081706,6.47553929 23.0210503,6.6383 L20.7581383,7.20098571 C20.4921875,7.26841548 20.3055556,7.50558036 20.3055556,7.77762262 L20.3055556,10.0771952 C20.3055556,10.3515625 20.4921875,10.588728 20.7581383,10.6561571 L23.0210503,11.2188429 C23.081706,11.3816036 23.14936,11.5443637 23.2263455,11.7071244 L22.031901,13.6904762 C20.130588,14.064825 17.9423287,14.2857143 15.5277778,14.2857143 C6.95437268,14.2857143 1.19444444,11.5164619 1.19444444,8.92857143 C1.19444444,6.34068095 6.95437268,3.57142857 15.5277778,3.57142857 Z M16.1996528,4.76888036 C15.8730469,4.76888036 15.6070967,5.02697202 15.6024306,5.35249286 C15.5954317,5.68033869 15.8590498,5.95238095 16.1903212,5.95935655 C16.7525498,5.96865714 17.3217772,5.99423393 17.8793403,6.03143631 C17.8910046,6.03143631 17.9050023,6.03376131 17.9189994,6.03376131 C18.2292755,6.03376131 18.4928929,5.79194583 18.5138889,5.4780506 C18.5372182,5.14787976 18.2875978,4.86653631 17.9586592,4.84328512 C17.3824329,4.80375774 16.7922095,4.78050595 16.2089844,4.76888036 L16.1996528,4.76888036 Z M13.5144855,4.81770833 C11.6295029,4.92233988 9.83317072,5.17578155 8.32378472,5.55245536 C8.00417767,5.63383571 7.81054687,5.95935655 7.8921985,6.27790179 C7.95985243,6.54761905 8.20247396,6.72665536 8.47075753,6.72665536 C8.51974826,6.72665536 8.568739,6.72200536 8.61539699,6.70805417 C10.052463,6.34998155 11.7694768,6.10584107 13.5798067,6.00585952 C13.9110787,5.98725833 14.1630318,5.70591548 14.1443686,5.37806905 C14.1257054,5.05022321 13.8387587,4.80608274 13.5144855,4.81770833 Z M29.2638889,5.95238095 C27.6168623,5.95238095 26.2777778,7.28701667 26.2777778,8.92857143 C26.2777778,10.5701268 27.6168623,11.9047619 29.2638889,11.9047619 C30.9109161,11.9047619 32.25,10.5701268 32.25,8.92857143 C32.25,7.28701667 30.9109161,5.95238095 29.2638889,5.95238095 Z M29.2638889,7.14285714 C30.2507054,7.14285714 31.0555556,7.94503333 31.0555556,8.92857143 C31.0555556,9.91210952 30.2507054,10.7142857 29.2638889,10.7142857 C28.2770723,10.7142857 27.4722222,9.91210952 27.4722222,8.92857143 C27.4722222,7.94503333 28.2770723,7.14285714 29.2638889,7.14285714 Z M1.19444444,11.4932107 C3.5156794,13.8555619 8.99099422,15.4761905 15.5277778,15.4761905 C18.047309,15.4761905 20.394206,15.2227494 22.477485,14.7902714 L23.7465822,16.0551524 C23.9378796,16.2481399 24.2388241,16.2830173 24.4744468,16.1435083 L26.4760741,14.9460565 C26.6393773,15.0227863 26.80268,15.0902161 26.9659832,15.1506696 L27.5305446,17.4060643 C27.5562066,17.5037202 27.6098634,17.5851006 27.6751846,17.6548548 C25.2489693,19.1266744 20.9564346,20.2380952 15.5277778,20.2380952 C6.95437268,20.2380952 1.19444444,17.4688429 1.19444444,14.8809524 L1.19444444,11.4932107 Z M1.19444444,17.4455917 C3.5156794,19.8079429 8.99099422,21.4285714 15.5277778,21.4285714 C21.6749676,21.4285714 26.8703345,19.9916298 29.4015301,17.8571429 L29.8611111,17.8571429 L29.8611111,20.8333333 C29.8611111,21.8633744 28.9466146,22.9282923 27.2832575,23.83045 C26.993978,23.9885601 26.8866643,24.3489583 27.0429687,24.6372768 C27.1526152,24.8372399 27.3579103,24.9465214 27.5678709,24.9465214 C27.665853,24.9465214 27.7638345,24.9255952 27.8548177,24.8767673 C28.6829971,24.4256881 29.350206,23.9350821 29.8611111,23.4119232 L29.8611111,26.7857143 C29.8611111,29.3736048 24.1035156,32.1428571 15.5277778,32.1428571 C6.95437268,32.1428571 1.19444444,29.3736048 1.19444444,26.7857143 L1.19444444,23.3840214 C3.11442072,25.3510976 7.21332465,26.8275673 12.4553495,27.2577196 C12.47168,27.2600446 12.4903432,27.2600446 12.5043403,27.2600446 C12.8146157,27.2600446 13.0735677,27.0228798 13.1015625,26.7113095 C13.1272245,26.3834637 12.8822703,26.0974702 12.553331,26.0695685 C6.07720254,25.5394345 1.19444444,23.2886905 1.19444444,20.8333333 L1.19444444,17.4455917 Z M24.4861111,23.8095238 C24.1548397,23.8095238 23.8888889,24.0745911 23.8888889,24.4047619 L23.8888889,25.5952381 C23.8888889,25.9254095 24.1548397,26.1904762 24.4861111,26.1904762 C24.8173831,26.1904762 25.0833333,25.9254095 25.0833333,25.5952381 L25.0833333,24.4047619 C25.0833333,24.0745911 24.8173831,23.8095238 24.4861111,23.8095238 Z M21.5,24.4628905 C21.1687286,24.4628905 20.9027778,24.7302827 20.9027778,25.0581286 L20.9027778,26.2486048 C20.9027778,26.5787762 21.1687286,26.8438429 21.5,26.8438429 C21.831272,26.8438429 22.0972222,26.5787762 22.0972222,26.2486048 L22.0972222,25.0581286 C22.0972222,24.7302827 21.831272,24.4628905 21.5,24.4628905 Z M18.5138889,24.8814173 C18.1826175,24.8814173 17.9166667,25.1464845 17.9166667,25.4766554 L17.9166667,26.6671315 C17.9166667,26.997303 18.1826175,27.2623696 18.5138889,27.2623696 C18.8451609,27.2623696 19.1111111,26.997303 19.1111111,26.6671315 L19.1111111,25.4766554 C19.1111111,25.1464845 18.8451609,24.8814173 18.5138889,24.8814173 Z M15.5277778,25 C15.1965064,25 14.9305556,25.2650673 14.9305556,25.5952381 L14.9305556,26.7857143 C14.9305556,27.1158857 15.1965064,27.3809524 15.5277778,27.3809524 C15.8590498,27.3809524 16.125,27.1158857 16.125,26.7857143 L16.125,25.5952381 C16.125,25.2650673 15.8590498,25 15.5277778,25 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(0.888889, 3.111111)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/tax-id-npi',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'tax-id',
                            tabindex: '-1',
                            transform: 'translate(1302.000000, 247.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1327.000000, -247.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-tax_id',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Tax ID / NPI',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '99B2EC9B-E11D-4532-BC6E-B74204E7D634',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M20,0 C8.97216812,0 0,7.21760524 0,16.0909847 C0,21.6724682 3.47412125,26.7306871 9.31640625,29.6983068 C9.20898438,31.1747473 8.811035,33.6338426 7.438965,35.935713 C7.30957063,36.1518972 7.3217775,36.4245843 7.46826187,36.6260284 C7.58544937,36.7930798 7.77587875,36.8888889 7.97607437,36.8888889 C8.02001938,36.8888889 8.06640625,36.8839759 8.11035188,36.8741494 C12.8417969,35.8153379 15.061035,33.1007521 15.8618163,31.8331265 C17.2290038,32.0640502 18.6181644,32.1819689 20,32.1819689 C31.0302737,32.1819689 40,24.9643643 40,16.0934412 C40,7.22006172 31.0278319,0 20,0 Z M20,1.25779909 C30.3393556,1.25779909 38.75,7.91283356 38.75,16.0909847 C38.75,24.2691353 30.3393556,30.9241698 20,30.9241698 C18.549805,30.9241698 17.0898438,30.7890545 15.6616212,30.521281 C15.3955081,30.4696917 15.1269531,30.597437 14.9975587,30.8357308 C14.5776369,31.6071157 13.0004881,34.0170782 9.1967775,35.2724208 C10.2661131,32.9238741 10.5322269,30.6244601 10.5883788,29.3494644 C10.6005862,29.098887 10.4614256,28.8630496 10.2368163,28.752501 C4.609375,26.0305452 1.25,21.296602 1.25,16.0934412 C1.25,7.91283356 9.66064438,1.25779909 20,1.25779909 Z M20,3.66530516 C11.3989256,3.66530516 4.40185563,9.30820442 4.40185563,16.243296 C4.40185563,17.0883798 4.50683625,17.9334636 4.71191438,18.7564377 C4.782715,19.0414078 5.0390625,19.2305689 5.31738313,19.2305689 C5.3686525,19.2305689 5.42236313,19.2256559 5.47363313,19.2109158 C5.80810563,19.1273904 6.0107425,18.7859174 5.92529313,18.449358 C5.74462875,17.7271059 5.65185563,16.9852013 5.65185563,16.243296 C5.65185563,10.0009769 12.0874025,4.92310424 20,4.92310424 C22.5415038,4.92310424 25.0390625,5.45373823 27.22168,6.46341696 C27.53418,6.6059017 27.9052738,6.46832992 28.0493163,6.15142367 C28.1933594,5.83697389 28.0566406,5.46356479 27.7441406,5.31862294 C25.3979494,4.23770185 22.7197269,3.66530516 20,3.66530516 Z M30.03418,6.82208591 C29.8754881,6.84665262 29.7290037,6.93263513 29.626465,7.07511987 C29.4238281,7.35517701 29.4848631,7.74823923 29.7631837,7.95213978 C30.3222656,8.36485511 30.8447269,8.81196369 31.3134769,9.28609483 C31.4355469,9.41138357 31.59668,9.47279938 31.7578125,9.47279938 C31.9165038,9.47279938 32.0751956,9.41138357 32.1972656,9.28855131 C32.4438475,9.04288743 32.4438475,8.64491225 32.1997069,8.39924837 C31.6845706,7.87844093 31.1132812,7.38465668 30.4980469,6.93509162 C30.3588869,6.83191247 30.1928712,6.79751984 30.03418,6.82208591 Z M33.42041,10.4652815 C33.342285,10.4775645 33.2617188,10.5045877 33.1884769,10.551264 C32.8930663,10.7305985 32.7978519,11.1162906 32.9785156,11.4135444 C33.8867188,12.9292904 34.3481444,14.5531285 34.3481444,16.243296 C34.3481444,21.3973246 29.9340819,25.9028 23.6181644,27.1999053 C23.28125,27.2686912 23.0615238,27.6027941 23.1323244,27.9418105 C23.1909181,28.2390637 23.4521488,28.4454213 23.7426756,28.4454213 C23.78418,28.4454213 23.8256838,28.4405077 23.8671875,28.4306812 C30.7739256,27.0132007 35.5981444,22.0016575 35.5981444,16.243296 C35.5981444,14.3222048 35.0756838,12.4772688 34.04541,10.7625346 C33.9135744,10.538981 33.6621094,10.4308888 33.42041,10.4652815 Z M8.09082063,20.5276742 C7.93457063,20.4981945 7.76367188,20.5325878 7.62451188,20.6308533 L6.59912125,21.3506484 C6.31591813,21.5496359 6.24755875,21.9426982 6.4453125,22.2276683 C6.56738313,22.4020898 6.76025375,22.4954417 6.95800813,22.4954417 C7.08251938,22.4954417 7.20459,22.4585926 7.31445313,22.3824367 L8.33984375,21.6601845 C8.62304688,21.4611969 8.69140625,21.0705912 8.4936525,20.7856211 C8.39599625,20.6431364 8.24707063,20.5546974 8.09082063,20.5276742 Z M10.2416994,23.0629255 C10.0805663,23.0776656 9.92675813,23.1513645 9.81445313,23.2864798 L9.01123063,24.2494822 C8.7890625,24.5147992 8.8232425,24.9103179 9.08935563,25.1338722 C9.20410188,25.2321377 9.34814438,25.2812705 9.48974625,25.2812705 C9.66796875,25.2812705 9.84375,25.2051145 9.96826188,25.0577162 L10.7714844,24.0947138 C10.9936525,23.8269403 10.9594725,23.4314216 10.6958006,23.2078673 C10.563965,23.0973187 10.4003906,23.048186 10.2416994,23.0629255 Z M13.2055663,24.917688 C12.9614256,24.9078614 12.7246094,25.0405196 12.6171875,25.2763569 L12.0874025,26.4162373 C11.9409181,26.7306871 12.0751956,27.1065533 12.3876956,27.2539517 C12.4731444,27.2932579 12.5634769,27.312911 12.6538088,27.312911 C12.8881838,27.312911 13.1127931,27.1777957 13.220215,26.9493284 L13.7475588,25.8119045 C13.8940431,25.4974547 13.7597656,25.1215891 13.4472656,24.9766473 C13.3691406,24.9397975 13.2861331,24.9201444 13.2055663,24.917688 Z M16.5576175,25.9642158 C16.2158206,25.9052565 15.893555,26.1337243 15.8325194,26.4751967 L15.6152344,27.7133426 C15.5541994,28.0548156 15.7836913,28.3815484 16.1230469,28.4405077 C16.1596681,28.4478778 16.1962894,28.4503343 16.2304688,28.4503343 C16.5283206,28.4503343 16.7919925,28.2366072 16.8457031,27.931984 L17.06543,26.693838 C17.126465,26.352365 16.8969725,26.0256322 16.5576175,25.9642158 Z M19.8193362,26.1091576 C19.4750975,26.1410938 19.2211913,26.445717 19.2504881,26.7896464 L19.35791,28.044989 C19.3872069,28.3717219 19.6582031,28.6198429 19.9804687,28.6198429 C19.9975587,28.6198429 20.01709,28.6198429 20.03418,28.6173857 C20.3784181,28.5879061 20.6323244,28.2832829 20.6030275,27.9368969 L20.4956056,26.6815543 C20.4663087,26.3376249 20.15625,26.0772215 19.8193362,26.1091576 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(0.000000, 1.333333)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/contact',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'contact',
                            tabindex: '-1',
                            transform: 'translate(1188.000000, 247.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1213.000000, -247.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-contact',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Contact',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'E57DBB1A-E756-4444-8337-7035C33F6AD2',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M19.1111111,0 C16.9693487,0 14.8687739,0.353050297 12.8608716,1.04626666 C12.5184987,1.16480882 12.335728,1.54105271 12.4567171,1.88637181 C12.5751315,2.22911406 12.95097,2.41208198 13.2933429,2.29353982 C15.1596622,1.64670998 17.1160798,1.31942946 19.1111111,1.31942946 C28.921516,1.31942946 36.9042146,9.31073938 36.9042146,19.1317272 C36.9042146,28.4785451 29.6139847,36.286887 20.3055556,36.9027928 C19.9425888,36.9285632 19.6697197,37.2429582 19.6954623,37.6063165 C19.7160562,37.9542131 20.0069444,38.2222222 20.3493174,38.2222222 C20.3647631,38.2222222 20.3802082,38.2222222 20.3956539,38.2222222 C30.3914036,37.5573538 38.2222222,29.1717608 38.2222222,19.1317272 C38.2222222,8.58144585 29.6500243,0 19.1111111,0 Z M9.80268199,2.47908459 C9.72030651,2.48939263 9.63535697,2.51773926 9.55555556,2.56154893 C9.23892464,2.7445162 9.13338123,3.14910737 9.31615198,3.46350234 L9.97515582,4.60769507 C10.096145,4.81901028 10.3175287,4.93755244 10.5440613,4.93755244 C10.6573276,4.93755244 10.7705939,4.90920516 10.8735632,4.84993441 C11.1901941,4.66696648 11.2957375,4.26237597 11.1129668,3.94798034 L10.453963,2.80378761 C10.3201028,2.56927947 10.0601054,2.44816046 9.80268199,2.47908459 Z M19.4612069,3.96086523 C17.3992459,3.91190252 15.342433,4.28556891 13.424629,5.06124895 C13.0848301,5.19783035 12.9252273,5.58438228 13.0590875,5.92197084 C13.1646316,6.17967191 13.4091833,6.33429255 13.6717554,6.33429255 C13.7541309,6.33429255 13.8365064,6.31883016 13.9188819,6.28790603 C16.253712,5.3395661 18.8125,5.05094091 21.3120811,5.45295457 C21.6724738,5.51222598 22.0096986,5.26483296 22.0663314,4.90662831 C22.1229649,4.54584682 21.8784125,4.20568141 21.5205939,4.1489875 C20.835848,4.03817588 20.1459534,3.97632763 19.4612069,3.96086523 Z M6.79855108,4.74685398 C6.63122605,4.73654594 6.45875223,4.79323984 6.32231801,4.91435951 C6.05202363,5.15917569 6.03142976,5.57665108 6.2734074,5.84466019 L7.15636973,6.82650109 C7.28508175,6.97081369 7.46527778,7.04296999 7.64804854,7.04296999 C7.80250256,7.04296999 7.96210472,6.98885293 8.08566794,6.87546446 C8.35853704,6.63064828 8.37913091,6.21317288 8.13457854,5.94516378 L7.25419094,4.96332288 C7.13320179,4.82674082 6.96587677,4.75458452 6.79855108,4.74685398 Z M24.1591833,4.87312734 C23.9017599,4.88343538 23.6649304,5.04578722 23.5696839,5.30091078 C23.4435466,5.64365369 23.6160204,6.02247377 23.9558193,6.15132463 C24.4243295,6.32656135 24.8902656,6.52756786 25.3381826,6.75434479 C25.4334291,6.80330816 25.5363985,6.82650109 25.6367937,6.82650109 C25.8761973,6.82650109 26.1078787,6.69507404 26.2262931,6.46314275 C26.38847,6.13843974 26.2571839,5.74157977 25.9328308,5.57665108 C25.441152,5.32925806 24.9314534,5.10763547 24.4166066,4.91435951 C24.3316571,4.88343538 24.2441335,4.87055049 24.1591833,4.87312734 Z M4.08016028,7.62279788 C3.91283525,7.64856766 3.75838123,7.7387632 3.65026374,7.88565264 C3.43660218,8.17943219 3.50095785,8.59433074 3.79442083,8.80822279 L4.86272733,9.58390284 C4.97856834,9.66894402 5.11500256,9.7101762 5.24886271,9.7101762 C5.45222734,9.7101762 5.65301724,9.61483546 5.78430333,9.43959024 C5.99796489,9.14323385 5.93103448,8.73091214 5.63757217,8.51444325 L4.57183908,7.74134005 C4.42253385,7.63310593 4.24748596,7.59702745 4.08016028,7.62279788 Z M2.26532567,10.9574494 C2.01047637,10.9548725 1.76334993,11.101762 1.65265838,11.349155 C1.50592656,11.6841667 1.65265838,12.0732948 1.98730843,12.2227618 L3.19204981,12.75878 C3.27699936,12.7974353 3.3670977,12.8154739 3.45719605,12.8154739 C3.70947062,12.8154739 3.95144892,12.6685844 4.05956641,12.4211914 C4.20887229,12.0887572 4.05956641,11.6996284 3.72749042,11.552739 L2.52274904,11.0167208 C2.43779949,10.9780654 2.35284995,10.9600262 2.26532567,10.9574494 Z M27.0191571,13.1942946 C26.8518321,13.1942946 26.6819323,13.2587197 26.553221,13.3875706 L17.1340996,22.8168528 L12.3280051,18.0055737 C12.0705817,17.7478726 11.6535562,17.7478726 11.3961328,18.0055737 C11.1387095,18.2632748 11.1387095,18.6807502 11.3961328,18.9384512 L16.6681635,24.2161691 C16.7968748,24.3450199 16.9642005,24.409445 17.1340996,24.409445 C17.3039994,24.409445 17.4713244,24.3450199 17.6000358,24.2161691 L27.4850932,14.3204481 C27.7425166,14.062747 27.7425166,13.6452717 27.4850932,13.3875706 C27.3563819,13.2587197 27.1864821,13.1942946 27.0191571,13.1942946 Z M0.937021073,14.6425749 C0.684746498,14.6915377 0.473659004,14.8873905 0.417026192,15.1553996 C0.34237292,15.5110274 0.568905487,15.8615008 0.926724138,15.936234 L2.213841,16.2119743 C2.26017753,16.2197055 2.30651341,16.2248592 2.35284995,16.2248592 C2.6566092,16.2248592 2.9294783,16.0135446 2.99640805,15.7017258 C3.07106066,15.3460987 2.84452809,14.9956252 2.4867101,14.9208921 L1.19959324,14.6477286 C1.1094949,14.6271125 1.02197062,14.6271125 0.937021073,14.6425749 Z M0.659003831,18.4720125 C0.296037042,18.4720125 0,18.7683689 0,19.1317272 C0,19.4950855 0.296037042,19.7914419 0.659003831,19.7914419 L1.97701149,19.7914419 C2.33997828,19.7914419 2.63601533,19.4950855 2.63601533,19.1317272 C2.63601533,18.7683689 2.33997828,18.4720125 1.97701149,18.4720125 L0.659003831,18.4720125 Z M2.47641316,22.0489033 C2.39146296,22.0334415 2.30136527,22.0334415 2.213841,22.0514801 L0.924150069,22.3272204 C0.568905487,22.4019536 0.34237292,22.752427 0.417026192,23.1106317 C0.483955939,23.4198729 0.756825042,23.6311882 1.06058429,23.6311882 C1.10692083,23.6311882 1.15068264,23.6260338 1.19701851,23.6157258 L2.4867101,23.342563 C2.84452809,23.2678292 3.07106066,22.9173557 2.99640805,22.5617286 C2.93977523,22.2937195 2.72611367,22.0978666 2.47641316,22.0489033 Z M3.44689911,25.4479805 C3.36194956,25.4505574 3.27442529,25.4685966 3.19204981,25.5046744 L1.98730843,26.0406926 C1.65523244,26.1901596 1.50592656,26.5792884 1.65265838,26.9142994 C1.76077586,27.1591156 2.00275416,27.306005 2.25502874,27.306005 C2.34512708,27.306005 2.43522543,27.2853889 2.52274904,27.2467336 L3.72749042,26.7107154 C4.05956641,26.563826 4.20887229,26.1721203 4.06214113,25.8396861 C3.94887485,25.5897163 3.70432248,25.4428262 3.44689911,25.4479805 Z M5.35183206,28.5635862 C5.18450703,28.535239 5.00945914,28.5713174 4.86015326,28.6795516 L3.79442083,29.4552323 C3.50095785,29.6691237 3.43660218,30.0840229 3.65026374,30.3778017 C3.7789751,30.5556153 3.97976566,30.6483877 4.18570435,30.6483877 C4.31956451,30.6483877 4.45342466,30.609733 4.57183908,30.5221143 L5.63757217,29.7490111 C5.93103448,29.5325423 5.99796489,29.1202205 5.78430333,28.8238642 C5.67618518,28.6769747 5.51915709,28.5893567 5.35183206,28.5635862 Z M7.60943487,31.2204844 C7.44210984,31.2282156 7.27735888,31.3029487 7.15636973,31.4369533 L6.2734074,32.4187942 C6.03142976,32.6868033 6.0545977,33.1042794 6.32231801,33.3490949 C6.4484553,33.4624834 6.60805811,33.5191779 6.76508621,33.5191779 C6.9452829,33.5191779 7.12290486,33.4444448 7.25419094,33.3001322 L8.13457854,32.3182906 C8.37913091,32.0502815 8.35596297,31.6328061 8.08566794,31.3879899 C7.95180779,31.2668703 7.77933462,31.2127532 7.60943487,31.2204844 Z M10.6264368,33.3310563 C10.3690134,33.3001322 10.109016,33.4186743 9.97515582,33.6557593 L9.31615198,34.7999521 C9.13338123,35.1143477 9.24149937,35.5163614 9.55555556,35.6993286 C9.6585249,35.7586 9.77179119,35.7895242 9.88505747,35.7895242 C10.11159,35.7895242 10.3329745,35.670982 10.453963,35.4596668 L11.1129668,34.3154741 C11.2957375,34.0010791 11.1901941,33.5964879 10.8735632,33.4160975 C10.7937618,33.369711 10.7113863,33.3413643 10.6264368,33.3310563 Z M13.759279,34.7870672 C13.5018557,34.8102601 13.272749,34.9803431 13.1903736,35.240621 L12.7810702,36.4956254 C12.6703787,36.8409445 12.8582976,37.2146109 13.2032446,37.3254225 C13.272749,37.3486154 13.3422535,37.3589235 13.4091833,37.3589235 C13.6872005,37.3589235 13.9446239,37.1811099 14.0347222,36.9027928 L14.4440255,35.6477884 C14.5547178,35.3024693 14.3642241,34.9288029 14.0192771,34.8179913 C13.9317529,34.789644 13.8442293,34.779336 13.759279,34.7870672 Z M17.3889489,35.5343999 C17.0208333,35.4983221 16.7016284,35.7586 16.6630147,36.1219584 L16.5265805,37.4336573 C16.4879668,37.7970156 16.750539,38.1217186 17.1135057,38.160374 C17.1366737,38.160374 17.1598423,38.160374 17.1830102,38.160374 C17.5150862,38.160374 17.8008263,37.9104041 17.8368653,37.5702387 L17.9758742,36.2585404 C18.0144879,35.8977589 17.7519157,35.5730553 17.3889489,35.5343999 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(0.888889, 0.888889)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/permissions',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'permissions',
                            tabindex: '-1',
                            transform: 'translate(1074.000000, 247.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-1099.000000, -247.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-permissions',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Permissions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'A26508DB-C086-4D52-AF95-88D230B81ADA',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M19.1111111,0 C8.56244725,0 0,8.56244725 0,19.1111111 C0,29.659775 8.56244725,38.2222222 19.1111111,38.2222222 C29.659775,38.2222222 38.2222222,29.659775 38.2222222,19.1111111 C38.2222222,8.56244725 29.659775,0 19.1111111,0 Z M19.1111111,1.15824916 C29.0331442,1.15824916 37.0639731,9.18907857 37.0639731,19.1111111 C37.0639731,29.0331442 29.0331442,37.0639731 19.1111111,37.0639731 C9.18907857,37.0639731 1.15824916,29.0331442 1.15824916,19.1111111 C1.15824916,9.18907857 9.18907857,1.15824916 19.1111111,1.15824916 Z M19.1111111,2.8956229 C18.7921403,2.8956229 18.5319865,3.15577666 18.5319865,3.47474747 C18.5319865,3.79371829 18.7921403,4.05387205 19.1111111,4.05387205 C19.4300819,4.05387205 19.6902357,3.79371829 19.6902357,3.47474747 C19.6902357,3.15577666 19.4300819,2.8956229 19.1111111,2.8956229 Z M22.1763996,3.19423401 C21.893624,3.18744725 21.6493058,3.38425926 21.5927503,3.66251067 C21.5316712,3.97469472 21.7352694,4.28009259 22.0497161,4.34343434 C22.3619001,4.40451403 22.667298,4.20091526 22.7306397,3.88873121 C22.7917194,3.57428451 22.5881206,3.26888664 22.2759366,3.20554489 C22.2420034,3.20102077 22.2103328,3.19649607 22.1763996,3.19423401 Z M16.0639203,3.19649607 C16.025463,3.19649607 15.9870056,3.19875871 15.9485483,3.20554489 C15.6341016,3.26888664 15.4305028,3.57428451 15.4938446,3.88873121 C15.5232537,4.03803647 15.6114792,4.17150673 15.7404254,4.25747083 C15.8671089,4.34117228 16.0232009,4.37284287 16.1747688,4.34343434 C16.4892149,4.28009259 16.6928137,3.97695736 16.6294719,3.66251067 C16.575179,3.39330808 16.3399097,3.19875871 16.0639203,3.19649607 Z M13.1321021,4.08554322 C13.0551874,4.08554322 12.9782722,4.09911616 12.9058816,4.12852469 C12.6095331,4.25294613 12.4692761,4.59001459 12.5936975,4.88636364 C12.7158563,5.18271269 13.0529254,5.32296913 13.3492738,5.20081033 C13.6456229,5.07638889 13.7858799,4.73932043 13.6637205,4.44297138 C13.5732323,4.22806172 13.3651094,4.08780528 13.1321021,4.08554322 Z M25.1082177,4.08554322 C24.8684237,4.08101852 24.651252,4.22127554 24.5585017,4.44297138 C24.4363429,4.73932043 24.5765993,5.07638889 24.8729484,5.20081033 C25.1692974,5.32296913 25.5063659,5.18271269 25.6285247,4.88636364 C25.7529461,4.59001459 25.6126897,4.25294613 25.3163406,4.12852469 C25.2507368,4.10137822 25.1783462,4.08780528 25.1082177,4.08554322 Z M10.4310292,5.52882997 C10.3133945,5.52882997 10.1980219,5.56276319 10.1007469,5.628367 C9.83606902,5.80481931 9.76367845,6.16450954 9.94239282,6.43145006 C10.1188446,6.69612795 10.4785354,6.76851852 10.7454759,6.58980415 C11.0124158,6.41335242 11.0825443,6.05366162 10.906092,5.78898373 C10.7997688,5.628367 10.6210544,5.53109203 10.4310292,5.52882997 Z M27.8070286,5.52882997 C27.6102166,5.52656791 27.4247161,5.62384288 27.3161302,5.78898373 C27.1374158,6.05366162 27.2098064,6.41335242 27.4744843,6.58980415 C27.7414248,6.76851852 28.1011156,6.69612795 28.2775673,6.43145006 C28.3635314,6.30476656 28.395202,6.14641189 28.3657935,5.99710663 C28.336385,5.84553872 28.2481588,5.71206846 28.1192133,5.628367 C28.0264624,5.56502525 27.9201392,5.53109203 27.8070286,5.52882997 Z M8.0625,7.4743266 C7.90640797,7.4743266 7.75484007,7.53540629 7.64625421,7.64625421 C7.42003367,7.87021269 7.42003367,8.23895231 7.64625421,8.46291021 C7.87021269,8.68913075 8.23895231,8.68913075 8.46291021,8.46291021 C8.68913075,8.23895231 8.68913075,7.87021269 8.46291021,7.64625421 C8.35658699,7.53766835 8.21406791,7.47658866 8.0625,7.4743266 Z M30.1755578,7.4743266 C30.0194658,7.4743266 29.8678979,7.53540629 29.759312,7.64625421 C29.5330915,7.87021269 29.5330915,8.23895231 29.759312,8.46291021 C29.9832705,8.68913075 30.3520095,8.68913075 30.575968,8.46291021 C30.8021886,8.23895231 30.8021886,7.87021269 30.575968,7.64625421 C30.4696442,7.53766835 30.3271257,7.47658866 30.1755578,7.4743266 Z M32.1187924,9.84511785 C32.0011577,9.84285578 31.8880471,9.87678901 31.7907722,9.94239282 C31.5260943,10.1188446 31.4537037,10.4785354 31.6324181,10.7432132 C31.8088698,11.0101538 32.1685606,11.0825443 32.4332385,10.90383 C32.700179,10.7251156 32.7725696,10.3676874 32.5938552,10.1007469 C32.4875314,9.94239282 32.3088176,9.84511785 32.1187924,9.84511785 Z M6.11926543,9.84511785 C5.92245399,9.84059372 5.73695286,9.93786812 5.628367,10.1007469 C5.45191527,10.3676874 5.52204321,10.7273782 5.78898373,10.90383 C6.05592368,11.0825443 6.41335242,11.0101538 6.59206679,10.7454759 C6.76851852,10.4785354 6.69839001,10.1188446 6.43145006,9.94239282 C6.33869978,9.88131313 6.23237599,9.84737991 6.11926543,9.84511785 Z M19.1111111,9.84511785 C14.197601,9.84511785 10.1754001,13.6931291 9.87452637,18.5319865 L6.94949495,18.5319865 L10.7138047,22.2962963 L14.4781145,18.5319865 L11.6119001,18.5319865 C11.9082492,14.6500421 15.154514,11.5824916 19.1111111,11.5824916 C21.3348592,11.5824916 23.327862,12.5575022 24.7078075,14.0935399 L25.9339226,12.8674242 C24.2395309,11.0146779 21.8121846,9.84511785 19.1111111,9.84511785 Z M33.5620791,12.5484534 C33.4851644,12.5461914 33.4082492,12.5620264 33.3358586,12.5914355 C33.0395095,12.7135943 32.8992531,13.0529254 33.0214119,13.3470118 C33.1458333,13.6433608 33.4829018,13.7836173 33.7792508,13.6614585 C34.0755999,13.5392991 34.2158563,13.1999686 34.0936975,12.9036195 C34.0032093,12.6909725 33.7950864,12.5484534 33.5620791,12.5484534 Z M4.67824074,12.5484534 C4.43844726,12.5439287 4.22127554,12.6841858 4.13078733,12.9058816 C4.00862795,13.2022306 4.14888497,13.5392991 4.44297138,13.6637205 C4.73932043,13.7858799 5.07865095,13.6456229 5.20081033,13.3492738 C5.32296913,13.0529254 5.18271269,12.7158563 4.88636364,12.5936975 C4.82075982,12.564289 4.75063131,12.5507155 4.67824074,12.5484534 Z M34.4488636,15.4825337 C34.4104063,15.4802716 34.3719489,15.4847957 34.333491,15.4915825 C34.021307,15.5549242 33.8177082,15.8603221 33.8787879,16.1725062 C33.9421296,16.4869529 34.2475275,16.6905516 34.5597116,16.6294719 C34.8741582,16.5661302 35.077757,16.2607323 35.0166773,15.9462856 C34.9623844,15.6770836 34.724853,15.4825337 34.4488636,15.4825337 Z M3.79145623,15.4825337 C3.5086807,15.4757469 3.26436252,15.6702969 3.20780753,15.9462856 C3.17839842,16.0978535 3.20780753,16.2562082 3.29377104,16.3828917 C3.37973514,16.5118373 3.51320482,16.6000634 3.66477273,16.6294719 C3.81407857,16.6588805 3.9701706,16.6272099 4.09911616,16.5435079 C4.22579966,16.4575443 4.31402582,16.3240741 4.34343434,16.1725062 C4.40677609,15.8603221 4.2031779,15.5549242 3.89099327,15.4915825 C3.85706004,15.4870584 3.82538945,15.4825337 3.79145623,15.4825337 Z M27.5084175,15.9259259 L23.7441077,19.6902357 L26.6103221,19.6902357 C26.3139731,23.5721801 23.0677082,26.6397306 19.1111111,26.6397306 C16.8873631,26.6397306 14.8943603,25.66472 13.5144153,24.1286829 L12.2882997,25.354798 C13.9826914,27.2075443 16.4100382,28.3771044 19.1111111,28.3771044 C24.0246212,28.3771044 28.0468227,24.5290932 28.3476959,19.6902357 L31.2727273,19.6902357 L27.5084175,15.9259259 Z M3.47474747,18.5319865 C3.15577666,18.5319865 2.8956229,18.7921403 2.8956229,19.1111111 C2.8956229,19.4300819 3.15577666,19.6902357 3.47474747,19.6902357 C3.79371829,19.6902357 4.05387205,19.4300819 4.05387205,19.1111111 C4.05387205,18.7921403 3.79371829,18.5319865 3.47474747,18.5319865 Z M34.7474747,18.5319865 C34.4285039,18.5319865 34.1683502,18.7921403 34.1683502,19.1111111 C34.1683502,19.4300819 34.4285039,19.6902357 34.7474747,19.6902357 C35.0664456,19.6902357 35.3265993,19.4300819 35.3265993,19.1111111 C35.3265993,18.7921403 35.0664456,18.5319865 34.7474747,18.5319865 Z M3.77788329,21.5814394 C3.73942536,21.5814394 3.70096801,21.5859641 3.66251067,21.5927503 C3.34806397,21.656092 3.14446578,21.9614899 3.20780753,22.2759366 C3.27114928,22.5881206 3.57428451,22.7917194 3.88873121,22.7306397 C4.2031779,22.667298 4.40677609,22.3619001 4.34343434,22.0497161 C4.28914141,21.7782514 4.05387205,21.5837015 3.77788329,21.5814394 Z M34.4624372,21.5814394 C34.1796611,21.5746526 33.9353429,21.7714646 33.8787879,22.0497161 C33.8177082,22.3619001 34.021307,22.667298 34.333491,22.7306397 C34.6479377,22.7917194 34.9533356,22.5881206 35.0166773,22.2759366 C35.077757,21.9614899 34.8741582,21.656092 34.5597116,21.5927503 C34.528041,21.5882262 34.4963698,21.5837015 34.4624372,21.5814394 Z M33.5711279,24.5132576 C33.3313345,24.5087335 33.1141627,24.651252 33.0214119,24.8729484 C32.8992531,25.1670348 33.0395095,25.5063659 33.3358586,25.6285247 C33.6322076,25.7506841 33.9692761,25.610427 34.0936975,25.3163406 C34.2158563,25.0199916 34.0755999,24.6806611 33.7792508,24.5585017 C33.713647,24.5313552 33.6412565,24.5155196 33.5711279,24.5132576 Z M4.66919192,24.5155196 C4.59227723,24.5155196 4.51536195,24.5290932 4.44297138,24.5585017 C4.30271494,24.6173193 4.18960438,24.7304293 4.13078733,24.8729484 C4.0719697,25.0154675 4.0719697,25.1738215 4.12852469,25.3163406 C4.25294613,25.6126897 4.59001459,25.7529461 4.88636364,25.6285247 C5.02888272,25.5719697 5.1419927,25.4588597 5.20081033,25.3163406 C5.25962738,25.1738215 5.25962738,25.0154675 5.20081033,24.8729484 C5.11258418,24.6580387 4.90219922,24.5177823 4.66919192,24.5155196 Z M32.1233165,27.2188552 C31.9265045,27.2143311 31.7410039,27.3116055 31.6324181,27.4744843 C31.4537037,27.7414248 31.5260943,28.098853 31.7907722,28.2775673 C31.9174557,28.3635314 32.0758103,28.395202 32.2251156,28.3635314 C32.3766835,28.3341223 32.5101538,28.2458968 32.5938552,28.1169506 C32.7725696,27.8522727 32.700179,27.4925819 32.4332385,27.3161302 C32.3427503,27.2527884 32.2341644,27.2188552 32.1233165,27.2188552 Z M6.11700337,27.2188552 C5.99936869,27.2165932 5.88625871,27.2505264 5.78898373,27.3161302 C5.52430585,27.4948446 5.45191527,27.8522727 5.628367,28.1192133 C5.80708137,28.3838911 6.16677218,28.4562817 6.43371212,28.2775673 C6.69839001,28.1011156 6.77078058,27.7414248 6.59206679,27.4744843 C6.48574299,27.3161302 6.30702862,27.2211173 6.11700337,27.2188552 Z M8.0625,29.5896465 C7.90640797,29.5873844 7.75484007,29.6484641 7.64625421,29.759312 C7.42003367,29.9832705 7.42003367,30.3520095 7.64625421,30.575968 C7.87021269,30.8021886 8.23895231,30.8021886 8.46291021,30.575968 C8.68913075,30.3520095 8.68913075,29.9832705 8.46291021,29.759312 C8.35658699,29.6507262 8.21406791,29.5896465 8.0625,29.5896465 Z M30.1755578,29.5896465 C30.0194658,29.5873844 29.8678979,29.6484641 29.759312,29.759312 C29.5330915,29.9832705 29.5330915,30.3520095 29.759312,30.575968 C29.9832705,30.8021886 30.3520095,30.8021886 30.575968,30.575968 C30.8021886,30.3520095 30.8021886,29.9832705 30.575968,29.759312 C30.4696442,29.6507262 30.3271257,29.5896465 30.1755578,29.5896465 Z M10.4355533,31.532881 C10.2387419,31.5283563 10.0532407,31.6256313 9.94465488,31.7885101 C9.76594051,32.0554506 9.83833108,32.4151408 10.1052716,32.5938552 C10.3699495,32.7703075 10.7296403,32.697917 10.906092,32.4332385 C11.0848064,32.1662985 11.0124158,31.8088698 10.7477379,31.630156 C10.6549877,31.5690763 10.5464018,31.532881 10.4355533,31.532881 Z M27.8047666,31.532881 C27.6871319,31.530619 27.5740213,31.5645516 27.4767469,31.6278934 C27.3478008,31.7138575 27.2595752,31.8473277 27.2301661,31.9988951 C27.2007576,32.1482009 27.2324287,32.306555 27.3183923,32.4332385 C27.4948446,32.697917 27.8545348,32.7703075 28.1214753,32.5938552 C28.3861532,32.4151408 28.4585438,32.0554506 28.2798294,31.7885101 C28.1757682,31.630156 27.9970539,31.532881 27.8047666,31.532881 Z M13.1411509,32.9761678 C12.9013575,32.9716437 12.6841858,33.1141627 12.5936975,33.3358586 C12.4715382,33.6299456 12.6117952,33.9692761 12.9058816,34.0914355 C13.2022306,34.2135943 13.5415617,34.0733378 13.6637205,33.7792508 C13.7858799,33.4829018 13.6456229,33.1435713 13.3492738,33.0214119 C13.28367,32.9942654 13.2135415,32.9784304 13.1411509,32.9761678 Z M25.0991689,32.9761678 C25.0222536,32.9761678 24.9453389,32.9920034 24.8752104,33.0214119 C24.7326914,33.0802295 24.6195814,33.1933395 24.5607637,33.3335965 C24.5019467,33.4761156 24.5019467,33.6367318 24.5585017,33.7792508 C24.6829231,34.0733378 25.0199916,34.2135943 25.3163406,34.0914355 C25.4588597,34.0326178 25.5719697,33.9195079 25.6307873,33.7792508 C25.6896044,33.6367318 25.6896044,33.4761156 25.6307873,33.3358586 C25.5425612,33.1186869 25.3321762,32.9784304 25.0991689,32.9761678 Z M16.0774938,33.867477 C15.7947183,33.8606902 15.5481375,34.0575022 15.4938446,34.333491 C15.4305028,34.6479377 15.6341016,34.9510735 15.9485483,35.0144153 C16.2629944,35.077757 16.5661302,34.8741582 16.6294719,34.5597116 C16.6928137,34.2452654 16.4892149,33.9421296 16.1747688,33.8787879 C16.1430976,33.8720011 16.1091644,33.867477 16.0774938,33.867477 Z M22.162826,33.8697391 C22.1243687,33.867477 22.0859113,33.8720011 22.0497161,33.8787879 C21.7352694,33.9421296 21.5316712,34.2452654 21.5927503,34.5597116 C21.6244214,34.7112795 21.7126476,34.8424877 21.8393311,34.9284512 C21.9682767,35.0144153 22.1243687,35.0460859 22.2759366,35.0166773 C22.4252419,34.9850062 22.5587121,34.8967806 22.6446762,34.7700971 C22.7283777,34.6411509 22.7600483,34.4850589 22.7306397,34.333491 C22.6763468,34.064289 22.4388154,33.8697391 22.162826,33.8697391 Z M19.1111111,34.1683502 C18.7921403,34.1683502 18.5319865,34.4285039 18.5319865,34.7474747 C18.5319865,35.0664456 18.7921403,35.3265993 19.1111111,35.3265993 C19.4300819,35.3265993 19.6902357,35.0664456 19.6902357,34.7474747 C19.6902357,34.4285039 19.4300819,34.1683502 19.1111111,34.1683502 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(0.888889, 0.888889)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/change-requests',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'change-reqests',
                            tabindex: '-1',
                            transform: 'translate(960.000000, 247.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-985.000000, -247.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-change_requests',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Change Requests',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '69B0552F-D5B4-41EC-9DFA-0FF4A5FD7894',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M19.1111111,0 C8.57219861,0 0,8.57477267 0,19.1111111 C0,29.6474495 8.57219861,38.2222222 19.1111111,38.2222222 C29.6500243,38.2222222 38.2222222,29.6474495 38.2222222,19.1111111 C38.2222222,8.57477267 29.6500243,0 19.1111111,0 Z M19.1111111,1.31800766 C28.921516,1.31800766 36.9042146,9.30070625 36.9042146,19.1111111 C36.9042146,28.921516 28.921516,36.9042146 19.1111111,36.9042146 C9.30070625,36.9042146 1.31800766,28.921516 1.31800766,19.1111111 C1.31800766,9.30070625 9.30070625,1.31800766 19.1111111,1.31800766 Z M18.8227969,3.95917179 C14.9408525,4.03639847 11.1798972,5.60668136 8.39457598,8.39200192 C2.48413537,14.3024425 2.48413537,23.9172056 8.39457598,29.8276462 C8.523288,29.9563576 8.69061303,30.0207139 8.86051278,30.0207139 C9.03041188,30.0207139 9.1977369,29.9563576 9.32644892,29.8276462 C9.58387229,29.5702229 9.58387229,29.1531967 9.32644892,28.8957733 C3.93085505,23.5001794 3.92828098,14.7220428 9.32644892,9.32644892 C12.454143,6.19618072 16.9358838,4.74688697 21.3120811,5.44707854 C21.6698998,5.50628608 22.0071239,5.25915965 22.0663314,4.901341 C22.1229649,4.54094828 21.8784125,4.20114943 21.5205939,4.14451661 C20.6196124,4.00035952 19.7186303,3.93857792 18.8227969,3.95917179 Z M24.1566092,4.86530205 C23.9017599,4.87817306 23.6649304,5.04034995 23.5696839,5.29519859 C23.4409726,5.63757217 23.6134457,6.01598403 23.9558193,6.14469605 C24.4243295,6.31716987 24.8876916,6.52053384 25.3381826,6.74706641 C25.4334291,6.79597701 25.5363985,6.81914495 25.6367937,6.81914495 C25.8761973,6.81914495 26.1078787,6.68785952 26.2262931,6.45617816 C26.38847,6.13439911 26.2571839,5.73539272 25.9328308,5.57064176 C25.4385779,5.32351533 24.9288793,5.09955683 24.4166066,4.90648979 C24.3316571,4.87559899 24.2441335,4.86272733 24.1566092,4.86530205 Z M27.963901,7.03538058 C27.796576,7.05597445 27.6369732,7.14092466 27.5237069,7.28250702 C27.2997484,7.5708212 27.348659,7.98269859 27.6369732,8.20665709 C28.0745932,8.55160474 28.4993416,8.92744253 28.8957733,9.32644892 C34.2939419,14.7220428 34.2939419,23.5001794 28.8957733,28.8957733 C28.6383499,29.1557714 28.6383499,29.5702229 28.8957733,29.8302203 C29.0244853,29.9563576 29.1943844,30.023288 29.3642842,30.023288 C29.5316092,30.023288 29.701509,29.9563576 29.8302203,29.8302203 C35.7380869,23.9197797 35.7380869,14.3024425 29.8302203,8.39200192 C29.395175,7.95953065 28.9292388,7.54507919 28.450431,7.16924074 C28.3062739,7.05854918 28.1312261,7.01478671 27.963901,7.03538058 Z M19.1111111,10.5440613 C18.7481443,10.5440613 18.4521073,10.8375243 18.4521073,11.2030651 L18.4521073,18.4521073 L11.2030651,18.4521073 C10.8400983,18.4521073 10.5440613,18.7455703 10.5440613,19.1111111 C10.5440613,19.4766526 10.8400983,19.7701149 11.2030651,19.7701149 L18.4521073,19.7701149 L18.4521073,27.0191571 C18.4521073,27.3846986 18.7481443,27.6781609 19.1111111,27.6781609 C19.4740779,27.6781609 19.7701149,27.3846986 19.7701149,27.0191571 L19.7701149,19.7701149 L27.0191571,19.7701149 C27.3821239,19.7701149 27.6781609,19.4766526 27.6781609,19.1111111 C27.6781609,18.7455703 27.3821239,18.4521073 27.0191571,18.4521073 L19.7701149,18.4521073 L19.7701149,11.2030651 C19.7701149,10.8375243 19.4740779,10.5440613 19.1111111,10.5440613 Z M12.7681992,29.9151699 C12.5107759,29.884279 12.2507784,30.0026941 12.1169183,30.2395236 L11.4579144,31.3799093 C11.2751437,31.6965396 11.3806871,32.09812 11.697318,32.2808908 C11.8002874,32.3400983 11.9135536,32.3684151 12.0268199,32.3684151 C12.2533525,32.3684151 12.4747369,32.25 12.5957254,32.0389132 L13.2547292,30.8985275 C13.4375,30.5844706 13.3319566,30.1803161 13.0153257,29.9975453 C12.9355243,29.9537835 12.8505747,29.9254668 12.7681992,29.9151699 Z M25.454023,29.9151699 C25.3716475,29.9254668 25.286698,29.9537835 25.2068966,29.9975453 C24.8902656,30.1803161 24.7847222,30.5844706 24.967493,30.9011015 L25.6264968,32.0414872 C25.747486,32.2525741 25.9688697,32.3709891 26.1954023,32.3709891 C26.3086686,32.3709891 26.4219349,32.3400983 26.5249042,32.2808908 C26.8415351,32.09812 26.9470785,31.6965396 26.7643078,31.3824834 L26.105304,30.2420977 C25.9714438,30.0052682 25.7114464,29.884279 25.454023,29.9151699 Z M22.5296935,31.1997126 C22.4447439,31.1868416 22.3546456,31.1919898 22.2645472,31.2177324 C21.9144515,31.3104049 21.7059387,31.6733716 21.7986111,32.0234674 L22.140984,33.2977133 C22.2207854,33.5911756 22.4859317,33.7842433 22.7768199,33.7842433 C22.8334534,33.7842433 22.8900862,33.7790952 22.9492937,33.7636494 C23.2993895,33.6684029 23.5079023,33.3080102 23.4152299,32.9579144 L23.075431,31.6836686 C23.0033525,31.4185223 22.7819687,31.2357522 22.5296935,31.1997126 Z M15.6925287,31.1997126 C15.4402542,31.2357522 15.2188697,31.4185223 15.1467912,31.6836686 L14.8069923,32.9579144 C14.7117459,33.3080102 14.9202586,33.6684029 15.2729285,33.7636494 C15.3295619,33.7790952 15.3887695,33.7842433 15.4454023,33.7842433 C15.7337165,33.7842433 16.0014368,33.5911756 16.0812382,33.2977133 L16.421037,32.0234674 C16.5162835,31.6733716 16.3077708,31.3104049 15.957675,31.2177324 C15.8675766,31.1919898 15.7774783,31.1894157 15.6925287,31.1997126 Z M19.1111111,31.6321839 C18.7481443,31.6321839 18.4521073,31.9256469 18.4521073,32.2911877 L18.4521073,33.6091954 C18.4521073,33.9747369 18.7481443,34.2681992 19.1111111,34.2681992 C19.4740779,34.2681992 19.7701149,33.9747369 19.7701149,33.6091954 L19.7701149,32.2911877 C19.7701149,31.9256469 19.4740779,31.6321839 19.1111111,31.6321839 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(0.888889, 0.888889)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/add-new',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'add-new',
                            tabindex: '-1',
                            transform: 'translate(732.000000, 247.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-757.000000, -247.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-add_new',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Add New',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'D4A8CED9-9556-4B6B-AF72-62EC176544BB',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M19.1111111,0 C8.57363985,0 0,8.57363985 0,19.1111111 C0,29.6485824 8.57363985,38.2222222 19.1111111,38.2222222 C29.6485824,38.2222222 38.2222222,29.6485824 38.2222222,19.1111111 C38.2222222,8.57363985 29.6485824,0 19.1111111,0 Z M19.1111111,1.31800766 C28.9223602,1.31800766 36.9042146,9.29986207 36.9042146,19.1111111 C36.9042146,28.9223602 28.9223602,36.9042146 19.1111111,36.9042146 C9.29986207,36.9042146 1.31800766,28.9223602 1.31800766,19.1111111 C1.31800766,9.29986207 9.29986207,1.31800766 19.1111111,1.31800766 Z M18.9515083,3.29759336 C16.3825987,3.32613653 13.8413356,4.00290255 11.6033586,5.28104055 C11.2870367,5.4609486 11.1769521,5.86378512 11.3575192,6.17944795 C11.4787759,6.3929652 11.7009531,6.51281097 11.9302864,6.51281097 C12.040999,6.51281097 12.153122,6.4845977 12.2559266,6.42528736 C14.9809074,4.87135632 18.198978,4.28986782 21.3107941,4.78807471 C21.6686331,4.84474904 22.0083391,4.60215326 22.0663314,4.24233716 C22.1243238,3.88252107 21.8784639,3.54413289 21.5193068,3.48679955 C20.6670501,3.35038576 19.8078119,3.28807899 18.9515083,3.29759336 Z M24.1591833,4.20887216 C23.902666,4.21986929 23.6645805,4.3801719 23.5696839,4.63619489 C23.4411782,4.97821794 23.6144553,5.35787644 23.9558186,5.48440518 C24.423712,5.6597002 24.888711,5.86199329 25.3394697,6.08934961 C25.4350252,6.13745689 25.5359971,6.16014112 25.6355067,6.16014112 C25.8760431,6.16014112 26.1090214,6.0284537 26.2250061,5.79846136 C26.389098,5.47423148 26.257719,5.07701699 25.9328301,4.91292503 C25.4398959,4.66382158 24.9299706,4.43988384 24.4166066,4.24877273 C24.3315951,4.21714055 24.244689,4.20520645 24.1591833,4.20887216 Z M19.1111111,7.90804598 C15.8404751,7.90804598 13.1800766,10.5684444 13.1800766,13.8390805 L13.1800766,15.816092 L12.5210728,15.816092 C11.4310805,15.816092 10.5440613,16.7031111 10.5440613,17.7931034 L10.5440613,25.7011494 C10.5440613,26.7911418 11.4310805,27.6781609 12.5210728,27.6781609 L25.7011494,27.6781609 C26.7911418,27.6781609 27.6781609,26.7911418 27.6781609,25.7011494 L27.6781609,17.7931034 C27.6781609,16.7031111 26.7911418,15.816092 25.7011494,15.816092 L25.0421456,15.816092 L25.0421456,13.8390805 C25.0421456,10.5684444 22.3817471,7.90804598 19.1111111,7.90804598 Z M19.1111111,9.22605364 C21.6542069,9.22605364 23.7241379,11.2959847 23.7241379,13.8390805 L23.7241379,15.816092 L22.4061303,15.816092 L22.4061303,13.8390805 C22.4061303,12.0222069 20.9279847,10.5440613 19.1111111,10.5440613 C17.2942375,10.5440613 15.816092,12.0222069 15.816092,13.8390805 L15.816092,15.816092 L14.4980843,15.816092 L14.4980843,13.8390805 C14.4980843,11.2959847 16.5680153,9.22605364 19.1111111,9.22605364 Z M19.1111111,11.862069 C20.2011034,11.862069 21.0881226,12.7490881 21.0881226,13.8390805 L21.0881226,15.816092 L17.1340996,15.816092 L17.1340996,13.8390805 C17.1340996,12.7490881 18.0211188,11.862069 19.1111111,11.862069 Z M12.5210728,17.1340996 L13.1800766,17.1340996 L15.816092,17.1340996 L22.4061303,17.1340996 L25.0421456,17.1340996 L25.7011494,17.1340996 C26.0649195,17.1340996 26.3601533,17.4293333 26.3601533,17.7931034 L26.3601533,25.7011494 C26.3601533,26.0649195 26.0649195,26.3601533 25.7011494,26.3601533 L12.5210728,26.3601533 C12.1573027,26.3601533 11.862069,26.0649195 11.862069,25.7011494 L11.862069,17.7931034 C11.862069,17.4293333 12.1573027,17.1340996 12.5210728,17.1340996 Z M19.1111111,19.1111111 C18.0211188,19.1111111 17.1340996,19.9981303 17.1340996,21.0881226 L17.1340996,22.4061303 C17.1340996,23.4961226 18.0211188,24.3831418 19.1111111,24.3831418 C20.2011034,24.3831418 21.0881226,23.4961226 21.0881226,22.4061303 L21.0881226,21.0881226 C21.0881226,19.9981303 20.2011034,19.1111111 19.1111111,19.1111111 Z M19.1111111,20.4291188 C19.4748812,20.4291188 19.7701149,20.7243525 19.7701149,21.0881226 L19.7701149,22.4061303 C19.7701149,22.7699004 19.4748812,23.0651341 19.1111111,23.0651341 C18.747341,23.0651341 18.4521073,22.7699004 18.4521073,22.4061303 L18.4521073,21.0881226 C18.4521073,20.7243525 18.747341,20.4291188 19.1111111,20.4291188 Z M12.7669122,30.5741737 C12.51197,30.5423563 12.252045,30.6617803 12.1156312,30.8985275 L11.4566274,32.0389132 C11.2747423,32.3545753 11.3823142,32.7580096 11.697318,32.9398946 C11.8007816,32.999864 11.9135022,33.0274189 12.0255329,33.0274189 C12.2535482,33.0274189 12.4750967,32.9094566 12.5970124,32.697917 L13.2560163,31.5575313 C13.4385603,31.2425275 13.3309885,30.8403803 13.0153257,30.6578362 C12.93641,30.6122002 12.8518927,30.5847797 12.7669122,30.5741737 Z M25.454023,30.5741737 C25.3691868,30.5848107 25.285318,30.6120354 25.2068966,30.6578362 C24.8912337,30.8397213 24.7836619,31.2438145 24.9662059,31.5588183 L25.6252098,32.699204 C25.7477845,32.9107443 25.968674,33.0287059 26.1966893,33.0287059 C26.30872,33.0287059 26.4214406,32.999864 26.5249042,32.9398946 C26.840567,32.7580096 26.9481389,32.355204 26.7655948,32.0402002 L26.106591,30.8998145 C25.9696829,30.6630674 25.7085322,30.5422634 25.454023,30.5741737 Z M15.6951028,31.8600035 C15.4409336,31.8954045 15.2187564,32.0774543 15.1480782,32.3413854 L14.8069923,33.6156312 C14.7127548,33.9668803 14.9216794,34.3284157 15.2729285,34.4226533 C15.3302618,34.4378103 15.3874409,34.4445342 15.4441153,34.4445342 C15.734736,34.4445342 16.0015297,34.2512918 16.0799512,33.9567171 L16.4223241,32.6837583 C16.5165616,32.3325093 16.307637,31.9696868 15.9563879,31.8754492 C15.8689052,31.8520546 15.7798263,31.8482034 15.6951028,31.8600035 Z M22.5284065,31.8600035 C22.4435597,31.8482034 22.353976,31.8520546 22.2658343,31.8754492 C21.9145852,31.9696868 21.7056606,32.3318503 21.7998981,32.6837583 L22.1422711,33.9567171 C22.2206925,34.2512918 22.4868273,34.4445342 22.778107,34.4445342 C22.8347813,34.4445342 22.8919604,34.4378103 22.9492937,34.4226533 C23.3005428,34.3284157 23.5094674,33.9675393 23.4152299,33.6156312 L23.074144,32.3413854 C23.0034658,32.0774543 22.7829467,31.8954045 22.5284065,31.8600035 Z M19.1111111,32.2911877 C18.746682,32.2911877 18.4521073,32.5857625 18.4521073,32.9501916 L18.4521073,34.2681992 C18.4521073,34.6326284 18.746682,34.9272031 19.1111111,34.9272031 C19.4755402,34.9272031 19.7701149,34.6326284 19.7701149,34.2681992 L19.7701149,32.9501916 C19.7701149,32.5857625 19.4755402,32.2911877 19.1111111,32.2911877 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(0.888889, 0.888889)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/security',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'sign-in-security',
                            tabindex: '-1',
                            transform: 'translate(618.000000, 247.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-643.000000, -247.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-security',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Sign In / Security',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '6CF12BCA-479C-4D33-A1FB-DDDC5F4D6564',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M19.1111111,0 C8.57219861,0 0,8.57219861 0,19.1111111 C0,29.6500243 8.57219861,38.2222222 19.1111111,38.2222222 C29.6500243,38.2222222 38.2222222,29.6500243 38.2222222,19.1111111 C38.2222222,8.57219861 29.6500243,0 19.1111111,0 Z M19.1111111,1.31800766 C28.921516,1.31800766 36.9042146,9.30070625 36.9042146,19.1111111 C36.9042146,28.921516 28.921516,36.9042146 19.1111111,36.9042146 C9.30070625,36.9042146 1.31800766,28.921516 1.31800766,19.1111111 C1.31800766,9.30070625 9.30070625,1.31800766 19.1111111,1.31800766 Z M18.8227969,3.95917179 C14.9382784,4.03639847 11.1798972,5.60925543 8.39457598,8.39200192 C5.53202809,11.2571239 3.95402299,15.0618416 3.95402299,19.1111111 C3.95402299,23.1603806 5.52945402,26.9650983 8.39200192,29.8302203 C8.52071393,29.9563576 8.69061303,30.023288 8.85793805,30.023288 C9.02783781,30.023288 9.1977369,29.9563576 9.32644892,29.8302203 C9.58387229,29.5702229 9.58387229,29.1557714 9.32644892,28.8957733 C9.02268901,28.5945881 8.7420977,28.2805319 8.47180333,27.9561782 C8.47952619,27.9433072 8.49497126,27.9330102 8.50269413,27.9175645 C9.98030395,24.8773946 12.5931513,22.7819687 15.5972823,22.0997963 C16.5806392,23.0780051 17.7905294,23.7241379 19.1111111,23.7241379 C20.4316928,23.7241379 21.6441571,23.0780051 22.62494,22.0997963 C25.631645,22.779394 28.2444923,24.8773946 29.7221028,27.9175645 C29.729825,27.9330102 29.740122,27.9458812 29.7478448,27.9587522 C29.4775505,28.2805319 29.1969591,28.5971622 28.8957733,28.8957733 C28.6383499,29.1557714 28.6383499,29.5702229 28.8957733,29.8302203 C29.0244853,29.9563576 29.1943844,30.023288 29.3642842,30.023288 C29.5316092,30.023288 29.701509,29.9563576 29.8302203,29.8302203 C32.6927682,26.9650983 34.2681992,23.1603806 34.2681992,19.1111111 C34.2681992,15.0618416 32.6927682,11.2571239 29.8302203,8.39200192 C29.3926009,7.95695658 28.9292388,7.54507919 28.450431,7.16924074 C28.1621169,6.9452829 27.7476654,6.99676757 27.5237069,7.28250702 C27.2997484,7.56824713 27.348659,7.98269859 27.6369732,8.20665709 C28.0745932,8.55160474 28.4993416,8.92744253 28.8957733,9.32644892 C31.5111948,11.9392963 32.9501916,15.4145115 32.9501916,19.1111111 C32.9501916,21.8887095 32.1367337,24.5401699 30.6230843,26.7951986 C29.0399304,23.891463 26.4965875,21.8269278 23.559387,20.9748563 C24.4783882,19.6285319 25.0421456,17.9810223 25.0421456,16.4750958 L25.0421456,15.1570881 C25.0421456,11.8878116 22.3803883,9.22605364 19.1111111,9.22605364 C15.8418346,9.22605364 13.1800766,11.8878116 13.1800766,15.1570881 L13.1800766,16.4750958 C13.1800766,17.9810223 13.7412599,19.6285319 14.6628352,20.9748563 C11.7256347,21.8269278 9.17971776,23.891463 7.59913793,26.7951986 C6.08548851,24.5401699 5.27203065,21.8887095 5.27203065,19.1111111 C5.27203065,15.4145115 6.71102746,11.9392963 9.32644892,9.32644892 C12.454143,6.19618072 16.9333097,4.74688697 21.3120811,5.44707854 C21.6750479,5.50628608 22.0096986,5.25915965 22.0663314,4.901341 C22.1229649,4.54094828 21.8784125,4.20114943 21.5205939,4.14451661 C20.6196124,4.00035952 19.7186303,3.93857792 18.8227969,3.95917179 Z M24.1591833,4.86787612 C23.9017599,4.87817306 23.6649304,5.04034995 23.5696839,5.29519859 C23.4409726,5.63499744 23.6134457,6.01598403 23.9558193,6.14469605 C24.4243295,6.31974394 24.8902656,6.52310857 25.3381826,6.74706641 C25.4334291,6.79597701 25.5363985,6.81914495 25.6367937,6.81914495 C25.8761973,6.81914495 26.1078787,6.68785952 26.2262931,6.45617816 C26.38847,6.13182504 26.2571839,5.73539272 25.9328308,5.57064176 C25.441152,5.32351533 24.9314534,5.10213156 24.4166066,4.90906386 C24.3342312,4.87817306 24.2441335,4.86530205 24.1591833,4.86787612 Z M19.1111111,10.5440613 C21.654454,10.5440613 23.7241379,12.6137452 23.7241379,15.1570881 L23.7241379,16.4750958 C23.7241379,19.0905172 21.5514847,22.4061303 19.1111111,22.4061303 C16.6707375,22.4061303 14.4980843,19.0905172 14.4980843,16.4750958 L14.4980843,15.1570881 C14.4980843,12.6137452 16.5677682,10.5440613 19.1111111,10.5440613 Z M12.7681992,29.9151699 C12.5107759,29.884279 12.2507784,30.0026941 12.1169183,30.2395236 L11.4579144,31.3824834 C11.2751437,31.6965396 11.3832618,32.09812 11.697318,32.2808908 C11.8002874,32.3400983 11.9135536,32.3709891 12.0268199,32.3709891 C12.2533525,32.3709891 12.4747369,32.2525741 12.5957254,32.0414872 L13.2547292,30.8985275 C13.4375,30.5844706 13.3319566,30.1803161 13.0153257,29.9975453 C12.9355243,29.9537835 12.8531488,29.9254668 12.7681992,29.9151699 Z M25.454023,29.9151699 C25.3690734,29.9254668 25.286698,29.9537835 25.2068966,29.9975453 C24.8902656,30.1803161 24.7847222,30.5844706 24.967493,30.9011015 L25.6264968,32.0414872 C25.747486,32.2525741 25.9688697,32.3709891 26.1954023,32.3709891 C26.3086686,32.3709891 26.4219349,32.3426724 26.5249042,32.2808908 C26.8415351,32.1006948 26.9470785,31.6965396 26.7643078,31.3824834 L26.105304,30.2420977 C25.9688697,30.0052682 25.7088723,29.884279 25.454023,29.9151699 Z M15.6925287,31.1997126 C15.4402542,31.2357522 15.2188697,31.4185223 15.1467912,31.6836686 L14.8069923,32.9579144 C14.7117459,33.3080102 14.9228327,33.6684029 15.2729285,33.7636494 C15.3295619,33.7790952 15.3887695,33.7868174 15.4454023,33.7868174 C15.7362905,33.7868174 16.0014368,33.5911756 16.0812382,33.2977133 L16.421037,32.0234674 C16.5162835,31.6733716 16.3077708,31.3104049 15.957675,31.2177324 C15.8675766,31.1919898 15.7774783,31.1868416 15.6925287,31.1997126 Z M22.5296935,31.1997126 C22.4447439,31.1868416 22.3546456,31.1919898 22.2645472,31.2177324 C21.9144515,31.3104049 21.7059387,31.6733716 21.7986111,32.0234674 L22.140984,33.2977133 C22.2207854,33.5911756 22.4859317,33.7868174 22.7768199,33.7868174 C22.8334534,33.7868174 22.8900862,33.7790952 22.9492937,33.7636494 C23.2993895,33.6684029 23.5079023,33.3080102 23.4152299,32.9579144 L23.075431,31.6836686 C23.0033525,31.4185223 22.7819687,31.2357522 22.5296935,31.1997126 Z M19.1111111,31.6321839 C18.7481443,31.6321839 18.4521073,31.928221 18.4521073,32.2911877 L18.4521073,33.6091954 C18.4521073,33.9721622 18.7481443,34.2681992 19.1111111,34.2681992 C19.4740779,34.2681992 19.7701149,33.9721622 19.7701149,33.6091954 L19.7701149,32.2911877 C19.7701149,31.928221 19.4740779,31.6321839 19.1111111,31.6321839 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(0.888889, 0.888889)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/profile',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'profile',
                            tabindex: '-1',
                            transform: 'translate(504.000000, 247.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-529.000000, -247.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-profile_product',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-group': 'null',
                'data-title': 'Profile',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: '9801E2A6-A598-4133-9673-545CB8D7E87C',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'path',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [],
                                      attributes: {
                                        d: 'M16.5878136,0 C11.6633065,0 7.65591398,3.98070988 7.65591398,8.87242798 L7.65591398,10.1399177 C7.65591398,12.3555493 8.53066212,15.088574 10.0159892,17.321534 L3.50148394,21.0695411 C1.34078213,22.3122748 0,24.6244536 0,27.1024949 L0,32.3209877 C0,33.3681522 0.859794867,34.2222222 1.91397849,34.2222222 L31.2616487,34.2222222 C32.3158324,34.2222222 33.1756272,33.3681522 33.1756272,32.3209877 L33.1756272,30.4197531 L37.6415771,30.4197531 C38.6957607,30.4197531 39.5555556,29.565683 39.5555556,28.5185185 L39.5555556,26.2608025 C39.5555556,23.8867347 38.356827,21.7008105 36.3506388,20.4085648 L30.5015403,16.6481801 C30.698421,16.4402326 30.8878251,16.217432 31.0697526,15.9872045 C31.0722446,15.9822531 31.0722446,15.9773023 31.0772293,15.9723508 C32.3831208,14.2939175 33.1756272,12.1476018 33.1756272,10.1399177 L33.1756272,8.87242798 C33.1756272,4.67881976 29.7414318,1.26748971 25.5197133,1.26748971 C24.345906,1.26748971 23.2393872,1.53980227 22.2425234,2.01263487 C20.7023691,0.757523465 18.7335628,0 16.5878136,0 Z M16.5878136,1.26748971 C20.8095321,1.26748971 24.2437276,4.67881976 24.2437276,8.87242798 L24.2437276,10.1399177 C24.2437276,14.6107899 20.6400653,20.2798354 16.5878136,20.2798354 C12.5355626,20.2798354 8.93189964,14.6107899 8.93189964,10.1399177 L8.93189964,8.87242798 C8.93189964,4.67881976 12.3660957,1.26748971 16.5878136,1.26748971 Z M25.5197133,2.53497942 C29.0386425,2.53497942 31.8996416,5.37692901 31.8996416,8.87242798 L31.8996416,10.1399177 C31.8996416,12.0188723 31.0871979,14.0389341 29.7788137,15.5366512 C29.7339551,15.591114 29.6915886,15.6480515 29.6442374,15.6975629 C29.4573253,15.9005596 29.2629371,16.0961294 29.0585797,16.2768456 C28.7146621,16.5813403 28.3508065,16.84375 27.9794748,17.056649 C27.6729391,17.2299383 27.5682687,17.618602 27.7427195,17.9230967 C27.8623432,18.1260934 28.0766692,18.2399691 28.2984713,18.2399691 C28.4056343,18.2399691 28.5152893,18.2127378 28.6149757,18.1533242 C28.9264955,17.9775595 29.2255546,17.7621851 29.5221217,17.5294816 L35.6578181,21.4755339 C37.2976594,22.5301246 38.2795699,24.3199588 38.2795699,26.2608025 L38.2795699,28.5185185 C38.2795699,28.8675731 37.9929714,29.1522634 37.6415771,29.1522634 L33.1756272,29.1522634 L33.1756272,27.8847737 C33.5295142,27.8847737 33.8136201,27.6025595 33.8136201,27.2510288 L33.8136201,25.9835391 C33.8136201,25.6320091 33.5295142,25.3497942 33.1756272,25.3497942 C33.0983701,25.3497942 33.0236057,25.3695988 32.9538252,25.3943547 C32.4927759,23.5970936 31.3264452,22.0201583 29.6741433,21.0695411 L23.1596381,17.321534 C24.6449651,15.088574 25.5197133,12.3555493 25.5197133,10.1399177 L25.5197133,8.87242798 C25.5197133,6.60233426 24.6499498,4.53523663 23.2344032,2.96325216 C23.9446685,2.69094023 24.7122536,2.53497942 25.5197133,2.53497942 Z M10.7736057,18.3513694 C12.3012993,20.2253733 14.3049955,21.5473251 16.5878136,21.5473251 C18.8706317,21.5473251 20.874328,20.2253733 22.4020216,18.3513694 L29.0361505,22.1662169 C30.8030914,23.183674 31.8996416,25.0750063 31.8996416,27.1024949 L31.8996416,32.3209877 C31.8996416,32.6700423 31.6130431,32.9547325 31.2616487,32.9547325 L1.91397849,32.9547325 C1.56258416,32.9547325 1.27598566,32.6700423 1.27598566,32.3209877 L1.27598566,27.1024949 C1.27598566,25.0750063 2.37502784,23.183674 4.14196941,22.1662169 L10.7736057,18.3513694 Z M14.6738351,25.3497942 C14.3199488,25.3497942 14.0358423,25.6320091 14.0358423,25.9835391 C14.0358423,26.3350698 14.3199488,26.617284 14.6738351,26.617284 L18.5017921,26.617284 C18.8556791,26.617284 19.1397849,26.3350698 19.1397849,25.9835391 C19.1397849,25.6320091 18.8556791,25.3497942 18.5017921,25.3497942 L14.6738351,25.3497942 Z M36.3655914,25.3497942 C36.0117051,25.3497942 35.7275986,25.6320091 35.7275986,25.9835391 L35.7275986,27.2510288 C35.7275986,27.6025595 36.0117051,27.8847737 36.3655914,27.8847737 C36.7194784,27.8847737 37.0035842,27.6025595 37.0035842,27.2510288 L37.0035842,25.9835391 C37.0035842,25.6320091 36.7194784,25.3497942 36.3655914,25.3497942 Z M3.82795699,29.1522634 C3.47407066,29.1522634 3.18996416,29.4344782 3.18996416,29.7860082 L3.18996416,31.0534979 C3.18996416,31.4050286 3.47407066,31.6872428 3.82795699,31.6872428 C4.18184396,31.6872428 4.46594982,31.4050286 4.46594982,31.0534979 L4.46594982,29.7860082 C4.46594982,29.4344782 4.18184396,29.1522634 3.82795699,29.1522634 Z M7.01792115,29.1522634 C6.66403482,29.1522634 6.37992832,29.4344782 6.37992832,29.7860082 L6.37992832,31.0534979 C6.37992832,31.4050286 6.66403482,31.6872428 7.01792115,31.6872428 C7.37180811,31.6872428 7.65591398,31.4050286 7.65591398,31.0534979 L7.65591398,29.7860082 C7.65591398,29.4344782 7.37180811,29.1522634 7.01792115,29.1522634 Z M10.2078853,29.1522634 C9.85399897,29.1522634 9.56989247,29.4344782 9.56989247,29.7860082 L9.56989247,31.0534979 C9.56989247,31.4050286 9.85399897,31.6872428 10.2078853,31.6872428 C10.5617723,31.6872428 10.8458781,31.4050286 10.8458781,31.0534979 L10.8458781,29.7860082 C10.8458781,29.4344782 10.5617723,29.1522634 10.2078853,29.1522634 Z M13.3978495,29.1522634 C13.0439631,29.1522634 12.7598566,29.4344782 12.7598566,29.7860082 L12.7598566,31.0534979 C12.7598566,31.4050286 13.0439631,31.6872428 13.3978495,31.6872428 C13.7517364,31.6872428 14.0358423,31.4050286 14.0358423,31.0534979 L14.0358423,29.7860082 C14.0358423,29.4344782 13.7517364,29.1522634 13.3978495,29.1522634 Z M16.5878136,29.1522634 C16.2339273,29.1522634 15.9498208,29.4344782 15.9498208,29.7860082 L15.9498208,31.0534979 C15.9498208,31.4050286 16.2339273,31.6872428 16.5878136,31.6872428 C16.9417006,31.6872428 17.2258065,31.4050286 17.2258065,31.0534979 L17.2258065,29.7860082 C17.2258065,29.4344782 16.9417006,29.1522634 16.5878136,29.1522634 Z M19.7777778,29.1522634 C19.4238914,29.1522634 19.1397849,29.4344782 19.1397849,29.7860082 L19.1397849,31.0534979 C19.1397849,31.4050286 19.4238914,31.6872428 19.7777778,31.6872428 C20.1316647,31.6872428 20.4157706,31.4050286 20.4157706,31.0534979 L20.4157706,29.7860082 C20.4157706,29.4344782 20.1316647,29.1522634 19.7777778,29.1522634 Z M22.9677419,29.1522634 C22.6138556,29.1522634 22.3297491,29.4344782 22.3297491,29.7860082 L22.3297491,31.0534979 C22.3297491,31.4050286 22.6138556,31.6872428 22.9677419,31.6872428 C23.3216289,31.6872428 23.6057348,31.4050286 23.6057348,31.0534979 L23.6057348,29.7860082 C23.6057348,29.4344782 23.3216289,29.1522634 22.9677419,29.1522634 Z M26.1577061,29.1522634 C25.8038198,29.1522634 25.5197133,29.4344782 25.5197133,29.7860082 L25.5197133,31.0534979 C25.5197133,31.4050286 25.8038198,31.6872428 26.1577061,31.6872428 C26.5115931,31.6872428 26.7956989,31.4050286 26.7956989,31.0534979 L26.7956989,29.7860082 C26.7956989,29.4344782 26.5115931,29.1522634 26.1577061,29.1522634 Z M29.3476703,29.1522634 C28.9937839,29.1522634 28.7096774,29.4344782 28.7096774,29.7860082 L28.7096774,31.0534979 C28.7096774,31.4050286 28.9937839,31.6872428 29.3476703,31.6872428 C29.7015572,31.6872428 29.9856631,31.4050286 29.9856631,31.0534979 L29.9856631,29.7860082 C29.9856631,29.4344782 29.7015572,29.1522634 29.3476703,29.1522634 Z',
                                        id: 'Shape',
                                        tabindex: '-1',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Shape-2',
                                    tabindex: '-1',
                                    transform: 'translate(0.000000, 3.111111)',
                                  },
                                },
                              ],
                              attributes: {
                                id: 'Icon/Product/people/multiple',
                                tabindex: '-1',
                                transform: 'translate(25.000000, 0.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'multiple-users',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 247.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        fill: 'var(--icon-color)',
                        tabindex: '-1',
                        'fill-rule': 'nonzero',
                        transform: 'translate(-415.000000, -247.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-multiple',
                viewBox: '0 0 40 40',
                'data-set': 'product',
                tabindex: '-1',
                'data-title': 'Multiple People',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'title',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: '',
                      type: 'text',
                      value: 'D74348F3-F164-432F-927D-EB56DD7A5BC1',
                      parent: null,
                      children: [],
                      attributes: {},
                    },
                  ],
                  attributes: { tabindex: '-1' },
                },
                {
                  name: 'g',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [
                    {
                      name: 'g',
                      type: 'element',
                      value: '',
                      parent: null,
                      children: [
                        {
                          name: 'g',
                          type: 'element',
                          value: '',
                          parent: null,
                          children: [
                            {
                              name: 'g',
                              type: 'element',
                              value: '',
                              parent: null,
                              children: [
                                {
                                  name: 'g',
                                  type: 'element',
                                  value: '',
                                  parent: null,
                                  children: [
                                    {
                                      name: 'g',
                                      type: 'element',
                                      value: '',
                                      parent: null,
                                      children: [
                                        {
                                          name: 'path',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            d: 'M2,17 L17,17 L17,20 L2,20 L2,17 Z M20.5,17 L22,17 L22,20 L20.5,20 L20.5,17 Z M18,17 L19.5,17 L19.5,20 L18,20 L18,17 Z M18.85,8.73 C19.47,8.12 19.85,7.28 19.85,6.35 C19.85,4.5 18.35,3 16.5,3 L16.5,4.5 C17.52,4.5 18.35,5.33 18.35,6.35 C18.35,7.37 17.52,8.2 16.5,8.2 L16.5,9.7 C18.74,9.7 20.5,11.53 20.5,13.77 L20.5,16 L22,16 L22,13.76 C22,11.54 20.72,9.62 18.85,8.73 Z M16.03,11.2 L14.5,11.2 C13.48,11.2 12.65,10.22 12.65,9.2 C12.65,8.18 13.48,7.45 14.5,7.45 L14.5,5.95 C12.65,5.95 11.15,7.45 11.15,9.3 C11.15,11.15 12.65,12.65 14.5,12.65 L16.03,12.65 C17.08,12.65 18,13.39 18,14.7 L18,16 L19.5,16 L19.5,14.36 C19.5,12.55 17.9,11.2 16.03,11.2 L16.03,11.2 Z',
                                            id: 'Shape',
                                            fill: 'var(--icon-color)',
                                            tabindex: '-1',
                                            'fill-rule': 'nonzero',
                                          },
                                        },
                                        {
                                          name: 'polygon',
                                          type: 'element',
                                          value: '',
                                          parent: null,
                                          children: [],
                                          attributes: {
                                            id: 'Path',
                                            points: '0 0 24 0 24 24 0 24',
                                            tabindex: '-1',
                                          },
                                        },
                                      ],
                                      attributes: {
                                        id: 'icon',
                                        tabindex: '-1',
                                        transform:
                                          'translate(33.000000, 0.000000)',
                                      },
                                    },
                                  ],
                                  attributes: {
                                    id: 'Portal/Styleguide/syetem-icon-Copy-19',
                                    tabindex: '-1',
                                    transform:
                                      'translate(684.000000, 0.000000)',
                                  },
                                },
                              ],
                              attributes: {
                                id: '8',
                                tabindex: '-1',
                                transform: 'translate(0.000000, 706.000000)',
                              },
                            },
                          ],
                          attributes: {
                            id: 'Features',
                            tabindex: '-1',
                            transform: 'translate(390.000000, 1597.000000)',
                          },
                        },
                      ],
                      attributes: {
                        id: 'Icons',
                        tabindex: '-1',
                        transform: 'translate(-1107.000000, -2303.000000)',
                      },
                    },
                  ],
                  attributes: {
                    id: 'Styleguide',
                    fill: 'none',
                    stroke: 'none',
                    tabindex: '-1',
                    'fill-rule': 'evenodd',
                    'stroke-width': '1',
                  },
                },
              ],
              attributes: {
                id: 'icon-smoking',
                title: 'Smoking',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
                'data-title': 'Smoking',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M11.98 3.804A1 1 0 0 1 12 4v15.56a1 1 0 0 1-1.196.981l-8-1.6a1 1 0 0 1-.804-.98V5.6a1 1 0 0 1 .804-.981l8-1.6a1 1 0 0 1 1.177.784zM20 4.78a2 2 0 0 1 2 2v10a2 2 0 0 1-1.85 1.995l-.15.005h-6v-2h2v-2h-2v-2h2v-2h-2v-2h2v-2h-2v-2h6zM10 5.22l-6 1.2v10.722l6 1.2V5.219zm10 9.561h-2v2h2v-2zM8.972 9L7.67 11.859 9 15l-.963-.1a.221.221 0 0 1-.152-.079.543.543 0 0 1-.093-.16L6.96 12.63a.885.885 0 0 1-.051.144l-.775 1.73a.428.428 0 0 1-.091.13.17.17 0 0 1-.143.046l-.9-.093 1.336-2.664-1.285-2.516.963-.1c.063-.006.109 0 .138.018.03.018.056.05.079.098L7 11.13c.006-.023.291-.639.855-1.85.047-.115.112-.177.193-.185L8.972 9zM20 10.78h-2v2h2v-2zm0-4h-2v2h2v-2z',
                    fill: 'var(--icon-color)',
                    tabindex: '-1',
                    'fill-rule': 'nonzero',
                  },
                },
              ],
              attributes: {
                id: 'icon-excel',
                viewbox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'documents',
                'data-title': 'Excel',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 11.524v2.619l3 1.857 1-2zM12 11.524v2.619l-3 1.857-1-2z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: { d: 'M11 9h2v5h-2z', tabindex: '-1' },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M16 15h6v6h-6zM2 15h6v6h-6z',
                    fill: 'none',
                    style: 'stroke: var(--color4, #0c2250)',
                    stroke: '#0c2250',
                    tabindex: '-1',
                    'stroke-width': '2',
                    'stroke-linecap': 'butt',
                    'stroke-linejoin': 'miter',
                    'stroke-miterlimit': '4',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M15 6c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z',
                    fill: 'none',
                    style: 'stroke: var(--color4, #0c2250)',
                    stroke: '#0c2250',
                    tabindex: '-1',
                    'stroke-width': '2',
                    'stroke-linecap': 'butt',
                    'stroke-linejoin': 'miter',
                    'stroke-miterlimit': '4',
                  },
                },
              ],
              attributes: {
                id: 'icon-hierarchy',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
                'data-title': 'Hierarchy',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 12l-1.41-1.41-5.59 5.58v-12.17h-2v12.17l-5.58-5.59-1.42 1.42 8 8z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-arrow_down',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
                'data-title': 'Arrow Down',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 11h-12.17l5.59-5.59-1.42-1.41-8 8 8 8 1.41-1.41-5.58-5.59h12.17z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-arrow_left',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
                'data-title': 'Arrow Left',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 4l-1.41 1.41 5.58 5.59h-12.17v2h12.17l-5.58 5.59 1.41 1.41 8-8z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-arrow_right',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
                'data-title': 'Arrow Right',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M4 12l1.41 1.41 5.59-5.58v12.17h2v-12.17l5.58 5.59 1.42-1.42-8-8z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-arrow_up',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
                'data-title': 'Arrow Up',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M14 5v2h-6.59l11.59 11.59-1.41 1.41-11.59-11.59v6.59h-2v-10z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-arrow_diagonal_left',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 7v4h-13.17l3.58-3.59-1.41-1.41-6 6 6 6 1.41-1.41-3.58-3.59h15.17v-6z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-arrow_return',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M7.41 8.84l4.59 4.58 4.59-4.58 1.41 1.41-6 6-6-6z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-chevron_down',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M15.41 7.41l-1.41-1.41-6 6 6 6 1.41-1.41-4.58-4.59z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-chevron_left',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M10 6l-1.41 1.41 4.58 4.59-4.58 4.59 1.41 1.41 6-6z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-chevron_right',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M16.59 16.25l-4.59-4.58-4.59 4.58-1.41-1.41 6-6 6 6z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-chevron_up',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: { d: 'M7 10l5 5 5-5z', tabindex: '-1' },
                },
              ],
              attributes: {
                id: 'icon-carat_down',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: { d: 'M14 7l-5 5 5 5v-10z', tabindex: '-1' },
                },
              ],
              attributes: {
                id: 'icon-carat_left',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: { d: 'M10 17l5-5-5-5v10z', tabindex: '-1' },
                },
              ],
              attributes: {
                id: 'icon-carat_right',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: { d: 'M7 15l5-5 5 5z', tabindex: '-1' },
                },
              ],
              attributes: {
                id: 'icon-carat_up',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M6 6h2v12h-2v-12zM9.5 12l8.5 6v-12l-8.5 6zM16 14.14l-3.030-2.14 3.030-2.14v4.28z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-playback',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M6 6h2v12h-2v-12zM9.5 12l8.5 6v-12l-8.5 6z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-playback_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M6 18l8.5-6-8.5-6v12zM8 9.86l3.030 2.14-3.030 2.14v-4.28zM16 6h2v12h-2v-12z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-playforward',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M6 18l8.5-6-8.5-6v12zM16 6v12h2v-12h-2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-playforward_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M11 12c2.21 0 4-1.79 4-4s-1.79-4-4-4c-2.21 0-4 1.79-4 4s1.79 4 4 4zM11 6c1.1 0 2 0.9 2 2s-0.9 2-2 2c-1.1 0-2-0.9-2-2s0.9-2 2-2zM5 18c0.2-0.63 2.57-1.68 4.96-1.94l2.040-2c-0.39-0.040-0.68-0.060-1-0.060-2.67 0-8 1.34-8 4v2h9l-2-2h-5zM20.6 12.5l-5.13 5.17-2.070-2.080-1.4 1.41 3.47 3.5 6.53-6.59-1.4-1.41z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-auths',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'people',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M9 17l3-2.94c-0.39-0.040-0.68-0.060-1-0.060-2.67 0-8 1.34-8 4v2h9l-3-3zM11 12c-2.21 0-4-1.79-4-4s1.79-4 4-4c2.21 0 4 1.79 4 4s-1.79 4-4 4zM15.47 20.5l-3.47-3.5 1.4-1.41 2.070 2.080 5.13-5.17 1.4 1.41-6.53 6.59z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-auths_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'people',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M17 3c-1.105 0-2 0.895-2 2v0 7l2-2h4c1.105 0 2-0.895 2-2v0-3c0-1.105-0.895-2-2-2v0h-4zM9.5 5c-1.93 0.008-3.492 1.57-3.5 3.499v0.001c0 1.921 1.579 3.5 3.5 3.5s3.5-1.579 3.5-3.5-1.579-3.5-3.5-3.5zM17 5h4v3h-4v-3zM9.5 7c0.84 0 1.5 0.66 1.5 1.5s-0.66 1.5-1.5 1.5-1.5-0.66-1.5-1.5 0.66-1.5 1.5-1.5zM9.5 14c-1.487 0-3.198 0.422-4.65 1.127-0.726 0.353-1.386 0.775-1.91 1.312-0.525 0.538-0.94 1.239-0.94 2.061v2.5h15v-2.5c0-0.822-0.415-1.523-0.94-2.060-0.524-0.538-1.184-0.96-1.91-1.313-1.452-0.705-3.163-1.127-4.65-1.127zM9.5 16c1.080 0 2.62 0.364 3.775 0.926 0.579 0.28 1.061 0.61 1.354 0.91s0.371 0.52 0.371 0.664v0.5h-11v-0.5c0-0.144 0.078-0.364 0.371-0.664s0.775-0.63 1.354-0.91c1.155-0.562 2.695-0.926 3.775-0.926z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-csr',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'people',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M17 3c-1.105 0-2 0.895-2 2v0 7l2-2h4c0.414 0 0.798-0.126 1.117-0.342 0.535-0.361 0.883-0.965 0.883-1.651 0-0.002 0-0.005-0-0.007v0-3c0-0.414-0.126-0.798-0.342-1.117-0.146-0.215-0.326-0.394-0.533-0.537l-0.007-0.004c-0.312-0.214-0.698-0.342-1.114-0.342-0.001 0-0.003 0-0.004 0h-4zM9.5 5c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5v0c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5v0zM9.5 14c-2.985 0-7.5 1.795-7.5 4.5v2.5h15v-2.5c0-2.705-4.515-4.5-7.5-4.5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-csr_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'people',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M22 3h-20c-1.1 0-2 0.9-2 2v14c0 1.1 0.9 2 2 2h20c1.1 0 1.99-0.9 1.99-2l0.010-14c0-1.1-0.9-2-2-2zM22 19h-20v-14h20v14zM9 12c1.65 0 3-1.35 3-3s-1.35-3-3-3c-1.65 0-3 1.35-3 3s1.35 3 3 3zM9 8c0.55 0 1 0.45 1 1s-0.45 1-1 1c-0.55 0-1-0.45-1-1s0.45-1 1-1zM15 16.59c0-2.5-3.97-3.58-6-3.58s-6 1.080-6 3.58v1.41h12v-1.41zM5.48 16c0.74-0.5 2.22-1 3.52-1s2.77 0.49 3.52 1h-7.040z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-id',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'people',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M22 3h-20c-1.1 0-2 0.9-2 2v14c0 1.1 0.9 2 2 2h20c1.1 0 1.99-0.9 1.99-2l0.010-14c0-1.1-0.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3c-1.66 0-3-1.34-3-3s1.34-3 3-3zM14 18h-12v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-id_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'people',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 6h-8l-2-2h-6c-1.1 0-1.99 0.9-1.99 2l-0.010 12c0 1.1 0.9 2 2 2h16c1.1 0 2-0.9 2-2v-10c0-1.1-0.9-2-2-2zM20 18h-16v-12h5.17l2 2h8.83v10zM15 13c1.1 0 2-0.9 2-2s-0.9-2-2-2c-1.1 0-2 0.9-2 2s0.9 2 2 2zM11 17h8v-1c0-1.33-2.67-2-4-2s-4 0.67-4 2v1z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-plans',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'people',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 6h-8l-2-2h-6c-1.1 0-1.99 0.9-1.99 2l-0.010 12c0 1.1 0.9 2 2 2h16c1.1 0 2-0.9 2-2v-10c0-1.1-0.9-2-2-2zM15 9c1.1 0 2 0.9 2 2s-0.9 2-2 2c-1.1 0-2-0.9-2-2s0.9-2 2-2zM19 17h-8v-1c0-1.33 2.67-2 4-2s4 0.67 4 2v1z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-plans_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'people',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M11.717 2c-5.364 0-9.717 4.353-9.717 9.717s4.353 9.717 9.717 9.717c5.364 0 9.717-4.353 9.717-9.717s-4.353-9.717-9.717-9.717zM6.926 17.819c0.418-0.875 2.964-1.73 4.79-1.73s4.382 0.855 4.79 1.73c-1.321 1.049-2.983 1.671-4.79 1.671s-3.469-0.622-4.79-1.671zM17.896 16.41c-1.389-1.691-4.761-2.264-6.18-2.264s-4.79 0.573-6.18 2.264c-0.991-1.302-1.594-2.925-1.594-4.693 0-4.285 3.488-7.773 7.773-7.773s7.773 3.488 7.773 7.773c0 1.768-0.602 3.391-1.594 4.693zM11.717 5.887c-1.885 0-3.401 1.516-3.401 3.401s1.516 3.401 3.401 3.401c1.885 0 3.401-1.516 3.401-3.401s-1.516-3.401-3.401-3.401zM11.717 10.745c-0.806 0-1.457-0.651-1.457-1.457s0.651-1.457 1.457-1.457c0.806 0 1.457 0.651 1.457 1.457s-0.651 1.457-1.457 1.457z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-profile',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'people',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10c5.52 0 10-4.48 10-10s-4.48-10-10-10zM12 5c1.66 0 3 1.34 3 3s-1.34 3-3 3c-1.66 0-3-1.34-3-3s1.34-3 3-3zM12 19.2c-2.5 0-4.71-1.28-6-3.22 0.030-1.99 4-3.080 6-3.080 1.99 0 5.97 1.090 6 3.080-1.29 1.94-3.5 3.22-6 3.22z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-profile_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'people',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M9 13.75c-2.34 0-7 1.17-7 3.5v1.75h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c0.84-0.58 2.87-1.25 4.66-1.25s3.82 0.67 4.66 1.25h-9.32zM9 12c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5zM9 7c0.83 0 1.5 0.67 1.5 1.5s-0.67 1.5-1.5 1.5c-0.83 0-1.5-0.67-1.5-1.5s0.67-1.5 1.5-1.5zM16.040 13.81c1.16 0.84 1.96 1.96 1.96 3.44v1.75h4v-1.75c0-2.020-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5c-0.54 0-1.040 0.13-1.5 0.35 0.63 0.89 1 1.98 1 3.15s-0.37 2.26-1 3.15c0.46 0.22 0.96 0.35 1.5 0.35z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-patients',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'people',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M16 11c1.66 0 2.99-1.34 2.99-3s-1.33-3-2.99-3c-1.66 0-3 1.34-3 3s1.34 3 3 3zM8 11c1.66 0 2.99-1.34 2.99-3s-1.33-3-2.99-3c-1.66 0-3 1.34-3 3s1.34 3 3 3zM8 13c-2.33 0-7 1.17-7 3.5v2.5h14v-2.5c0-2.33-4.67-3.5-7-3.5zM16 13c-0.29 0-0.62 0.020-0.97 0.050 1.16 0.84 1.97 1.97 1.97 3.45v2.5h6v-2.5c0-2.33-4.67-3.5-7-3.5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-patients_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'people',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 5.9c1.16 0 2.1 0.94 2.1 2.1s-0.94 2.1-2.1 2.1-2.1-0.94-2.1-2.1 0.94-2.1 2.1-2.1zM12 14.9c2.97 0 6.1 1.46 6.1 2.1v1.1h-12.2v-1.1c0-0.64 3.13-2.1 6.1-2.1zM12 4c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zM12 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-person',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'people',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zM12 14c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-person_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'people',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 5.5c-3.31 0-6 2.69-6 6s2.69 6 6 6c3.31 0 6-2.69 6-6s-2.69-6-6-6zM12 15.5c-2.21 0-4-1.79-4-4s1.79-4 4-4c2.21 0 4 1.79 4 4s-1.79 4-4 4zM3.55 18.54l1.79-1.8 1.41 1.41-1.79 1.8-1.41-1.41zM11 19.5h2v2.95h-2v-2.95zM20 10.5h3v2h-3v-2zM17.24 18.16l1.4-1.4 1.8 1.79-1.41 1.41-1.79-1.8zM19.226 3.050l1.407 1.407-1.789 1.789-1.407-1.407 1.789-1.789zM11 0.55h2v2.95h-2v-2.95zM1 10.5h3v2h-3v-2zM6.76 4.84l-1.42 1.41-1.79-1.79 1.41-1.41 1.8 1.79z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-benefits',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5h-3v2h3v-2zM13 0.55h-2v2.95h2v-2.95zM20.45 4.46l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zM17.24 18.16l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zM12 5.5c-3.31 0-6 2.69-6 6s2.69 6 6 6c3.31 0 6-2.69 6-6s-2.69-6-6-6zM11 22.45h2v-2.95h-2v2.95zM3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-benefits_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M6.54 5c0.060 0.89 0.21 1.76 0.45 2.59l-1.2 1.2c-0.41-1.2-0.67-2.47-0.76-3.79h1.51zM16.4 17.020c0.85 0.24 1.72 0.39 2.6 0.45v1.49c-1.32-0.090-2.59-0.35-3.8-0.75l1.2-1.19zM7.5 3h-3.5c-0.55 0-1 0.45-1 1 0 9.39 7.61 17 17 17 0.55 0 1-0.45 1-1v-3.49c0-0.55-0.45-1-1-1-1.24 0-2.45-0.2-3.57-0.57-0.1-0.040-0.21-0.050-0.31-0.050-0.26 0-0.51 0.1-0.71 0.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c0.28-0.28 0.36-0.67 0.25-1.020-0.37-1.12-0.57-2.32-0.57-3.57 0-0.55-0.45-1-1-1z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-phone',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c0.27-0.27 0.67-0.36 1.020-0.24 1.12 0.37 2.33 0.57 3.57 0.57 0.55 0 1 0.45 1 1v3.49c0 0.55-0.45 1-1 1-9.39 0-17-7.61-17-17 0-0.55 0.45-1 1-1h3.5c0.55 0 1 0.45 1 1 0 1.25 0.2 2.45 0.57 3.57 0.11 0.35 0.030 0.74-0.25 1.020l-2.2 2.2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-phone_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 4h-3.17l-1.83-2h-6l-1.83 2h-3.17c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h16c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM20 18h-16v-12h4.050l1.83-2h4.24l1.83 2h4.050v12zM12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM12 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-camera',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M15.2 13c0 1.767-1.433 3.2-3.2 3.2s-3.2-1.433-3.2-3.2c0-1.767 1.433-3.2 3.2-3.2s3.2 1.433 3.2 3.2z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M9 3l-1.83 2h-3.17c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h16c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2h-3.17l-1.83-2h-6zM12 18c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-camera_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M15 8v8h-10v-8h10zM16 6h-12c-0.55 0-1 0.45-1 1v10c0 0.55 0.45 1 1 1h12c0.55 0 1-0.45 1-1v-3.5l4 4v-11l-4 4v-3.5c0-0.55-0.45-1-1-1z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-video',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M17 10.5v-3.5c0-0.55-0.45-1-1-1h-12c-0.55 0-1 0.45-1 1v10c0 0.55 0.45 1 1 1h12c0.55 0 1-0.45 1-1v-3.5l4 4v-11l-4 4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-video_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M9.56 8l-2-2-4.15-4.14-1.41 1.41 2.73 2.73h-0.73c-0.55 0-1 0.45-1 1v10c0 0.55 0.45 1 1 1h12c0.21 0 0.39-0.080 0.55-0.18l3.18 3.18 1.41-1.41-11.58-11.59zM5 16v-8h1.73l8 8h-9.73zM15 8v2.61l6 6v-10.11l-4 4v-3.5c0-0.55-0.45-1-1-1h-5.61l2 2h2.61z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-video_off',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M21 6.5l-4 4v-3.5c0-0.55-0.45-1-1-1h-6.18l11.18 11.18v-10.68zM3.27 2l-1.27 1.27 2.73 2.73h-0.73c-0.55 0-1 0.45-1 1v10c0 0.55 0.45 1 1 1h12c0.21 0 0.39-0.080 0.54-0.18l3.19 3.18 1.27-1.27-17.73-17.73z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-video_off_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 3h-14c-1.1 0-1.99 0.9-1.99 2l-0.010 14c0 1.1 0.9 2 2 2h14c1.1 0 2-0.9 2-2v-14c0-1.1-0.9-2-2-2zM19 19h-14v-14h14v14zM10.5 17h3v-3.5h3.5v-3h-3.5v-3.5h-3v3.5h-3.5v3h3.5v3.5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-doctors',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 3h-14c-1.1 0-1.99 0.9-1.99 2l-0.010 14c0 1.1 0.9 2 2 2h14c1.1 0 2-0.9 2-2v-14c0-1.1-0.9-2-2-2zM18 14h-4v4h-4v-4h-4v-4h4v-4h4v4h4v4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-doctors_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M16.545 13c0.75 0 1.41-0.41 1.749-1.030l3.579-6.49c0.079-0.139 0.126-0.306 0.126-0.484 0-0.55-0.446-0.996-0.995-0.996h-14.795l-0.94-2h-3.268v2h2l3.598 7.59-1.35 2.44c-0.73 1.34 0.23 2.97 1.75 2.97h11.995v-2h-11.995l1.1-2h7.447zM7.158 6h12.146l-2.76 5h-7.016l-2.37-5zM7.998 18c-1.1 0-1.99 0.9-1.99 2s0.89 2 1.99 2 1.999-0.9 1.999-2-0.9-2-2-2zM17.994 18c-1.1 0-1.99 0.9-1.99 2s0.89 2 1.99 2 2-0.9 2-2-0.9-2-2-2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-cart',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M8 18c-1.1 0-1.99 0.9-1.99 2s0.89 2 1.99 2 2-0.9 2-2-0.9-2-2-2zM2 2v2h2l3.6 7.59-1.35 2.45c-0.16 0.28-0.25 0.61-0.25 0.96 0 1.1 0.9 2 2 2h12v-2h-11.58c-0.14 0-0.25-0.11-0.25-0.25l0.030-0.12 0.9-1.63h7.45c0.75 0 1.41-0.41 1.75-1.030l3.58-6.49c0.076-0.138 0.121-0.302 0.121-0.477 0-0.553-0.448-1.002-1.001-1.003h-14.79l-0.94-2h-3.27zM18 18c-1.1 0-1.99 0.9-1.99 2s0.89 2 1.99 2 2-0.9 2-2-0.9-2-2-2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-cart_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M4 4h16v12h-14.83l-1.17 1.17v-13.17zM4 2c-1.1 0-1.99 0.9-1.99 2l-0.010 18 4-4h14c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2h-16zM6 12h8v2h-8v-2zM6 9h12v2h-12v-2zM6 6h12v2h-12v-2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-chat',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 2h-16c-1.1 0-1.99 0.9-1.99 2l-0.010 18 4-4h14c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM6 9h12v2h-12v-2zM14 14h-8v-2h8v2zM18 8h-12v-2h12v2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-chat_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12.31 11.14c-1.77-0.45-2.34-0.94-2.34-1.67 0-0.84 0.79-1.43 2.1-1.43 1.38 0 1.9 0.66 1.94 1.64h1.71c-0.050-1.34-0.87-2.57-2.49-2.97v-1.71h-2.33v1.69c-1.51 0.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95 0.46 2.34 1.15 2.34 1.87 0 0.53-0.39 1.39-2.1 1.39-1.6 0-2.23-0.72-2.32-1.64h-1.72c0.1 1.7 1.36 2.66 2.86 2.97v1.7h2.34v-1.67c1.52-0.29 2.72-1.16 2.73-2.77-0.010-2.2-1.9-2.96-3.66-3.42zM12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10c5.52 0 10-4.48 10-10s-4.48-10-10-10zM12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8c4.41 0 8 3.59 8 8s-3.59 8-8 8z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-costs',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10c5.52 0 10-4.48 10-10s-4.48-10-10-10zM13.41 18.090v1.91h-2.67v-1.93c-1.71-0.36-3.16-1.46-3.27-3.4h1.96c0.1 1.050 0.82 1.87 2.65 1.87 1.96 0 2.4-0.98 2.4-1.59 0-0.83-0.44-1.61-2.67-2.14-2.48-0.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21v-1.93h2.67v1.95c1.86 0.45 2.79 1.86 2.85 3.39h-1.96c-0.050-1.11-0.64-1.87-2.22-1.87-1.5 0-2.4 0.68-2.4 1.64 0 0.84 0.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-0.010 1.83-1.38 2.83-3.12 3.16z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-costs_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 2h-14c-1.11 0-2 0.9-2 2v14c0 1.1 0.89 2 2 2h4l3 3 3-3h4c1.1 0 2-0.9 2-2v-14c0-1.1-0.9-2-2-2zM19 18h-4.83l-2.17 2.17-2.17-2.17h-4.83v-14h14v14zM11 15h2v2h-2v-2zM12 7c1.1 0 2 0.9 2 2 0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4s-4 1.79-4 4h2c0-1.1 0.9-2 2-2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-faq',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 2h-14c-1.11 0-2 0.9-2 2v14c0 1.1 0.89 2 2 2h4l3 3 3-3h4c1.1 0 2-0.9 2-2v-14c0-1.1-0.9-2-2-2zM13 18h-2v-2h2v2zM15.070 10.25l-0.9 0.92c-0.72 0.73-1.17 1.33-1.17 2.83h-2v-0.5c0-1.1 0.45-2.1 1.17-2.83l1.24-1.26c0.37-0.36 0.59-0.86 0.59-1.41 0-1.1-0.9-2-2-2s-2 0.9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 0.88-0.36 1.68-0.93 2.25z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-faq_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 4h-16c-1.1 0-1.99 0.9-1.99 2l-0.010 18 4-4h14c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM20 18h-14.83l-1.17 1.17v-13.17h16v12zM11 14h2v2h-2v-2zM11 8h2v4h-2v-4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-feedback',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 4h-16c-1.1 0-1.99 0.9-1.99 2l-0.010 18 4-4h14c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM13 16h-2v-2h2v2zM13 12h-2v-4h2v4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-feedback_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M17 20c-0.29 0-0.56-0.060-0.76-0.15-0.71-0.37-1.21-0.88-1.71-2.38-0.51-1.56-1.47-2.29-2.39-3-0.79-0.61-1.61-1.24-2.32-2.53-0.53-0.96-0.82-2.010-0.82-2.94 0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.070-7-7-7s-7 3.070-7 7c0 1.26 0.38 2.65 1.070 3.9 0.91 1.65 1.98 2.48 2.85 3.15 0.81 0.62 1.39 1.070 1.71 2.050 0.6 1.82 1.37 2.84 2.73 3.55 0.482 0.222 1.046 0.352 1.641 0.352 2.209 0 3.999-1.79 3.999-3.999 0-0.001 0-0.002 0-0.003v0h-2c0 1.1-0.9 2-2 2zM7.64 2.64l-1.42-1.42c-1.989 1.985-3.22 4.73-3.22 7.762 0 0.006 0 0.013 0 0.019v-0.001c0 3.040 1.23 5.79 3.22 7.78l1.41-1.41c-1.625-1.63-2.63-3.879-2.63-6.362 0-0.003 0-0.005 0-0.008v0c0-2.49 1.010-4.74 2.64-6.36zM11.5 9c0 1.381 1.119 2.5 2.5 2.5s2.5-1.119 2.5-2.5v0c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5v0z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-hearing',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M16 6c0 2.209-1.791 4-4 4s-4-1.791-4-4c0-2.209 1.791-4 4-4s4 1.791 4 4z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: { d: 'M11 9h2v5h-2z', tabindex: '-1' },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 11.524v2.619l-3 1.857-1-2zM12 11.524v2.619l3 1.857 1-2z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M1 14h8v8h-8zM15 14h8v8h-8z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-hierarchy_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 6.69l5 4.5v7.81h-2v-6h-6v6h-2v-7.81l5-4.5zM12 4l-10 9h3v8h6v-6h2v6h6v-8h3l-10-9z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-home',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M10 20v-6h4v6h5v-8h3l-10-9-10 9h3v8z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-home_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 11.5c1.381 0 2.5-1.119 2.5-2.5s-1.119-2.5-2.5-2.5c-1.381 0-2.5 1.119-2.5 2.5s1.119 2.5 2.5 2.5zM12 2c-3.87 0-7 3.13-7 7 0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88-2.080-2.67-5-7.030-5-9.88z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-location',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 2c-3.87 0-7 3.13-7 7 0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM12 11.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-location_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M21.41 11.58l-9-9c-0.36-0.36-0.86-0.58-1.41-0.58h-7c-1.1 0-2 0.9-2 2v7c0 0.55 0.22 1.050 0.59 1.42l9 9c0.36 0.36 0.86 0.58 1.41 0.58s1.050-0.22 1.41-0.59l7-7c0.37-0.36 0.59-0.86 0.59-1.41s-0.23-1.060-0.59-1.42zM13 20.010l-9-9.010v-7h7v-0.010l9 9-7 7.020zM8.9 12.55c0 0.57 0.23 1.070 0.6 1.45l3.5 3.5 3.5-3.5c0.37-0.37 0.6-0.89 0.6-1.45 0-1.13-0.92-2.050-2.050-2.050-0.57 0-1.080 0.23-1.45 0.6l-0.6 0.6-0.6-0.59c-0.37-0.38-0.89-0.61-1.45-0.61-1.13 0-2.050 0.92-2.050 2.050zM6.5 8c0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-coverage',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M21.41 11.58l-9-9c-0.36-0.36-0.86-0.58-1.41-0.58h-7c-1.1 0-2 0.9-2 2v7c0 0.55 0.22 1.050 0.59 1.42l9 9c0.36 0.36 0.86 0.58 1.41 0.58s1.050-0.22 1.41-0.59l7-7c0.37-0.36 0.59-0.86 0.59-1.41s-0.23-1.060-0.59-1.42zM5.5 7c-0.83 0-1.5-0.67-1.5-1.5s0.67-1.5 1.5-1.5c0.83 0 1.5 0.67 1.5 1.5s-0.67 1.5-1.5 1.5zM17.27 15.27l-4.27 4.27-4.27-4.27c-0.45-0.46-0.73-1.080-0.73-1.77 0-1.38 1.12-2.5 2.5-2.5 0.69 0 1.32 0.28 1.77 0.74l0.73 0.72 0.73-0.73c0.45-0.45 1.080-0.73 1.77-0.73 1.38 0 2.5 1.12 2.5 2.5 0 0.69-0.28 1.32-0.73 1.77z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-coverage_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M18.4 7.909h-8v1.636h8v9.818h-12.8v-9.818h1.6v3.273h1.6v-6.545h4.8v-3.273h-6.4v4.909h-1.6c-0.88 0-1.6 0.736-1.6 1.636v9.818c0 0.9 0.72 1.636 1.6 1.636h12.8c0.88 0 1.6-0.736 1.6-1.636v-9.818c0-0.9-0.72-1.636-1.6-1.636z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-order',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M18.4 7.909h-8v4.909h-1.6v-6.545h4.8v-3.273h-6.4v4.909h-1.6c-0.88 0-1.6 0.736-1.6 1.636v9.818c0 0.9 0.72 1.636 1.6 1.636h12.8c0.88 0 1.6-0.736 1.6-1.636v-9.818c0-0.9-0.72-1.636-1.6-1.636z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-order_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M4 2l0.004 5 8 4 8-4-0.004-5h-16zM12.004 11l-1.854 3.621-4.144 0.58 2.998 2.819-0.707 3.98 3.707-1.879 3.705 1.879-0.707-3.98 2.998-2.82-4.145-0.58-1.851-3.62zM6.002 4h2.998v3.262l-2.998-1.498v-1.764zM11 4h2v4.266l-0.996 0.498-1.004-0.502v-4.262zM15 4h3.002v1.764l-3.002 1.502v-3.266z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-medal',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M4 2l0.004 5 8 4 8-4-0.004-5h-16zM12.004 11l-1.854 3.621-4.144 0.58 2.998 2.819-0.707 3.98 3.707-1.879 3.705 1.879-0.707-3.98 2.998-2.82-4.145-0.58-1.851-3.62zM10 4h4v3.766l-1.996 0.998-2.004-1.002v-3.762z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-medal_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M22 6c0-1.1-0.9-2-2-2h-16c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h16c1.1 0 2-0.9 2-2v-12zM20 6l-8 5-8-5h16zM20 18h-16v-10l8 5 8-5v10z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-email',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 4h-16c-1.1 0-1.99 0.9-1.99 2l-0.010 12c0 1.1 0.9 2 2 2h16c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM20 8l-8 5-8-5v-2l8 5 8-5v2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-email_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 22c1.1 0 2-0.9 2-2h-4c0 1.1 0.9 2 2 2zM18 16v-5c0-3.070-1.63-5.64-4.5-6.32v-0.68c0-0.83-0.67-1.5-1.5-1.5s-1.5 0.67-1.5 1.5v0.68c-2.86 0.68-4.5 3.24-4.5 6.32v5l-2 2v1h16v-1l-2-2zM16 17h-8v-6c0-2.48 1.51-4.5 4-4.5s4 2.020 4 4.5v6z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-notification',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M18 15.5v-5c0-3.070-1.64-5.64-4.5-6.32v-0.68c0-0.83-0.67-1.5-1.5-1.5s-1.5 0.67-1.5 1.5v0.68c-2.87 0.68-4.5 3.24-4.5 6.32v5l-2 2v1h16v-1l-2-2zM12 21.5c1.1 0 2-0.9 2-2h-4c0 1.105 0.895 2 2 2v0z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-notification_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M7.263 11.1h-1.895v6.3h1.895v-6.3zM12.947 11.1h-1.895v6.3h1.895v-6.3zM21 19.2h-18v1.8h18v-1.8zM18.632 11.1h-1.895v6.3h1.895v-6.3zM12 5.034l4.936 2.466h-9.872l4.936-2.466zM12 3l-9 4.5v1.8h18v-1.8l-9-4.5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-payments',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M4.895 10.714v6h2.842v-6h-2.842zM10.579 10.714v6h2.842v-6h-2.842zM3 21h18v-2.571h-18v2.571zM16.263 10.714v6h2.842v-6h-2.842zM12 3l-9 4.286v1.714h18v-1.714l-9-4.286z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-payments_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M18.36 9l0.6 3h-13.92l0.6-3h12.72zM20 4h-16v2h16v-2zM20 7h-16l-1 5v2h1v6h10v-6h4v6h2v-6h1v-2l-1-5zM6 18v-4h6v4h-6z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-pharmacy',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 4h-16v2h16v-2zM21 14v-2l-1-5h-16l-1 5v2h1v6h10v-6h4v6h2v-6h1zM12 18h-6v-4h6v4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-pharmacy_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M21 6h-2.64l1.14-3.14-2.35-0.86-1.46 4h-12.69v2l2 6-2 6v2h18v-2l-2-6 2-6v-2zM17.1 14.63l1.79 5.37h-13.78l2-6-2-6h13.78l-2 6 0.21 0.63zM13 10h-2v3h-3v2h3v3h2v-3h3v-2h-3v-3z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-prescription',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M21 6h-2.64l1.14-3.14-2.35-0.86-1.46 4h-12.69v2l2 6-2 6v2h18v-2l-2-6 2-6v-2zM16 15h-3v3h-2v-3h-3v-2h3v-3h2v3h3v2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-prescription_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19.43 12.98c0.040-0.32 0.070-0.64 0.070-0.98s-0.030-0.66-0.070-0.98l2.11-1.65c0.19-0.15 0.24-0.42 0.12-0.64l-2-3.46c-0.090-0.16-0.26-0.25-0.44-0.25-0.060 0-0.12 0.010-0.17 0.030l-2.49 1c-0.52-0.4-1.080-0.73-1.69-0.98l-0.38-2.65c-0.030-0.24-0.24-0.42-0.49-0.42h-4c-0.25 0-0.46 0.18-0.49 0.42l-0.38 2.65c-0.61 0.25-1.17 0.59-1.69 0.98l-2.49-1c-0.060-0.020-0.12-0.030-0.18-0.030-0.17 0-0.34 0.090-0.43 0.25l-2 3.46c-0.13 0.22-0.070 0.49 0.12 0.64l2.11 1.65c-0.040 0.32-0.070 0.65-0.070 0.98s0.030 0.66 0.070 0.98l-2.11 1.65c-0.19 0.15-0.24 0.42-0.12 0.64l2 3.46c0.090 0.16 0.26 0.25 0.44 0.25 0.060 0 0.12-0.010 0.17-0.030l2.49-1c0.52 0.4 1.080 0.73 1.69 0.98l0.38 2.65c0.030 0.24 0.24 0.42 0.49 0.42h4c0.25 0 0.46-0.18 0.49-0.42l0.38-2.65c0.61-0.25 1.17-0.59 1.69-0.98l2.49 1c0.060 0.020 0.12 0.030 0.18 0.030 0.17 0 0.34-0.090 0.43-0.25l2-3.46c0.12-0.22 0.070-0.49-0.12-0.64l-2.11-1.65zM17.45 11.27c0.040 0.31 0.050 0.52 0.050 0.73s-0.020 0.43-0.050 0.73l-0.14 1.13 0.89 0.7 1.080 0.84-0.7 1.21-1.27-0.51-1.040-0.42-0.9 0.68c-0.43 0.32-0.84 0.56-1.25 0.73l-1.060 0.43-0.16 1.13-0.2 1.35h-1.4l-0.19-1.35-0.16-1.13-1.060-0.43c-0.43-0.18-0.83-0.41-1.23-0.71l-0.91-0.7-1.060 0.43-1.27 0.51-0.7-1.21 1.080-0.84 0.89-0.7-0.14-1.13c-0.030-0.31-0.050-0.54-0.050-0.74s0.020-0.43 0.050-0.73l0.14-1.13-0.89-0.7-1.080-0.84 0.7-1.21 1.27 0.51 1.040 0.42 0.9-0.68c0.43-0.32 0.84-0.56 1.25-0.73l1.060-0.43 0.16-1.13 0.2-1.35h1.39l0.19 1.35 0.16 1.13 1.060 0.43c0.43 0.18 0.83 0.41 1.23 0.71l0.91 0.7 1.060-0.43 1.27-0.51 0.7 1.21-1.070 0.85-0.89 0.7 0.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4c2.21 0 4-1.79 4-4s-1.79-4-4-4zM12 14c-1.1 0-2-0.9-2-2s0.9-2 2-2c1.1 0 2 0.9 2 2s-0.9 2-2 2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-settings',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19.14 12.936c0.036-0.3 0.060-0.612 0.060-0.936s-0.024-0.636-0.072-0.936l2.028-1.584c0.18-0.144 0.228-0.408 0.12-0.612l-1.92-3.324c-0.12-0.216-0.372-0.288-0.588-0.216l-2.388 0.96c-0.504-0.384-1.032-0.696-1.62-0.936l-0.36-2.544c-0.036-0.24-0.24-0.408-0.48-0.408h-3.84c-0.24 0-0.432 0.168-0.468 0.408l-0.36 2.544c-0.588 0.24-1.128 0.564-1.62 0.936l-2.388-0.96c-0.216-0.084-0.468 0-0.588 0.216l-1.92 3.324c-0.12 0.216-0.072 0.468 0.12 0.612l2.028 1.584c-0.048 0.3-0.084 0.624-0.084 0.936s0.024 0.636 0.072 0.936l-2.028 1.584c-0.18 0.144-0.228 0.408-0.12 0.612l1.92 3.324c0.12 0.216 0.372 0.288 0.588 0.216l2.388-0.96c0.504 0.384 1.032 0.696 1.62 0.936l0.36 2.544c0.048 0.24 0.24 0.408 0.48 0.408h3.84c0.24 0 0.444-0.168 0.468-0.408l0.36-2.544c0.588-0.24 1.128-0.564 1.62-0.936l2.388 0.96c0.216 0.084 0.468 0 0.588-0.216l1.92-3.324c0.12-0.216 0.072-0.468-0.12-0.612l-2.004-1.584zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6c1.98 0 3.6 1.62 3.6 3.6s-1.62 3.6-3.6 3.6z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-settings_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M15 4v7h-9.83l-1.17 1.17v-8.17h11zM16 2h-13c-0.55 0-1 0.45-1 1v14l4-4h10c0.55 0 1-0.45 1-1v-9c0-0.55-0.45-1-1-1zM21 6h-2v9h-13v2c0 0.55 0.45 1 1 1h11l4 4v-15c0-0.55-0.45-1-1-1z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-support',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M21 6h-2v9h-13v2c0 0.55 0.45 1 1 1h11l4 4v-15c0-0.55-0.45-1-1-1zM17 12v-9c0-0.55-0.45-1-1-1h-13c-0.55 0-1 0.45-1 1v14l4-4h10c0.55 0 1-0.45 1-1z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-support_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M18.92 6.010c-0.2-0.59-0.76-1.010-1.42-1.010h-2.5v-2h-6v2h-2.5c-0.66 0-1.21 0.42-1.42 1.010l-2.080 5.99v8c0 0.55 0.45 1 1 1h1c0.55 0 1-0.45 1-1v-1h12v1c0 0.55 0.45 1 1 1h1c0.55 0 1-0.45 1-1v-8l-2.080-5.99zM6.85 7h10.29l1.040 3h-12.37l1.040-3zM19 17h-14v-4.66l0.12-0.34h13.77l0.11 0.34v4.66z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M9 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M18 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-taxi',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M18.92 6.010c-0.2-0.59-0.76-1.010-1.42-1.010h-2.5v-2h-6v2h-2.5c-0.66 0-1.21 0.42-1.42 1.010l-2.080 5.99v8c0 0.55 0.45 1 1 1h1c0.55 0 1-0.45 1-1v-1h12v1c0 0.55 0.45 1 1 1h1c0.55 0 1-0.45 1-1v-8l-2.080-5.99zM6.5 16c-0.83 0-1.5-0.67-1.5-1.5s0.67-1.5 1.5-1.5 1.5 0.67 1.5 1.5-0.67 1.5-1.5 1.5zM17.5 16c-0.83 0-1.5-0.67-1.5-1.5s0.67-1.5 1.5-1.5 1.5 0.67 1.5 1.5-0.67 1.5-1.5 1.5zM5 11l1.5-4.5h11l1.5 4.5h-14z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-taxi_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c0.5 0.7 0.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1h-10c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h10c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM14 20h-10v-16h10v16zM7.8 16h2.4v-2.8h2.8v-2.4h-2.8v-2.8h-2.4v2.8h-2.8v2.4h2.8v2.8z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-telemedicine',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c0.5 0.7 0.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1c1.1 0 2 0.9 2 2v18c0 1.1-0.9 2-2 2h-10c-1.1 0-2-0.9-2-2v-18c0-1.1 0.9-2 2-2h10zM7.8 16h2.4v-2.8h2.8v-2.4h-2.8v-2.8h-2.4v2.8h-2.8v2.4h2.8v2.8z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-telemedicine_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 9c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zM12 3c1.1 0 2 0.9 2 2s-0.9 2-2 2-2-0.9-2-2 0.9-2 2-2zM12 11.55c-2.36-2.2-5.52-3.55-9-3.55v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55v-11c-3.48 0-6.64 1.35-9 3.55zM19 17.13c-2.53 0.34-4.93 1.3-7 2.82-2.060-1.52-4.47-2.49-7-2.83v-6.95c2.1 0.38 4.050 1.35 5.64 2.83l1.36 1.28 1.36-1.27c1.59-1.48 3.54-2.45 5.64-2.83v6.95z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-library',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 11.55c-2.36-2.2-5.52-3.55-9-3.55v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55v-11c-3.48 0-6.64 1.35-9 3.55zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-library_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M7.704 2l-0.875 0.697c-0.239 0.19-5.829 4.717-5.829 10.573 0 3.402 1.727 5.094 2.912 5.865-0.335 0.4-0.635 0.802-0.883 1.197-0.574 0.916-0.945 1.766-0.945 2.667h2.17c0-0.18 0.171-0.817 0.614-1.522 0.122-0.196 0.266-0.4 0.423-0.606 0.696 0.217 3.53 1.047 6.553 1.047 2.928 0 5.13-0.92 6.786-2.272 1.658-1.352 2.792-3.074 3.876-4.696l0.494-0.737-0.63-0.627s-3.477-3.56-8.357-3.56c-2.981 0-5.167 1.6-6.674 3.427 0.097-1.109 0.168-2.253 0.168-3.426h-2.17c0 2.55-0.319 5.179-0.705 6.938-0.69-0.622-1.463-1.737-1.463-3.695 0-3.543 2.694-6.667 4.134-8.083 0.555 0.902 1.335 2.332 1.847 3.94 0.572-0.328 1.236-0.617 1.932-0.83l0.070-0.019c-0.983-2.966-2.677-5.253-2.777-5.386l-0.671-0.892zM14.965 12c3.046 0 5.152 1.703 6.035 2.487-0.875 1.35-1.72 2.7-2.795 3.63-1.323 1.14-2.915 1.883-5.405 1.883-1.983 0-3.678-0.4-4.8-0.712 1.723-1.499 4.115-2.717 6.965-2.717v-2.285c-2.109 0-3.999 0.556-5.622 1.393 1.242-1.966 3.013-3.679 5.622-3.679z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-wellness',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M7.704 2l-0.875 0.697c-0.239 0.19-5.829 4.717-5.829 10.573 0 3.122 1.465 4.818 2.622 5.673-0.238 0.388-0.46 0.772-0.644 1.14-0.551 1.1-0.894 2.015-0.894 2.916h2.17c0-0.18 0.2-1.021 0.664-1.949 0.593-1.148 1.274-2.138 2.062-3.031l-0.014 0.016c1.538-1.751 3.59-3.241 5.963-3.6l0.072-0.010c0.331-0.047 0.669-0.074 1.012-0.074v2.162c-3.023 0-5.412 2.507-6.75 4.864 1.27 0.275 2.926 0.541 4.581 0.541 6.003 0 8.478-3.702 10.662-6.968l0.494-0.737-0.63-0.627c-0.145-0.146-3.624-3.56-8.357-3.56-3.003 0-5.16 1.554-6.674 3.4 0.1-1.010 0.161-2.193 0.168-3.389l0-0.011h-2.17c0 2.57-0.316 5.168-0.71 6.934-0.69-0.622-1.458-1.738-1.458-3.69 0-3.543 2.694-6.667 4.134-8.083 0.555 0.902 1.335 2.332 1.847 3.94 0.572-0.328 1.236-0.617 1.932-0.83l0.070-0.019c-0.983-2.966-2.677-5.253-2.777-5.386l-0.671-0.892z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-wellness_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'features',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M14 6v-2h-4v2h4zM4 8v11h16v-11h-16zM20 6c1.11 0 2 0.89 2 2v11c0 1.11-0.89 2-2 2h-16c-1.11 0-2-0.89-2-2l0.010-11c0-1.11 0.88-2 1.99-2h4v-2c0-1.11 0.89-2 2-2h4c1.11 0 2 0.89 2 2v2h4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-work',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'documents',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 7h-4v-2c0-1.11-0.89-2-2-2h-4c-1.11 0-2 0.89-2 2v2h-4c-1.11 0-1.99 0.89-1.99 2l-0.010 11c0 1.11 0.89 2 2 2h16c1.11 0 2-0.89 2-2v-11c0-1.11-0.89-2-2-2zM14 7h-4v-2h4v2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-work_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'documents',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M14 2h-8c-1.1 0-1.99 0.9-1.99 2l-0.010 16c0 1.1 0.89 2 1.99 2h12.010c1.1 0 2-0.9 2-2v-12l-6-6zM6 20v-16h7v5h5v11h-12z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-claims',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'documents',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M6 2c-1.1 0-1.99 0.9-1.99 2l-0.010 16c0 1.1 0.89 2 1.99 2h12.010c1.1 0 2-0.9 2-2v-12l-6-6h-8zM13 9v-5.5l5.5 5.5h-5.5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-claims_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'documents',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 6h-8l-2-2h-6c-1.1 0-1.99 0.9-1.99 2l-0.010 12c0 1.1 0.9 2 2 2h16c1.1 0 2-0.9 2-2v-10c0-1.1-0.9-2-2-2zM20 18h-16v-10h16v10z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-documents',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'documents',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M10 4h-6c-1.1 0-1.99 0.9-1.99 2l-0.010 12c0 1.1 0.9 2 2 2h16c1.1 0 2-0.9 2-2v-10c0-1.1-0.9-2-2-2h-8l-2-2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-documents_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'documents',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M7 15h7v2h-7v-2zM7 11h10v2h-10v-2zM7 7h10v2h-10v-2zM19 3h-4.18c-0.42-1.16-1.52-2-2.82-2s-2.4 0.84-2.82 2h-4.18c-0.14 0-0.27 0.010-0.4 0.040-0.39 0.080-0.74 0.28-1.010 0.55-0.18 0.18-0.33 0.4-0.43 0.64-0.1 0.23-0.16 0.49-0.16 0.77v14c0 0.27 0.060 0.54 0.16 0.78s0.25 0.45 0.43 0.64c0.27 0.27 0.62 0.47 1.010 0.55 0.13 0.020 0.26 0.030 0.4 0.030h14c1.1 0 2-0.9 2-2v-14c0-1.1-0.9-2-2-2zM12 2.75c0.41 0 0.75 0.34 0.75 0.75s-0.34 0.75-0.75 0.75c-0.41 0-0.75-0.34-0.75-0.75s0.34-0.75 0.75-0.75zM19 19h-14v-14h14v14z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-hra',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'documents',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 3h-4.18c-0.42-1.16-1.52-2-2.82-2s-2.4 0.84-2.82 2h-4.18c-1.1 0-2 0.9-2 2v14c0 1.1 0.9 2 2 2h14c1.1 0 2-0.9 2-2v-14c0-1.1-0.9-2-2-2zM12 3c0.55 0 1 0.45 1 1s-0.45 1-1 1c-0.55 0-1-0.45-1-1s0.45-1 1-1zM14 17h-7v-2h7v2zM17 13h-10v-2h10v2zM17 9h-10v-2h10v2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-hra_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'documents',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M21 4.5c-1.11-0.35-2.33-0.5-3.5-0.5-1.95 0-4.050 0.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5s-4.050 0.4-5.5 1.5v14.65c0 0.25 0.25 0.5 0.5 0.5 0.1 0 0.15-0.050 0.25-0.050 1.35-0.65 3.3-1.1 4.75-1.1 1.95 0 4.050 0.4 5.5 1.5 1.35-0.85 3.8-1.5 5.5-1.5 1.65 0 3.35 0.3 4.75 1.050 0.1 0.050 0.15 0.050 0.25 0.050 0.25 0 0.5-0.25 0.5-0.5v-14.6c-0.6-0.45-1.25-0.75-2-1zM21 18c-0.978-0.35-2.044-0.5-3.111-0.5-1.511 0-3.689 0.65-4.889 1.5v-11.5c1.2-0.85 3.378-1.5 4.889-1.5 1.067 0 2.133 0.15 3.111 0.5v11.5zM3 18v-11.5c0.978-0.35 2.044-0.5 3.111-0.5 1.511 0 3.689 0.65 4.889 1.5v11.5c-1.2-0.85-3.378-1.5-4.889-1.5-1.067 0-2.133 0.15-3.111 0.5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-healthwise',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'documents',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M21 5c-1.11-0.35-2.33-0.5-3.5-0.5-1.95 0-4.050 0.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5s-4.050 0.4-5.5 1.5v14.65c0 0.25 0.25 0.5 0.5 0.5 0.1 0 0.15-0.050 0.25-0.050 1.35-0.65 3.3-1.1 4.75-1.1 1.95 0 4.050 0.4 5.5 1.5 1.35-0.85 3.8-1.5 5.5-1.5 1.65 0 3.35 0.3 4.75 1.050 0.1 0.050 0.15 0.050 0.25 0.050 0.25 0 0.5-0.25 0.5-0.5v-14.6c-0.6-0.45-1.25-0.75-2-1zM21 18.5c-1.1-0.35-2.3-0.5-3.5-0.5-1.7 0-4.15 0.65-5.5 1.5v-11.5c1.35-0.85 3.8-1.5 5.5-1.5 1.2 0 2.4 0.15 3.5 0.5v11.5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-healthwise_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'documents',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 2h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM20 16h-12v-12h12v12zM4 6h-2v14c0 1.1 0.9 2 2 2h14v-2h-14v-14zM16 12v-3c0-0.55-0.45-1-1-1h-2v5h2c0.55 0 1-0.45 1-1zM14 9h1v3h-1v-3zM18 11h1v-1h-1v-1h1v-1h-2v5h1v-2zM10 11h1c0.55 0 1-0.45 1-1v-1c0-0.55-0.45-1-1-1h-2v5h1v-2zM10 9h1v1h-1v-1z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-pdf',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'documents',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 2h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM11.5 9.5c0 0.83-0.67 1.5-1.5 1.5h-1v2h-1.5v-6h2.5c0.83 0 1.5 0.67 1.5 1.5v1zM16.5 11.5c0 0.83-0.67 1.5-1.5 1.5h-2.5v-6h2.5c0.83 0 1.5 0.67 1.5 1.5v3zM20.5 8.5h-1.5v1h1.5v1.5h-1.5v2h-1.5v-6h3v1.5zM9 9.5h1v-1h-1v1zM4 6h-2v14c0 1.1 0.9 2 2 2h14v-2h-14v-14zM14 11.5h1v-3h-1v3z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-pdf_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'documents',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 0.79-0.71 1.57-1.5 1.57s-1.5-0.78-1.5-1.57v-1.43c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-0.56 3.54-1.47 0.65 0.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57v-1.43c0-5.52-4.48-10-10-10zM12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-send_to',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 13h-6v6h-2v-6h-6v-2h6v-6h2v6h6z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-add',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
                'data-title': 'Add',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20.54 5.23l-1.39-1.68c-0.27-0.34-0.68-0.55-1.15-0.55h-12c-0.47 0-0.88 0.21-1.16 0.55l-1.38 1.68c-0.29 0.34-0.46 0.79-0.46 1.27v12.5c0 1.1 0.9 2 2 2h14c1.1 0 2-0.9 2-2v-12.5c0-0.48-0.17-0.93-0.46-1.27zM6.24 5h11.52l0.81 0.97h-13.13l0.8-0.97zM5 19v-11h14v11h-14zM13.45 10h-2.9v3h-2.55l4 4 4-4h-2.55v-3z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-archive',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
                'data-title': 'Archive',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20.54 5.23l-1.39-1.68c-0.27-0.34-0.68-0.55-1.15-0.55h-12c-0.47 0-0.88 0.21-1.16 0.55l-1.38 1.68c-0.29 0.34-0.46 0.79-0.46 1.27v12.5c0 1.1 0.9 2 2 2h14c1.1 0 2-0.9 2-2v-12.5c0-0.48-0.17-0.93-0.46-1.27zM12 17.5l-5.5-5.5h3.5v-2h4v2h3.5l-5.5 5.5zM5.12 5l0.81-1h12l0.94 1h-13.75z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-archive_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
                'data-title': 'Archive - Active',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4v-12.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5v0 10.5c0 0.55-0.45 1-1 1s-1-0.45-1-1v-9.5h-1.5v9.5c0 1.381 1.119 2.5 2.5 2.5s2.5-1.119 2.5-2.5v0-10.5c0-2.21-1.79-4-4-4s-4 1.79-4 4v12.5c0 3.040 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5v-11.5h-1.5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-attachment',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 3h-1v-2h-2v2h-10v-2h-2v2h-1c-1.1 0-2 0.9-2 2v16c0 1.1 0.9 2 2 2h16c1.1 0 2-0.9 2-2v-16c0-1.1-0.9-2-2-2zM20 21h-16v-11h16v11zM20 8h-16v-3h16v3z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-calendar',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 3h-1v-2h-2v2h-10v-2h-2v2h-1c-1.1 0-2 0.9-2 2v16c0 1.1 0.9 2 2 2h16c1.1 0 2-0.9 2-2v-16c0-1.1-0.9-2-2-2zM20 21h-16v-13h16v13z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-calendar_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 5v14h-14v-14h14zM19 3h-14c-1.1 0-2 0.9-2 2v14c0 1.1 0.9 2 2 2h14c1.1 0 2-0.9 2-2v-14c0-1.1-0.9-2-2-2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-checkbox',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 3h-14c-1.11 0-2 0.9-2 2v14c0 1.1 0.89 2 2 2h14c1.11 0 2-0.9 2-2v-14c0-1.1-0.89-2-2-2zM10 17l-5-5 1.41-1.41 3.59 3.58 7.59-7.59 1.41 1.42-9 9z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-checkbox_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 3h-14c-1.1 0-2 0.9-2 2v14c0 1.1 0.9 2 2 2h14c1.1 0 2-0.9 2-2v-14c0-1.1-0.9-2-2-2zM17 13h-10v-2h10v2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-checkbox_all',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M20 5.611l-1.611-1.611-6.389 6.389-6.389-6.389-1.611 1.611 6.389 6.389-6.389 6.389 1.611 1.611 6.389-6.389 6.389 6.389 1.611-1.611-6.389-6.389z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-close',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M6 19c0 1.1 0.9 2 2 2h8c1.1 0 2-0.9 2-2v-12h-12v12zM8 9h8v10h-8v-10zM15.5 4l-1-1h-5l-1 1h-3.5v2h14v-2h-3.5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-trash',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M6 19c0 1.1 0.9 2 2 2h8c1.1 0 2-0.9 2-2v-12h-12v12zM19 4h-3.5l-1-1h-5l-1 1h-3.5v2h14v-2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-delete_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M22.425 10.576l-9.010-9.010c-0.75-0.75-2.070-0.76-2.83 0l-9 9c-0.78 0.78-0.78 2.040 0 2.82l9 9c0.39 0.39 0.9 0.58 1.41 0.58s1.020-0.19 1.41-0.58l8.99-8.99c0.79-0.76 0.8-2.020 0.030-2.82zM12.005 20.976l-9-9 9-9 9 9-9 9zM7.995 10.986v4h2v-3h4v2.5l3.5-3.5-3.5-3.5v2.5h-5c-0.55 0-1 0.45-1 1z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-directions',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M21.703 11.293l-9-9c-0.18-0.181-0.43-0.292-0.705-0.292s-0.525 0.112-0.705 0.292l-9 9c-0.181 0.18-0.292 0.43-0.292 0.705s0.112 0.525 0.292 0.705l9 9c0.39 0.39 1.020 0.39 1.41 0l9-9c0.181-0.18 0.292-0.43 0.292-0.705s-0.112-0.525-0.292-0.705l-0-0zM13.993 14.503v-2.5h-4v3h-2v-4c0-0.55 0.45-1 1-1h5v-2.5l3.5 3.5-3.5 3.5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-directions_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M17 1h-12c-1.1 0-2 0.9-2 2v14h2v-14h12v-2zM16 5h-7c-1.1 0-1.99 0.9-1.99 2l-0.010 14c0 1.1 0.89 2 1.99 2h11.010c1.1 0 2-0.9 2-2v-10l-6-6zM9 21v-14h6v5h5v9h-11z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-document_upload',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M17 1h-12c-1.1 0-2 0.9-2 2v14h2v-14h12v-2zM16 5l6 6v10c0 1.1-0.9 2-2 2h-11.010c-1.1 0-1.99-0.9-1.99-2l0.010-14c0-1.1 0.89-2 1.99-2h7zM15 12h5.5l-5.5-5.5v5.5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-document_upload_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M13 5v6h1.17l-2.17 2.17-2.17-2.17h1.17v-6h2zM15 3h-6v6h-4l7 7 7-7h-4v-6zM19 18h-14v2h14v-2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-download',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 9h-4v-6h-6v6h-4l7 7 7-7zM5 18v2h14v-2h-14z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-download_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M14.060 9.020l0.92 0.92-9.060 9.060h-0.92v-0.92l9.060-9.060zM17.66 3c-0.25 0-0.51 0.1-0.7 0.29l-1.83 1.83 3.75 3.75 1.83-1.83c0.39-0.39 0.39-1.020 0-1.41l-2.34-2.34c-0.2-0.2-0.45-0.29-0.71-0.29zM14.060 6.19l-11.060 11.060v3.75h3.75l11.060-11.060-3.75-3.75z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-edit',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M3 17.253v3.75h3.75l11.060-11.060-3.75-3.75-11.060 11.060zM20.71 7.043c0.39-0.39 0.39-1.020 0-1.41l-2.34-2.34c-0.39-0.39-1.020-0.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-edit_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M15 3l2.3 2.3-2.89 2.87 1.42 1.42 2.87-2.89 2.3 2.3v-6h-6zM3 9l2.3-2.3 2.87 2.89 1.42-1.42-2.89-2.87 2.3-2.3h-6v6zM9 21l-2.3-2.3 2.89-2.87-1.42-1.42-2.87 2.89-2.3-2.3v6h6zM21 15l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87-2.3 2.3h6v-6z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-enlarge',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 4.5c-5 0-9.27 3.11-11 7.5 1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-eye_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M4.915 4l-1.285 1.286 2.076 2.074c-2.616 2.136-3.706 5.010-3.706 5.010s2.727 7.273 10 7.273c1.887 0 3.46-0.496 4.766-1.222l2.319 2.32 1.285-1.286-15.455-15.455zM12 5.097c-0 0-0 0-0.001 0-1.066 0-2.093 0.17-3.054 0.485l0.069-0.020 2.328 2.328c0.215-0.032 0.432-0.065 0.657-0.065 2.51 0.001 4.544 2.035 4.545 4.545v0c0 0.225-0.033 0.442-0.065 0.657l3.118 3.118c1.679-1.865 2.402-3.775 2.402-3.775s-2.727-7.273-10-7.273zM8.213 9.868l1.33 1.33c-0.17 0.342-0.27 0.745-0.27 1.172v0c0 1.506 1.221 2.727 2.727 2.727v0c0.426-0 0.83-0.1 1.188-0.277l-0.016 0.007 1.33 1.33c-0.703 0.475-1.569 0.758-2.502 0.758v0c-2.51-0.001-4.544-2.035-4.545-4.545v-0c0-0.927 0.282-1.784 0.758-2.502z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-eye_active_hide',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M10.090 15.59l1.41 1.41 5-5-5-5-1.41 1.41 2.58 2.59h-9.67v2h9.67l-2.58 2.59zM19 3h-14c-1.11 0-2 0.9-2 2v4h2v-4h14v14h-14v-4h-2v4c0 1.1 0.89 2 2 2h14c1.1 0 2-0.9 2-2v-14c0-1.1-0.9-2-2-2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-exit',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M17 3h-10c-1.1 0-1.99 0.9-1.99 2l-0.010 16 7-3 7 3v-16c0-1.1-0.9-2-2-2zM17 18l-5-2.18-5 2.18v-13h10v13z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-bookmark',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M17 3h-10c-1.1 0-1.99 0.9-1.99 2l-0.010 16 7-3 7 3v-16c0-1.1-0.9-2-2-2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-bookmark_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M22 9.24l-7.19-0.62-2.81-6.62-2.81 6.63-7.19 0.61 5.46 4.73-1.64 7.030 6.18-3.73 6.18 3.73-1.63-7.030 5.45-4.73zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-0.38 1.7-4.030 1.71 4.040 4.38 0.38-3.32 2.88 1 4.28-3.77-2.28z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-star',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 17.27l6.18 3.73-1.64-7.030 5.46-4.73-7.19-0.61-2.81-6.63-2.81 6.63-7.19 0.61 5.46 4.73-1.64 7.030z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-star_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M16.5 3c-1.74 0-3.41 0.81-4.5 2.090-1.090-1.28-2.76-2.090-4.5-2.090-3.080 0-5.5 2.42-5.5 5.5 0 3.78 3.4 6.86 8.55 11.54l1.45 1.31 1.45-1.32c5.15-4.67 8.55-7.75 8.55-11.53 0-3.080-2.42-5.5-5.5-5.5zM12.1 18.55l-0.1 0.1-0.1-0.1c-4.76-4.31-7.9-7.16-7.9-10.050 0-2 1.5-3.5 3.5-3.5 1.54 0 3.040 0.99 3.57 2.36h1.87c0.52-1.37 2.020-2.36 3.56-2.36 2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.050z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-heart',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 21.35l-1.45-1.32c-5.15-4.67-8.55-7.75-8.55-11.53 0-3.080 2.42-5.5 5.5-5.5 1.74 0 3.41 0.81 4.5 2.090 1.090-1.28 2.76-2.090 4.5-2.090 3.080 0 5.5 2.42 5.5 5.5 0 3.78-3.4 6.86-8.55 11.54l-1.45 1.31z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-heart_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M3 17v2h6v-2h-6zM3 5v2h10v-2h-10zM13 21v-2h8v-2h-8v-2h-2v6h2zM7 9v2h-4v2h4v2h2v-6h-2zM21 13v-2h-10v2h10zM15 9h2v-2h4v-2h-4v-2h-2v6z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-tune',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M9 7h-2v2h2v-2zM9 11h-2v2h2v-2zM9 3c-1.11 0-2 0.9-2 2h2v-2zM13 15h-2v2h2v-2zM19 3v2h2c0-1.1-0.9-2-2-2zM13 3h-2v2h2v-2zM9 17v-2h-2c0 1.1 0.89 2 2 2zM19 13h2v-2h-2v2zM19 9h2v-2h-2v2zM19 17c1.1 0 2-0.9 2-2h-2v2zM5 7h-2v12c0 1.1 0.89 2 2 2h12v-2h-12v-12zM15 5h2v-2h-2v2zM15 17h2v-2h-2v2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-flip_back',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
                'data-title': 'Flip',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M3 13h2v-2h-2v2zM3 17h2v-2h-2v2zM5 21v-2h-2c0 1.105 0.895 2 2 2v0zM3 9h2v-2h-2v2zM15 21h2v-2h-2v2zM19 3h-10c-1.105 0-2 0.895-2 2v0 10c0 1.105 0.895 2 2 2v0h10c1.1 0 2-0.9 2-2v-10c0-1.1-0.9-2-2-2zM19 15h-10v-10h10v10zM11 21h2v-2h-2v2zM7 21h2v-2h-2v2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-flip_front',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M3 18h18v-2h-18v2zM3 13h18v-2h-18v2zM3 6v2h18v-2h-18z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-hamburger',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M11 18h2v-2h-2v2zM12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10c5.52 0 10-4.48 10-10s-4.48-10-10-10zM12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8c4.41 0 8 3.59 8 8s-3.59 8-8 8zM12 6c-2.21 0-4 1.79-4 4h2c0-1.1 0.9-2 2-2s2 0.9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-help',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10c5.52 0 10-4.48 10-10s-4.48-10-10-10zM13 19h-2v-2h2v2zM15.070 11.25l-0.9 0.92c-0.72 0.73-1.17 1.33-1.17 2.83h-2v-0.5c0-1.1 0.45-2.1 1.17-2.83l1.24-1.26c0.37-0.36 0.59-0.86 0.59-1.41 0-1.1-0.9-2-2-2s-2 0.9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 0.88-0.36 1.68-0.93 2.25z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-help_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M5.25 3c-1.241 0.004-2.246 1.009-2.25 2.25v0c0.004 1.241 1.009 2.246 2.25 2.25h0c1.241-0.004 2.246-1.009 2.25-2.25v-0c-0.004-1.241-1.009-2.246-2.25-2.25h-0zM5.25 9.75c-1.241 0.004-2.246 1.009-2.25 2.25v0c0.004 1.241 1.009 2.246 2.25 2.25h0c1.241-0.004 2.246-1.009 2.25-2.25v-0c-0.004-1.241-1.009-2.246-2.25-2.25h-0zM5.25 16.5c-1.241 0.004-2.246 1.009-2.25 2.25v0c0.004 1.241 1.009 2.246 2.25 2.25h0c1.241-0.004 2.246-1.009 2.25-2.25v-0c-0.004-1.241-1.009-2.246-2.25-2.25h-0zM18.75 7.5c1.241-0.004 2.246-1.009 2.25-2.25v-0c-0.004-1.241-1.009-2.246-2.25-2.25h-0c-1.241 0.004-2.246 1.009-2.25 2.25v0c0.004 1.241 1.009 2.246 2.25 2.25h0zM12 16.5c-1.241 0.004-2.246 1.009-2.25 2.25v0c0.004 1.241 1.009 2.246 2.25 2.25h0c1.241-0.004 2.246-1.009 2.25-2.25v-0c-0.004-1.241-1.009-2.246-2.25-2.25h-0zM18.75 16.5c-1.241 0.004-2.246 1.009-2.25 2.25v0c0.004 1.241 1.009 2.246 2.25 2.25h0c1.241-0.004 2.246-1.009 2.25-2.25v-0c-0.004-1.241-1.009-2.246-2.25-2.25h-0zM18.75 9.75c-1.241 0.004-2.246 1.009-2.25 2.25v0c0.004 1.241 1.009 2.246 2.25 2.25h0c1.241-0.004 2.246-1.009 2.25-2.25v-0c-0.004-1.241-1.009-2.246-2.25-2.25h-0zM12 9.75c-1.241 0.004-2.246 1.009-2.25 2.25v0c0.004 1.241 1.009 2.246 2.25 2.25h0c1.241-0.004 2.246-1.009 2.25-2.25v-0c-0.004-1.241-1.009-2.246-2.25-2.25h-0zM12 3c-1.241 0.004-2.246 1.009-2.25 2.25v0c0.004 1.241 1.009 2.246 2.25 2.25h0c1.241-0.004 2.246-1.009 2.25-2.25v-0c-0.004-1.241-1.009-2.246-2.25-2.25h-0z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-line_of_business',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 19h-14v-14h7v-2h-7c-1.11 0-2 0.9-2 2v14c0 1.1 0.89 2 2 2h14c1.1 0 2-0.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41 9.83-9.83v3.59h2v-7h-7z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-open_in_new',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 4v-3l-4 4 4 4v-3c3.31 0 6 2.69 6 6 0 1.010-0.25 1.97-0.7 2.8l1.46 1.46c0.78-1.23 1.24-2.69 1.24-4.26 0-4.42-3.58-8-8-8zM12 18c-3.31 0-6-2.69-6-6 0-1.010 0.25-1.97 0.7-2.8l-1.46-1.46c-0.78 1.23-1.24 2.69-1.24 4.26 0 4.42 3.58 8 8 8v3l4-4-4-4v3z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-loading',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 17c1.1 0 2-0.9 2-2s-0.9-2-2-2-2 0.9-2 2 0.9 2 2 2zM18 8h-1v-2c0-2.76-2.24-5-5-5s-5 2.24-5 5h1.9c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2h-9.1c-1.1 0-2 0.9-2 2v10c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-10c0-1.1-0.9-2-2-2zM18 20h-12v-10h12v10z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-unlock',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M18 8h-1v-2c0-2.76-2.24-5-5-5s-5 2.24-5 5v2h-1c-1.1 0-2 0.9-2 2v10c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-10c0-1.1-0.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2h-6v-2zM18 20h-12v-10h12v10zM12 17c1.1 0 2-0.9 2-2s-0.9-2-2-2-2 0.9-2 2 0.9 2 2 2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-lock',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M18 8h-1v-2c0-2.76-2.24-5-5-5s-5 2.24-5 5v2h-1c-1.1 0-2 0.9-2 2v10c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-10c0-1.1-0.9-2-2-2zM12 17c-1.1 0-2-0.9-2-2s0.9-2 2-2 2 0.9 2 2-0.9 2-2 2zM15.1 8h-6.2v-2c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-lock_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 8c1.1 0 2-0.9 2-2s-0.9-2-2-2-2 0.9-2 2 0.9 2 2 2zM12 10c-1.1 0-2 0.9-2 2s0.9 2 2 2 2-0.9 2-2-0.9-2-2-2zM12 16c-1.1 0-2 0.9-2 2s0.9 2 2 2 2-0.9 2-2-0.9-2-2-2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-more',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M9 16h2v-8h-2v8zM12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10c5.52 0 10-4.48 10-10s-4.48-10-10-10zM12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8c4.41 0 8 3.59 8 8s-3.59 8-8 8zM13 16h2v-8h-2v8z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-pause',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10c5.52 0 10-4.48 10-10s-4.48-10-10-10zM11 16h-2v-8h2v8zM15 16h-2v-8h2v8z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-pause_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 8h-1v-5h-12v5h-1c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zM8 5h8v3h-8v-3zM16 17v2h-8v-4h8v2zM18 15v-2h-12v2h-2v-4c0-0.55 0.45-1 1-1h14c0.55 0 1 0.45 1 1v4h-2z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 11.5c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-print',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 8h-14c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zM16 19h-8v-5h8v5zM19 12c-0.55 0-1-0.45-1-1s0.45-1 1-1 1 0.45 1 1-0.45 1-1 1zM18 3h-12v4h12v-4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-print_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10c5.52 0 10-4.48 10-10s-4.48-10-10-10zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8c4.42 0 8 3.58 8 8s-3.58 8-8 8z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-radio',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5c2.76 0 5-2.24 5-5s-2.24-5-5-5zM12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10c5.52 0 10-4.48 10-10s-4.48-10-10-10zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8c4.42 0 8 3.58 8 8s-3.58 8-8 8z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-radio_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M10 9v-4l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-reply',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M15.5 14h-0.79l-0.28-0.27c0.98-1.14 1.57-2.62 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 2.91-6.5 6.5c0 3.59 2.91 6.5 6.5 6.5 1.61 0 3.090-0.59 4.23-1.57l0.27 0.28v0.79l5 4.99 1.49-1.49-4.99-5zM9.5 14c-2.49 0-4.5-2.010-4.5-4.5s2.010-4.5 4.5-4.5c2.49 0 4.5 2.010 4.5 4.5s-2.010 4.5-4.5 4.5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-search',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M2.010 21l20.99-9-20.99-9-0.010 7 15 2-15 2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-send',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M18 16.080c-0.76 0-1.44 0.3-1.96 0.77l-7.13-4.15c0.050-0.23 0.090-0.46 0.090-0.7s-0.040-0.47-0.090-0.7l7.050-4.11c0.54 0.5 1.25 0.81 2.040 0.81 1.66 0 3-1.34 3-3s-1.34-3-3-3c-1.66 0-3 1.34-3 3 0 0.24 0.040 0.47 0.090 0.7l-7.050 4.11c-0.54-0.5-1.25-0.81-2.040-0.81-1.66 0-3 1.34-3 3s1.34 3 3 3c0.79 0 1.5-0.31 2.040-0.81l7.12 4.16c-0.050 0.21-0.080 0.43-0.080 0.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92zM18 4c0.55 0 1 0.45 1 1s-0.45 1-1 1c-0.55 0-1-0.45-1-1s0.45-1 1-1zM6 13c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1zM18 20.020c-0.55 0-1-0.45-1-1s0.45-1 1-1c0.55 0 1 0.45 1 1s-0.45 1-1 1z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-share',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M18 16.080c-0.76 0-1.44 0.3-1.96 0.77l-7.13-4.15c0.050-0.23 0.090-0.46 0.090-0.7s-0.040-0.47-0.090-0.7l7.050-4.11c0.54 0.5 1.25 0.81 2.040 0.81 1.66 0 3-1.34 3-3s-1.34-3-3-3c-1.66 0-3 1.34-3 3 0 0.24 0.040 0.47 0.090 0.7l-7.050 4.11c-0.54-0.5-1.25-0.81-2.040-0.81-1.66 0-3 1.34-3 3s1.34 3 3 3c0.79 0 1.5-0.31 2.040-0.81l7.12 4.16c-0.050 0.21-0.080 0.43-0.080 0.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-share_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M11.99 15h2.090l-5.11-13h-1.86l-5.11 13h2.090l1.12-3h5.64l1.14 3zM5.97 10l2.070-5.52 2.070 5.52h-4.14zM21.13 10.59l-8.090 8.090-3.67-3.68-1.41 1.41 5.090 5.090 9.49-9.5-1.41-1.41z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-spellcheck',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M10 18h4v-2h-4v2zM3 6v2h18v-2h-18zM6 13h12v-2h-12v2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-sort',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: { d: 'M19 13h-14v-2h14v2z', tabindex: '-1' },
                },
              ],
              attributes: {
                id: 'icon-subtract',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19 5v14h-14v-14h14zM20.1 3h-16.2c-0.5 0-0.9 0.4-0.9 0.9v16.2c0 0.4 0.4 0.9 0.9 0.9h16.2c0.4 0 0.9-0.5 0.9-0.9v-16.2c0-0.5-0.5-0.9-0.9-0.9zM11 7h6v2h-6v-2zM11 11h6v2h-6v-2zM11 15h6v2h-6v-2zM7 7h2v2h-2v-2zM7 11h2v2h-2v-2zM7 15h2v2h-2v-2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-stepper',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M11 7h2v2h-2v-2zM11 11h2v6h-2v-6zM12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10c5.52 0 10-4.48 10-10s-4.48-10-10-10zM12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8c4.41 0 8 3.59 8 8s-3.59 8-8 8z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-info',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10c5.52 0 10-4.48 10-10s-4.48-10-10-10zM13 17h-2v-6h2v6zM13 9h-2v-2h2v2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-info_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12.5 8c-2.65 0-5.050 0.99-6.9 2.6l-3.6-3.6v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-0.78c-1.39-4.19-5.32-7.22-9.97-7.22z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-undo',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M7 18.59l1.42 1.41 3.17-3.17 3.17 3.17 1.41-1.41-4.58-4.59-4.59 4.59zM16.18 5.41l-1.42-1.41-3.17 3.17-3.17-3.17-1.42 1.41 4.59 4.59 4.59-4.59z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-unfold_less',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M11.59 5.83l3.17 3.17 1.41-1.41-4.58-4.59-4.59 4.59 1.42 1.41 3.17-3.17zM11.59 18.17l-3.17-3.17-1.41 1.41 4.58 4.59 4.59-4.59-1.42-1.41-3.17 3.17z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-unfold_more',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M11 14v-6h-1.17l2.17-2.17 2.17 2.17h-1.17v6h-2zM9 16h6v-6h4l-7-7-7 7h4v6zM19 18h-14v2h14v-2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-upload',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M5 10h4v6h6v-6h4l-7-7-7 7zM5 18v2h14v-2h-14z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-upload_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19.35 10.040c-0.68-3.45-3.71-6.040-7.35-6.040-2.89 0-5.4 1.64-6.65 4.040-3.010 0.32-5.35 2.87-5.35 5.96 0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.050-4.78-4.65-4.96zM19 18h-13c-2.21 0-4-1.79-4-4 0-2.050 1.53-3.76 3.56-3.97l1.070-0.11 0.5-0.95c0.95-1.83 2.81-2.97 4.87-2.97 2.62 0 4.88 1.86 5.39 4.43l0.3 1.5 1.53 0.11c1.56 0.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3h2.55l-4-4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-cloud_upload',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19.35 10.040c-0.702-3.467-3.725-6.040-7.348-6.040-0.001 0-0.001 0-0.002 0h0c-2.89 0-5.4 1.64-6.65 4.040-3.022 0.336-5.35 2.876-5.35 5.959 0 0 0 0 0 0.001v-0c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.050-4.78-4.65-4.96zM14 13v4h-4v-4h-3l5-5 5 5h-3z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-cloud_upload_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M15 3h-9c-0.83 0-1.54 0.5-1.84 1.22l-3.020 7.050c-0.090 0.23-0.14 0.47-0.14 0.73v2c0 1.1 0.9 2 2 2h6.31l-0.95 4.57-0.030 0.32c0 0.41 0.17 0.79 0.44 1.060l1.060 1.050 6.59-6.59c0.36-0.36 0.58-0.86 0.58-1.41v-10c0-1.1-0.9-2-2-2zM15 15l-4.34 4.34 1.34-5.34h-9v-2l3-7h9v10zM19 3h4v12h-4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-thumb_down',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M15 3h-9c-0.83 0-1.54 0.5-1.84 1.22l-3.020 7.050c-0.090 0.23-0.14 0.47-0.14 0.73v2c0 1.1 0.9 2 2 2h6.31l-0.95 4.57-0.030 0.32c0 0.41 0.17 0.79 0.44 1.060l1.060 1.050 6.59-6.59c0.36-0.36 0.58-0.86 0.58-1.41v-10c0-1.1-0.9-2-2-2zM19 3v12h4v-12h-4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-thumb_down_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M9 21h9c0.83 0 1.54-0.5 1.84-1.22l3.020-7.050c0.090-0.23 0.14-0.47 0.14-0.73v-2c0-1.1-0.9-2-2-2h-6.31l0.95-4.57 0.030-0.32c0-0.41-0.17-0.79-0.44-1.060l-1.060-1.050-6.59 6.59c-0.36 0.36-0.58 0.86-0.58 1.41v10c0 1.1 0.9 2 2 2zM9 9l4.34-4.34-1.34 5.34h9v2l-3 7h-9v-10zM1 9h4v12h-4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-thumb_up',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M1 21h4v-12h-4v12zM23 10c0-1.1-0.9-2-2-2h-6.31l0.95-4.57 0.030-0.32c0-0.41-0.17-0.79-0.44-1.060l-1.060-1.050-6.58 6.59c-0.37 0.36-0.59 0.86-0.59 1.41v10c0 1.1 0.9 2 2 2h9c0.83 0 1.54-0.5 1.84-1.22l3.020-7.050c0.090-0.23 0.14-0.47 0.14-0.73v-2z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-thumb_up_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'actions',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M16.59 7.58l-6.59 6.59-3.59-3.58-1.41 1.41 5 5 8-8-1.41-1.42zM12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10c5.52 0 10-4.48 10-10s-4.48-10-10-10zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8c4.42 0 8 3.58 8 8s-3.58 8-8 8z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-check_circle',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'status',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10c5.52 0 10-4.48 10-10s-4.48-10-10-10zM10 17l-5-5 1.41-1.41 3.59 3.58 7.59-7.59 1.41 1.42-9 9z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-check_circle_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'status',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M9 16.17l-4.17-4.17-1.42 1.41 5.59 5.59 12-12-1.41-1.41z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-check',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'status',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M0.41 13.41l5.59 5.59 1.41-1.41-5.58-5.59zM18 7l-1.41-1.41-6.34 6.34 1.41 1.41z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M22.24 5.59l-10.58 10.58-4.18-4.17-1.41 1.41 5.59 5.59 12-12z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-double_check',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'status',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M11 15h2v2h-2v-2zM11 7h2v6h-2v-6zM11.99 2c-5.52 0-9.99 4.48-9.99 10s4.47 10 9.99 10c5.53 0 10.010-4.48 10.010-10s-4.48-10-10.010-10zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8c4.42 0 8 3.58 8 8s-3.58 8-8 8z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-error',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'status',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10c5.52 0 10-4.48 10-10s-4.48-10-10-10zM13 17h-2v-2h2v2zM13 13h-2v-6h2v6z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-error_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'status',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M14 6l-1-2h-8v17h2v-7h5l1 2h7v-10h-6zM18 14h-4l-1-2h-6v-6h5l1 2h5v6z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-flag',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'status',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M14.4 6l-0.4-2h-9v17h2v-7h5.6l0.4 2h7v-10z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-flag_active',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'status',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M9.84 11.136h4.32v2h-4.32z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-bullet',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'status',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M11.99 2c-5.52 0-9.99 4.48-9.99 10s4.47 10 9.99 10c5.53 0 10.010-4.48 10.010-10s-4.48-10-10.010-10zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8c4.42 0 8 3.58 8 8s-3.58 8-8 8zM15.5 11c0.83 0 1.5-0.67 1.5-1.5s-0.67-1.5-1.5-1.5c-0.83 0-1.5 0.67-1.5 1.5s0.67 1.5 1.5 1.5zM8.5 11c0.83 0 1.5-0.67 1.5-1.5s-0.67-1.5-1.5-1.5c-0.83 0-1.5 0.67-1.5 1.5s0.67 1.5 1.5 1.5zM12 17.5c2.33 0 4.31-1.46 5.11-3.5h-10.22c0.8 2.040 2.78 3.5 5.11 3.5z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-face',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'status',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M1 21h22l-11-19-11 19zM13 18h-2v-2h2v2zM13 14h-2v-4h2v4z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-warning',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'status',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M11.41 7.41l-1.41-1.41-6 6 6 6 1.41-1.41-4.58-4.59z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M19.41 7.41l-1.41-1.41-6 6 6 6 1.41-1.41-4.58-4.59z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-first_page',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
              },
            },
            {
              name: 'symbol',
              type: 'element',
              value: '',
              parent: null,
              children: [
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M5.41 6l-1.41 1.41 4.58 4.59-4.58 4.59 1.41 1.41 6-6z',
                    tabindex: '-1',
                  },
                },
                {
                  name: 'path',
                  type: 'element',
                  value: '',
                  parent: null,
                  children: [],
                  attributes: {
                    d: 'M13.41 6l-1.41 1.41 4.58 4.59-4.58 4.59 1.41 1.41 6-6z',
                    tabindex: '-1',
                  },
                },
              ],
              attributes: {
                id: 'icon-last_page',
                viewBox: '0 0 24 24',
                'data-set': 'system',
                tabindex: '-1',
                'data-group': 'arrows',
              },
            },
          ],
          attributes: { id: 'iconSymbols', tabindex: '-1' },
        },
      ],
      attributes: {
        id: 'svgDefs',
        style: 'position: absolute; width: 0; height: 0; overflow: hidden;',
        xmlns: 'http://www.w3.org/2000/svg',
        version: '1.1',
        tabindex: '-1',
        'aria-hidden': 'true',
        'xmlns:xlink': 'http://www.w3.org/1999/xlink',
      },
    },
  },
  COHORTS: [],
  SESSION_COOKIE_AGE: 9999,
  SESSION_COOKIE_AGE_AUTHENTICATED: 9999,
  SESSION_COOKIE_AGE_ANONYMOUS: 9999,
  TENANT_NAME: 'democare',
  APP_NAME: 'zshop',
  VARIATION: '',
  ASSETS_BASE_URL:
    'https://zipari-assets-dev.s3.us-east-2.amazonaws.com/v3.22.0-beta.126/zshop/',
  TENANT_ASSETS_BASE_URL:
    'https://zipari-assets-dev.s3.us-east-2.amazonaws.com/democare/1/',
  USER: '{}',
  ANGULAR_PARAMS: null,
  IS_FIRST_VISIT: true,
  CSRF_TOKEN:
    'iohqPebYbBii5aa52Ihhbo9df00ye9GZcjLyU8w8pcz2PSxYdQXQb15Aj8jYcDVH',
  LANGUAGE: 'en-us',
  IS_FIRST_SESSION_CONFIG_REQUEST: false,
};
